/*
 CanvasJS HTML5 & JavaScript StockCharts - v1.3 GA - https://canvasjs.com/
 Copyright 2021 fenopix

  --------------------- License Information --------------------
 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
     https://canvasjs.com/license/

*/
/*eslint-disable*/
/*jshint ignore:start*/
(function () {
  function ha(k, B) {
    k.prototype = pb(B.prototype);
    k.prototype.constructor = k;
    k.base = B.prototype;
  }
  function pb(k) {
    function B() {}
    B.prototype = k;
    return new B();
  }
  function db(k, B, f) {
    "millisecond" === f
      ? k.setMilliseconds(k.getMilliseconds() + 1 * B)
      : "second" === f
      ? k.setSeconds(k.getSeconds() + 1 * B)
      : "minute" === f
      ? k.setMinutes(k.getMinutes() + 1 * B)
      : "hour" === f
      ? k.setHours(k.getHours() + 1 * B)
      : "day" === f
      ? k.setDate(k.getDate() + 1 * B)
      : "week" === f
      ? k.setDate(k.getDate() + 7 * B)
      : "month" === f
      ? k.setMonth(k.getMonth() + 1 * B)
      : "year" === f && k.setFullYear(k.getFullYear() + 1 * B);
    return k;
  }
  function ka(k, B) {
    var f = !1;
    0 > k && ((f = !0), (k *= -1));
    k = "" + k;
    for (B = B ? B : 1; k.length < B; ) k = "0" + k;
    return f ? "-" + k : k;
  }
  function Pa(k) {
    if (!k) return k;
    k = k.replace(/^\s\s*/, "");
    for (var B = /\s/, f = k.length; B.test(k.charAt(--f)); );
    return k.slice(0, f + 1);
  }
  function Ha(k) {
    k.roundRect = function (k, f, v, Z, H, z, s, y) {
      s && (this.fillStyle = s);
      y && (this.strokeStyle = y);
      "undefined" === typeof H && (H = 5);
      this.lineWidth = z;
      this.beginPath();
      this.moveTo(k + H, f);
      this.lineTo(k + v - H, f);
      this.quadraticCurveTo(k + v, f, k + v, f + H);
      this.lineTo(k + v, f + Z - H);
      this.quadraticCurveTo(k + v, f + Z, k + v - H, f + Z);
      this.lineTo(k + H, f + Z);
      this.quadraticCurveTo(k, f + Z, k, f + Z - H);
      this.lineTo(k, f + H);
      this.quadraticCurveTo(k, f, k + H, f);
      this.closePath();
      s && this.fill();
      y && 0 < z && this.stroke();
    };
  }
  function Ya(k, B) {
    return k - B;
  }
  function eb(k, B, f) {
    if (k && B && f) {
      f = f + "." + B;
      var v = "image/" + B;
      k = k.toDataURL(v);
      var Z = !1,
        H = document.createElement("a");
      H.download = f;
      H.href = k;
      if ("undefined" !== typeof Blob && new Blob()) {
        for (
          var z = k.replace(/^data:[a-z\/]*;base64,/, ""),
            z = atob(z),
            s = new ArrayBuffer(z.length),
            s = new Uint8Array(s),
            y = 0;
          y < z.length;
          y++
        )
          s[y] = z.charCodeAt(y);
        B = new Blob([s.buffer], { type: "image/" + B });
        try {
          window.navigator.msSaveBlob(B, f), (Z = !0);
        } catch (P) {
          (H.dataset.downloadurl = [v, H.download, H.href].join(":")),
            (H.href = window.URL.createObjectURL(B));
        }
      }
      if (!Z)
        try {
          (event = document.createEvent("MouseEvents")),
            event.initMouseEvent(
              "click",
              !0,
              !1,
              window,
              0,
              0,
              0,
              0,
              0,
              !1,
              !1,
              !1,
              !1,
              0,
              null
            ),
            H.dispatchEvent
              ? H.dispatchEvent(event)
              : H.fireEvent && H.fireEvent("onclick");
        } catch (F) {
          (B = window.open()),
            B.document.write(
              "<img src='" +
                k +
                "'></img><div>Please right click on the image and save it to your device</div>"
            ),
            B.document.close();
        }
    }
  }
  function O(k) {
    var B = ((k & 16711680) >> 16).toString(16),
      f = ((k & 65280) >> 8).toString(16);
    k = ((k & 255) >> 0).toString(16);
    B = 2 > B.length ? "0" + B : B;
    f = 2 > f.length ? "0" + f : f;
    k = 2 > k.length ? "0" + k : k;
    return "#" + B + f + k;
  }
  function qb(k, B) {
    var f = this.length >>> 0,
      v = Number(B) || 0,
      v = 0 > v ? Math.ceil(v) : Math.floor(v);
    for (0 > v && (v += f); v < f; v++)
      if (v in this && this[v] === k) return v;
    return -1;
  }
  function f(k) {
    return null === k || "undefined" === typeof k;
  }
  function Ea(k) {
    k.indexOf || (k.indexOf = qb);
    return k;
  }
  function rb(k) {
    if (Qa.fSDec)
      k[wa("`eeDwdouMhrudods")](wa("e`u`@ohl`uhnoHuds`uhnoDoe"), function () {
        Qa._fTWm && Qa._fTWm(k);
      });
  }
  function fb(k, B, f) {
    f = f || "normal";
    var v = k + "_" + B + "_" + f,
      Z = gb[v];
    if (isNaN(Z)) {
      try {
        k =
          "position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:" +
          k +
          "; font-size:" +
          B +
          "px; font-weight:" +
          f +
          ";";
        if (!Fa) {
          var H = document.body;
          Fa = document.createElement("span");
          Fa.innerHTML = "";
          var z = document.createTextNode("Mpgyi");
          Fa.appendChild(z);
          H.appendChild(Fa);
        }
        Fa.style.display = "";
        Fa.setAttribute("style", k);
        Z = Math.round(Fa.offsetHeight);
        Fa.style.display = "none";
      } catch (s) {
        Z = Math.ceil(1.1 * B);
      }
      Z = Math.max(Z, B);
      gb[v] = Z;
    }
    return Z;
  }
  function N(k, B) {
    var f = [];
    if (
      (f = {
        solid: [],
        shortDash: [3, 1],
        shortDot: [1, 1],
        shortDashDot: [3, 1, 1, 1],
        shortDashDotDot: [3, 1, 1, 1, 1, 1],
        dot: [1, 2],
        dash: [4, 2],
        dashDot: [4, 2, 1, 2],
        longDash: [8, 2],
        longDashDot: [8, 2, 1, 2],
        longDashDotDot: [8, 2, 1, 2, 1, 2],
      }[k || "solid"])
    )
      for (var v = 0; v < f.length; v++) f[v] *= B;
    else f = [];
    return f;
  }
  function y(k, B, L, v, Z) {
    v = v || [];
    Z = f(Z) ? (sb ? { passive: !1, capture: !1 } : !1) : Z;
    v.push([k, B, L, Z]);
    return k.addEventListener
      ? (k.addEventListener(B, L, Z), L)
      : k.attachEvent
      ? ((v = function (B) {
          B = B || window.event;
          B.preventDefault =
            B.preventDefault ||
            function () {
              B.returnValue = !1;
            };
          B.stopPropagation =
            B.stopPropagation ||
            function () {
              B.cancelBubble = !0;
            };
          L.call(k, B);
        }),
        k.attachEvent("on" + B, v),
        v)
      : !1;
  }
  function hb(k, B, f, v) {
    v = v || !1;
    if (k.removeEventListener) k.removeEventListener(B, f, v);
    else if (k.detachEvent) k.detachEvent("on" + B, f);
    else return !1;
  }
  function ib(k, B) {
    if ("createEvent" in document) {
      var f = document.createEvent("HTMLEvents");
      f.initEvent(B, !1, !0);
      k.dispatchEvent(f);
    } else k.fireEvent("on" + B);
  }
  function jb(k) {
    if (k._menuButton) k.exportEnabled ? Ta(k._menuButton) : za(k._menuButton);
    else if (k.exportEnabled && v) {
      var B = !1;
      k._menuButton = document.createElement("button");
      Ca(k, k._menuButton, "menu");
      k._toolBar.appendChild(k._menuButton);
      y(
        k._menuButton,
        "touchstart",
        function (k) {
          B = !0;
        },
        k.allDOMEventHandlers
      );
      y(
        k._menuButton,
        "click",
        function () {
          "none" !== k._dropdownMenu.style.display ||
            (k._dropDownCloseTime &&
              500 >= new Date().getTime() - k._dropDownCloseTime.getTime()) ||
            ((k._dropdownMenu.style.display = "block"),
            k._menuButton.blur(),
            k._dropdownMenu.focus());
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        k._menuButton,
        "mouseover",
        function () {
          B ||
            (sa(k._menuButton, {
              backgroundColor: k.toolbar.backgroundColorOnHover,
              color: k.toolbar.fontColorOnHover,
            }),
            0 >= navigator.userAgent.search("MSIE") &&
              sa(k._menuButton.childNodes[0], {
                WebkitFilter: "invert(100%)",
                filter: "invert(100%)",
              }));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        k._menuButton,
        "mouseout",
        function () {
          B ||
            (sa(k._menuButton, {
              backgroundColor: k.toolbar.backgroundColor,
              color: k.toolbar.fontColor,
            }),
            0 >= navigator.userAgent.search("MSIE") &&
              sa(k._menuButton.childNodes[0], {
                WebkitFilter: "invert(0%)",
                filter: "invert(0%)",
              }));
        },
        k.allDOMEventHandlers,
        !0
      );
    }
    if (!k._dropdownMenu && k.exportEnabled && v) {
      B = !1;
      k._dropdownMenu = document.createElement("div");
      k._dropdownMenu.setAttribute("tabindex", -1);
      var f = -1 !== k.theme.indexOf("dark") ? "black" : "#888888";
      k._dropdownMenu.style.cssText =
        "position: absolute; z-index: 1; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 0px;top: 25px;min-width: 120px;outline: 0;font-size: 14px; font-family: Arial, Helvetica, sans-serif;padding: 5px 0px 5px 0px;text-align: left;line-height: 10px;background-color:" +
        k.toolbar.backgroundColor +
        ";box-shadow: 2px 2px 10px " +
        f;
      k._dropdownMenu.style.display = "none";
      k._toolBar.appendChild(k._dropdownMenu);
      y(
        k._dropdownMenu,
        "blur",
        function () {
          za(k._dropdownMenu);
          k._dropDownCloseTime = new Date();
        },
        k.allDOMEventHandlers,
        !0
      );
      f = document.createElement("div");
      f.style.cssText = "padding: 12px 8px 12px 8px";
      f.innerHTML = k._cultureInfo.printText;
      f.style.backgroundColor = k.toolbar.backgroundColor;
      f.style.color = k.toolbar.fontColor;
      k._dropdownMenu.appendChild(f);
      y(
        f,
        "touchstart",
        function (k) {
          B = !0;
        },
        k.allDOMEventHandlers
      );
      y(
        f,
        "mouseover",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColorOnHover),
            (this.style.color = k.toolbar.fontColorOnHover));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "mouseout",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColor),
            (this.style.color = k.toolbar.fontColor));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "click",
        function () {
          k.print();
          za(k._dropdownMenu);
        },
        k.allDOMEventHandlers,
        !0
      );
      f = document.createElement("div");
      f.style.cssText = "padding: 12px 8px 12px 8px";
      f.innerHTML = k._cultureInfo.saveJPGText;
      f.style.backgroundColor = k.toolbar.backgroundColor;
      f.style.color = k.toolbar.fontColor;
      k._dropdownMenu.appendChild(f);
      y(
        f,
        "touchstart",
        function (k) {
          B = !0;
        },
        k.allDOMEventHandlers
      );
      y(
        f,
        "mouseover",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColorOnHover),
            (this.style.color = k.toolbar.fontColorOnHover));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "mouseout",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColor),
            (this.style.color = k.toolbar.fontColor));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "click",
        function () {
          k.exportChart({ format: "jpeg", fileName: k.exportFileName });
          za(k._dropdownMenu);
        },
        k.allDOMEventHandlers,
        !0
      );
      f = document.createElement("div");
      f.style.cssText = "padding: 12px 8px 12px 8px";
      f.innerHTML = k._cultureInfo.savePNGText;
      f.style.backgroundColor = k.toolbar.backgroundColor;
      f.style.color = k.toolbar.fontColor;
      k._dropdownMenu.appendChild(f);
      y(
        f,
        "touchstart",
        function (k) {
          B = !0;
        },
        k.allDOMEventHandlers
      );
      y(
        f,
        "mouseover",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColorOnHover),
            (this.style.color = k.toolbar.fontColorOnHover));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "mouseout",
        function () {
          B ||
            ((this.style.backgroundColor = k.toolbar.backgroundColor),
            (this.style.color = k.toolbar.fontColor));
        },
        k.allDOMEventHandlers,
        !0
      );
      y(
        f,
        "click",
        function () {
          k.exportChart({ format: "png", fileName: k.exportFileName });
          za(k._dropdownMenu);
        },
        k.allDOMEventHandlers,
        !0
      );
    }
  }
  function kb(k, B, f) {
    k *= ia;
    B *= ia;
    k = f.getImageData(k, B, 2, 2).data;
    B = !0;
    for (f = 0; 4 > f; f++)
      if ((k[f] !== k[f + 4]) | (k[f] !== k[f + 8]) | (k[f] !== k[f + 12])) {
        B = !1;
        break;
      }
    return B ? (k[0] << 16) | (k[1] << 8) | k[2] : 0;
  }
  function ra(k, B, f) {
    return k in B ? B[k] : f[k];
  }
  function Ua(k, B, f) {
    if (v && lb) {
      var U = k.getContext("2d");
      Va =
        U.webkitBackingStorePixelRatio ||
        U.mozBackingStorePixelRatio ||
        U.msBackingStorePixelRatio ||
        U.oBackingStorePixelRatio ||
        U.backingStorePixelRatio ||
        1;
      ia = Za / Va;
      k.width = B * ia;
      k.height = f * ia;
      Za !== Va &&
        ((k.style.width = B + "px"),
        (k.style.height = f + "px"),
        U.scale(ia, ia));
    } else (k.width = B), (k.height = f);
  }
  function tb(k) {
    if (!ub) {
      var B = !1,
        f = !1;
      "undefined" === typeof ma.Chart.creditHref
        ? ((k.creditHref = wa("iuuqr;..b`ow`rkr/bnl.")),
          (k.creditText = wa("B`ow`rKR/bnl")))
        : ((B = k.updateOption("creditText")),
          (f = k.updateOption("creditHref")));
      if (k.creditHref && k.creditText) {
        k._creditLink ||
          ((k._creditLink = document.createElement("a")),
          k._creditLink.setAttribute("class", "canvasjs-chart-credit"),
          k._creditLink.setAttribute("title", "JavaScript Charts"),
          k._creditLink.setAttribute(
            "style",
            "outline:none;margin:0px;position:absolute;right:2px;top:" +
              (k.height - 14) +
              "px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"
          ),
          k._creditLink.setAttribute("tabIndex", -1),
          k._creditLink.setAttribute("target", "_blank"));
        if (0 === k.renderCount || B || f)
          k._creditLink.setAttribute("href", k.creditHref),
            (k._creditLink.innerHTML = k.creditText);
        k._creditLink && k.creditHref && k.creditText
          ? (k._creditLink.parentElement ||
              k._canvasJSContainer.appendChild(k._creditLink),
            (k._creditLink.style.top = k.height - 14 + "px"))
          : k._creditLink.parentElement &&
            k._canvasJSContainer.removeChild(k._creditLink);
      }
    }
  }
  function ta(k, B) {
    Ma && ((this.canvasCount |= 0), window.console.log(++this.canvasCount));
    var f = document.createElement("canvas");
    f.setAttribute("class", "canvasjs-chart-canvas");
    Ua(f, k, B);
    v ||
      "undefined" === typeof G_vmlCanvasManager ||
      G_vmlCanvasManager.initElement(f);
    return f;
  }
  function sa(k, f) {
    for (var v in f) k.style[v] = f[v];
  }
  function Ca(k, f, v) {
    f.getAttribute("state") ||
      ((f.style.backgroundColor = k.toolbar.backgroundColor),
      (f.style.color = k.toolbar.fontColor),
      (f.style.border = "none"),
      sa(f, {
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
      }));
    f.getAttribute("state") !== v &&
      (f.setAttribute("state", v),
      f.setAttribute("type", "button"),
      sa(f, {
        padding: "5px 12px",
        cursor: "pointer",
        float: "left",
        width: "40px",
        height: "25px",
        outline: "0px",
        verticalAlign: "baseline",
        lineHeight: "0",
      }),
      f.setAttribute("title", k._cultureInfo[v + "Text"]),
      (f.innerHTML =
        "<img style='height:95%; pointer-events: none;' src='" +
        vb[v].image +
        "' alt='" +
        k._cultureInfo[v + "Text"] +
        "' />"));
  }
  function Ta() {
    for (var k = null, f = 0; f < arguments.length; f++)
      (k = arguments[f]), k.style && (k.style.display = "inline");
  }
  function za() {
    for (var k = null, f = 0; f < arguments.length; f++)
      (k = arguments[f]) && k.style && (k.style.display = "none");
  }
  function $a(k) {
    if (null === k || "object" !== typeof k) return k;
    if (k instanceof Date) return new Date(k.getTime());
    Array.isArray ||
      (Array.isArray = function (k) {
        return "[object Array]" === Object.prototype.toString.call(k);
      });
    if (Array.isArray(k)) {
      for (var f = [], v = 0; v < k.length; v++) f.push($a(k[v]));
      return f;
    }
    f = new k.constructor();
    for (v in k) k.hasOwnProperty(v) && (f[v] = $a(k[v]));
    return f;
  }
  function Wa(k, f, v, U, Z) {
    if (null === k || "undefined" === typeof k)
      return "undefined" === typeof v ? f : v;
    k =
      parseFloat(k.toString()) * (0 <= k.toString().indexOf("%") ? f / 100 : 1);
    "undefined" !== typeof U &&
      ((k = Math.min(U, k)), "undefined" !== typeof Z && (k = Math.max(Z, k)));
    return !isNaN(k) && k <= f && 0 <= k ? k : "undefined" === typeof v ? f : v;
  }
  function Q(k, B, v, U, Z) {
    this._defaultsKey = k;
    this._themeOptionsKey = B;
    this._index = U;
    this.parent = Z;
    this._eventListeners = [];
    k = {};
    this.theme && f(this.parent) && f(B) && f(U)
      ? (k = f(this.predefinedThemes[this.theme])
          ? this.predefinedThemes.light1
          : this.predefinedThemes[this.theme])
      : this.parent &&
        this.parent.themeOptions &&
        this.parent.themeOptions[B] &&
        (null === U
          ? (k = this.parent.themeOptions[B])
          : 0 < this.parent.themeOptions[B].length &&
            ((U = Math.min(this.parent.themeOptions[B].length - 1, U)),
            (k = this.parent.themeOptions[B][U])));
    this.themeOptions = k;
    this.options = v ? v : { _isPlaceholder: !0 };
    this.setOptions(this.options, k);
  }
  function La(k, f, v, U, Z) {
    "undefined" === typeof Z && (Z = 0);
    this._padding = Z;
    this._x1 = k;
    this._y1 = f;
    this._x2 = v;
    this._y2 = U;
    this._rightOccupied =
      this._leftOccupied =
      this._bottomOccupied =
      this._topOccupied =
        this._padding;
  }
  function na(k, f) {
    na.base.constructor.call(this, "TextBlock", null, f, null, null);
    this.ctx = k;
    this._isDirty = !0;
    this._wrappedText = null;
    this._initialize();
  }
  function Xa(k, f) {
    Xa.base.constructor.call(this, "Toolbar", "toolbar", f, null, k);
    this.chart = k;
    this.canvas = k.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "toolbar";
  }
  function Ia(k, B) {
    Ia.base.constructor.call(this, "Title", "title", B, null, k);
    this.chart = k;
    this.canvas = k.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "title";
    if (f(this.options.margin) && k.options.subtitles)
      for (var v = k.options.subtitles, U = 0; U < v.length; U++)
        if (
          ((f(v[U].horizontalAlign) && "center" === this.horizontalAlign) ||
            v[U].horizontalAlign === this.horizontalAlign) &&
          ((f(v[U].verticalAlign) && "top" === this.verticalAlign) ||
            v[U].verticalAlign === this.verticalAlign) &&
          !v[U].dockInsidePlotArea === !this.dockInsidePlotArea
        ) {
          this.margin = 0;
          break;
        }
    "undefined" === typeof this.options.fontSize &&
      (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
    this.height = this.width = null;
    this.bounds = { x1: null, y1: null, x2: null, y2: null };
  }
  function Na(k, f, v) {
    Na.base.constructor.call(this, "Subtitle", "subtitles", f, v, k);
    this.chart = k;
    this.canvas = k.canvas;
    this.ctx = this.chart.ctx;
    this.optionsName = "subtitles";
    this.isOptionsInArray = !0;
    "undefined" === typeof this.options.fontSize &&
      (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
    this.height = this.width = null;
    this.bounds = { x1: null, y1: null, x2: null, y2: null };
  }
  function ab() {
    this.pool = [];
  }
  function Oa(k) {
    var f;
    k && Ra[k] && (f = Ra[k]);
    Oa.base.constructor.call(this, "CultureInfo", null, f, null, null);
  }
  var Ma = !1,
    Qa = {},
    v = !!document.createElement("canvas").getContext,
    ma = {
      Chart: {
        width: 500,
        height: 400,
        zoomEnabled: !1,
        zoomType: "x",
        backgroundColor: "white",
        theme: "light1",
        animationEnabled: !1,
        animationDuration: 1200,
        dataPointWidth: null,
        dataPointMinWidth: null,
        dataPointMaxWidth: null,
        colorSet: "colorSet1",
        culture: "en",
        creditHref: "",
        creditText: "CanvasJS",
        interactivityEnabled: !0,
        exportEnabled: !1,
        exportFileName: "Chart",
        rangeChanging: null,
        rangeChanged: null,
        publicProperties: {
          title: "readWrite",
          subtitles: "readWrite",
          toolbar: "readWrite",
          toolTip: "readWrite",
          legend: "readWrite",
          axisX: "readWrite",
          axisY: "readWrite",
          axisX2: "readWrite",
          axisY2: "readWrite",
          data: "readWrite",
          options: "readWrite",
          bounds: "readOnly",
          container: "readOnly",
          selectedColorSet: "readOnly",
        },
      },
      Title: {
        padding: 0,
        text: null,
        verticalAlign: "top",
        horizontalAlign: "center",
        fontSize: 20,
        fontFamily: "Calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: v ? "transparent" : null,
        margin: 5,
        wrap: !0,
        maxWidth: null,
        dockInsidePlotArea: !1,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Subtitle: {
        padding: 0,
        text: null,
        verticalAlign: "top",
        horizontalAlign: "center",
        fontSize: 14,
        fontFamily: "Calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: null,
        margin: 2,
        wrap: !0,
        maxWidth: null,
        dockInsidePlotArea: !1,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Toolbar: {
        backgroundColor: "white",
        backgroundColorOnHover: "#2196f3",
        borderColor: "#2196f3",
        borderThickness: 1,
        fontColor: "black",
        fontColorOnHover: "white",
        publicProperties: { options: "readWrite", chart: "readOnly" },
      },
      Legend: {
        name: null,
        verticalAlign: "center",
        horizontalAlign: "right",
        fontSize: 14,
        fontFamily: "calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        cursor: null,
        itemmouseover: null,
        itemmouseout: null,
        itemmousemove: null,
        itemclick: null,
        dockInsidePlotArea: !1,
        reversed: !1,
        backgroundColor: v ? "transparent" : null,
        borderColor: v ? "transparent" : null,
        borderThickness: 0,
        cornerRadius: 0,
        maxWidth: null,
        maxHeight: null,
        markerMargin: null,
        itemMaxWidth: null,
        itemWidth: null,
        itemWrap: !0,
        itemTextFormatter: null,
        publicProperties: {
          options: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      ToolTip: {
        enabled: !0,
        shared: !1,
        animationEnabled: !0,
        content: null,
        contentFormatter: null,
        reversed: !1,
        backgroundColor: v ? "rgba(255,255,255,.9)" : "rgb(255,255,255)",
        borderColor: null,
        borderThickness: 2,
        cornerRadius: 5,
        fontSize: 14,
        fontColor: "black",
        fontFamily: "Calibri, Arial, Georgia, serif;",
        fontWeight: "normal",
        fontStyle: "italic",
        updated: null,
        hidden: null,
        publicProperties: { options: "readWrite", chart: "readOnly" },
      },
      Axis: {
        minimum: null,
        maximum: null,
        viewportMinimum: null,
        viewportMaximum: null,
        interval: null,
        intervalType: null,
        reversed: !1,
        logarithmic: !1,
        logarithmBase: 10,
        title: null,
        titleFontColor: "black",
        titleFontSize: 20,
        titleFontFamily: "arial",
        titleFontWeight: "normal",
        titleFontStyle: "normal",
        titleWrap: !0,
        titleMaxWidth: null,
        titleBackgroundColor: v ? "transparent" : null,
        titleBorderColor: v ? "transparent" : null,
        titleBorderThickness: 0,
        titleCornerRadius: 0,
        labelAngle: 0,
        labelFontFamily: "arial",
        labelFontColor: "black",
        labelFontSize: 12,
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelAutoFit: !0,
        labelWrap: !0,
        labelMaxWidth: null,
        labelFormatter: null,
        labelBackgroundColor: v ? "transparent" : null,
        labelBorderColor: v ? "transparent" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelPlacement: "outside",
        labelTextAlign: "left",
        prefix: "",
        suffix: "",
        includeZero: !1,
        tickLength: 5,
        tickColor: "black",
        tickThickness: 1,
        tickPlacement: "outside",
        lineColor: "black",
        lineThickness: 1,
        lineDashType: "solid",
        gridColor: "#A0A0A0",
        gridThickness: 0,
        gridDashType: "solid",
        interlacedColor: v ? "transparent" : null,
        valueFormatString: null,
        margin: 2,
        publicProperties: {
          options: "readWrite",
          stripLines: "readWrite",
          scaleBreaks: "readWrite",
          crosshair: "readWrite",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      StripLine: {
        value: null,
        startValue: null,
        endValue: null,
        color: "orange",
        opacity: null,
        thickness: 2,
        lineDashType: "solid",
        label: "",
        labelPlacement: "inside",
        labelAlign: "far",
        labelWrap: !0,
        labelMaxWidth: null,
        labelBackgroundColor: null,
        labelBorderColor: v ? "transparent" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelFontFamily: "arial",
        labelFontColor: "orange",
        labelFontSize: 12,
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelFormatter: null,
        showOnTop: !1,
        publicProperties: {
          options: "readWrite",
          axis: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      ScaleBreaks: {
        autoCalculate: !1,
        collapsibleThreshold: "25%",
        maxNumberOfAutoBreaks: 2,
        spacing: 8,
        type: "straight",
        color: "#FFFFFF",
        fillOpacity: 0.9,
        lineThickness: 2,
        lineColor: "#E16E6E",
        lineDashType: "solid",
        publicProperties: {
          options: "readWrite",
          customBreaks: "readWrite",
          axis: "readOnly",
          autoBreaks: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Break: {
        startValue: null,
        endValue: null,
        spacing: 8,
        type: "straight",
        color: "#FFFFFF",
        fillOpacity: 0.9,
        lineThickness: 2,
        lineColor: "#E16E6E",
        lineDashType: "solid",
        publicProperties: {
          options: "readWrite",
          scaleBreaks: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      Crosshair: {
        enabled: !1,
        snapToDataPoint: !1,
        color: "grey",
        opacity: null,
        thickness: 2,
        lineDashType: "solid",
        label: "",
        labelWrap: !0,
        labelMaxWidth: null,
        labelBackgroundColor: v ? "grey" : null,
        labelBorderColor: v ? "grey" : null,
        labelBorderThickness: 0,
        labelCornerRadius: 0,
        labelFontFamily: v
          ? "Calibri, Optima, Candara, Verdana, Geneva, sans-serif"
          : "calibri",
        labelFontSize: 12,
        labelFontColor: "#fff",
        labelFontWeight: "normal",
        labelFontStyle: "normal",
        labelFormatter: null,
        valueFormatString: null,
        updated: null,
        hidden: null,
        publicProperties: {
          options: "readWrite",
          axis: "readOnly",
          bounds: "readOnly",
          chart: "readOnly",
        },
      },
      DataSeries: {
        name: null,
        dataPoints: null,
        label: "",
        bevelEnabled: !1,
        highlightEnabled: !0,
        cursor: "default",
        indexLabel: "",
        indexLabelPlacement: "auto",
        indexLabelOrientation: "horizontal",
        indexLabelTextAlign: "left",
        indexLabelFontColor: "black",
        indexLabelFontSize: 12,
        indexLabelFontStyle: "normal",
        indexLabelFontFamily: "Arial",
        indexLabelFontWeight: "normal",
        indexLabelBackgroundColor: null,
        indexLabelLineColor: "gray",
        indexLabelLineThickness: 1,
        indexLabelLineDashType: "solid",
        indexLabelMaxWidth: null,
        indexLabelWrap: !0,
        indexLabelFormatter: null,
        lineThickness: 2,
        lineDashType: "solid",
        connectNullData: !1,
        nullDataLineDashType: "dash",
        color: null,
        lineColor: null,
        risingColor: "white",
        fallingColor: "red",
        fillOpacity: null,
        startAngle: 0,
        radius: null,
        innerRadius: null,
        neckHeight: null,
        neckWidth: null,
        reversed: !1,
        valueRepresents: null,
        linkedDataSeriesIndex: null,
        whiskerThickness: 2,
        whiskerDashType: "solid",
        whiskerColor: null,
        whiskerLength: null,
        stemThickness: 2,
        stemColor: null,
        stemDashType: "solid",
        upperBoxColor: "white",
        lowerBoxColor: "white",
        type: "column",
        xValueType: "number",
        axisXType: "primary",
        axisYType: "primary",
        axisXIndex: 0,
        axisYIndex: 0,
        xValueFormatString: null,
        yValueFormatString: null,
        zValueFormatString: null,
        percentFormatString: null,
        showInLegend: null,
        legendMarkerType: null,
        legendMarkerColor: null,
        legendText: null,
        legendMarkerBorderColor: v ? "transparent" : null,
        legendMarkerBorderThickness: 0,
        markerType: "circle",
        markerColor: null,
        markerSize: null,
        markerBorderColor: v ? "transparent" : null,
        markerBorderThickness: 0,
        mouseover: null,
        mouseout: null,
        mousemove: null,
        click: null,
        toolTipContent: null,
        visible: !0,
        publicProperties: {
          options: "readWrite",
          axisX: "readWrite",
          axisY: "readWrite",
          chart: "readOnly",
        },
      },
      TextBlock: {
        x: 0,
        y: 0,
        width: null,
        height: null,
        maxWidth: null,
        maxHeight: null,
        padding: 0,
        angle: 0,
        text: "",
        horizontalAlign: "center",
        textAlign: "left",
        fontSize: 12,
        fontFamily: "calibri",
        fontWeight: "normal",
        fontColor: "black",
        fontStyle: "normal",
        borderThickness: 0,
        borderColor: "black",
        cornerRadius: 0,
        backgroundColor: null,
        textBaseline: "top",
      },
      CultureInfo: {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        zoomText: "Zoom",
        panText: "Pan",
        resetText: "Reset",
        menuText: "More Options",
        saveJPGText: "Save as JPEG",
        savePNGText: "Save as PNG",
        printText: "Print",
        days: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(
          " "
        ),
        shortDays: "Sun Mon Tue Wed Thu Fri Sat".split(" "),
        months:
          "January February March April May June July August September October November December".split(
            " "
          ),
        shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(
          " "
        ),
      },
    },
    Ra = { en: {} },
    s = v ? "Trebuchet MS, Helvetica, sans-serif" : "Arial",
    Aa = v ? "Impact, Charcoal, sans-serif" : "Arial",
    ya = {
      colorSet1:
        "#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #7F6084 #77A033 #33558B #E59566".split(
          " "
        ),
      colorSet2:
        "#6D78AD #51CDA0 #DF7970 #4C9CA0 #AE7D99 #C9D45C #5592AD #DF874D #52BCA8 #8E7AA3 #E3CB64 #C77B85 #C39762 #8DD17E #B57952 #FCC26C".split(
          " "
        ),
      colorSet3:
        "#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(
          " "
        ),
    },
    K,
    W,
    M,
    X,
    ua;
  W = "#333333";
  M = "#000000";
  K = "#666666";
  ua = X = "#000000";
  var ea = 20,
    F = 14,
    Ga = {
      colorSet: "colorSet1",
      backgroundColor: "#FFFFFF",
      title: {
        fontFamily: Aa,
        fontSize: 32,
        fontColor: W,
        fontWeight: "normal",
        verticalAlign: "top",
        margin: 5,
      },
      subtitles: [
        {
          fontFamily: Aa,
          fontSize: F,
          fontColor: W,
          fontWeight: "normal",
          verticalAlign: "top",
          margin: 5,
        },
      ],
      data: [
        {
          indexLabelFontFamily: s,
          indexLabelFontSize: F,
          indexLabelFontColor: W,
          indexLabelFontWeight: "normal",
          indexLabelLineThickness: 1,
        },
      ],
      axisX: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: W,
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: M,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: K,
          tickThickness: 1,
          tickColor: K,
          gridThickness: 0,
          gridColor: K,
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: ua,
            color: X,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisX2: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: W,
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: M,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: K,
          tickThickness: 1,
          tickColor: K,
          gridThickness: 0,
          gridColor: K,
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: ua,
            color: X,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: W,
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: M,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: K,
          tickThickness: 1,
          tickColor: K,
          gridThickness: 1,
          gridColor: K,
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: ua,
            color: X,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY2: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: W,
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: M,
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: K,
          tickThickness: 1,
          tickColor: K,
          gridThickness: 1,
          gridColor: K,
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FF7300",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FF7300",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: ua,
            color: X,
            thickness: 1,
            lineDashType: "dash",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      legend: {
        fontFamily: s,
        fontSize: 14,
        fontColor: W,
        fontWeight: "bold",
        verticalAlign: "bottom",
        horizontalAlign: "center",
      },
      toolTip: {
        fontFamily: s,
        fontSize: 14,
        fontStyle: "normal",
        cornerRadius: 0,
        borderThickness: 1,
      },
    };
  K = "#2A2A2A";
  M = W = "#F5F5F5";
  K = "#FFFFFF";
  X = "#40BAF1";
  ua = "#F5F5F5";
  var ea = 20,
    F = 14,
    Ja = {
      colorSet: "colorSet2",
      title: {
        fontFamily: s,
        fontSize: 33,
        fontColor: "#3A3A3A",
        fontWeight: "bold",
        verticalAlign: "top",
        margin: 5,
      },
      subtitles: [
        {
          fontFamily: s,
          fontSize: F,
          fontColor: "#3A3A3A",
          fontWeight: "normal",
          verticalAlign: "top",
          margin: 5,
        },
      ],
      data: [
        {
          indexLabelFontFamily: s,
          indexLabelFontSize: F,
          indexLabelFontColor: "#666666",
          indexLabelFontWeight: "normal",
          indexLabelLineThickness: 1,
        },
      ],
      axisX: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: "#BBBBBB",
          tickThickness: 1,
          tickColor: "#BBBBBB",
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisX2: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 1,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 0,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      axisY2: [
        {
          titleFontFamily: s,
          titleFontSize: ea,
          titleFontColor: "#666666",
          titleFontWeight: "normal",
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#666666",
          labelFontWeight: "normal",
          lineThickness: 0,
          lineColor: "#BBBBBB",
          tickColor: "#BBBBBB",
          tickThickness: 1,
          gridThickness: 1,
          gridColor: "#BBBBBB",
          stripLines: [
            {
              labelFontFamily: s,
              labelFontSize: F,
              labelFontColor: "#FFA500",
              labelFontWeight: "normal",
              labelBackgroundColor: null,
              color: "#FFA500",
              thickness: 1,
            },
          ],
          crosshair: {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#EEEEEE",
            labelFontWeight: "normal",
            labelBackgroundColor: "black",
            color: "black",
            thickness: 1,
            lineDashType: "dot",
          },
          scaleBreaks: {
            type: "zigzag",
            spacing: "2%",
            lineColor: "#BBBBBB",
            lineThickness: 1,
            lineDashType: "solid",
          },
        },
      ],
      legend: {
        fontFamily: s,
        fontSize: 14,
        fontColor: "#3A3A3A",
        fontWeight: "bold",
        verticalAlign: "bottom",
        horizontalAlign: "center",
      },
      toolTip: {
        fontFamily: s,
        fontSize: 14,
        fontStyle: "normal",
        cornerRadius: 0,
        borderThickness: 1,
      },
    };
  M = W = "#F5F5F5";
  K = "#FFFFFF";
  X = "#40BAF1";
  ua = "#F5F5F5";
  ea = 20;
  F = 14;
  Aa = {
    colorSet: "colorSet12",
    backgroundColor: "#2A2A2A",
    title: {
      fontFamily: Aa,
      fontSize: 32,
      fontColor: W,
      fontWeight: "normal",
      verticalAlign: "top",
      margin: 5,
    },
    subtitles: [
      {
        fontFamily: Aa,
        fontSize: F,
        fontColor: W,
        fontWeight: "normal",
        verticalAlign: "top",
        margin: 5,
      },
    ],
    toolbar: {
      backgroundColor: "#666666",
      backgroundColorOnHover: "#FF7372",
      borderColor: "#FF7372",
      borderThickness: 1,
      fontColor: "#F5F5F5",
      fontColorOnHover: "#F5F5F5",
    },
    data: [
      {
        indexLabelFontFamily: s,
        indexLabelFontSize: F,
        indexLabelFontColor: M,
        indexLabelFontWeight: "normal",
        indexLabelLineThickness: 1,
      },
    ],
    axisX: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 0,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisX2: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 0,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 1,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY2: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 1,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    legend: {
      fontFamily: s,
      fontSize: 14,
      fontColor: W,
      fontWeight: "bold",
      verticalAlign: "bottom",
      horizontalAlign: "center",
    },
    toolTip: {
      fontFamily: s,
      fontSize: 14,
      fontStyle: "normal",
      cornerRadius: 0,
      borderThickness: 1,
      fontColor: M,
      backgroundColor: "rgba(0, 0, 0, .7)",
    },
  };
  K = "#FFFFFF";
  M = W = "#FAFAFA";
  X = "#40BAF1";
  ua = "#F5F5F5";
  ea = 20;
  F = 14;
  X = {
    colorSet: "colorSet2",
    backgroundColor: "#32373A",
    title: {
      fontFamily: s,
      fontSize: 32,
      fontColor: W,
      fontWeight: "normal",
      verticalAlign: "top",
      margin: 5,
    },
    subtitles: [
      {
        fontFamily: s,
        fontSize: F,
        fontColor: W,
        fontWeight: "normal",
        verticalAlign: "top",
        margin: 5,
      },
    ],
    toolbar: {
      backgroundColor: "#666666",
      backgroundColorOnHover: "#FF7372",
      borderColor: "#FF7372",
      borderThickness: 1,
      fontColor: "#F5F5F5",
      fontColorOnHover: "#F5F5F5",
    },
    data: [
      {
        indexLabelFontFamily: s,
        indexLabelFontSize: F,
        indexLabelFontColor: M,
        indexLabelFontWeight: "normal",
        indexLabelLineThickness: 1,
      },
    ],
    axisX: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 0,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisX2: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 1,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 0,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 0,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 1,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    axisY2: [
      {
        titleFontFamily: s,
        titleFontSize: ea,
        titleFontColor: M,
        titleFontWeight: "normal",
        labelFontFamily: s,
        labelFontSize: F,
        labelFontColor: M,
        labelFontWeight: "normal",
        lineThickness: 0,
        lineColor: K,
        tickThickness: 1,
        tickColor: K,
        gridThickness: 1,
        gridColor: K,
        stripLines: [
          {
            labelFontFamily: s,
            labelFontSize: F,
            labelFontColor: "#FF7300",
            labelFontWeight: "normal",
            labelBackgroundColor: null,
            color: "#FF7300",
            thickness: 1,
          },
        ],
        crosshair: {
          labelFontFamily: s,
          labelFontSize: F,
          labelFontColor: "#000000",
          labelFontWeight: "normal",
          labelBackgroundColor: ua,
          color: X,
          thickness: 1,
          lineDashType: "dash",
        },
        scaleBreaks: {
          type: "zigzag",
          spacing: "2%",
          lineColor: "#777777",
          lineThickness: 1,
          lineDashType: "solid",
          color: "#111111",
        },
      },
    ],
    legend: {
      fontFamily: s,
      fontSize: 14,
      fontColor: W,
      fontWeight: "bold",
      verticalAlign: "bottom",
      horizontalAlign: "center",
    },
    toolTip: {
      fontFamily: s,
      fontSize: 14,
      fontStyle: "normal",
      cornerRadius: 0,
      borderThickness: 1,
      fontColor: M,
      backgroundColor: "rgba(0, 0, 0, .7)",
    },
  };
  var bb = {
      light1: Ga,
      light2: Ja,
      dark1: Aa,
      dark2: X,
      theme1: Ga,
      theme2: Ja,
      theme3: Ga,
    },
    Y = {
      numberDuration: 1,
      yearDuration: 314496e5,
      monthDuration: 2592e6,
      weekDuration: 6048e5,
      dayDuration: 864e5,
      hourDuration: 36e5,
      minuteDuration: 6e4,
      secondDuration: 1e3,
      millisecondDuration: 1,
      dayOfWeekFromInt:
        "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
    },
    sb = (function () {
      var k = !1;
      try {
        var f =
          Object.defineProperty &&
          Object.defineProperty({}, "passive", {
            get: function () {
              k = !0;
              return !1;
            },
          });
        window.addEventListener &&
          (window.addEventListener("test", null, f),
          window.removeEventListener("test", null, f));
      } catch (v) {
        k = !1;
      }
      return k;
    })(),
    gb = {},
    Fa = null,
    mb = function (k) {
      var f = 0,
        v = 0;
      this.options.width
        ? (f = this.width)
        : (this.width = f =
            0 < this.container.clientWidth
              ? this.container.clientWidth
              : this.width);
      this.options.height
        ? (v = this.height)
        : (this.height = v =
            0 < this.container.clientHeight
              ? this.container.clientHeight
              : this.height);
      if (this.canvas.width !== f * ia || this.canvas.height !== v * ia) {
        for (var U = 0; U < k.length; U++) Ua(k[U], f, v);
        this.bounds = {
          x1: 0,
          y1: 0,
          x2: this.width,
          y2: this.height,
          width: this.width,
          height: this.height,
        };
        return !0;
      }
      return !1;
    },
    nb = function () {
      this.ctx.clearRect(0, 0, this.width, this.height);
      this.backgroundColor &&
        ((this.ctx.fillStyle = this.backgroundColor),
        this.ctx.fillRect(0, 0, this.width, this.height));
    },
    ob = function (k, f, v) {
      f = Math.min(this.width, this.height);
      return Math.max(
        "theme4" === this.theme ? 0 : 300 <= f ? 12 : 11,
        Math.round(f * (k / 400))
      );
    },
    oa = (function () {
      var k =
          /D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,
        f = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(
          " "
        ),
        v = "Sun Mon Tue Wed Thu Fri Sat".split(" "),
        U =
          "January February March April May June July August September October November December".split(
            " "
          ),
        Z = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
        s =
          /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        z = /[^-+\dA-Z]/g;
      return function (y, F, P) {
        var K = P ? P.days : f,
          N = P ? P.months : U,
          M = P ? P.shortDays : v,
          O = P ? P.shortMonths : Z;
        P = "";
        var d = !1;
        y = y && y.getTime ? y : y ? new Date(y) : new Date();
        if (isNaN(y)) throw SyntaxError("invalid date");
        "UTC:" === F.slice(0, 4) && ((F = F.slice(4)), (d = !0));
        P = d ? "getUTC" : "get";
        var u = y[P + "Date"](),
          x = y[P + "Day"](),
          t = y[P + "Month"](),
          a = y[P + "FullYear"](),
          e = y[P + "Hours"](),
          b = y[P + "Minutes"](),
          c = y[P + "Seconds"](),
          g = y[P + "Milliseconds"](),
          h = d ? 0 : y.getTimezoneOffset();
        return (P = F.replace(k, function (D) {
          switch (D) {
            case "D":
              return u;
            case "DD":
              return ka(u, 2);
            case "DDD":
              return M[x];
            case "DDDD":
              return K[x];
            case "M":
              return t + 1;
            case "MM":
              return ka(t + 1, 2);
            case "MMM":
              return O[t];
            case "MMMM":
              return N[t];
            case "Y":
              return parseInt(String(a).slice(-2));
            case "YY":
              return ka(String(a).slice(-2), 2);
            case "YYY":
              return ka(String(a).slice(-3), 3);
            case "YYYY":
              return ka(a, 4);
            case "h":
              return e % 12 || 12;
            case "hh":
              return ka(e % 12 || 12, 2);
            case "H":
              return e;
            case "HH":
              return ka(e, 2);
            case "m":
              return b;
            case "mm":
              return ka(b, 2);
            case "s":
              return c;
            case "ss":
              return ka(c, 2);
            case "f":
              return ka(String(g), 3).slice(0, 1);
            case "ff":
              return ka(String(g), 3).slice(0, 2);
            case "fff":
              return ka(String(g), 3).slice(0, 3);
            case "t":
              return 12 > e ? "a" : "p";
            case "tt":
              return 12 > e ? "am" : "pm";
            case "T":
              return 12 > e ? "A" : "P";
            case "TT":
              return 12 > e ? "AM" : "PM";
            case "K":
              return d
                ? "UTC"
                : (String(y).match(s) || [""]).pop().replace(z, "");
            case "z":
              return (0 < h ? "-" : "+") + Math.floor(Math.abs(h) / 60);
            case "zz":
              return (0 < h ? "-" : "+") + ka(Math.floor(Math.abs(h) / 60), 2);
            case "zzz":
              return (
                (0 < h ? "-" : "+") +
                ka(Math.floor(Math.abs(h) / 60), 2) +
                ka(Math.abs(h) % 60, 2)
              );
            default:
              return D.slice(1, D.length - 1);
          }
        }));
      };
    })(),
    $ = function (k, f, v) {
      if (null === k) return "";
      if (!isFinite(k)) return k;
      k = Number(k);
      var U = 0 > k ? !0 : !1;
      U && (k *= -1);
      var Z = v ? v.decimalSeparator : ".",
        s = v ? v.digitGroupSeparator : ",",
        z = "";
      f = String(f);
      var z = 1,
        y = (v = ""),
        F = -1,
        P = [],
        K = [],
        N = 0,
        M = 0,
        O = 0,
        d = !1,
        u = 0,
        y = f.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);
      f = null;
      for (var x = 0; y && x < y.length; x++)
        if (((f = y[x]), "." === f && 0 > F)) F = x;
        else {
          if ("%" === f) z *= 100;
          else if ("\u2030" === f) {
            z *= 1e3;
            continue;
          } else if ("," === f[0] && "." === f[f.length - 1]) {
            z /= Math.pow(1e3, f.length - 1);
            F = x + f.length - 1;
            continue;
          } else
            ("E" !== f[0] && "e" !== f[0]) ||
              "0" !== f[f.length - 1] ||
              (d = !0);
          0 > F
            ? (P.push(f), "#" === f || "0" === f ? N++ : "," === f && O++)
            : (K.push(f), ("#" !== f && "0" !== f) || M++);
        }
      d &&
        ((f = Math.floor(k)),
        (y = -Math.floor(Math.log(k) / Math.LN10 + 1)),
        (u = 0 === k ? 0 : 0 === f ? -(N + y) : String(f).length - N),
        (z /= Math.pow(10, u)));
      0 > F && (F = x);
      z = (k * z).toFixed(M);
      f = z.split(".");
      z = (f[0] + "").split("");
      k = (f[1] + "").split("");
      z && "0" === z[0] && z.shift();
      for (d = y = x = M = F = 0; 0 < P.length; )
        if (((f = P.pop()), "#" === f || "0" === f))
          if ((F++, F === N)) {
            var t = z,
              z = [];
            if ("0" === f)
              for (f = N - M - (t ? t.length : 0); 0 < f; ) t.unshift("0"), f--;
            for (; 0 < t.length; )
              (v = t.pop() + v),
                d++,
                0 === d % y && x === O && 0 < t.length && (v = s + v);
          } else
            0 < z.length
              ? ((v = z.pop() + v), M++, d++)
              : "0" === f && ((v = "0" + v), M++, d++),
              0 === d % y && x === O && 0 < z.length && (v = s + v);
        else
          ("E" !== f[0] && "e" !== f[0]) ||
          "0" !== f[f.length - 1] ||
          !/[eE][+-]*[0]+/.test(f)
            ? "," === f
              ? (x++, (y = d), (d = 0), 0 < z.length && (v = s + v))
              : (v =
                  1 < f.length &&
                  (('"' === f[0] && '"' === f[f.length - 1]) ||
                    ("'" === f[0] && "'" === f[f.length - 1]))
                    ? f.slice(1, f.length - 1) + v
                    : f + v)
            : ((f =
                0 > u
                  ? f.replace("+", "").replace("-", "")
                  : f.replace("-", "")),
              (v += f.replace(/[0]+/, function (a) {
                return ka(u, a.length);
              })));
      s = "";
      for (P = !1; 0 < K.length; )
        (f = K.shift()),
          "#" === f || "0" === f
            ? 0 < k.length && 0 !== Number(k.join(""))
              ? ((s += k.shift()), (P = !0))
              : "0" === f && ((s += "0"), (P = !0))
            : 1 < f.length &&
              (('"' === f[0] && '"' === f[f.length - 1]) ||
                ("'" === f[0] && "'" === f[f.length - 1]))
            ? (s += f.slice(1, f.length - 1))
            : ("E" !== f[0] && "e" !== f[0]) ||
              "0" !== f[f.length - 1] ||
              !/[eE][+-]*[0]+/.test(f)
            ? (s += f)
            : ((f =
                0 > u
                  ? f.replace("+", "").replace("-", "")
                  : f.replace("-", "")),
              (s += f.replace(/[0]+/, function (a) {
                return ka(u, a.length);
              })));
      v += (P ? Z : "") + s;
      return U ? "-" + v : v;
    },
    Ba = function (f) {
      var v = 0,
        L = 0;
      f = f || window.event;
      f.offsetX || 0 === f.offsetX
        ? ((v = f.offsetX), (L = f.offsetY))
        : f.layerX || 0 == f.layerX
        ? ((v = f.layerX), (L = f.layerY))
        : ((v = f.pageX - f.target.offsetLeft),
          (L = f.pageY - f.target.offsetTop));
      return { x: v, y: L };
    },
    lb = !0,
    Za = window.devicePixelRatio || 1,
    Va = 1,
    ia = lb ? Za / Va : 1,
    fa = function (f, v, L, U, s, y, z, F, K, P, N, M, O) {
      "undefined" === typeof O && (O = 1);
      z = z || 0;
      F = F || "black";
      var Q = 15 < U - v && 15 < s - L ? 8 : 0.35 * Math.min(U - v, s - L);
      f.beginPath();
      f.moveTo(v, L);
      f.save();
      f.fillStyle = y;
      f.globalAlpha = O;
      f.fillRect(v, L, U - v, s - L);
      f.globalAlpha = 1;
      0 < z &&
        ((O = 0 === z % 2 ? 0 : 0.5),
        f.beginPath(),
        (f.lineWidth = z),
        (f.strokeStyle = F),
        f.moveTo(v, L),
        f.rect(v - O, L - O, U - v + 2 * O, s - L + 2 * O),
        f.stroke());
      f.restore();
      !0 === K &&
        (f.save(),
        f.beginPath(),
        f.moveTo(v, L),
        f.lineTo(v + Q, L + Q),
        f.lineTo(U - Q, L + Q),
        f.lineTo(U, L),
        f.closePath(),
        (z = f.createLinearGradient((U + v) / 2, L + Q, (U + v) / 2, L)),
        z.addColorStop(0, y),
        z.addColorStop(1, "rgba(255, 255, 255, .4)"),
        (f.fillStyle = z),
        f.fill(),
        f.restore());
      !0 === P &&
        (f.save(),
        f.beginPath(),
        f.moveTo(v, s),
        f.lineTo(v + Q, s - Q),
        f.lineTo(U - Q, s - Q),
        f.lineTo(U, s),
        f.closePath(),
        (z = f.createLinearGradient((U + v) / 2, s - Q, (U + v) / 2, s)),
        z.addColorStop(0, y),
        z.addColorStop(1, "rgba(255, 255, 255, .4)"),
        (f.fillStyle = z),
        f.fill(),
        f.restore());
      !0 === N &&
        (f.save(),
        f.beginPath(),
        f.moveTo(v, L),
        f.lineTo(v + Q, L + Q),
        f.lineTo(v + Q, s - Q),
        f.lineTo(v, s),
        f.closePath(),
        (z = f.createLinearGradient(v + Q, (s + L) / 2, v, (s + L) / 2)),
        z.addColorStop(0, y),
        z.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (f.fillStyle = z),
        f.fill(),
        f.restore());
      !0 === M &&
        (f.save(),
        f.beginPath(),
        f.moveTo(U, L),
        f.lineTo(U - Q, L + Q),
        f.lineTo(U - Q, s - Q),
        f.lineTo(U, s),
        (z = f.createLinearGradient(U - Q, (s + L) / 2, U, (s + L) / 2)),
        z.addColorStop(0, y),
        z.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (f.fillStyle = z),
        z.addColorStop(0, y),
        z.addColorStop(1, "rgba(255, 255, 255, 0.1)"),
        (f.fillStyle = z),
        f.fill(),
        f.closePath(),
        f.restore());
    },
    wa = function (f) {
      for (var v = "", L = 0; L < f.length; L++)
        v += String.fromCharCode(
          Math.ceil(f.length / 57 / 5) ^ f.charCodeAt(L)
        );
      return v;
    },
    ub =
      window &&
      window[wa("mnb`uhno")] &&
      window[wa("mnb`uhno")].href &&
      window[wa("mnb`uhno")].href.indexOf &&
      (-1 !== window[wa("mnb`uhno")].href.indexOf(wa("b`ow`rkr/bnl")) ||
        -1 !== window[wa("mnb`uhno")].href.indexOf(wa("gdonqhy/bnl")) ||
        -1 !== window[wa("mnb`uhno")].href.indexOf(wa("gheemd"))) &&
      -1 === window[wa("mnb`uhno")].href.indexOf(wa("gheemd")),
    vb = {
      reset: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPjSURBVFhHxVdJaFNRFP1J/jwkP5MxsbaC1WJEglSxOFAXIsFpVRE3ggi1K90obioRRBA33XXnQnciirhQcMCdorgQxBkXWlREkFKsWkv5npvckp/XnzRpKh64kLw733fffe9L/wrL0+mVUdO8uTSZ3MBL/we2qg4rkuSpodCELstXE46ziVkLQ6FQcGOmeSSq6wd4aV50d3drWjj8kQKZJTUc9kxFGenv79dZrDksTSTWWJp2QYtEPiErysyzdX0LsxsCQR8keX8gs6RHIk8ysdgKFg2G53mhuOPsshTlBjKaFo1g7SqLNoShKLdFXT8huQ/paLSbxatYnc2mHMM4hr18Vi8TIvCmXF3vYrW6cF23gGTOk0M1wA4RKvOmq6vLZRVJipvmSWT6tZ6CSEYkco5V50VPT4+D7RwOqi6RiSZm0fJ+vggSqkeoypdsNmuyelNwbXsbgvkWYMtzDWNvWaijoyOBqE+hVK8abcssUeXQ/YfKyi0gFYv1Ipgfoj34fYGTJLOYJA0ODirok32GLN8XhUWCwSes1hIwBg6LydJ/tEeRRapAdUp+wSAiZchtZZWWgAZ+JNpD8peYXQVK9UwUxNpzOK8pq97kURZhYTCKBwPD7h2zK+js7Myi7D8Fod+0TkMI8+EMAngLGc/WtBFWawkFHFnoj/t9KLgGmF0B3QfkxC+EarxkdhnFYlFLY06USqUwL7UMjICHfh/wOc2sCqhpxGbCkLvL7EUDbF73+6DkmVWB6zi7xUDQSLeYvWjAILvm9zEnkJhlbRcDQZcv6Kg2AipyT/Axw6wKlqVSqxDdjF8Izfod13qURdrG/nxehY+xGh+h0CSzKygGvSNQIcc097BI24jb9hax6kj2E7OrMFX1il+ICEf2NrPbhiXLl+fYl+U7zK4iYdsDcyLGf+ofFlkwcN+s10KhmpuYhhtm0hCLVIFL0MDsqNlDIqy9x2CLs1jL6OvrI7vPRbtohXG6eFmsFnHDGAp6n9AgyuVySRZrGvROxRgIfLXhzjrNYnNBUxNX/dMgRWT1mt4XLDovaApD53E9W3ilNX5M55LJHpRtIsgAvciR4WWcgK2Dvb1YqgXevmF8z2zEBTcKG39EfSKsT9EbhVUaI2FZO+oZIqImxol6j66/hcAu4sSN4vc1ZPoKeoE6RGhYL2YYA+ymOSSi0Z0wWntbtkGUWCvfSDXIxONraZ/FY90KUfNTpfC5spnNLgxoYNnR9RO4F8ofXEHOgogCQE99w+fF2Xw+b7O59rEOsyRqGEfpVoaDMQQ1CZrG46bcM6AZ0C/wPqNfHliqejyTySxh9TqQpL+xmbIlkB9SlAAAAABJRU5ErkJggg==",
      },
      pan: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAICSURBVEhLxZbPahNRGMUn/5MpuAiBEAIufQGfzr5E40YptBXajYzudCEuGqS+gGlrFwquDGRTutBdYfydzJ3LzeQmJGZue+Dw/Z17Mnfmu5Pof9Hr9Z61Wq0bWZMKj263O6xWq99wU9lOpzPMKgEhEcRucNOcioOK+0RzBhNvt9tPV4nmVF19+OWhVqt9xXgFXZq+8lCv119UKpUJ7iX2FmvFTKz8RH34YdBsNk8wVtjE4fGYwm8wrrDi3WBG5oKXZGRSS9hGuNFojLTe2lFz5xThWZIktayyiE2FdT3rzXBXz7krKiL8c17wAKFDjCus2AvW+YGZ9y2JF0VFRuMPfI//rsCE/C+s26s4gQu9ul7r4NteKx7H8XOC724xNNGbaNu++IrBqbOV7Tj3FgMRvc/YKOr3+3sE47wgEt/Bl/gaK5cHbNU11vYSXylfpK7XOvjuumPp4Wcoipu30Qsez2uMXYz4lfI+mOmwothY+SLiXJy7mKVpWs3Si0CoOMfeI9Od43Wic+jO+ZVv+crsm9QSNhUW9LXSeoPBYLXopthGuFQgdIxxhY+UDwlt1x5CZ1hX+NTUdt/OIvjKaDSmuOJfaIVNPKX+W18j/PLA2/kR44p5Sd8HbHngT/yTfNRWUXX14ZcL3wmX0+TLf8YO7CGT8yFE5zB3/gney25/OETRP9CtPDFe5jShAAAAAElFTkSuQmCC",
      },
      zoom: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALWSURBVEhLvZZLaBNRFIabyftBIgEfqCCBoCC6MYqiXYiIj4U76U4X7sUHbhQhUBfixhZEUBDB16YuFERaUaQLK7ooCOJj4UKtYEFU0EptShO/A9Ph3js3k8lo/eHnP7n3nP/M3LlzMz1hkUwmNziOcyKRSFyFt+LxeD/c2Wq1Ym7Kv0M2m11Os1OxWGycn1OwZXCGuXfwIhezkd9/jRgNT2L4ldhs1pbkX5OLJe4euVxuGQaPCa3mnUjtJx7BDuKusJTCV6jVVGHTMuYRjxma7yIOhTgFY6jNaAKew2xPKpVay9ganmkvj+M448/MfJdT5K5Gg4HJacRngPFgqVRaRNwW1B4i7yehWfsEDdz1K+A01AoxPIqGAiuwGfkOTY8+1A6u7AyiFTB2Hu0KPIrdiOnzHLWDybeImvy+Wq2mZa5bUHsD0Zpz+KxHdWQymV6kAb1ElqeORgJLvgnRdj1+R1AfzkIvSUjxVjQSarVakrueIPT8+H1F5jSUy+WXiJrUYBVWyVxU4PEU8TzhfaijUqnMIWrjaY492eWRwdKOIqrnIxnXwLLeRLwk2GQzrEMjg0avEbXxkIxr4OoOImpj2QwyFgms1koa/SZUG8s+0iGnEhNfCNXEhzIXBVz0McTzEvJ+70P9oNFtxEzei3aFYrFYxmuSUPWSv9Yi9IMm2xE1We56Mp1OV4nDwqFmBDV9gk9AEh4gZtFHNt8W4kAUCoXF5MorY9Z/kDni9nDv7hc0i2fhgLvTtX8a99PoMPPagTFPxofRzmDJ9yM+AyEmTfgGysYbQcfhDzPPJDmX0c7gDg4gs9BqFIWhm/Nct5H8gtBq1I7UfIbtvmIuoaGQcp+fdpbbSM43eEH5wrwLbXmhm/fU63VHXjcuok7hEByFY/AeHGC8L5/PL3HT5xGH1uYwfPOICGo+CBcU0vwO1BqzUqILDl/z/9VYIMfpddiAc47jDP8BsUpb13wOLRwAAAAASUVORK5CYII=",
      },
      menu: {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVFhH7dc9CsJAFATgRxIIBCwCqZKATX5sbawsY2MvWOtF9AB6AU8gguAJbD2AnZ2VXQT/Ko2TYGCL2OYtYQc+BuYA+1hCtnCVwMm27SGaXpDJIAiCvCkVR05hGOZNN3HkFMdx3nQRR06+76/R1IcFLJlNQEWlmWlBTwJtKLKHynehZqnjOGM0PYWRVXk61C37p7xlZ3Hk5HneCk1dmMH811xGoKLSzDiQwIBZB4ocoPJdqNkDt2yKlueWRVGUtzy3rPwo3sWRU3nLjuLI6OO67oZM00wMw3hrmpZx0XU9syxrR0T0BeMpb9dneSR2AAAAAElFTkSuQmCC",
      },
    };
  Q.prototype.setOptions = function (f, v) {
    if (ma[this._defaultsKey]) {
      var L = ma[this._defaultsKey],
        s;
      for (s in L)
        "publicProperties" !== s &&
          L.hasOwnProperty(s) &&
          (this[s] = f && s in f ? f[s] : v && s in v ? v[s] : L[s]);
    } else Ma && window.console && console.log("defaults not set");
  };
  Q.prototype.get = function (f) {
    var v = ma[this._defaultsKey];
    if ("options" === f)
      return this.options && this.options._isPlaceholder ? null : this.options;
    if (
      v.hasOwnProperty(f) ||
      (v.publicProperties && v.publicProperties.hasOwnProperty(f))
    )
      return this[f];
    window.console &&
      window.console.log(
        'Property "' + f + "\" doesn't exist. Please check for typo."
      );
  };
  Q.prototype.set = function (f, v, L) {
    L = "undefined" === typeof L ? !0 : L;
    var s = ma[this._defaultsKey];
    if ("options" === f) this.createUserOptions(v);
    else if (
      s.hasOwnProperty(f) ||
      (s.publicProperties &&
        s.publicProperties.hasOwnProperty(f) &&
        "readWrite" === s.publicProperties[f])
    )
      this.options._isPlaceholder && this.createUserOptions(),
        (this.options[f] = v);
    else {
      window.console &&
        (s.publicProperties &&
        s.publicProperties.hasOwnProperty(f) &&
        "readOnly" === s.publicProperties[f]
          ? window.console.log('Property "' + f + '" is read-only.')
          : window.console.log(
              'Property "' + f + "\" doesn't exist. Please check for typo."
            ));
      return;
    }
    L && (this.stockChart || this.chart || this).render();
  };
  Q.prototype.addTo = function (f, v, L, s) {
    s = "undefined" === typeof s ? !0 : s;
    var y = ma[this._defaultsKey];
    y.hasOwnProperty(f) ||
    (y.publicProperties &&
      y.publicProperties.hasOwnProperty(f) &&
      "readWrite" === y.publicProperties[f])
      ? (this.options._isPlaceholder && this.createUserOptions(),
        "undefined" === typeof this.options[f] && (this.options[f] = []),
        (f = this.options[f]),
        (L = "undefined" === typeof L || null === L ? f.length : L),
        f.splice(L, 0, v),
        s && (this.stockChart || this.chart || this).render())
      : window.console &&
        (y.publicProperties &&
        y.publicProperties.hasOwnProperty(f) &&
        "readOnly" === y.publicProperties[f]
          ? window.console.log('Property "' + f + '" is read-only.')
          : window.console.log(
              'Property "' + f + "\" doesn't exist. Please check for typo."
            ));
  };
  Q.prototype.createUserOptions = function (f) {
    if ("undefined" !== typeof f || this.options._isPlaceholder)
      if (
        (this.parent.options._isPlaceholder && this.parent.createUserOptions(),
        this.isOptionsInArray)
      ) {
        this.parent.options[this.optionsName] ||
          (this.parent.options[this.optionsName] = []);
        var v = this.parent.options[this.optionsName],
          s = v.length;
        this.options._isPlaceholder || (Ea(v), (s = v.indexOf(this.options)));
        this.options = "undefined" === typeof f ? {} : f;
        v[s] = this.options;
      } else
        (this.options = "undefined" === typeof f ? {} : f),
          (f = this.parent.options),
          this.optionsName
            ? (v = this.optionsName)
            : (v = this._defaultsKey) && 0 !== v.length
            ? ((s = v.charAt(0).toLowerCase()),
              1 < v.length && (s = s.concat(v.slice(1))),
              (v = s))
            : (v = void 0),
          (f[v] = this.options);
  };
  Q.prototype.remove = function (f) {
    f = "undefined" === typeof f ? !0 : f;
    if (this.isOptionsInArray) {
      var v = this.parent.options[this.optionsName];
      Ea(v);
      var s = v.indexOf(this.options);
      0 <= s && v.splice(s, 1);
    } else delete this.parent.options[this.optionsName];
    f && (this.stockChart || this.chart || this).render();
  };
  Q.prototype.updateOption = function (k) {
    !ma[this._defaultsKey] &&
      Ma &&
      window.console &&
      console.log("defaults not set");
    var v = ma[this._defaultsKey],
      s = {},
      y = this[k],
      F = this._themeOptionsKey,
      H = this._index;
    this.theme && f(this.parent) && f(F) && f(H)
      ? (s = f(this.predefinedThemes[this.theme])
          ? this.predefinedThemes.light1
          : this.predefinedThemes[this.theme])
      : this.parent &&
        this.parent.themeOptions &&
        this.parent.themeOptions[F] &&
        (null === H
          ? (s = this.parent.themeOptions[F])
          : 0 < this.parent.themeOptions[F].length &&
            ((s = Math.min(this.parent.themeOptions[F].length - 1, H)),
            (s = this.parent.themeOptions[F][s])));
    this.themeOptions = s;
    k in v &&
      (y = k in this.options ? this.options[k] : s && k in s ? s[k] : v[k]);
    if (y === this[k]) return !1;
    this[k] = y;
    return !0;
  };
  Q.prototype.trackChanges = function (f) {
    if (!this.sessionVariables) throw "Session Variable Store not set";
    this.sessionVariables[f] = this.options[f];
  };
  Q.prototype.isBeingTracked = function (f) {
    this.options._oldOptions || (this.options._oldOptions = {});
    return this.options._oldOptions[f] ? !0 : !1;
  };
  Q.prototype.hasOptionChanged = function (f) {
    if (!this.sessionVariables) throw "Session Variable Store not set";
    return this.sessionVariables[f] !== this.options[f];
  };
  Q.prototype.addEventListener = function (f, v, s) {
    f &&
      v &&
      ((this._eventListeners[f] = this._eventListeners[f] || []),
      this._eventListeners[f].push({ context: s || this, eventHandler: v }));
  };
  Q.prototype.removeEventListener = function (f, v) {
    if (f && v && this._eventListeners[f])
      for (var s = this._eventListeners[f], y = 0; y < s.length; y++)
        if (s[y].eventHandler === v) {
          s[y].splice(y, 1);
          break;
        }
  };
  Q.prototype.removeAllEventListeners = function () {
    this._eventListeners = [];
  };
  Q.prototype.dispatchEvent = function (f, v, s) {
    if (f && this._eventListeners[f]) {
      v = v || {};
      for (var y = this._eventListeners[f], F = 0; F < y.length; F++)
        y[F].eventHandler.call(y[F].context, v);
    }
    "function" === typeof this[f] && this[f].call(s || this.chart, v);
  };
  La.prototype.registerSpace = function (f, v) {
    "top" === f
      ? (this._topOccupied += v.height)
      : "bottom" === f
      ? (this._bottomOccupied += v.height)
      : "left" === f
      ? (this._leftOccupied += v.width)
      : "right" === f && (this._rightOccupied += v.width);
  };
  La.prototype.unRegisterSpace = function (f, v) {
    "top" === f
      ? (this._topOccupied -= v.height)
      : "bottom" === f
      ? (this._bottomOccupied -= v.height)
      : "left" === f
      ? (this._leftOccupied -= v.width)
      : "right" === f && (this._rightOccupied -= v.width);
  };
  La.prototype.getFreeSpace = function () {
    return {
      x1: this._x1 + this._leftOccupied,
      y1: this._y1 + this._topOccupied,
      x2: this._x2 - this._rightOccupied,
      y2: this._y2 - this._bottomOccupied,
      width: this._x2 - this._x1 - this._rightOccupied - this._leftOccupied,
      height: this._y2 - this._y1 - this._bottomOccupied - this._topOccupied,
    };
  };
  La.prototype.reset = function () {
    this._rightOccupied =
      this._leftOccupied =
      this._bottomOccupied =
      this._topOccupied =
        this._padding;
  };
  ha(na, Q);
  na.prototype._initialize = function () {
    f(this.padding) || "object" !== typeof this.padding
      ? (this.topPadding =
          this.rightPadding =
          this.bottomPadding =
          this.leftPadding =
            Number(this.padding) | 0)
      : ((this.topPadding = f(this.padding.top)
          ? 0
          : Number(this.padding.top) | 0),
        (this.rightPadding = f(this.padding.right)
          ? 0
          : Number(this.padding.right) | 0),
        (this.bottomPadding = f(this.padding.bottom)
          ? 0
          : Number(this.padding.bottom) | 0),
        (this.leftPadding = f(this.padding.left)
          ? 0
          : Number(this.padding.left) | 0));
  };
  na.prototype.render = function (f) {
    if (0 !== this.fontSize) {
      f && this.ctx.save();
      var v = this.ctx.font;
      this.ctx.textBaseline = this.textBaseline;
      var s = 0;
      this._isDirty && this.measureText(this.ctx);
      this.ctx.translate(this.x, this.y + s);
      "middle" === this.textBaseline && (s = -this._lineHeight / 2);
      this.ctx.font = this._getFontString();
      this.ctx.rotate((Math.PI / 180) * this.angle);
      var y = 0,
        F = this.topPadding,
        H = null;
      this.ctx.roundRect || Ha(this.ctx);
      ((0 < this.borderThickness && this.borderColor) ||
        this.backgroundColor) &&
        this.ctx.roundRect(
          0,
          s,
          this.width,
          this.height,
          this.cornerRadius,
          this.borderThickness,
          this.backgroundColor,
          this.borderColor
        );
      this.ctx.fillStyle = this.fontColor;
      for (s = 0; s < this._wrappedText.lines.length; s++) {
        H = this._wrappedText.lines[s];
        if ("right" === this.horizontalAlign || "right" === this.textAlign)
          y = this.width - H.width - this.rightPadding;
        else if ("left" === this.horizontalAlign || "left" === this.textAlign)
          y = this.leftPadding;
        else if (
          "center" === this.horizontalAlign ||
          "center" === this.textAlign
        )
          y =
            (this.width - (this.leftPadding + this.rightPadding)) / 2 -
            H.width / 2 +
            this.leftPadding;
        this.ctx.fillText(H.text, y, F);
        F += H.height;
      }
      this.ctx.font = v;
      f && this.ctx.restore();
    }
  };
  na.prototype.setText = function (f) {
    this.text = f;
    this._isDirty = !0;
    this._wrappedText = null;
  };
  na.prototype.measureText = function () {
    this._lineHeight = fb(this.fontFamily, this.fontSize, this.fontWeight);
    if (null === this.maxWidth)
      throw "Please set maxWidth and height for TextBlock";
    this._wrapText(this.ctx);
    this._isDirty = !1;
    return { width: this.width, height: this.height };
  };
  na.prototype._getLineWithWidth = function (f, v, s) {
    f = String(f);
    if (!f) return { text: "", width: 0 };
    var y = (s = 0),
      F = f.length - 1,
      H = Infinity;
    for (this.ctx.font = this._getFontString(); y <= F; ) {
      var H = Math.floor((y + F) / 2),
        z = f.substr(0, H + 1);
      s = this.ctx.measureText(z).width;
      if (s < v) y = H + 1;
      else if (s > v) F = H - 1;
      else break;
    }
    s > v &&
      1 < z.length &&
      ((z = z.substr(0, z.length - 1)), (s = this.ctx.measureText(z).width));
    v = !0;
    if (z.length === f.length || " " === f[z.length]) v = !1;
    v &&
      ((f = z.split(" ")),
      1 < f.length && f.pop(),
      (z = f.join(" ")),
      (s = this.ctx.measureText(z).width));
    return { text: z, width: s };
  };
  na.prototype._wrapText = function () {
    var f = new String(Pa(String(this.text))),
      v = [],
      s = this.ctx.font,
      y = 0,
      F = 0;
    this.ctx.font = this._getFontString();
    if (0 === this.frontSize) F = y = 0;
    else
      for (; 0 < f.length; ) {
        var H = this.maxHeight - (this.topPadding + this.bottomPadding),
          z = this._getLineWithWidth(
            f,
            this.maxWidth - (this.leftPadding + this.rightPadding),
            !1
          );
        z.height = this._lineHeight;
        v.push(z);
        var K = F,
          F = Math.max(F, z.width),
          y = y + z.height,
          f = Pa(f.slice(z.text.length, f.length));
        H && y > H && ((z = v.pop()), (y -= z.height), (F = K));
      }
    this._wrappedText = { lines: v, width: F, height: y };
    this.width = F + (this.leftPadding + this.rightPadding);
    this.height = y + (this.topPadding + this.bottomPadding);
    this.ctx.font = s;
  };
  na.prototype._getFontString = function () {
    var f;
    f = "" + (this.fontStyle ? this.fontStyle + " " : "");
    f += this.fontWeight ? this.fontWeight + " " : "";
    f += this.fontSize ? this.fontSize + "px " : "";
    var B = this.fontFamily ? this.fontFamily + "" : "";
    !v &&
      B &&
      ((B = B.split(",")[0]),
      "'" !== B[0] && '"' !== B[0] && (B = "'" + B + "'"));
    return (f += B);
  };
  ha(Xa, Q);
  ha(Ia, Q);
  Ia.prototype.setLayout = function () {
    if (this.text) {
      var v = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
        B = v.layoutManager.getFreeSpace(),
        s = B.x1,
        y = B.y1,
        F = 0,
        H = 0,
        z =
          this.chart._menuButton &&
          this.chart.exportEnabled &&
          "top" === this.verticalAlign
            ? 22
            : 0,
        K,
        N;
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? (null === this.maxWidth &&
            (this.maxWidth =
              B.width - 4 - z * ("center" === this.horizontalAlign ? 2 : 1)),
          (H = 0.5 * B.height - this.margin - 2),
          (F = 0))
        : "center" === this.verticalAlign &&
          ("left" === this.horizontalAlign || "right" === this.horizontalAlign
            ? (null === this.maxWidth && (this.maxWidth = B.height - 4),
              (H = 0.5 * B.width - this.margin - 2))
            : "center" === this.horizontalAlign &&
              (null === this.maxWidth && (this.maxWidth = B.width - 4),
              (H = 0.5 * B.height - 4)));
      var P;
      f(this.padding) || "number" !== typeof this.padding
        ? f(this.padding) ||
          "object" !== typeof this.padding ||
          ((P = this.padding.top
            ? this.padding.top
            : this.padding.bottom
            ? this.padding.bottom
            : 0),
          (P += this.padding.bottom
            ? this.padding.bottom
            : this.padding.top
            ? this.padding.top
            : 0))
        : (P = 2 * this.padding);
      this.wrap || (H = Math.min(H, 1.5 * this.fontSize + P));
      H = new na(this.ctx, {
        fontSize: this.fontSize,
        fontFamily: this.fontFamily,
        fontColor: this.fontColor,
        fontStyle: this.fontStyle,
        fontWeight: this.fontWeight,
        horizontalAlign: this.horizontalAlign,
        verticalAlign: this.verticalAlign,
        borderColor: this.borderColor,
        borderThickness: this.borderThickness,
        backgroundColor: this.backgroundColor,
        maxWidth: this.maxWidth,
        maxHeight: H,
        cornerRadius: this.cornerRadius,
        text: this.text,
        padding: this.padding,
        textBaseline: "top",
      });
      P = H.measureText();
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? ("top" === this.verticalAlign
            ? ((y = B.y1 + 2), (N = "top"))
            : "bottom" === this.verticalAlign &&
              ((y = B.y2 - 2 - P.height), (N = "bottom")),
          "left" === this.horizontalAlign
            ? (s = B.x1 + 2)
            : "center" === this.horizontalAlign
            ? (s = B.x1 + B.width / 2 - P.width / 2)
            : "right" === this.horizontalAlign && (s = B.x2 - 2 - P.width - z),
          (K = this.horizontalAlign),
          (this.width = P.width),
          (this.height = P.height))
        : "center" === this.verticalAlign &&
          ("left" === this.horizontalAlign
            ? ((s = B.x1 + 2),
              (y = B.y2 - 2 - (this.maxWidth / 2 - P.width / 2)),
              (F = -90),
              (N = "left"),
              (this.width = P.height),
              (this.height = P.width))
            : "right" === this.horizontalAlign
            ? ((s = B.x2 - 2),
              (y = B.y1 + 2 + (this.maxWidth / 2 - P.width / 2)),
              (F = 90),
              (N = "right"),
              (this.width = P.height),
              (this.height = P.width))
            : "center" === this.horizontalAlign &&
              ((y = v.y1 + (v.height / 2 - P.height / 2)),
              (s = v.x1 + (v.width / 2 - P.width / 2)),
              (N = "center"),
              (this.width = P.width),
              (this.height = P.height)),
          (K = "center"));
      H.x = s;
      H.y = y;
      H.angle = F;
      H.horizontalAlign = K;
      this._textBlock = H;
      v.layoutManager.registerSpace(N, {
        width:
          this.width + ("left" === N || "right" === N ? this.margin + 2 : 0),
        height:
          this.height + ("top" === N || "bottom" === N ? this.margin + 2 : 0),
      });
      this.bounds = { x1: s, y1: y, x2: s + this.width, y2: y + this.height };
      this.ctx.textBaseline = "top";
    }
  };
  Ia.prototype.render = function () {
    this._textBlock && this._textBlock.render(!0);
  };
  ha(Na, Q);
  Na.prototype.setLayout = Ia.prototype.setLayout;
  Na.prototype.render = Ia.prototype.render;
  ab.prototype.get = function (f, v) {
    var s = null;
    0 < this.pool.length
      ? ((s = this.pool.pop()), Ua(s, f, v))
      : (s = ta(f, v));
    return s;
  };
  ab.prototype.release = function (f) {
    this.pool.push(f);
  };
  ha(Oa, Q);
  var Sa = {
    addTheme: function (f, v) {
      bb[f] = v;
    },
    addColorSet: function (f, v) {
      ya[f] = v;
    },
    addCultureInfo: function (f, v) {
      Ra[f] = v;
    },
    formatNumber: function (f, v, s) {
      s = s || "en";
      if (Ra[s]) return $(f, v || "#,##0.##", new Oa(s));
      throw "Unknown Culture Name";
    },
    formatDate: function (f, v, s) {
      s = s || "en";
      if (Ra[s]) return oa(f, v || "DD MMM YYYY", new Oa(s));
      throw "Unknown Culture Name";
    },
  };
  "undefined" !== typeof module && "undefined" !== typeof module.exports
    ? (module.exports = Sa)
    : "function" === typeof define && define.amd
    ? define([], function () {
        return Sa;
      })
    : (window.CanvasJS &&
        window.console &&
        window.console.log(
          "CanvasJS namespace already exists. If you are loading both chart and stockchart scripts, just load stockchart alone as it includes all chart features."
        ),
      (window.CanvasJS = window.CanvasJS ? window.CanvasJS : Sa));
  var Ka = (Sa.Chart = (function () {
    function k(a, e) {
      return a.x - e.x;
    }
    function s(a, e, b) {
      e = e || {};
      f(b)
        ? ((this.predefinedThemes = bb),
          (this.optionsName = this.parent = this.index = null))
        : ((this.parent = b.parent),
          (this.index = b.index),
          (this.predefinedThemes = b.predefinedThemes),
          (this.optionsName = b.optionsName),
          (this.stockChart = b.stockChart),
          (this.panel = a),
          (this.isOptionsInArray = b.isOptionsInArray));
      this.theme =
        f(e.theme) || f(this.predefinedThemes[e.theme]) ? "light1" : e.theme;
      s.base.constructor.call(
        this,
        "Chart",
        this.optionsName,
        e,
        this.index,
        this.parent
      );
      var c = this;
      this._containerId = a;
      this._objectsInitialized = !1;
      this.overlaidCanvasCtx = this.ctx = null;
      this._indexLabels = [];
      this._panTimerId = 0;
      this._lastTouchEventType = "";
      this._lastTouchData = null;
      this.isAnimating = !1;
      this.renderCount = 0;
      this.disableToolTip = this.animatedRender = !1;
      this.canvasPool = new ab();
      this.allDOMEventHandlers = [];
      this.panEnabled = !1;
      this._defaultCursor = "default";
      this.plotArea = {
        canvas: null,
        ctx: null,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        width: 0,
        height: 0,
      };
      this._dataInRenderedOrder = [];
      (this.container =
        "string" === typeof this._containerId
          ? document.getElementById(this._containerId)
          : this._containerId)
        ? ((this.container.innerHTML = ""),
          (e = a = 0),
          (a = this.options.width
            ? this.width
            : 0 < this.container.clientWidth
            ? this.container.clientWidth
            : this.width),
          (e = this.options.height
            ? this.height
            : 0 < this.container.clientHeight
            ? this.container.clientHeight
            : this.height),
          (this.width = a),
          (this.height = e),
          (this.x1 = this.y1 = 0),
          (this.x2 = this.width),
          (this.y2 = this.height),
          (this.selectedColorSet =
            "undefined" !== typeof ya[this.colorSet]
              ? ya[this.colorSet]
              : ya.colorSet1),
          (this._canvasJSContainer = document.createElement("div")),
          this._canvasJSContainer.setAttribute(
            "class",
            "canvasjs-chart-container"
          ),
          (this._canvasJSContainer.style.position = "relative"),
          (this._canvasJSContainer.style.textAlign = "left"),
          (this._canvasJSContainer.style.cursor = "auto"),
          (this._canvasJSContainer.style.direction = "ltr"),
          v || (this._canvasJSContainer.style.height = "0px"),
          this.container.appendChild(this._canvasJSContainer),
          (this.canvas = ta(a, e)),
          (this._preRenderCanvas = ta(a, e)),
          (this.canvas.style.position = "absolute"),
          (this.canvas.style.WebkitUserSelect = "none"),
          (this.canvas.style.MozUserSelect = "none"),
          (this.canvas.style.msUserSelect = "none"),
          (this.canvas.style.userSelect = "none"),
          this.canvas.getContext &&
            (this._canvasJSContainer.appendChild(this.canvas),
            (this.ctx = this.canvas.getContext("2d")),
            (this.ctx.textBaseline = "top"),
            Ha(this.ctx),
            (this._preRenderCtx = this._preRenderCanvas.getContext("2d")),
            (this._preRenderCtx.textBaseline = "top"),
            Ha(this._preRenderCtx),
            v
              ? (this.plotArea.ctx = this.ctx)
              : ((this.plotArea.canvas = ta(a, e)),
                (this.plotArea.canvas.style.position = "absolute"),
                this.plotArea.canvas.setAttribute("class", "plotAreaCanvas"),
                this._canvasJSContainer.appendChild(this.plotArea.canvas),
                (this.plotArea.ctx = this.plotArea.canvas.getContext("2d"))),
            (this.overlaidCanvas = ta(a, e)),
            (this.overlaidCanvas.style.position = "absolute"),
            (this.overlaidCanvas.style.webkitTapHighlightColor = "transparent"),
            (this.overlaidCanvas.style.WebkitUserSelect = "none"),
            (this.overlaidCanvas.style.MozUserSelect = "none"),
            (this.overlaidCanvas.style.msUserSelect = "none"),
            (this.overlaidCanvas.style.userSelect = "none"),
            this.overlaidCanvas.getContext &&
              (this._canvasJSContainer.appendChild(this.overlaidCanvas),
              (this.overlaidCanvasCtx = this.overlaidCanvas.getContext("2d")),
              (this.overlaidCanvasCtx.textBaseline = "top"),
              Ha(this.overlaidCanvasCtx)),
            (this._eventManager = new ka(this)),
            (this.windowResizeHandler = y(
              window,
              "resize",
              function () {
                c._updateSize() && c.render();
              },
              this.allDOMEventHandlers
            )),
            (this._toolBar = document.createElement("div")),
            this._toolBar.setAttribute("class", "canvasjs-chart-toolbar"),
            (this._toolBar.style.cssText =
              "position: absolute; right: 1px; top: 1px;"),
            this._canvasJSContainer.appendChild(this._toolBar),
            (this.bounds = { x1: 0, y1: 0, x2: this.width, y2: this.height }),
            y(
              this.overlaidCanvas,
              "click",
              function (a) {
                c._mouseEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              "mousemove",
              function (a) {
                c._mouseEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              "mouseup",
              function (a) {
                c._mouseEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              "mousedown",
              function (a) {
                c._mouseEventHandler(a);
                za(c._dropdownMenu);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              "mouseout",
              function (a) {
                c._mouseEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              window.navigator.msPointerEnabled
                ? "MSPointerDown"
                : "touchstart",
              function (a) {
                c._touchEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove",
              function (a) {
                c._touchEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend",
              function (a) {
                c._touchEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            y(
              this.overlaidCanvas,
              window.navigator.msPointerEnabled
                ? "MSPointerCancel"
                : "touchcancel",
              function (a) {
                c._touchEventHandler(a);
              },
              this.allDOMEventHandlers
            ),
            (this.toolTip = new aa(this, this.options.toolTip)),
            (this.data = null),
            (this.axisX = []),
            (this.axisX2 = []),
            (this.axisY = []),
            (this.axisY2 = []),
            (this.sessionVariables = {
              axisX: [],
              axisX2: [],
              axisY: [],
              axisY2: [],
            })))
        : window.console &&
          window.console.log(
            'CanvasJS Error: Chart Container with id "' +
              this._containerId +
              '" was not found'
          );
    }
    function F(a, e) {
      for (var b = [], c, g = 0; g < a.length; g++)
        if (0 == g) b.push(a[0]);
        else {
          var h, D, f;
          f = g - 1;
          h = 0 === f ? 0 : f - 1;
          D = f === a.length - 1 ? f : f + 1;
          c =
            (Math.abs(
              (a[D].x - a[h].x) /
                (0 === a[D].x - a[f].x ? 0.01 : a[D].x - a[f].x)
            ) *
              (e - 1)) /
              2 +
            1;
          var d = (a[D].x - a[h].x) / c;
          c = (a[D].y - a[h].y) / c;
          b[b.length] =
            (a[f].x > a[h].x && 0 < d) || (a[f].x < a[h].x && 0 > d)
              ? { x: a[f].x + d / 3, y: a[f].y + c / 3 }
              : { x: a[f].x, y: a[f].y + c / 9 };
          f = g;
          h = 0 === f ? 0 : f - 1;
          D = f === a.length - 1 ? f : f + 1;
          c =
            (Math.abs(
              (a[D].x - a[h].x) /
                (0 === a[f].x - a[h].x ? 0.01 : a[f].x - a[h].x)
            ) *
              (e - 1)) /
              2 +
            1;
          d = (a[D].x - a[h].x) / c;
          c = (a[D].y - a[h].y) / c;
          b[b.length] =
            (a[f].x > a[h].x && 0 < d) || (a[f].x < a[h].x && 0 > d)
              ? { x: a[f].x - d / 3, y: a[f].y - c / 3 }
              : { x: a[f].x, y: a[f].y - c / 9 };
          b[b.length] = a[g];
        }
      return b;
    }
    function K(a, e, b, c, g, h, D, f, d, m) {
      var n = 0;
      m ? ((D.color = h), (f.color = h)) : (m = 1);
      n = d ? Math.abs(g - b) : Math.abs(c - e);
      n =
        0 < D.trimLength
          ? Math.abs((n * D.trimLength) / 100)
          : Math.abs(n - D.length);
      d ? ((b += n / 2), (g -= n / 2)) : ((e += n / 2), (c -= n / 2));
      var n = 1 === Math.round(D.thickness) % 2 ? 0.5 : 0,
        p = 1 === Math.round(f.thickness) % 2 ? 0.5 : 0;
      a.save();
      a.globalAlpha = m;
      a.strokeStyle = f.color || h;
      a.lineWidth = f.thickness || 2;
      a.setLineDash && a.setLineDash(N(f.dashType, f.thickness));
      a.beginPath();
      d && 0 < f.thickness
        ? (a.moveTo(c - D.thickness / 2, Math.round((b + g) / 2) - p),
          a.lineTo(e + D.thickness / 2, Math.round((b + g) / 2) - p))
        : 0 < f.thickness &&
          (a.moveTo(Math.round((e + c) / 2) - p, b + D.thickness / 2),
          a.lineTo(Math.round((e + c) / 2) - p, g - D.thickness / 2));
      a.stroke();
      a.strokeStyle = D.color || h;
      a.lineWidth = D.thickness || 2;
      a.setLineDash && a.setLineDash(N(D.dashType, D.thickness));
      a.beginPath();
      d && 0 < D.thickness
        ? (a.moveTo(c - n, b),
          a.lineTo(c - n, g),
          a.moveTo(e + n, b),
          a.lineTo(e + n, g))
        : 0 < D.thickness &&
          (a.moveTo(e, b + n),
          a.lineTo(c, b + n),
          a.moveTo(e, g - n),
          a.lineTo(c, g - n));
      a.stroke();
      a.restore();
    }
    function M(a, e) {
      M.base.constructor.call(this, "Legend", "legend", e, null, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = this.chart.ctx;
      this.ghostCtx = this.chart._eventManager.ghostCtx;
      this.items = [];
      this.optionsName = "legend";
      this.height = this.width = 0;
      this.orientation = null;
      this.dataSeries = [];
      this.bounds = { x1: null, y1: null, x2: null, y2: null };
      "undefined" === typeof this.options.fontSize &&
        (this.fontSize = this.chart.getAutoFontSize(this.fontSize));
      this.lineHeight = fb(this.fontFamily, this.fontSize, this.fontWeight);
      this.horizontalSpacing = this.fontSize;
    }
    function H(a, e, b, c) {
      H.base.constructor.call(this, "DataSeries", "data", e, b, a);
      this.chart = a;
      this.canvas = a.canvas;
      this._ctx = a.canvas.ctx;
      this.index = b;
      this.noDataPointsInPlotArea = 0;
      this.id = c;
      this.chart._eventManager.objectMap[c] = {
        id: c,
        objectType: "dataSeries",
        dataSeriesIndex: b,
      };
      a = e.dataPoints ? e.dataPoints.length : 0;
      this.dataPointEOs = [];
      for (e = 0; e < a; e++) this.dataPointEOs[e] = {};
      this.dataPointIds = [];
      this.plotUnit = [];
      this.axisY = this.axisX = null;
      this.optionsName = "data";
      this.isOptionsInArray = !0;
      null === this.fillOpacity &&
        (this.type.match(/area/i)
          ? (this.fillOpacity = 0.7)
          : (this.fillOpacity = 1));
      this.axisPlacement = this.getDefaultAxisPlacement();
      "undefined" === typeof this.options.indexLabelFontSize &&
        (this.indexLabelFontSize = this.chart.getAutoFontSize(
          this.indexLabelFontSize
        ));
    }
    function z(a, e, b, c, g, h) {
      z.base.constructor.call(this, "Axis", e, b, c, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = a.ctx;
      this.intervalStartPosition = this.maxHeight = this.maxWidth = 0;
      this.labels = [];
      this.dataSeries = [];
      this._stripLineLabels = this._ticks = this._labels = null;
      this.dataInfo = {
        min: Infinity,
        max: -Infinity,
        viewPortMin: Infinity,
        viewPortMax: -Infinity,
        minDiff: Infinity,
      };
      this.isOptionsInArray = !0;
      "axisX" === g
        ? ("left" === h || "bottom" === h
            ? ((this.optionsName = "axisX"),
              f(this.chart.sessionVariables.axisX[c]) &&
                (this.chart.sessionVariables.axisX[c] = {}),
              (this.sessionVariables = this.chart.sessionVariables.axisX[c]))
            : ((this.optionsName = "axisX2"),
              f(this.chart.sessionVariables.axisX2[c]) &&
                (this.chart.sessionVariables.axisX2[c] = {}),
              (this.sessionVariables = this.chart.sessionVariables.axisX2[c])),
          this.options.interval || (this.intervalType = null))
        : "left" === h || "bottom" === h
        ? ((this.optionsName = "axisY"),
          f(this.chart.sessionVariables.axisY[c]) &&
            (this.chart.sessionVariables.axisY[c] = {}),
          (this.sessionVariables = this.chart.sessionVariables.axisY[c]))
        : ((this.optionsName = "axisY2"),
          f(this.chart.sessionVariables.axisY2[c]) &&
            (this.chart.sessionVariables.axisY2[c] = {}),
          (this.sessionVariables = this.chart.sessionVariables.axisY2[c]));
      "undefined" === typeof this.options.titleFontSize &&
        (this.titleFontSize = this.chart.getAutoFontSize(this.titleFontSize));
      "undefined" === typeof this.options.labelFontSize &&
        (this.labelFontSize = this.chart.getAutoFontSize(this.labelFontSize));
      this.type = g;
      "axisX" !== g ||
        (b && "undefined" !== typeof b.gridThickness) ||
        (this.gridThickness = 0);
      this._position = h;
      this.lineCoordinates = {
        x1: null,
        y1: null,
        x2: null,
        y2: null,
        width: null,
      };
      this.labelAngle = ((this.labelAngle % 360) + 360) % 360;
      90 < this.labelAngle && 270 > this.labelAngle
        ? (this.labelAngle -= 180)
        : 270 <= this.labelAngle &&
          360 >= this.labelAngle &&
          (this.labelAngle -= 360);
      this.options.scaleBreaks &&
        (this.scaleBreaks = new W(
          this.chart,
          this.options.scaleBreaks,
          ++this.chart._eventManager.lastObjectId,
          this
        ));
      this.stripLines = [];
      if (this.options.stripLines && 0 < this.options.stripLines.length)
        for (a = 0; a < this.options.stripLines.length; a++)
          this.stripLines.push(
            new P(
              this.chart,
              this.options.stripLines[a],
              a,
              ++this.chart._eventManager.lastObjectId,
              this
            )
          );
      this.options.crosshair &&
        (this.crosshair = new ea(this.chart, this.options.crosshair, this));
      this._titleTextBlock = null;
      this.hasOptionChanged("viewportMinimum") &&
        null === this.viewportMinimum &&
        ((this.options.viewportMinimum = void 0),
        (this.sessionVariables.viewportMinimum = null));
      this.hasOptionChanged("viewportMinimum") ||
      isNaN(this.sessionVariables.newViewportMinimum) ||
      null === this.sessionVariables.newViewportMinimum
        ? (this.sessionVariables.newViewportMinimum = null)
        : (this.viewportMinimum = this.sessionVariables.newViewportMinimum);
      this.hasOptionChanged("viewportMaximum") &&
        null === this.viewportMaximum &&
        ((this.options.viewportMaximum = void 0),
        (this.sessionVariables.viewportMaximum = null));
      this.hasOptionChanged("viewportMaximum") ||
      isNaN(this.sessionVariables.newViewportMaximum) ||
      null === this.sessionVariables.newViewportMaximum
        ? (this.sessionVariables.newViewportMaximum = null)
        : (this.viewportMaximum = this.sessionVariables.newViewportMaximum);
      null !== this.minimum &&
        null !== this.viewportMinimum &&
        (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));
      null !== this.maximum &&
        null !== this.viewportMaximum &&
        (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));
      this.trackChanges("viewportMinimum");
      this.trackChanges("viewportMaximum");
    }
    function W(a, e, b, c) {
      W.base.constructor.call(this, "ScaleBreaks", "scaleBreaks", e, null, c);
      this.id = b;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.axis = c;
      this.optionsName = "scaleBreaks";
      this.isOptionsInArray = !1;
      this._appliedBreaks = [];
      this.customBreaks = [];
      this.autoBreaks = [];
      "string" === typeof this.spacing
        ? ((this.spacing = parseFloat(this.spacing)),
          (this.spacing = isNaN(this.spacing)
            ? 8
            : (10 < this.spacing ? 10 : this.spacing) + "%"))
        : "number" !== typeof this.spacing && (this.spacing = 8);
      this.autoCalculate &&
        (this.maxNumberOfAutoBreaks = Math.min(this.maxNumberOfAutoBreaks, 5));
      if (this.options.customBreaks && 0 < this.options.customBreaks.length) {
        for (a = 0; a < this.options.customBreaks.length; a++)
          this.customBreaks.push(
            new X(
              this.chart,
              "customBreaks",
              this.options.customBreaks[a],
              a,
              ++this.chart._eventManager.lastObjectId,
              this
            )
          ),
            "number" === typeof this.customBreaks[a].startValue &&
              "number" === typeof this.customBreaks[a].endValue &&
              this.customBreaks[a].endValue !==
                this.customBreaks[a].startValue &&
              this._appliedBreaks.push(this.customBreaks[a]);
        this._appliedBreaks.sort(function (a, c) {
          return a.startValue - c.startValue;
        });
        for (a = 0; a < this._appliedBreaks.length - 1; a++)
          this._appliedBreaks[a].endValue >=
            this._appliedBreaks[a + 1].startValue &&
            ((this._appliedBreaks[a].endValue = Math.max(
              this._appliedBreaks[a].endValue,
              this._appliedBreaks[a + 1].endValue
            )),
            window.console &&
              window.console.log(
                "CanvasJS Error: Breaks " +
                  a +
                  " and " +
                  (a + 1) +
                  " are overlapping."
              ),
            this._appliedBreaks.splice(a, 2),
            a--);
      }
    }
    function X(a, e, b, c, g, h) {
      X.base.constructor.call(this, "Break", e, b, c, h);
      this.id = g;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.scaleBreaks = h;
      this.optionsName = e;
      this.isOptionsInArray = !0;
      this.type = b.type ? this.type : h.type;
      this.fillOpacity = f(b.fillOpacity) ? h.fillOpacity : this.fillOpacity;
      this.lineThickness = f(b.lineThickness)
        ? h.lineThickness
        : this.lineThickness;
      this.color = b.color ? this.color : h.color;
      this.lineColor = b.lineColor ? this.lineColor : h.lineColor;
      this.lineDashType = b.lineDashType ? this.lineDashType : h.lineDashType;
      !f(this.startValue) &&
        this.startValue.getTime &&
        (this.startValue = this.startValue.getTime());
      !f(this.endValue) &&
        this.endValue.getTime &&
        (this.endValue = this.endValue.getTime());
      "number" === typeof this.startValue &&
        "number" === typeof this.endValue &&
        this.endValue < this.startValue &&
        ((a = this.startValue),
        (this.startValue = this.endValue),
        (this.endValue = a));
      this.spacing = "undefined" === typeof b.spacing ? h.spacing : b.spacing;
      "string" === typeof this.options.spacing
        ? ((this.spacing = parseFloat(this.spacing)),
          (this.spacing = isNaN(this.spacing)
            ? 0
            : (10 < this.spacing ? 10 : this.spacing) + "%"))
        : "number" !== typeof this.options.spacing &&
          (this.spacing = h.spacing);
      this.size = h.parent.logarithmic ? 1 : 0;
    }
    function P(a, e, b, c, g) {
      P.base.constructor.call(this, "StripLine", "stripLines", e, b, g);
      this.id = c;
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.label = this.label;
      this.axis = g;
      this.optionsName = "stripLines";
      this.isOptionsInArray = !0;
      this._thicknessType = "pixel";
      null !== this.startValue &&
        null !== this.endValue &&
        ((this.value = g.logarithmic
          ? Math.sqrt(
              (this.startValue.getTime
                ? this.startValue.getTime()
                : this.startValue) *
                (this.endValue.getTime
                  ? this.endValue.getTime()
                  : this.endValue)
            )
          : ((this.startValue.getTime
              ? this.startValue.getTime()
              : this.startValue) +
              (this.endValue.getTime
                ? this.endValue.getTime()
                : this.endValue)) /
            2),
        (this._thicknessType = null));
    }
    function ea(a, e, b) {
      ea.base.constructor.call(this, "Crosshair", "crosshair", e, null, b);
      this.chart = a;
      this.ctx = this.chart.ctx;
      this.axis = b;
      this.optionsName = "crosshair";
      this._thicknessType = "pixel";
    }
    function aa(a, e) {
      aa.base.constructor.call(this, "ToolTip", "toolTip", e, null, a);
      this.chart = a;
      this.canvas = a.canvas;
      this.ctx = this.chart.ctx;
      this.currentDataPointIndex = this.currentSeriesIndex = -1;
      this._prevY = this._prevX = NaN;
      this.containerTransitionDuration = 0.1;
      this.mozContainerTransition = this.getContainerTransition(
        this.containerTransitionDuration
      );
      this.optionsName = "toolTip";
      this._initialize();
    }
    function ka(a) {
      this.chart = a;
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.previousDataPointEventObject = null;
      this.ghostCanvas = ta(this.chart.width, this.chart.height);
      this.ghostCtx = this.ghostCanvas.getContext("2d");
      this.mouseoveredObjectMaps = [];
    }
    function ma(a) {
      this.chart = a;
      this.ctx = this.chart.plotArea.ctx;
      this.animations = [];
      this.animationRequestId = null;
    }
    ha(s, Q);
    s.prototype.destroy = function () {
      var a = this.allDOMEventHandlers;
      this._animator && this._animator.cancelAllAnimations();
      this._panTimerId && clearTimeout(this._panTimerId);
      for (var e = 0; e < a.length; e++) hb(a[e][0], a[e][1], a[e][2], a[e][3]);
      this.allDOMEventHandlers = [];
      for (
        this.removeAllEventListeners();
        this._canvasJSContainer && this._canvasJSContainer.hasChildNodes();

      )
        this._canvasJSContainer.removeChild(this._canvasJSContainer.lastChild);
      for (; this.container && this.container.hasChildNodes(); )
        this.container.removeChild(this.container.lastChild);
      for (; this._dropdownMenu && this._dropdownMenu.hasChildNodes(); )
        this._dropdownMenu.removeChild(this._dropdownMenu.lastChild);
      this.overlaidCanvas =
        this.canvas =
        this.container =
        this._canvasJSContainer =
          null;
      this._toolBar =
        this._dropdownMenu =
        this._menuButton =
        this._resetButton =
        this._zoomButton =
        this._breaksCanvas =
        this._preRenderCanvas =
        this.toolTip.container =
          null;
    };
    s.prototype._updateOptions = function () {
      var a = this;
      this.updateOption("width");
      this.updateOption("height");
      this.updateOption("dataPointWidth");
      this.updateOption("dataPointMinWidth");
      this.updateOption("dataPointMaxWidth");
      this.updateOption("interactivityEnabled");
      this.updateOption("theme");
      this.updateOption("colorSet") &&
        (this.selectedColorSet =
          "undefined" !== typeof ya[this.colorSet]
            ? ya[this.colorSet]
            : ya.colorSet1);
      this.updateOption("backgroundColor");
      this.backgroundColor || (this.backgroundColor = "rgba(0,0,0,0)");
      this.updateOption("culture");
      this._cultureInfo = new Oa(this.options.culture);
      this.updateOption("animationEnabled");
      this.animationEnabled = this.animationEnabled && v;
      this.updateOption("animationDuration");
      this.updateOption("rangeChanging");
      this.updateOption("rangeChanged");
      this.updateOption("exportEnabled");
      this.updateOption("exportFileName");
      this.updateOption("zoomType");
      if (this.options.zoomEnabled || this.panEnabled) {
        if (!this._zoomButton) {
          var e = !1;
          za((this._zoomButton = document.createElement("button")));
          Ca(this, this._zoomButton, "pan");
          this._toolBar.appendChild(this._zoomButton);
          this._zoomButton.style.borderRight =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor;
          y(
            this._zoomButton,
            "touchstart",
            function (a) {
              e = !0;
            },
            this.allDOMEventHandlers
          );
          y(
            this._zoomButton,
            "click",
            function () {
              a.zoomEnabled
                ? ((a.zoomEnabled = !1),
                  (a.panEnabled = !0),
                  Ca(a, a._zoomButton, "zoom"))
                : ((a.zoomEnabled = !0),
                  (a.panEnabled = !1),
                  Ca(a, a._zoomButton, "pan"));
              a.render();
            },
            this.allDOMEventHandlers
          );
          y(
            this._zoomButton,
            "mouseover",
            function () {
              e
                ? (e = !1)
                : (sa(a._zoomButton, {
                    backgroundColor: a.toolbar.backgroundColorOnHover,
                    color: a.toolbar.fontColorOnHover,
                    transition: "0.4s",
                    WebkitTransition: "0.4s",
                  }),
                  0 >= navigator.userAgent.search("MSIE") &&
                    sa(a._zoomButton.childNodes[0], {
                      WebkitFilter: "invert(100%)",
                      filter: "invert(100%)",
                    }));
            },
            this.allDOMEventHandlers
          );
          y(
            this._zoomButton,
            "mouseout",
            function () {
              e ||
                (sa(a._zoomButton, {
                  backgroundColor: a.toolbar.backgroundColor,
                  color: a.toolbar.fontColor,
                  transition: "0.4s",
                  WebkitTransition: "0.4s",
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  sa(a._zoomButton.childNodes[0], {
                    WebkitFilter: "invert(0%)",
                    filter: "invert(0%)",
                  }));
            },
            this.allDOMEventHandlers
          );
        }
        this._resetButton ||
          ((e = !1),
          za((this._resetButton = document.createElement("button"))),
          Ca(this, this._resetButton, "reset"),
          (this._resetButton.style.borderRight =
            (this.exportEnabled ? this.toolbar.borderThickness : 0) +
            "px solid " +
            this.toolbar.borderColor),
          this._toolBar.appendChild(this._resetButton),
          y(
            this._resetButton,
            "touchstart",
            function (a) {
              e = !0;
            },
            this.allDOMEventHandlers
          ),
          y(
            this._resetButton,
            "click",
            function () {
              a.toolTip.hide();
              a.toolTip.dispatchEvent(
                "hidden",
                { chart: a, toolTip: a.toolTip },
                a.toolTip
              );
              a.zoomEnabled || a.panEnabled
                ? ((a.zoomEnabled = !0),
                  (a.panEnabled = !1),
                  Ca(a, a._zoomButton, "pan"),
                  (a._defaultCursor = "default"),
                  (a.overlaidCanvas.style.cursor = a._defaultCursor))
                : ((a.zoomEnabled = !1), (a.panEnabled = !1));
              if (a.sessionVariables.axisX)
                for (var c = 0; c < a.sessionVariables.axisX.length; c++)
                  (a.sessionVariables.axisX[c].newViewportMinimum = null),
                    (a.sessionVariables.axisX[c].newViewportMaximum = null);
              if (a.sessionVariables.axisX2)
                for (c = 0; c < a.sessionVariables.axisX2.length; c++)
                  (a.sessionVariables.axisX2[c].newViewportMinimum = null),
                    (a.sessionVariables.axisX2[c].newViewportMaximum = null);
              if (a.sessionVariables.axisY)
                for (c = 0; c < a.sessionVariables.axisY.length; c++)
                  (a.sessionVariables.axisY[c].newViewportMinimum = null),
                    (a.sessionVariables.axisY[c].newViewportMaximum = null);
              if (a.sessionVariables.axisY2)
                for (c = 0; c < a.sessionVariables.axisY2.length; c++)
                  (a.sessionVariables.axisY2[c].newViewportMinimum = null),
                    (a.sessionVariables.axisY2[c].newViewportMaximum = null);
              a.resetOverlayedCanvas();
              za(a._zoomButton, a._resetButton);
              a.stockChart &&
                (a.stockChart._rangeEventParameter = {
                  stockChart: a.stockChart,
                  source: "chart",
                  index: a.stockChart.charts.indexOf(a),
                  minimum: null,
                  maximum: null,
                });
              a._dispatchRangeEvent("rangeChanging", "reset");
              a.stockChart &&
                ((a.stockChart._rangeEventParameter.type = "rangeChanging"),
                a.stockChart.dispatchEvent(
                  "rangeChanging",
                  a.stockChart._rangeEventParameter,
                  a.stockChart
                ));
              a.render();
              a.syncCharts && a.syncCharts(null, null);
              a._dispatchRangeEvent("rangeChanged", "reset");
              a.stockChart &&
                ((a.stockChart._rangeEventParameter.type = "rangeChanged"),
                a.stockChart.dispatchEvent(
                  "rangeChanged",
                  a.stockChart._rangeEventParameter,
                  a.stockChart
                ));
            },
            this.allDOMEventHandlers
          ),
          y(
            this._resetButton,
            "mouseover",
            function () {
              e ||
                (sa(a._resetButton, {
                  backgroundColor: a.toolbar.backgroundColorOnHover,
                  color: a.toolbar.hoverFfontColorOnHoverontColor,
                  transition: "0.4s",
                  WebkitTransition: "0.4s",
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  sa(a._resetButton.childNodes[0], {
                    WebkitFilter: "invert(100%)",
                    filter: "invert(100%)",
                  }));
            },
            this.allDOMEventHandlers
          ),
          y(
            this._resetButton,
            "mouseout",
            function () {
              e ||
                (sa(a._resetButton, {
                  backgroundColor: a.toolbar.backgroundColor,
                  color: a.toolbar.fontColor,
                  transition: "0.4s",
                  WebkitTransition: "0.4s",
                }),
                0 >= navigator.userAgent.search("MSIE") &&
                  sa(a._resetButton.childNodes[0], {
                    WebkitFilter: "invert(0%)",
                    filter: "invert(0%)",
                  }));
            },
            this.allDOMEventHandlers
          ),
          (this.overlaidCanvas.style.cursor = a._defaultCursor));
        this.zoomEnabled ||
          this.panEnabled ||
          (this._zoomButton
            ? (a._zoomButton.getAttribute("state") === a._cultureInfo.zoomText
                ? ((this.panEnabled = !0), (this.zoomEnabled = !1))
                : ((this.zoomEnabled = !0), (this.panEnabled = !1)),
              Ta(a._zoomButton, a._resetButton))
            : ((this.zoomEnabled = !0), (this.panEnabled = !1)));
      } else this.panEnabled = this.zoomEnabled = !1;
      jb(this);
      "none" !== this._toolBar.style.display &&
        this._zoomButton &&
        (this.panEnabled
          ? Ca(a, a._zoomButton, "zoom")
          : Ca(a, a._zoomButton, "pan"),
        a._resetButton.getAttribute("state") !== a._cultureInfo.resetText &&
          Ca(a, a._resetButton, "reset"));
      this.options.toolTip &&
        this.toolTip.options !== this.options.toolTip &&
        (this.toolTip.options = this.options.toolTip);
      for (var b in this.toolTip.options)
        this.toolTip.options.hasOwnProperty(b) && this.toolTip.updateOption(b);
    };
    s.prototype._updateSize = function () {
      return mb.call(this, [
        this.canvas,
        this.overlaidCanvas,
        this._eventManager.ghostCanvas,
      ]);
    };
    s.prototype._initialize = function () {
      this.isNavigator =
        f(this.parent) ||
        f(this.parent._defaultsKey) ||
        "Navigator" !== this.parent._defaultsKey
          ? !1
          : !0;
      this.toolbar = new Xa(this, this.options.toolbar);
      this._animator
        ? this._animator.cancelAllAnimations()
        : (this._animator = new ma(this));
      this.removeAllEventListeners();
      this.disableToolTip = !1;
      this._axes = [];
      this.funnelPyramidClickHandler = this.pieDoughnutClickHandler = null;
      this._updateOptions();
      this.animatedRender =
        v && this.animationEnabled && 0 === this.renderCount;
      this._updateSize();
      this.clearCanvas();
      this.ctx.beginPath();
      this.axisX = [];
      this.axisX2 = [];
      this.axisY = [];
      this.axisY2 = [];
      this._indexLabels = [];
      this._dataInRenderedOrder = [];
      this._events = [];
      this._eventManager && this._eventManager.reset();
      this.plotInfo = { axisPlacement: null, plotTypes: [] };
      this.layoutManager = new La(
        0,
        0,
        this.width,
        this.height,
        this.isNavigator ? 0 : 2
      );
      this.plotArea.layoutManager && this.plotArea.layoutManager.reset();
      this.data = [];
      this.title = null;
      this.subtitles = [];
      var a = 0,
        e = null;
      if (this.options.data) {
        for (var b = 0; b < this.options.data.length; b++)
          if (
            (a++,
            !this.options.data[b].type ||
              0 <= s._supportedChartTypes.indexOf(this.options.data[b].type))
          ) {
            var c = new H(
              this,
              this.options.data[b],
              a - 1,
              ++this._eventManager.lastObjectId
            );
            "error" === c.type &&
              ((c.linkedDataSeriesIndex = f(
                this.options.data[b].linkedDataSeriesIndex
              )
                ? b - 1
                : this.options.data[b].linkedDataSeriesIndex),
              0 > c.linkedDataSeriesIndex ||
                c.linkedDataSeriesIndex >= this.options.data.length ||
                "number" !== typeof c.linkedDataSeriesIndex ||
                "error" === this.options.data[c.linkedDataSeriesIndex].type) &&
              (c.linkedDataSeriesIndex = null);
            null === c.name && (c.name = "DataSeries " + a);
            null === c.color
              ? 1 < this.options.data.length
                ? ((c._colorSet = [
                    this.selectedColorSet[
                      c.index % this.selectedColorSet.length
                    ],
                  ]),
                  (c.color =
                    this.selectedColorSet[
                      c.index % this.selectedColorSet.length
                    ]))
                : (c._colorSet =
                    "line" === c.type ||
                    "stepLine" === c.type ||
                    "spline" === c.type ||
                    "area" === c.type ||
                    "stepArea" === c.type ||
                    "splineArea" === c.type ||
                    "stackedArea" === c.type ||
                    "stackedArea100" === c.type ||
                    "rangeArea" === c.type ||
                    "rangeSplineArea" === c.type ||
                    "candlestick" === c.type ||
                    "ohlc" === c.type ||
                    "waterfall" === c.type ||
                    "boxAndWhisker" === c.type
                      ? [this.selectedColorSet[0]]
                      : this.selectedColorSet)
              : (c._colorSet = [c.color]);
            null === c.markerSize &&
              ((("line" === c.type ||
                "stepLine" === c.type ||
                "spline" === c.type ||
                0 <= c.type.toLowerCase().indexOf("area")) &&
                c.dataPoints &&
                c.dataPoints.length < this.width / 16) ||
                "scatter" === c.type) &&
              (c.markerSize = 8);
            ("bubble" !== c.type && "scatter" !== c.type) ||
              !c.dataPoints ||
              (c.dataPoints.some
                ? c.dataPoints.some(function (a) {
                    return a.x;
                  }) && c.dataPoints.sort(k)
                : c.dataPoints.sort(k));
            this.data.push(c);
            var g = c.axisPlacement,
              e = e || g,
              h;
            "normal" === g
              ? "xySwapped" === this.plotInfo.axisPlacement
                ? (h = 'You cannot combine "' + c.type + '" with bar chart')
                : "none" === this.plotInfo.axisPlacement
                ? (h = 'You cannot combine "' + c.type + '" with pie chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "normal")
              : "xySwapped" === g
              ? "normal" === this.plotInfo.axisPlacement
                ? (h =
                    'You cannot combine "' +
                    c.type +
                    '" with line, area, column or pie chart')
                : "none" === this.plotInfo.axisPlacement
                ? (h = 'You cannot combine "' + c.type + '" with pie chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "xySwapped")
              : "none" === g
              ? "normal" === this.plotInfo.axisPlacement
                ? (h =
                    'You cannot combine "' +
                    c.type +
                    '" with line, area, column or bar chart')
                : "xySwapped" === this.plotInfo.axisPlacement
                ? (h = 'You cannot combine "' + c.type + '" with bar chart')
                : null === this.plotInfo.axisPlacement &&
                  (this.plotInfo.axisPlacement = "none")
              : null === g &&
                "none" === this.plotInfo.axisPlacement &&
                (h = 'You cannot combine "' + c.type + '" with pie chart');
            if (h && window.console) {
              window.console.log(h);
              return;
            }
          }
        for (b = 0; b < this.data.length; b++) {
          if ("none" == e && "error" === this.data[b].type && window.console) {
            window.console.log(
              'You cannot combine "' + c.type + '" with error chart'
            );
            return;
          }
          "error" === this.data[b].type &&
            ((this.data[b].axisPlacement = this.plotInfo.axisPlacement =
              e || "normal"),
            (this.data[b]._linkedSeries =
              null === this.data[b].linkedDataSeriesIndex
                ? null
                : this.data[this.data[b].linkedDataSeriesIndex]));
        }
      }
      this._objectsInitialized = !0;
      this._plotAreaElements = [];
    };
    s._supportedChartTypes = Ea(
      "line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeBar rangeArea rangeSplineArea pie doughnut funnel pyramid waterfall".split(
        " "
      )
    );
    s.prototype.setLayout = function () {
      for (var a = this._plotAreaElements, e = 0; e < this.data.length; e++)
        if (
          "normal" === this.plotInfo.axisPlacement ||
          "xySwapped" === this.plotInfo.axisPlacement
        ) {
          if (!this.data[e].axisYType || "primary" === this.data[e].axisYType)
            if (this.options.axisY && 0 < this.options.axisY.length) {
              if (!this.axisY.length)
                for (var b = 0; b < this.options.axisY.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisY[b] = new z(
                          this,
                          "axisY",
                          this.options.axisY[b],
                          b,
                          "axisY",
                          "left"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisY[b] = new z(
                          this,
                          "axisY",
                          this.options.axisY[b],
                          b,
                          "axisY",
                          "bottom"
                        ))
                      );
              this.data[e].axisY =
                this.axisY[
                  0 <= this.data[e].axisYIndex &&
                  this.data[e].axisYIndex < this.axisY.length
                    ? this.data[e].axisYIndex
                    : 0
                ];
              this.axisY[
                0 <= this.data[e].axisYIndex &&
                this.data[e].axisYIndex < this.axisY.length
                  ? this.data[e].axisYIndex
                  : 0
              ].dataSeries.push(this.data[e]);
            } else
              this.axisY.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisY[0] = new z(
                        this,
                        "axisY",
                        this.options.axisY,
                        0,
                        "axisY",
                        "left"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisY[0] = new z(
                        this,
                        "axisY",
                        this.options.axisY,
                        0,
                        "axisY",
                        "bottom"
                      ))
                    )),
                (this.data[e].axisY = this.axisY[0]),
                this.axisY[0].dataSeries.push(this.data[e]);
          if ("secondary" === this.data[e].axisYType)
            if (this.options.axisY2 && 0 < this.options.axisY2.length) {
              if (!this.axisY2.length)
                for (b = 0; b < this.options.axisY2.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisY2[b] = new z(
                          this,
                          "axisY2",
                          this.options.axisY2[b],
                          b,
                          "axisY",
                          "right"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisY2[b] = new z(
                          this,
                          "axisY2",
                          this.options.axisY2[b],
                          b,
                          "axisY",
                          "top"
                        ))
                      );
              this.data[e].axisY =
                this.axisY2[
                  0 <= this.data[e].axisYIndex &&
                  this.data[e].axisYIndex < this.axisY2.length
                    ? this.data[e].axisYIndex
                    : 0
                ];
              this.axisY2[
                0 <= this.data[e].axisYIndex &&
                this.data[e].axisYIndex < this.axisY2.length
                  ? this.data[e].axisYIndex
                  : 0
              ].dataSeries.push(this.data[e]);
            } else
              this.axisY2.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisY2[0] = new z(
                        this,
                        "axisY2",
                        this.options.axisY2,
                        0,
                        "axisY",
                        "right"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisY2[0] = new z(
                        this,
                        "axisY2",
                        this.options.axisY2,
                        0,
                        "axisY",
                        "top"
                      ))
                    )),
                (this.data[e].axisY = this.axisY2[0]),
                this.axisY2[0].dataSeries.push(this.data[e]);
          if (!this.data[e].axisXType || "primary" === this.data[e].axisXType)
            if (this.options.axisX && 0 < this.options.axisX.length) {
              if (!this.axisX.length)
                for (b = 0; b < this.options.axisX.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisX[b] = new z(
                          this,
                          "axisX",
                          this.options.axisX[b],
                          b,
                          "axisX",
                          "bottom"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisX[b] = new z(
                          this,
                          "axisX",
                          this.options.axisX[b],
                          b,
                          "axisX",
                          "left"
                        ))
                      );
              this.data[e].axisX =
                this.axisX[
                  0 <= this.data[e].axisXIndex &&
                  this.data[e].axisXIndex < this.axisX.length
                    ? this.data[e].axisXIndex
                    : 0
                ];
              this.axisX[
                0 <= this.data[e].axisXIndex &&
                this.data[e].axisXIndex < this.axisX.length
                  ? this.data[e].axisXIndex
                  : 0
              ].dataSeries.push(this.data[e]);
            } else
              this.axisX.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisX[0] = new z(
                        this,
                        "axisX",
                        this.options.axisX,
                        0,
                        "axisX",
                        "bottom"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisX[0] = new z(
                        this,
                        "axisX",
                        this.options.axisX,
                        0,
                        "axisX",
                        "left"
                      ))
                    )),
                (this.data[e].axisX = this.axisX[0]),
                this.axisX[0].dataSeries.push(this.data[e]);
          if ("secondary" === this.data[e].axisXType)
            if (this.options.axisX2 && 0 < this.options.axisX2.length) {
              if (!this.axisX2.length)
                for (b = 0; b < this.options.axisX2.length; b++)
                  "normal" === this.plotInfo.axisPlacement
                    ? this._axes.push(
                        (this.axisX2[b] = new z(
                          this,
                          "axisX2",
                          this.options.axisX2[b],
                          b,
                          "axisX",
                          "top"
                        ))
                      )
                    : "xySwapped" === this.plotInfo.axisPlacement &&
                      this._axes.push(
                        (this.axisX2[b] = new z(
                          this,
                          "axisX2",
                          this.options.axisX2[b],
                          b,
                          "axisX",
                          "right"
                        ))
                      );
              this.data[e].axisX =
                this.axisX2[
                  0 <= this.data[e].axisXIndex &&
                  this.data[e].axisXIndex < this.axisX2.length
                    ? this.data[e].axisXIndex
                    : 0
                ];
              this.axisX2[
                0 <= this.data[e].axisXIndex &&
                this.data[e].axisXIndex < this.axisX2.length
                  ? this.data[e].axisXIndex
                  : 0
              ].dataSeries.push(this.data[e]);
            } else
              this.axisX2.length ||
                ("normal" === this.plotInfo.axisPlacement
                  ? this._axes.push(
                      (this.axisX2[0] = new z(
                        this,
                        "axisX2",
                        this.options.axisX2,
                        0,
                        "axisX",
                        "top"
                      ))
                    )
                  : "xySwapped" === this.plotInfo.axisPlacement &&
                    this._axes.push(
                      (this.axisX2[0] = new z(
                        this,
                        "axisX2",
                        this.options.axisX2,
                        0,
                        "axisX",
                        "right"
                      ))
                    )),
                (this.data[e].axisX = this.axisX2[0]),
                this.axisX2[0].dataSeries.push(this.data[e]);
        }
      if (this.axisY) {
        for (b = 1; b < this.axisY.length; b++)
          "undefined" === typeof this.axisY[b].options.gridThickness &&
            (this.axisY[b].gridThickness = 0);
        for (b = 0; b < this.axisY.length - 1; b++)
          "undefined" === typeof this.axisY[b].options.margin &&
            (this.axisY[b].margin = 10);
      }
      if (this.axisY2) {
        for (b = 1; b < this.axisY2.length; b++)
          "undefined" === typeof this.axisY2[b].options.gridThickness &&
            (this.axisY2[b].gridThickness = 0);
        for (b = 0; b < this.axisY2.length - 1; b++)
          "undefined" === typeof this.axisY2[b].options.margin &&
            (this.axisY2[b].margin = 10);
      }
      this.axisY &&
        0 < this.axisY.length &&
        this.axisY2 &&
        0 < this.axisY2.length &&
        (0 < this.axisY[0].gridThickness &&
        "undefined" === typeof this.axisY2[0].options.gridThickness
          ? (this.axisY2[0].gridThickness = 0)
          : 0 < this.axisY2[0].gridThickness &&
            "undefined" === typeof this.axisY[0].options.gridThickness &&
            (this.axisY[0].gridThickness = 0));
      if (this.axisX)
        for (b = 0; b < this.axisX.length; b++)
          "undefined" === typeof this.axisX[b].options.gridThickness &&
            (this.axisX[b].gridThickness = 0);
      if (this.axisX2)
        for (b = 0; b < this.axisX2.length; b++)
          "undefined" === typeof this.axisX2[b].options.gridThickness &&
            (this.axisX2[b].gridThickness = 0);
      this.axisX &&
        0 < this.axisX.length &&
        this.axisX2 &&
        0 < this.axisX2.length &&
        (0 < this.axisX[0].gridThickness &&
        "undefined" === typeof this.axisX2[0].options.gridThickness
          ? (this.axisX2[0].gridThickness = 0)
          : 0 < this.axisX2[0].gridThickness &&
            "undefined" === typeof this.axisX[0].options.gridThickness &&
            (this.axisX[0].gridThickness = 0));
      b = !1;
      if (
        0 < this._axes.length &&
        this.options.zoomEnabled &&
        (this.zoomEnabled || this.panEnabled)
      )
        for (e = 0; e < this._axes.length; e++)
          if (
            null !== this._axes[e].viewportMinimum ||
            null !== this._axes[e].viewportMaximum
          ) {
            b = !0;
            break;
          }
      b
        ? (Ta(this._zoomButton, this._resetButton),
          (this._toolBar.style.border =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor),
          (this._zoomButton.style.borderRight =
            this.toolbar.borderThickness +
            "px solid " +
            this.toolbar.borderColor),
          (this._resetButton.style.borderRight =
            (this.exportEnabled ? this.toolbar.borderThickness : 0) +
            "px solid " +
            this.toolbar.borderColor))
        : (za(this._zoomButton, this._resetButton),
          (this._toolBar.style.border =
            this.toolbar.borderThickness + "px solid transparent"),
          this.options.zoomEnabled &&
            ((this.zoomEnabled = !0), (this.panEnabled = !1)));
      rb(this);
      this._processData();
      this.options.title &&
        ((this.title = new Ia(this, this.options.title)),
        this.title.dockInsidePlotArea
          ? a.push(this.title)
          : this.title.setLayout());
      if (this.options.subtitles)
        for (e = 0; e < this.options.subtitles.length; e++)
          (b = new Na(this, this.options.subtitles[e], e)),
            this.subtitles.push(b),
            b.dockInsidePlotArea ? a.push(b) : b.setLayout();
      this.legend = new M(this, this.options.legend);
      for (e = 0; e < this.data.length; e++)
        (this.data[e].showInLegend ||
          "pie" === this.data[e].type ||
          "doughnut" === this.data[e].type ||
          "funnel" === this.data[e].type ||
          "pyramid" === this.data[e].type) &&
          this.legend.dataSeries.push(this.data[e]);
      this.legend.dockInsidePlotArea
        ? a.push(this.legend)
        : this.legend.setLayout();
      for (e = 0; e < this._axes.length; e++)
        if (
          this._axes[e].scaleBreaks &&
          this._axes[e].scaleBreaks._appliedBreaks.length
        ) {
          v
            ? ((this._breaksCanvas = ta(this.width, this.height, !0)),
              (this._breaksCanvasCtx = this._breaksCanvas.getContext("2d")))
            : ((this._breaksCanvas = this.canvas),
              (this._breaksCanvasCtx = this.ctx));
          break;
        }
      this._preRenderCanvas = ta(this.width, this.height);
      this._preRenderCtx = this._preRenderCanvas.getContext("2d");
      ("normal" !== this.plotInfo.axisPlacement &&
        "xySwapped" !== this.plotInfo.axisPlacement) ||
        z.setLayout(
          this.axisX,
          this.axisX2,
          this.axisY,
          this.axisY2,
          this.plotInfo.axisPlacement,
          this.layoutManager.getFreeSpace()
        );
    };
    s.prototype.renderElements = function () {
      var a = this._plotAreaElements;
      this.title && !this.title.dockInsidePlotArea && this.title.render();
      for (var e = 0; e < this.subtitles.length; e++)
        this.subtitles[e].dockInsidePlotArea || this.subtitles[e].render();
      this.legend.dockInsidePlotArea || this.legend.render();
      if (
        "normal" === this.plotInfo.axisPlacement ||
        "xySwapped" === this.plotInfo.axisPlacement
      )
        z.render(
          this.axisX,
          this.axisX2,
          this.axisY,
          this.axisY2,
          this.plotInfo.axisPlacement
        );
      else if ("none" === this.plotInfo.axisPlacement) this.preparePlotArea();
      else return;
      for (e = 0; e < a.length; e++) a[e].setLayout(), a[e].render();
      var b = [];
      if (this.animatedRender) {
        var c = ta(this.width, this.height);
        c.getContext("2d").drawImage(
          this.canvas,
          0,
          0,
          this.width,
          this.height
        );
      }
      tb(this);
      var a = this.ctx.miterLimit,
        g;
      this.ctx.miterLimit = 3;
      v &&
        this._breaksCanvas &&
        (this._preRenderCtx.drawImage(
          this.canvas,
          0,
          0,
          this.width,
          this.height
        ),
        this._preRenderCtx.drawImage(
          this._breaksCanvas,
          0,
          0,
          this.width,
          this.height
        ),
        (this._breaksCanvasCtx.globalCompositeOperation = "source-atop"),
        this._breaksCanvasCtx.drawImage(
          this._preRenderCanvas,
          0,
          0,
          this.width,
          this.height
        ),
        this._preRenderCtx.clearRect(0, 0, this.width, this.height));
      for (e = 0; e < this.plotInfo.plotTypes.length; e++)
        for (
          var h = this.plotInfo.plotTypes[e], D = 0;
          D < h.plotUnits.length;
          D++
        ) {
          var f = h.plotUnits[D],
            d = null;
          f.targetCanvas = null;
          this.animatedRender &&
            ((f.targetCanvas = ta(this.width, this.height)),
            (f.targetCanvasCtx = f.targetCanvas.getContext("2d")),
            (g = f.targetCanvasCtx.miterLimit),
            (f.targetCanvasCtx.miterLimit = 3));
          "line" === f.type
            ? (d = this.renderLine(f))
            : "stepLine" === f.type
            ? (d = this.renderStepLine(f))
            : "spline" === f.type
            ? (d = this.renderSpline(f))
            : "column" === f.type
            ? (d = this.renderColumn(f))
            : "bar" === f.type
            ? (d = this.renderBar(f))
            : "area" === f.type
            ? (d = this.renderArea(f))
            : "stepArea" === f.type
            ? (d = this.renderStepArea(f))
            : "splineArea" === f.type
            ? (d = this.renderSplineArea(f))
            : "stackedColumn" === f.type
            ? (d = this.renderStackedColumn(f))
            : "stackedColumn100" === f.type
            ? (d = this.renderStackedColumn100(f))
            : "stackedBar" === f.type
            ? (d = this.renderStackedBar(f))
            : "stackedBar100" === f.type
            ? (d = this.renderStackedBar100(f))
            : "stackedArea" === f.type
            ? (d = this.renderStackedArea(f))
            : "stackedArea100" === f.type
            ? (d = this.renderStackedArea100(f))
            : "bubble" === f.type
            ? (d = d = this.renderBubble(f))
            : "scatter" === f.type
            ? (d = this.renderScatter(f))
            : "pie" === f.type
            ? this.renderPie(f)
            : "doughnut" === f.type
            ? this.renderPie(f)
            : "funnel" === f.type
            ? (d = this.renderFunnel(f))
            : "pyramid" === f.type
            ? (d = this.renderFunnel(f))
            : "candlestick" === f.type
            ? (d = this.renderCandlestick(f))
            : "ohlc" === f.type
            ? (d = this.renderCandlestick(f))
            : "rangeColumn" === f.type
            ? (d = this.renderRangeColumn(f))
            : "error" === f.type
            ? (d = this.renderError(f))
            : "rangeBar" === f.type
            ? (d = this.renderRangeBar(f))
            : "rangeArea" === f.type
            ? (d = this.renderRangeArea(f))
            : "rangeSplineArea" === f.type
            ? (d = this.renderRangeSplineArea(f))
            : "waterfall" === f.type
            ? (d = this.renderWaterfall(f))
            : "boxAndWhisker" === f.type && (d = this.renderBoxAndWhisker(f));
          for (var m = 0; m < f.dataSeriesIndexes.length; m++)
            this._dataInRenderedOrder.push(this.data[f.dataSeriesIndexes[m]]);
          this.animatedRender &&
            ((f.targetCanvasCtx.miterLimit = g), d && b.push(d));
        }
      this.ctx.miterLimit = a;
      this.animatedRender &&
        this._breaksCanvasCtx &&
        b.push({
          source: this._breaksCanvasCtx,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
          startTimePercent: 0.7,
        });
      this.animatedRender &&
        0 < this._indexLabels.length &&
        ((g = ta(this.width, this.height).getContext("2d")),
        b.push(this.renderIndexLabels(g)));
      var n = this;
      if (0 < b.length)
        (n.disableToolTip = !0),
          n._animator.animate(
            200,
            n.animationDuration,
            function (a) {
              n.ctx.clearRect(0, 0, n.width, n.height);
              n.ctx.drawImage(
                c,
                0,
                0,
                Math.floor(n.width * ia),
                Math.floor(n.height * ia),
                0,
                0,
                n.width,
                n.height
              );
              for (var e = 0; e < b.length; e++)
                (d = b[e]),
                  1 > a && "undefined" !== typeof d.startTimePercent
                    ? a >= d.startTimePercent &&
                      d.animationCallback(
                        d.easingFunction(
                          a - d.startTimePercent,
                          0,
                          1,
                          1 - d.startTimePercent
                        ),
                        d
                      )
                    : d.animationCallback(d.easingFunction(a, 0, 1, 1), d);
              n.dispatchEvent("dataAnimationIterationEnd", { chart: n });
            },
            function () {
              b = [];
              for (var a = 0; a < n.plotInfo.plotTypes.length; a++)
                for (
                  var e = n.plotInfo.plotTypes[a], g = 0;
                  g < e.plotUnits.length;
                  g++
                )
                  e.plotUnits[g].targetCanvas = null;
              c = null;
              n.disableToolTip = !1;
              n.dispatchEvent("dataAnimationEnd", { chart: n });
            }
          );
      else {
        if (n._breaksCanvas)
          if (v)
            n.plotArea.ctx.drawImage(
              n._breaksCanvas,
              0,
              0,
              this.width,
              this.height
            );
          else for (m = 0; m < n._axes.length; m++) n._axes[m].createMask();
        0 < n._indexLabels.length && n.renderIndexLabels();
        n.dispatchEvent("dataAnimationIterationEnd", { chart: n });
        n.dispatchEvent("dataAnimationEnd", { chart: n });
      }
      this.attachPlotAreaEventHandlers();
      this.zoomEnabled ||
        this.panEnabled ||
        !this._zoomButton ||
        "none" === this._zoomButton.style.display ||
        za(this._zoomButton, this._resetButton);
      this.toolTip._updateToolTip();
      this.renderCount++;
      Ma &&
        ((n = this),
        setTimeout(function () {
          var a = document.getElementById("ghostCanvasCopy");
          a &&
            (Ua(a, n.width, n.height),
            a.getContext("2d").drawImage(n._eventManager.ghostCanvas, 0, 0));
        }, 2e3));
      this._breaksCanvas &&
        (delete this._breaksCanvas, delete this._breaksCanvasCtx);
      for (m = 0; m < this._axes.length; m++)
        this._axes[m].maskCanvas &&
          (delete this._axes[m].maskCanvas, delete this._axes[m].maskCtx);
    };
    s.prototype.render = function (a) {
      a && (this.options = a);
      this._initialize();
      this.setLayout();
      this.renderElements();
      this._preRenderCanvas = null;
    };
    s.prototype.attachPlotAreaEventHandlers = function () {
      this.attachEvent({
        context: this,
        chart: this,
        mousedown: this._plotAreaMouseDown,
        mouseup: this._plotAreaMouseUp,
        mousemove: this._plotAreaMouseMove,
        cursor: this.panEnabled ? "move" : "default",
        capture: !0,
        bounds: this.plotArea,
      });
    };
    s.prototype.categoriseDataSeries = function () {
      for (var a = "", e = 0; e < this.data.length; e++)
        if (
          ((a = this.data[e]),
          a.dataPoints &&
            0 !== a.dataPoints.length &&
            a.visible &&
            0 <= s._supportedChartTypes.indexOf(a.type))
        ) {
          for (
            var b = null, c = !1, g = null, h = !1, D = 0;
            D < this.plotInfo.plotTypes.length;
            D++
          )
            if (this.plotInfo.plotTypes[D].type === a.type) {
              c = !0;
              b = this.plotInfo.plotTypes[D];
              break;
            }
          c ||
            ((b = { type: a.type, totalDataSeries: 0, plotUnits: [] }),
            this.plotInfo.plotTypes.push(b));
          for (D = 0; D < b.plotUnits.length; D++)
            if (
              b.plotUnits[D].axisYType === a.axisYType &&
              b.plotUnits[D].axisXType === a.axisXType &&
              b.plotUnits[D].axisYIndex === a.axisYIndex &&
              b.plotUnits[D].axisXIndex === a.axisXIndex
            ) {
              h = !0;
              g = b.plotUnits[D];
              break;
            }
          h ||
            ((g = {
              type: a.type,
              previousDataSeriesCount: 0,
              index: b.plotUnits.length,
              plotType: b,
              axisXType: a.axisXType,
              axisYType: a.axisYType,
              axisYIndex: a.axisYIndex,
              axisXIndex: a.axisXIndex,
              axisY:
                "primary" === a.axisYType
                  ? this.axisY[
                      0 <= a.axisYIndex && a.axisYIndex < this.axisY.length
                        ? a.axisYIndex
                        : 0
                    ]
                  : this.axisY2[
                      0 <= a.axisYIndex && a.axisYIndex < this.axisY2.length
                        ? a.axisYIndex
                        : 0
                    ],
              axisX:
                "primary" === a.axisXType
                  ? this.axisX[
                      0 <= a.axisXIndex && a.axisXIndex < this.axisX.length
                        ? a.axisXIndex
                        : 0
                    ]
                  : this.axisX2[
                      0 <= a.axisXIndex && a.axisXIndex < this.axisX2.length
                        ? a.axisXIndex
                        : 0
                    ],
              dataSeriesIndexes: [],
              yTotals: [],
              yAbsTotals: [],
            }),
            b.plotUnits.push(g));
          b.totalDataSeries++;
          g.dataSeriesIndexes.push(e);
          a.plotUnit = g;
        }
      for (e = 0; e < this.plotInfo.plotTypes.length; e++)
        for (
          b = this.plotInfo.plotTypes[e], D = a = 0;
          D < b.plotUnits.length;
          D++
        )
          (b.plotUnits[D].previousDataSeriesCount = a),
            (a += b.plotUnits[D].dataSeriesIndexes.length);
    };
    s.prototype.assignIdToDataPoints = function () {
      for (var a = 0; a < this.data.length; a++) {
        var e = this.data[a];
        if (e.dataPoints)
          for (var b = e.dataPoints.length, c = 0; c < b; c++)
            e.dataPointIds[c] = ++this._eventManager.lastObjectId;
      }
    };
    s.prototype._processData = function () {
      this.assignIdToDataPoints();
      this.categoriseDataSeries();
      for (var a = 0; a < this.plotInfo.plotTypes.length; a++)
        for (
          var e = this.plotInfo.plotTypes[a], b = 0;
          b < e.plotUnits.length;
          b++
        ) {
          var c = e.plotUnits[b];
          "line" === c.type ||
          "stepLine" === c.type ||
          "spline" === c.type ||
          "column" === c.type ||
          "area" === c.type ||
          "stepArea" === c.type ||
          "splineArea" === c.type ||
          "bar" === c.type ||
          "bubble" === c.type ||
          "scatter" === c.type
            ? this._processMultiseriesPlotUnit(c)
            : "stackedColumn" === c.type ||
              "stackedBar" === c.type ||
              "stackedArea" === c.type
            ? this._processStackedPlotUnit(c)
            : "stackedColumn100" === c.type ||
              "stackedBar100" === c.type ||
              "stackedArea100" === c.type
            ? this._processStacked100PlotUnit(c)
            : "candlestick" === c.type ||
              "ohlc" === c.type ||
              "rangeColumn" === c.type ||
              "rangeBar" === c.type ||
              "rangeArea" === c.type ||
              "rangeSplineArea" === c.type ||
              "error" === c.type ||
              "boxAndWhisker" === c.type
            ? this._processMultiYPlotUnit(c)
            : "waterfall" === c.type && this._processSpecificPlotUnit(c);
        }
      this.calculateAutoBreaks();
    };
    s.prototype._processMultiseriesPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
        for (
          var e = a.axisY.dataInfo, b = a.axisX.dataInfo, c, g, h = !1, D = 0;
          D < a.dataSeriesIndexes.length;
          D++
        ) {
          var f = this.data[a.dataSeriesIndexes[D]],
            d = 0,
            m = !1,
            n = !1,
            p;
          if ("normal" === f.axisPlacement || "xySwapped" === f.axisPlacement)
            var q = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              l = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (f.dataPoints[d].x && f.dataPoints[d].x.getTime) ||
            "dateTime" === f.xValueType
          )
            h = !0;
          for (d = 0; d < f.dataPoints.length; d++) {
            "undefined" === typeof f.dataPoints[d].x &&
              (f.dataPoints[d].x = d + (a.axisX.logarithmic ? 1 : 0));
            f.dataPoints[d].x.getTime
              ? ((h = !0), (c = f.dataPoints[d].x.getTime()))
              : (c = f.dataPoints[d].x);
            g = f.dataPoints[d].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            g < e.min && "number" === typeof g && (e.min = g);
            g > e.max && "number" === typeof g && (e.max = g);
            if (0 < d) {
              if (a.axisX.logarithmic) {
                var r = c / f.dataPoints[d - 1].x;
                1 > r && (r = 1 / r);
                b.minDiff > r && 1 !== r && (b.minDiff = r);
              } else
                (r = c - f.dataPoints[d - 1].x),
                  0 > r && (r *= -1),
                  b.minDiff > r && 0 !== r && (b.minDiff = r);
              null !== g &&
                null !== f.dataPoints[d - 1].y &&
                (a.axisY.logarithmic
                  ? ((r = g / f.dataPoints[d - 1].y),
                    1 > r && (r = 1 / r),
                    e.minDiff > r && 1 !== r && (e.minDiff = r))
                  : ((r = g - f.dataPoints[d - 1].y),
                    0 > r && (r *= -1),
                    e.minDiff > r && 0 !== r && (e.minDiff = r)));
            }
            if (c < q && !m) null !== g && (p = c);
            else {
              if (!m && ((m = !0), 0 < d)) {
                d -= 2;
                continue;
              }
              if (c > l && !n) n = !0;
              else if (c > l && n) continue;
              f.dataPoints[d].label &&
                (a.axisX.labels[c] = f.dataPoints[d].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === g
                ? b.viewPortMin === c && p < c && (b.viewPortMin = p)
                : (g < e.viewPortMin &&
                    "number" === typeof g &&
                    (e.viewPortMin = g),
                  g > e.viewPortMax &&
                    "number" === typeof g &&
                    (e.viewPortMax = g));
            }
          }
          f.axisX.valueType = f.xValueType = h ? "dateTime" : "number";
        }
    };
    s.prototype._processStackedPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
        for (
          var e = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            g,
            h = !1,
            D = [],
            d = [],
            J = Infinity,
            m = -Infinity,
            n = 0;
          n < a.dataSeriesIndexes.length;
          n++
        ) {
          var p = this.data[a.dataSeriesIndexes[n]],
            q = 0,
            l = !1,
            r = !1,
            x;
          if ("normal" === p.axisPlacement || "xySwapped" === p.axisPlacement)
            var v = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : -Infinity,
              w = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (p.dataPoints[q].x && p.dataPoints[q].x.getTime) ||
            "dateTime" === p.xValueType
          )
            h = !0;
          for (q = 0; q < p.dataPoints.length; q++) {
            "undefined" === typeof p.dataPoints[q].x &&
              (p.dataPoints[q].x = q + (a.axisX.logarithmic ? 1 : 0));
            p.dataPoints[q].x.getTime
              ? ((h = !0), (c = p.dataPoints[q].x.getTime()))
              : (c = p.dataPoints[q].x);
            g = f(p.dataPoints[q].y) ? 0 : p.dataPoints[q].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            if (0 < q) {
              if (a.axisX.logarithmic) {
                var A = c / p.dataPoints[q - 1].x;
                1 > A && (A = 1 / A);
                b.minDiff > A && 1 !== A && (b.minDiff = A);
              } else
                (A = c - p.dataPoints[q - 1].x),
                  0 > A && (A *= -1),
                  b.minDiff > A && 0 !== A && (b.minDiff = A);
              null !== g &&
                null !== p.dataPoints[q - 1].y &&
                (a.axisY.logarithmic
                  ? 0 < g &&
                    ((A = g / p.dataPoints[q - 1].y),
                    1 > A && (A = 1 / A),
                    e.minDiff > A && 1 !== A && (e.minDiff = A))
                  : ((A = g - p.dataPoints[q - 1].y),
                    0 > A && (A *= -1),
                    e.minDiff > A && 0 !== A && (e.minDiff = A)));
            }
            if (c < v && !l) null !== p.dataPoints[q].y && (x = c);
            else {
              if (!l && ((l = !0), 0 < q)) {
                q -= 2;
                continue;
              }
              if (c > w && !r) r = !0;
              else if (c > w && r) continue;
              p.dataPoints[q].label &&
                (a.axisX.labels[c] = p.dataPoints[q].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === p.dataPoints[q].y
                ? b.viewPortMin === c && x < c && (b.viewPortMin = x)
                : ((a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + g),
                  (a.yAbsTotals[c] =
                    (a.yAbsTotals[c] ? a.yAbsTotals[c] : 0) + Math.abs(g)),
                  0 <= g
                    ? D[c]
                      ? (D[c] += g)
                      : ((D[c] = g), (J = Math.min(g, J)))
                    : d[c]
                    ? (d[c] += g)
                    : ((d[c] = g), (m = Math.max(g, m))));
            }
          }
          a.axisY.scaleBreaks &&
            a.axisY.scaleBreaks.autoCalculate &&
            1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks &&
            (e.dataPointYPositiveSums
              ? (e.dataPointYPositiveSums.push.apply(
                  e.dataPointYPositiveSums,
                  D
                ),
                e.dataPointYNegativeSums.push.apply(
                  e.dataPointYPositiveSums,
                  d
                ))
              : ((e.dataPointYPositiveSums = D),
                (e.dataPointYNegativeSums = d)));
          p.axisX.valueType = p.xValueType = h ? "dateTime" : "number";
        }
        for (q in D)
          D.hasOwnProperty(q) &&
            !isNaN(q) &&
            ((a = D[q]),
            a < e.min && (e.min = Math.min(a, J)),
            a > e.max && (e.max = a),
            q < b.viewPortMin ||
              q > b.viewPortMax ||
              (a < e.viewPortMin && (e.viewPortMin = Math.min(a, J)),
              a > e.viewPortMax && (e.viewPortMax = a)));
        for (q in d)
          d.hasOwnProperty(q) &&
            !isNaN(q) &&
            ((a = d[q]),
            a < e.min && (e.min = a),
            a > e.max && (e.max = Math.max(a, m)),
            q < b.viewPortMin ||
              q > b.viewPortMax ||
              (a < e.viewPortMin && (e.viewPortMin = a),
              a > e.viewPortMax && (e.viewPortMax = Math.max(a, m))));
      }
    };
    s.prototype._processStacked100PlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
        for (
          var e = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            g,
            h = !1,
            D = !1,
            d = !1,
            J = [],
            m = 0;
          m < a.dataSeriesIndexes.length;
          m++
        ) {
          var n = this.data[a.dataSeriesIndexes[m]],
            p = 0,
            q = !1,
            l = !1,
            r;
          if ("normal" === n.axisPlacement || "xySwapped" === n.axisPlacement)
            var x = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : -Infinity,
              v = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (n.dataPoints[p].x && n.dataPoints[p].x.getTime) ||
            "dateTime" === n.xValueType
          )
            h = !0;
          for (p = 0; p < n.dataPoints.length; p++) {
            "undefined" === typeof n.dataPoints[p].x &&
              (n.dataPoints[p].x = p + (a.axisX.logarithmic ? 1 : 0));
            n.dataPoints[p].x.getTime
              ? ((h = !0), (c = n.dataPoints[p].x.getTime()))
              : (c = n.dataPoints[p].x);
            g = f(n.dataPoints[p].y) ? null : n.dataPoints[p].y;
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            if (0 < p) {
              if (a.axisX.logarithmic) {
                var w = c / n.dataPoints[p - 1].x;
                1 > w && (w = 1 / w);
                b.minDiff > w && 1 !== w && (b.minDiff = w);
              } else
                (w = c - n.dataPoints[p - 1].x),
                  0 > w && (w *= -1),
                  b.minDiff > w && 0 !== w && (b.minDiff = w);
              f(g) ||
                null === n.dataPoints[p - 1].y ||
                (a.axisY.logarithmic
                  ? 0 < g &&
                    ((w = g / n.dataPoints[p - 1].y),
                    1 > w && (w = 1 / w),
                    e.minDiff > w && 1 !== w && (e.minDiff = w))
                  : ((w = g - n.dataPoints[p - 1].y),
                    0 > w && (w *= -1),
                    e.minDiff > w && 0 !== w && (e.minDiff = w)));
            }
            if (c < x && !q) null !== g && (r = c);
            else {
              if (!q && ((q = !0), 0 < p)) {
                p -= 2;
                continue;
              }
              if (c > v && !l) l = !0;
              else if (c > v && l) continue;
              n.dataPoints[p].label &&
                (a.axisX.labels[c] = n.dataPoints[p].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              null === g
                ? b.viewPortMin === c && r < c && (b.viewPortMin = r)
                : ((a.yTotals[c] = (a.yTotals[c] ? a.yTotals[c] : 0) + g),
                  (a.yAbsTotals[c] =
                    (a.yAbsTotals[c] ? a.yAbsTotals[c] : 0) + Math.abs(g)),
                  0 <= g ? (D = !0) : 0 > g && (d = !0),
                  (J[c] = J[c] ? J[c] + Math.abs(g) : Math.abs(g)));
            }
          }
          n.axisX.valueType = n.xValueType = h ? "dateTime" : "number";
        }
        a.axisY.logarithmic
          ? ((e.max = f(e.viewPortMax)
              ? 99 * Math.pow(a.axisY.logarithmBase, -0.05)
              : Math.max(
                  e.viewPortMax,
                  99 * Math.pow(a.axisY.logarithmBase, -0.05)
                )),
            (e.min = f(e.viewPortMin) ? 1 : Math.min(e.viewPortMin, 1)))
          : D && !d
          ? ((e.max = f(e.viewPortMax) ? 99 : Math.max(e.viewPortMax, 99)),
            (e.min = f(e.viewPortMin) ? 1 : Math.min(e.viewPortMin, 1)))
          : D && d
          ? ((e.max = f(e.viewPortMax) ? 99 : Math.max(e.viewPortMax, 99)),
            (e.min = f(e.viewPortMin) ? -99 : Math.min(e.viewPortMin, -99)))
          : !D &&
            d &&
            ((e.max = f(e.viewPortMax) ? -1 : Math.max(e.viewPortMax, -1)),
            (e.min = f(e.viewPortMin) ? -99 : Math.min(e.viewPortMin, -99)));
        e.viewPortMin = e.min;
        e.viewPortMax = e.max;
        a.dataPointYSums = J;
      }
    };
    s.prototype._processMultiYPlotUnit = function (a) {
      if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length))
        for (
          var e = a.axisY.dataInfo,
            b = a.axisX.dataInfo,
            c,
            g,
            h,
            D,
            f = !1,
            d = 0;
          d < a.dataSeriesIndexes.length;
          d++
        ) {
          var m = this.data[a.dataSeriesIndexes[d]],
            n = 0,
            p = !1,
            q = !1,
            l,
            r,
            x;
          if ("normal" === m.axisPlacement || "xySwapped" === m.axisPlacement)
            var v = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              w = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (m.dataPoints[n].x && m.dataPoints[n].x.getTime) ||
            "dateTime" === m.xValueType
          )
            f = !0;
          for (n = 0; n < m.dataPoints.length; n++) {
            "undefined" === typeof m.dataPoints[n].x &&
              (m.dataPoints[n].x = n + (a.axisX.logarithmic ? 1 : 0));
            m.dataPoints[n].x.getTime
              ? ((f = !0), (c = m.dataPoints[n].x.getTime()))
              : (c = m.dataPoints[n].x);
            if ((g = m.dataPoints[n].y) && g.length) {
              h = Math.min.apply(null, g);
              D = Math.max.apply(null, g);
              r = !0;
              for (var A = 0; A < g.length; A++) null === g.k && (r = !1);
              r && (p || (x = l), (l = c));
            }
            c < b.min && (b.min = c);
            c > b.max && (b.max = c);
            h < e.min && (e.min = h);
            D > e.max && (e.max = D);
            0 < n &&
              (a.axisX.logarithmic
                ? ((r = c / m.dataPoints[n - 1].x),
                  1 > r && (r = 1 / r),
                  b.minDiff > r && 1 !== r && (b.minDiff = r))
                : ((r = c - m.dataPoints[n - 1].x),
                  0 > r && (r *= -1),
                  b.minDiff > r && 0 !== r && (b.minDiff = r)),
              g &&
                null !== g[0] &&
                m.dataPoints[n - 1].y &&
                null !== m.dataPoints[n - 1].y[0] &&
                (a.axisY.logarithmic
                  ? ((r = g[0] / m.dataPoints[n - 1].y[0]),
                    1 > r && (r = 1 / r),
                    e.minDiff > r && 1 !== r && (e.minDiff = r))
                  : ((r = g[0] - m.dataPoints[n - 1].y[0]),
                    0 > r && (r *= -1),
                    e.minDiff > r && 0 !== r && (e.minDiff = r))));
            if (!(c < v) || p) {
              if (!p && ((p = !0), 0 < n)) {
                n -= 2;
                l = x;
                continue;
              }
              if (c > w && !q) q = !0;
              else if (c > w && q) continue;
              m.dataPoints[n].label &&
                (a.axisX.labels[c] = m.dataPoints[n].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              if (b.viewPortMin === c && g)
                for (A = 0; A < g.length; A++)
                  if (null === g[A] && l < c) {
                    b.viewPortMin = l;
                    break;
                  }
              null === g
                ? b.viewPortMin === c && l < c && (b.viewPortMin = l)
                : (h < e.viewPortMin && (e.viewPortMin = h),
                  D > e.viewPortMax && (e.viewPortMax = D));
            }
          }
          m.axisX.valueType = m.xValueType = f ? "dateTime" : "number";
        }
    };
    s.prototype._processSpecificPlotUnit = function (a) {
      if (
        "waterfall" === a.type &&
        a.dataSeriesIndexes &&
        !(1 > a.dataSeriesIndexes.length)
      )
        for (
          var e = a.axisY.dataInfo, b = a.axisX.dataInfo, c, g, h = !1, D = 0;
          D < a.dataSeriesIndexes.length;
          D++
        ) {
          var f = this.data[a.dataSeriesIndexes[D]],
            d = 0,
            m = !1,
            n = !1,
            p = (c = 0);
          if ("normal" === f.axisPlacement || "xySwapped" === f.axisPlacement)
            var q = a.axisX.sessionVariables.newViewportMinimum
                ? a.axisX.sessionVariables.newViewportMinimum
                : this.options.axisX && this.options.axisX.viewportMinimum
                ? this.options.axisX.viewportMinimum
                : this.options.axisX && this.options.axisX.minimum
                ? this.options.axisX.minimum
                : a.axisX.logarithmic
                ? 0
                : -Infinity,
              l = a.axisX.sessionVariables.newViewportMaximum
                ? a.axisX.sessionVariables.newViewportMaximum
                : this.options.axisX && this.options.axisX.viewportMaximum
                ? this.options.axisX.viewportMaximum
                : this.options.axisX && this.options.axisX.maximum
                ? this.options.axisX.maximum
                : Infinity;
          if (
            (f.dataPoints[d].x && f.dataPoints[d].x.getTime) ||
            "dateTime" === f.xValueType
          )
            h = !0;
          for (d = 0; d < f.dataPoints.length; d++)
            "undefined" !== typeof f.dataPoints[d].isCumulativeSum &&
            !0 === f.dataPoints[d].isCumulativeSum
              ? ((f.dataPointEOs[d].cumulativeSumYStartValue = 0),
                (f.dataPointEOs[d].cumulativeSum =
                  0 === d ? 0 : f.dataPointEOs[d - 1].cumulativeSum),
                (f.dataPoints[d].y =
                  0 === d ? 0 : f.dataPointEOs[d - 1].cumulativeSum))
              : "undefined" !== typeof f.dataPoints[d].isIntermediateSum &&
                !0 === f.dataPoints[d].isIntermediateSum
              ? ((f.dataPointEOs[d].cumulativeSumYStartValue = p),
                (f.dataPointEOs[d].cumulativeSum =
                  0 === d ? 0 : f.dataPointEOs[d - 1].cumulativeSum),
                (f.dataPoints[d].y = 0 === d ? 0 : c),
                (p = 0 === d ? 0 : f.dataPointEOs[d - 1].cumulativeSum),
                (c = 0))
              : ((g =
                  "number" !== typeof f.dataPoints[d].y
                    ? 0
                    : f.dataPoints[d].y),
                (f.dataPointEOs[d].cumulativeSumYStartValue =
                  0 === d ? 0 : f.dataPointEOs[d - 1].cumulativeSum),
                (f.dataPointEOs[d].cumulativeSum =
                  0 === d ? g : f.dataPointEOs[d - 1].cumulativeSum + g),
                (c += g));
          for (d = 0; d < f.dataPoints.length; d++)
            if (
              ("undefined" === typeof f.dataPoints[d].x &&
                (f.dataPoints[d].x = d + (a.axisX.logarithmic ? 1 : 0)),
              f.dataPoints[d].x.getTime
                ? ((h = !0), (c = f.dataPoints[d].x.getTime()))
                : (c = f.dataPoints[d].x),
              (g = f.dataPoints[d].y),
              c < b.min && (b.min = c),
              c > b.max && (b.max = c),
              f.dataPointEOs[d].cumulativeSum < e.min &&
                (e.min = f.dataPointEOs[d].cumulativeSum),
              f.dataPointEOs[d].cumulativeSum > e.max &&
                (e.max = f.dataPointEOs[d].cumulativeSum),
              0 < d &&
                (a.axisX.logarithmic
                  ? ((p = c / f.dataPoints[d - 1].x),
                    1 > p && (p = 1 / p),
                    b.minDiff > p && 1 !== p && (b.minDiff = p))
                  : ((p = c - f.dataPoints[d - 1].x),
                    0 > p && (p *= -1),
                    b.minDiff > p && 0 !== p && (b.minDiff = p)),
                null !== g &&
                  null !== f.dataPoints[d - 1].y &&
                  (a.axisY.logarithmic
                    ? ((g =
                        f.dataPointEOs[d].cumulativeSum /
                        f.dataPointEOs[d - 1].cumulativeSum),
                      1 > g && (g = 1 / g),
                      e.minDiff > g && 1 !== g && (e.minDiff = g))
                    : ((g =
                        f.dataPointEOs[d].cumulativeSum -
                        f.dataPointEOs[d - 1].cumulativeSum),
                      0 > g && (g *= -1),
                      e.minDiff > g && 0 !== g && (e.minDiff = g)))),
              !(c < q) || m)
            ) {
              if (!m && ((m = !0), 0 < d)) {
                d -= 2;
                continue;
              }
              if (c > l && !n) n = !0;
              else if (c > l && n) continue;
              f.dataPoints[d].label &&
                (a.axisX.labels[c] = f.dataPoints[d].label);
              c < b.viewPortMin && (b.viewPortMin = c);
              c > b.viewPortMax && (b.viewPortMax = c);
              0 < d &&
                (f.dataPointEOs[d - 1].cumulativeSum < e.viewPortMin &&
                  (e.viewPortMin = f.dataPointEOs[d - 1].cumulativeSum),
                f.dataPointEOs[d - 1].cumulativeSum > e.viewPortMax &&
                  (e.viewPortMax = f.dataPointEOs[d - 1].cumulativeSum));
              f.dataPointEOs[d].cumulativeSum < e.viewPortMin &&
                (e.viewPortMin = f.dataPointEOs[d].cumulativeSum);
              f.dataPointEOs[d].cumulativeSum > e.viewPortMax &&
                (e.viewPortMax = f.dataPointEOs[d].cumulativeSum);
            }
          f.axisX.valueType = f.xValueType = h ? "dateTime" : "number";
        }
    };
    s.prototype.calculateAutoBreaks = function () {
      function a(a, c, b, e) {
        if (e)
          return (
            (b = Math.pow(Math.min((b * a) / c, c / a), 0.2)),
            1 >= b && (b = Math.pow(1 > a ? 1 / a : Math.min(c / a, a), 0.25)),
            { startValue: a * b, endValue: c / b }
          );
        b = 0.2 * Math.min(b - c + a, c - a);
        0 >= b && (b = 0.25 * Math.min(c - a, Math.abs(a)));
        return { startValue: a + b, endValue: c - b };
      }
      function e(a) {
        if (a.dataSeriesIndexes && !(1 > a.dataSeriesIndexes.length)) {
          var c =
              a.axisX.scaleBreaks &&
              a.axisX.scaleBreaks.autoCalculate &&
              1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks,
            b =
              a.axisY.scaleBreaks &&
              a.axisY.scaleBreaks.autoCalculate &&
              1 <= a.axisY.scaleBreaks.maxNumberOfAutoBreaks;
          if (c || b)
            for (
              var e = a.axisY.dataInfo,
                h = a.axisX.dataInfo,
                l,
                m = h.min,
                D = h.max,
                n = e.min,
                d = e.max,
                h = h._dataRanges,
                e = e._dataRanges,
                p,
                q = 0,
                xa = 0;
              xa < a.dataSeriesIndexes.length;
              xa++
            ) {
              var x = g.data[a.dataSeriesIndexes[xa]];
              if (!(4 > x.dataPoints.length))
                for (q = 0; q < x.dataPoints.length; q++)
                  if (
                    (c &&
                      ((p =
                        ((D + 1 - m) *
                          Math.max(
                            parseFloat(
                              a.axisX.scaleBreaks.collapsibleThreshold
                            ) || 10,
                            10
                          )) /
                        100),
                      (l = x.dataPoints[q].x.getTime
                        ? x.dataPoints[q].x.getTime()
                        : x.dataPoints[q].x),
                      (p = Math.floor((l - m) / p)),
                      l < h[p].min && (h[p].min = l),
                      l > h[p].max && (h[p].max = l)),
                    b)
                  ) {
                    var J =
                      ((d + 1 - n) *
                        Math.max(
                          parseFloat(
                            a.axisY.scaleBreaks.collapsibleThreshold
                          ) || 10,
                          10
                        )) /
                      100;
                    if (
                      (l =
                        "waterfall" === a.type
                          ? x.dataPointEOs[q].cumulativeSum
                          : x.dataPoints[q].y) &&
                      l.length
                    )
                      for (var v = 0; v < l.length; v++)
                        (p = Math.floor((l[v] - n) / J)),
                          l[v] < e[p].min && (e[p].min = l[v]),
                          l[v] > e[p].max && (e[p].max = l[v]);
                    else
                      f(l) ||
                        ((p = Math.floor((l - n) / J)),
                        l < e[p].min && (e[p].min = l),
                        l > e[p].max && (e[p].max = l));
                  }
            }
        }
      }
      function b(a) {
        if (
          a.dataSeriesIndexes &&
          !(1 > a.dataSeriesIndexes.length) &&
          a.axisX.scaleBreaks &&
          a.axisX.scaleBreaks.autoCalculate &&
          1 <= a.axisX.scaleBreaks.maxNumberOfAutoBreaks
        )
          for (
            var c = a.axisX.dataInfo,
              b = c.min,
              e = c.max,
              h = c._dataRanges,
              l,
              m = 0,
              f = 0;
            f < a.dataSeriesIndexes.length;
            f++
          ) {
            var D = g.data[a.dataSeriesIndexes[f]];
            if (!(4 > D.dataPoints.length))
              for (m = 0; m < D.dataPoints.length; m++)
                (l =
                  ((e + 1 - b) *
                    Math.max(
                      parseFloat(a.axisX.scaleBreaks.collapsibleThreshold) ||
                        10,
                      10
                    )) /
                  100),
                  (c = D.dataPoints[m].x.getTime
                    ? D.dataPoints[m].x.getTime()
                    : D.dataPoints[m].x),
                  (l = Math.floor((c - b) / l)),
                  c < h[l].min && (h[l].min = c),
                  c > h[l].max && (h[l].max = c);
          }
      }
      for (var c, g = this, h = !1, D = 0; D < this._axes.length; D++)
        if (
          this._axes[D].scaleBreaks &&
          this._axes[D].scaleBreaks.autoCalculate &&
          1 <= this._axes[D].scaleBreaks.maxNumberOfAutoBreaks
        ) {
          h = !0;
          this._axes[D].dataInfo._dataRanges = [];
          for (
            var d = 0;
            d <
            100 /
              Math.max(
                parseFloat(this._axes[D].scaleBreaks.collapsibleThreshold) ||
                  10,
                10
              );
            d++
          )
            this._axes[D].dataInfo._dataRanges.push({
              min: Infinity,
              max: -Infinity,
            });
        }
      if (h) {
        for (D = 0; D < this.plotInfo.plotTypes.length; D++)
          for (
            h = this.plotInfo.plotTypes[D], d = 0;
            d < h.plotUnits.length;
            d++
          )
            (c = h.plotUnits[d]),
              "line" === c.type ||
              "stepLine" === c.type ||
              "spline" === c.type ||
              "column" === c.type ||
              "area" === c.type ||
              "stepArea" === c.type ||
              "splineArea" === c.type ||
              "bar" === c.type ||
              "bubble" === c.type ||
              "scatter" === c.type ||
              "candlestick" === c.type ||
              "ohlc" === c.type ||
              "rangeColumn" === c.type ||
              "rangeBar" === c.type ||
              "rangeArea" === c.type ||
              "rangeSplineArea" === c.type ||
              "waterfall" === c.type ||
              "error" === c.type ||
              "boxAndWhisker" === c.type
                ? e(c)
                : 0 <= c.type.indexOf("stacked") && b(c);
        for (D = 0; D < this._axes.length; D++)
          if (this._axes[D].dataInfo._dataRanges) {
            var x = this._axes[D].dataInfo.min;
            c =
              ((this._axes[D].dataInfo.max + 1 - x) *
                Math.max(
                  parseFloat(this._axes[D].scaleBreaks.collapsibleThreshold) ||
                    10,
                  10
                )) /
              100;
            var m = this._axes[D].dataInfo._dataRanges,
              n,
              p,
              h = [];
            if (this._axes[D].dataInfo.dataPointYPositiveSums) {
              var q = this._axes[D].dataInfo.dataPointYPositiveSums;
              n = m;
              for (d in q)
                if (q.hasOwnProperty(d) && !isNaN(d) && ((p = q[d]), !f(p))) {
                  var l = Math.floor((p - x) / c);
                  p < n[l].min && (n[l].min = p);
                  p > n[l].max && (n[l].max = p);
                }
              delete this._axes[D].dataInfo.dataPointYPositiveSums;
            }
            if (this._axes[D].dataInfo.dataPointYNegativeSums) {
              q = this._axes[D].dataInfo.dataPointYNegativeSums;
              n = m;
              for (d in q)
                q.hasOwnProperty(d) &&
                  !isNaN(d) &&
                  ((p = -1 * q[d]),
                  f(p) ||
                    ((l = Math.floor((p - x) / c)),
                    p < n[l].min && (n[l].min = p),
                    p > n[l].max && (n[l].max = p)));
              delete this._axes[D].dataInfo.dataPointYNegativeSums;
            }
            for (d = 0; d < m.length - 1; d++)
              if (((n = m[d].max), isFinite(n)))
                for (; d < m.length - 1; )
                  if (((x = m[d + 1].min), isFinite(x))) {
                    p = x - n;
                    p > c && h.push({ diff: p, start: n, end: x });
                    break;
                  } else d++;
            if (this._axes[D].scaleBreaks.customBreaks)
              for (
                d = 0;
                d < this._axes[D].scaleBreaks.customBreaks.length;
                d++
              )
                for (c = 0; c < h.length; c++)
                  if (
                    (this._axes[D].scaleBreaks.customBreaks[d].startValue <=
                      h[c].start &&
                      h[c].start <=
                        this._axes[D].scaleBreaks.customBreaks[d].endValue) ||
                    (this._axes[D].scaleBreaks.customBreaks[d].startValue <=
                      h[c].start &&
                      h[c].start <=
                        this._axes[D].scaleBreaks.customBreaks[d].endValue) ||
                    (h[c].start <=
                      this._axes[D].scaleBreaks.customBreaks[d].startValue &&
                      this._axes[D].scaleBreaks.customBreaks[d].startValue <=
                        h[c].end) ||
                    (h[c].start <=
                      this._axes[D].scaleBreaks.customBreaks[d].endValue &&
                      this._axes[D].scaleBreaks.customBreaks[d].endValue <=
                        h[c].end)
                  )
                    h.splice(c, 1), c--;
            h.sort(function (a, c) {
              return c.diff - a.diff;
            });
            for (
              d = 0;
              d <
              Math.min(
                h.length,
                this._axes[D].scaleBreaks.maxNumberOfAutoBreaks
              );
              d++
            )
              (c = a(
                h[d].start,
                h[d].end,
                this._axes[D].logarithmic
                  ? this._axes[D].dataInfo.max / this._axes[D].dataInfo.min
                  : this._axes[D].dataInfo.max - this._axes[D].dataInfo.min,
                this._axes[D].logarithmic
              )),
                this._axes[D].scaleBreaks.autoBreaks.push(
                  new X(
                    this,
                    "autoBreaks",
                    c,
                    d,
                    ++this._eventManager.lastObjectId,
                    this._axes[D].scaleBreaks
                  )
                ),
                this._axes[D].scaleBreaks._appliedBreaks.push(
                  this._axes[D].scaleBreaks.autoBreaks[
                    this._axes[D].scaleBreaks.autoBreaks.length - 1
                  ]
                );
            this._axes[D].scaleBreaks._appliedBreaks.sort(function (a, c) {
              return a.startValue - c.startValue;
            });
          }
      }
    };
    s.prototype.renderCrosshairs = function (a) {
      for (var e = 0; e < this.axisX.length; e++)
        this.axisX[e] != a &&
          this.axisX[e].crosshair &&
          this.axisX[e].crosshair.enabled &&
          !this.axisX[e].crosshair._hidden &&
          this.axisX[e].showCrosshair(this.axisX[e].crosshair._updatedValue);
      for (e = 0; e < this.axisX2.length; e++)
        this.axisX2[e] != a &&
          this.axisX2[e].crosshair &&
          this.axisX2[e].crosshair.enabled &&
          !this.axisX2[e].crosshair._hidden &&
          this.axisX2[e].showCrosshair(this.axisX2[e].crosshair._updatedValue);
      for (e = 0; e < this.axisY.length; e++)
        this.axisY[e] != a &&
          this.axisY[e].crosshair &&
          this.axisY[e].crosshair.enabled &&
          !this.axisY[e].crosshair._hidden &&
          this.axisY[e].showCrosshair(this.axisY[e].crosshair._updatedValue);
      for (e = 0; e < this.axisY2.length; e++)
        this.axisY2[e] != a &&
          this.axisY2[e].crosshair &&
          this.axisY2[e].crosshair.enabled &&
          !this.axisY2[e].crosshair._hidden &&
          this.axisY2[e].showCrosshair(this.axisY2[e].crosshair._updatedValue);
    };
    s.prototype.getDataPointAtXY = function (a, e, b) {
      b = b || !1;
      for (var c = [], g = this._dataInRenderedOrder.length - 1; 0 <= g; g--) {
        var h = null;
        (h = this._dataInRenderedOrder[g].getDataPointAtXY(a, e, b)) &&
          c.push(h);
      }
      a = null;
      e = !1;
      for (b = 0; b < c.length; b++)
        if (
          "line" === c[b].dataSeries.type ||
          "stepLine" === c[b].dataSeries.type ||
          "area" === c[b].dataSeries.type ||
          "stepArea" === c[b].dataSeries.type
        )
          if (
            ((g = ra("markerSize", c[b].dataPoint, c[b].dataSeries) || 8),
            c[b].distance <= g / 2)
          ) {
            e = !0;
            break;
          }
      for (b = 0; b < c.length; b++)
        (e &&
          "line" !== c[b].dataSeries.type &&
          "stepLine" !== c[b].dataSeries.type &&
          "area" !== c[b].dataSeries.type &&
          "stepArea" !== c[b].dataSeries.type) ||
          (a ? c[b].distance <= a.distance && (a = c[b]) : (a = c[b]));
      return a;
    };
    s.prototype.getObjectAtXY = function (a, e, b) {
      var c = null;
      if ((b = this.getDataPointAtXY(a, e, b || !1)))
        c = b.dataSeries.dataPointIds[b.dataPointIndex];
      else if (v) c = kb(a, e, this._eventManager.ghostCtx);
      else
        for (b = 0; b < this.legend.items.length; b++) {
          var g = this.legend.items[b];
          a >= g.x1 && a <= g.x2 && e >= g.y1 && e <= g.y2 && (c = g.id);
        }
      return c;
    };
    s.prototype.getAutoFontSize = ob;
    s.prototype.resetOverlayedCanvas = function () {
      this.overlaidCanvasCtx.clearRect(0, 0, this.width, this.height);
    };
    s.prototype.clearCanvas = nb;
    s.prototype.attachEvent = function (a) {
      this._events.push(a);
    };
    s.prototype._touchEventHandler = function (a) {
      if (a.changedTouches && this.interactivityEnabled) {
        var e = [],
          b = a.changedTouches,
          c = b ? b[0] : a,
          g = null;
        switch (a.type) {
          case "touchstart":
          case "MSPointerDown":
            e = ["mousemove", "mousedown"];
            this._lastTouchData = Ba(c);
            this._lastTouchData.time = new Date();
            break;
          case "touchmove":
          case "MSPointerMove":
            e = ["mousemove"];
            break;
          case "touchend":
          case "MSPointerUp":
            var h =
                this._lastTouchData && this._lastTouchData.time
                  ? new Date() - this._lastTouchData.time
                  : 0,
              e =
                "touchstart" === this._lastTouchEventType ||
                "MSPointerDown" === this._lastTouchEventType ||
                300 > h
                  ? ["mouseup", "click"]
                  : ["mouseup"];
            break;
          default:
            return;
        }
        if (!(b && 1 < b.length)) {
          g = Ba(c);
          g.time = new Date();
          try {
            var D = g.y - this._lastTouchData.y,
              h = g.time - this._lastTouchData.time;
            if (
              (1 < Math.abs(D) && this._lastTouchData.scroll) ||
              (5 < Math.abs(D) && 250 > h)
            )
              this._lastTouchData.scroll = !0;
          } catch (d) {}
          this._lastTouchEventType = a.type;
          if (this._lastTouchData.scroll && this.zoomEnabled)
            this.isDrag && this.resetOverlayedCanvas(), (this.isDrag = !1);
          else
            for (b = 0; b < e.length; b++)
              if (
                ((g = e[b]),
                (D = document.createEvent("MouseEvent")),
                D.initMouseEvent(
                  g,
                  !0,
                  !0,
                  window,
                  1,
                  c.screenX,
                  c.screenY,
                  c.clientX,
                  c.clientY,
                  !1,
                  !1,
                  !1,
                  !1,
                  0,
                  null
                ),
                c.target.dispatchEvent(D),
                (!f(this._lastTouchData.scroll) &&
                  !this._lastTouchData.scroll) ||
                  (!this._lastTouchData.scroll && 250 < h) ||
                  "click" === g)
              )
                a.preventManipulation && a.preventManipulation(),
                  a.preventDefault && a.cancelable && a.preventDefault();
        }
      }
    };
    s.prototype._dispatchRangeEvent = function (a, e) {
      var b = { chart: this };
      b.type = a;
      b.trigger = e;
      var c = [];
      this.axisX && 0 < this.axisX.length && c.push("axisX");
      this.axisX2 && 0 < this.axisX2.length && c.push("axisX2");
      this.axisY && 0 < this.axisY.length && c.push("axisY");
      this.axisY2 && 0 < this.axisY2.length && c.push("axisY2");
      for (var g = 0; g < c.length; g++)
        if ((f(b[c[g]]) && (b[c[g]] = []), "axisY" === c[g]))
          for (var h = 0; h < this.axisY.length; h++)
            b[c[g]].push({
              viewportMinimum:
                this[c[g]][h].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[g]][h].sessionVariables.newViewportMaximum,
            });
        else if ("axisY2" === c[g])
          for (h = 0; h < this.axisY2.length; h++)
            b[c[g]].push({
              viewportMinimum:
                this[c[g]][h].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[g]][h].sessionVariables.newViewportMaximum,
            });
        else if ("axisX" === c[g])
          for (h = 0; h < this.axisX.length; h++)
            b[c[g]].push({
              viewportMinimum:
                this[c[g]][h].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[g]][h].sessionVariables.newViewportMaximum,
            });
        else if ("axisX2" === c[g])
          for (h = 0; h < this.axisX2.length; h++)
            b[c[g]].push({
              viewportMinimum:
                this[c[g]][h].sessionVariables.newViewportMinimum,
              viewportMaximum:
                this[c[g]][h].sessionVariables.newViewportMaximum,
            });
      this.dispatchEvent(a, b, this);
    };
    s.prototype._mouseEventHandler = function (a) {
      "undefined" === typeof a.target &&
        a.srcElement &&
        (a.target = a.srcElement);
      var e = Ba(a),
        b = a.type,
        c,
        g;
      a.which ? (g = 3 == a.which) : a.button && (g = 2 == a.button);
      s.capturedEventParam &&
        ((c = s.capturedEventParam),
        "mouseup" === b &&
          ((s.capturedEventParam = null),
          c.chart.overlaidCanvas.releaseCapture
            ? c.chart.overlaidCanvas.releaseCapture()
            : document.documentElement.removeEventListener(
                "mouseup",
                c.chart._mouseEventHandler,
                !1
              )),
        c.hasOwnProperty(b) &&
          ("mouseup" !== b || c.chart.overlaidCanvas.releaseCapture
            ? (a.target !== c.chart.overlaidCanvas && v) ||
              c[b].call(c.context, e.x, e.y)
            : a.target !== c.chart.overlaidCanvas && (c.chart.isDrag = !1)));
      if (this.interactivityEnabled)
        if (this._ignoreNextEvent) this._ignoreNextEvent = !1;
        else if (
          (a.preventManipulation && a.preventManipulation(),
          a.preventDefault && a.preventDefault(),
          Ma &&
            window.console &&
            (window.console.log(b + " --\x3e x: " + e.x + "; y:" + e.y),
            g && window.console.log(a.which),
            "mouseup" === b && window.console.log("mouseup")),
          !g)
        ) {
          if (!s.capturedEventParam && this._events) {
            for (var h = 0; h < this._events.length; h++)
              if (this._events[h].hasOwnProperty(b))
                if (
                  ((c = this._events[h]),
                  (g = c.bounds),
                  e.x >= g.x1 && e.x <= g.x2 && e.y >= g.y1 && e.y <= g.y2)
                ) {
                  c[b].call(c.context, e.x, e.y);
                  "mousedown" === b && !0 === c.capture
                    ? ((s.capturedEventParam = c),
                      this.overlaidCanvas.setCapture
                        ? this.overlaidCanvas.setCapture()
                        : document.documentElement.addEventListener(
                            "mouseup",
                            this._mouseEventHandler,
                            !1
                          ))
                    : "mouseup" === b &&
                      (c.chart.overlaidCanvas.releaseCapture
                        ? c.chart.overlaidCanvas.releaseCapture()
                        : document.documentElement.removeEventListener(
                            "mouseup",
                            this._mouseEventHandler,
                            !1
                          ));
                  break;
                } else c = null;
            a.target.style.cursor =
              c && c.cursor ? c.cursor : this._defaultCursor;
          }
          b = this.plotArea;
          if (e.x < b.x1 || e.x > b.x2 || e.y < b.y1 || e.y > b.y2)
            if (this.toolTip && this.toolTip.enabled) {
              this.toolTip.hide();
              this.toolTip.dispatchEvent(
                "hidden",
                { chart: this, toolTip: this.toolTip },
                this.toolTip
              );
              for (h = 0; h < this.axisX.length; h++)
                this.axisX[h].crosshair &&
                  this.axisX[h].crosshair.enabled &&
                  this.axisX[h].crosshair.dispatchEvent(
                    "hidden",
                    { chart: this, axis: this.axisX[h].options },
                    this.axisX[h].crosshair
                  );
              for (h = 0; h < this.axisX2.length; h++)
                this.axisX2[h].crosshair &&
                  this.axisX2[h].crosshair.enabled &&
                  this.axisX2[h].crosshair.dispatchEvent(
                    "hidden",
                    { chart: this, axis: this.axisX2[h].options },
                    this.axisX2[h].crosshair
                  );
              for (h = 0; h < this.axisY.length; h++)
                this.axisY[h].crosshair &&
                  this.axisY[h].crosshair.enabled &&
                  this.axisY[h].crosshair.dispatchEvent(
                    "hidden",
                    { chart: this, axis: this.axisY[h].options },
                    this.axisY[h].crosshair
                  );
              for (h = 0; h < this.axisY2.length; h++)
                this.axisY2[h].crosshair &&
                  this.axisY2[h].crosshair.enabled &&
                  this.axisY2[h].crosshair.dispatchEvent(
                    "hidden",
                    { chart: this, axis: this.axisY2[h].options },
                    this.axisY2[h].crosshair
                  );
            } else this.resetOverlayedCanvas();
          (this.isDrag && this.zoomEnabled) ||
            !this._eventManager ||
            this._eventManager.mouseEventHandler(a);
        }
    };
    s.prototype._plotAreaMouseDown = function (a, e) {
      this.isDrag = !0;
      this.dragStartPoint = { x: a, y: e };
    };
    s.prototype._plotAreaMouseUp = function (a, e) {
      if (
        ("normal" === this.plotInfo.axisPlacement ||
          "xySwapped" === this.plotInfo.axisPlacement) &&
        this.isDrag
      ) {
        var b = e - this.dragStartPoint.y,
          c = a - this.dragStartPoint.x,
          g = 0 <= this.zoomType.indexOf("x"),
          h = 0 <= this.zoomType.indexOf("y"),
          D = !1;
        this.resetOverlayedCanvas();
        if ("xySwapped" === this.plotInfo.axisPlacement)
          var f = h,
            h = g,
            g = f;
        if (this.panEnabled || this.zoomEnabled) {
          if (this.panEnabled)
            for (g = h = 0; g < this._axes.length; g++)
              (b = this._axes[g]),
                b.logarithmic
                  ? b.viewportMinimum < b.minimum
                    ? ((h = b.minimum / b.viewportMinimum),
                      (b.sessionVariables.newViewportMinimum =
                        b.viewportMinimum * h),
                      (b.sessionVariables.newViewportMaximum =
                        b.viewportMaximum * h),
                      (D = !0))
                    : b.viewportMaximum > b.maximum &&
                      ((h = b.viewportMaximum / b.maximum),
                      (b.sessionVariables.newViewportMinimum =
                        b.viewportMinimum / h),
                      (b.sessionVariables.newViewportMaximum =
                        b.viewportMaximum / h),
                      (D = !0))
                  : b.viewportMinimum < b.minimum
                  ? ((h = b.minimum - b.viewportMinimum),
                    (b.sessionVariables.newViewportMinimum =
                      b.viewportMinimum + h),
                    (b.sessionVariables.newViewportMaximum =
                      b.viewportMaximum + h),
                    (D = !0))
                  : b.viewportMaximum > b.maximum &&
                    ((h = b.viewportMaximum - b.maximum),
                    (b.sessionVariables.newViewportMinimum =
                      b.viewportMinimum - h),
                    (b.sessionVariables.newViewportMaximum =
                      b.viewportMaximum - h),
                    (D = !0));
          else if (
            (!g || 2 < Math.abs(c)) &&
            (!h || 2 < Math.abs(b)) &&
            this.zoomEnabled
          ) {
            if (!this.dragStartPoint) return;
            b = g ? this.dragStartPoint.x : this.plotArea.x1;
            c = h ? this.dragStartPoint.y : this.plotArea.y1;
            g = g ? a : this.plotArea.x2;
            h = h ? e : this.plotArea.y2;
            2 < Math.abs(b - g) &&
              2 < Math.abs(c - h) &&
              this._zoomPanToSelectedRegion(b, c, g, h) &&
              (D = !0);
          }
          D &&
            ((this._ignoreNextEvent = !0),
            this._dispatchRangeEvent("rangeChanging", "zoom"),
            this.stockChart &&
              this.stockChart.navigator &&
              this.stockChart.navigator.enabled &&
              (this.stockChart._rangeEventParameter ||
                (this.stockChart._rangeEventParameter = {
                  stockChart: this.stockChart,
                  source: "chart",
                  index: this.stockChart.charts.indexOf(this),
                  minimum: this.stockChart.sessionVariables._axisXMin,
                  maximum: this.stockChart.sessionVariables._axisXMax,
                }),
              (this.stockChart._rangeEventParameter.type = "rangeChanging"),
              this.stockChart.dispatchEvent(
                "rangeChanging",
                this.stockChart._rangeEventParameter,
                this.stockChart
              )),
            this.render(),
            this._dispatchRangeEvent("rangeChanged", "zoom"),
            this.stockChart &&
              this.stockChart.navigator &&
              this.stockChart.navigator.enabled &&
              ((this.stockChart._rangeEventParameter.type = "rangeChanged"),
              this.stockChart.dispatchEvent(
                "rangeChanged",
                this.stockChart._rangeEventParameter,
                this.stockChart
              )),
            D &&
              this.zoomEnabled &&
              "none" === this._zoomButton.style.display &&
              (Ta(this._zoomButton, this._resetButton),
              Ca(this, this._zoomButton, "pan"),
              Ca(this, this._resetButton, "reset")));
        }
      }
      this.isDrag = !1;
      if ("none" !== this.plotInfo.axisPlacement) {
        this.resetOverlayedCanvas();
        if (this.axisX && 0 < this.axisX.length)
          for (D = 0; D < this.axisX.length; D++)
            this.axisX[D].crosshair &&
              this.axisX[D].crosshair.enabled &&
              this.axisX[D].renderCrosshair(a, e);
        if (this.axisX2 && 0 < this.axisX2.length)
          for (D = 0; D < this.axisX2.length; D++)
            this.axisX2[D].crosshair &&
              this.axisX2[D].crosshair.enabled &&
              this.axisX2[D].renderCrosshair(a, e);
        if (this.axisY && 0 < this.axisY.length)
          for (D = 0; D < this.axisY.length; D++)
            this.axisY[D].crosshair &&
              this.axisY[D].crosshair.enabled &&
              this.axisY[D].renderCrosshair(a, e);
        if (this.axisY2 && 0 < this.axisY2.length)
          for (D = 0; D < this.axisY2.length; D++)
            this.axisY2[D].crosshair &&
              this.axisY2[D].crosshair.enabled &&
              this.axisY2[D].renderCrosshair(a, e);
      }
    };
    s.prototype._plotAreaMouseMove = function (a, e) {
      if (this.isDrag && "none" !== this.plotInfo.axisPlacement) {
        var b = 0,
          c = 0,
          g = (b = null),
          g = 0 <= this.zoomType.indexOf("x"),
          h = 0 <= this.zoomType.indexOf("y"),
          f = this;
        "xySwapped" === this.plotInfo.axisPlacement &&
          ((b = h), (h = g), (g = b));
        b = this.dragStartPoint.x - a;
        c = this.dragStartPoint.y - e;
        2 < Math.abs(b) &&
        8 > Math.abs(b) &&
        (this.panEnabled || this.zoomEnabled)
          ? (this.toolTip.hide(),
            this.toolTip.dispatchEvent(
              "hidden",
              { chart: this, toolTip: this.toolTip },
              this.toolTip
            ))
          : this.panEnabled ||
            this.zoomEnabled ||
            this.toolTip.mouseMoveHandler(a, e);
        if (
          (!g || 2 < Math.abs(b) || !h || 2 < Math.abs(c)) &&
          (this.panEnabled || this.zoomEnabled)
        )
          if (this.panEnabled)
            (g = {
              x1: g ? this.plotArea.x1 + b : this.plotArea.x1,
              y1: h ? this.plotArea.y1 + c : this.plotArea.y1,
              x2: g ? this.plotArea.x2 + b : this.plotArea.x2,
              y2: h ? this.plotArea.y2 + c : this.plotArea.y2,
            }),
              clearTimeout(f._panTimerId),
              (f._panTimerId = setTimeout(
                (function (c, b, g, h) {
                  return function () {
                    f._zoomPanToSelectedRegion(c, b, g, h, !0) &&
                      (f._dispatchRangeEvent("rangeChanging", "pan"),
                      f.stockChart &&
                        f.stockChart.navigator &&
                        f.stockChart.navigator.enabled &&
                        ((f.stockChart._rangeEventParameter.type =
                          "rangeChanging"),
                        f.stockChart.dispatchEvent(
                          "rangeChanging",
                          f.stockChart._rangeEventParameter,
                          f.stockChart
                        )),
                      f.render(),
                      f._dispatchRangeEvent("rangeChanged", "pan"),
                      f.stockChart &&
                        f.stockChart.navigator &&
                        f.stockChart.navigator.enabled &&
                        ((f.stockChart._rangeEventParameter.type =
                          "rangeChanged"),
                        f.stockChart.dispatchEvent(
                          "rangeChanged",
                          f.stockChart._rangeEventParameter,
                          f.stockChart
                        )),
                      (f.dragStartPoint.x = a),
                      (f.dragStartPoint.y = e));
                  };
                })(g.x1, g.y1, g.x2, g.y2),
                0
              ));
          else if (this.zoomEnabled) {
            this.resetOverlayedCanvas();
            b = this.overlaidCanvasCtx.globalAlpha;
            this.overlaidCanvasCtx.fillStyle = "#A89896";
            var c = g ? this.dragStartPoint.x : this.plotArea.x1,
              d = h ? this.dragStartPoint.y : this.plotArea.y1,
              x = g
                ? a - this.dragStartPoint.x
                : this.plotArea.x2 - this.plotArea.x1,
              m = h
                ? e - this.dragStartPoint.y
                : this.plotArea.y2 - this.plotArea.y1;
            this.validateRegion(
              c,
              d,
              g ? a : this.plotArea.x2 - this.plotArea.x1,
              h ? e : this.plotArea.y2 - this.plotArea.y1,
              "xy" !== this.zoomType
            ).isValid &&
              (this.resetOverlayedCanvas(),
              (this.overlaidCanvasCtx.fillStyle = "#99B2B5"));
            this.overlaidCanvasCtx.globalAlpha = 0.7;
            this.overlaidCanvasCtx.fillRect(c, d, x, m);
            this.overlaidCanvasCtx.globalAlpha = b;
          }
      } else if (
        (this.toolTip.mouseMoveHandler(a, e),
        "none" !== this.plotInfo.axisPlacement)
      ) {
        if (this.axisX && 0 < this.axisX.length)
          for (g = 0; g < this.axisX.length; g++)
            this.axisX[g].crosshair &&
              this.axisX[g].crosshair.enabled &&
              this.axisX[g].renderCrosshair(a, e);
        if (this.axisX2 && 0 < this.axisX2.length)
          for (g = 0; g < this.axisX2.length; g++)
            this.axisX2[g].crosshair &&
              this.axisX2[g].crosshair.enabled &&
              this.axisX2[g].renderCrosshair(a, e);
        if (this.axisY && 0 < this.axisY.length)
          for (g = 0; g < this.axisY.length; g++)
            this.axisY[g].crosshair &&
              this.axisY[g].crosshair.enabled &&
              this.axisY[g].renderCrosshair(a, e);
        if (this.axisY2 && 0 < this.axisY2.length)
          for (g = 0; g < this.axisY2.length; g++)
            this.axisY2[g].crosshair &&
              this.axisY2[g].crosshair.enabled &&
              this.axisY2[g].renderCrosshair(a, e);
      }
    };
    s.prototype._zoomPanToSelectedRegion = function (a, e, b, c, g) {
      a = this.validateRegion(a, e, b, c, g);
      e = a.axesWithValidRange;
      b = a.axesRanges;
      if (a.isValid)
        for (c = 0; c < e.length; c++)
          (g = b[c]),
            e[c].setViewPortRange(g.val1, g.val2),
            this.syncCharts &&
              "y" != this.zoomType &&
              this.syncCharts(g.val1, g.val2),
            this.stockChart &&
              (this.stockChart._rangeEventParameter = {
                stockChart: this.stockChart,
                source: "chart",
                index: this.stockChart.charts.indexOf(this),
                minimum: g.val1,
                maximum: g.val2,
              });
      return a.isValid;
    };
    s.prototype.validateRegion = function (a, e, b, c, g) {
      g = g || !1;
      for (
        var h = 0 <= this.zoomType.indexOf("x"),
          f = 0 <= this.zoomType.indexOf("y"),
          d = !1,
          x = [],
          m = [],
          n = [],
          p = 0;
        p < this._axes.length;
        p++
      )
        (("axisX" === this._axes[p].type && h) ||
          ("axisY" === this._axes[p].type && f)) &&
          m.push(this._axes[p]);
      for (f = 0; f < m.length; f++) {
        var p = m[f],
          h = !1,
          q = p.convertPixelToValue({ x: a, y: e }),
          l = p.convertPixelToValue({ x: b, y: c });
        if (q > l)
          var r = l,
            l = q,
            q = r;
        if (p.scaleBreaks)
          for (r = 0; !h && r < p.scaleBreaks._appliedBreaks.length; r++)
            h =
              p.scaleBreaks._appliedBreaks[r].startValue <= q &&
              p.scaleBreaks._appliedBreaks[r].endValue >= l;
        if (isFinite(p.dataInfo.minDiff))
          if (
            ((r = p.getApparentDifference(q, l, null, !0)),
            !(
              h ||
              (!(
                this.panEnabled &&
                p.scaleBreaks &&
                p.scaleBreaks._appliedBreaks.length
              ) &&
                ((p.logarithmic && r < Math.pow(p.dataInfo.minDiff, 3)) ||
                  (!p.logarithmic && r < 3 * Math.abs(p.dataInfo.minDiff)))) ||
              q < p.minimum ||
              l > p.maximum
            ))
          )
            x.push(p), n.push({ val1: q, val2: l }), (d = !0);
          else if (!g) {
            d = !1;
            break;
          }
      }
      return { isValid: d, axesWithValidRange: x, axesRanges: n };
    };
    s.prototype.preparePlotArea = function () {
      var a = this.plotArea;
      !v && (0 < a.x1 || 0 < a.y1) && a.ctx.translate(a.x1, a.y1);
      if (
        (this.axisX[0] || this.axisX2[0]) &&
        (this.axisY[0] || this.axisY2[0])
      ) {
        var e = this.axisX[0]
          ? this.axisX[0].lineCoordinates
          : this.axisX2[0].lineCoordinates;
        if (this.axisY && 0 < this.axisY.length && this.axisY[0]) {
          var b = this.axisY[0];
          a.x1 = e.x1 < e.x2 ? e.x1 : b.lineCoordinates.x1;
          a.y1 = e.y1 < b.lineCoordinates.y1 ? e.y1 : b.lineCoordinates.y1;
          a.x2 = e.x2 > b.lineCoordinates.x2 ? e.x2 : b.lineCoordinates.x2;
          a.y2 = e.y2 > e.y1 ? e.y2 : b.lineCoordinates.y2;
          a.width = a.x2 - a.x1;
          a.height = a.y2 - a.y1;
        }
        this.axisY2 &&
          0 < this.axisY2.length &&
          this.axisY2[0] &&
          ((b = this.axisY2[0]),
          (a.x1 = e.x1 < e.x2 ? e.x1 : b.lineCoordinates.x1),
          (a.y1 = e.y1 < b.lineCoordinates.y1 ? e.y1 : b.lineCoordinates.y1),
          (a.x2 = e.x2 > b.lineCoordinates.x2 ? e.x2 : b.lineCoordinates.x2),
          (a.y2 = e.y2 > e.y1 ? e.y2 : b.lineCoordinates.y2),
          (a.width = a.x2 - a.x1),
          (a.height = a.y2 - a.y1));
      } else
        (e = this.layoutManager.getFreeSpace()),
          (a.x1 = e.x1),
          (a.x2 = e.x2),
          (a.y1 = e.y1),
          (a.y2 = e.y2),
          (a.width = e.width),
          (a.height = e.height);
      v ||
        ((a.canvas.width = a.width),
        (a.canvas.height = a.height),
        (a.canvas.style.left = a.x1 + "px"),
        (a.canvas.style.top = a.y1 + "px"),
        (0 < a.x1 || 0 < a.y1) && a.ctx.translate(-a.x1, -a.y1));
      a.layoutManager = new La(a.x1, a.y1, a.x2, a.y2, 2);
    };
    s.prototype.renderIndexLabels = function (a) {
      var e = a || this.plotArea.ctx,
        b = this.plotArea,
        c = 0,
        g = 0,
        h = 0,
        D = (h = g = 0),
        d = 0,
        J = (c = 0),
        m = 0;
      for (a = 0; a < this._indexLabels.length; a++) {
        var n = this._indexLabels[a],
          p = n.chartType.toLowerCase(),
          q,
          l,
          D = ra("indexLabelFontColor", n.dataPoint, n.dataSeries),
          r = ra("indexLabelFontSize", n.dataPoint, n.dataSeries),
          d = ra("indexLabelFontFamily", n.dataPoint, n.dataSeries),
          J = ra("indexLabelFontStyle", n.dataPoint, n.dataSeries),
          m = ra("indexLabelFontWeight", n.dataPoint, n.dataSeries),
          qa = ra("indexLabelBackgroundColor", n.dataPoint, n.dataSeries);
        q = ra("indexLabelMaxWidth", n.dataPoint, n.dataSeries);
        l = ra("indexLabelWrap", n.dataPoint, n.dataSeries);
        var ga = ra("indexLabelLineDashType", n.dataPoint, n.dataSeries),
          w = ra("indexLabelLineColor", n.dataPoint, n.dataSeries),
          A = f(n.dataPoint.indexLabelLineThickness)
            ? f(n.dataSeries.options.indexLabelLineThickness)
              ? 0
              : n.dataSeries.options.indexLabelLineThickness
            : n.dataPoint.indexLabelLineThickness,
          c =
            0 < A
              ? Math.min(
                  10,
                  ("normal" === this.plotInfo.axisPlacement
                    ? this.plotArea.height
                    : this.plotArea.width) << 0
                )
              : 0,
          t = { percent: null, total: null },
          k = null;
        if (
          0 <= n.dataSeries.type.indexOf("stacked") ||
          "pie" === n.dataSeries.type ||
          "doughnut" === n.dataSeries.type
        )
          t = this.getPercentAndTotal(n.dataSeries, n.dataPoint);
        if (n.dataSeries.indexLabelFormatter || n.dataPoint.indexLabelFormatter)
          k = {
            chart: this,
            dataSeries: n.dataSeries,
            dataPoint: n.dataPoint,
            index: n.indexKeyword,
            total: t.total,
            percent: t.percent,
          };
        var u = n.dataPoint.indexLabelFormatter
          ? n.dataPoint.indexLabelFormatter(k)
          : n.dataPoint.indexLabel
          ? this.replaceKeywordsWithValue(
              n.dataPoint.indexLabel,
              n.dataPoint,
              n.dataSeries,
              null,
              n.indexKeyword
            )
          : n.dataSeries.indexLabelFormatter
          ? n.dataSeries.indexLabelFormatter(k)
          : n.dataSeries.indexLabel
          ? this.replaceKeywordsWithValue(
              n.dataSeries.indexLabel,
              n.dataPoint,
              n.dataSeries,
              null,
              n.indexKeyword
            )
          : null;
        if (null !== u && "" !== u) {
          var t = ra("indexLabelPlacement", n.dataPoint, n.dataSeries),
            k = ra("indexLabelOrientation", n.dataPoint, n.dataSeries),
            s = ra("indexLabelTextAlign", n.dataPoint, n.dataSeries),
            y = n.direction,
            g = n.dataSeries.axisX,
            h = n.dataSeries.axisY,
            z = !1,
            qa = new na(e, {
              x: 0,
              y: 0,
              maxWidth: q ? q : 0.5 * this.width,
              maxHeight: l ? 5 * r : 1.5 * r,
              angle: "horizontal" === k ? 0 : -90,
              text: u,
              padding: 0,
              backgroundColor: qa,
              textAlign: s,
              fontSize: r,
              fontFamily: d,
              fontWeight: m,
              fontColor: D,
              fontStyle: J,
              textBaseline: "middle",
            });
          qa.measureText();
          n.dataSeries.indexLabelMaxWidth = qa.maxWidth;
          if ("stackedarea100" === p) {
            if (
              n.point.x < b.x1 ||
              n.point.x > b.x2 ||
              n.point.y < b.y1 - 1 ||
              n.point.y > b.y2 + 1
            )
              continue;
          } else if ("rangearea" === p || "rangesplinearea" === p) {
            if (
              n.dataPoint.x < g.viewportMinimum ||
              n.dataPoint.x > g.viewportMaximum ||
              Math.max.apply(null, n.dataPoint.y) < h.viewportMinimum ||
              Math.min.apply(null, n.dataPoint.y) > h.viewportMaximum
            )
              continue;
          } else if (
            0 <= p.indexOf("line") ||
            0 <= p.indexOf("area") ||
            0 <= p.indexOf("bubble") ||
            0 <= p.indexOf("scatter")
          ) {
            if (
              n.dataPoint.x < g.viewportMinimum ||
              n.dataPoint.x > g.viewportMaximum ||
              n.dataPoint.y < h.viewportMinimum ||
              n.dataPoint.y > h.viewportMaximum
            )
              continue;
          } else if (
            0 <= p.indexOf("column") ||
            "waterfall" === p ||
            ("error" === p && !n.axisSwapped)
          ) {
            if (
              n.dataPoint.x < g.viewportMinimum ||
              n.dataPoint.x > g.viewportMaximum ||
              n.bounds.y1 > b.y2 ||
              n.bounds.y2 < b.y1
            )
              continue;
          } else if (0 <= p.indexOf("bar") || "error" === p) {
            if (
              n.dataPoint.x < g.viewportMinimum ||
              n.dataPoint.x > g.viewportMaximum ||
              n.bounds.x1 > b.x2 ||
              n.bounds.x2 < b.x1
            )
              continue;
          } else if ("candlestick" === p || "ohlc" === p) {
            if (
              n.dataPoint.x < g.viewportMinimum ||
              n.dataPoint.x > g.viewportMaximum ||
              Math.max.apply(null, n.dataPoint.y) < h.viewportMinimum ||
              Math.min.apply(null, n.dataPoint.y) > h.viewportMaximum
            )
              continue;
          } else if (
            n.dataPoint.x < g.viewportMinimum ||
            n.dataPoint.x > g.viewportMaximum
          )
            continue;
          D = d = 2;
          "horizontal" === k
            ? ((J = qa.width), (m = qa.height))
            : ((m = qa.width), (J = qa.height));
          if ("normal" === this.plotInfo.axisPlacement) {
            if (0 <= p.indexOf("line") || 0 <= p.indexOf("area"))
              (t = "auto"), (d = 4);
            else if (0 <= p.indexOf("stacked")) "auto" === t && (t = "inside");
            else if ("bubble" === p || "scatter" === p) t = "inside";
            q = n.point.x - ("horizontal" === k ? J / 2 : J / 2 - r / 2);
            "inside" !== t
              ? ((g = b.y1),
                (h = b.y2),
                0 < y
                  ? ((l =
                      n.point.y + ("horizontal" === k ? r / 2 : 0) - m - d - c),
                    l < g &&
                      ((l =
                        "auto" === t
                          ? Math.max(n.point.y, g) + r / 2 + d
                          : g + r / 2 + d),
                      (z = l + m > n.point.y)))
                  : ((l = n.point.y + r / 2 + d + c),
                    l > h - m &&
                      ((l =
                        "auto" === t
                          ? Math.min(n.point.y, h) + r / 2 - m - d
                          : h + r / 2 - m),
                      (z = l < n.point.y))))
              : ((g = Math.max(n.bounds.y1, b.y1)),
                (h = Math.min(n.bounds.y2, b.y2 - m + r / 2)),
                (c =
                  0 <= p.indexOf("range") || "error" === p
                    ? 0 < y
                      ? Math.max(n.bounds.y1, b.y1) + r / 2 + d
                      : Math.min(n.bounds.y2, b.y2) + r / 2 - m + d
                    : (Math.max(n.bounds.y1, b.y1) +
                        Math.min(n.bounds.y2, b.y2)) /
                        2 -
                      m / 2 +
                      r / 2 +
                      ("horizontal" === k ? d : 0)),
                0 < y
                  ? ((l = Math.max(n.point.y, c)),
                    l < g &&
                      ("bubble" === p || "scatter" === p) &&
                      (l = Math.max(n.point.y - m - d, b.y1 + d)))
                  : ((l = Math.min(n.point.y, c)),
                    l > h - m - d &&
                      ("bubble" === p || "scatter" === p) &&
                      (l = Math.min(n.point.y + d, b.y2 - m - d))),
                (l = Math.min(l, h)));
          } else
            0 <= p.indexOf("line") ||
            0 <= p.indexOf("area") ||
            0 <= p.indexOf("scatter")
              ? ((t = "auto"), (D = 4))
              : 0 <= p.indexOf("stacked")
              ? "auto" === t && (t = "inside")
              : "bubble" === p && (t = "inside"),
              (l = n.point.y + r / 2 - m / 2 + d),
              "inside" !== t
                ? ((g = b.x1),
                  (h = b.x2),
                  0 > y
                    ? ((q =
                        n.point.x -
                        ("horizontal" === k ? J : J - r / 2) -
                        D -
                        c),
                      q < g &&
                        ((q =
                          "auto" === t ? Math.max(n.point.x, g) + D : g + D),
                        (z = q + J > n.point.x)))
                    : ((q =
                        n.point.x + ("horizontal" === k ? 0 : r / 2) + D + c),
                      q > h - J - D - c &&
                        ((q =
                          "auto" === t
                            ? Math.min(n.point.x, h) -
                              ("horizontal" === k ? J : J / 2) -
                              D
                            : h - J - D),
                        (z = q < n.point.x))))
                : ((g = Math.max(n.bounds.x1, b.x1)),
                  Math.min(n.bounds.x2, b.x2),
                  (c =
                    0 <= p.indexOf("range") || "error" === p
                      ? 0 > y
                        ? Math.max(n.bounds.x1, b.x1) + r / 2 + D
                        : Math.min(n.bounds.x2, b.x2) -
                          J / 2 -
                          D +
                          ("horizontal" === k ? 0 : r / 2)
                      : (Math.max(n.bounds.x1, b.x1) +
                          Math.min(n.bounds.x2, b.x2)) /
                          2 +
                        ("horizontal" === k ? 0 : r / 2)),
                  (q =
                    0 > y
                      ? Math.max(n.point.x, c) -
                        ("horizontal" === k ? J / 2 : 0)
                      : Math.min(n.point.x, c) - J / 2),
                  (q = Math.max(q, g)));
          "vertical" === k && (l += m - r / 2);
          qa.x = q;
          qa.y = l;
          qa.render(!0);
          A &&
            "inside" !== t &&
            ((0 > p.indexOf("bar") &&
              ("error" !== p || !n.axisSwapped) &&
              n.point.x > b.x1 &&
              n.point.x < b.x2) ||
              !z) &&
            ((0 > p.indexOf("column") &&
              ("error" !== p || n.axisSwapped) &&
              n.point.y > b.y1 &&
              n.point.y < b.y2) ||
              !z) &&
            ((e.lineWidth = A),
            (e.strokeStyle = w ? w : "gray"),
            e.setLineDash && e.setLineDash(N(ga, A)),
            e.beginPath(),
            e.moveTo(n.point.x, n.point.y),
            0 <= p.indexOf("bar") || ("error" === p && n.axisSwapped)
              ? e.lineTo(
                  q +
                    (0 < n.direction ? -D : J + D) +
                    ("vertical" === k ? -r / 2 : 0),
                  l + ("vertical" === k ? -m / 2 : m / 2 - r / 2) - d
                )
              : 0 <= p.indexOf("column") || ("error" === p && !n.axisSwapped)
              ? e.lineTo(
                  q + J / 2 - ("horizontal" === k ? 0 : r / 2),
                  l +
                    ("vertical" === k
                      ? (l - m < n.point.y ? 0 : -m) + d
                      : (l - r / 2 < n.point.y ? m : 0) - r / 2)
                )
              : e.lineTo(
                  q + J / 2 - ("horizontal" === k ? 0 : r / 2),
                  l +
                    ("vertical" === k
                      ? l - m < n.point.y
                        ? 0
                        : -m
                      : (l - r / 2 < n.point.y ? m : 0) - r / 2)
                ),
            e.stroke());
        }
      }
      e = {
        source: e,
        dest: this.plotArea.ctx,
        animationCallback: x.fadeInAnimation,
        easingFunction: x.easing.easeInQuad,
        animationBase: 0,
        startTimePercent: 0.7,
      };
      for (a = 0; a < this._indexLabels.length; a++)
        (n = this._indexLabels[a]),
          (qa = ra("indexLabelBackgroundColor", n.dataPoint, n.dataSeries)),
          (n.dataSeries.indexLabelBackgroundColor = f(qa)
            ? v
              ? "transparent"
              : null
            : qa);
      return e;
    };
    s.prototype.renderLine = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx;
        b.save();
        var g = this.plotArea;
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        for (var h = [], f, d = 0; d < a.dataSeriesIndexes.length; d++) {
          var J = a.dataSeriesIndexes[d],
            m = this.data[J];
          b.lineWidth = m.lineThickness;
          var n = m.dataPoints,
            p = "solid";
          if (b.setLineDash) {
            var q = N(m.nullDataLineDashType, m.lineThickness),
              p = m.lineDashType,
              l = N(p, m.lineThickness);
            b.setLineDash(l);
          }
          var r = m.id;
          this._eventManager.objectMap[r] = {
            objectType: "dataSeries",
            dataSeriesIndex: J,
          };
          r = O(r);
          c.strokeStyle = r;
          c.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;
          var r = m._colorSet,
            qa =
              (r =
              m.lineColor =
                m.options.lineColor ? m.options.lineColor : r[0]);
          b.strokeStyle = r;
          var ga = !0,
            w = 0,
            A,
            k;
          b.beginPath();
          if (0 < n.length) {
            for (var u = !1, w = 0; w < n.length; w++)
              if (
                ((A = n[w].x.getTime ? n[w].x.getTime() : n[w].x),
                !(
                  A < a.axisX.dataInfo.viewPortMin ||
                  (A > a.axisX.dataInfo.viewPortMax &&
                    (!m.connectNullData || !u))
                ))
              )
                if ("number" !== typeof n[w].y)
                  0 < w &&
                    !(m.connectNullData || u || ga) &&
                    (b.stroke(), v && c.stroke()),
                    (u = !0);
                else {
                  A = a.axisX.convertValueToPixel(A);
                  k = a.axisY.convertValueToPixel(n[w].y);
                  var s = m.dataPointIds[w];
                  this._eventManager.objectMap[s] = {
                    id: s,
                    objectType: "dataPoint",
                    dataSeriesIndex: J,
                    dataPointIndex: w,
                    x1: A,
                    y1: k,
                  };
                  ga || u
                    ? (!ga && m.connectNullData
                        ? (b.setLineDash &&
                            (m.options.nullDataLineDashType ||
                              (p === m.lineDashType &&
                                m.lineDashType !== m.nullDataLineDashType)) &&
                            (b.stroke(),
                            b.beginPath(),
                            b.moveTo(f.x, f.y),
                            (p = m.nullDataLineDashType),
                            b.setLineDash(q)),
                          b.lineTo(A, k),
                          v && c.lineTo(A, k))
                        : (b.beginPath(),
                          b.moveTo(A, k),
                          v && (c.beginPath(), c.moveTo(A, k))),
                      (u = ga = !1))
                    : (b.lineTo(A, k),
                      v && c.lineTo(A, k),
                      0 == w % 500 &&
                        (b.stroke(),
                        b.beginPath(),
                        b.moveTo(A, k),
                        v && (c.stroke(), c.beginPath(), c.moveTo(A, k))));
                  f = { x: A, y: k };
                  w < n.length - 1 &&
                    (qa !== (n[w].lineColor || r) ||
                      p !== (n[w].lineDashType || m.lineDashType)) &&
                    (b.stroke(),
                    b.beginPath(),
                    b.moveTo(A, k),
                    (qa = n[w].lineColor || r),
                    (b.strokeStyle = qa),
                    b.setLineDash &&
                      (n[w].lineDashType
                        ? ((p = n[w].lineDashType),
                          b.setLineDash(N(p, m.lineThickness)))
                        : ((p = m.lineDashType), b.setLineDash(l))));
                  if (0 < n[w].markerSize || 0 < m.markerSize) {
                    var C = m.getMarkerProperties(w, A, k, b);
                    h.push(C);
                    s = O(s);
                    v &&
                      h.push({
                        x: A,
                        y: k,
                        ctx: c,
                        type: C.type,
                        size: C.size,
                        color: s,
                        borderColor: s,
                        borderThickness: C.borderThickness,
                      });
                  }
                  (n[w].indexLabel ||
                    m.indexLabel ||
                    n[w].indexLabelFormatter ||
                    m.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "line",
                      dataPoint: n[w],
                      dataSeries: m,
                      point: { x: A, y: k },
                      direction: 0 > n[w].y === a.axisY.reversed ? 1 : -1,
                      color: r,
                    });
                }
            b.stroke();
            v && c.stroke();
          }
        }
        t.drawMarkers(h);
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          c.beginPath());
        b.restore();
        b.beginPath();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStepLine = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx;
        b.save();
        var g = this.plotArea;
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        for (var h = [], f, d = 0; d < a.dataSeriesIndexes.length; d++) {
          var J = a.dataSeriesIndexes[d],
            m = this.data[J];
          b.lineWidth = m.lineThickness;
          var n = m.dataPoints,
            p = "solid";
          if (b.setLineDash) {
            var q = N(m.nullDataLineDashType, m.lineThickness),
              p = m.lineDashType,
              l = N(p, m.lineThickness);
            b.setLineDash(l);
          }
          var r = m.id;
          this._eventManager.objectMap[r] = {
            objectType: "dataSeries",
            dataSeriesIndex: J,
          };
          r = O(r);
          c.strokeStyle = r;
          c.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;
          var r = m._colorSet,
            k =
              (r =
              m.lineColor =
                m.options.lineColor ? m.options.lineColor : r[0]);
          b.strokeStyle = r;
          var ga = !0,
            w = 0,
            A,
            u;
          b.beginPath();
          if (0 < n.length) {
            for (var s = !1, w = 0; w < n.length; w++)
              if (
                ((A = n[w].getTime ? n[w].x.getTime() : n[w].x),
                !(
                  A < a.axisX.dataInfo.viewPortMin ||
                  (A > a.axisX.dataInfo.viewPortMax &&
                    (!m.connectNullData || !s))
                ))
              )
                if ("number" !== typeof n[w].y)
                  0 < w &&
                    !(m.connectNullData || s || ga) &&
                    (b.stroke(), v && c.stroke()),
                    (s = !0);
                else {
                  var E = u;
                  A = a.axisX.convertValueToPixel(A);
                  u = a.axisY.convertValueToPixel(n[w].y);
                  var C = m.dataPointIds[w];
                  this._eventManager.objectMap[C] = {
                    id: C,
                    objectType: "dataPoint",
                    dataSeriesIndex: J,
                    dataPointIndex: w,
                    x1: A,
                    y1: u,
                  };
                  ga || s
                    ? (!ga && m.connectNullData
                        ? (b.setLineDash &&
                            (m.options.nullDataLineDashType ||
                              (p === m.lineDashType &&
                                m.lineDashType !== m.nullDataLineDashType)) &&
                            (b.stroke(),
                            b.beginPath(),
                            b.moveTo(f.x, f.y),
                            (p = m.nullDataLineDashType),
                            b.setLineDash(q)),
                          b.lineTo(A, E),
                          b.lineTo(A, u),
                          v && (c.lineTo(A, E), c.lineTo(A, u)))
                        : (b.beginPath(),
                          b.moveTo(A, u),
                          v && (c.beginPath(), c.moveTo(A, u))),
                      (s = ga = !1))
                    : (b.lineTo(A, E),
                      v && c.lineTo(A, E),
                      b.lineTo(A, u),
                      v && c.lineTo(A, u),
                      0 == w % 500 &&
                        (b.stroke(),
                        b.beginPath(),
                        b.moveTo(A, u),
                        v && (c.stroke(), c.beginPath(), c.moveTo(A, u))));
                  f = { x: A, y: u };
                  w < n.length - 1 &&
                    (k !== (n[w].lineColor || r) ||
                      p !== (n[w].lineDashType || m.lineDashType)) &&
                    (b.stroke(),
                    b.beginPath(),
                    b.moveTo(A, u),
                    (k = n[w].lineColor || r),
                    (b.strokeStyle = k),
                    b.setLineDash &&
                      (n[w].lineDashType
                        ? ((p = n[w].lineDashType),
                          b.setLineDash(N(p, m.lineThickness)))
                        : ((p = m.lineDashType), b.setLineDash(l))));
                  if (0 < n[w].markerSize || 0 < m.markerSize)
                    (E = m.getMarkerProperties(w, A, u, b)),
                      h.push(E),
                      (C = O(C)),
                      v &&
                        h.push({
                          x: A,
                          y: u,
                          ctx: c,
                          type: E.type,
                          size: E.size,
                          color: C,
                          borderColor: C,
                          borderThickness: E.borderThickness,
                        });
                  (n[w].indexLabel ||
                    m.indexLabel ||
                    n[w].indexLabelFormatter ||
                    m.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stepLine",
                      dataPoint: n[w],
                      dataSeries: m,
                      point: { x: A, y: u },
                      direction: 0 > n[w].y === a.axisY.reversed ? 1 : -1,
                      color: r,
                    });
                }
            b.stroke();
            v && c.stroke();
          }
        }
        t.drawMarkers(h);
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          c.beginPath());
        b.restore();
        b.beginPath();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderSpline = function (a) {
      function e(a) {
        a = F(a, 2);
        if (0 < a.length) {
          c.beginPath();
          v && g.beginPath();
          c.moveTo(a[0].x, a[0].y);
          a[0].newStrokeStyle && (c.strokeStyle = a[0].newStrokeStyle);
          a[0].newLineDashArray && c.setLineDash(a[0].newLineDashArray);
          v && g.moveTo(a[0].x, a[0].y);
          for (var b = 0; b < a.length - 3; b += 3)
            if (
              (c.bezierCurveTo(
                a[b + 1].x,
                a[b + 1].y,
                a[b + 2].x,
                a[b + 2].y,
                a[b + 3].x,
                a[b + 3].y
              ),
              v &&
                g.bezierCurveTo(
                  a[b + 1].x,
                  a[b + 1].y,
                  a[b + 2].x,
                  a[b + 2].y,
                  a[b + 3].x,
                  a[b + 3].y
                ),
              (0 < b && 0 === b % 3e3) ||
                a[b + 3].newStrokeStyle ||
                a[b + 3].newLineDashArray)
            )
              c.stroke(),
                c.beginPath(),
                c.moveTo(a[b + 3].x, a[b + 3].y),
                a[b + 3].newStrokeStyle &&
                  (c.strokeStyle = a[b + 3].newStrokeStyle),
                a[b + 3].newLineDashArray &&
                  c.setLineDash(a[b + 3].newLineDashArray),
                v &&
                  (g.stroke(), g.beginPath(), g.moveTo(a[b + 3].x, a[b + 3].y));
          c.stroke();
          v && g.stroke();
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = this._eventManager.ghostCtx;
        c.save();
        var h = this.plotArea;
        c.beginPath();
        c.rect(h.x1, h.y1, h.width, h.height);
        c.clip();
        for (var f = [], d = 0; d < a.dataSeriesIndexes.length; d++) {
          var J = a.dataSeriesIndexes[d],
            m = this.data[J];
          c.lineWidth = m.lineThickness;
          var n = m.dataPoints,
            p = "solid";
          if (c.setLineDash) {
            var q = N(m.nullDataLineDashType, m.lineThickness),
              p = m.lineDashType,
              l = N(p, m.lineThickness);
            c.setLineDash(l);
          }
          var r = m.id;
          this._eventManager.objectMap[r] = {
            objectType: "dataSeries",
            dataSeriesIndex: J,
          };
          r = O(r);
          g.strokeStyle = r;
          g.lineWidth = 0 < m.lineThickness ? Math.max(m.lineThickness, 4) : 0;
          var r = m._colorSet,
            k =
              (r =
              m.lineColor =
                m.options.lineColor ? m.options.lineColor : r[0]);
          c.strokeStyle = r;
          var ga = 0,
            w,
            A,
            u = [];
          c.beginPath();
          if (0 < n.length)
            for (A = !1, ga = 0; ga < n.length; ga++)
              if (
                ((w = n[ga].getTime ? n[ga].x.getTime() : n[ga].x),
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  (w > a.axisX.dataInfo.viewPortMax &&
                    (!m.connectNullData || !A))
                ))
              )
                if ("number" !== typeof n[ga].y)
                  0 < ga &&
                    !A &&
                    (m.connectNullData
                      ? c.setLineDash &&
                        0 < u.length &&
                        (m.options.nullDataLineDashType ||
                          !n[ga - 1].lineDashType) &&
                        ((u[u.length - 1].newLineDashArray = q),
                        (p = m.nullDataLineDashType))
                      : (e(u), (u = []))),
                    (A = !0);
                else {
                  w = a.axisX.convertValueToPixel(w);
                  A = a.axisY.convertValueToPixel(n[ga].y);
                  var s = m.dataPointIds[ga];
                  this._eventManager.objectMap[s] = {
                    id: s,
                    objectType: "dataPoint",
                    dataSeriesIndex: J,
                    dataPointIndex: ga,
                    x1: w,
                    y1: A,
                  };
                  u[u.length] = { x: w, y: A };
                  ga < n.length - 1 &&
                    (k !== (n[ga].lineColor || r) ||
                      p !== (n[ga].lineDashType || m.lineDashType)) &&
                    ((k = n[ga].lineColor || r),
                    (u[u.length - 1].newStrokeStyle = k),
                    c.setLineDash &&
                      (n[ga].lineDashType
                        ? ((p = n[ga].lineDashType),
                          (u[u.length - 1].newLineDashArray = N(
                            p,
                            m.lineThickness
                          )))
                        : ((p = m.lineDashType),
                          (u[u.length - 1].newLineDashArray = l))));
                  if (0 < n[ga].markerSize || 0 < m.markerSize) {
                    var E = m.getMarkerProperties(ga, w, A, c);
                    f.push(E);
                    s = O(s);
                    v &&
                      f.push({
                        x: w,
                        y: A,
                        ctx: g,
                        type: E.type,
                        size: E.size,
                        color: s,
                        borderColor: s,
                        borderThickness: E.borderThickness,
                      });
                  }
                  (n[ga].indexLabel ||
                    m.indexLabel ||
                    n[ga].indexLabelFormatter ||
                    m.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "spline",
                      dataPoint: n[ga],
                      dataSeries: m,
                      point: { x: w, y: A },
                      direction: 0 > n[ga].y === a.axisY.reversed ? 1 : -1,
                      color: r,
                    });
                  A = !1;
                }
          e(u);
        }
        t.drawMarkers(f);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(h.x1, h.y1, h.width, h.height),
          g.beginPath());
        c.restore();
        c.beginPath();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderColumn = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = 0,
          f,
          d,
          J,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          h = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1,
          n = this.options.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : Math.min(
                0.15 * this.width,
                0.9 * (this.plotArea.width / a.plotType.totalDataSeries)
              ) << 0,
          p = a.axisX.dataInfo.minDiff;
        isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
        p = this.dataPointWidth = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.width *
                (a.axisX.logarithmic
                  ? Math.log(p) / Math.log(a.axisX.range)
                  : Math.abs(p) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          h > n &&
          (h = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            n
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          n < h &&
          (n = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            h
          ));
        p < h && (p = h);
        p > n && (p = n);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (n = 0; n < a.dataSeriesIndexes.length; n++) {
          var q = a.dataSeriesIndexes[n],
            l = this.data[q],
            r = l.dataPoints;
          if (0 < r.length)
            for (
              var k = 5 < p && l.bevelEnabled ? !0 : !1, h = 0;
              h < r.length;
              h++
            )
              if (
                (r[h].getTime ? (J = r[h].x.getTime()) : (J = r[h].x),
                !(
                  J < a.axisX.dataInfo.viewPortMin ||
                  J > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof r[h].y)
              ) {
                f = a.axisX.convertValueToPixel(J);
                d = a.axisY.convertValueToPixel(r[h].y);
                f = a.axisX.reversed
                  ? (f +
                      (a.plotType.totalDataSeries * p) / 2 -
                      (a.previousDataSeriesCount + n) * p) <<
                    0
                  : (f -
                      (a.plotType.totalDataSeries * p) / 2 +
                      (a.previousDataSeriesCount + n) * p) <<
                    0;
                var t = a.axisX.reversed ? (f - p) << 0 : (f + p) << 0,
                  w;
                0 <= r[h].y ? (w = m) : ((w = d), (d = m));
                d > w && ((c = d), (d = w), (w = c));
                c = r[h].color
                  ? r[h].color
                  : l._colorSet[h % l._colorSet.length];
                fa(
                  b,
                  f,
                  d,
                  t,
                  w,
                  c,
                  0,
                  null,
                  k && 0 <= r[h].y,
                  0 > r[h].y && k,
                  !1,
                  !1,
                  l.fillOpacity
                );
                c = l.dataPointIds[h];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: q,
                  dataPointIndex: h,
                  x1: f,
                  y1: d,
                  x2: t,
                  y2: w,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    f,
                    d,
                    t,
                    w,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (r[h].indexLabel ||
                  l.indexLabel ||
                  r[h].indexLabelFormatter ||
                  l.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "column",
                    dataPoint: r[h],
                    dataSeries: l,
                    point: {
                      x: f + (t - f) / 2,
                      y: 0 > r[h].y === a.axisY.reversed ? d : w,
                    },
                    direction: 0 > r[h].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: f,
                      y1: Math.min(d, w),
                      x2: t,
                      y2: Math.max(d, w),
                    },
                    color: c,
                  });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.yScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : m > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : m,
        };
      }
    };
    s.prototype.renderStackedColumn = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = [],
          f = [],
          d = [],
          J = [],
          m = 0,
          n,
          p,
          q = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          m = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        n = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.width) << 0;
        var l = a.axisX.dataInfo.minDiff;
        isFinite(l) || (l = 0.3 * Math.abs(a.axisX.range));
        l = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.width *
                (a.axisX.logarithmic
                  ? Math.log(l) / Math.log(a.axisX.range)
                  : Math.abs(l) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          m > n &&
          (m = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            n
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          n < m &&
          (n = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            m
          ));
        l < m && (l = m);
        l > n && (l = n);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var r = 0; r < a.dataSeriesIndexes.length; r++) {
          var k = a.dataSeriesIndexes[r],
            t = this.data[k],
            w = t.dataPoints;
          if (0 < w.length) {
            var A = 5 < l && t.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (m = 0; m < w.length; m++)
              if (
                ((c = w[m].x.getTime ? w[m].x.getTime() : w[m].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[m].y)
              ) {
                n = a.axisX.convertValueToPixel(c);
                var u =
                    (n - (a.plotType.plotUnits.length * l) / 2 + a.index * l) <<
                    0,
                  s = (u + l) << 0,
                  E;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < w[m].y)
                )
                  (d[c] = w[m].y + (d[c] ? d[c] : 0)),
                    0 < d[c] &&
                      ((p = a.axisY.convertValueToPixel(d[c])),
                      (E = "undefined" !== typeof h[c] ? h[c] : q),
                      (h[c] = p));
                else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= w[m].y
                )
                  (J[c] = w[m].y + (J[c] ? J[c] : 0)),
                    (E = a.axisY.convertValueToPixel(J[c])),
                    (p = "undefined" !== typeof f[c] ? f[c] : q),
                    (f[c] = E);
                else if (
                  ((p = a.axisY.convertValueToPixel(w[m].y)), 0 <= w[m].y)
                ) {
                  var C = "undefined" !== typeof h[c] ? h[c] : 0;
                  p -= C;
                  E = q - C;
                  h[c] = C + (E - p);
                } else
                  (C = f[c] ? f[c] : 0),
                    (E = p + C),
                    (p = q + C),
                    (f[c] = C + (E - p));
                c = w[m].color
                  ? w[m].color
                  : t._colorSet[m % t._colorSet.length];
                fa(
                  b,
                  u,
                  p,
                  s,
                  E,
                  c,
                  0,
                  null,
                  A && 0 <= w[m].y,
                  0 > w[m].y && A,
                  !1,
                  !1,
                  t.fillOpacity
                );
                c = t.dataPointIds[m];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: k,
                  dataPointIndex: m,
                  x1: u,
                  y1: p,
                  x2: s,
                  y2: E,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    u,
                    p,
                    s,
                    E,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[m].indexLabel ||
                  t.indexLabel ||
                  w[m].indexLabelFormatter ||
                  t.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedColumn",
                    dataPoint: w[m],
                    dataSeries: t,
                    point: { x: n, y: 0 <= w[m].y ? p : E },
                    direction: 0 > w[m].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: u,
                      y1: Math.min(p, E),
                      x2: s,
                      y2: Math.max(p, E),
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.yScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            q < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : q > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : q,
        };
      }
    };
    s.prototype.renderStackedColumn100 = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = [],
          f = [],
          d = [],
          J = [],
          m = 0,
          n,
          p,
          q = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          m = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        n = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.width) << 0;
        var l = a.axisX.dataInfo.minDiff;
        isFinite(l) || (l = 0.3 * Math.abs(a.axisX.range));
        l = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.width *
                (a.axisX.logarithmic
                  ? Math.log(l) / Math.log(a.axisX.range)
                  : Math.abs(l) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          m > n &&
          (m = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            n
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          n < m &&
          (n = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            m
          ));
        l < m && (l = m);
        l > n && (l = n);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var r = 0; r < a.dataSeriesIndexes.length; r++) {
          var t = a.dataSeriesIndexes[r],
            k = this.data[t],
            w = k.dataPoints;
          if (0 < w.length)
            for (
              var A = 5 < l && k.bevelEnabled ? !0 : !1, m = 0;
              m < w.length;
              m++
            )
              if (
                ((c = w[m].x.getTime ? w[m].x.getTime() : w[m].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[m].y)
              ) {
                n = a.axisX.convertValueToPixel(c);
                p =
                  0 !== a.dataPointYSums[c]
                    ? 100 * (w[m].y / a.dataPointYSums[c])
                    : 0;
                var u =
                    (n - (a.plotType.plotUnits.length * l) / 2 + a.index * l) <<
                    0,
                  s = (u + l) << 0,
                  E;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < w[m].y)
                ) {
                  d[c] = p + ("undefined" !== typeof d[c] ? d[c] : 0);
                  if (0 >= d[c]) continue;
                  p = a.axisY.convertValueToPixel(d[c]);
                  E = h[c] ? h[c] : q;
                  h[c] = p;
                } else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= w[m].y
                )
                  (J[c] = p + ("undefined" !== typeof J[c] ? J[c] : 0)),
                    (E = a.axisY.convertValueToPixel(J[c])),
                    (p = f[c] ? f[c] : q),
                    (f[c] = E);
                else if (((p = a.axisY.convertValueToPixel(p)), 0 <= w[m].y)) {
                  var C = "undefined" !== typeof h[c] ? h[c] : 0;
                  p -= C;
                  E = q - C;
                  a.dataSeriesIndexes.length - 1 === r &&
                    1 >= Math.abs(g.y1 - p) &&
                    (p = g.y1);
                  h[c] = C + (E - p);
                } else
                  (C = "undefined" !== typeof f[c] ? f[c] : 0),
                    (E = p + C),
                    (p = q + C),
                    a.dataSeriesIndexes.length - 1 === r &&
                      1 >= Math.abs(g.y2 - E) &&
                      (E = g.y2),
                    (f[c] = C + (E - p));
                c = w[m].color
                  ? w[m].color
                  : k._colorSet[m % k._colorSet.length];
                fa(
                  b,
                  u,
                  p,
                  s,
                  E,
                  c,
                  0,
                  null,
                  A && 0 <= w[m].y,
                  0 > w[m].y && A,
                  !1,
                  !1,
                  k.fillOpacity
                );
                c = k.dataPointIds[m];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: t,
                  dataPointIndex: m,
                  x1: u,
                  y1: p,
                  x2: s,
                  y2: E,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    u,
                    p,
                    s,
                    E,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[m].indexLabel ||
                  k.indexLabel ||
                  w[m].indexLabelFormatter ||
                  k.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedColumn100",
                    dataPoint: w[m],
                    dataSeries: k,
                    point: { x: n, y: 0 <= w[m].y ? p : E },
                    direction: 0 > w[m].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: u,
                      y1: Math.min(p, E),
                      x2: s,
                      y2: Math.max(p, E),
                    },
                    color: c,
                  });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.yScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            q < a.axisY.bounds.y1
              ? a.axisY.bounds.y1
              : q > a.axisY.bounds.y2
              ? a.axisY.bounds.y2
              : q,
        };
      }
    };
    s.prototype.renderBar = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = 0,
          f,
          d,
          J,
          m = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          h = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1,
          n = this.options.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : Math.min(
                0.15 * this.height,
                0.9 * (this.plotArea.height / a.plotType.totalDataSeries)
              ) << 0,
          p = a.axisX.dataInfo.minDiff;
        isFinite(p) || (p = 0.3 * Math.abs(a.axisX.range));
        p = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.height *
                (a.axisX.logarithmic
                  ? Math.log(p) / Math.log(a.axisX.range)
                  : Math.abs(p) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          h > n &&
          (h = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            n
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          n < h &&
          (n = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            h
          ));
        p < h && (p = h);
        p > n && (p = n);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (n = 0; n < a.dataSeriesIndexes.length; n++) {
          var q = a.dataSeriesIndexes[n],
            l = this.data[q],
            r = l.dataPoints;
          if (0 < r.length) {
            var k = 5 < p && l.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (h = 0; h < r.length; h++)
              if (
                (r[h].getTime ? (J = r[h].x.getTime()) : (J = r[h].x),
                !(
                  J < a.axisX.dataInfo.viewPortMin ||
                  J > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof r[h].y)
              ) {
                d = a.axisX.convertValueToPixel(J);
                f = a.axisY.convertValueToPixel(r[h].y);
                d = a.axisX.reversed
                  ? (d +
                      (a.plotType.totalDataSeries * p) / 2 -
                      (a.previousDataSeriesCount + n) * p) <<
                    0
                  : (d -
                      (a.plotType.totalDataSeries * p) / 2 +
                      (a.previousDataSeriesCount + n) * p) <<
                    0;
                var t = a.axisX.reversed ? (d - p) << 0 : (d + p) << 0,
                  w;
                0 <= r[h].y ? (w = m) : ((w = f), (f = m));
                c = r[h].color
                  ? r[h].color
                  : l._colorSet[h % l._colorSet.length];
                fa(b, w, d, f, t, c, 0, null, k, !1, !1, !1, l.fillOpacity);
                c = l.dataPointIds[h];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: q,
                  dataPointIndex: h,
                  x1: w,
                  y1: d,
                  x2: f,
                  y2: t,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    w,
                    d,
                    f,
                    t,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (r[h].indexLabel ||
                  l.indexLabel ||
                  r[h].indexLabelFormatter ||
                  l.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "bar",
                    dataPoint: r[h],
                    dataSeries: l,
                    point: { x: 0 <= r[h].y ? f : w, y: d + (t - d) / 2 },
                    direction: 0 > r[h].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(w, f),
                      y1: d,
                      x2: Math.max(w, f),
                      y2: t,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.xScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            m < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : m > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : m,
        };
      }
    };
    s.prototype.renderStackedBar = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = [],
          f = [],
          d = [],
          J = [],
          m = 0,
          n,
          p,
          q = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          m = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        p = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.height) << 0;
        var l = a.axisX.dataInfo.minDiff;
        isFinite(l) || (l = 0.3 * Math.abs(a.axisX.range));
        l = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.height *
                (a.axisX.logarithmic
                  ? Math.log(l) / Math.log(a.axisX.range)
                  : Math.abs(l) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          m > p &&
          (m = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            p
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          p < m &&
          (p = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            m
          ));
        l < m && (l = m);
        l > p && (l = p);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var r = 0; r < a.dataSeriesIndexes.length; r++) {
          var t = a.dataSeriesIndexes[r],
            k = this.data[t],
            w = k.dataPoints;
          if (0 < w.length) {
            var A = 5 < l && k.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (m = 0; m < w.length; m++)
              if (
                ((c = w[m].x.getTime ? w[m].x.getTime() : w[m].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[m].y)
              ) {
                p = a.axisX.convertValueToPixel(c);
                var u =
                    (p - (a.plotType.plotUnits.length * l) / 2 + a.index * l) <<
                    0,
                  s = (u + l) << 0,
                  E;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < w[m].y)
                )
                  (d[c] = w[m].y + (d[c] ? d[c] : 0)),
                    0 < d[c] &&
                      ((E = h[c] ? h[c] : q),
                      (h[c] = n = a.axisY.convertValueToPixel(d[c])));
                else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= w[m].y
                )
                  (J[c] = w[m].y + (J[c] ? J[c] : 0)),
                    (n = f[c] ? f[c] : q),
                    (f[c] = E = a.axisY.convertValueToPixel(J[c]));
                else if (
                  ((n = a.axisY.convertValueToPixel(w[m].y)), 0 <= w[m].y)
                ) {
                  var C = h[c] ? h[c] : 0;
                  E = q + C;
                  n += C;
                  h[c] = C + (n - E);
                } else
                  (C = f[c] ? f[c] : 0),
                    (E = n - C),
                    (n = q - C),
                    (f[c] = C + (n - E));
                c = w[m].color
                  ? w[m].color
                  : k._colorSet[m % k._colorSet.length];
                fa(b, E, u, n, s, c, 0, null, A, !1, !1, !1, k.fillOpacity);
                c = k.dataPointIds[m];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: t,
                  dataPointIndex: m,
                  x1: E,
                  y1: u,
                  x2: n,
                  y2: s,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    E,
                    u,
                    n,
                    s,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[m].indexLabel ||
                  k.indexLabel ||
                  w[m].indexLabelFormatter ||
                  k.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedBar",
                    dataPoint: w[m],
                    dataSeries: k,
                    point: { x: 0 <= w[m].y ? n : E, y: p },
                    direction: 0 > w[m].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(E, n),
                      y1: u,
                      x2: Math.max(E, n),
                      y2: s,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.xScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            q < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : q > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : q,
        };
      }
    };
    s.prototype.renderStackedBar100 = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = [],
          f = [],
          d = [],
          J = [],
          m = 0,
          n,
          p,
          q = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          m = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        p = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.15 * this.height) << 0;
        var l = a.axisX.dataInfo.minDiff;
        isFinite(l) || (l = 0.3 * Math.abs(a.axisX.range));
        l = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.height *
                (a.axisX.logarithmic
                  ? Math.log(l) / Math.log(a.axisX.range)
                  : Math.abs(l) / Math.abs(a.axisX.range))) /
                a.plotType.plotUnits.length)) <<
            0;
        this.dataPointMaxWidth &&
          m > p &&
          (m = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            p
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          p < m &&
          (p = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            m
          ));
        l < m && (l = m);
        l > p && (l = p);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var r = 0; r < a.dataSeriesIndexes.length; r++) {
          var k = a.dataSeriesIndexes[r],
            t = this.data[k],
            w = t.dataPoints;
          if (0 < w.length) {
            var A = 5 < l && t.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (m = 0; m < w.length; m++)
              if (
                ((c = w[m].x.getTime ? w[m].x.getTime() : w[m].x),
                !(
                  c < a.axisX.dataInfo.viewPortMin ||
                  c > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof w[m].y)
              ) {
                p = a.axisX.convertValueToPixel(c);
                var u;
                u =
                  0 !== a.dataPointYSums[c]
                    ? 100 * (w[m].y / a.dataPointYSums[c])
                    : 0;
                var s =
                    (p - (a.plotType.plotUnits.length * l) / 2 + a.index * l) <<
                    0,
                  E = (s + l) << 0;
                if (
                  a.axisY.logarithmic ||
                  (a.axisY.scaleBreaks &&
                    0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                    0 < w[m].y)
                ) {
                  d[c] = u + (d[c] ? d[c] : 0);
                  if (0 >= d[c]) continue;
                  u = h[c] ? h[c] : q;
                  h[c] = n = a.axisY.convertValueToPixel(d[c]);
                } else if (
                  a.axisY.scaleBreaks &&
                  0 < a.axisY.scaleBreaks._appliedBreaks.length &&
                  0 >= w[m].y
                )
                  (J[c] = u + (J[c] ? J[c] : 0)),
                    (n = f[c] ? f[c] : q),
                    (f[c] = u = a.axisY.convertValueToPixel(J[c]));
                else if (((n = a.axisY.convertValueToPixel(u)), 0 <= w[m].y)) {
                  var C = h[c] ? h[c] : 0;
                  u = q + C;
                  n += C;
                  a.dataSeriesIndexes.length - 1 === r &&
                    1 >= Math.abs(g.x2 - n) &&
                    (n = g.x2);
                  h[c] = C + (n - u);
                } else
                  (C = f[c] ? f[c] : 0),
                    (u = n - C),
                    (n = q - C),
                    a.dataSeriesIndexes.length - 1 === r &&
                      1 >= Math.abs(g.x1 - u) &&
                      (u = g.x1),
                    (f[c] = C + (n - u));
                c = w[m].color
                  ? w[m].color
                  : t._colorSet[m % t._colorSet.length];
                fa(b, u, s, n, E, c, 0, null, A, !1, !1, !1, t.fillOpacity);
                c = t.dataPointIds[m];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: k,
                  dataPointIndex: m,
                  x1: u,
                  y1: s,
                  x2: n,
                  y2: E,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    u,
                    s,
                    n,
                    E,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                (w[m].indexLabel ||
                  t.indexLabel ||
                  w[m].indexLabelFormatter ||
                  t.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "stackedBar100",
                    dataPoint: w[m],
                    dataSeries: t,
                    point: { x: 0 <= w[m].y ? n : u, y: p },
                    direction: 0 > w[m].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: Math.min(u, n),
                      y1: s,
                      x2: Math.max(u, n),
                      y2: E,
                    },
                    color: c,
                  });
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.xScaleAnimation,
          easingFunction: x.easing.easeOutQuart,
          animationBase:
            q < a.axisY.bounds.x1
              ? a.axisY.bounds.x1
              : q > a.axisY.bounds.x2
              ? a.axisY.bounds.x2
              : q,
        };
      }
    };
    s.prototype.renderArea = function (a) {
      var e, b;
      function c() {
        E &&
          (0 < l.lineThickness && h.stroke(),
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (ca = s)
            : 0 > a.axisY.viewportMaximum
            ? (ca = d.y1)
            : 0 < a.axisY.viewportMinimum && (ca = s),
          h.lineTo(u, ca),
          h.lineTo(E.x, ca),
          h.closePath(),
          (h.globalAlpha = l.fillOpacity),
          h.fill(),
          (h.globalAlpha = 1),
          v && (f.lineTo(u, ca), f.lineTo(E.x, ca), f.closePath(), f.fill()),
          h.beginPath(),
          h.moveTo(u, w),
          f.beginPath(),
          f.moveTo(u, w),
          (E = { x: u, y: w }));
      }
      var g = a.targetCanvasCtx || this.plotArea.ctx,
        h = v ? this._preRenderCtx : g;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var f = this._eventManager.ghostCtx,
          d = a.axisY.lineCoordinates,
          J = [],
          m = this.plotArea,
          n;
        h.save();
        v && f.save();
        h.beginPath();
        h.rect(m.x1, m.y1, m.width, m.height);
        h.clip();
        v && (f.beginPath(), f.rect(m.x1, m.y1, m.width, m.height), f.clip());
        for (var p = 0; p < a.dataSeriesIndexes.length; p++) {
          var q = a.dataSeriesIndexes[p],
            l = this.data[q],
            r = l.dataPoints,
            J = l.id;
          this._eventManager.objectMap[J] = {
            objectType: "dataSeries",
            dataSeriesIndex: q,
          };
          J = O(J);
          f.fillStyle = J;
          J = [];
          e = !0;
          var k = 0,
            u,
            w,
            A,
            s = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            ca,
            E = null;
          if (0 < r.length) {
            var C = l._colorSet[k % l._colorSet.length],
              y = (l.lineColor = l.options.lineColor || C),
              z = y;
            h.fillStyle = C;
            h.strokeStyle = y;
            h.lineWidth = l.lineThickness;
            b = "solid";
            if (h.setLineDash) {
              var R = N(l.nullDataLineDashType, l.lineThickness);
              b = l.lineDashType;
              var da = N(b, l.lineThickness);
              h.setLineDash(da);
            }
            for (var ja = !0; k < r.length; k++)
              if (
                ((A = r[k].x.getTime ? r[k].x.getTime() : r[k].x),
                !(
                  A < a.axisX.dataInfo.viewPortMin ||
                  (A > a.axisX.dataInfo.viewPortMax &&
                    (!l.connectNullData || !ja))
                ))
              )
                if ("number" !== typeof r[k].y)
                  l.connectNullData || ja || e || c(), (ja = !0);
                else {
                  u = a.axisX.convertValueToPixel(A);
                  w = a.axisY.convertValueToPixel(r[k].y);
                  e || ja
                    ? (!e && l.connectNullData
                        ? (h.setLineDash &&
                            (l.options.nullDataLineDashType ||
                              (b === l.lineDashType &&
                                l.lineDashType !== l.nullDataLineDashType)) &&
                            ((e = u),
                            (b = w),
                            (u = n.x),
                            (w = n.y),
                            c(),
                            h.moveTo(n.x, n.y),
                            (u = e),
                            (w = b),
                            (E = n),
                            (b = l.nullDataLineDashType),
                            h.setLineDash(R)),
                          h.lineTo(u, w),
                          v && f.lineTo(u, w))
                        : (h.beginPath(),
                          h.moveTo(u, w),
                          v && (f.beginPath(), f.moveTo(u, w)),
                          (E = { x: u, y: w })),
                      (ja = e = !1))
                    : (h.lineTo(u, w),
                      v && f.lineTo(u, w),
                      0 == k % 250 && c());
                  n = { x: u, y: w };
                  k < r.length - 1 &&
                    (z !== (r[k].lineColor || y) ||
                      b !== (r[k].lineDashType || l.lineDashType)) &&
                    (c(),
                    (z = r[k].lineColor || y),
                    (h.strokeStyle = z),
                    h.setLineDash &&
                      (r[k].lineDashType
                        ? ((b = r[k].lineDashType),
                          h.setLineDash(N(b, l.lineThickness)))
                        : ((b = l.lineDashType), h.setLineDash(da))));
                  var ba = l.dataPointIds[k];
                  this._eventManager.objectMap[ba] = {
                    id: ba,
                    objectType: "dataPoint",
                    dataSeriesIndex: q,
                    dataPointIndex: k,
                    x1: u,
                    y1: w,
                  };
                  0 !== r[k].markerSize &&
                    (0 < r[k].markerSize || 0 < l.markerSize) &&
                    ((A = l.getMarkerProperties(k, u, w, h)),
                    J.push(A),
                    (ba = O(ba)),
                    v &&
                      J.push({
                        x: u,
                        y: w,
                        ctx: f,
                        type: A.type,
                        size: A.size,
                        color: ba,
                        borderColor: ba,
                        borderThickness: A.borderThickness,
                      }));
                  (r[k].indexLabel ||
                    l.indexLabel ||
                    r[k].indexLabelFormatter ||
                    l.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "area",
                      dataPoint: r[k],
                      dataSeries: l,
                      point: { x: u, y: w },
                      direction: 0 > r[k].y === a.axisY.reversed ? 1 : -1,
                      color: C,
                    });
                }
            c();
            t.drawMarkers(J);
          }
        }
        v &&
          (g.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (h.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            h.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            h.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          h.clearRect(m.x1, m.y1, m.width, m.height),
          this._eventManager.ghostCtx.restore());
        h.restore();
        return {
          source: g,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderSplineArea = function (a) {
      function e() {
        var b = F(A, 2);
        if (0 < b.length) {
          if (0 < n.lineThickness) {
            c.beginPath();
            c.moveTo(b[0].x, b[0].y);
            b[0].newStrokeStyle && (c.strokeStyle = b[0].newStrokeStyle);
            b[0].newLineDashArray && c.setLineDash(b[0].newLineDashArray);
            for (var e = 0; e < b.length - 3; e += 3)
              if (
                (c.bezierCurveTo(
                  b[e + 1].x,
                  b[e + 1].y,
                  b[e + 2].x,
                  b[e + 2].y,
                  b[e + 3].x,
                  b[e + 3].y
                ),
                v &&
                  g.bezierCurveTo(
                    b[e + 1].x,
                    b[e + 1].y,
                    b[e + 2].x,
                    b[e + 2].y,
                    b[e + 3].x,
                    b[e + 3].y
                  ),
                b[e + 3].newStrokeStyle || b[e + 3].newLineDashArray)
              )
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(b[e + 3].x, b[e + 3].y),
                  b[e + 3].newStrokeStyle &&
                    (c.strokeStyle = b[e + 3].newStrokeStyle),
                  b[e + 3].newLineDashArray &&
                    c.setLineDash(b[e + 3].newLineDashArray);
            c.stroke();
          }
          c.beginPath();
          c.moveTo(b[0].x, b[0].y);
          v && (g.beginPath(), g.moveTo(b[0].x, b[0].y));
          for (e = 0; e < b.length - 3; e += 3)
            c.bezierCurveTo(
              b[e + 1].x,
              b[e + 1].y,
              b[e + 2].x,
              b[e + 2].y,
              b[e + 3].x,
              b[e + 3].y
            ),
              v &&
                g.bezierCurveTo(
                  b[e + 1].x,
                  b[e + 1].y,
                  b[e + 2].x,
                  b[e + 2].y,
                  b[e + 3].x,
                  b[e + 3].y
                );
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (u = k)
            : 0 > a.axisY.viewportMaximum
            ? (u = h.y1)
            : 0 < a.axisY.viewportMinimum && (u = k);
          w = { x: b[0].x, y: b[0].y };
          c.lineTo(b[b.length - 1].x, u);
          c.lineTo(w.x, u);
          c.closePath();
          c.globalAlpha = n.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          v &&
            (g.lineTo(b[b.length - 1].x, u),
            g.lineTo(w.x, u),
            g.closePath(),
            g.fill());
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = this._eventManager.ghostCtx,
          h = a.axisY.lineCoordinates,
          f = [],
          d = this.plotArea;
        c.save();
        v && g.save();
        c.beginPath();
        c.rect(d.x1, d.y1, d.width, d.height);
        c.clip();
        v && (g.beginPath(), g.rect(d.x1, d.y1, d.width, d.height), g.clip());
        for (var J = 0; J < a.dataSeriesIndexes.length; J++) {
          var m = a.dataSeriesIndexes[J],
            n = this.data[m],
            p = n.dataPoints,
            f = n.id;
          this._eventManager.objectMap[f] = {
            objectType: "dataSeries",
            dataSeriesIndex: m,
          };
          f = O(f);
          g.fillStyle = f;
          var f = [],
            q = 0,
            l,
            r,
            k = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            u,
            w = null,
            A = [];
          if (0 < p.length) {
            var s = n._colorSet[q % n._colorSet.length],
              ca = (n.lineColor = n.options.lineColor || s),
              E = ca;
            c.fillStyle = s;
            c.strokeStyle = ca;
            c.lineWidth = n.lineThickness;
            var C = "solid";
            if (c.setLineDash) {
              var y = N(n.nullDataLineDashType, n.lineThickness),
                C = n.lineDashType,
                z = N(C, n.lineThickness);
              c.setLineDash(z);
            }
            for (r = !1; q < p.length; q++)
              if (
                ((l = p[q].x.getTime ? p[q].x.getTime() : p[q].x),
                !(
                  l < a.axisX.dataInfo.viewPortMin ||
                  (l > a.axisX.dataInfo.viewPortMax &&
                    (!n.connectNullData || !r))
                ))
              )
                if ("number" !== typeof p[q].y)
                  0 < q &&
                    !r &&
                    (n.connectNullData
                      ? c.setLineDash &&
                        0 < A.length &&
                        (n.options.nullDataLineDashType ||
                          !p[q - 1].lineDashType) &&
                        ((A[A.length - 1].newLineDashArray = y),
                        (C = n.nullDataLineDashType))
                      : (e(), (A = []))),
                    (r = !0);
                else {
                  l = a.axisX.convertValueToPixel(l);
                  r = a.axisY.convertValueToPixel(p[q].y);
                  var R = n.dataPointIds[q];
                  this._eventManager.objectMap[R] = {
                    id: R,
                    objectType: "dataPoint",
                    dataSeriesIndex: m,
                    dataPointIndex: q,
                    x1: l,
                    y1: r,
                  };
                  A[A.length] = { x: l, y: r };
                  q < p.length - 1 &&
                    (E !== (p[q].lineColor || ca) ||
                      C !== (p[q].lineDashType || n.lineDashType)) &&
                    ((E = p[q].lineColor || ca),
                    (A[A.length - 1].newStrokeStyle = E),
                    c.setLineDash &&
                      (p[q].lineDashType
                        ? ((C = p[q].lineDashType),
                          (A[A.length - 1].newLineDashArray = N(
                            C,
                            n.lineThickness
                          )))
                        : ((C = n.lineDashType),
                          (A[A.length - 1].newLineDashArray = z))));
                  if (
                    0 !== p[q].markerSize &&
                    (0 < p[q].markerSize || 0 < n.markerSize)
                  ) {
                    var da = n.getMarkerProperties(q, l, r, c);
                    f.push(da);
                    R = O(R);
                    v &&
                      f.push({
                        x: l,
                        y: r,
                        ctx: g,
                        type: da.type,
                        size: da.size,
                        color: R,
                        borderColor: R,
                        borderThickness: da.borderThickness,
                      });
                  }
                  (p[q].indexLabel ||
                    n.indexLabel ||
                    p[q].indexLabelFormatter ||
                    n.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "splineArea",
                      dataPoint: p[q],
                      dataSeries: n,
                      point: { x: l, y: r },
                      direction: 0 > p[q].y === a.axisY.reversed ? 1 : -1,
                      color: s,
                    });
                  r = !1;
                }
            e();
            t.drawMarkers(f);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(d.x1, d.y1, d.width, d.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStepArea = function (a) {
      var e, b;
      function c() {
        E &&
          (0 < l.lineThickness && h.stroke(),
          a.axisY.logarithmic ||
          (0 >= a.axisY.viewportMinimum && 0 <= a.axisY.viewportMaximum)
            ? (ca = s)
            : 0 > a.axisY.viewportMaximum
            ? (ca = d.y1)
            : 0 < a.axisY.viewportMinimum && (ca = s),
          h.lineTo(u, ca),
          h.lineTo(E.x, ca),
          h.closePath(),
          (h.globalAlpha = l.fillOpacity),
          h.fill(),
          (h.globalAlpha = 1),
          v && (f.lineTo(u, ca), f.lineTo(E.x, ca), f.closePath(), f.fill()),
          h.beginPath(),
          h.moveTo(u, w),
          f.beginPath(),
          f.moveTo(u, w),
          (E = { x: u, y: w }));
      }
      var g = a.targetCanvasCtx || this.plotArea.ctx,
        h = v ? this._preRenderCtx : g;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var f = this._eventManager.ghostCtx,
          d = a.axisY.lineCoordinates,
          J = [],
          m = this.plotArea,
          n;
        h.save();
        v && f.save();
        h.beginPath();
        h.rect(m.x1, m.y1, m.width, m.height);
        h.clip();
        v && (f.beginPath(), f.rect(m.x1, m.y1, m.width, m.height), f.clip());
        for (var p = 0; p < a.dataSeriesIndexes.length; p++) {
          var q = a.dataSeriesIndexes[p],
            l = this.data[q],
            r = l.dataPoints,
            J = l.id;
          this._eventManager.objectMap[J] = {
            objectType: "dataSeries",
            dataSeriesIndex: q,
          };
          J = O(J);
          f.fillStyle = J;
          J = [];
          e = !0;
          var k = 0,
            u,
            w,
            A,
            s = a.axisY.convertValueToPixel(
              a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
            ),
            ca,
            E = null;
          b = !1;
          if (0 < r.length) {
            var C = l._colorSet[k % l._colorSet.length],
              y = (l.lineColor = l.options.lineColor || C),
              z = y;
            h.fillStyle = C;
            h.strokeStyle = y;
            h.lineWidth = l.lineThickness;
            var R = "solid";
            if (h.setLineDash) {
              var da = N(l.nullDataLineDashType, l.lineThickness),
                R = l.lineDashType,
                B = N(R, l.lineThickness);
              h.setLineDash(B);
            }
            for (; k < r.length; k++)
              if (
                ((A = r[k].x.getTime ? r[k].x.getTime() : r[k].x),
                !(
                  A < a.axisX.dataInfo.viewPortMin ||
                  (A > a.axisX.dataInfo.viewPortMax &&
                    (!l.connectNullData || !b))
                ))
              ) {
                var ba = w;
                "number" !== typeof r[k].y
                  ? (l.connectNullData || b || e || c(), (b = !0))
                  : ((u = a.axisX.convertValueToPixel(A)),
                    (w = a.axisY.convertValueToPixel(r[k].y)),
                    e || b
                      ? (!e && l.connectNullData
                          ? (h.setLineDash &&
                              (l.options.nullDataLineDashType ||
                                (R === l.lineDashType &&
                                  l.lineDashType !== l.nullDataLineDashType)) &&
                              ((e = u),
                              (b = w),
                              (u = n.x),
                              (w = n.y),
                              c(),
                              h.moveTo(n.x, n.y),
                              (u = e),
                              (w = b),
                              (E = n),
                              (R = l.nullDataLineDashType),
                              h.setLineDash(da)),
                            h.lineTo(u, ba),
                            h.lineTo(u, w),
                            v && (f.lineTo(u, ba), f.lineTo(u, w)))
                          : (h.beginPath(),
                            h.moveTo(u, w),
                            v && (f.beginPath(), f.moveTo(u, w)),
                            (E = { x: u, y: w })),
                        (b = e = !1))
                      : (h.lineTo(u, ba),
                        v && f.lineTo(u, ba),
                        h.lineTo(u, w),
                        v && f.lineTo(u, w),
                        0 == k % 250 && c()),
                    (n = { x: u, y: w }),
                    k < r.length - 1 &&
                      (z !== (r[k].lineColor || y) ||
                        R !== (r[k].lineDashType || l.lineDashType)) &&
                      (c(),
                      (z = r[k].lineColor || y),
                      (h.strokeStyle = z),
                      h.setLineDash &&
                        (r[k].lineDashType
                          ? ((R = r[k].lineDashType),
                            h.setLineDash(N(R, l.lineThickness)))
                          : ((R = l.lineDashType), h.setLineDash(B)))),
                    (A = l.dataPointIds[k]),
                    (this._eventManager.objectMap[A] = {
                      id: A,
                      objectType: "dataPoint",
                      dataSeriesIndex: q,
                      dataPointIndex: k,
                      x1: u,
                      y1: w,
                    }),
                    0 !== r[k].markerSize &&
                      (0 < r[k].markerSize || 0 < l.markerSize) &&
                      ((ba = l.getMarkerProperties(k, u, w, h)),
                      J.push(ba),
                      (A = O(A)),
                      v &&
                        J.push({
                          x: u,
                          y: w,
                          ctx: f,
                          type: ba.type,
                          size: ba.size,
                          color: A,
                          borderColor: A,
                          borderThickness: ba.borderThickness,
                        })),
                    (r[k].indexLabel ||
                      l.indexLabel ||
                      r[k].indexLabelFormatter ||
                      l.indexLabelFormatter) &&
                      this._indexLabels.push({
                        chartType: "stepArea",
                        dataPoint: r[k],
                        dataSeries: l,
                        point: { x: u, y: w },
                        direction: 0 > r[k].y === a.axisY.reversed ? 1 : -1,
                        color: C,
                      }));
              }
            c();
            t.drawMarkers(J);
          }
        }
        v &&
          (g.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (h.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            h.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            h.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          h.clearRect(m.x1, m.y1, m.width, m.height),
          this._eventManager.ghostCtx.restore());
        h.restore();
        return {
          source: g,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStackedArea = function (a) {
      function e() {
        if (!(1 > m.length)) {
          for (0 < C.lineThickness && c.stroke(); 0 < m.length; ) {
            var a = m.pop();
            c.lineTo(a.x, a.y);
            v && u.lineTo(a.x, a.y);
          }
          c.closePath();
          c.globalAlpha = C.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          c.beginPath();
          v && (u.closePath(), u.fill(), u.beginPath());
          m = [];
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = null,
          h = null,
          f = [],
          d = this.plotArea,
          J = [],
          m = [],
          n = [],
          p = [],
          q = 0,
          l,
          r,
          k = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          u = this._eventManager.ghostCtx,
          w,
          A,
          s;
        v && u.beginPath();
        c.save();
        v && u.save();
        c.beginPath();
        c.rect(d.x1, d.y1, d.width, d.height);
        c.clip();
        v && (u.beginPath(), u.rect(d.x1, d.y1, d.width, d.height), u.clip());
        for (var g = [], ca = 0; ca < a.dataSeriesIndexes.length; ca++) {
          var E = a.dataSeriesIndexes[ca],
            C = this.data[E],
            y = C.dataPoints;
          C.dataPointIndexes = [];
          for (q = 0; q < y.length; q++)
            (E = y[q].x.getTime ? y[q].x.getTime() : y[q].x),
              (C.dataPointIndexes[E] = q),
              g[E] || (n.push(E), (g[E] = !0));
          n.sort(Ya);
        }
        for (ca = 0; ca < a.dataSeriesIndexes.length; ca++) {
          E = a.dataSeriesIndexes[ca];
          C = this.data[E];
          y = C.dataPoints;
          A = !0;
          m = [];
          q = C.id;
          this._eventManager.objectMap[q] = {
            objectType: "dataSeries",
            dataSeriesIndex: E,
          };
          q = O(q);
          u.fillStyle = q;
          if (0 < n.length) {
            var g = C._colorSet[0],
              z = (C.lineColor = C.options.lineColor || g),
              R = z;
            c.fillStyle = g;
            c.strokeStyle = z;
            c.lineWidth = C.lineThickness;
            s = "solid";
            if (c.setLineDash) {
              var da = N(C.nullDataLineDashType, C.lineThickness);
              s = C.lineDashType;
              var B = N(s, C.lineThickness);
              c.setLineDash(B);
            }
            for (var ba = !0, q = 0; q < n.length; q++) {
              var h = n[q],
                la = null,
                la =
                  0 <= C.dataPointIndexes[h]
                    ? y[C.dataPointIndexes[h]]
                    : { x: h, y: null };
              if (
                !(
                  h < a.axisX.dataInfo.viewPortMin ||
                  (h > a.axisX.dataInfo.viewPortMax &&
                    (!C.connectNullData || !ba))
                )
              )
                if ("number" !== typeof la.y)
                  C.connectNullData || ba || A || e(), (ba = !0);
                else {
                  l = a.axisX.convertValueToPixel(h);
                  var va = J[h] ? J[h] : 0;
                  if (
                    a.axisY.logarithmic ||
                    (a.axisY.scaleBreaks &&
                      0 < a.axisY.scaleBreaks._appliedBreaks.length)
                  ) {
                    p[h] = la.y + (p[h] ? p[h] : 0);
                    if (0 >= p[h] && a.axisY.logarithmic) continue;
                    r = a.axisY.convertValueToPixel(p[h]);
                  } else (r = a.axisY.convertValueToPixel(la.y)), (r -= va);
                  m.push({ x: l, y: k - va });
                  J[h] = k - r;
                  A || ba
                    ? (!A && C.connectNullData
                        ? (c.setLineDash &&
                            (C.options.nullDataLineDashType ||
                              (s === C.lineDashType &&
                                C.lineDashType !== C.nullDataLineDashType)) &&
                            ((A = m.pop()),
                            (s = m[m.length - 1]),
                            e(),
                            c.moveTo(w.x, w.y),
                            m.push(s),
                            m.push(A),
                            (s = C.nullDataLineDashType),
                            c.setLineDash(da)),
                          c.lineTo(l, r),
                          v && u.lineTo(l, r))
                        : (c.beginPath(),
                          c.moveTo(l, r),
                          v && (u.beginPath(), u.moveTo(l, r))),
                      (ba = A = !1))
                    : (c.lineTo(l, r),
                      v && u.lineTo(l, r),
                      0 == q % 250 &&
                        (e(),
                        c.moveTo(l, r),
                        v && u.moveTo(l, r),
                        m.push({ x: l, y: k - va })));
                  w = { x: l, y: r };
                  q < y.length - 1 &&
                    (R !== (y[q].lineColor || z) ||
                      s !== (y[q].lineDashType || C.lineDashType)) &&
                    (e(),
                    c.beginPath(),
                    c.moveTo(l, r),
                    m.push({ x: l, y: k - va }),
                    (R = y[q].lineColor || z),
                    (c.strokeStyle = R),
                    c.setLineDash &&
                      (y[q].lineDashType
                        ? ((s = y[q].lineDashType),
                          c.setLineDash(N(s, C.lineThickness)))
                        : ((s = C.lineDashType), c.setLineDash(B))));
                  if (0 <= C.dataPointIndexes[h]) {
                    var pa = C.dataPointIds[C.dataPointIndexes[h]];
                    this._eventManager.objectMap[pa] = {
                      id: pa,
                      objectType: "dataPoint",
                      dataSeriesIndex: E,
                      dataPointIndex: C.dataPointIndexes[h],
                      x1: l,
                      y1: r,
                    };
                  }
                  0 <= C.dataPointIndexes[h] &&
                    0 !== la.markerSize &&
                    (0 < la.markerSize || 0 < C.markerSize) &&
                    ((va = C.getMarkerProperties(
                      C.dataPointIndexes[h],
                      l,
                      r,
                      c
                    )),
                    f.push(va),
                    (h = O(pa)),
                    v &&
                      f.push({
                        x: l,
                        y: r,
                        ctx: u,
                        type: va.type,
                        size: va.size,
                        color: h,
                        borderColor: h,
                        borderThickness: va.borderThickness,
                      }));
                  (la.indexLabel ||
                    C.indexLabel ||
                    la.indexLabelFormatter ||
                    C.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stackedArea",
                      dataPoint: la,
                      dataSeries: C,
                      point: { x: l, y: r },
                      direction: 0 > y[q].y === a.axisY.reversed ? 1 : -1,
                      color: g,
                    });
                }
            }
            e();
            c.moveTo(l, r);
            v && u.moveTo(l, r);
          }
          delete C.dataPointIndexes;
        }
        t.drawMarkers(f);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(d.x1, d.y1, d.width, d.height),
          u.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderStackedArea100 = function (a) {
      function e() {
        for (0 < C.lineThickness && c.stroke(); 0 < m.length; ) {
          var a = m.pop();
          c.lineTo(a.x, a.y);
          v && V.lineTo(a.x, a.y);
        }
        c.closePath();
        c.globalAlpha = C.fillOpacity;
        c.fill();
        c.globalAlpha = 1;
        c.beginPath();
        v && (V.closePath(), V.fill(), V.beginPath());
        m = [];
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = null,
          h = null,
          f = this.plotArea,
          d = [],
          k = [],
          m = [],
          n = [],
          p = [],
          q = 0,
          l,
          r,
          u,
          s,
          w,
          A = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          V = this._eventManager.ghostCtx;
        c.save();
        v && V.save();
        c.beginPath();
        c.rect(f.x1, f.y1, f.width, f.height);
        c.clip();
        v && (V.beginPath(), V.rect(f.x1, f.y1, f.width, f.height), V.clip());
        for (var g = [], ca = 0; ca < a.dataSeriesIndexes.length; ca++) {
          var E = a.dataSeriesIndexes[ca],
            C = this.data[E],
            y = C.dataPoints;
          C.dataPointIndexes = [];
          for (q = 0; q < y.length; q++)
            (E = y[q].x.getTime ? y[q].x.getTime() : y[q].x),
              (C.dataPointIndexes[E] = q),
              g[E] || (n.push(E), (g[E] = !0));
          n.sort(Ya);
        }
        for (ca = 0; ca < a.dataSeriesIndexes.length; ca++) {
          E = a.dataSeriesIndexes[ca];
          C = this.data[E];
          y = C.dataPoints;
          s = !0;
          g = C.id;
          this._eventManager.objectMap[g] = {
            objectType: "dataSeries",
            dataSeriesIndex: E,
          };
          g = O(g);
          V.fillStyle = g;
          m = [];
          if (0 < n.length) {
            var g = C._colorSet[q % C._colorSet.length],
              z = (C.lineColor = C.options.lineColor || g),
              R = z;
            c.fillStyle = g;
            c.strokeStyle = z;
            c.lineWidth = C.lineThickness;
            w = "solid";
            if (c.setLineDash) {
              var da = N(C.nullDataLineDashType, C.lineThickness);
              w = C.lineDashType;
              var B = N(w, C.lineThickness);
              c.setLineDash(B);
            }
            for (var ba = !0, q = 0; q < n.length; q++) {
              var h = n[q],
                la = null,
                la =
                  0 <= C.dataPointIndexes[h]
                    ? y[C.dataPointIndexes[h]]
                    : { x: h, y: null };
              if (
                !(
                  h < a.axisX.dataInfo.viewPortMin ||
                  (h > a.axisX.dataInfo.viewPortMax &&
                    (!C.connectNullData || !ba))
                )
              )
                if ("number" !== typeof la.y)
                  C.connectNullData || ba || s || e(), (ba = !0);
                else {
                  var va;
                  va =
                    0 !== a.dataPointYSums[h]
                      ? 100 * (la.y / a.dataPointYSums[h])
                      : 0;
                  l = a.axisX.convertValueToPixel(h);
                  var pa = k[h] ? k[h] : 0;
                  if (
                    a.axisY.logarithmic ||
                    (a.axisY.scaleBreaks &&
                      0 < a.axisY.scaleBreaks._appliedBreaks.length)
                  ) {
                    p[h] = va + (p[h] ? p[h] : 0);
                    if (0 >= p[h] && a.axisY.logarithmic) continue;
                    r = a.axisY.convertValueToPixel(p[h]);
                  } else (r = a.axisY.convertValueToPixel(va)), (r -= pa);
                  m.push({ x: l, y: A - pa });
                  k[h] = A - r;
                  s || ba
                    ? (!s && C.connectNullData
                        ? (c.setLineDash &&
                            (C.options.nullDataLineDashType ||
                              (w === C.lineDashType &&
                                C.lineDashType !== C.nullDataLineDashType)) &&
                            ((s = m.pop()),
                            (w = m[m.length - 1]),
                            e(),
                            c.moveTo(u.x, u.y),
                            m.push(w),
                            m.push(s),
                            (w = C.nullDataLineDashType),
                            c.setLineDash(da)),
                          c.lineTo(l, r),
                          v && V.lineTo(l, r))
                        : (c.beginPath(),
                          c.moveTo(l, r),
                          v && (V.beginPath(), V.moveTo(l, r))),
                      (ba = s = !1))
                    : (c.lineTo(l, r),
                      v && V.lineTo(l, r),
                      0 == q % 250 &&
                        (e(),
                        c.moveTo(l, r),
                        v && V.moveTo(l, r),
                        m.push({ x: l, y: A - pa })));
                  u = { x: l, y: r };
                  q < y.length - 1 &&
                    (R !== (y[q].lineColor || z) ||
                      w !== (y[q].lineDashType || C.lineDashType)) &&
                    (e(),
                    c.beginPath(),
                    c.moveTo(l, r),
                    m.push({ x: l, y: A - pa }),
                    (R = y[q].lineColor || z),
                    (c.strokeStyle = R),
                    c.setLineDash &&
                      (y[q].lineDashType
                        ? ((w = y[q].lineDashType),
                          c.setLineDash(N(w, C.lineThickness)))
                        : ((w = C.lineDashType), c.setLineDash(B))));
                  if (0 <= C.dataPointIndexes[h]) {
                    var G = C.dataPointIds[C.dataPointIndexes[h]];
                    this._eventManager.objectMap[G] = {
                      id: G,
                      objectType: "dataPoint",
                      dataSeriesIndex: E,
                      dataPointIndex: C.dataPointIndexes[h],
                      x1: l,
                      y1: r,
                    };
                  }
                  0 <= C.dataPointIndexes[h] &&
                    0 !== la.markerSize &&
                    (0 < la.markerSize || 0 < C.markerSize) &&
                    ((pa = C.getMarkerProperties(q, l, r, c)),
                    d.push(pa),
                    (h = O(G)),
                    v &&
                      d.push({
                        x: l,
                        y: r,
                        ctx: V,
                        type: pa.type,
                        size: pa.size,
                        color: h,
                        borderColor: h,
                        borderThickness: pa.borderThickness,
                      }));
                  (la.indexLabel ||
                    C.indexLabel ||
                    la.indexLabelFormatter ||
                    C.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "stackedArea100",
                      dataPoint: la,
                      dataSeries: C,
                      point: { x: l, y: r },
                      direction: 0 > y[q].y === a.axisY.reversed ? 1 : -1,
                      color: g,
                    });
                }
            }
            e();
            c.moveTo(l, r);
            v && V.moveTo(l, r);
          }
          delete C.dataPointIndexes;
        }
        t.drawMarkers(d);
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(f.x1, f.y1, f.width, f.height),
          V.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderBubble = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this.plotArea,
          g = 0,
          h,
          f;
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(c.x1, c.y1, c.width, c.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.clip());
        for (
          var d = -Infinity, k = Infinity, m = 0;
          m < a.dataSeriesIndexes.length;
          m++
        )
          for (
            var n = a.dataSeriesIndexes[m],
              p = this.data[n],
              q = p.dataPoints,
              l = 0,
              g = 0;
            g < q.length;
            g++
          )
            (h = q[g].getTime ? (h = q[g].x.getTime()) : (h = q[g].x)),
              h < a.axisX.dataInfo.viewPortMin ||
                h > a.axisX.dataInfo.viewPortMax ||
                "undefined" === typeof q[g].z ||
                ((l = q[g].z), l > d && (d = l), l < k && (k = l));
        for (
          var r = 25 * Math.PI,
            u = Math.max(
              Math.pow((0.25 * Math.min(c.height, c.width)) / 2, 2) * Math.PI,
              r
            ),
            m = 0;
          m < a.dataSeriesIndexes.length;
          m++
        )
          if (
            ((n = a.dataSeriesIndexes[m]),
            (p = this.data[n]),
            (q = p.dataPoints),
            0 < q.length)
          )
            for (b.strokeStyle = "#4572A7 ", g = 0; g < q.length; g++)
              if (
                ((h = q[g].getTime ? (h = q[g].x.getTime()) : (h = q[g].x)),
                !(
                  h < a.axisX.dataInfo.viewPortMin ||
                  h > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof q[g].y)
              ) {
                h = a.axisX.convertValueToPixel(h);
                f = a.axisY.convertValueToPixel(q[g].y);
                var l = q[g].z,
                  s =
                    2 *
                    Math.max(
                      Math.sqrt(
                        (d === k ? u / 2 : r + ((u - r) / (d - k)) * (l - k)) /
                          Math.PI
                      ) << 0,
                      1
                    ),
                  l = p.getMarkerProperties(g, b);
                l.size = s;
                b.globalAlpha = p.fillOpacity;
                t.drawMarker(
                  h,
                  f,
                  b,
                  l.type,
                  l.size,
                  l.color,
                  l.borderColor,
                  l.borderThickness
                );
                b.globalAlpha = 1;
                var w = p.dataPointIds[g];
                this._eventManager.objectMap[w] = {
                  id: w,
                  objectType: "dataPoint",
                  dataSeriesIndex: n,
                  dataPointIndex: g,
                  x1: h,
                  y1: f,
                  size: s,
                };
                s = O(w);
                v &&
                  t.drawMarker(
                    h,
                    f,
                    this._eventManager.ghostCtx,
                    l.type,
                    l.size,
                    s,
                    s,
                    l.borderThickness
                  );
                (q[g].indexLabel ||
                  p.indexLabel ||
                  q[g].indexLabelFormatter ||
                  p.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "bubble",
                    dataPoint: q[g],
                    dataSeries: p,
                    point: { x: h, y: f },
                    direction: 1,
                    bounds: {
                      x1: h - l.size / 2,
                      y1: f - l.size / 2,
                      x2: h + l.size / 2,
                      y2: f + l.size / 2,
                    },
                    color: null,
                  });
              }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderScatter = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this.plotArea,
          g = 0,
          h,
          f;
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(c.x1, c.y1, c.width, c.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.clip());
        for (var d = 0; d < a.dataSeriesIndexes.length; d++) {
          var k = a.dataSeriesIndexes[d],
            m = this.data[k],
            n = m.dataPoints;
          if (0 < n.length) {
            b.strokeStyle = "#4572A7 ";
            Math.pow((0.3 * Math.min(c.height, c.width)) / 2, 2);
            for (var p = 0, q = 0, g = 0; g < n.length; g++)
              if (
                ((h = n[g].getTime ? (h = n[g].x.getTime()) : (h = n[g].x)),
                !(
                  h < a.axisX.dataInfo.viewPortMin ||
                  h > a.axisX.dataInfo.viewPortMax
                ) && "number" === typeof n[g].y)
              ) {
                h = a.axisX.convertValueToPixel(h);
                f = a.axisY.convertValueToPixel(n[g].y);
                var l = m.getMarkerProperties(g, h, f, b);
                b.globalAlpha = m.fillOpacity;
                t.drawMarker(
                  l.x,
                  l.y,
                  l.ctx,
                  l.type,
                  l.size,
                  l.color,
                  l.borderColor,
                  l.borderThickness
                );
                b.globalAlpha = 1;
                (Math.sqrt((p - h) * (p - h) + (q - f) * (q - f)) <
                  Math.min(l.size, 5) &&
                  n.length >
                    Math.min(this.plotArea.width, this.plotArea.height)) ||
                  ((p = m.dataPointIds[g]),
                  (this._eventManager.objectMap[p] = {
                    id: p,
                    objectType: "dataPoint",
                    dataSeriesIndex: k,
                    dataPointIndex: g,
                    x1: h,
                    y1: f,
                  }),
                  (p = O(p)),
                  v &&
                    t.drawMarker(
                      l.x,
                      l.y,
                      this._eventManager.ghostCtx,
                      l.type,
                      l.size,
                      p,
                      p,
                      l.borderThickness
                    ),
                  (n[g].indexLabel ||
                    m.indexLabel ||
                    n[g].indexLabelFormatter ||
                    m.indexLabelFormatter) &&
                    this._indexLabels.push({
                      chartType: "scatter",
                      dataPoint: n[g],
                      dataSeries: m,
                      point: { x: h, y: f },
                      direction: 1,
                      bounds: {
                        x1: h - l.size / 2,
                        y1: f - l.size / 2,
                        x2: h + l.size / 2,
                        y2: f + l.size / 2,
                      },
                      color: null,
                    }),
                  (p = h),
                  (q = f));
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(c.x1, c.y1, c.width, c.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderCandlestick = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e,
        c = this._eventManager.ghostCtx;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = null,
          h = null,
          d = this.plotArea,
          k = 0,
          u,
          m,
          n,
          p,
          q,
          l,
          g = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1,
          h = this.options.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 0.015 * this.width,
          r = a.axisX.dataInfo.minDiff;
        isFinite(r) || (r = 0.3 * Math.abs(a.axisX.range));
        r = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.7 *
              d.width *
              (a.axisX.logarithmic
                ? Math.log(r) / Math.log(a.axisX.range)
                : Math.abs(r) / Math.abs(a.axisX.range))) <<
            0;
        this.dataPointMaxWidth &&
          g > h &&
          (g = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            h
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          h < g &&
          (h = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        r < g && (r = g);
        r > h && (r = h);
        b.save();
        v && c.save();
        b.beginPath();
        b.rect(d.x1, d.y1, d.width, d.height);
        b.clip();
        v && (c.beginPath(), c.rect(d.x1, d.y1, d.width, d.height), c.clip());
        for (var t = 0; t < a.dataSeriesIndexes.length; t++) {
          var s = a.dataSeriesIndexes[t],
            w = this.data[s],
            A = w.dataPoints;
          if (0 < A.length)
            for (
              var V = 5 < r && w.bevelEnabled ? !0 : !1, k = 0;
              k < A.length;
              k++
            )
              if (
                (A[k].getTime ? (l = A[k].x.getTime()) : (l = A[k].x),
                !(
                  l < a.axisX.dataInfo.viewPortMin ||
                  l > a.axisX.dataInfo.viewPortMax
                ) &&
                  !f(A[k].y) &&
                  A[k].y.length &&
                  "number" === typeof A[k].y[0] &&
                  "number" === typeof A[k].y[1] &&
                  "number" === typeof A[k].y[2] &&
                  "number" === typeof A[k].y[3])
              ) {
                u = a.axisX.convertValueToPixel(l);
                m = a.axisY.convertValueToPixel(A[k].y[0]);
                n = a.axisY.convertValueToPixel(A[k].y[1]);
                p = a.axisY.convertValueToPixel(A[k].y[2]);
                q = a.axisY.convertValueToPixel(A[k].y[3]);
                var y = (u - r / 2) << 0,
                  E = (y + r) << 0,
                  h = w.options.fallingColor ? w.fallingColor : w._colorSet[0],
                  g = A[k].color ? A[k].color : w._colorSet[0],
                  C = Math.round(Math.max(1, 0.15 * r)),
                  z = 0 === C % 2 ? 0 : 0.5,
                  B = w.dataPointIds[k];
                this._eventManager.objectMap[B] = {
                  id: B,
                  objectType: "dataPoint",
                  dataSeriesIndex: s,
                  dataPointIndex: k,
                  x1: y,
                  y1: m,
                  x2: E,
                  y2: n,
                  x3: u,
                  y3: p,
                  x4: u,
                  y4: q,
                  borderThickness: C,
                  color: g,
                };
                b.strokeStyle = g;
                b.beginPath();
                b.lineWidth = C;
                c.lineWidth = Math.max(C, 4);
                "candlestick" === w.type
                  ? (b.moveTo(u - z, n),
                    b.lineTo(u - z, Math.min(m, q)),
                    b.stroke(),
                    b.moveTo(u - z, Math.max(m, q)),
                    b.lineTo(u - z, p),
                    b.stroke(),
                    fa(
                      b,
                      y,
                      Math.min(m, q),
                      E,
                      Math.max(m, q),
                      A[k].y[0] <= A[k].y[3] ? w.risingColor : h,
                      C,
                      g,
                      V,
                      V,
                      !1,
                      !1,
                      w.fillOpacity
                    ),
                    v &&
                      ((g = O(B)),
                      (c.strokeStyle = g),
                      c.moveTo(u - z, n),
                      c.lineTo(u - z, Math.min(m, q)),
                      c.stroke(),
                      c.moveTo(u - z, Math.max(m, q)),
                      c.lineTo(u - z, p),
                      c.stroke(),
                      fa(
                        c,
                        y,
                        Math.min(m, q),
                        E,
                        Math.max(m, q),
                        g,
                        0,
                        null,
                        !1,
                        !1,
                        !1,
                        !1
                      )))
                  : "ohlc" === w.type &&
                    (b.moveTo(u - z, n),
                    b.lineTo(u - z, p),
                    b.stroke(),
                    b.beginPath(),
                    b.moveTo(u, m),
                    b.lineTo(y, m),
                    b.stroke(),
                    b.beginPath(),
                    b.moveTo(u, q),
                    b.lineTo(E, q),
                    b.stroke(),
                    v &&
                      ((g = O(B)),
                      (c.strokeStyle = g),
                      c.moveTo(u - z, n),
                      c.lineTo(u - z, p),
                      c.stroke(),
                      c.beginPath(),
                      c.moveTo(u, m),
                      c.lineTo(y, m),
                      c.stroke(),
                      c.beginPath(),
                      c.moveTo(u, q),
                      c.lineTo(E, q),
                      c.stroke()));
                (A[k].indexLabel ||
                  w.indexLabel ||
                  A[k].indexLabelFormatter ||
                  w.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: w.type,
                    dataPoint: A[k],
                    dataSeries: w,
                    point: { x: y + (E - y) / 2, y: a.axisY.reversed ? p : n },
                    direction: 1,
                    bounds: {
                      x1: y,
                      y1: Math.min(n, p),
                      x2: E,
                      y2: Math.max(n, p),
                    },
                    color: g,
                  });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(d.x1, d.y1, d.width, d.height),
          c.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderBoxAndWhisker = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e,
        c = this._eventManager.ghostCtx;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = null,
          h = this.plotArea,
          d = 0,
          k,
          u,
          m,
          n,
          p,
          q,
          l,
          g = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1,
          d = this.options.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 0.015 * this.width,
          r = a.axisX.dataInfo.minDiff;
        isFinite(r) || (r = 0.3 * Math.abs(a.axisX.range));
        r = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.7 *
              h.width *
              (a.axisX.logarithmic
                ? Math.log(r) / Math.log(a.axisX.range)
                : Math.abs(r) / Math.abs(a.axisX.range))) <<
            0;
        this.dataPointMaxWidth &&
          g > d &&
          (g = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            d
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          d < g &&
          (d = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            g
          ));
        r < g && (r = g);
        r > d && (r = d);
        b.save();
        v && c.save();
        b.beginPath();
        b.rect(h.x1, h.y1, h.width, h.height);
        b.clip();
        v && (c.beginPath(), c.rect(h.x1, h.y1, h.width, h.height), c.clip());
        for (
          var t = !1, t = !!a.axisY.reversed, s = 0;
          s < a.dataSeriesIndexes.length;
          s++
        ) {
          var w = a.dataSeriesIndexes[s],
            A = this.data[w],
            V = A.dataPoints;
          if (0 < V.length)
            for (
              var y = 5 < r && A.bevelEnabled ? !0 : !1, d = 0;
              d < V.length;
              d++
            )
              if (
                (V[d].getTime ? (l = V[d].x.getTime()) : (l = V[d].x),
                !(
                  l < a.axisX.dataInfo.viewPortMin ||
                  l > a.axisX.dataInfo.viewPortMax
                ) &&
                  !f(V[d].y) &&
                  V[d].y.length &&
                  "number" === typeof V[d].y[0] &&
                  "number" === typeof V[d].y[1] &&
                  "number" === typeof V[d].y[2] &&
                  "number" === typeof V[d].y[3] &&
                  "number" === typeof V[d].y[4] &&
                  5 === V[d].y.length)
              ) {
                k = a.axisX.convertValueToPixel(l);
                u = a.axisY.convertValueToPixel(V[d].y[0]);
                m = a.axisY.convertValueToPixel(V[d].y[1]);
                n = a.axisY.convertValueToPixel(V[d].y[2]);
                p = a.axisY.convertValueToPixel(V[d].y[3]);
                q = a.axisY.convertValueToPixel(V[d].y[4]);
                var E = (k - r / 2) << 0,
                  C = (k + r / 2) << 0,
                  g = V[d].color ? V[d].color : A._colorSet[0],
                  z = Math.round(Math.max(1, 0.15 * r)),
                  B = 0 === z % 2 ? 0 : 0.5,
                  R = V[d].whiskerColor
                    ? V[d].whiskerColor
                    : V[d].color
                    ? A.whiskerColor
                      ? A.whiskerColor
                      : V[d].color
                    : A.whiskerColor
                    ? A.whiskerColor
                    : g,
                  da =
                    "number" === typeof V[d].whiskerThickness
                      ? V[d].whiskerThickness
                      : "number" === typeof A.options.whiskerThickness
                      ? A.whiskerThickness
                      : z,
                  ja = V[d].whiskerDashType
                    ? V[d].whiskerDashType
                    : A.whiskerDashType,
                  ba = f(V[d].whiskerLength)
                    ? f(A.options.whiskerLength)
                      ? r
                      : A.whiskerLength
                    : V[d].whiskerLength,
                  ba =
                    "number" === typeof ba
                      ? 0 >= ba
                        ? 0
                        : ba >= r
                        ? r
                        : ba
                      : "string" === typeof ba
                      ? (parseInt(ba) * r) / 100 > r
                        ? r
                        : (parseInt(ba) * r) / 100
                      : r,
                  la = 1 === Math.round(da) % 2 ? 0.5 : 0,
                  va = V[d].stemColor
                    ? V[d].stemColor
                    : V[d].color
                    ? A.stemColor
                      ? A.stemColor
                      : V[d].color
                    : A.stemColor
                    ? A.stemColor
                    : g,
                  pa =
                    "number" === typeof V[d].stemThickness
                      ? V[d].stemThickness
                      : "number" === typeof A.options.stemThickness
                      ? A.stemThickness
                      : z,
                  G = 1 === Math.round(pa) % 2 ? 0.5 : 0,
                  F = V[d].stemDashType ? V[d].stemDashType : A.stemDashType,
                  L = V[d].lineColor
                    ? V[d].lineColor
                    : V[d].color
                    ? A.lineColor
                      ? A.lineColor
                      : V[d].color
                    : A.lineColor
                    ? A.lineColor
                    : g,
                  H =
                    "number" === typeof V[d].lineThickness
                      ? V[d].lineThickness
                      : "number" === typeof A.options.lineThickness
                      ? A.lineThickness
                      : z,
                  K = V[d].lineDashType ? V[d].lineDashType : A.lineDashType,
                  S = 1 === Math.round(H) % 2 ? 0.5 : 0,
                  P = A.upperBoxColor,
                  U = A.lowerBoxColor,
                  Q = f(A.options.fillOpacity) ? 1 : A.fillOpacity,
                  T = A.dataPointIds[d];
                this._eventManager.objectMap[T] = {
                  id: T,
                  objectType: "dataPoint",
                  dataSeriesIndex: w,
                  dataPointIndex: d,
                  x1: E,
                  y1: u,
                  x2: C,
                  y2: m,
                  x3: k,
                  y3: n,
                  x4: k,
                  y4: p,
                  y5: q,
                  borderThickness: z,
                  color: g,
                  stemThickness: pa,
                  stemColor: va,
                  whiskerThickness: da,
                  whiskerLength: ba,
                  whiskerColor: R,
                  lineThickness: H,
                  lineColor: L,
                };
                b.save();
                0 < pa &&
                  (b.beginPath(),
                  (b.strokeStyle = va),
                  (b.lineWidth = pa),
                  b.setLineDash && b.setLineDash(N(F, pa)),
                  b.moveTo(k - G, m),
                  b.lineTo(k - G, u),
                  b.stroke(),
                  b.moveTo(k - G, p),
                  b.lineTo(k - G, n),
                  b.stroke());
                b.restore();
                c.lineWidth = Math.max(z, 4);
                b.beginPath();
                fa(
                  b,
                  E,
                  Math.min(q, m),
                  C,
                  Math.max(m, q),
                  U,
                  0,
                  g,
                  t ? y : !1,
                  t ? !1 : y,
                  !1,
                  !1,
                  Q
                );
                b.beginPath();
                fa(
                  b,
                  E,
                  Math.min(n, q),
                  C,
                  Math.max(q, n),
                  P,
                  0,
                  g,
                  t ? !1 : y,
                  t ? y : !1,
                  !1,
                  !1,
                  Q
                );
                b.beginPath();
                b.lineWidth = z;
                b.strokeStyle = g;
                b.rect(
                  E - B,
                  Math.min(m, n) - B,
                  C - E + 2 * B,
                  Math.max(m, n) - Math.min(m, n) + 2 * B
                );
                b.stroke();
                b.save();
                0 < H &&
                  (b.beginPath(),
                  (b.globalAlpha = 1),
                  b.setLineDash && b.setLineDash(N(K, H)),
                  (b.strokeStyle = L),
                  (b.lineWidth = H),
                  b.moveTo(E, q - S),
                  b.lineTo(C, q - S),
                  b.stroke());
                b.restore();
                b.save();
                0 < da &&
                  (b.beginPath(),
                  b.setLineDash && b.setLineDash(N(ja, da)),
                  (b.strokeStyle = R),
                  (b.lineWidth = da),
                  b.moveTo((k - ba / 2) << 0, p - la),
                  b.lineTo((k + ba / 2) << 0, p - la),
                  b.stroke(),
                  b.moveTo((k - ba / 2) << 0, u + la),
                  b.lineTo((k + ba / 2) << 0, u + la),
                  b.stroke());
                b.restore();
                v &&
                  ((g = O(T)),
                  (c.strokeStyle = g),
                  (c.lineWidth = pa),
                  0 < pa &&
                    (c.moveTo(k - B - G, m),
                    c.lineTo(k - B - G, Math.max(u, p)),
                    c.stroke(),
                    c.moveTo(k - B - G, Math.min(u, p)),
                    c.lineTo(k - B - G, n),
                    c.stroke()),
                  fa(
                    c,
                    E,
                    Math.max(m, n),
                    C,
                    Math.min(m, n),
                    g,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  ),
                  0 < da &&
                    (c.beginPath(),
                    (c.lineWidth = da),
                    c.moveTo(k + ba / 2, p - la),
                    c.lineTo(k - ba / 2, p - la),
                    c.stroke(),
                    c.moveTo(k + ba / 2, u + la),
                    c.lineTo(k - ba / 2, u + la),
                    c.stroke()));
                (V[d].indexLabel ||
                  A.indexLabel ||
                  V[d].indexLabelFormatter ||
                  A.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: A.type,
                    dataPoint: V[d],
                    dataSeries: A,
                    point: { x: E + (C - E) / 2, y: a.axisY.reversed ? u : p },
                    direction: 1,
                    bounds: {
                      x1: E,
                      y1: Math.min(u, p),
                      x2: C,
                      y2: Math.max(u, p),
                    },
                    color: g,
                  });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(h.x1, h.y1, h.width, h.height),
          c.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeColumn = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = 0,
          d,
          k,
          u,
          h = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        d = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : 0.03 * this.width;
        var m = a.axisX.dataInfo.minDiff;
        isFinite(m) || (m = 0.3 * Math.abs(a.axisX.range));
        m = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.width *
                (a.axisX.logarithmic
                  ? Math.log(m) / Math.log(a.axisX.range)
                  : Math.abs(m) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          h > d &&
          (h = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            d
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          d < h &&
          (d = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            h
          ));
        m < h && (m = h);
        m > d && (m = d);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var n = 0; n < a.dataSeriesIndexes.length; n++) {
          var p = a.dataSeriesIndexes[n],
            q = this.data[p],
            l = q.dataPoints;
          if (0 < l.length)
            for (
              var r = 5 < m && q.bevelEnabled ? !0 : !1, h = 0;
              h < l.length;
              h++
            )
              if (
                (l[h].getTime ? (u = l[h].x.getTime()) : (u = l[h].x),
                !(
                  u < a.axisX.dataInfo.viewPortMin ||
                  u > a.axisX.dataInfo.viewPortMax
                ) &&
                  !f(l[h].y) &&
                  l[h].y.length &&
                  "number" === typeof l[h].y[0] &&
                  "number" === typeof l[h].y[1])
              ) {
                c = a.axisX.convertValueToPixel(u);
                d = a.axisY.convertValueToPixel(l[h].y[0]);
                k = a.axisY.convertValueToPixel(l[h].y[1]);
                var t = a.axisX.reversed
                    ? (c +
                        (a.plotType.totalDataSeries * m) / 2 -
                        (a.previousDataSeriesCount + n) * m) <<
                      0
                    : (c -
                        (a.plotType.totalDataSeries * m) / 2 +
                        (a.previousDataSeriesCount + n) * m) <<
                      0,
                  s = a.axisX.reversed ? (t - m) << 0 : (t + m) << 0,
                  c = l[h].color
                    ? l[h].color
                    : q._colorSet[h % q._colorSet.length];
                if (d > k) {
                  var w = d;
                  d = k;
                  k = w;
                }
                w = q.dataPointIds[h];
                this._eventManager.objectMap[w] = {
                  id: w,
                  objectType: "dataPoint",
                  dataSeriesIndex: p,
                  dataPointIndex: h,
                  x1: t,
                  y1: d,
                  x2: s,
                  y2: k,
                };
                fa(b, t, d, s, k, c, 0, c, r, r, !1, !1, q.fillOpacity);
                c = O(w);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    t,
                    d,
                    s,
                    k,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                if (
                  l[h].indexLabel ||
                  q.indexLabel ||
                  l[h].indexLabelFormatter ||
                  q.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "rangeColumn",
                    dataPoint: l[h],
                    dataSeries: q,
                    indexKeyword: 0,
                    point: {
                      x: t + (s - t) / 2,
                      y: l[h].y[1] >= l[h].y[0] ? k : d,
                    },
                    direction: l[h].y[1] >= l[h].y[0] ? -1 : 1,
                    bounds: {
                      x1: t,
                      y1: Math.min(d, k),
                      x2: s,
                      y2: Math.max(d, k),
                    },
                    color: c,
                  }),
                    this._indexLabels.push({
                      chartType: "rangeColumn",
                      dataPoint: l[h],
                      dataSeries: q,
                      indexKeyword: 1,
                      point: {
                        x: t + (s - t) / 2,
                        y: l[h].y[1] >= l[h].y[0] ? d : k,
                      },
                      direction: l[h].y[1] >= l[h].y[0] ? 1 : -1,
                      bounds: {
                        x1: t,
                        y1: Math.min(d, k),
                        x2: s,
                        y2: Math.max(d, k),
                      },
                      color: c,
                    });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderError = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e,
        c = a.axisY._position
          ? "left" === a.axisY._position || "right" === a.axisY._position
            ? !1
            : !0
          : !1;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = null,
          h = !1,
          d = this.plotArea,
          k = 0,
          u,
          m,
          n,
          p,
          q,
          l,
          r,
          t = a.axisX.dataInfo.minDiff;
        isFinite(t) || (t = 0.3 * Math.abs(a.axisX.range));
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(d.x1, d.y1, d.width, d.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(d.x1, d.y1, d.width, d.height),
          this._eventManager.ghostCtx.clip());
        for (var s = 0, w = 0; w < this.data.length; w++)
          !this.data[w].type.match(/(bar|column)/gi) ||
            !this.data[w].visible ||
            (this.data[w].type.match(/(stacked)/gi) && s) ||
            s++;
        for (var A = 0; A < a.dataSeriesIndexes.length; A++) {
          var V = a.dataSeriesIndexes[A],
            y = this.data[V],
            E = y.dataPoints,
            C = f(y._linkedSeries)
              ? !1
              : y._linkedSeries.type.match(/(bar|column)/gi) &&
                y._linkedSeries.visible
              ? !0
              : !1,
            z = 0;
          if (C)
            for (g = y._linkedSeries.id, w = 0; w < g; w++)
              !this.data[w].type.match(/(bar|column)/gi) ||
                !this.data[w].visible ||
                (this.data[w].type.match(/(stacked)/gi) && z) ||
                (this.data[w].type.match(/(range)/gi) && (h = !0), z++);
          g = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
          k = this.options.dataPointMaxWidth
            ? this.dataPointMaxWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : c
            ? Math.min(
                0.15 * this.height,
                0.9 * (this.plotArea.height / (C ? s : 1))
              ) << 0
            : 0.3 * this.width;
          h &&
            (k = this.options.dataPointMaxWidth
              ? this.dataPointMaxWidth
              : this.options.dataPointWidth
              ? this.dataPointWidth
              : c
              ? Math.min(
                  0.15 * this.height,
                  0.9 * (this.plotArea.height / (C ? s : 1))
                ) << 0
              : 0.03 * this.width);
          w = this.options.dataPointWidth
            ? this.dataPointWidth
            : (0.9 *
                (((c ? d.height : d.width) *
                  (a.axisX.logarithmic
                    ? Math.log(t) / Math.log(a.axisX.range)
                    : Math.abs(t) / Math.abs(a.axisX.range))) /
                  (C ? s : 1))) <<
              0;
          this.dataPointMaxWidth &&
            g > k &&
            (g = Math.min(
              this.options.dataPointWidth ? this.dataPointWidth : Infinity,
              k
            ));
          !this.dataPointMaxWidth &&
            this.dataPointMinWidth &&
            k < g &&
            (k = Math.max(
              this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
              g
            ));
          w < g && (w = g);
          w > k && (w = k);
          if (0 < E.length)
            for (var B = y._colorSet, k = 0; k < E.length; k++) {
              var g = (y.lineColor = y.options.color ? y.options.color : B[0]),
                R = {
                  color: E[k].whiskerColor
                    ? E[k].whiskerColor
                    : E[k].color
                    ? y.whiskerColor
                      ? y.whiskerColor
                      : E[k].color
                    : y.whiskerColor
                    ? y.whiskerColor
                    : g,
                  thickness: f(E[k].whiskerThickness)
                    ? y.whiskerThickness
                    : E[k].whiskerThickness,
                  dashType: E[k].whiskerDashType
                    ? E[k].whiskerDashType
                    : y.whiskerDashType,
                  length: f(E[k].whiskerLength)
                    ? f(y.options.whiskerLength)
                      ? w
                      : y.options.whiskerLength
                    : E[k].whiskerLength,
                  trimLength: f(E[k].whiskerLength)
                    ? f(y.options.whiskerLength)
                      ? 50
                      : 0
                    : 0,
                };
              R.length =
                "number" === typeof R.length
                  ? 0 >= R.length
                    ? 0
                    : R.length >= w
                    ? w
                    : R.length
                  : "string" === typeof R.length
                  ? (parseInt(R.length) * w) / 100 > w
                    ? w
                    : (parseInt(R.length) * w) / 100 > w
                  : w;
              R.thickness =
                "number" === typeof R.thickness
                  ? 0 > R.thickness
                    ? 0
                    : Math.round(R.thickness)
                  : 2;
              var da = {
                color: E[k].stemColor
                  ? E[k].stemColor
                  : E[k].color
                  ? y.stemColor
                    ? y.stemColor
                    : E[k].color
                  : y.stemColor
                  ? y.stemColor
                  : g,
                thickness: E[k].stemThickness
                  ? E[k].stemThickness
                  : y.stemThickness,
                dashType: E[k].stemDashType
                  ? E[k].stemDashType
                  : y.stemDashType,
              };
              da.thickness =
                "number" === typeof da.thickness
                  ? 0 > da.thickness
                    ? 0
                    : Math.round(da.thickness)
                  : 2;
              E[k].getTime ? (r = E[k].x.getTime()) : (r = E[k].x);
              if (
                !(
                  r < a.axisX.dataInfo.viewPortMin ||
                  r > a.axisX.dataInfo.viewPortMax
                ) &&
                !f(E[k].y) &&
                E[k].y.length &&
                "number" === typeof E[k].y[0] &&
                "number" === typeof E[k].y[1]
              ) {
                var ja = a.axisX.convertValueToPixel(r);
                c ? (m = ja) : (u = ja);
                ja = a.axisY.convertValueToPixel(E[k].y[0]);
                c ? (n = ja) : (q = ja);
                ja = a.axisY.convertValueToPixel(E[k].y[1]);
                c ? (p = ja) : (l = ja);
                c
                  ? ((q = a.axisX.reversed
                      ? (m + ((C ? s : 1) * w) / 2 - (C ? z - 1 : 0) * w) << 0
                      : (m - ((C ? s : 1) * w) / 2 + (C ? z - 1 : 0) * w) << 0),
                    (l = a.axisX.reversed ? (q - w) << 0 : (q + w) << 0))
                  : ((n = a.axisX.reversed
                      ? (u + ((C ? s : 1) * w) / 2 - (C ? z - 1 : 0) * w) << 0
                      : (u - ((C ? s : 1) * w) / 2 + (C ? z - 1 : 0) * w) << 0),
                    (p = a.axisX.reversed ? (n - w) << 0 : (n + w) << 0));
                !c && q > l && ((ja = q), (q = l), (l = ja));
                c && n > p && ((ja = n), (n = p), (p = ja));
                ja = y.dataPointIds[k];
                this._eventManager.objectMap[ja] = {
                  id: ja,
                  objectType: "dataPoint",
                  dataSeriesIndex: V,
                  dataPointIndex: k,
                  x1: Math.min(n, p),
                  y1: Math.min(q, l),
                  x2: Math.max(p, n),
                  y2: Math.max(l, q),
                  isXYSwapped: c,
                  stemProperties: da,
                  whiskerProperties: R,
                };
                K(
                  b,
                  Math.min(n, p),
                  Math.min(q, l),
                  Math.max(p, n),
                  Math.max(l, q),
                  g,
                  R,
                  da,
                  c
                );
                v && K(this._eventManager.ghostCtx, n, q, p, l, g, R, da, c);
                if (
                  E[k].indexLabel ||
                  y.indexLabel ||
                  E[k].indexLabelFormatter ||
                  y.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "error",
                    dataPoint: E[k],
                    dataSeries: y,
                    indexKeyword: 0,
                    point: {
                      x: c ? (E[k].y[1] >= E[k].y[0] ? n : p) : n + (p - n) / 2,
                      y: c ? q + (l - q) / 2 : E[k].y[1] >= E[k].y[0] ? l : q,
                    },
                    direction: E[k].y[1] >= E[k].y[0] ? -1 : 1,
                    bounds: {
                      x1: c ? Math.min(n, p) : n,
                      y1: c ? q : Math.min(q, l),
                      x2: c ? Math.max(n, p) : p,
                      y2: c ? l : Math.max(q, l),
                    },
                    color: g,
                    axisSwapped: c,
                  }),
                    this._indexLabels.push({
                      chartType: "error",
                      dataPoint: E[k],
                      dataSeries: y,
                      indexKeyword: 1,
                      point: {
                        x: c
                          ? E[k].y[1] >= E[k].y[0]
                            ? p
                            : n
                          : n + (p - n) / 2,
                        y: c ? q + (l - q) / 2 : E[k].y[1] >= E[k].y[0] ? q : l,
                      },
                      direction: E[k].y[1] >= E[k].y[0] ? 1 : -1,
                      bounds: {
                        x1: c ? Math.min(n, p) : n,
                        y1: c ? q : Math.min(q, l),
                        x2: c ? Math.max(n, p) : p,
                        y2: c ? l : Math.max(q, l),
                      },
                      color: g,
                      axisSwapped: c,
                    });
              }
            }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(d.x1, d.y1, d.width, d.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeBar = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = null,
          g = this.plotArea,
          h = 0,
          d,
          k,
          u,
          m,
          h = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        d = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : Math.min(
              0.15 * this.height,
              0.9 * (this.plotArea.height / a.plotType.totalDataSeries)
            ) << 0;
        var n = a.axisX.dataInfo.minDiff;
        isFinite(n) || (n = 0.3 * Math.abs(a.axisX.range));
        n = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.9 *
              ((g.height *
                (a.axisX.logarithmic
                  ? Math.log(n) / Math.log(a.axisX.range)
                  : Math.abs(n) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          h > d &&
          (h = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            d
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          d < h &&
          (d = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            h
          ));
        n < h && (n = h);
        n > d && (n = d);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(g.x1, g.y1, g.width, g.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.clip());
        for (var p = 0; p < a.dataSeriesIndexes.length; p++) {
          var q = a.dataSeriesIndexes[p],
            l = this.data[q],
            r = l.dataPoints;
          if (0 < r.length) {
            var t = 5 < n && l.bevelEnabled ? !0 : !1;
            b.strokeStyle = "#4572A7 ";
            for (h = 0; h < r.length; h++)
              if (
                (r[h].getTime ? (m = r[h].x.getTime()) : (m = r[h].x),
                !(
                  m < a.axisX.dataInfo.viewPortMin ||
                  m > a.axisX.dataInfo.viewPortMax
                ) &&
                  !f(r[h].y) &&
                  r[h].y.length &&
                  "number" === typeof r[h].y[0] &&
                  "number" === typeof r[h].y[1])
              ) {
                d = a.axisY.convertValueToPixel(r[h].y[0]);
                k = a.axisY.convertValueToPixel(r[h].y[1]);
                u = a.axisX.convertValueToPixel(m);
                u = a.axisX.reversed
                  ? (u +
                      (a.plotType.totalDataSeries * n) / 2 -
                      (a.previousDataSeriesCount + p) * n) <<
                    0
                  : (u -
                      (a.plotType.totalDataSeries * n) / 2 +
                      (a.previousDataSeriesCount + p) * n) <<
                    0;
                var s = a.axisX.reversed ? (u - n) << 0 : (u + n) << 0;
                d > k && ((c = d), (d = k), (k = c));
                c = r[h].color
                  ? r[h].color
                  : l._colorSet[h % l._colorSet.length];
                fa(b, d, u, k, s, c, 0, null, t, !1, !1, !1, l.fillOpacity);
                c = l.dataPointIds[h];
                this._eventManager.objectMap[c] = {
                  id: c,
                  objectType: "dataPoint",
                  dataSeriesIndex: q,
                  dataPointIndex: h,
                  x1: d,
                  y1: u,
                  x2: k,
                  y2: s,
                };
                c = O(c);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    d,
                    u,
                    k,
                    s,
                    c,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                if (
                  r[h].indexLabel ||
                  l.indexLabel ||
                  r[h].indexLabelFormatter ||
                  l.indexLabelFormatter
                )
                  this._indexLabels.push({
                    chartType: "rangeBar",
                    dataPoint: r[h],
                    dataSeries: l,
                    indexKeyword: 0,
                    point: {
                      x: r[h].y[1] >= r[h].y[0] ? d : k,
                      y: u + (s - u) / 2,
                    },
                    direction: r[h].y[1] >= r[h].y[0] ? -1 : 1,
                    bounds: {
                      x1: Math.min(d, k),
                      y1: u,
                      x2: Math.max(d, k),
                      y2: s,
                    },
                    color: c,
                  }),
                    this._indexLabels.push({
                      chartType: "rangeBar",
                      dataPoint: r[h],
                      dataSeries: l,
                      indexKeyword: 1,
                      point: {
                        x: r[h].y[1] >= r[h].y[0] ? k : d,
                        y: u + (s - u) / 2,
                      },
                      direction: r[h].y[1] >= r[h].y[0] ? 1 : -1,
                      bounds: {
                        x1: Math.min(d, k),
                        y1: u,
                        x2: Math.max(d, k),
                        y2: s,
                      },
                      color: c,
                    });
              }
          }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(g.x1, g.y1, g.width, g.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeArea = function (a) {
      function e() {
        if (A) {
          for (var a = null, b = k.length - 1; 0 <= b; b--)
            (a = k[b]), c.lineTo(a.x, a.y2), g.lineTo(a.x, a.y2);
          c.closePath();
          c.globalAlpha = n.fillOpacity;
          c.fill();
          c.globalAlpha = 1;
          g.fill();
          if (0 < n.lineThickness) {
            c.beginPath();
            c.moveTo(a.x, a.y2);
            for (b = 0; b < k.length; b++) (a = k[b]), c.lineTo(a.x, a.y2);
            c.moveTo(k[0].x, k[0].y1);
            for (b = 0; b < k.length; b++) (a = k[b]), c.lineTo(a.x, a.y1);
            c.stroke();
          }
          c.beginPath();
          c.moveTo(r, u);
          g.beginPath();
          g.moveTo(r, u);
          A = { x: r, y: u };
          k = [];
          k.push({ x: r, y1: u, y2: s });
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = this._eventManager.ghostCtx,
          h = [],
          d = this.plotArea;
        c.save();
        v && g.save();
        c.beginPath();
        c.rect(d.x1, d.y1, d.width, d.height);
        c.clip();
        v && (g.beginPath(), g.rect(d.x1, d.y1, d.width, d.height), g.clip());
        for (var f = 0; f < a.dataSeriesIndexes.length; f++) {
          var k = [],
            m = a.dataSeriesIndexes[f],
            n = this.data[m],
            p = n.dataPoints,
            h = n.id;
          this._eventManager.objectMap[h] = {
            objectType: "dataSeries",
            dataSeriesIndex: m,
          };
          h = O(h);
          g.fillStyle = h;
          var h = [],
            q = !0,
            l = 0,
            r,
            u,
            s,
            w,
            A = null;
          if (0 < p.length) {
            var y = n._colorSet[l % n._colorSet.length],
              z = (n.lineColor = n.options.lineColor || y),
              E = z;
            c.fillStyle = y;
            c.strokeStyle = z;
            c.lineWidth = n.lineThickness;
            var C = "solid";
            if (c.setLineDash) {
              var B = N(n.nullDataLineDashType, n.lineThickness),
                C = n.lineDashType,
                F = N(C, n.lineThickness);
              c.setLineDash(F);
            }
            for (var R = !0; l < p.length; l++)
              if (
                ((w = p[l].x.getTime ? p[l].x.getTime() : p[l].x),
                !(
                  w < a.axisX.dataInfo.viewPortMin ||
                  (w > a.axisX.dataInfo.viewPortMax &&
                    (!n.connectNullData || !R))
                ))
              )
                if (
                  null !== p[l].y &&
                  p[l].y.length &&
                  "number" === typeof p[l].y[0] &&
                  "number" === typeof p[l].y[1]
                ) {
                  r = a.axisX.convertValueToPixel(w);
                  u = a.axisY.convertValueToPixel(p[l].y[0]);
                  s = a.axisY.convertValueToPixel(p[l].y[1]);
                  q || R
                    ? (n.connectNullData && !q
                        ? (c.setLineDash &&
                            (n.options.nullDataLineDashType ||
                              (C === n.lineDashType &&
                                n.lineDashType !== n.nullDataLineDashType)) &&
                            ((k[k.length - 1].newLineDashArray = F),
                            (C = n.nullDataLineDashType),
                            c.setLineDash(B)),
                          c.lineTo(r, u),
                          v && g.lineTo(r, u),
                          k.push({ x: r, y1: u, y2: s }))
                        : (c.beginPath(),
                          c.moveTo(r, u),
                          (A = { x: r, y: u }),
                          (k = []),
                          k.push({ x: r, y1: u, y2: s }),
                          v && (g.beginPath(), g.moveTo(r, u))),
                      (R = q = !1))
                    : (c.lineTo(r, u),
                      k.push({ x: r, y1: u, y2: s }),
                      v && g.lineTo(r, u),
                      0 == l % 250 && e());
                  w = n.dataPointIds[l];
                  this._eventManager.objectMap[w] = {
                    id: w,
                    objectType: "dataPoint",
                    dataSeriesIndex: m,
                    dataPointIndex: l,
                    x1: r,
                    y1: u,
                    y2: s,
                  };
                  l < p.length - 1 &&
                    (E !== (p[l].lineColor || z) ||
                      C !== (p[l].lineDashType || n.lineDashType)) &&
                    (e(),
                    (E = p[l].lineColor || z),
                    (k[k.length - 1].newStrokeStyle = E),
                    (c.strokeStyle = E),
                    c.setLineDash &&
                      (p[l].lineDashType
                        ? ((C = p[l].lineDashType),
                          (k[k.length - 1].newLineDashArray = N(
                            C,
                            n.lineThickness
                          )),
                          c.setLineDash(k[k.length - 1].newLineDashArray))
                        : ((C = n.lineDashType),
                          (k[k.length - 1].newLineDashArray = F),
                          c.setLineDash(F))));
                  if (
                    0 !== p[l].markerSize &&
                    (0 < p[l].markerSize || 0 < n.markerSize)
                  ) {
                    var da = n.getMarkerProperties(l, r, s, c);
                    h.push(da);
                    var ja = O(w);
                    v &&
                      h.push({
                        x: r,
                        y: s,
                        ctx: g,
                        type: da.type,
                        size: da.size,
                        color: ja,
                        borderColor: ja,
                        borderThickness: da.borderThickness,
                      });
                    da = n.getMarkerProperties(l, r, u, c);
                    h.push(da);
                    ja = O(w);
                    v &&
                      h.push({
                        x: r,
                        y: u,
                        ctx: g,
                        type: da.type,
                        size: da.size,
                        color: ja,
                        borderColor: ja,
                        borderThickness: da.borderThickness,
                      });
                  }
                  if (
                    p[l].indexLabel ||
                    n.indexLabel ||
                    p[l].indexLabelFormatter ||
                    n.indexLabelFormatter
                  )
                    this._indexLabels.push({
                      chartType: "rangeArea",
                      dataPoint: p[l],
                      dataSeries: n,
                      indexKeyword: 0,
                      point: { x: r, y: u },
                      direction:
                        p[l].y[0] > p[l].y[1] === a.axisY.reversed ? -1 : 1,
                      color: y,
                    }),
                      this._indexLabels.push({
                        chartType: "rangeArea",
                        dataPoint: p[l],
                        dataSeries: n,
                        indexKeyword: 1,
                        point: { x: r, y: s },
                        direction:
                          p[l].y[0] > p[l].y[1] === a.axisY.reversed ? 1 : -1,
                        color: y,
                      });
                } else R || q || e(), (R = !0);
            e();
            t.drawMarkers(h);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(d.x1, d.y1, d.width, d.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderRangeSplineArea = function (a) {
      function e(a, b) {
        var e = F(u, 2);
        if (0 < e.length) {
          if (0 < m.lineThickness) {
            c.strokeStyle = b;
            c.setLineDash && c.setLineDash(a);
            c.beginPath();
            c.moveTo(e[0].x, e[0].y);
            for (var h = 0; h < e.length - 3; h += 3) {
              if (e[h].newStrokeStyle || e[h].newLineDashArray)
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(e[h].x, e[h].y),
                  e[h].newStrokeStyle && (c.strokeStyle = e[h].newStrokeStyle),
                  e[h].newLineDashArray && c.setLineDash(e[h].newLineDashArray);
              c.bezierCurveTo(
                e[h + 1].x,
                e[h + 1].y,
                e[h + 2].x,
                e[h + 2].y,
                e[h + 3].x,
                e[h + 3].y
              );
            }
          }
          c.beginPath();
          c.moveTo(e[0].x, e[0].y);
          v && (g.beginPath(), g.moveTo(e[0].x, e[0].y));
          for (h = 0; h < e.length - 3; h += 3)
            c.bezierCurveTo(
              e[h + 1].x,
              e[h + 1].y,
              e[h + 2].x,
              e[h + 2].y,
              e[h + 3].x,
              e[h + 3].y
            ),
              v &&
                g.bezierCurveTo(
                  e[h + 1].x,
                  e[h + 1].y,
                  e[h + 2].x,
                  e[h + 2].y,
                  e[h + 3].x,
                  e[h + 3].y
                );
          e = F(s, 2);
          c.lineTo(s[s.length - 1].x, s[s.length - 1].y);
          for (h = e.length - 1; 2 < h; h -= 3)
            c.bezierCurveTo(
              e[h - 1].x,
              e[h - 1].y,
              e[h - 2].x,
              e[h - 2].y,
              e[h - 3].x,
              e[h - 3].y
            ),
              v &&
                g.bezierCurveTo(
                  e[h - 1].x,
                  e[h - 1].y,
                  e[h - 2].x,
                  e[h - 2].y,
                  e[h - 3].x,
                  e[h - 3].y
                );
          c.closePath();
          c.globalAlpha = m.fillOpacity;
          c.fill();
          v && (g.closePath(), g.fill());
          c.globalAlpha = 1;
          if (0 < m.lineThickness) {
            c.strokeStyle = b;
            c.setLineDash && c.setLineDash(a);
            c.beginPath();
            c.moveTo(e[0].x, e[0].y);
            for (var l = (h = 0); h < e.length - 3; h += 3, l++) {
              if (u[l].newStrokeStyle || u[l].newLineDashArray)
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(e[h].x, e[h].y),
                  u[l].newStrokeStyle && (c.strokeStyle = u[l].newStrokeStyle),
                  u[l].newLineDashArray && c.setLineDash(u[l].newLineDashArray);
              c.bezierCurveTo(
                e[h + 1].x,
                e[h + 1].y,
                e[h + 2].x,
                e[h + 2].y,
                e[h + 3].x,
                e[h + 3].y
              );
            }
            e = F(u, 2);
            c.moveTo(e[0].x, e[0].y);
            for (l = h = 0; h < e.length - 3; h += 3, l++) {
              if (u[l].newStrokeStyle || u[l].newLineDashArray)
                c.stroke(),
                  c.beginPath(),
                  c.moveTo(e[h].x, e[h].y),
                  u[l].newStrokeStyle && (c.strokeStyle = u[l].newStrokeStyle),
                  u[l].newLineDashArray && c.setLineDash(u[l].newLineDashArray);
              c.bezierCurveTo(
                e[h + 1].x,
                e[h + 1].y,
                e[h + 2].x,
                e[h + 2].y,
                e[h + 3].x,
                e[h + 3].y
              );
            }
            c.stroke();
          }
          c.beginPath();
        }
      }
      var b = a.targetCanvasCtx || this.plotArea.ctx,
        c = v ? this._preRenderCtx : b;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var g = this._eventManager.ghostCtx,
          h = [],
          d = this.plotArea;
        c.save();
        v && g.save();
        c.beginPath();
        c.rect(d.x1, d.y1, d.width, d.height);
        c.clip();
        v && (g.beginPath(), g.rect(d.x1, d.y1, d.width, d.height), g.clip());
        for (var f = 0; f < a.dataSeriesIndexes.length; f++) {
          var k = a.dataSeriesIndexes[f],
            m = this.data[k],
            n = m.dataPoints,
            h = m.id;
          this._eventManager.objectMap[h] = {
            objectType: "dataSeries",
            dataSeriesIndex: k,
          };
          h = O(h);
          g.fillStyle = h;
          var h = [],
            p = 0,
            q,
            l,
            r,
            u = [],
            s = [];
          if (0 < n.length) {
            var w = m._colorSet[p % m._colorSet.length],
              A = (m.lineColor = m.options.lineColor || w),
              y = A;
            c.fillStyle = w;
            c.lineWidth = m.lineThickness;
            var z = "solid",
              E;
            if (c.setLineDash) {
              var C = N(m.nullDataLineDashType, m.lineThickness),
                z = m.lineDashType;
              E = N(z, m.lineThickness);
            }
            for (l = !1; p < n.length; p++)
              if (
                ((q = n[p].x.getTime ? n[p].x.getTime() : n[p].x),
                !(
                  q < a.axisX.dataInfo.viewPortMin ||
                  (q > a.axisX.dataInfo.viewPortMax &&
                    (!m.connectNullData || !l))
                ))
              )
                if (
                  null !== n[p].y &&
                  n[p].y.length &&
                  "number" === typeof n[p].y[0] &&
                  "number" === typeof n[p].y[1]
                ) {
                  q = a.axisX.convertValueToPixel(q);
                  l = a.axisY.convertValueToPixel(n[p].y[0]);
                  r = a.axisY.convertValueToPixel(n[p].y[1]);
                  var B = m.dataPointIds[p];
                  this._eventManager.objectMap[B] = {
                    id: B,
                    objectType: "dataPoint",
                    dataSeriesIndex: k,
                    dataPointIndex: p,
                    x1: q,
                    y1: l,
                    y2: r,
                  };
                  u[u.length] = { x: q, y: l };
                  s[s.length] = { x: q, y: r };
                  p < n.length - 1 &&
                    (y !== (n[p].lineColor || A) ||
                      z !== (n[p].lineDashType || m.lineDashType)) &&
                    ((y = n[p].lineColor || A),
                    (u[u.length - 1].newStrokeStyle = y),
                    c.setLineDash &&
                      (n[p].lineDashType
                        ? ((z = n[p].lineDashType),
                          (u[u.length - 1].newLineDashArray = N(
                            z,
                            m.lineThickness
                          )))
                        : ((z = m.lineDashType),
                          (u[u.length - 1].newLineDashArray = E))));
                  if (
                    0 !== n[p].markerSize &&
                    (0 < n[p].markerSize || 0 < m.markerSize)
                  ) {
                    var H = m.getMarkerProperties(p, q, l, c);
                    h.push(H);
                    var R = O(B);
                    v &&
                      h.push({
                        x: q,
                        y: l,
                        ctx: g,
                        type: H.type,
                        size: H.size,
                        color: R,
                        borderColor: R,
                        borderThickness: H.borderThickness,
                      });
                    H = m.getMarkerProperties(p, q, r, c);
                    h.push(H);
                    R = O(B);
                    v &&
                      h.push({
                        x: q,
                        y: r,
                        ctx: g,
                        type: H.type,
                        size: H.size,
                        color: R,
                        borderColor: R,
                        borderThickness: H.borderThickness,
                      });
                  }
                  if (
                    n[p].indexLabel ||
                    m.indexLabel ||
                    n[p].indexLabelFormatter ||
                    m.indexLabelFormatter
                  )
                    this._indexLabels.push({
                      chartType: "rangeSplineArea",
                      dataPoint: n[p],
                      dataSeries: m,
                      indexKeyword: 0,
                      point: { x: q, y: l },
                      direction: n[p].y[0] <= n[p].y[1] ? -1 : 1,
                      color: w,
                    }),
                      this._indexLabels.push({
                        chartType: "rangeSplineArea",
                        dataPoint: n[p],
                        dataSeries: m,
                        indexKeyword: 1,
                        point: { x: q, y: r },
                        direction: n[p].y[0] <= n[p].y[1] ? 1 : -1,
                        color: w,
                      });
                  l = !1;
                } else
                  0 < p &&
                    !l &&
                    (m.connectNullData
                      ? c.setLineDash &&
                        0 < u.length &&
                        (m.options.nullDataLineDashType ||
                          !n[p - 1].lineDashType) &&
                        ((u[u.length - 1].newLineDashArray = C),
                        (z = m.nullDataLineDashType))
                      : (e(E, A), (u = []), (s = []))),
                    (l = !0);
            e(E, A);
            t.drawMarkers(h);
          }
        }
        v &&
          (b.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (c.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            c.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            c.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          c.clearRect(d.x1, d.y1, d.width, d.height),
          this._eventManager.ghostCtx.restore());
        c.restore();
        return {
          source: b,
          dest: this.plotArea.ctx,
          animationCallback: x.xClipAnimation,
          easingFunction: x.easing.linear,
          animationBase: 0,
        };
      }
    };
    s.prototype.renderWaterfall = function (a) {
      var e = a.targetCanvasCtx || this.plotArea.ctx,
        b = v ? this._preRenderCtx : e;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var c = this._eventManager.ghostCtx,
          g = null,
          h = this.plotArea,
          d = 0,
          f,
          k,
          m,
          n,
          p = a.axisY.convertValueToPixel(
            a.axisY.logarithmic ? a.axisY.viewportMinimum : 0
          ),
          d = this.options.dataPointMinWidth
            ? this.dataPointMinWidth
            : this.options.dataPointWidth
            ? this.dataPointWidth
            : 1;
        k = this.options.dataPointMaxWidth
          ? this.dataPointMaxWidth
          : this.options.dataPointWidth
          ? this.dataPointWidth
          : Math.min(
              0.15 * this.width,
              0.9 * (this.plotArea.width / a.plotType.totalDataSeries)
            ) << 0;
        var q = a.axisX.dataInfo.minDiff;
        isFinite(q) || (q = 0.3 * Math.abs(a.axisX.range));
        q = this.options.dataPointWidth
          ? this.dataPointWidth
          : (0.6 *
              ((h.width *
                (a.axisX.logarithmic
                  ? Math.log(q) / Math.log(a.axisX.range)
                  : Math.abs(q) / Math.abs(a.axisX.range))) /
                a.plotType.totalDataSeries)) <<
            0;
        this.dataPointMaxWidth &&
          d > k &&
          (d = Math.min(
            this.options.dataPointWidth ? this.dataPointWidth : Infinity,
            k
          ));
        !this.dataPointMaxWidth &&
          this.dataPointMinWidth &&
          k < d &&
          (k = Math.max(
            this.options.dataPointWidth ? this.dataPointWidth : -Infinity,
            d
          ));
        q < d && (q = d);
        q > k && (q = k);
        b.save();
        v && this._eventManager.ghostCtx.save();
        b.beginPath();
        b.rect(h.x1, h.y1, h.width, h.height);
        b.clip();
        v &&
          (this._eventManager.ghostCtx.beginPath(),
          this._eventManager.ghostCtx.rect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.clip());
        for (var l = 0; l < a.dataSeriesIndexes.length; l++) {
          var r = a.dataSeriesIndexes[l],
            u = this.data[r],
            t = u.dataPoints,
            g = u._colorSet[0];
          u.risingColor = u.options.risingColor ? u.options.risingColor : g;
          u.fallingColor = u.options.fallingColor
            ? u.options.fallingColor
            : "#e40a0a";
          var w =
              "number" === typeof u.options.lineThickness
                ? Math.round(u.lineThickness)
                : 1,
            s = 1 === Math.round(w) % 2 ? -0.5 : 0;
          if (0 < t.length)
            for (
              var y = 5 < q && u.bevelEnabled ? !0 : !1,
                z = !1,
                E = null,
                C = null,
                d = 0;
              d < t.length;
              d++
            )
              if (
                (t[d].getTime ? (n = t[d].x.getTime()) : (n = t[d].x),
                "number" !== typeof t[d].y)
              ) {
                if (0 < d && !z && u.connectNullData)
                  var B =
                    u.options.nullDataLineDashType || !t[d - 1].lineDashType
                      ? u.nullDataLineDashType
                      : t[d - 1].lineDashType;
                z = !0;
              } else {
                f = a.axisX.convertValueToPixel(n);
                k =
                  0 === u.dataPointEOs[d].cumulativeSum
                    ? p
                    : a.axisY.convertValueToPixel(
                        u.dataPointEOs[d].cumulativeSum
                      );
                m =
                  0 === u.dataPointEOs[d].cumulativeSumYStartValue
                    ? p
                    : a.axisY.convertValueToPixel(
                        u.dataPointEOs[d].cumulativeSumYStartValue
                      );
                f = a.axisX.reversed
                  ? (f +
                      (a.plotType.totalDataSeries * q) / 2 -
                      (a.previousDataSeriesCount + l) * q) <<
                    0
                  : (f -
                      (a.plotType.totalDataSeries * q) / 2 +
                      (a.previousDataSeriesCount + l) * q) <<
                    0;
                var F = a.axisX.reversed ? (f - q) << 0 : (f + q) << 0;
                k > m && ((g = k), (k = m), (m = g));
                a.axisY.reversed && ((g = k), (k = m), (m = g));
                g = u.dataPointIds[d];
                this._eventManager.objectMap[g] = {
                  id: g,
                  objectType: "dataPoint",
                  dataSeriesIndex: r,
                  dataPointIndex: d,
                  x1: f,
                  y1: k,
                  x2: F,
                  y2: m,
                };
                var R = t[d].color
                  ? t[d].color
                  : 0 < t[d].y
                  ? u.risingColor
                  : u.fallingColor;
                fa(b, f, k, F, m, R, 0, R, y, y, !1, !1, u.fillOpacity);
                g = O(g);
                v &&
                  fa(
                    this._eventManager.ghostCtx,
                    f,
                    k,
                    F,
                    m,
                    g,
                    0,
                    null,
                    !1,
                    !1,
                    !1,
                    !1
                  );
                var da,
                  R = f;
                da =
                  ("undefined" !== typeof t[d].isIntermediateSum &&
                    !0 === t[d].isIntermediateSum) ||
                  ("undefined" !== typeof t[d].isCumulativeSum &&
                    !0 === t[d].isCumulativeSum)
                    ? 0 < t[d].y
                      ? k
                      : m
                    : 0 < t[d].y
                    ? m
                    : k;
                0 < d &&
                  E &&
                  (!z || u.connectNullData) &&
                  (z && b.setLineDash && b.setLineDash(N(B, w)),
                  b.beginPath(),
                  b.moveTo(E, C - s),
                  b.lineTo(R, da - s),
                  0 < w && b.stroke(),
                  v &&
                    (c.beginPath(),
                    c.moveTo(E, C - s),
                    c.lineTo(R, da - s),
                    0 < w && c.stroke()));
                z = !1;
                E = F;
                C = 0 < t[d].y ? k : m;
                R = t[d].lineDashType
                  ? t[d].lineDashType
                  : u.options.lineDashType
                  ? u.options.lineDashType
                  : "shortDash";
                b.strokeStyle = t[d].lineColor
                  ? t[d].lineColor
                  : u.options.lineColor
                  ? u.options.lineColor
                  : "#9e9e9e";
                b.lineWidth = w;
                b.setLineDash && ((R = N(R, w)), b.setLineDash(R));
                (t[d].indexLabel ||
                  u.indexLabel ||
                  t[d].indexLabelFormatter ||
                  u.indexLabelFormatter) &&
                  this._indexLabels.push({
                    chartType: "waterfall",
                    dataPoint: t[d],
                    dataSeries: u,
                    point: { x: f + (F - f) / 2, y: 0 <= t[d].y ? k : m },
                    direction: 0 > t[d].y === a.axisY.reversed ? 1 : -1,
                    bounds: {
                      x1: f,
                      y1: Math.min(k, m),
                      x2: F,
                      y2: Math.max(k, m),
                    },
                    color: g,
                  });
              }
        }
        v &&
          (e.drawImage(this._preRenderCanvas, 0, 0, this.width, this.height),
          (b.globalCompositeOperation = "source-atop"),
          a.axisX.maskCanvas &&
            b.drawImage(a.axisX.maskCanvas, 0, 0, this.width, this.height),
          a.axisY.maskCanvas &&
            b.drawImage(a.axisY.maskCanvas, 0, 0, this.width, this.height),
          this._breaksCanvasCtx &&
            this._breaksCanvasCtx.drawImage(
              this._preRenderCanvas,
              0,
              0,
              this.width,
              this.height
            ),
          b.clearRect(h.x1, h.y1, h.width, h.height),
          this._eventManager.ghostCtx.restore());
        b.restore();
        return {
          source: e,
          dest: this.plotArea.ctx,
          animationCallback: x.fadeInAnimation,
          easingFunction: x.easing.easeInQuad,
          animationBase: 0,
        };
      }
    };
    var d = function (a, e, b, c, g, h, d, f, k) {
      if (!(0 > b)) {
        "undefined" === typeof f && (f = 1);
        if (!v) {
          var m = Number((d % (2 * Math.PI)).toFixed(8));
          Number((h % (2 * Math.PI)).toFixed(8)) === m && (d -= 1e-4);
        }
        a.save();
        a.globalAlpha = f;
        "pie" === g
          ? (a.beginPath(),
            a.moveTo(e.x, e.y),
            a.arc(e.x, e.y, b, h, d, !1),
            (a.fillStyle = c),
            (a.strokeStyle = "white"),
            (a.lineWidth = 2),
            a.closePath(),
            a.fill())
          : "doughnut" === g &&
            (a.beginPath(),
            a.arc(e.x, e.y, b, h, d, !1),
            0 <= k && a.arc(e.x, e.y, k * b, d, h, !0),
            a.closePath(),
            (a.fillStyle = c),
            (a.strokeStyle = "white"),
            (a.lineWidth = 2),
            a.fill());
        a.globalAlpha = 1;
        a.restore();
      }
    };
    s.prototype.renderPie = function (a) {
      function e() {
        if (m && n) {
          for (var a = 0, c = 0, b = 0, e = 0, g = 0; g < n.length; g++) {
            var h = n[g],
              d = m.dataPointIds[g];
            l[g].id = d;
            l[g].objectType = "dataPoint";
            l[g].dataPointIndex = g;
            l[g].dataSeriesIndex = 0;
            var p = l[g],
              k = { percent: null, total: null },
              r = null,
              k = x.getPercentAndTotal(m, h);
            if (m.indexLabelFormatter || h.indexLabelFormatter)
              r = {
                chart: x.options,
                dataSeries: m,
                dataPoint: h,
                total: k.total,
                percent: k.percent,
              };
            k = h.indexLabelFormatter
              ? h.indexLabelFormatter(r)
              : h.indexLabel
              ? x.replaceKeywordsWithValue(h.indexLabel, h, m, g)
              : m.indexLabelFormatter
              ? m.indexLabelFormatter(r)
              : m.indexLabel
              ? x.replaceKeywordsWithValue(m.indexLabel, h, m, g)
              : h.label
              ? h.label
              : "";
            x._eventManager.objectMap[d] = p;
            p.center = { x: y.x, y: y.y };
            p.y = h.y;
            p.radius = C;
            p.percentInnerRadius = F;
            p.indexLabelText = k;
            p.indexLabelPlacement = m.indexLabelPlacement;
            p.indexLabelLineColor = h.indexLabelLineColor
              ? h.indexLabelLineColor
              : m.options.indexLabelLineColor
              ? m.options.indexLabelLineColor
              : h.color
              ? h.color
              : m._colorSet[g % m._colorSet.length];
            p.indexLabelLineThickness = f(h.indexLabelLineThickness)
              ? m.indexLabelLineThickness
              : h.indexLabelLineThickness;
            p.indexLabelLineDashType = h.indexLabelLineDashType
              ? h.indexLabelLineDashType
              : m.indexLabelLineDashType;
            p.indexLabelFontColor = h.indexLabelFontColor
              ? h.indexLabelFontColor
              : m.indexLabelFontColor;
            p.indexLabelFontStyle = h.indexLabelFontStyle
              ? h.indexLabelFontStyle
              : m.indexLabelFontStyle;
            p.indexLabelFontWeight = h.indexLabelFontWeight
              ? h.indexLabelFontWeight
              : m.indexLabelFontWeight;
            p.indexLabelFontSize = f(h.indexLabelFontSize)
              ? m.indexLabelFontSize
              : h.indexLabelFontSize;
            p.indexLabelFontFamily = h.indexLabelFontFamily
              ? h.indexLabelFontFamily
              : m.indexLabelFontFamily;
            p.indexLabelBackgroundColor = h.indexLabelBackgroundColor
              ? h.indexLabelBackgroundColor
              : m.options.indexLabelBackgroundColor
              ? m.options.indexLabelBackgroundColor
              : m.indexLabelBackgroundColor;
            p.indexLabelMaxWidth = h.indexLabelMaxWidth
              ? h.indexLabelMaxWidth
              : m.indexLabelMaxWidth
              ? m.indexLabelMaxWidth
              : 0.33 * q.width;
            p.indexLabelWrap =
              "undefined" !== typeof h.indexLabelWrap
                ? h.indexLabelWrap
                : m.indexLabelWrap;
            p.indexLabelTextAlign = h.indexLabelTextAlign
              ? h.indexLabelTextAlign
              : m.indexLabelTextAlign
              ? m.indexLabelTextAlign
              : "left";
            p.startAngle =
              0 === g
                ? m.startAngle
                  ? (m.startAngle / 180) * Math.PI
                  : 0
                : l[g - 1].endAngle;
            p.startAngle = (p.startAngle + 2 * Math.PI) % (2 * Math.PI);
            p.endAngle = p.startAngle + ((2 * Math.PI) / z) * Math.abs(h.y);
            h = (p.endAngle + p.startAngle) / 2;
            h = (h + 2 * Math.PI) % (2 * Math.PI);
            p.midAngle = h;
            if (p.midAngle > Math.PI / 2 - w && p.midAngle < Math.PI / 2 + w) {
              if (0 === a || l[b].midAngle > p.midAngle) b = g;
              a++;
            } else if (
              p.midAngle > (3 * Math.PI) / 2 - w &&
              p.midAngle < (3 * Math.PI) / 2 + w
            ) {
              if (0 === c || l[e].midAngle > p.midAngle) e = g;
              c++;
            }
            p.hemisphere =
              h > Math.PI / 2 && h <= (3 * Math.PI) / 2 ? "left" : "right";
            p.indexLabelTextBlock = new na(x.plotArea.ctx, {
              fontSize: p.indexLabelFontSize,
              fontFamily: p.indexLabelFontFamily,
              fontColor: p.indexLabelFontColor,
              fontStyle: p.indexLabelFontStyle,
              fontWeight: p.indexLabelFontWeight,
              textAlign: p.indexLabelTextAlign,
              backgroundColor: p.indexLabelBackgroundColor,
              maxWidth: p.indexLabelMaxWidth,
              maxHeight: p.indexLabelWrap
                ? 5 * p.indexLabelFontSize
                : 1.5 * p.indexLabelFontSize,
              text: p.indexLabelText,
              padding: 0,
              textBaseline: "top",
            });
            p.indexLabelTextBlock.measureText();
          }
          d = h = 0;
          k = !1;
          for (g = 0; g < n.length; g++)
            (p = l[(b + g) % n.length]),
              1 < a &&
                p.midAngle > Math.PI / 2 - w &&
                p.midAngle < Math.PI / 2 + w &&
                (h <= a / 2 && !k
                  ? ((p.hemisphere = "right"), h++)
                  : ((p.hemisphere = "left"), (k = !0)));
          k = !1;
          for (g = 0; g < n.length; g++)
            (p = l[(e + g) % n.length]),
              1 < c &&
                p.midAngle > (3 * Math.PI) / 2 - w &&
                p.midAngle < (3 * Math.PI) / 2 + w &&
                (d <= c / 2 && !k
                  ? ((p.hemisphere = "left"), d++)
                  : ((p.hemisphere = "right"), (k = !0)));
        }
      }
      function b(a) {
        var c = x.plotArea.ctx;
        c.clearRect(q.x1, q.y1, q.width, q.height);
        c.fillStyle = x.backgroundColor;
        c.fillRect(q.x1, q.y1, q.width, q.height);
        for (c = 0; c < n.length; c++) {
          var b = l[c].startAngle,
            e = l[c].endAngle;
          if (e > b) {
            var g = 0.07 * C * Math.cos(l[c].midAngle),
              h = 0.07 * C * Math.sin(l[c].midAngle),
              f = !1;
            if (n[c].exploded) {
              if (
                1e-9 < Math.abs(l[c].center.x - (y.x + g)) ||
                1e-9 < Math.abs(l[c].center.y - (y.y + h))
              )
                (l[c].center.x = y.x + g * a),
                  (l[c].center.y = y.y + h * a),
                  (f = !0);
            } else if (
              0 < Math.abs(l[c].center.x - y.x) ||
              0 < Math.abs(l[c].center.y - y.y)
            )
              (l[c].center.x = y.x + g * (1 - a)),
                (l[c].center.y = y.y + h * (1 - a)),
                (f = !0);
            f &&
              ((g = {}),
              (g.dataSeries = m),
              (g.dataPoint = m.dataPoints[c]),
              (g.index = c),
              x.toolTip.highlightObjects([g]));
            d(
              x.plotArea.ctx,
              l[c].center,
              l[c].radius,
              n[c].color ? n[c].color : m._colorSet[c % m._colorSet.length],
              m.type,
              b,
              e,
              m.fillOpacity,
              l[c].percentInnerRadius
            );
          }
        }
        a = x.plotArea.ctx;
        a.save();
        a.fillStyle = "black";
        a.strokeStyle = "grey";
        a.textBaseline = "middle";
        a.lineJoin = "round";
        for (c = c = 0; c < n.length; c++)
          (b = l[c]),
            b.indexLabelText &&
              ((b.indexLabelTextBlock.y -= b.indexLabelTextBlock.height / 2),
              (e = 0),
              (e =
                "left" === b.hemisphere
                  ? "inside" !== m.indexLabelPlacement
                    ? -(b.indexLabelTextBlock.width + p)
                    : -b.indexLabelTextBlock.width / 2
                  : "inside" !== m.indexLabelPlacement
                  ? p
                  : -b.indexLabelTextBlock.width / 2),
              (b.indexLabelTextBlock.x += e),
              b.indexLabelTextBlock.render(!0),
              (b.indexLabelTextBlock.x -= e),
              (b.indexLabelTextBlock.y += b.indexLabelTextBlock.height / 2),
              "inside" !== b.indexLabelPlacement &&
                0 < b.indexLabelLineThickness &&
                ((e = b.center.x + C * Math.cos(b.midAngle)),
                (g = b.center.y + C * Math.sin(b.midAngle)),
                (a.strokeStyle = b.indexLabelLineColor),
                (a.lineWidth = b.indexLabelLineThickness),
                a.setLineDash &&
                  a.setLineDash(
                    N(b.indexLabelLineDashType, b.indexLabelLineThickness)
                  ),
                a.beginPath(),
                a.moveTo(e, g),
                a.lineTo(b.indexLabelTextBlock.x, b.indexLabelTextBlock.y),
                a.lineTo(
                  b.indexLabelTextBlock.x + ("left" === b.hemisphere ? -p : p),
                  b.indexLabelTextBlock.y
                ),
                a.stroke()),
              (a.lineJoin = "miter"));
        a.save();
      }
      function c(a, c) {
        var b = 0,
          b = a.indexLabelTextBlock.y - a.indexLabelTextBlock.height / 2,
          e = a.indexLabelTextBlock.y + a.indexLabelTextBlock.height / 2,
          g = c.indexLabelTextBlock.y - c.indexLabelTextBlock.height / 2,
          h = c.indexLabelTextBlock.y + c.indexLabelTextBlock.height / 2;
        return (b =
          c.indexLabelTextBlock.y > a.indexLabelTextBlock.y ? g - e : b - h);
      }
      function g(a) {
        for (var b = null, e = 1; e < n.length; e++)
          if (
            ((b = (a + e + l.length) % l.length),
            l[b].hemisphere !== l[a].hemisphere)
          ) {
            b = null;
            break;
          } else if (
            l[b].indexLabelText &&
            b !== a &&
            (0 > c(l[b], l[a]) ||
              ("right" === l[a].hemisphere
                ? l[b].indexLabelTextBlock.y >= l[a].indexLabelTextBlock.y
                : l[b].indexLabelTextBlock.y <= l[a].indexLabelTextBlock.y))
          )
            break;
          else b = null;
        return b;
      }
      function h(a, b, e) {
        e = (e || 0) + 1;
        if (1e3 < e) return 0;
        b = b || 0;
        var d = 0,
          f = y.y - 1 * t,
          m = y.y + 1 * t;
        if (0 <= a && a < n.length) {
          var p = l[a];
          if (
            (0 > b && p.indexLabelTextBlock.y < f) ||
            (0 < b && p.indexLabelTextBlock.y > m)
          )
            return 0;
          var q = 0,
            k = 0,
            k = (q = q = 0);
          0 > b
            ? p.indexLabelTextBlock.y - p.indexLabelTextBlock.height / 2 > f &&
              p.indexLabelTextBlock.y - p.indexLabelTextBlock.height / 2 + b <
                f &&
              (b = -(
                f -
                (p.indexLabelTextBlock.y - p.indexLabelTextBlock.height / 2 + b)
              ))
            : p.indexLabelTextBlock.y + p.indexLabelTextBlock.height / 2 < f &&
              p.indexLabelTextBlock.y + p.indexLabelTextBlock.height / 2 + b >
                m &&
              (b =
                p.indexLabelTextBlock.y +
                p.indexLabelTextBlock.height / 2 +
                b -
                m);
          b = p.indexLabelTextBlock.y + b;
          f = 0;
          f =
            "right" === p.hemisphere
              ? y.x + Math.sqrt(Math.pow(t, 2) - Math.pow(b - y.y, 2))
              : y.x - Math.sqrt(Math.pow(t, 2) - Math.pow(b - y.y, 2));
          k = y.x + C * Math.cos(p.midAngle);
          q = y.y + C * Math.sin(p.midAngle);
          q = Math.sqrt(Math.pow(f - k, 2) + Math.pow(b - q, 2));
          k = Math.acos(C / t);
          q = Math.acos((t * t + C * C - q * q) / (2 * C * t));
          b = q < k ? b - p.indexLabelTextBlock.y : 0;
          f = null;
          for (m = 1; m < n.length; m++)
            if (
              ((f = (a - m + l.length) % l.length),
              l[f].hemisphere !== l[a].hemisphere)
            ) {
              f = null;
              break;
            } else if (
              l[f].indexLabelText &&
              l[f].hemisphere === l[a].hemisphere &&
              f !== a &&
              (0 > c(l[f], l[a]) ||
                ("right" === l[a].hemisphere
                  ? l[f].indexLabelTextBlock.y <= l[a].indexLabelTextBlock.y
                  : l[f].indexLabelTextBlock.y >= l[a].indexLabelTextBlock.y))
            )
              break;
            else f = null;
          k = f;
          q = g(a);
          m = f = 0;
          0 > b
            ? ((m = "right" === p.hemisphere ? k : q),
              (d = b),
              null !== m &&
                ((k = -b),
                (b =
                  p.indexLabelTextBlock.y -
                  p.indexLabelTextBlock.height / 2 -
                  (l[m].indexLabelTextBlock.y +
                    l[m].indexLabelTextBlock.height / 2)),
                b - k < r &&
                  ((f = -k),
                  (m = h(m, f, e + 1)),
                  +m.toFixed(s) > +f.toFixed(s) &&
                    (d = b > r ? -(b - r) : -(k - (m - f))))))
            : 0 < b &&
              ((m = "right" === p.hemisphere ? q : k),
              (d = b),
              null !== m &&
                ((k = b),
                (b =
                  l[m].indexLabelTextBlock.y -
                  l[m].indexLabelTextBlock.height / 2 -
                  (p.indexLabelTextBlock.y + p.indexLabelTextBlock.height / 2)),
                b - k < r &&
                  ((f = k),
                  (m = h(m, f, e + 1)),
                  +m.toFixed(s) < +f.toFixed(s) &&
                    (d = b > r ? b - r : k - (f - m)))));
          d &&
            ((e = p.indexLabelTextBlock.y + d),
            (b = 0),
            (b =
              "right" === p.hemisphere
                ? y.x + Math.sqrt(Math.pow(t, 2) - Math.pow(e - y.y, 2))
                : y.x - Math.sqrt(Math.pow(t, 2) - Math.pow(e - y.y, 2))),
            p.midAngle > Math.PI / 2 - w && p.midAngle < Math.PI / 2 + w
              ? ((f = (a - 1 + l.length) % l.length),
                (f = l[f]),
                (a = l[(a + 1 + l.length) % l.length]),
                "left" === p.hemisphere &&
                "right" === f.hemisphere &&
                b > f.indexLabelTextBlock.x
                  ? (b = f.indexLabelTextBlock.x - 15)
                  : "right" === p.hemisphere &&
                    "left" === a.hemisphere &&
                    b < a.indexLabelTextBlock.x &&
                    (b = a.indexLabelTextBlock.x + 15))
              : p.midAngle > (3 * Math.PI) / 2 - w &&
                p.midAngle < (3 * Math.PI) / 2 + w &&
                ((f = (a - 1 + l.length) % l.length),
                (f = l[f]),
                (a = l[(a + 1 + l.length) % l.length]),
                "right" === p.hemisphere &&
                "left" === f.hemisphere &&
                b < f.indexLabelTextBlock.x
                  ? (b = f.indexLabelTextBlock.x + 15)
                  : "left" === p.hemisphere &&
                    "right" === a.hemisphere &&
                    b > a.indexLabelTextBlock.x &&
                    (b = a.indexLabelTextBlock.x - 15)),
            (p.indexLabelTextBlock.y = e),
            (p.indexLabelTextBlock.x = b),
            (p.indexLabelAngle = Math.atan2(
              p.indexLabelTextBlock.y - y.y,
              p.indexLabelTextBlock.x - y.x
            )));
        }
        return d;
      }
      function k() {
        var a = x.plotArea.ctx;
        a.fillStyle = "grey";
        a.strokeStyle = "grey";
        a.font = "16px Arial";
        a.textBaseline = "middle";
        for (
          var b = (a = 0), e = 0, d = !0, b = 0;
          10 > b && (1 > b || 0 < e);
          b++
        ) {
          if (
            m.radius ||
            (!m.radius &&
              "undefined" !== typeof m.innerRadius &&
              null !== m.innerRadius &&
              C - e <= B)
          )
            d = !1;
          d && (C -= e);
          e = 0;
          if ("inside" !== m.indexLabelPlacement) {
            t = C * v;
            for (a = 0; a < n.length; a++) {
              var f = l[a];
              f.indexLabelTextBlock.x = y.x + t * Math.cos(f.midAngle);
              f.indexLabelTextBlock.y = y.y + t * Math.sin(f.midAngle);
              f.indexLabelAngle = f.midAngle;
              f.radius = C;
              f.percentInnerRadius = F;
            }
            for (var u, D, a = 0; a < n.length; a++) {
              var f = l[a],
                w = g(a);
              if (null !== w) {
                u = l[a];
                D = l[w];
                var xa = 0,
                  xa = c(u, D) - r;
                if (0 > xa) {
                  for (var z = (D = 0), E = 0; E < n.length; E++)
                    E !== a &&
                      l[E].hemisphere === f.hemisphere &&
                      (l[E].indexLabelTextBlock.y < f.indexLabelTextBlock.y
                        ? D++
                        : z++);
                  D = (xa / (D + z || 1)) * z;
                  var z = -1 * (xa - D),
                    ca = (E = 0);
                  "right" === f.hemisphere
                    ? ((E = h(a, D)),
                      (z = -1 * (xa - E)),
                      (ca = h(w, z)),
                      +ca.toFixed(s) < +z.toFixed(s) &&
                        +E.toFixed(s) <= +D.toFixed(s) &&
                        h(a, -(z - ca)))
                    : ((E = h(w, D)),
                      (z = -1 * (xa - E)),
                      (ca = h(a, z)),
                      +ca.toFixed(s) < +z.toFixed(s) &&
                        +E.toFixed(s) <= +D.toFixed(s) &&
                        h(w, -(z - ca)));
                }
              }
            }
          } else
            for (a = 0; a < n.length; a++)
              (f = l[a]),
                (t = "pie" === m.type ? 0.7 * C : 0.8 * C),
                (w = y.x + t * Math.cos(f.midAngle)),
                (D = y.y + t * Math.sin(f.midAngle)),
                (f.indexLabelTextBlock.x = w),
                (f.indexLabelTextBlock.y = D);
          for (a = 0; a < n.length; a++)
            if (
              ((f = l[a]),
              (w = f.indexLabelTextBlock.measureText()),
              0 !== w.height && 0 !== w.width)
            )
              (w = w = 0),
                "right" === f.hemisphere
                  ? ((w =
                      q.x2 -
                      (f.indexLabelTextBlock.x +
                        f.indexLabelTextBlock.width +
                        p)),
                    (w *= -1))
                  : (w =
                      q.x1 -
                      (f.indexLabelTextBlock.x -
                        f.indexLabelTextBlock.width -
                        p)),
                0 < w &&
                  (!d &&
                    f.indexLabelText &&
                    ((D =
                      "right" === f.hemisphere
                        ? q.x2 - f.indexLabelTextBlock.x
                        : f.indexLabelTextBlock.x - q.x1),
                    0.3 * f.indexLabelTextBlock.maxWidth > D
                      ? (f.indexLabelText = "")
                      : (f.indexLabelTextBlock.maxWidth = 0.85 * D),
                    0.3 * f.indexLabelTextBlock.maxWidth < D &&
                      (f.indexLabelTextBlock.x -=
                        "right" === f.hemisphere ? 2 : -2)),
                  Math.abs(
                    f.indexLabelTextBlock.y -
                      f.indexLabelTextBlock.height / 2 -
                      y.y
                  ) < C ||
                    Math.abs(
                      f.indexLabelTextBlock.y +
                        f.indexLabelTextBlock.height / 2 -
                        y.y
                    ) < C) &&
                  ((w /= Math.abs(Math.cos(f.indexLabelAngle))),
                  9 < w && (w *= 0.3),
                  w > e && (e = w)),
                (w = w = 0),
                0 < f.indexLabelAngle && f.indexLabelAngle < Math.PI
                  ? ((w =
                      q.y2 -
                      (f.indexLabelTextBlock.y +
                        f.indexLabelTextBlock.height / 2 +
                        5)),
                    (w *= -1))
                  : (w =
                      q.y1 -
                      (f.indexLabelTextBlock.y -
                        f.indexLabelTextBlock.height / 2 -
                        5)),
                0 < w &&
                  (!d &&
                    f.indexLabelText &&
                    ((D =
                      0 < f.indexLabelAngle && f.indexLabelAngle < Math.PI
                        ? -1
                        : 1),
                    0 === h(a, w * D) && h(a, 2 * D)),
                  Math.abs(f.indexLabelTextBlock.x - y.x) < C &&
                    ((w /= Math.abs(Math.sin(f.indexLabelAngle))),
                    9 < w && (w *= 0.3),
                    w > e && (e = w)));
          var H = function (a, b, c) {
            for (
              var e = [], g = 0;
              e.push(l[b]), b !== c;
              b = (b + 1 + n.length) % n.length
            );
            e.sort(function (a, b) {
              return a.y - b.y;
            });
            for (b = 0; b < e.length; b++)
              if (((c = e[b]), g < 0.7 * a))
                (g += c.indexLabelTextBlock.height),
                  (c.indexLabelTextBlock.text = ""),
                  (c.indexLabelText = ""),
                  c.indexLabelTextBlock.measureText();
              else break;
          };
          (function () {
            for (var a = -1, b = -1, e = 0, h = !1, f = 0; f < n.length; f++)
              if (((h = !1), (u = l[f]), u.indexLabelText)) {
                var d = g(f);
                if (null !== d) {
                  var m = l[d];
                  xa = 0;
                  xa = c(u, m);
                  var q;
                  if ((q = 0 > xa)) {
                    q = u.indexLabelTextBlock.x;
                    var k =
                        u.indexLabelTextBlock.y -
                        u.indexLabelTextBlock.height / 2,
                      r =
                        u.indexLabelTextBlock.y +
                        u.indexLabelTextBlock.height / 2,
                      D =
                        m.indexLabelTextBlock.y -
                        m.indexLabelTextBlock.height / 2,
                      x = m.indexLabelTextBlock.x + m.indexLabelTextBlock.width,
                      w =
                        m.indexLabelTextBlock.y +
                        m.indexLabelTextBlock.height / 2;
                    q =
                      u.indexLabelTextBlock.x + u.indexLabelTextBlock.width <
                        m.indexLabelTextBlock.x - p ||
                      q > x + p ||
                      k > w + p ||
                      r < D - p
                        ? !1
                        : !0;
                  }
                  q
                    ? (0 > a && (a = f),
                      d !== a && ((b = d), (e += -xa)),
                      0 === f % Math.max(n.length / 10, 3) && (h = !0))
                    : (h = !0);
                  h &&
                    0 < e &&
                    0 <= a &&
                    0 <= b &&
                    (H(e, a, b), (b = a = -1), (e = 0));
                }
              }
            0 < e && H(e, a, b);
          })();
        }
      }
      function u() {
        x.plotArea.layoutManager.reset();
        x.title &&
          (x.title.dockInsidePlotArea ||
            ("center" === x.title.horizontalAlign &&
              "center" === x.title.verticalAlign)) &&
          x.title.render();
        if (x.subtitles)
          for (var a = 0; a < x.subtitles.length; a++) {
            var b = x.subtitles[a];
            (b.dockInsidePlotArea ||
              ("center" === b.horizontalAlign &&
                "center" === b.verticalAlign)) &&
              b.render();
          }
        x.legend &&
          (x.legend.dockInsidePlotArea ||
            ("center" === x.legend.horizontalAlign &&
              "center" === x.legend.verticalAlign)) &&
          (x.legend.setLayout(), x.legend.render());
      }
      var x = this;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        var m = this.data[a.dataSeriesIndexes[0]],
          n = m.dataPoints,
          p = 10,
          q = this.plotArea,
          l = m.dataPointEOs,
          r = 2,
          t,
          v = 1.3,
          w = (20 / 180) * Math.PI,
          s = 6,
          y = { x: (q.x2 + q.x1) / 2, y: (q.y2 + q.y1) / 2 },
          z = 0;
        a = !1;
        for (var E = 0; E < n.length; E++)
          (z += Math.abs(n[E].y)),
            !a &&
              "undefined" !== typeof n[E].indexLabel &&
              null !== n[E].indexLabel &&
              0 < n[E].indexLabel.toString().length &&
              (a = !0),
            !a &&
              "undefined" !== typeof n[E].label &&
              null !== n[E].label &&
              0 < n[E].label.toString().length &&
              (a = !0);
        if (0 !== z) {
          a =
            a ||
            ("undefined" !== typeof m.indexLabel &&
              null !== m.indexLabel &&
              0 < m.indexLabel.toString().length);
          var C =
            "inside" !== m.indexLabelPlacement && a
              ? (0.75 * Math.min(q.width, q.height)) / 2
              : (0.92 * Math.min(q.width, q.height)) / 2;
          m.radius && (C = Wa(m.radius, C));
          var B =
            "undefined" !== typeof m.innerRadius && null !== m.innerRadius
              ? Wa(m.innerRadius, C)
              : 0.7 * C;
          m.radius = C;
          "doughnut" === m.type && (m.innerRadius = B);
          var F = Math.min(B / C, (C - 1) / C);
          this.pieDoughnutClickHandler = function (a) {
            x.isAnimating ||
              (!f(a.dataSeries.explodeOnClick) &&
                !a.dataSeries.explodeOnClick) ||
              ((a = a.dataPoint),
              (a.exploded = a.exploded ? !1 : !0),
              1 < this.dataPoints.length &&
                x._animator.animate(0, 500, function (a) {
                  b(a);
                  u();
                  x.dispatchEvent("dataAnimationIterationEnd", { chart: x });
                  x.dispatchEvent("dataAnimationEnd", { chart: x });
                }));
          };
          e();
          k();
          k();
          k();
          k();
          this.disableToolTip = !0;
          this._animator.animate(
            0,
            this.animatedRender ? this.animationDuration : 0,
            function (a) {
              var b = x.plotArea.ctx;
              b.clearRect(q.x1, q.y1, q.width, q.height);
              b.fillStyle = x.backgroundColor;
              b.fillRect(q.x1, q.y1, q.width, q.height);
              for (
                var b = l[0].startAngle + 2 * Math.PI * a, c = 0;
                c < n.length;
                c++
              ) {
                var e = 0 === c ? l[c].startAngle : g,
                  g = e + (l[c].endAngle - l[c].startAngle),
                  h = !1;
                g > b && ((g = b), (h = !0));
                var f = n[c].color
                  ? n[c].color
                  : m._colorSet[c % m._colorSet.length];
                g > e &&
                  d(
                    x.plotArea.ctx,
                    l[c].center,
                    l[c].radius,
                    f,
                    m.type,
                    e,
                    g,
                    m.fillOpacity,
                    l[c].percentInnerRadius
                  );
                if (h) break;
              }
              u();
              x.dispatchEvent("dataAnimationIterationEnd", { chart: x });
              1 <= a && x.dispatchEvent("dataAnimationEnd", { chart: x });
            },
            function () {
              x.disableToolTip = !1;
              x._animator.animate(0, x.animatedRender ? 500 : 0, function (a) {
                b(a);
                u();
                x.dispatchEvent("dataAnimationIterationEnd", { chart: x });
              });
              x.dispatchEvent("dataAnimationEnd", { chart: x });
            }
          );
        }
      }
    };
    var u = function (a, e, b, c) {
      "undefined" === typeof b && (b = 1);
      0 >= Math.round(e.y4 - e.y1) ||
        (a.save(),
        (a.globalAlpha = b),
        a.beginPath(),
        a.moveTo(Math.round(e.x1), Math.round(e.y1)),
        a.lineTo(Math.round(e.x2), Math.round(e.y2)),
        a.lineTo(Math.round(e.x3), Math.round(e.y3)),
        a.lineTo(Math.round(e.x4), Math.round(e.y4)),
        "undefined" !== e.x5 &&
          (a.lineTo(Math.round(e.x5), Math.round(e.y5)),
          a.lineTo(Math.round(e.x6), Math.round(e.y6))),
        a.closePath(),
        (a.fillStyle = c ? c : e.color),
        a.fill(),
        (a.globalAplha = 1),
        a.restore());
    };
    s.prototype.renderFunnel = function (a) {
      function e() {
        for (var a = 0, b = [], c = 0; c < A.length; c++) {
          if ("undefined" === typeof A[c].y) return -1;
          A[c].y = "number" === typeof A[c].y ? A[c].y : 0;
          a += Math.abs(A[c].y);
        }
        if (0 === a) return -1;
        for (c = b[0] = 0; c < A.length; c++)
          b.push((Math.abs(A[c].y) * F) / a);
        return b;
      }
      function b() {
        var a = Z,
          b = Y,
          c = S,
          e = fa,
          g,
          h;
        g = P;
        h = U - M;
        e = Math.abs(((h - g) * (b - a + (e - c))) / 2);
        c = fa - S;
        g = h - g;
        h = c * (h - U);
        h = Math.abs(h);
        h = e + h;
        for (var e = [], l = 0, f = 0; f < A.length; f++) {
          if ("undefined" === typeof A[f].y) return -1;
          A[f].y = "number" === typeof A[f].y ? A[f].y : 0;
          l += Math.abs(A[f].y);
        }
        if (0 === l) return -1;
        for (
          var d = (e[0] = 0), m = 0, n, p, b = b - a, d = !1, f = 0;
          f < A.length;
          f++
        )
          (a = (Math.abs(A[f].y) * h) / l),
            d
              ? (n = 0 == Number(c.toFixed(3)) ? 0 : a / c)
              : ((p = ha * ha * b * b - 4 * Math.abs(ha) * a),
                0 > p
                  ? ((p = c),
                    (d = ((b + p) * (g - m)) / 2),
                    (a -= d),
                    (n = g - m),
                    (m += g - m),
                    (n += 0 == p ? 0 : a / p),
                    (m += a / p),
                    (d = !0))
                  : ((n = (Math.abs(ha) * b - Math.sqrt(p)) / 2),
                    (p = b - (2 * n) / Math.abs(ha)),
                    (m += n),
                    m > g &&
                      ((m -= n),
                      (p = c),
                      (d = ((b + p) * (g - m)) / 2),
                      (a -= d),
                      (n = g - m),
                      (m += g - m),
                      (n += a / p),
                      (m += a / p),
                      (d = !0)),
                    (b = p))),
            e.push(n);
        return e;
      }
      function c() {
        if (w && A) {
          for (
            var a,
              b,
              c,
              e,
              g,
              h,
              d,
              m,
              p,
              n,
              q,
              k,
              r,
              u,
              D,
              x = [],
              t = [],
              s = { percent: null, total: null },
              J = null,
              z = 0;
            z < A.length;
            z++
          )
            (D = T[z]),
              (D =
                "undefined" !== typeof D.x5
                  ? (D.y2 + D.y4) / 2
                  : (D.y2 + D.y3) / 2),
              (D = l(D).x2 + 1),
              (x[z] = K - D - O);
          D = 0.5 * O;
          for (var z = 0, C = A.length - 1; z < A.length || 0 <= C; z++, C--) {
            b = w.reversed ? A[C] : A[z];
            a = b.color
              ? b.color
              : w.reversed
              ? w._colorSet[(A.length - 1 - z) % w._colorSet.length]
              : w._colorSet[z % w._colorSet.length];
            c = b.indexLabelPlacement || w.indexLabelPlacement || "outside";
            u = b.indexLabelTextAlign || w.indexLabelTextAlign || "left";
            e =
              b.indexLabelBackgroundColor ||
              w.indexLabelBackgroundColor ||
              (v ? "transparent" : null);
            g = b.indexLabelFontColor || w.indexLabelFontColor || "#979797";
            h = f(b.indexLabelFontSize)
              ? w.indexLabelFontSize
              : b.indexLabelFontSize;
            d = b.indexLabelFontStyle || w.indexLabelFontStyle || "normal";
            m = b.indexLabelFontFamily || w.indexLabelFontFamily || "arial";
            p = b.indexLabelFontWeight || w.indexLabelFontWeight || "normal";
            a = b.indexLabelLineColor || w.options.indexLabelLineColor || a;
            n =
              "number" === typeof b.indexLabelLineThickness
                ? b.indexLabelLineThickness
                : "number" === typeof w.indexLabelLineThickness
                ? w.indexLabelLineThickness
                : 2;
            q = b.indexLabelLineDashType || w.indexLabelLineDashType || "solid";
            k =
              "undefined" !== typeof b.indexLabelWrap
                ? b.indexLabelWrap
                : "undefined" !== typeof w.indexLabelWrap
                ? w.indexLabelWrap
                : !0;
            r = w.dataPointIds[z];
            y._eventManager.objectMap[r] = {
              id: r,
              objectType: "dataPoint",
              dataPointIndex: z,
              dataSeriesIndex: 0,
              funnelSection: T[w.reversed ? A.length - 1 - z : z],
            };
            "inside" === w.indexLabelPlacement &&
              ((x[z] =
                z !== ea
                  ? w.reversed
                    ? T[z].x2 - T[z].x1
                    : T[z].x3 - T[z].x4
                  : T[z].x3 - T[z].x6),
              20 > x[z] &&
                ((x[z] =
                  z !== ea
                    ? w.reversed
                      ? T[z].x3 - T[z].x4
                      : T[z].x2 - T[z].x1
                    : T[z].x2 - T[z].x1),
                (x[z] /= 2)));
            r = b.indexLabelMaxWidth
              ? b.indexLabelMaxWidth
              : w.options.indexLabelMaxWidth
              ? w.indexLabelMaxWidth
              : x[z];
            if (r > x[z] || 0 > r) r = x[z];
            t[z] = "inside" === w.indexLabelPlacement ? T[z].height : !1;
            s = y.getPercentAndTotal(w, b);
            if (w.indexLabelFormatter || b.indexLabelFormatter)
              J = {
                chart: y.options,
                dataSeries: w,
                dataPoint: b,
                total: s.total,
                percent: s.percent,
              };
            b = b.indexLabelFormatter
              ? b.indexLabelFormatter(J)
              : b.indexLabel
              ? y.replaceKeywordsWithValue(b.indexLabel, b, w, z)
              : w.indexLabelFormatter
              ? w.indexLabelFormatter(J)
              : w.indexLabel
              ? y.replaceKeywordsWithValue(w.indexLabel, b, w, z)
              : b.label
              ? b.label
              : "";
            0 >= n && (n = 0);
            1e3 > r && 1e3 - r < D && (r += 1e3 - r);
            Q.roundRect || Ha(Q);
            c = new na(Q, {
              fontSize: h,
              fontFamily: m,
              fontColor: g,
              fontStyle: d,
              fontWeight: p,
              horizontalAlign: c,
              textAlign: u,
              backgroundColor: e,
              maxWidth: r,
              maxHeight: !1 === t[z] ? (k ? 4.28571429 * h : 1.5 * h) : t[z],
              text: b,
              padding: ia,
            });
            c.measureText();
            I.push({
              textBlock: c,
              id: w.reversed ? C : z,
              isDirty: !1,
              lineColor: a,
              lineThickness: n,
              lineDashType: q,
              height: c.height < c.maxHeight ? c.height : c.maxHeight,
              width: c.width < c.maxWidth ? c.width : c.maxWidth,
            });
          }
        }
      }
      function g() {
        var a,
          b,
          c,
          e,
          g,
          h = [];
        g = !1;
        c = 0;
        for (
          var l,
            f = K - Y - O / 2,
            f = w.options.indexLabelMaxWidth
              ? w.indexLabelMaxWidth > f
                ? f
                : w.indexLabelMaxWidth
              : f,
            d = I.length - 1;
          0 <= d;
          d--
        ) {
          l = A[I[d].id];
          c = I[d];
          e = c.textBlock;
          b = (a = q(d) < T.length ? I[q(d)] : null) ? a.textBlock : null;
          c = c.height;
          a && e.y + c + ia > b.y && (g = !0);
          c = l.indexLabelMaxWidth || f;
          if (c > f || 0 > c) c = f;
          h.push(c);
        }
        if (g)
          for (d = I.length - 1; 0 <= d; d--)
            (a = T[d]),
              (I[d].textBlock.maxWidth = h[h.length - (d + 1)]),
              I[d].textBlock.measureText(),
              (I[d].textBlock.x = K - f),
              (c =
                I[d].textBlock.height < I[d].textBlock.maxHeight
                  ? I[d].textBlock.height
                  : I[d].textBlock.maxHeight),
              (g =
                I[d].textBlock.width < I[d].textBlock.maxWidth
                  ? I[d].textBlock.width
                  : I[d].textBlock.maxWidth),
              (I[d].height = c),
              (I[d].width = g),
              (c =
                "undefined" !== typeof a.x5
                  ? (a.y2 + a.y4) / 2
                  : (a.y2 + a.y3) / 2),
              (I[d].textBlock.y = c - I[d].height / 2),
              w.reversed
                ? (I[d].textBlock.y + I[d].height > W + B &&
                    (I[d].textBlock.y = W + B - I[d].height),
                  I[d].textBlock.y < Da - B && (I[d].textBlock.y = Da - B))
                : (I[d].textBlock.y < W - B && (I[d].textBlock.y = W - B),
                  I[d].textBlock.y + I[d].height > Da + B &&
                    (I[d].textBlock.y = Da + B - I[d].height));
      }
      function h() {
        var a, b, c, e;
        if ("inside" !== w.indexLabelPlacement)
          for (var g = 0; g < T.length; g++)
            0 == I[g].textBlock.text.length
              ? (I[g].isDirty = !0)
              : ((a = T[g]),
                (c =
                  "undefined" !== typeof a.x5
                    ? (a.y2 + a.y4) / 2
                    : (a.y2 + a.y3) / 2),
                (b = w.reversed
                  ? "undefined" !== typeof a.x5
                    ? c > $
                      ? l(c).x2 + 1
                      : (a.x2 + a.x3) / 2 + 1
                    : (a.x2 + a.x3) / 2 + 1
                  : "undefined" !== typeof a.x5
                  ? c < $
                    ? l(c).x2 + 1
                    : (a.x4 + a.x3) / 2 + 1
                  : (a.x2 + a.x3) / 2 + 1),
                (I[g].textBlock.x = b + O),
                (I[g].textBlock.y = c - I[g].height / 2),
                w.reversed
                  ? (I[g].textBlock.y + I[g].height > W + B &&
                      (I[g].textBlock.y = W + B - I[g].height),
                    I[g].textBlock.y < Da - B && (I[g].textBlock.y = Da - B))
                  : (I[g].textBlock.y < W - B && (I[g].textBlock.y = W - B),
                    I[g].textBlock.y + I[g].height > Da + B &&
                      (I[g].textBlock.y = Da + B - I[g].height)));
        else
          for (g = 0; g < T.length; g++)
            0 == I[g].textBlock.text.length
              ? (I[g].isDirty = !0)
              : ((a = T[g]),
                (b = a.height),
                (c = I[g].height),
                (e = I[g].width),
                b >= c
                  ? ((b =
                      g != ea
                        ? (a.x4 + a.x3) / 2 - e / 2
                        : (a.x5 + a.x4) / 2 - e / 2),
                    (c =
                      g != ea
                        ? (a.y1 + a.y3) / 2 - c / 2
                        : (a.y1 + a.y4) / 2 - c / 2),
                    (I[g].textBlock.x = b),
                    (I[g].textBlock.y = c))
                  : (I[g].isDirty = !0));
      }
      function d() {
        function a(b, c) {
          var e;
          if (0 > b || b >= I.length) return 0;
          var g,
            h = I[b].textBlock;
          if (0 > c) {
            c *= -1;
            g = p(b);
            e = k(g, b);
            if (e >= c) return (h.y -= c), c;
            if (0 == b) return 0 < e && (h.y -= e), e;
            e += a(g, -(c - e));
            0 < e && (h.y -= e);
            return e;
          }
          g = q(b);
          e = k(b, g);
          if (e >= c) return (h.y += c), c;
          if (b == T.length - 1) return 0 < e && (h.y += e), e;
          e += a(g, c - e);
          0 < e && (h.y += e);
          return e;
        }
        function b() {
          var a,
            e,
            g,
            h,
            l = 0,
            d;
          h = (U - P + 2 * B) / n;
          d = n;
          for (var f, m = 1; m < d; m++) {
            g = m * h;
            for (var k = I.length - 1; 0 <= k; k--)
              !I[k].isDirty &&
                I[k].textBlock.y < g &&
                I[k].textBlock.y + I[k].height > g &&
                ((f = q(k)),
                !(f >= I.length - 1) &&
                  I[k].textBlock.y + I[k].height + ia > I[f].textBlock.y &&
                  (I[k].textBlock.y =
                    I[k].textBlock.y + I[k].height - g > g - I[k].textBlock.y
                      ? g + 1
                      : g - I[k].height - 1));
          }
          for (f = T.length - 1; 0 < f; f--)
            if (!I[f].isDirty) {
              g = p(f);
              if (0 > g && ((g = 0), I[g].isDirty)) break;
              if (I[f].textBlock.y < I[g].textBlock.y + I[g].height) {
                e = e || f;
                h = f;
                for (
                  d = 0;
                  I[h].textBlock.y < I[g].textBlock.y + I[g].height + ia;

                ) {
                  a = a || I[h].textBlock.y + I[h].height;
                  d += I[h].height;
                  d += ia;
                  h = g;
                  if (0 >= h) {
                    h = 0;
                    d += I[h].height;
                    break;
                  }
                  g = p(h);
                  if (0 > g) {
                    h = 0;
                    d += I[h].height;
                    break;
                  }
                }
                if (h != f) {
                  l = I[h].textBlock.y;
                  a -= l;
                  a = d - a;
                  l = c(a, e, h);
                  break;
                }
              }
            }
          return l;
        }
        function c(a, b, e) {
          var g = [],
            h = 0,
            d = 0;
          for (a = Math.abs(a); e <= b; e++) g.push(T[e]);
          g.sort(function (a, b) {
            return a.height - b.height;
          });
          for (e = 0; e < g.length; e++)
            if (((b = g[e]), h < a))
              d++,
                (h += I[b.id].height + ia),
                (I[b.id].textBlock.text = ""),
                (I[b.id].indexLabelText = ""),
                (I[b.id].isDirty = !0),
                I[b.id].textBlock.measureText();
            else break;
          return d;
        }
        for (var e, g, h, l, f, m, n = 1, r = 0; r < 2 * n; r++) {
          for (
            var u = I.length - 1;
            0 <= u &&
            !(0 <= p(u) && p(u),
            (h = I[u]),
            (l = h.textBlock),
            (m = (f = q(u) < T.length ? I[q(u)] : null) ? f.textBlock : null),
            (e = +h.height.toFixed(6)),
            (g = +l.y.toFixed(6)),
            !h.isDirty &&
              f &&
              g + e + ia > +m.y.toFixed(6) &&
              ((e = l.y + e + ia - m.y),
              (g = a(u, -e)),
              g < e && (0 < g && (e -= g), (g = a(q(u), e)), g != e)));
            u--
          );
          b();
        }
      }
      function k(a, b) {
        return (
          (b < T.length ? I[b].textBlock.y : w.reversed ? W + B : Da + B) -
          (0 > a
            ? w.reversed
              ? Da - B
              : W - B
            : I[a].textBlock.y + I[a].height + ia)
        );
      }
      function t(a, b, c) {
        var e,
          g,
          d,
          l = [],
          f = B,
          p = [];
        -1 !== b &&
          (0 <= aa.indexOf(b)
            ? ((g = aa.indexOf(b)), aa.splice(g, 1))
            : (aa.push(b),
              (aa = aa.sort(function (a, b) {
                return a - b;
              }))));
        if (0 === aa.length) l = oa;
        else {
          g =
            (B *
              (1 != aa.length || (0 != aa[0] && aa[0] != T.length - 1)
                ? 2
                : 1)) /
            m();
          for (var q = 0; q < T.length; q++) {
            if (1 == aa.length && 0 == aa[0]) {
              if (0 === q) {
                l.push(oa[q]);
                e = f;
                continue;
              }
            } else 0 === q && (e = -1 * f);
            l.push(oa[q] + e);
            if (0 <= aa.indexOf(q) || (q < T.length && 0 <= aa.indexOf(q + 1)))
              e += g;
          }
        }
        d = (function () {
          for (var a = [], b = 0; b < T.length; b++) a.push(l[b] - T[b].y1);
          return a;
        })();
        var k = {
          startTime: new Date().getTime(),
          duration: c || 500,
          easingFunction: function (a, b, c, e) {
            return x.easing.easeOutQuart(a, b, c, e);
          },
          changeSection: function (a) {
            for (var b, c, e = 0; e < T.length; e++)
              (b = d[e]),
                (c = T[e]),
                (b *= a),
                "undefined" === typeof p[e] && (p[e] = 0),
                0 > p && (p *= -1),
                (c.y1 += b - p[e]),
                (c.y2 += b - p[e]),
                (c.y3 += b - p[e]),
                (c.y4 += b - p[e]),
                c.y5 && ((c.y5 += b - p[e]), (c.y6 += b - p[e])),
                (p[e] = b);
          },
        };
        a._animator.animate(
          0,
          c,
          function (c) {
            var e = a.plotArea.ctx || a.ctx;
            ma = !0;
            e.clearRect(z.x1, z.y1, z.x2 - z.x1, z.y2 - z.y1);
            e.fillStyle = a.backgroundColor;
            e.fillRect(z.x1, z.y1, z.width, z.height);
            k.changeSection(c, b);
            var g = {};
            g.dataSeries = w;
            g.dataPoint = w.reversed
              ? w.dataPoints[A.length - 1 - b]
              : w.dataPoints[b];
            g.index = w.reversed ? A.length - 1 - b : b;
            a.toolTip.highlightObjects([g]);
            for (g = 0; g < T.length; g++) u(e, T[g], w.fillOpacity);
            s(e);
            R && ("inside" !== w.indexLabelPlacement ? n(e) : h(), r(e));
            1 <= c && (ma = !1);
          },
          null,
          x.easing.easeOutQuart
        );
      }
      function m() {
        for (var a = 0, b = 0; b < T.length - 1; b++)
          (0 <= aa.indexOf(b) || 0 <= aa.indexOf(b + 1)) && a++;
        return a;
      }
      function n(a) {
        for (var b, c, e, g, h = 0; h < T.length; h++)
          (g = 1 === I[h].lineThickness % 2 ? 0.5 : 0),
            (c = (((T[h].y2 + T[h].y4) / 2) << 0) + g),
            (b = l(c).x2 - 1),
            (e = I[h].textBlock.x),
            (g = ((I[h].textBlock.y + I[h].height / 2) << 0) + g),
            I[h].isDirty ||
              0 == I[h].lineThickness ||
              ((a.strokeStyle = I[h].lineColor),
              (a.lineWidth = I[h].lineThickness),
              a.setLineDash &&
                a.setLineDash(N(I[h].lineDashType, I[h].lineThickness)),
              a.beginPath(),
              a.moveTo(b, c),
              a.lineTo(e, g),
              a.stroke());
      }
      function p(a) {
        for (a -= 1; -1 <= a && -1 != a && I[a].isDirty; a--);
        return a;
      }
      function q(a) {
        for (a += 1; a <= T.length && a != T.length && I[a].isDirty; a++);
        return a;
      }
      function l(a) {
        for (var b, c = 0; c < A.length; c++)
          if (T[c].y1 < a && T[c].y4 > a) {
            b = T[c];
            break;
          }
        return b
          ? ((a = b.y6
              ? a > b.y6
                ? b.x3 + ((b.x4 - b.x3) / (b.y4 - b.y3)) * (a - b.y3)
                : b.x2 + ((b.x3 - b.x2) / (b.y3 - b.y2)) * (a - b.y2)
              : b.x2 + ((b.x3 - b.x2) / (b.y3 - b.y2)) * (a - b.y2)),
            { x1: a, x2: a })
          : -1;
      }
      function r(a) {
        for (var b = 0; b < T.length; b++)
          I[b].isDirty ||
            (a && (I[b].textBlock.ctx = a), I[b].textBlock.render(!0));
      }
      function s(a) {
        y.plotArea.layoutManager.reset();
        a.roundRect || Ha(a);
        y.title &&
          (y.title.dockInsidePlotArea ||
            ("center" === y.title.horizontalAlign &&
              "center" === y.title.verticalAlign)) &&
          ((y.title.ctx = a), y.title.render());
        if (y.subtitles)
          for (var b = 0; b < y.subtitles.length; b++) {
            var c = y.subtitles[b];
            if (
              c.dockInsidePlotArea ||
              ("center" === c.horizontalAlign && "center" === c.verticalAlign)
            )
              (y.subtitles.ctx = a), c.render();
          }
        y.legend &&
          (y.legend.dockInsidePlotArea ||
            ("center" === y.legend.horizontalAlign &&
              "center" === y.legend.verticalAlign)) &&
          ((y.legend.ctx = a), y.legend.setLayout(), y.legend.render());
        Qa.fNg && Qa.fNg(y);
      }
      var y = this;
      if (!(0 >= a.dataSeriesIndexes.length)) {
        for (
          var w = this.data[a.dataSeriesIndexes[0]],
            A = w.dataPoints,
            z = this.plotArea,
            B = 0.025 * z.width,
            E = 0.01 * z.width,
            C = 0,
            F = z.height - 2 * B,
            H = Math.min(z.width - 2 * E, 2.8 * z.height),
            R = !1,
            L = 0;
          L < A.length;
          L++
        )
          if (
            (!R &&
              "undefined" !== typeof A[L].indexLabel &&
              null !== A[L].indexLabel &&
              0 < A[L].indexLabel.toString().length &&
              (R = !0),
            !R &&
              "undefined" !== typeof A[L].label &&
              null !== A[L].label &&
              0 < A[L].label.toString().length &&
              (R = !0),
            (!R && "function" === typeof w.indexLabelFormatter) ||
              "function" === typeof A[L].indexLabelFormatter)
          )
            R = !0;
        R =
          R ||
          ("undefined" !== typeof w.indexLabel &&
            null !== w.indexLabel &&
            0 < w.indexLabel.toString().length);
        ("inside" !== w.indexLabelPlacement && R) ||
          (E = (z.width - 0.75 * H) / 2);
        var L = z.x1 + E,
          K = z.x2 - E,
          P = z.y1 + B,
          U = z.y2 - B,
          Q = a.targetCanvasCtx || this.plotArea.ctx || this.ctx;
        if (0 != w.length && w.dataPoints && w.visible && 0 !== A.length) {
          var M, G;
          a = (75 * H) / 100;
          var O = (30 * (K - a)) / 100;
          "funnel" === w.type
            ? ((M = f(w.options.neckHeight) ? 0.35 * F : w.neckHeight),
              (G = f(w.options.neckWidth) ? 0.25 * a : w.neckWidth),
              "string" === typeof M && M.match(/%$/)
                ? ((M = parseInt(M)), (M = (M * F) / 100))
                : (M = parseInt(M)),
              "string" === typeof G && G.match(/%$/)
                ? ((G = parseInt(G)), (G = (G * a) / 100))
                : (G = parseInt(G)),
              M > F ? (M = F) : 0 >= M && (M = 0),
              G > a ? (G = a - 0.5) : 0 >= G && (G = 0))
            : "pyramid" === w.type &&
              ((G = M = 0), (w.reversed = w.reversed ? !1 : !0));
          var E = L + a / 2,
            Z = L,
            Y = L + a,
            W = w.reversed ? U : P,
            S = E - G / 2,
            fa = E + G / 2,
            $ = w.reversed ? P + M : U - M,
            Da = w.reversed ? P : U;
          a = [];
          var E = [],
            T = [],
            H = [],
            X = P,
            ea,
            ha = ($ - W) / (S - Z),
            ka = -ha,
            L =
              "area" === (w.valueRepresents ? w.valueRepresents : "height")
                ? b()
                : e();
          if (-1 !== L) {
            if (w.reversed)
              for (H.push(X), G = L.length - 1; 0 < G; G--)
                (X += L[G]), H.push(X);
            else for (G = 0; G < L.length; G++) (X += L[G]), H.push(X);
            if (w.reversed)
              for (G = 0; G < L.length; G++)
                H[G] < $
                  ? (a.push(S), E.push(fa), (ea = G))
                  : (a.push((H[G] - W + ha * Z) / ha),
                    E.push((H[G] - W + ka * Y) / ka));
            else
              for (G = 0; G < L.length; G++)
                H[G] < $
                  ? (a.push((H[G] - W + ha * Z) / ha),
                    E.push((H[G] - W + ka * Y) / ka),
                    (ea = G))
                  : (a.push(S), E.push(fa));
            for (G = 0; G < L.length - 1; G++)
              (X = w.reversed
                ? A[A.length - 1 - G].color
                  ? A[A.length - 1 - G].color
                  : w._colorSet[(A.length - 1 - G) % w._colorSet.length]
                : A[G].color
                ? A[G].color
                : w._colorSet[G % w._colorSet.length]),
                G === ea
                  ? T.push({
                      x1: a[G],
                      y1: H[G],
                      x2: E[G],
                      y2: H[G],
                      x3: fa,
                      y3: $,
                      x4: E[G + 1],
                      y4: H[G + 1],
                      x5: a[G + 1],
                      y5: H[G + 1],
                      x6: S,
                      y6: $,
                      id: G,
                      height: H[G + 1] - H[G],
                      color: X,
                    })
                  : T.push({
                      x1: a[G],
                      y1: H[G],
                      x2: E[G],
                      y2: H[G],
                      x3: E[G + 1],
                      y3: H[G + 1],
                      x4: a[G + 1],
                      y4: H[G + 1],
                      id: G,
                      height: H[G + 1] - H[G],
                      color: X,
                    });
            var ia = 2,
              I = [],
              ma = !1,
              aa = [],
              oa = [],
              L = !1;
            a = a = 0;
            Ea(aa);
            for (G = 0; G < A.length; G++)
              A[G].exploded &&
                ((L = !0), w.reversed ? aa.push(A.length - 1 - G) : aa.push(G));
            Q.clearRect(z.x1, z.y1, z.width, z.height);
            Q.fillStyle = y.backgroundColor;
            Q.fillRect(z.x1, z.y1, z.width, z.height);
            if (
              R &&
              w.visible &&
              (c(), h(), g(), "inside" !== w.indexLabelPlacement)
            ) {
              d();
              for (G = 0; G < A.length; G++)
                I[G].isDirty ||
                  ((a = I[G].textBlock.x + I[G].width),
                  (a = (K - a) / 2),
                  0 == G && (C = a),
                  C > a && (C = a));
              for (G = 0; G < T.length; G++)
                (T[G].x1 += C),
                  (T[G].x2 += C),
                  (T[G].x3 += C),
                  (T[G].x4 += C),
                  T[G].x5 && ((T[G].x5 += C), (T[G].x6 += C)),
                  (I[G].textBlock.x += C);
            }
            for (G = 0; G < T.length; G++)
              (C = T[G]), u(Q, C, w.fillOpacity), oa.push(C.y1);
            s(Q);
            R &&
              w.visible &&
              ("inside" === w.indexLabelPlacement || y.animationEnabled || n(Q),
              y.animationEnabled || r());
            if (!R)
              for (G = 0; G < A.length; G++)
                (C = w.dataPointIds[G]),
                  (a = {
                    id: C,
                    objectType: "dataPoint",
                    dataPointIndex: G,
                    dataSeriesIndex: 0,
                    funnelSection: T[w.reversed ? A.length - 1 - G : G],
                  }),
                  (y._eventManager.objectMap[C] = a);
            !y.animationEnabled && L
              ? t(y, -1, 0)
              : y.animationEnabled && !y.animatedRender && t(y, -1, 0);
            this.funnelPyramidClickHandler = function (a) {
              var b = -1;
              if (
                !ma &&
                !y.isAnimating &&
                (f(a.dataSeries.explodeOnClick) ||
                  a.dataSeries.explodeOnClick) &&
                ((b = w.reversed
                  ? A.length - 1 - a.dataPointIndex
                  : a.dataPointIndex),
                0 <= b)
              ) {
                a = b;
                if ("funnel" === w.type || "pyramid" === w.type)
                  w.reversed
                    ? (A[A.length - 1 - a].exploded = A[A.length - 1 - a]
                        .exploded
                        ? !1
                        : !0)
                    : (A[a].exploded = A[a].exploded ? !1 : !0);
                t(y, b, 500);
              }
            };
            return {
              source: Q,
              dest: this.plotArea.ctx,
              animationCallback: function (a, b) {
                x.fadeInAnimation(a, b);
                1 <= a && (t(y, -1, 500), s(y.plotArea.ctx || y.ctx));
              },
              easingFunction: x.easing.easeInQuad,
              animationBase: 0,
            };
          }
        }
      }
    };
    s.prototype.requestAnimFrame = (function () {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (a) {
          window.setTimeout(a, 1e3 / 60);
        }
      );
    })();
    s.prototype.cancelRequestAnimFrame =
      window.cancelAnimationFrame ||
      window.webkitCancelRequestAnimationFrame ||
      window.mozCancelRequestAnimationFrame ||
      window.oCancelRequestAnimationFrame ||
      window.msCancelRequestAnimationFrame ||
      clearTimeout;
    s.prototype.set = function (a, e, b) {
      b = "undefined" === typeof b ? !0 : b;
      "options" === a
        ? ((this.options = e), b && this.render())
        : s.base.set.call(this, a, e, b);
    };
    s.prototype.exportChart = function (a) {
      a = "undefined" === typeof a ? {} : a;
      var e = a.format ? a.format : "png",
        b = a.fileName ? a.fileName : this.exportFileName;
      if (a.toDataURL) return this.canvas.toDataURL("image/" + e);
      eb(this.canvas, e, b);
    };
    s.prototype.print = function () {
      var a = this.exportChart({ toDataURL: !0 }),
        e = document.createElement("iframe");
      e.setAttribute("class", "canvasjs-chart-print-frame");
      e.setAttribute(
        "style",
        "position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;"
      );
      e.style.height = this.height + "px";
      this._canvasJSContainer.appendChild(e);
      var b = this,
        c = e.contentWindow || e.contentDocument.document || e.contentDocument;
      c.document.open();
      c.document.write(
        '<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="' +
          a +
          '"/><body/></html>'
      );
      c.document.close();
      setTimeout(function () {
        c.focus();
        c.print();
        setTimeout(function () {
          b._canvasJSContainer.removeChild(e);
        }, 1e3);
      }, 500);
    };
    s.prototype.getPercentAndTotal = function (a, e) {
      var b = null,
        c = null,
        g = (b = null);
      if (0 <= a.type.indexOf("stacked"))
        (c = 0),
          (b = e.x.getTime ? e.x.getTime() : e.x),
          b in a.plotUnit.yTotals &&
            ((c = a.plotUnit.yTotals[b]),
            (b = a.plotUnit.yAbsTotals[b]),
            (g = isNaN(e.y) ? 0 : 0 === b ? 0 : 100 * (e.y / b)));
      else if (
        "pie" === a.type ||
        "doughnut" === a.type ||
        "funnel" === a.type ||
        "pyramid" === a.type
      ) {
        for (b = c = 0; b < a.dataPoints.length; b++)
          isNaN(a.dataPoints[b].y) || (c += a.dataPoints[b].y);
        g = isNaN(e.y) ? 0 : 100 * (e.y / c);
      }
      return { percent: g, total: c };
    };
    s.prototype.replaceKeywordsWithValue = function (a, e, b, c, g) {
      var h = this;
      g = "undefined" === typeof g ? 0 : g;
      if (
        (0 <= b.type.indexOf("stacked") ||
          "pie" === b.type ||
          "doughnut" === b.type ||
          "funnel" === b.type ||
          "pyramid" === b.type) &&
        (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"))
      ) {
        var d = "#percent",
          f = "#total",
          k = this.getPercentAndTotal(b, e),
          f = isNaN(k.total) ? f : k.total,
          d = isNaN(k.percent) ? d : k.percent;
        do {
          k = "";
          if (b.percentFormatString) k = b.percentFormatString;
          else {
            var k = "#,##0.",
              m = Math.max(Math.ceil(Math.log(1 / Math.abs(d)) / Math.LN10), 2);
            if (isNaN(m) || !isFinite(m)) m = 2;
            for (var n = 0; n < m; n++) k += "#";
            b.percentFormatString = k;
          }
          a = a.replace("#percent", $(d, k, h._cultureInfo));
          a = a.replace(
            "#total",
            $(
              f,
              b.yValueFormatString ? b.yValueFormatString : "#,##0.########",
              h._cultureInfo
            )
          );
        } while (0 <= a.indexOf("#percent") || 0 <= a.indexOf("#total"));
      }
      return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g, function (a) {
        if (
          ('"' === a[0] && '"' === a[a.length - 1]) ||
          ("'" === a[0] && "'" === a[a.length - 1])
        )
          return a.slice(1, a.length - 1);
        a = Pa(a.slice(1, a.length - 1));
        a = a.replace("#index", g);
        var d = null;
        try {
          var l = a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);
          l && 0 < l.length && ((d = Pa(l[2])), (a = Pa(l[1])));
        } catch (f) {}
        l = null;
        if ("color" === a)
          return "waterfall" === b.type
            ? e.color
              ? e.color
              : 0 < e.y
              ? b.risingColor
              : b.fallingColor
            : "error" === b.type
            ? b.color
              ? b.color
              : b._colorSet[d % b._colorSet.length]
            : e.color
            ? e.color
            : b.color
            ? b.color
            : b._colorSet[c % b._colorSet.length];
        if (e.hasOwnProperty(a)) l = e;
        else if (b.hasOwnProperty(a)) l = b;
        else return "";
        l = l[a];
        null !== d && (l = l[d]);
        if ("x" === a)
          if (
            "dateTime" === b.axisX.valueType ||
            "dateTime" === b.xValueType ||
            (e.x && e.x.getTime)
          ) {
            if (!b.axisX.logarithmic)
              return oa(
                l,
                e.xValueFormatString
                  ? e.xValueFormatString
                  : b.xValueFormatString
                  ? b.xValueFormatString
                  : (b.xValueFormatString =
                      h.axisX && h.axisX.autoValueFormatString
                        ? h.axisX.autoValueFormatString
                        : "DD MMM YY"),
                h._cultureInfo
              );
          } else
            return $(
              l,
              e.xValueFormatString
                ? e.xValueFormatString
                : b.xValueFormatString
                ? b.xValueFormatString
                : (b.xValueFormatString = "#,##0.########"),
              h._cultureInfo
            );
        else
          return "y" === a
            ? $(
                l,
                e.yValueFormatString
                  ? e.yValueFormatString
                  : b.yValueFormatString
                  ? b.yValueFormatString
                  : (b.yValueFormatString = "#,##0.########"),
                h._cultureInfo
              )
            : "z" === a
            ? $(
                l,
                e.zValueFormatString
                  ? e.zValueFormatString
                  : b.zValueFormatString
                  ? b.zValueFormatString
                  : (b.zValueFormatString = "#,##0.########"),
                h._cultureInfo
              )
            : l;
      });
    };
    ha(M, Q);
    M.prototype.setLayout = function () {
      var a = this.dockInsidePlotArea ? this.chart.plotArea : this.chart,
        e = a.layoutManager.getFreeSpace(),
        b = null,
        c = 0,
        g = 0,
        h = 0,
        d = 0,
        k = (this.markerMargin =
          this.chart.options.legend &&
          !f(this.chart.options.legend.markerMargin)
            ? this.chart.options.legend.markerMargin
            : 0.3 * this.fontSize);
      this.height = 0;
      var u = [],
        m = [];
      "top" === this.verticalAlign || "bottom" === this.verticalAlign
        ? ((this.orientation = "horizontal"),
          (b = this.verticalAlign),
          (h = this.maxWidth =
            null !== this.maxWidth ? this.maxWidth : e.width),
          (d = this.maxHeight =
            null !== this.maxHeight ? this.maxHeight : 0.5 * e.height))
        : "center" === this.verticalAlign &&
          ((this.orientation = "vertical"),
          (b = this.horizontalAlign),
          (h = this.maxWidth =
            null !== this.maxWidth ? this.maxWidth : 0.5 * e.width),
          (d = this.maxHeight =
            null !== this.maxHeight ? this.maxHeight : e.height));
      this.errorMarkerColor = [];
      for (var n = 0; n < this.dataSeries.length; n++) {
        var p = this.dataSeries[n];
        if (p.dataPoints && p.dataPoints.length)
          if (
            "pie" !== p.type &&
            "doughnut" !== p.type &&
            "funnel" !== p.type &&
            "pyramid" !== p.type
          ) {
            var q = (p.legendMarkerType = p.legendMarkerType
                ? p.legendMarkerType
                : ("line" !== p.type &&
                    "stepLine" !== p.type &&
                    "spline" !== p.type &&
                    "scatter" !== p.type &&
                    "bubble" !== p.type) ||
                  !p.markerType
                ? "error" === p.type && p._linkedSeries
                  ? p._linkedSeries.legendMarkerType
                    ? p._linkedSeries.legendMarkerType
                    : H.getDefaultLegendMarker(p._linkedSeries.type)
                  : H.getDefaultLegendMarker(p.type)
                : p.markerType),
              l = p.legendText
                ? p.legendText
                : this.itemTextFormatter
                ? this.itemTextFormatter({
                    chart: this.chart,
                    legend: this.options,
                    dataSeries: p,
                    dataPoint: null,
                  })
                : p.name,
              r = (p.legendMarkerColor = p.legendMarkerColor
                ? p.legendMarkerColor
                : p.markerColor
                ? p.markerColor
                : "error" === p.type
                ? f(p.whiskerColor)
                  ? p._colorSet[0]
                  : p.whiskerColor
                : p._colorSet[0]),
              x =
                p.markerSize ||
                ("line" !== p.type &&
                  "stepLine" !== p.type &&
                  "spline" !== p.type)
                  ? 0.75 * this.lineHeight
                  : 0,
              t = p.legendMarkerBorderColor
                ? p.legendMarkerBorderColor
                : p.markerBorderColor,
              w = p.legendMarkerBorderThickness
                ? p.legendMarkerBorderThickness
                : p.markerBorderThickness
                ? Math.max(1, Math.round(0.2 * x))
                : 0;
            "error" === p.type && this.errorMarkerColor.push(r);
            l = this.chart.replaceKeywordsWithValue(l, p.dataPoints[0], p, n);
            q = {
              markerType: q,
              markerColor: r,
              text: l,
              textBlock: null,
              chartType: p.type,
              markerSize: x,
              lineColor: p._colorSet[0],
              dataSeriesIndex: p.index,
              dataPointIndex: null,
              markerBorderColor: t,
              markerBorderThickness: w,
            };
            u.push(q);
          } else
            for (var v = 0; v < p.dataPoints.length; v++) {
              var s = p.dataPoints[v],
                q = s.legendMarkerType
                  ? s.legendMarkerType
                  : p.legendMarkerType
                  ? p.legendMarkerType
                  : H.getDefaultLegendMarker(p.type),
                l = s.legendText
                  ? s.legendText
                  : p.legendText
                  ? p.legendText
                  : this.itemTextFormatter
                  ? this.itemTextFormatter({
                      chart: this.chart,
                      legend: this.options,
                      dataSeries: p,
                      dataPoint: s,
                    })
                  : s.name
                  ? s.name
                  : "DataPoint: " + (v + 1),
                r = s.legendMarkerColor
                  ? s.legendMarkerColor
                  : p.legendMarkerColor
                  ? p.legendMarkerColor
                  : s.color
                  ? s.color
                  : p.color
                  ? p.color
                  : p._colorSet[v % p._colorSet.length],
                x = 0.75 * this.lineHeight,
                t = s.legendMarkerBorderColor
                  ? s.legendMarkerBorderColor
                  : p.legendMarkerBorderColor
                  ? p.legendMarkerBorderColor
                  : s.markerBorderColor
                  ? s.markerBorderColor
                  : p.markerBorderColor,
                w = s.legendMarkerBorderThickness
                  ? s.legendMarkerBorderThickness
                  : p.legendMarkerBorderThickness
                  ? p.legendMarkerBorderThickness
                  : s.markerBorderThickness || p.markerBorderThickness
                  ? Math.max(1, Math.round(0.2 * x))
                  : 0,
                l = this.chart.replaceKeywordsWithValue(l, s, p, v),
                q = {
                  markerType: q,
                  markerColor: r,
                  text: l,
                  textBlock: null,
                  chartType: p.type,
                  markerSize: x,
                  dataSeriesIndex: n,
                  dataPointIndex: v,
                  markerBorderColor: t,
                  markerBorderThickness: w,
                };
              (s.showInLegend || (p.showInLegend && !1 !== s.showInLegend)) &&
                u.push(q);
            }
      }
      !0 === this.reversed && u.reverse();
      if (0 < u.length) {
        p = null;
        r = l = s = v = 0;
        s =
          null !== this.itemWidth
            ? null !== this.itemMaxWidth
              ? Math.min(this.itemWidth, this.itemMaxWidth, h)
              : (this.itemMaxWidth = Math.min(this.itemWidth, h))
            : null !== this.itemMaxWidth
            ? Math.min(this.itemMaxWidth, h)
            : (this.itemMaxWidth = h);
        x = 0 === x ? 0.75 * this.lineHeight : x;
        s -= x + k;
        for (n = 0; n < u.length; n++) {
          q = u[n];
          t = s;
          if (
            "line" === q.chartType ||
            "spline" === q.chartType ||
            "stepLine" === q.chartType
          )
            t -= 2 * 0.1 * this.lineHeight;
          if (
            !(
              0 >= d ||
              "undefined" === typeof d ||
              0 >= t ||
              "undefined" === typeof t
            )
          ) {
            if ("horizontal" === this.orientation) {
              q.textBlock = new na(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: t,
                maxHeight: this.itemWrap ? d : this.lineHeight,
                angle: 0,
                text: q.text,
                horizontalAlign: "left",
                fontSize: this.fontSize,
                fontFamily: this.fontFamily,
                fontWeight: this.fontWeight,
                fontColor: this.fontColor,
                fontStyle: this.fontStyle,
                textBaseline: "middle",
              });
              q.textBlock.measureText();
              null !== this.itemWidth &&
                (q.textBlock.width =
                  this.itemWidth -
                  (x +
                    k +
                    ("line" === q.chartType ||
                    "spline" === q.chartType ||
                    "stepLine" === q.chartType
                      ? 2 * 0.1 * this.lineHeight
                      : 0)));
              if (
                !p ||
                p.width +
                  Math.round(
                    q.textBlock.width +
                      x +
                      k +
                      (0 === p.width ? 0 : this.horizontalSpacing) +
                      ("line" === q.chartType ||
                      "spline" === q.chartType ||
                      "stepLine" === q.chartType
                        ? 2 * 0.1 * this.lineHeight
                        : 0)
                  ) >
                  h
              )
                (p = { items: [], width: 0 }),
                  m.push(p),
                  (this.height += l),
                  (l = 0);
              l = Math.max(l, q.textBlock.height);
            } else
              (q.textBlock = new na(this.ctx, {
                x: 0,
                y: 0,
                maxWidth: s,
                maxHeight: !0 === this.itemWrap ? d : 1.5 * this.fontSize,
                angle: 0,
                text: q.text,
                horizontalAlign: "left",
                fontSize: this.fontSize,
                fontFamily: this.fontFamily,
                fontWeight: this.fontWeight,
                fontColor: this.fontColor,
                fontStyle: this.fontStyle,
                textBaseline: "middle",
              })),
                q.textBlock.measureText(),
                null !== this.itemWidth &&
                  (q.textBlock.width =
                    this.itemWidth -
                    (x +
                      k +
                      ("line" === q.chartType ||
                      "spline" === q.chartType ||
                      "stepLine" === q.chartType
                        ? 2 * 0.1 * this.lineHeight
                        : 0))),
                this.height < d - this.lineHeight
                  ? ((p = { items: [], width: 0 }), m.push(p))
                  : ((p = m[v]), (v = (v + 1) % m.length)),
                (this.height += q.textBlock.height);
            q.textBlock.x = p.width;
            q.textBlock.y = 0;
            p.width += Math.round(
              q.textBlock.width +
                x +
                k +
                (0 === p.width ? 0 : this.horizontalSpacing) +
                ("line" === q.chartType ||
                "spline" === q.chartType ||
                "stepLine" === q.chartType
                  ? 2 * 0.1 * this.lineHeight
                  : 0)
            );
            p.items.push(q);
            this.width = Math.max(p.width, this.width);
            r =
              q.textBlock.width +
              (x +
                k +
                ("line" === q.chartType ||
                "spline" === q.chartType ||
                "stepLine" === q.chartType
                  ? 2 * 0.1 * this.lineHeight
                  : 0));
          }
        }
        this.itemWidth = r;
        this.height =
          !1 === this.itemWrap ? m.length * this.lineHeight : this.height + l;
        this.height = Math.min(d, this.height);
        this.width = Math.min(h, this.width);
      }
      "top" === this.verticalAlign
        ? ((g =
            "left" === this.horizontalAlign
              ? e.x1
              : "right" === this.horizontalAlign
              ? e.x2 - this.width
              : e.x1 + e.width / 2 - this.width / 2),
          (c = e.y1))
        : "center" === this.verticalAlign
        ? ((g =
            "left" === this.horizontalAlign
              ? e.x1
              : "right" === this.horizontalAlign
              ? e.x2 - this.width
              : e.x1 + e.width / 2 - this.width / 2),
          (c = e.y1 + e.height / 2 - this.height / 2))
        : "bottom" === this.verticalAlign &&
          ((g =
            "left" === this.horizontalAlign
              ? e.x1
              : "right" === this.horizontalAlign
              ? e.x2 - this.width
              : e.x1 + e.width / 2 - this.width / 2),
          (c = e.y2 - this.height));
      this.items = u;
      for (n = 0; n < this.items.length; n++)
        (q = u[n]),
          (q.id = ++this.chart._eventManager.lastObjectId),
          (this.chart._eventManager.objectMap[q.id] = {
            id: q.id,
            objectType: "legendItem",
            legendItemIndex: n,
            dataSeriesIndex: q.dataSeriesIndex,
            dataPointIndex: q.dataPointIndex,
          });
      this.markerSize = x;
      this.rows = m;
      0 < u.length &&
        a.layoutManager.registerSpace(b, {
          width: this.width + 2 + 2,
          height: this.height + 5 + 5,
        });
      this.bounds = { x1: g, y1: c, x2: g + this.width, y2: c + this.height };
    };
    M.prototype.render = function () {
      var a = this.bounds.x1,
        e = this.bounds.y1,
        b = this.markerMargin,
        c = this.maxWidth,
        g = this.maxHeight,
        h = this.markerSize,
        d = this.rows;
      ((0 < this.borderThickness && this.borderColor) ||
        this.backgroundColor) &&
        this.ctx.roundRect(
          a,
          e,
          this.width,
          this.height,
          this.cornerRadius,
          this.borderThickness,
          this.backgroundColor,
          this.borderColor
        );
      for (var f = 0, k = 0; k < d.length; k++) {
        for (var m = d[k], n = 0, p = 0; p < m.items.length; p++) {
          var q = m.items[p],
            l =
              q.textBlock.x + a + (0 === p ? 0.2 * h : this.horizontalSpacing),
            r = e + f,
            u = l;
          this.chart.data[q.dataSeriesIndex].visible ||
            (this.ctx.globalAlpha = 0.5);
          this.ctx.save();
          this.ctx.beginPath();
          this.ctx.rect(a, e, c, Math.max(g - (g % this.lineHeight), 0));
          this.ctx.clip();
          if (
            "line" === q.chartType ||
            "stepLine" === q.chartType ||
            "spline" === q.chartType
          )
            (this.ctx.strokeStyle = q.lineColor),
              (this.ctx.lineWidth = Math.ceil(this.lineHeight / 8)),
              this.ctx.beginPath(),
              this.ctx.moveTo(
                l - 0.1 * this.lineHeight,
                r + this.lineHeight / 2
              ),
              this.ctx.lineTo(
                l + 0.85 * this.lineHeight,
                r + this.lineHeight / 2
              ),
              this.ctx.stroke(),
              (u -= 0.1 * this.lineHeight);
          if ("error" === q.chartType) {
            this.ctx.strokeStyle = this.errorMarkerColor[0];
            this.ctx.lineWidth = h / 8;
            this.ctx.beginPath();
            var x = l - 0.08 * this.lineHeight + 0.1 * this.lineHeight,
              w = r + 0.15 * this.lineHeight,
              v = 0.7 * this.lineHeight,
              s = v + 0.02 * this.lineHeight;
            this.ctx.moveTo(x, w);
            this.ctx.lineTo(x + v, w);
            this.ctx.stroke();
            this.ctx.beginPath();
            this.ctx.moveTo(x + v / 2, w);
            this.ctx.lineTo(x + v / 2, w + s);
            this.ctx.stroke();
            this.ctx.beginPath();
            this.ctx.moveTo(x, w + s);
            this.ctx.lineTo(x + v, w + s);
            this.ctx.stroke();
            this.errorMarkerColor.shift();
          }
          t.drawMarker(
            l + h / 2,
            r + this.lineHeight / 2,
            this.ctx,
            q.markerType,
            "error" === q.chartType ||
              "line" === q.chartType ||
              "spline" === q.chartType
              ? q.markerSize / 2
              : q.markerSize,
            q.markerColor,
            q.markerBorderColor,
            q.markerBorderThickness
          );
          q.textBlock.x = l + b + h;
          if (
            "line" === q.chartType ||
            "stepLine" === q.chartType ||
            "spline" === q.chartType
          )
            q.textBlock.x += 0.1 * this.lineHeight;
          q.textBlock.y = Math.round(r + this.lineHeight / 2);
          q.textBlock.render(!0);
          this.ctx.restore();
          n = 0 < p ? Math.max(n, q.textBlock.height) : q.textBlock.height;
          this.chart.data[q.dataSeriesIndex].visible ||
            (this.ctx.globalAlpha = 1);
          l = O(q.id);
          this.ghostCtx.fillStyle = l;
          this.ghostCtx.beginPath();
          this.ghostCtx.fillRect(
            u,
            q.textBlock.y - this.lineHeight / 2,
            q.textBlock.x + q.textBlock.width - u,
            q.textBlock.height
          );
          q.x1 = this.chart._eventManager.objectMap[q.id].x1 = u;
          q.y1 = this.chart._eventManager.objectMap[q.id].y1 =
            q.textBlock.y - this.lineHeight / 2;
          q.x2 = this.chart._eventManager.objectMap[q.id].x2 =
            q.textBlock.x + q.textBlock.width;
          q.y2 = this.chart._eventManager.objectMap[q.id].y2 =
            q.textBlock.y + q.textBlock.height - this.lineHeight / 2;
        }
        f += n;
      }
    };
    ha(H, Q);
    H.prototype.getDefaultAxisPlacement = function () {
      var a = this.type;
      if (
        "column" === a ||
        "line" === a ||
        "stepLine" === a ||
        "spline" === a ||
        "area" === a ||
        "stepArea" === a ||
        "splineArea" === a ||
        "stackedColumn" === a ||
        "stackedLine" === a ||
        "bubble" === a ||
        "scatter" === a ||
        "stackedArea" === a ||
        "stackedColumn100" === a ||
        "stackedLine100" === a ||
        "stackedArea100" === a ||
        "candlestick" === a ||
        "ohlc" === a ||
        "rangeColumn" === a ||
        "rangeArea" === a ||
        "rangeSplineArea" === a ||
        "boxAndWhisker" === a ||
        "waterfall" === a
      )
        return "normal";
      if (
        "bar" === a ||
        "stackedBar" === a ||
        "stackedBar100" === a ||
        "rangeBar" === a
      )
        return "xySwapped";
      if ("pie" === a || "doughnut" === a || "funnel" === a || "pyramid" === a)
        return "none";
      "error" !== a && window.console.log("Unknown Chart Type: " + a);
      return null;
    };
    H.getDefaultLegendMarker = function (a) {
      if (
        "column" === a ||
        "stackedColumn" === a ||
        "stackedLine" === a ||
        "bar" === a ||
        "stackedBar" === a ||
        "stackedBar100" === a ||
        "bubble" === a ||
        "scatter" === a ||
        "stackedColumn100" === a ||
        "stackedLine100" === a ||
        "stepArea" === a ||
        "candlestick" === a ||
        "ohlc" === a ||
        "rangeColumn" === a ||
        "rangeBar" === a ||
        "rangeArea" === a ||
        "rangeSplineArea" === a ||
        "boxAndWhisker" === a ||
        "waterfall" === a
      )
        return "square";
      if (
        "line" === a ||
        "stepLine" === a ||
        "spline" === a ||
        "pie" === a ||
        "doughnut" === a
      )
        return "circle";
      if (
        "area" === a ||
        "splineArea" === a ||
        "stackedArea" === a ||
        "stackedArea100" === a ||
        "funnel" === a ||
        "pyramid" === a
      )
        return "triangle";
      if ("error" === a) return "none";
      window.console.log("Unknown Chart Type: " + a);
      return null;
    };
    H.prototype.getDataPointAtX = function (a, e) {
      if (!this.dataPoints || 0 === this.dataPoints.length) return null;
      var b = { dataPoint: null, distance: Infinity, index: NaN },
        c = null,
        g = 0,
        h = 0,
        d = 1,
        f = Infinity,
        k = 0,
        m = 0,
        n = 0;
      "none" !== this.chart.plotInfo.axisPlacement &&
        (this.axisX.logarithmic
          ? ((n = Math.log(
              this.dataPoints[this.dataPoints.length - 1].x /
                this.dataPoints[0].x
            )),
            (n =
              1 < n
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / n) *
                        Math.log(a / this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0))
          : ((n =
              this.dataPoints[this.dataPoints.length - 1].x -
              this.dataPoints[0].x),
            (n =
              0 < n
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / n) *
                        (a - this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0)));
      for (;;) {
        h = 0 < d ? n + g : n - g;
        if (0 <= h && h < this.dataPoints.length) {
          var c = this.dataPoints[h],
            p = this.axisX.logarithmic
              ? c.x > a
                ? c.x / a
                : a / c.x
              : Math.abs(c.x - a);
          p < b.distance &&
            ((b.dataPoint = c), (b.distance = p), (b.index = h));
          c = p;
          c <= f ? (f = c) : 0 < d ? k++ : m++;
          if (1e3 < k && 1e3 < m) break;
        } else if (0 > n - g && n + g >= this.dataPoints.length) break;
        -1 === d ? (g++, (d = 1)) : (d = -1);
      }
      return e ||
        (b.dataPoint.x.getTime ? b.dataPoint.x.getTime() : b.dataPoint.x) !==
          (a.getTime ? a.getTime() : a)
        ? e && null !== b.dataPoint
          ? b
          : null
        : b;
    };
    H.prototype.getDataPointAtXY = function (a, e, b) {
      if (
        !this.dataPoints ||
        0 === this.dataPoints.length ||
        a < this.chart.plotArea.x1 ||
        a > this.chart.plotArea.x2 ||
        e < this.chart.plotArea.y1 ||
        e > this.chart.plotArea.y2
      )
        return null;
      b = b || !1;
      var c = [],
        g = 0,
        h = 0,
        d = 1,
        f = !1,
        k = Infinity,
        m = 0,
        n = 0,
        p = 0;
      if ("none" !== this.chart.plotInfo.axisPlacement)
        if (
          ((p = (
            this.chart.axisX[0] ? this.chart.axisX[0] : this.chart.axisX2[0]
          ).getXValueAt({ x: a, y: e })),
          this.axisX.logarithmic)
        )
          var q = Math.log(
              this.dataPoints[this.dataPoints.length - 1].x /
                this.dataPoints[0].x
            ),
            p =
              1 < q
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / q) *
                        Math.log(p / this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0;
        else
          (q =
            this.dataPoints[this.dataPoints.length - 1].x -
            this.dataPoints[0].x),
            (p =
              0 < q
                ? Math.min(
                    Math.max(
                      (((this.dataPoints.length - 1) / q) *
                        (p - this.dataPoints[0].x)) >>
                        0,
                      0
                    ),
                    this.dataPoints.length
                  )
                : 0);
      for (;;) {
        h = 0 < d ? p + g : p - g;
        if (0 <= h && h < this.dataPoints.length) {
          var q = this.chart._eventManager.objectMap[this.dataPointIds[h]],
            l = this.dataPoints[h],
            r = null;
          if (q) {
            switch (this.type) {
              case "column":
              case "stackedColumn":
              case "stackedColumn100":
              case "bar":
              case "stackedBar":
              case "stackedBar100":
              case "rangeColumn":
              case "rangeBar":
              case "waterfall":
              case "error":
                a >= q.x1 &&
                  a <= q.x2 &&
                  e >= q.y1 &&
                  e <= q.y2 &&
                  (c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(q.x1 - a),
                      Math.abs(q.x2 - a),
                      Math.abs(q.y1 - e),
                      Math.abs(q.y2 - e)
                    ),
                  }),
                  (f = !0));
                break;
              case "line":
              case "stepLine":
              case "spline":
              case "area":
              case "stepArea":
              case "stackedArea":
              case "stackedArea100":
              case "splineArea":
              case "scatter":
                var u = ra("markerSize", l, this) || 4,
                  x = b ? 20 : u,
                  r = Math.sqrt(Math.pow(q.x1 - a, 2) + Math.pow(q.y1 - e, 2));
                r <= x &&
                  c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: r,
                  });
                q = Math.abs(q.x1 - a);
                q <= k ? (k = q) : 0 < d ? m++ : n++;
                r <= u / 2 && (f = !0);
                break;
              case "rangeArea":
              case "rangeSplineArea":
                u = ra("markerSize", l, this) || 4;
                x = b ? 20 : u;
                r = Math.min(
                  Math.sqrt(Math.pow(q.x1 - a, 2) + Math.pow(q.y1 - e, 2)),
                  Math.sqrt(Math.pow(q.x1 - a, 2) + Math.pow(q.y2 - e, 2))
                );
                r <= x &&
                  c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: r,
                  });
                q = Math.abs(q.x1 - a);
                q <= k ? (k = q) : 0 < d ? m++ : n++;
                r <= u / 2 && (f = !0);
                break;
              case "bubble":
                u = q.size;
                r = Math.sqrt(Math.pow(q.x1 - a, 2) + Math.pow(q.y1 - e, 2));
                r <= u / 2 &&
                  (c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: r,
                  }),
                  (f = !0));
                break;
              case "pie":
              case "doughnut":
                u = q.center;
                x =
                  "doughnut" === this.type
                    ? q.percentInnerRadius * q.radius
                    : 0;
                r = Math.sqrt(Math.pow(u.x - a, 2) + Math.pow(u.y - e, 2));
                r < q.radius &&
                  r > x &&
                  ((r = Math.atan2(e - u.y, a - u.x)),
                  0 > r && (r += 2 * Math.PI),
                  (r = Number(
                    ((((180 * (r / Math.PI)) % 360) + 360) % 360).toFixed(12)
                  )),
                  (u = Number(
                    (
                      (((180 * (q.startAngle / Math.PI)) % 360) + 360) %
                      360
                    ).toFixed(12)
                  )),
                  (x = Number(
                    (
                      (((180 * (q.endAngle / Math.PI)) % 360) + 360) %
                      360
                    ).toFixed(12)
                  )),
                  0 === x && 1 < q.endAngle && (x = 360),
                  u >= x && 0 !== l.y && ((x += 360), r < u && (r += 360)),
                  r > u &&
                    r < x &&
                    (c.push({
                      dataPoint: l,
                      dataPointIndex: h,
                      dataSeries: this,
                      distance: 0,
                    }),
                    (f = !0)));
                break;
              case "funnel":
              case "pyramid":
                r = q.funnelSection;
                e > r.y1 &&
                  e < r.y4 &&
                  (r.y6
                    ? e > r.y6
                      ? ((h =
                          r.x6 + ((r.x5 - r.x6) / (r.y5 - r.y6)) * (e - r.y6)),
                        (r =
                          r.x3 + ((r.x4 - r.x3) / (r.y4 - r.y3)) * (e - r.y3)))
                      : ((h =
                          r.x1 + ((r.x6 - r.x1) / (r.y6 - r.y1)) * (e - r.y1)),
                        (r =
                          r.x2 + ((r.x3 - r.x2) / (r.y3 - r.y2)) * (e - r.y2)))
                    : ((h =
                        r.x1 + ((r.x4 - r.x1) / (r.y4 - r.y1)) * (e - r.y1)),
                      (r =
                        r.x2 + ((r.x3 - r.x2) / (r.y3 - r.y2)) * (e - r.y2))),
                  a > h &&
                    a < r &&
                    (c.push({
                      dataPoint: l,
                      dataPointIndex: q.dataPointIndex,
                      dataSeries: this,
                      distance: 0,
                    }),
                    (f = !0)));
                break;
              case "boxAndWhisker":
                if (
                  (a >= q.x1 - q.borderThickness / 2 &&
                    a <= q.x2 + q.borderThickness / 2 &&
                    e >= q.y4 - q.borderThickness / 2 &&
                    e <= q.y1 + q.borderThickness / 2) ||
                  (Math.abs(q.x2 - a + q.x1 - a) < q.borderThickness &&
                    e >= q.y1 &&
                    e <= q.y4)
                )
                  c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(q.x1 - a),
                      Math.abs(q.x2 - a),
                      Math.abs(q.y2 - e),
                      Math.abs(q.y3 - e)
                    ),
                  }),
                    (f = !0);
                break;
              case "candlestick":
                if (
                  (a >= q.x1 - q.borderThickness / 2 &&
                    a <= q.x2 + q.borderThickness / 2 &&
                    e >= q.y2 - q.borderThickness / 2 &&
                    e <= q.y3 + q.borderThickness / 2) ||
                  (Math.abs(q.x2 - a + q.x1 - a) < q.borderThickness &&
                    e >= q.y1 &&
                    e <= q.y4)
                )
                  c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(q.x1 - a),
                      Math.abs(q.x2 - a),
                      Math.abs(q.y2 - e),
                      Math.abs(q.y3 - e)
                    ),
                  }),
                    (f = !0);
                break;
              case "ohlc":
                if (
                  (Math.abs(q.x2 - a + q.x1 - a) < q.borderThickness &&
                    e >= q.y2 &&
                    e <= q.y3) ||
                  (a >= q.x1 &&
                    a <= (q.x2 + q.x1) / 2 &&
                    e >= q.y1 - q.borderThickness / 2 &&
                    e <= q.y1 + q.borderThickness / 2) ||
                  (a >= (q.x1 + q.x2) / 2 &&
                    a <= q.x2 &&
                    e >= q.y4 - q.borderThickness / 2 &&
                    e <= q.y4 + q.borderThickness / 2)
                )
                  c.push({
                    dataPoint: l,
                    dataPointIndex: h,
                    dataSeries: this,
                    distance: Math.min(
                      Math.abs(q.x1 - a),
                      Math.abs(q.x2 - a),
                      Math.abs(q.y2 - e),
                      Math.abs(q.y3 - e)
                    ),
                  }),
                    (f = !0);
            }
            if (f || (1e3 < m && 1e3 < n)) break;
          }
        } else if (0 > p - g && p + g >= this.dataPoints.length) break;
        -1 === d ? (g++, (d = 1)) : (d = -1);
      }
      a = null;
      for (e = 0; e < c.length; e++)
        a ? c[e].distance <= a.distance && (a = c[e]) : (a = c[e]);
      return a;
    };
    H.prototype.getMarkerProperties = function (a, e, b, c) {
      var g = this.dataPoints;
      return {
        x: e,
        y: b,
        ctx: c,
        type: g[a].markerType ? g[a].markerType : this.markerType,
        size: g[a].markerSize ? g[a].markerSize : this.markerSize,
        color: g[a].markerColor
          ? g[a].markerColor
          : this.markerColor
          ? this.markerColor
          : g[a].color
          ? g[a].color
          : this.color
          ? this.color
          : this._colorSet[a % this._colorSet.length],
        borderColor: g[a].markerBorderColor
          ? g[a].markerBorderColor
          : this.markerBorderColor
          ? this.markerBorderColor
          : null,
        borderThickness: g[a].markerBorderThickness
          ? g[a].markerBorderThickness
          : this.markerBorderThickness
          ? this.markerBorderThickness
          : null,
      };
    };
    ha(z, Q);
    z.prototype.createExtraLabelsForLog = function (a) {
      a = (a || 0) + 1;
      if (!(5 < a)) {
        var e = this.logLabelValues[0] || this.intervalStartPosition;
        if (
          Math.log(this.range) / Math.log(e / this.viewportMinimum) <
          this.noTicks - 1
        ) {
          for (
            var b = z.getNiceNumber(
                (e - this.viewportMinimum) /
                  Math.min(
                    Math.max(2, this.noTicks - this.logLabelValues.length),
                    3
                  ),
                !0
              ),
              c = Math.ceil(this.viewportMinimum / b) * b;
            c < e;
            c += b
          )
            c < this.viewportMinimum || this.logLabelValues.push(c);
          this.logLabelValues.sort(Ya);
          this.createExtraLabelsForLog(a);
        }
      }
    };
    z.prototype.createLabels = function () {
      var a,
        e,
        b = 0,
        c = 0,
        g,
        h = 0,
        d = 0,
        c = 0,
        c = this.interval,
        k = 0,
        u,
        m = 0.6 * this.chart.height,
        n;
      a = !1;
      var p = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
        q = p.length
          ? f(this.scaleBreaks.firstBreakIndex)
            ? 0
            : this.scaleBreaks.firstBreakIndex
          : 0;
      if (
        "axisX" !== this.type ||
        "dateTime" !== this.valueType ||
        this.logarithmic
      ) {
        g = this.viewportMaximum;
        if (this.labels) {
          a = Math.ceil(c);
          for (
            var c = Math.ceil(this.intervalStartPosition), l = !1, b = c;
            b < this.viewportMaximum;
            b += a
          )
            if (this.labels[b]) l = !0;
            else {
              l = !1;
              break;
            }
          l && ((this.interval = a), (this.intervalStartPosition = c));
        }
        if (this.logarithmic && !this.equidistantInterval)
          for (
            this.logLabelValues ||
              ((this.logLabelValues = []), this.createExtraLabelsForLog()),
              c = 0,
              l = q;
            c < this.logLabelValues.length;
            c++
          )
            if (((b = this.logLabelValues[c]), b < this.viewportMinimum)) c++;
            else {
              for (; l < p.length && b > p[l].endValue; l++);
              a = l < p.length && b >= p[l].startValue && b <= p[l].endValue;
              n = b;
              a ||
                ((a = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.options,
                      value: n,
                      label: this.labels[n] ? this.labels[n] : null,
                    })
                  : "axisX" === this.type && this.labels[n]
                  ? this.labels[n]
                  : $(n, this.valueFormatString, this.chart._cultureInfo)),
                (a = new na(this.ctx, {
                  x: 0,
                  y: 0,
                  maxWidth: h,
                  maxHeight: d,
                  angle: this.labelAngle,
                  text: this.prefix + a + this.suffix,
                  backgroundColor: this.labelBackgroundColor,
                  borderColor: this.labelBorderColor,
                  cornerRadius: this.labelCornerRadius,
                  textAlign: this.labelTextAlign,
                  fontSize: this.labelFontSize,
                  fontFamily: this.labelFontFamily,
                  fontWeight: this.labelFontWeight,
                  fontColor: this.labelFontColor,
                  fontStyle: this.labelFontStyle,
                  textBaseline: "middle",
                  borderThickness: 0,
                })),
                this._labels.push({
                  position: n,
                  textBlock: a,
                  effectiveHeight: null,
                }));
            }
        l = q;
        for (
          b = this.intervalStartPosition;
          b <= g;
          b = parseFloat(
            1e-12 > this.interval
              ? this.logarithmic && this.equidistantInterval
                ? b * Math.pow(this.logarithmBase, this.interval)
                : b + this.interval
              : (this.logarithmic && this.equidistantInterval
                  ? b * Math.pow(this.logarithmBase, this.interval)
                  : b + this.interval
                ).toFixed(12)
          )
        ) {
          for (; l < p.length && b > p[l].endValue; l++);
          a = l < p.length && b >= p[l].startValue && b <= p[l].endValue;
          n = b;
          a ||
            ((a = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.options,
                  value: n,
                  label: this.labels[n] ? this.labels[n] : null,
                })
              : "axisX" === this.type && this.labels[n]
              ? this.labels[n]
              : $(n, this.valueFormatString, this.chart._cultureInfo)),
            (a = new na(this.ctx, {
              x: 0,
              y: 0,
              maxWidth: h,
              maxHeight: d,
              angle: this.labelAngle,
              text: this.prefix + a + this.suffix,
              textAlign: this.labelTextAlign,
              backgroundColor: this.labelBackgroundColor,
              borderColor: this.labelBorderColor,
              borderThickness: this.labelBorderThickness,
              cornerRadius: this.labelCornerRadius,
              fontSize: this.labelFontSize,
              fontFamily: this.labelFontFamily,
              fontWeight: this.labelFontWeight,
              fontColor: this.labelFontColor,
              fontStyle: this.labelFontStyle,
              textBaseline: "middle",
            })),
            this._labels.push({
              position: n,
              textBlock: a,
              effectiveHeight: null,
            }));
        }
      } else
        for (
          this.intervalStartPosition = this.getLabelStartPoint(
            new Date(this.viewportMinimum),
            this.intervalType,
            this.interval
          ),
            g = db(
              new Date(this.viewportMaximum),
              this.interval,
              this.intervalType
            ),
            l = q,
            b = this.intervalStartPosition;
          b < g;
          db(b, c, this.intervalType)
        ) {
          for (a = b.getTime(); l < p.length && a > p[l].endValue; l++);
          n = a;
          a = l < p.length && a >= p[l].startValue && a <= p[l].endValue;
          a ||
            ((a = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.options,
                  value: new Date(n),
                  label: this.labels[n] ? this.labels[n] : null,
                })
              : "axisX" === this.type && this.labels[n]
              ? this.labels[n]
              : oa(n, this.valueFormatString, this.chart._cultureInfo)),
            (a = new na(this.ctx, {
              x: 0,
              y: 0,
              maxWidth: h,
              backgroundColor: this.labelBackgroundColor,
              borderColor: this.labelBorderColor,
              borderThickness: this.labelBorderThickness,
              cornerRadius: this.labelCornerRadius,
              maxHeight: d,
              angle: this.labelAngle,
              text: this.prefix + a + this.suffix,
              textAlign: this.labelTextAlign,
              fontSize: this.labelFontSize,
              fontFamily: this.labelFontFamily,
              fontWeight: this.labelFontWeight,
              fontColor: this.labelFontColor,
              fontStyle: this.labelFontStyle,
              textBaseline: "middle",
            })),
            this._labels.push({
              position: n,
              textBlock: a,
              effectiveHeight: null,
              breaksLabelType: void 0,
            }));
        }
      if ("bottom" === this._position || "top" === this._position)
        (k =
          this.logarithmic &&
          !this.equidistantInterval &&
          2 <= this._labels.length
            ? (this.lineCoordinates.width *
                Math.log(
                  Math.min(
                    this._labels[this._labels.length - 1].position /
                      this._labels[this._labels.length - 2].position,
                    this._labels[1].position / this._labels[0].position
                  )
                )) /
              Math.log(this.range)
            : (this.lineCoordinates.width /
                (this.logarithmic && this.equidistantInterval
                  ? Math.log(this.range) / Math.log(this.logarithmBase)
                  : Math.abs(this.range))) *
              Y[this.intervalType + "Duration"] *
              this.interval),
          (h =
            "undefined" === typeof this.options.labelMaxWidth
              ? (0.5 * this.chart.width) >> 0
              : this.options.labelMaxWidth),
          this.chart.panEnabled ||
            (d =
              "undefined" === typeof this.options.labelWrap || this.labelWrap
                ? (0.8 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize);
      else if ("left" === this._position || "right" === this._position)
        (k =
          this.logarithmic &&
          !this.equidistantInterval &&
          2 <= this._labels.length
            ? (this.lineCoordinates.height *
                Math.log(
                  Math.min(
                    this._labels[this._labels.length - 1].position /
                      this._labels[this._labels.length - 2].position,
                    this._labels[1].position / this._labels[0].position
                  )
                )) /
              Math.log(this.range)
            : (this.lineCoordinates.height /
                (this.logarithmic && this.equidistantInterval
                  ? Math.log(this.range) / Math.log(this.logarithmBase)
                  : Math.abs(this.range))) *
              Y[this.intervalType + "Duration"] *
              this.interval),
          this.chart.panEnabled ||
            (h =
              "undefined" === typeof this.options.labelMaxWidth
                ? (0.3 * this.chart.width) >> 0
                : this.options.labelMaxWidth),
          (d =
            "undefined" === typeof this.options.labelWrap || this.labelWrap
              ? (0.3 * this.chart.height) >> 0
              : 1.5 * this.labelFontSize);
      for (c = 0; c < this._labels.length; c++) {
        a = this._labels[c].textBlock;
        a.maxWidth = h;
        a.maxHeight = d;
        var r = a.measureText();
        u = r.height;
      }
      g = [];
      q = p = 0;
      if (this.labelAutoFit || this.options.labelAutoFit)
        if (
          (f(this.labelAngle) ||
            ((this.labelAngle = ((this.labelAngle % 360) + 360) % 360),
            90 < this.labelAngle && 270 > this.labelAngle
              ? (this.labelAngle -= 180)
              : 270 <= this.labelAngle &&
                360 >= this.labelAngle &&
                (this.labelAngle -= 360)),
          "bottom" === this._position || "top" === this._position)
        )
          if (
            ((h = (0.9 * k) >> 0),
            (q = 0),
            !this.chart.panEnabled && 1 <= this._labels.length)
          ) {
            this.sessionVariables.labelFontSize = this.labelFontSize;
            this.sessionVariables.labelMaxWidth = h;
            this.sessionVariables.labelMaxHeight = d;
            this.sessionVariables.labelAngle = this.labelAngle;
            this.sessionVariables.labelWrap = this.labelWrap;
            for (b = 0; b < this._labels.length; b++)
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                for (var x, l = a.text.split(" "), c = 0; c < l.length; c++)
                  (n = l[c]),
                    (this.ctx.font =
                      a.fontStyle +
                      " " +
                      a.fontWeight +
                      " " +
                      a.fontSize +
                      "px " +
                      a.fontFamily),
                    (n = this.ctx.measureText(n)),
                    n.width > q && ((x = b), (q = n.width));
              }
            b = 0;
            for (
              b = this.intervalStartPosition < this.viewportMinimum ? 1 : 0;
              b < this._labels.length;
              b++
            )
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                r = a.measureText();
                for (l = b + 1; l < this._labels.length; l++)
                  if (!this._labels[l].breaksLabelType) {
                    e = this._labels[l].textBlock;
                    e = e.measureText();
                    break;
                  }
                g.push(a.height);
                this.sessionVariables.labelMaxHeight = Math.max.apply(Math, g);
                Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
                c =
                  h * Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (d - a.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                if (
                  f(this.options.labelAngle) &&
                  isNaN(this.options.labelAngle) &&
                  0 !== this.options.labelAngle
                )
                  if (
                    ((this.sessionVariables.labelMaxHeight =
                      0 === this.labelAngle
                        ? d
                        : Math.min(
                            (c -
                              h *
                                Math.cos(
                                  (Math.PI / 180) * Math.abs(this.labelAngle)
                                )) /
                              Math.sin(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              ),
                            c
                          )),
                    (n =
                      (m -
                        (u + a.fontSize / 2) *
                          Math.cos((Math.PI / 180) * Math.abs(-25))) /
                      Math.sin((Math.PI / 180) * Math.abs(-25))),
                    !f(this.options.labelWrap))
                  )
                    this.labelWrap
                      ? f(this.options.labelMaxWidth)
                        ? ((this.sessionVariables.labelMaxWidth = Math.min(
                            Math.max(h, q),
                            n
                          )),
                          (this.sessionVariables.labelWrap = this.labelWrap),
                          e &&
                            (r.width + e.width) >> 0 > 2 * h &&
                            (this.sessionVariables.labelAngle = -25))
                        : ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth =
                            this.options.labelMaxWidth),
                          (this.sessionVariables.labelAngle =
                            this.sessionVariables.labelMaxWidth > h
                              ? -25
                              : this.sessionVariables.labelAngle))
                      : f(this.options.labelMaxWidth)
                      ? ((this.sessionVariables.labelWrap = this.labelWrap),
                        (this.sessionVariables.labelMaxHeight = d),
                        (this.sessionVariables.labelMaxWidth = h),
                        e &&
                          (r.width + e.width) >> 0 > 2 * h &&
                          ((this.sessionVariables.labelAngle = -25),
                          (this.sessionVariables.labelMaxWidth = n)))
                      : ((this.sessionVariables.labelAngle =
                          this.sessionVariables.labelMaxWidth > h
                            ? -25
                            : this.sessionVariables.labelAngle),
                        (this.sessionVariables.labelMaxWidth =
                          this.options.labelMaxWidth),
                        (this.sessionVariables.labelMaxHeight = d),
                        (this.sessionVariables.labelWrap = this.labelWrap));
                  else {
                    if (f(this.options.labelWrap))
                      if (!f(this.options.labelMaxWidth))
                        this.options.labelMaxWidth < h
                          ? ((this.sessionVariables.labelMaxWidth =
                              this.options.labelMaxWidth),
                            (this.sessionVariables.labelMaxHeight = c))
                          : ((this.sessionVariables.labelAngle = -25),
                            (this.sessionVariables.labelMaxWidth =
                              this.options.labelMaxWidth),
                            (this.sessionVariables.labelMaxHeight = d));
                      else if (!f(e))
                        if (
                          ((c = (r.width + e.width) >> 0),
                          (l = this.labelFontSize),
                          q < h)
                        )
                          c - 2 * h > p &&
                            ((p = c - 2 * h),
                            c >= 2 * h && c < 2.2 * h
                              ? ((this.sessionVariables.labelMaxWidth = h),
                                f(this.options.labelFontSize) &&
                                  12 < l &&
                                  ((l = Math.floor((12 / 13) * l)),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? l
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle))
                              : c >= 2.2 * h && c < 2.8 * h
                              ? ((this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelMaxWidth = n),
                                (this.sessionVariables.labelFontSize = l))
                              : c >= 2.8 * h && c < 3.2 * h
                              ? ((this.sessionVariables.labelMaxWidth =
                                  Math.max(h, q)),
                                (this.sessionVariables.labelWrap = !0),
                                f(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? l
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle))
                              : c >= 3.2 * h && c < 3.6 * h
                              ? ((this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelMaxWidth = n),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize))
                              : c > 3.6 * h && c < 5 * h
                              ? (f(this.options.labelFontSize) &&
                                  12 < l &&
                                  ((l = Math.floor((12 / 13) * l)),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? l
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelAngle = -25),
                                (this.sessionVariables.labelMaxWidth = n))
                              : c > 5 * h &&
                                ((this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelMaxWidth = h),
                                (this.sessionVariables.labelFontSize = l),
                                (this.sessionVariables.labelMaxHeight = d),
                                (this.sessionVariables.labelAngle =
                                  this.labelAngle)));
                        else if (
                          x === b &&
                          ((0 === x &&
                            q +
                              this._labels[x + 1].textBlock.measureText()
                                .width -
                              2 * h >
                              p) ||
                            (x === this._labels.length - 1 &&
                              q +
                                this._labels[x - 1].textBlock.measureText()
                                  .width -
                                2 * h >
                                p) ||
                            (0 < x &&
                              x < this._labels.length - 1 &&
                              q +
                                this._labels[x + 1].textBlock.measureText()
                                  .width -
                                2 * h >
                                p &&
                              q +
                                this._labels[x - 1].textBlock.measureText()
                                  .width -
                                2 * h >
                                p))
                        )
                          (p =
                            0 === x
                              ? q +
                                this._labels[x + 1].textBlock.measureText()
                                  .width -
                                2 * h
                              : q +
                                this._labels[x - 1].textBlock.measureText()
                                  .width -
                                2 * h),
                            (this.sessionVariables.labelFontSize = f(
                              this.options.labelFontSize
                            )
                              ? l
                              : this.options.labelFontSize),
                            (this.sessionVariables.labelWrap = !0),
                            (this.sessionVariables.labelAngle = -25),
                            (this.sessionVariables.labelMaxWidth = n);
                        else if (0 === p)
                          for (
                            this.sessionVariables.labelFontSize = f(
                              this.options.labelFontSize
                            )
                              ? l
                              : this.options.labelFontSize,
                              this.sessionVariables.labelWrap = !0,
                              c = 0;
                            c < this._labels.length;
                            c++
                          )
                            (a = this._labels[c].textBlock),
                              (a.maxWidth =
                                this.sessionVariables.labelMaxWidth =
                                  Math.min(Math.max(h, q), n)),
                              (r = a.measureText()),
                              c < this._labels.length - 1 &&
                                ((l = c + 1),
                                (e = this._labels[l].textBlock),
                                (e.maxWidth =
                                  this.sessionVariables.labelMaxWidth =
                                    Math.min(Math.max(h, q), n)),
                                (e = e.measureText()),
                                (r.width + e.width) >> 0 > 2 * h &&
                                  (this.sessionVariables.labelAngle = -25));
                  }
                else
                  ((this.sessionVariables.labelAngle = this.labelAngle),
                  (this.sessionVariables.labelMaxHeight =
                    0 === this.labelAngle
                      ? d
                      : Math.min(
                          (c -
                            h *
                              Math.cos(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              )) /
                            Math.sin(
                              (Math.PI / 180) * Math.abs(this.labelAngle)
                            ),
                          c
                        )),
                  (n =
                    0 != this.labelAngle
                      ? (m -
                          (u + a.fontSize / 2) *
                            Math.cos(
                              (Math.PI / 180) * Math.abs(this.labelAngle)
                            )) /
                        Math.sin((Math.PI / 180) * Math.abs(this.labelAngle))
                      : h),
                  (this.sessionVariables.labelMaxHeight = this.labelWrap
                    ? (m -
                        n *
                          Math.sin(
                            (Math.PI / 180) * Math.abs(this.labelAngle)
                          )) /
                      Math.cos((Math.PI / 180) * Math.abs(this.labelAngle))
                    : 1.5 * this.labelFontSize),
                  f(this.options.labelWrap))
                    ? f(this.options.labelWrap) &&
                      (this.labelWrap && !f(this.options.labelMaxWidth)
                        ? ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : n),
                          (this.sessionVariables.labelMaxHeight = d))
                        : ((this.sessionVariables.labelAngle = this.labelAngle),
                          (this.sessionVariables.labelMaxWidth = n),
                          (this.sessionVariables.labelMaxHeight =
                            c < 0.9 * k ? 0.9 * k : c),
                          (this.sessionVariables.labelWrap = this.labelWrap)))
                    : (this.options.labelWrap
                        ? ((this.sessionVariables.labelWrap = this.labelWrap),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : n))
                        : (f(this.options.labelMaxWidth),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : n),
                          (this.sessionVariables.labelWrap = this.labelWrap)),
                      (this.sessionVariables.labelMaxHeight = d));
              }
            for (c = 0; c < this._labels.length; c++)
              (a = this._labels[c].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  this.sessionVariables.labelMaxWidth),
                (a.fontSize = this.sessionVariables.labelFontSize),
                (a.angle = this.labelAngle = this.sessionVariables.labelAngle),
                (a.wrap = this.labelWrap = this.sessionVariables.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
          } else
            for (b = 0; b < this._labels.length; b++)
              (a = this._labels[b].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  f(this.options.labelMaxWidth)
                    ? f(this.sessionVariables.labelMaxWidth)
                      ? (this.sessionVariables.labelMaxWidth = h)
                      : this.sessionVariables.labelMaxWidth
                    : this.options.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  f(this.options.labelFontSize)
                    ? f(this.sessionVariables.labelFontSize)
                      ? (this.sessionVariables.labelFontSize =
                          this.labelFontSize)
                      : this.sessionVariables.labelFontSize
                    : this.options.labelFontSize),
                (a.angle = this.labelAngle =
                  f(this.options.labelAngle)
                    ? f(this.sessionVariables.labelAngle)
                      ? (this.sessionVariables.labelAngle = this.labelAngle)
                      : this.sessionVariables.labelAngle
                    : this.labelAngle),
                (a.wrap = this.labelWrap =
                  f(this.options.labelWrap)
                    ? f(this.sessionVariables.labelWrap)
                      ? (this.sessionVariables.labelWrap = this.labelWrap)
                      : this.sessionVariables.labelWrap
                    : this.options.labelWrap),
                (a.maxHeight = f(this.sessionVariables.labelMaxHeight)
                  ? (this.sessionVariables.labelMaxHeight = d)
                  : this.sessionVariables.labelMaxHeight),
                a.measureText();
        else if ("left" === this._position || "right" === this._position)
          if (
            ((h = f(this.options.labelMaxWidth)
              ? (0.3 * this.chart.width) >> 0
              : this.options.labelMaxWidth),
            (d =
              "undefined" === typeof this.options.labelWrap || this.labelWrap
                ? (0.3 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize),
            !this.chart.panEnabled && 1 <= this._labels.length)
          ) {
            this.sessionVariables.labelFontSize = this.labelFontSize;
            this.sessionVariables.labelMaxWidth = h;
            this.sessionVariables.labelMaxHeight = d;
            this.sessionVariables.labelAngle = f(
              this.sessionVariables.labelAngle
            )
              ? 0
              : this.sessionVariables.labelAngle;
            this.sessionVariables.labelWrap = this.labelWrap;
            for (b = 0; b < this._labels.length; b++)
              if (!this._labels[b].breaksLabelType) {
                a = this._labels[b].textBlock;
                r = a.measureText();
                for (l = b + 1; l < this._labels.length; l++)
                  if (!this._labels[l].breaksLabelType) {
                    e = this._labels[l].textBlock;
                    e = e.measureText();
                    break;
                  }
                g.push(a.height);
                this.sessionVariables.labelMaxHeight = Math.max.apply(Math, g);
                c =
                  h * Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (d - a.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
                Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
                f(this.options.labelAngle) &&
                isNaN(this.options.labelAngle) &&
                0 !== this.options.labelAngle
                  ? f(this.options.labelWrap)
                    ? f(this.options.labelWrap) &&
                      (f(this.options.labelMaxWidth)
                        ? f(e) ||
                          ((k = (r.height + e.height) >> 0),
                          k - 2 * d > q &&
                            ((q = k - 2 * d),
                            k >= 2 * d && k < 2.4 * d
                              ? (f(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelMaxHeight = d),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize))
                              : k >= 2.4 * d && k < 2.8 * d
                              ? ((this.sessionVariables.labelMaxHeight = c),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize),
                                (this.sessionVariables.labelWrap = !0))
                              : k >= 2.8 * d && k < 3.2 * d
                              ? ((this.sessionVariables.labelMaxHeight = d),
                                (this.sessionVariables.labelWrap = !0),
                                f(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelAngle = f(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))
                              : k >= 3.2 * d && k < 3.6 * d
                              ? ((this.sessionVariables.labelMaxHeight = c),
                                (this.sessionVariables.labelWrap = !0),
                                (this.sessionVariables.labelFontSize =
                                  this.labelFontSize))
                              : k > 3.6 * d && k < 10 * d
                              ? (f(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelMaxWidth = h),
                                (this.sessionVariables.labelMaxHeight = d),
                                (this.sessionVariables.labelAngle = f(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))
                              : k > 10 * d &&
                                k < 50 * d &&
                                (f(this.options.labelFontSize) &&
                                  12 < this.labelFontSize &&
                                  ((this.labelFontSize = Math.floor(
                                    (12 / 13) * this.labelFontSize
                                  )),
                                  a.measureText()),
                                (this.sessionVariables.labelFontSize = f(
                                  this.options.labelFontSize
                                )
                                  ? this.labelFontSize
                                  : this.options.labelFontSize),
                                (this.sessionVariables.labelMaxHeight = d),
                                (this.sessionVariables.labelMaxWidth = h),
                                (this.sessionVariables.labelAngle = f(
                                  this.sessionVariables.labelAngle
                                )
                                  ? 0
                                  : this.sessionVariables.labelAngle))))
                        : ((this.sessionVariables.labelMaxHeight = d),
                          (this.sessionVariables.labelMaxWidth = this.options
                            .labelMaxWidth
                            ? this.options.labelMaxWidth
                            : this.sessionVariables.labelMaxWidth)))
                    : ((this.sessionVariables.labelMaxWidth = this.labelWrap
                        ? this.options.labelMaxWidth
                          ? this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth
                        : this.labelMaxWidth
                        ? this.options.labelMaxWidth
                          ? this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth
                        : h),
                      (this.sessionVariables.labelMaxHeight = d))
                  : ((this.sessionVariables.labelAngle = this.labelAngle),
                    (this.sessionVariables.labelMaxWidth =
                      0 === this.labelAngle
                        ? h
                        : Math.min(
                            (c -
                              d *
                                Math.sin(
                                  (Math.PI / 180) * Math.abs(this.labelAngle)
                                )) /
                              Math.cos(
                                (Math.PI / 180) * Math.abs(this.labelAngle)
                              ),
                            d
                          )),
                    f(this.options.labelWrap))
                  ? f(this.options.labelWrap) &&
                    (this.labelWrap && !f(this.options.labelMaxWidth)
                      ? ((this.sessionVariables.labelMaxWidth = this.options
                          .labelMaxWidth
                          ? this.options.labelMaxWidth
                          : this.sessionVariables.labelMaxWidth),
                        (this.sessionVariables.labelWrap = this.labelWrap),
                        (this.sessionVariables.labelMaxHeight = c))
                      : ((this.sessionVariables.labelMaxWidth = this.options
                          .labelMaxWidth
                          ? this.options.labelMaxWidth
                          : h),
                        (this.sessionVariables.labelMaxHeight =
                          0 === this.labelAngle ? d : c),
                        f(this.options.labelMaxWidth) &&
                          (this.sessionVariables.labelAngle = this.labelAngle)))
                  : this.options.labelWrap
                  ? ((this.sessionVariables.labelMaxHeight =
                      0 === this.labelAngle ? d : c),
                    (this.sessionVariables.labelWrap = this.labelWrap),
                    (this.sessionVariables.labelMaxWidth = h))
                  : ((this.sessionVariables.labelMaxHeight = d),
                    f(this.options.labelMaxWidth),
                    (this.sessionVariables.labelMaxWidth = this.options
                      .labelMaxWidth
                      ? this.options.labelMaxWidth
                      : this.sessionVariables.labelMaxWidth),
                    (this.sessionVariables.labelWrap = this.labelWrap));
              }
            for (c = 0; c < this._labels.length; c++)
              (a = this._labels[c].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  this.sessionVariables.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  this.sessionVariables.labelFontSize),
                (a.angle = this.labelAngle = this.sessionVariables.labelAngle),
                (a.wrap = this.labelWrap = this.sessionVariables.labelWrap),
                (a.maxHeight = this.sessionVariables.labelMaxHeight),
                a.measureText();
          } else
            for (b = 0; b < this._labels.length; b++)
              (a = this._labels[b].textBlock),
                (a.maxWidth = this.labelMaxWidth =
                  f(this.options.labelMaxWidth)
                    ? f(this.sessionVariables.labelMaxWidth)
                      ? (this.sessionVariables.labelMaxWidth = h)
                      : this.sessionVariables.labelMaxWidth
                    : this.options.labelMaxWidth),
                (a.fontSize = this.labelFontSize =
                  f(this.options.labelFontSize)
                    ? f(this.sessionVariables.labelFontSize)
                      ? (this.sessionVariables.labelFontSize =
                          this.labelFontSize)
                      : this.sessionVariables.labelFontSize
                    : this.options.labelFontSize),
                (a.angle = this.labelAngle =
                  f(this.options.labelAngle)
                    ? f(this.sessionVariables.labelAngle)
                      ? (this.sessionVariables.labelAngle = this.labelAngle)
                      : this.sessionVariables.labelAngle
                    : this.labelAngle),
                (a.wrap = this.labelWrap =
                  f(this.options.labelWrap)
                    ? f(this.sessionVariables.labelWrap)
                      ? (this.sessionVariables.labelWrap = this.labelWrap)
                      : this.sessionVariables.labelWrap
                    : this.options.labelWrap),
                (a.maxHeight = f(this.sessionVariables.labelMaxHeight)
                  ? (this.sessionVariables.labelMaxHeight = d)
                  : this.sessionVariables.labelMaxHeight),
                a.measureText();
      for (b = 0; b < this.stripLines.length; b++) {
        var h = this.stripLines[b],
          t;
        if ("outside" === h.labelPlacement) {
          d = this.sessionVariables.labelMaxWidth;
          if ("bottom" === this._position || "top" === this._position)
            f(h.options.labelWrap) &&
            !f(this.sessionVariables.stripLineLabelMaxHeight)
              ? (t = this.sessionVariables.stripLineLabelMaxHeight)
              : (this.sessionVariables.stripLineLabelMaxHeight = t =
                  h.labelWrap
                    ? (0.8 * this.chart.height) >> 0
                    : 1.5 * this.labelFontSize);
          if ("left" === this._position || "right" === this._position)
            f(h.options.labelWrap) &&
            !f(this.sessionVariables.stripLineLabelMaxHeight)
              ? (t = this.sessionVariables.stripLineLabelMaxHeight)
              : (this.sessionVariables.stripLineLabelMaxHeight = t =
                  h.labelWrap
                    ? (0.8 * this.chart.width) >> 0
                    : 1.5 * this.labelFontSize);
          f(h.labelBackgroundColor) && (h.labelBackgroundColor = "#EEEEEE");
        } else
          (d =
            "bottom" === this._position || "top" === this._position
              ? (0.9 * this.chart.width) >> 0
              : (0.9 * this.chart.height) >> 0),
            (t =
              f(h.options.labelWrap) || h.labelWrap
                ? "bottom" === this._position || "top" === this._position
                  ? (0.8 * this.chart.width) >> 0
                  : (0.8 * this.chart.height) >> 0
                : 1.5 * this.labelFontSize),
            f(h.labelBackgroundColor) &&
              (f(h.startValue) && 0 !== h.startValue
                ? (h.labelBackgroundColor = v ? "transparent" : null)
                : (h.labelBackgroundColor = "#EEEEEE"));
        a = new na(this.ctx, {
          x: 0,
          y: 0,
          backgroundColor: h.labelBackgroundColor,
          borderColor: h.labelBorderColor,
          borderThickness: h.labelBorderThickness,
          cornerRadius: h.labelCornerRadius,
          maxWidth: h.options.labelMaxWidth ? h.options.labelMaxWidth : d,
          maxHeight: t,
          angle: this.labelAngle,
          text: h.labelFormatter
            ? h.labelFormatter({ chart: this.chart, axis: this, stripLine: h })
            : h.label,
          textAlign: this.labelTextAlign,
          fontSize:
            "outside" === h.labelPlacement
              ? h.options.labelFontSize
                ? h.labelFontSize
                : this.labelFontSize
              : h.labelFontSize,
          fontFamily:
            "outside" === h.labelPlacement
              ? h.options.labelFontFamily
                ? h.labelFontFamily
                : this.labelFontFamily
              : h.labelFontFamily,
          fontWeight:
            "outside" === h.labelPlacement
              ? h.options.labelFontWeight
                ? h.labelFontWeight
                : this.labelFontWeight
              : h.labelFontWeight,
          fontColor: h.labelFontColor || h.color,
          fontStyle:
            "outside" === h.labelPlacement
              ? h.options.labelFontStyle
                ? h.labelFontStyle
                : this.fontWeight
              : h.labelFontStyle,
          textBaseline: "middle",
        });
        this._stripLineLabels.push({
          position: h.value,
          textBlock: a,
          effectiveHeight: null,
          stripLine: h,
        });
      }
    };
    z.prototype.createLabelsAndCalculateWidth = function () {
      var a = 0,
        e = 0;
      this._labels = [];
      this._stripLineLabels = [];
      var b = this.chart.isNavigator ? 0 : 5;
      if ("left" === this._position || "right" === this._position) {
        this.createLabels();
        if (
          "inside" != this.labelPlacement ||
          ("inside" === this.labelPlacement && 0 < this._index)
        )
          for (e = 0; e < this._labels.length; e++) {
            var c = this._labels[e].textBlock,
              g = c.measureText(),
              h = 0,
              h =
                0 === this.labelAngle
                  ? g.width
                  : g.width *
                      Math.cos((Math.PI / 180) * Math.abs(this.labelAngle)) +
                    (g.height - c.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(this.labelAngle));
            a < h && (a = h);
            this._labels[e].effectiveWidth = h;
          }
        for (e = 0; e < this._stripLineLabels.length; e++)
          "outside" === this._stripLineLabels[e].stripLine.labelPlacement &&
            this._stripLineLabels[e].stripLine.value >= this.viewportMinimum &&
            this._stripLineLabels[e].stripLine.value <= this.viewportMaximum &&
            ((c = this._stripLineLabels[e].textBlock),
            (g = c.measureText()),
            (h =
              0 === this.labelAngle
                ? g.width
                : g.width *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (g.height - c.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle))),
            a < h && (a = h),
            (this._stripLineLabels[e].effectiveWidth = h));
      }
      return (
        (this.title ? this._titleTextBlock.measureText().height + 2 : 0) +
        a +
        ("inside" === this.tickPlacement ? 0 : this.tickLength) +
        b
      );
    };
    z.prototype.createLabelsAndCalculateHeight = function () {
      var a = 0;
      this._labels = [];
      this._stripLineLabels = [];
      var e,
        b = 0,
        c = this.chart.isNavigator ? 0 : 5;
      if ("bottom" === this._position || "top" === this._position) {
        this.createLabels();
        if (
          "inside" != this.labelPlacement ||
          ("inside" === this.labelPlacement && 0 < this._index)
        )
          for (b = 0; b < this._labels.length; b++) {
            e = this._labels[b].textBlock;
            var g = e.measureText(),
              h = 0,
              h =
                0 === this.labelAngle
                  ? g.height
                  : g.width *
                      Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                    (g.height - e.fontSize / 2) *
                      Math.cos((Math.PI / 180) * Math.abs(this.labelAngle));
            a < h && (a = h);
            this._labels[b].effectiveHeight = h;
          }
        for (b = 0; b < this._stripLineLabels.length; b++)
          "outside" === this._stripLineLabels[b].stripLine.labelPlacement &&
            this._stripLineLabels[b].stripLine.value >= this.viewportMinimum &&
            this._stripLineLabels[b].stripLine.value <= this.viewportMaximum &&
            ((e = this._stripLineLabels[b].textBlock),
            (g = e.measureText()),
            (h =
              0 === this.labelAngle
                ? g.height
                : g.width *
                    Math.sin((Math.PI / 180) * Math.abs(this.labelAngle)) +
                  (g.height - e.fontSize / 2) *
                    Math.cos((Math.PI / 180) * Math.abs(this.labelAngle))),
            a < h && (a = h),
            (this._stripLineLabels[b].effectiveHeight = h));
      }
      return (
        (this.title ? this._titleTextBlock.measureText().height + 2 : 0) +
        a +
        ("inside" === this.tickPlacement ? 0 : this.tickLength) +
        c
      );
    };
    z.setLayout = function (a, e, b, c, g, h) {
      var d,
        k,
        u,
        m,
        n = a[0] ? a[0].chart : e[0].chart,
        p = n.isNavigator ? 0 : 10,
        q = n._axes;
      if (a && 0 < a.length)
        for (var l = 0; l < a.length; l++)
          a[l] && a[l].calculateAxisParameters();
      if (e && 0 < e.length)
        for (l = 0; l < e.length; l++) e[l].calculateAxisParameters();
      if (b && 0 < b.length)
        for (l = 0; l < b.length; l++) b[l].calculateAxisParameters();
      if (c && 0 < c.length)
        for (l = 0; l < c.length; l++) c[l].calculateAxisParameters();
      for (l = 0; l < q.length; l++)
        if (q[l] && q[l].scaleBreaks && q[l].scaleBreaks._appliedBreaks.length)
          for (
            var r = q[l].scaleBreaks._appliedBreaks, x = 0;
            x < r.length && !(r[x].startValue > q[l].viewportMaximum);
            x++
          )
            r[x].endValue < q[l].viewportMinimum ||
              (f(q[l].scaleBreaks.firstBreakIndex) &&
                (q[l].scaleBreaks.firstBreakIndex = x),
              r[x].startValue >= q[l].viewPortMinimum &&
                (q[l].scaleBreaks.lastBreakIndex = x));
      for (
        var t = (x = 0),
          w = 0,
          v = 0,
          s = 0,
          y = 0,
          z = 0,
          C,
          B,
          F = (k = 0),
          H,
          L,
          K,
          r = (H = L = K = !1),
          l = 0;
        l < q.length;
        l++
      )
        q[l] &&
          q[l].title &&
          (q[l]._titleTextBlock = new na(q[l].ctx, {
            text: q[l].title,
            horizontalAlign: "center",
            fontSize: q[l].titleFontSize,
            fontFamily: q[l].titleFontFamily,
            fontWeight: q[l].titleFontWeight,
            fontColor: q[l].titleFontColor,
            fontStyle: q[l].titleFontStyle,
            borderColor: q[l].titleBorderColor,
            borderThickness: q[l].titleBorderThickness,
            backgroundColor: q[l].titleBackgroundColor,
            cornerRadius: q[l].titleCornerRadius,
            textBaseline: "top",
          }));
      for (l = 0; l < q.length; l++)
        if (q[l].title)
          switch (q[l]._position) {
            case "left":
              q[l]._titleTextBlock.maxWidth = q[l].titleMaxWidth || h.height;
              q[l]._titleTextBlock.maxHeight = q[l].titleWrap
                ? 0.8 * h.width
                : 1.5 * q[l].titleFontSize;
              q[l]._titleTextBlock.angle = -90;
              break;
            case "right":
              q[l]._titleTextBlock.maxWidth = q[l].titleMaxWidth || h.height;
              q[l]._titleTextBlock.maxHeight = q[l].titleWrap
                ? 0.8 * h.width
                : 1.5 * q[l].titleFontSize;
              q[l]._titleTextBlock.angle = 90;
              break;
            default:
              (q[l]._titleTextBlock.maxWidth = q[l].titleMaxWidth || h.width),
                (q[l]._titleTextBlock.maxHeight = q[l].titleWrap
                  ? 0.8 * h.height
                  : 1.5 * q[l].titleFontSize),
                (q[l]._titleTextBlock.angle = 0);
          }
      if ("normal" === g) {
        for (
          var v = [], s = [], y = [], z = [], P = [], M = [], Q = [], N = [];
          4 > x;

        ) {
          var G = 0,
            U = 0,
            O = 0,
            W = 0,
            Z = (g = 0),
            S = 0,
            aa = 0,
            X = 0,
            Y = 0,
            T = 0,
            $ = 0;
          if (b && 0 < b.length)
            for (y = [], l = T = 0; l < b.length; l++)
              y.push(
                Math.ceil(b[l] ? b[l].createLabelsAndCalculateWidth() : 0)
              ),
                (T += y[l]),
                (S += b[l] && !n.isNavigator ? b[l].margin : 0);
          else
            y.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateWidth() : 0));
          Q.push(y);
          if (c && 0 < c.length)
            for (z = [], l = $ = 0; l < c.length; l++)
              z.push(
                Math.ceil(c[l] ? c[l].createLabelsAndCalculateWidth() : 0)
              ),
                ($ += z[l]),
                (aa += c[l] ? c[l].margin : 0);
          else
            z.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateWidth() : 0));
          N.push(z);
          d = Math.round(h.x1 + T + S);
          u = Math.round(
            h.x2 - $ - aa > n.width - p ? n.width - p : h.x2 - $ - aa
          );
          if (a && 0 < a.length)
            for (v = [], l = X = 0; l < a.length; l++)
              a[l] && (a[l].lineCoordinates = {}),
                (a[l].lineCoordinates.width = Math.abs(u - d)),
                a[l].title &&
                  (a[l]._titleTextBlock.maxWidth =
                    0 < a[l].titleMaxWidth &&
                    a[l].titleMaxWidth < a[l].lineCoordinates.width
                      ? a[l].titleMaxWidth
                      : a[l].lineCoordinates.width),
                v.push(
                  Math.ceil(a[l] ? a[l].createLabelsAndCalculateHeight() : 0)
                ),
                (X += v[l]),
                (g += a[l] && !n.isNavigator ? a[l].margin : 0);
          else
            v.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateHeight() : 0));
          P.push(v);
          if (e && 0 < e.length)
            for (s = [], l = Y = 0; l < e.length; l++)
              e[l] && (e[l].lineCoordinates = {}),
                (e[l].lineCoordinates.width = Math.abs(u - d)),
                e[l].title &&
                  (e[l]._titleTextBlock.maxWidth =
                    0 < e[l].titleMaxWidth &&
                    e[l].titleMaxWidth < e[l].lineCoordinates.width
                      ? e[l].titleMaxWidth
                      : e[l].lineCoordinates.width),
                s.push(
                  Math.ceil(e[l] ? e[l].createLabelsAndCalculateHeight() : 0)
                ),
                (Y += s[l]),
                (Z += e[l] && !n.isNavigator ? e[l].margin : 0);
          else
            s.push(Math.ceil(e[0] ? e[0].createLabelsAndCalculateHeight() : 0));
          M.push(s);
          if (a && 0 < a.length)
            for (l = 0; l < a.length; l++)
              a[l] &&
                ((a[l].lineCoordinates.x1 = d),
                (u = Math.round(
                  h.x2 - $ - aa > n.width - p ? n.width - p : h.x2 - $ - aa
                )),
                a[l]._labels &&
                  1 < a[l]._labels.length &&
                  ((k = m = 0),
                  (m = a[l]._labels[1]),
                  (k =
                    "dateTime" === a[l].valueType
                      ? a[l]._labels[a[l]._labels.length - 2]
                      : a[l]._labels[a[l]._labels.length - 1]),
                  (t =
                    m.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(m.textBlock.angle)) +
                    (m.textBlock.height - k.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(m.textBlock.angle))),
                  (w =
                    k.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                    (k.textBlock.height - k.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle)))),
                !a[l] ||
                  !a[l].labelAutoFit ||
                  f(C) ||
                  f(B) ||
                  n.isNavigator ||
                  n.stockChart ||
                  ((k = 0),
                  0 < a[l].labelAngle
                    ? B + w > u &&
                      (k += 0 < a[l].labelAngle ? B + w - u - $ : 0)
                    : 0 > a[l].labelAngle
                    ? C - t < d &&
                      C - t < a[l].viewportMinimum &&
                      (F =
                        d -
                        (S +
                          a[l].tickLength +
                          y +
                          C -
                          t +
                          a[l].labelFontSize / 2))
                    : 0 === a[l].labelAngle &&
                      (B + w > u && (k = B + w / 2 - u - $),
                      C - t < d &&
                        C - t < a[l].viewportMinimum &&
                        (F = d - S - a[l].tickLength - y - C + t / 2)),
                  a[l].viewportMaximum === a[l].maximum &&
                  a[l].viewportMinimum === a[l].minimum &&
                  0 < a[l].labelAngle &&
                  0 < k
                    ? (u -= k)
                    : a[l].viewportMaximum === a[l].maximum &&
                      a[l].viewportMinimum === a[l].minimum &&
                      0 > a[l].labelAngle &&
                      0 < F
                    ? (d += F)
                    : a[l].viewportMaximum === a[l].maximum &&
                      a[l].viewportMinimum === a[l].minimum &&
                      0 === a[l].labelAngle &&
                      (0 < F && (d += F), 0 < k && (u -= k))),
                n.panEnabled
                  ? (X = f(n.sessionVariables.axisX.height)
                      ? (n.sessionVariables.axisX.height = X)
                      : n.sessionVariables.axisX.height)
                  : (n.sessionVariables.axisX.height = X),
                (k = Math.round(h.y2 - X - g + G)),
                (m = Math.round(h.y2)),
                (a[l].lineCoordinates.x2 = u),
                (a[l].lineCoordinates.width = u - d),
                (a[l].lineCoordinates.y1 = k),
                (a[l].lineCoordinates.y2 = k + a[l].lineThickness / 2),
                "inside" === a[l].labelPlacement &&
                  0 < l &&
                  ((a[l].lineCoordinates.y1 =
                    a[l].lineCoordinates.y1 +
                    v[l] -
                    (a[l]._titleTextBlock ? a[l]._titleTextBlock.height : 0) -
                    ("inside" === a[l].tickPlacement ? a[l].tickLength : 0)),
                  (a[l].lineCoordinates.y2 =
                    a[l].lineCoordinates.y1 + a[l].lineThickness / 2)),
                (a[l].bounds = {
                  x1: d,
                  y1: k,
                  x2: u,
                  y2: m - (X + g - v[l] - G),
                  width: u - d,
                  height: m - k,
                })),
                (G += v[l] + a[l].margin);
          if (e && 0 < e.length)
            for (l = 0; l < e.length; l++)
              (e[l].lineCoordinates.x1 = Math.round(h.x1 + T + S)),
                (e[l].lineCoordinates.x2 = Math.round(
                  h.x2 - $ - aa > n.width - p ? n.width - p : h.x2 - $ - aa
                )),
                (e[l].lineCoordinates.width = Math.abs(u - d)),
                e[l]._labels &&
                  1 < e[l]._labels.length &&
                  ((m = e[l]._labels[1]),
                  (k =
                    "dateTime" === e[l].valueType
                      ? e[l]._labels[e[l]._labels.length - 2]
                      : e[l]._labels[e[l]._labels.length - 1]),
                  (t =
                    m.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(m.textBlock.angle)) +
                    (m.textBlock.height - k.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(m.textBlock.angle))),
                  (w =
                    k.textBlock.width *
                      Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                    (k.textBlock.height - k.textBlock.fontSize / 2) *
                      Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle)))),
                n.panEnabled
                  ? (Y = f(n.sessionVariables.axisX2.height)
                      ? (n.sessionVariables.axisX2.height = Y)
                      : n.sessionVariables.axisX2.height)
                  : (n.sessionVariables.axisX2.height = Y),
                (k = Math.round(h.y1)),
                (m = Math.round(h.y2 + e[l].margin)),
                (e[l].lineCoordinates.y1 = k + Y + Z - U),
                (e[l].lineCoordinates.y2 = k),
                "inside" === e[l].labelPlacement &&
                  0 < l &&
                  (e[l].lineCoordinates.y1 =
                    e[l - 1].bounds.y1 -
                    s[l] +
                    (e[l]._titleTextBlock ? e[l]._titleTextBlock.height : 0)),
                (e[l].bounds = {
                  x1: d,
                  y1: k + (Y + Z - s[l] - U),
                  x2: u,
                  y2: m,
                  width: u - d,
                  height: m - k,
                }),
                (U += s[l] + e[l].margin);
          if (b && 0 < b.length)
            for (l = 0; l < b.length; l++)
              (S = n.isNavigator ? 0 : 10),
                b[l] &&
                  ((d = Math.round(
                    a[0] ? a[0].lineCoordinates.x1 : e[0].lineCoordinates.x1
                  )),
                  (S =
                    b[l]._labels && 0 < b[l]._labels.length
                      ? b[l]._labels[b[l]._labels.length - 1].textBlock.height /
                        2
                      : p),
                  (k = Math.round(
                    h.y1 + Y + Z < Math.max(S, p)
                      ? Math.max(S, p)
                      : h.y1 + Y + Z
                  )),
                  (u = Math.round(
                    a[0] ? a[0].lineCoordinates.x1 : e[0].lineCoordinates.x1
                  )),
                  (S =
                    0 < a.length
                      ? 0
                      : b[l]._labels && 0 < b[l]._labels.length
                      ? b[l]._labels[0].textBlock.height / 2
                      : p),
                  (m = Math.round(h.y2 - X - g - S)),
                  (b[l].lineCoordinates = {
                    x1: d - O,
                    y1: k,
                    x2: u - O,
                    y2: m,
                    height: Math.abs(m - k),
                  }),
                  "inside" === b[l].labelPlacement &&
                    0 < l &&
                    ((b[l].lineCoordinates.x1 =
                      b[l].lineCoordinates.x1 -
                      (y[l] - b[l]._titleTextBlock
                        ? b[l]._titleTextBlock.height
                        : 0) +
                      ("outside" === b[l].tickPlacement ? b[l].tickLength : 0)),
                    (b[l].lineCoordinates.x2 =
                      b[l].lineCoordinates.x1 + b[l].lineThickness / 2)),
                  (b[l].bounds = {
                    x1: d - (y[l] + O),
                    y1: k,
                    x2: u,
                    y2: m,
                    width: u - d,
                    height: m - k,
                  }),
                  b[l].title &&
                    (b[l]._titleTextBlock.maxWidth =
                      0 < b[l].titleMaxWidth &&
                      b[l].titleMaxWidth < b[l].lineCoordinates.height
                        ? b[l].titleMaxWidth
                        : b[l].lineCoordinates.height),
                  (O += y[l] + b[l].margin));
          if (c && 0 < c.length)
            for (l = 0; l < c.length; l++)
              c[l] &&
                ((d = Math.round(
                  a[0] ? a[0].lineCoordinates.x2 : e[0].lineCoordinates.x2
                )),
                (u = Math.round(d)),
                (S =
                  c[l]._labels && 0 < c[l]._labels.length
                    ? c[l]._labels[c[l]._labels.length - 1].textBlock.height / 2
                    : 0),
                (k = Math.round(
                  h.y1 + Y + Z < Math.max(S, p) ? Math.max(S, p) : h.y1 + Y + Z
                )),
                (S =
                  0 < a.length
                    ? 0
                    : c[l]._labels && 0 < c[l]._labels.length
                    ? c[l]._labels[0].textBlock.height / 2
                    : 0),
                (m = Math.round(h.y2 - (X + g + S))),
                (c[l].lineCoordinates = {
                  x1: d + W,
                  y1: k,
                  x2: d + W,
                  y2: m,
                  height: Math.abs(m - k),
                }),
                "inside" === c[l].labelPlacement &&
                  0 < l &&
                  ((c[l].lineCoordinates.x1 =
                    c[l].lineCoordinates.x1 +
                    (z[l] - c[l]._titleTextBlock
                      ? c[l]._titleTextBlock.height
                      : 0) -
                    ("outside" === c[l].tickPlacement ? c[l].tickLength : 0) -
                    2),
                  (c[l].lineCoordinates.x2 =
                    c[l].lineCoordinates.x1 + c[l].lineThickness / 2)),
                (c[l].bounds = {
                  x1: d,
                  y1: k,
                  x2: u + (z[l] + W),
                  y2: m,
                  width: u - d,
                  height: m - k,
                }),
                c[l].title &&
                  (c[l]._titleTextBlock.maxWidth =
                    0 < c[l].titleMaxWidth &&
                    c[l].titleMaxWidth < c[l].lineCoordinates.height
                      ? c[l].titleMaxWidth
                      : c[l].lineCoordinates.height),
                (W += z[l] + c[l].margin));
          if (a && 0 < a.length)
            for (l = 0; l < a.length; l++)
              a[l] &&
                (a[l].calculateValueToPixelConversionParameters(),
                a[l].calculateBreaksSizeInValues(),
                a[l]._labels &&
                  1 < a[l]._labels.length &&
                  ((C =
                    (a[l].logarithmic
                      ? Math.log(
                          a[l]._labels[1].position / a[l].viewportMinimum
                        ) / a[l].conversionParameters.lnLogarithmBase
                      : a[l]._labels[1].position - a[l].viewportMinimum) *
                      Math.abs(a[l].conversionParameters.pixelPerUnit) +
                    a[l].lineCoordinates.x1),
                  (d =
                    a[l]._labels[
                      a[l]._labels.length -
                        ("dateTime" === a[l].valueType ? 2 : 1)
                    ].position),
                  (d = a[l].getApparentDifference(a[l].viewportMinimum, d)),
                  (B = a[l].logarithmic
                    ? (1 < d
                        ? (Math.log(d) /
                            a[l].conversionParameters.lnLogarithmBase) *
                          Math.abs(a[l].conversionParameters.pixelPerUnit)
                        : 0) + a[l].lineCoordinates.x1
                    : (0 < d
                        ? d * Math.abs(a[l].conversionParameters.pixelPerUnit)
                        : 0) + a[l].lineCoordinates.x1)));
          if (e && 0 < e.length)
            for (l = 0; l < e.length; l++)
              e[l].calculateValueToPixelConversionParameters(),
                e[l].calculateBreaksSizeInValues(),
                e[l]._labels &&
                  1 < e[l]._labels.length &&
                  ((C =
                    (e[l].logarithmic
                      ? Math.log(
                          e[l]._labels[1].position / e[l].viewportMinimum
                        ) / e[l].conversionParameters.lnLogarithmBase
                      : e[l]._labels[1].position - e[l].viewportMinimum) *
                      Math.abs(e[l].conversionParameters.pixelPerUnit) +
                    e[l].lineCoordinates.x1),
                  (d =
                    e[l]._labels[
                      e[l]._labels.length -
                        ("dateTime" === e[l].valueType ? 2 : 1)
                    ].position),
                  (d = e[l].getApparentDifference(e[l].viewportMinimum, d)),
                  (B = e[l].logarithmic
                    ? (1 < d
                        ? (Math.log(d) /
                            e[l].conversionParameters.lnLogarithmBase) *
                          Math.abs(e[l].conversionParameters.pixelPerUnit)
                        : 0) + e[l].lineCoordinates.x1
                    : (0 < d
                        ? d * Math.abs(e[l].conversionParameters.pixelPerUnit)
                        : 0) + e[l].lineCoordinates.x1));
          for (l = 0; l < q.length; l++)
            "axisY" === q[l].type &&
              (q[l].calculateValueToPixelConversionParameters(),
              q[l].calculateBreaksSizeInValues());
          if (0 < x) {
            if (a && 0 < a.length)
              for (l = 0; l < a.length; l++)
                r = P[x - 1][l] === P[x][l] ? !0 : !1;
            else r = !0;
            if (e && 0 < e.length)
              for (l = 0; l < e.length; l++)
                H = M[x - 1][l] === M[x][l] ? !0 : !1;
            else H = !0;
            if (b && 0 < b.length)
              for (l = 0; l < b.length; l++)
                L = Q[x - 1][l] === Q[x][l] ? !0 : !1;
            else L = !0;
            if (c && 0 < c.length)
              for (l = 0; l < c.length; l++)
                K = N[x - 1][l] === N[x][l] ? !0 : !1;
            else K = !0;
          }
          if (r && H && L && K) break;
          x++;
        }
        if (a && 0 < a.length)
          for (l = 0; l < a.length; l++)
            a[l].calculateStripLinesThicknessInValues(),
              a[l].calculateBreaksInPixels();
        if (e && 0 < e.length)
          for (l = 0; l < e.length; l++)
            e[l].calculateStripLinesThicknessInValues(),
              e[l].calculateBreaksInPixels();
        if (b && 0 < b.length)
          for (l = 0; l < b.length; l++)
            b[l].calculateStripLinesThicknessInValues(),
              b[l].calculateBreaksInPixels();
        if (c && 0 < c.length)
          for (l = 0; l < c.length; l++)
            c[l].calculateStripLinesThicknessInValues(),
              c[l].calculateBreaksInPixels();
      } else {
        p = [];
        C = [];
        F = [];
        t = [];
        B = [];
        w = [];
        P = [];
        for (M = []; 4 > x; ) {
          X = W = U = O = aa = S = Z = g = N = Q = G = Y = 0;
          if (a && 0 < a.length)
            for (F = [], l = W = 0; l < a.length; l++)
              F.push(
                Math.ceil(a[l] ? a[l].createLabelsAndCalculateWidth() : 0)
              ),
                (W += F[l]),
                (g += a[l] && !n.isNavigator ? a[l].margin : 0);
          else
            F.push(Math.ceil(a[0] ? a[0].createLabelsAndCalculateWidth() : 0));
          P.push(F);
          if (e && 0 < e.length)
            for (t = [], l = X = 0; l < e.length; l++)
              t.push(
                Math.ceil(e[l] ? e[l].createLabelsAndCalculateWidth() : 0)
              ),
                (X += t[l]),
                (Z += e[l] ? e[l].margin : 0);
          else
            t.push(Math.ceil(e[0] ? e[0].createLabelsAndCalculateWidth() : 0));
          M.push(t);
          if (b && 0 < b.length)
            for (l = 0; l < b.length; l++)
              (b[l].lineCoordinates = {}),
                (d = Math.round(h.x1 + W + g)),
                (u = Math.round(
                  h.x2 - X - Z > n.width - 10 ? n.width - 10 : h.x2 - X - Z
                )),
                b[l].labelAutoFit &&
                  !f(v) &&
                  (0 < !a.length &&
                    (d =
                      0 > b[l].labelAngle
                        ? Math.max(d, v)
                        : 0 === b[l].labelAngle
                        ? Math.max(d, v / 2)
                        : d),
                  0 < !e.length &&
                    (u =
                      0 < b[l].labelAngle
                        ? u - s / 2
                        : 0 === b[l].labelAngle
                        ? u - s / 2
                        : u)),
                (b[l].lineCoordinates.x1 = d),
                (b[l].lineCoordinates.x2 = u),
                (b[l].lineCoordinates.width = Math.abs(u - d)),
                b[l].title &&
                  (b[l]._titleTextBlock.maxWidth =
                    0 < b[l].titleMaxWidth &&
                    b[l].titleMaxWidth < b[l].lineCoordinates.width
                      ? b[l].titleMaxWidth
                      : b[l].lineCoordinates.width);
          if (c && 0 < c.length)
            for (l = 0; l < c.length; l++)
              (c[l].lineCoordinates = {}),
                (d = Math.round(h.x1 + W + g)),
                (u = Math.round(
                  h.x2 - X - Z > c[l].chart.width - 10
                    ? c[l].chart.width - 10
                    : h.x2 - X - Z
                )),
                c[l] &&
                  c[l].labelAutoFit &&
                  !f(y) &&
                  (0 < !a.length &&
                    (d =
                      0 < c[l].labelAngle
                        ? Math.max(d, y)
                        : 0 === c[l].labelAngle
                        ? Math.max(d, y / 2)
                        : d),
                  0 < !e.length && (u -= z / 2)),
                (c[l].lineCoordinates.x1 = d),
                (c[l].lineCoordinates.x2 = u),
                (c[l].lineCoordinates.width = Math.abs(u - d)),
                c[l].title &&
                  (c[l]._titleTextBlock.maxWidth =
                    0 < c[l].titleMaxWidth &&
                    c[l].titleMaxWidth < c[l].lineCoordinates.width
                      ? c[l].titleMaxWidth
                      : c[l].lineCoordinates.width);
          if (b && 0 < b.length)
            for (p = [], l = O = 0; l < b.length; l++)
              p.push(
                Math.ceil(b[l] ? b[l].createLabelsAndCalculateHeight() : 0)
              ),
                (O += p[l] + b[l].margin),
                (S += b[l].margin);
          else
            p.push(Math.ceil(b[0] ? b[0].createLabelsAndCalculateHeight() : 0));
          B.push(p);
          if (c && 0 < c.length)
            for (C = [], l = U = 0; l < c.length; l++)
              C.push(
                Math.ceil(c[l] ? c[l].createLabelsAndCalculateHeight() : 0)
              ),
                (U += C[l]),
                (aa += c[l].margin);
          else
            C.push(Math.ceil(c[0] ? c[0].createLabelsAndCalculateHeight() : 0));
          w.push(C);
          if (b && 0 < b.length)
            for (l = 0; l < b.length; l++)
              0 < b[l]._labels.length &&
                ((m = b[l]._labels[0]),
                (k = b[l]._labels[b[l]._labels.length - 1]),
                (v =
                  m.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(m.textBlock.angle)) +
                  (m.textBlock.height - k.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(m.textBlock.angle))),
                (s =
                  k.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                  (k.textBlock.height - k.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))));
          if (c && 0 < c.length)
            for (l = 0; l < c.length; l++)
              c[l] &&
                0 < c[l]._labels.length &&
                ((m = c[l]._labels[0]),
                (k = c[l]._labels[c[l]._labels.length - 1]),
                (y =
                  m.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(m.textBlock.angle)) +
                  (m.textBlock.height - k.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(m.textBlock.angle))),
                (z =
                  k.textBlock.width *
                    Math.cos((Math.PI / 180) * Math.abs(k.textBlock.angle)) +
                  (k.textBlock.height - k.textBlock.fontSize / 2) *
                    Math.sin((Math.PI / 180) * Math.abs(k.textBlock.angle))));
          if (n.panEnabled)
            for (l = 0; l < b.length; l++)
              p[l] = f(n.sessionVariables.axisY.height)
                ? (n.sessionVariables.axisY.height = p[l])
                : n.sessionVariables.axisY.height;
          else
            for (l = 0; l < b.length; l++)
              n.sessionVariables.axisY.height = p[l];
          if (b && 0 < b.length)
            for (l = b.length - 1; 0 <= l; l--)
              (k = Math.round(h.y2)),
                (m = Math.round(
                  h.y2 > b[l].chart.height ? b[l].chart.height : h.y2
                )),
                (b[l].lineCoordinates.y1 = k - (p[l] + b[l].margin + Y)),
                (b[l].lineCoordinates.y2 = k - (p[l] + b[l].margin + Y)),
                "inside" === b[l].labelPlacement &&
                  0 < l &&
                  ((b[l].lineCoordinates.y1 =
                    b[l].lineCoordinates.y1 +
                    p[l] -
                    (b[l]._titleTextBlock ? b[l]._titleTextBlock.height : 0) -
                    ("inside" === b[l].tickPlacement ? b[l].tickLength : 0)),
                  (b[l].lineCoordinates.y2 =
                    b[l].lineCoordinates.y1 + b[l].lineThickness / 2)),
                (b[l].bounds = {
                  x1: d,
                  y1: k - (p[l] + Y + b[l].margin),
                  x2: u,
                  y2: m - (Y + b[l].margin),
                  width: u - d,
                  height: p[l],
                }),
                b[l].title &&
                  (b[l]._titleTextBlock.maxWidth =
                    0 < b[l].titleMaxWidth &&
                    b[l].titleMaxWidth < b[l].lineCoordinates.width
                      ? b[l].titleMaxWidth
                      : b[l].lineCoordinates.width),
                (Y += p[l] + b[l].margin);
          if (c && 0 < c.length)
            for (l = c.length - 1; 0 <= l; l--)
              c[l] &&
                ((k = Math.round(h.y1)),
                (m = Math.round(h.y1 + (C[l] + c[l].margin + G))),
                (c[l].lineCoordinates.y1 = m),
                (c[l].lineCoordinates.y2 = m),
                "inside" === c[l].labelPlacement &&
                  0 < l &&
                  (c[l].lineCoordinates.y1 =
                    m -
                    C[l] +
                    (c[l]._titleTextBlock ? c[l]._titleTextBlock.height : 0)),
                (c[l].bounds = {
                  x1: d,
                  y1: k + (c[l].margin + G),
                  x2: u,
                  y2: m,
                  width: u - d,
                  height: U,
                }),
                c[l].title &&
                  (c[l]._titleTextBlock.maxWidth =
                    0 < c[l].titleMaxWidth &&
                    c[l].titleMaxWidth < c[l].lineCoordinates.width
                      ? c[l].titleMaxWidth
                      : c[l].lineCoordinates.width),
                (G += C[l] + c[l].margin));
          if (a && 0 < a.length)
            for (l = 0; l < a.length; l++) {
              S =
                a[l]._labels && 0 < a[l]._labels.length
                  ? a[l]._labels[0].textBlock.fontSize / 2
                  : 0;
              d = Math.round(h.x1 + g);
              k =
                c && 0 < c.length
                  ? Math.round(
                      c[0]
                        ? c[0].lineCoordinates.y2
                        : h.y1 < Math.max(S, 10)
                        ? Math.max(S, 10)
                        : h.y1
                    )
                  : h.y1 < Math.max(S, 10)
                  ? Math.max(S, 10)
                  : h.y1;
              u = Math.round(h.x1 + W + g);
              m =
                b && 0 < b.length
                  ? Math.round(
                      b[0]
                        ? b[0].lineCoordinates.y1
                        : h.y2 - O > n.height - Math.max(S, 10)
                        ? n.height - Math.max(S, 10)
                        : h.y2 - O
                    )
                  : h.y2 > n.height - Math.max(S, 10)
                  ? n.height - Math.max(S, 10)
                  : h.y2;
              if (b && 0 < b.length)
                for (S = 0; S < b.length; S++)
                  b[S] &&
                    b[S].labelAutoFit &&
                    ((u =
                      0 > b[S].labelAngle
                        ? Math.max(u, v)
                        : 0 === b[S].labelAngle
                        ? Math.max(u, v / 2)
                        : u),
                    (d =
                      0 > b[S].labelAngle || 0 === b[S].labelAngle
                        ? u - W
                        : d));
              if (c && 0 < c.length)
                for (S = 0; S < c.length; S++)
                  c[S] &&
                    c[S].labelAutoFit &&
                    ((u = c[S].lineCoordinates.x1), (d = u - W));
              a[l].lineCoordinates = {
                x1: u - Q,
                y1: k,
                x2: u - Q,
                y2: m,
                height: Math.abs(m - k),
              };
              "inside" === a[l].labelPlacement &&
                0 < l &&
                ((a[l].lineCoordinates.x1 =
                  a[l].lineCoordinates.x1 -
                  (F[l] -
                    (a[l]._titleTextBlock ? a[l]._titleTextBlock.height : 0)) +
                  ("outside" === a[l].tickPlacement ? a[l].tickLength : 0)),
                (a[l].lineCoordinates.x2 =
                  a[l].lineCoordinates.x1 + a[l].lineThickness / 2));
              a[l].bounds = {
                x1: u - (F[l] + Q),
                y1: k,
                x2: u,
                y2: m,
                width: u - d,
                height: m - k,
              };
              a[l].title &&
                (a[l]._titleTextBlock.maxWidth =
                  0 < a[l].titleMaxWidth &&
                  a[l].titleMaxWidth < a[l].lineCoordinates.height
                    ? a[l].titleMaxWidth
                    : a[l].lineCoordinates.height);
              a[l].calculateValueToPixelConversionParameters();
              a[l].calculateBreaksSizeInValues();
              Q += F[l] + a[l].margin;
            }
          if (e && 0 < e.length)
            for (l = 0; l < e.length; l++) {
              S =
                e[l]._labels && 0 < e[l]._labels.length
                  ? e[l]._labels[0].textBlock.fontSize / 2
                  : 0;
              d = Math.round(h.x1 - g);
              k =
                c && 0 < c.length
                  ? Math.round(
                      c[0]
                        ? c[0].lineCoordinates.y2
                        : h.y1 < Math.max(S, 10)
                        ? Math.max(S, 10)
                        : h.y1
                    )
                  : h.y1 < Math.max(S, 10)
                  ? Math.max(S, 10)
                  : h.y1;
              u = Math.round(h.x2 - X - Z);
              m =
                b && 0 < b.length
                  ? Math.round(
                      b[0]
                        ? b[0].lineCoordinates.y1
                        : h.y2 - O > n.height - Math.max(S, 10)
                        ? n.height - Math.max(S, 10)
                        : h.y2 - O
                    )
                  : h.y2 > n.height - Math.max(S, 10)
                  ? n.height - Math.max(S, 10)
                  : h.y2;
              if (b && 0 < b.length)
                for (S = 0; S < b.length; S++)
                  b[S] &&
                    b[S].labelAutoFit &&
                    ((u =
                      0 > b[S].labelAngle
                        ? Math.max(u, v)
                        : 0 === b[S].labelAngle
                        ? Math.max(u, v / 2)
                        : u),
                    (d =
                      0 > b[S].labelAngle || 0 === b[S].labelAngle
                        ? u - X
                        : d));
              if (c && 0 < c.length)
                for (S = 0; S < c.length; S++)
                  c[S] &&
                    c[S].labelAutoFit &&
                    ((u = c[S].lineCoordinates.x2), (d = u - X));
              e[l].lineCoordinates = {
                x1: u + N,
                y1: k,
                x2: u + N,
                y2: m,
                height: Math.abs(m - k),
              };
              "inside" === e[l].labelPlacement &&
                0 < l &&
                ((e[l].lineCoordinates.x1 =
                  e[l].lineCoordinates.x1 +
                  (t[l] -
                    (e[l]._titleTextBlock ? e[l]._titleTextBlock.height : 0) -
                    2) -
                  ("outside" === e[l].tickPlacement ? e[l].tickLength : 0)),
                (e[l].lineCoordinates.x2 =
                  e[l].lineCoordinates.x1 + e[l].lineThickness / 2));
              e[l].bounds = {
                x1: e[l].lineCoordinates.x1,
                y1: k,
                x2: u + t[l] + N,
                y2: m,
                width: u - d,
                height: m - k,
              };
              e[l].title &&
                (e[l]._titleTextBlock.maxWidth =
                  0 < e[l].titleMaxWidth &&
                  e[l].titleMaxWidth < e[l].lineCoordinates.height
                    ? e[l].titleMaxWidth
                    : e[l].lineCoordinates.height);
              e[l].calculateValueToPixelConversionParameters();
              e[l].calculateBreaksSizeInValues();
              N += t[l] + e[l].margin;
            }
          for (l = 0; l < q.length; l++)
            "axisY" === q[l].type &&
              (q[l].calculateValueToPixelConversionParameters(),
              q[l].calculateBreaksSizeInValues());
          if (0 < x) {
            if (a && 0 < a.length)
              for (l = 0; l < a.length; l++)
                r = P[x - 1][l] === P[x][l] ? !0 : !1;
            else r = !0;
            if (e && 0 < e.length)
              for (l = 0; l < e.length; l++)
                H = M[x - 1][l] === M[x][l] ? !0 : !1;
            else H = !0;
            if (b && 0 < b.length)
              for (l = 0; l < b.length; l++)
                L = B[x - 1][l] === B[x][l] ? !0 : !1;
            else L = !0;
            if (c && 0 < c.length)
              for (l = 0; l < c.length; l++)
                K = w[x - 1][l] === w[x][l] ? !0 : !1;
            else K = !0;
          }
          if (r && H && L && K) break;
          x++;
        }
        if (b && 0 < b.length)
          for (l = 0; l < b.length; l++)
            b[l].calculateStripLinesThicknessInValues(),
              b[l].calculateBreaksInPixels();
        if (c && 0 < c.length)
          for (l = 0; l < c.length; l++)
            c[l].calculateStripLinesThicknessInValues(),
              c[l].calculateBreaksInPixels();
        if (a && 0 < a.length)
          for (l = 0; l < a.length; l++)
            a[l].calculateStripLinesThicknessInValues(),
              a[l].calculateBreaksInPixels();
        if (e && 0 < e.length)
          for (l = 0; l < e.length; l++)
            e[l].calculateStripLinesThicknessInValues(),
              e[l].calculateBreaksInPixels();
      }
    };
    z.render = function (a, e, b, c, g) {
      var h = a[0] ? a[0].chart : e[0].chart;
      g = h.ctx;
      h.alignVerticalAxes && h.alignVerticalAxes();
      g.save();
      g.beginPath();
      a[0] &&
        g.rect(5, a[0].bounds.y1, a[0].chart.width - 10, a[0].bounds.height);
      e[0] &&
        g.rect(
          5,
          e[e.length - 1].bounds.y1,
          e[0].chart.width - 10,
          e[0].bounds.height
        );
      g.clip();
      if (a && 0 < a.length)
        for (var d = 0; d < a.length; d++) a[d].renderLabelsTicksAndTitle();
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++) e[d].renderLabelsTicksAndTitle();
      g.restore();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].renderLabelsTicksAndTitle();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].renderLabelsTicksAndTitle();
      h.preparePlotArea();
      h = h.plotArea;
      g.save();
      g.beginPath();
      g.rect(h.x1, h.y1, Math.abs(h.x2 - h.x1), Math.abs(h.y2 - h.y1));
      g.clip();
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++)
          a[d].renderStripLinesOfThicknessType("value");
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++)
          e[d].renderStripLinesOfThicknessType("value");
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderStripLinesOfThicknessType("value");
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderStripLinesOfThicknessType("value");
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++) a[d].renderInterlacedColors();
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++) e[d].renderInterlacedColors();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].renderInterlacedColors();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].renderInterlacedColors();
      g.restore();
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++)
          a[d].renderGrid(),
            v && (a[d].createMask(), a[d].renderBreaksBackground());
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++)
          e[d].renderGrid(),
            v && (e[d].createMask(), e[d].renderBreaksBackground());
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderGrid(),
            v && (b[d].createMask(), b[d].renderBreaksBackground());
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderGrid(),
            v && (c[d].createMask(), c[d].renderBreaksBackground());
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++) a[d].renderAxisLine();
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++) e[d].renderAxisLine();
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++) b[d].renderAxisLine();
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++) c[d].renderAxisLine();
      if (a && 0 < a.length)
        for (d = 0; d < a.length; d++)
          a[d].renderStripLinesOfThicknessType("pixel");
      if (e && 0 < e.length)
        for (d = 0; d < e.length; d++)
          e[d].renderStripLinesOfThicknessType("pixel");
      if (b && 0 < b.length)
        for (d = 0; d < b.length; d++)
          b[d].renderStripLinesOfThicknessType("pixel");
      if (c && 0 < c.length)
        for (d = 0; d < c.length; d++)
          c[d].renderStripLinesOfThicknessType("pixel");
    };
    z.prototype.calculateStripLinesThicknessInValues = function () {
      for (var a = 0; a < this.stripLines.length; a++)
        if (
          null !== this.stripLines[a].startValue &&
          null !== this.stripLines[a].endValue
        ) {
          var e = Math.min(
              this.stripLines[a].startValue,
              this.stripLines[a].endValue
            ),
            b = Math.max(
              this.stripLines[a].startValue,
              this.stripLines[a].endValue
            ),
            e = this.getApparentDifference(e, b);
          this.stripLines[a].value = this.logarithmic
            ? this.stripLines[a].value *
              Math.sqrt(
                Math.log(
                  Math.max(
                    this.stripLines[a].startValue,
                    this.stripLines[a].endValue
                  ) /
                    Math.min(
                      this.stripLines[a].startValue,
                      this.stripLines[a].endValue
                    )
                ) / Math.log(e)
              )
            : this.stripLines[a].value +
              (Math.abs(
                this.stripLines[a].endValue - this.stripLines[a].startValue
              ) -
                e) /
                2;
          this.stripLines[a].thickness = e;
          this.stripLines[a]._thicknessType = "value";
        }
    };
    z.prototype.calculateBreaksSizeInValues = function () {
      for (
        var a =
            "left" === this._position || "right" === this._position
              ? this.lineCoordinates.height || this.chart.height
              : this.lineCoordinates.width || this.chart.width,
          e = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
          b =
            this.conversionParameters.pixelPerUnit ||
            a /
              (this.logarithmic
                ? this.conversionParameters.maximum /
                  this.conversionParameters.minimum
                : this.conversionParameters.maximum -
                  this.conversionParameters.minimum),
          c = this.scaleBreaks && !f(this.scaleBreaks.options.spacing),
          g,
          d = 0;
        d < e.length;
        d++
      )
        (g = c || !f(e[d].options.spacing)),
          (e[d].spacing =
            Wa(e[d].spacing, a, 8, g ? 0.1 * a : 8, g ? 0 : 3) << 0),
          (e[d].size = 0 > e[d].spacing ? 0 : Math.abs(e[d].spacing / b)),
          this.logarithmic &&
            (e[d].size = Math.pow(this.logarithmBase, e[d].size));
    };
    z.prototype.calculateBreaksInPixels = function () {
      if (!(this.scaleBreaks && 0 >= this.scaleBreaks._appliedBreaks.length)) {
        var a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
        a.length &&
          (this.scaleBreaks.firstBreakIndex = this.scaleBreaks.lastBreakIndex =
            null);
        for (
          var e = 0;
          e < a.length &&
          !(a[e].startValue > this.conversionParameters.maximum);
          e++
        )
          a[e].endValue < this.conversionParameters.minimum ||
            (f(this.scaleBreaks.firstBreakIndex) &&
              (this.scaleBreaks.firstBreakIndex = e),
            a[e].startValue >= this.conversionParameters.minimum &&
              ((a[e].startPixel = this.convertValueToPixel(a[e].startValue)),
              (this.scaleBreaks.lastBreakIndex = e)),
            a[e].endValue <= this.conversionParameters.maximum &&
              (a[e].endPixel = this.convertValueToPixel(a[e].endValue)));
      }
    };
    z.prototype.renderLabelsTicksAndTitle = function () {
      var a = this,
        e = !1,
        b = 0,
        c = 0,
        g = 1,
        d = 0;
      0 !== this.labelAngle && 360 !== this.labelAngle && (g = 1.2);
      if ("undefined" === typeof this.options.interval) {
        if ("bottom" === this._position || "top" === this._position)
          if (
            this.logarithmic &&
            !this.equidistantInterval &&
            this.labelAutoFit
          ) {
            for (
              var b = [],
                g = 0 !== this.labelAngle && 360 !== this.labelAngle ? 1 : 1.2,
                f,
                k = this.viewportMaximum,
                u = this.lineCoordinates.width / Math.log(this.range),
                m = this._labels.length - 1;
              0 <= m;
              m--
            ) {
              p = this._labels[m];
              if (p.position < this.viewportMinimum) break;
              p.position > this.viewportMaximum ||
                !(
                  m === this._labels.length - 1 ||
                  f < (Math.log(k / p.position) * u) / g
                ) ||
                (b.push(p),
                (k = p.position),
                (f =
                  p.textBlock.width *
                    Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                  p.textBlock.height *
                    Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))));
            }
            this._labels = b;
          } else {
            for (m = 0; m < this._labels.length; m++)
              (p = this._labels[m]),
                p.position < this.viewportMinimum ||
                  ((f =
                    p.textBlock.width *
                      Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                    p.textBlock.height *
                      Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))),
                  (b += f));
            b > this.lineCoordinates.width * g && this.labelAutoFit && (e = !0);
          }
        if ("left" === this._position || "right" === this._position)
          if (
            this.logarithmic &&
            !this.equidistantInterval &&
            this.labelAutoFit
          ) {
            for (
              var b = [],
                n,
                k = this.viewportMaximum,
                u = this.lineCoordinates.height / Math.log(this.range),
                m = this._labels.length - 1;
              0 <= m;
              m--
            ) {
              p = this._labels[m];
              if (p.position < this.viewportMinimum) break;
              p.position > this.viewportMaximum ||
                !(
                  m === this._labels.length - 1 ||
                  n < Math.log(k / p.position) * u
                ) ||
                (b.push(p),
                (k = p.position),
                (n =
                  p.textBlock.height *
                    Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                  p.textBlock.width *
                    Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))));
            }
            this._labels = b;
          } else {
            for (m = 0; m < this._labels.length; m++)
              (p = this._labels[m]),
                p.position < this.viewportMinimum ||
                  ((n =
                    p.textBlock.height *
                      Math.abs(Math.cos((Math.PI / 180) * this.labelAngle)) +
                    p.textBlock.width *
                      Math.abs(Math.sin((Math.PI / 180) * this.labelAngle))),
                  (c += n));
            c > this.lineCoordinates.height * g &&
              this.labelAutoFit &&
              (e = !0);
          }
      }
      this.logarithmic &&
        !this.equidistantInterval &&
        this.labelAutoFit &&
        this._labels.sort(function (a, b) {
          return a.position - b.position;
        });
      var m = 0,
        p,
        q;
      if ("bottom" === this._position) {
        for (m = 0; m < this._labels.length; m++)
          (p = this._labels[m]),
            p.position < this.viewportMinimum ||
              p.position > this.viewportMaximum ||
              ((q = this.getPixelCoordinatesOnAxis(p.position)),
              this.tickThickness &&
                "inside" != this.tickPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (q.x << 0) + 0.5 : q.x << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(c, q.y << 0),
                this.ctx.lineTo(c, (q.y + this.tickLength) << 0),
                this.ctx.stroke()),
              (e && 0 !== d++ % 2 && this.labelAutoFit) ||
                (0 === p.textBlock.angle
                  ? ((q.x -= p.textBlock.width / 2),
                    (q.y =
                      "inside" === this.labelPlacement
                        ? q.y -
                          (("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) +
                            p.textBlock.height -
                            p.textBlock.fontSize / 2)
                        : q.y +
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                          p.textBlock.fontSize / 2 +
                          5))
                  : ((q.x =
                      "inside" === this.labelPlacement
                        ? 0 > this.labelAngle
                          ? q.x
                          : q.x -
                            p.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                        : q.x -
                          (0 > this.labelAngle
                            ? p.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                            : 0)),
                    (q.y =
                      "inside" === this.labelPlacement
                        ? 0 > this.labelAngle
                          ? q.y -
                            ("inside" === this.tickPlacement
                              ? this.tickLength
                              : 0) -
                            5
                          : q.y -
                            ("inside" === this.tickPlacement
                              ? this.tickLength
                              : 0) -
                            Math.abs(
                              p.textBlock.width *
                                Math.sin((Math.PI / 180) * this.labelAngle) +
                                5
                            )
                        : q.y +
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                          Math.abs(
                            0 > this.labelAngle
                              ? p.textBlock.width *
                                  Math.sin((Math.PI / 180) * this.labelAngle) -
                                  5
                              : 5
                          ))),
                (p.textBlock.x = q.x),
                (p.textBlock.y = q.y)));
        "inside" === this.tickPlacement &&
          this.chart.addEventListener(
            "dataAnimationEnd",
            function () {
              for (m = 0; m < a._labels.length; m++)
                if (
                  ((p = a._labels[m]),
                  !(
                    p.position < a.viewportMinimum ||
                    p.position > a.viewportMaximum
                  ) &&
                    ((q = a.getPixelCoordinatesOnAxis(p.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (q.x << 0) + 0.5 : q.x << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(b, q.y << 0);
                  a.ctx.lineTo(b, (q.y - a.tickLength) << 0);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x =
            this.lineCoordinates.x1 +
            this.lineCoordinates.width / 2 -
            this._titleTextBlock.width / 2),
          (this._titleTextBlock.y =
            this.bounds.y2 - this._titleTextBlock.height - 3),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("top" === this._position) {
        for (m = 0; m < this._labels.length; m++)
          (p = this._labels[m]),
            p.position < this.viewportMinimum ||
              p.position > this.viewportMaximum ||
              ((q = this.getPixelCoordinatesOnAxis(p.position)),
              this.tickThickness &&
                "inside" != this.tickPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (q.x << 0) + 0.5 : q.x << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(c, q.y << 0),
                this.ctx.lineTo(c, (q.y - this.tickLength) << 0),
                this.ctx.stroke()),
              (e && 0 !== d++ % 2 && this.labelAutoFit) ||
                (0 === p.textBlock.angle
                  ? ((q.x -= p.textBlock.width / 2),
                    (q.y =
                      "inside" === this.labelPlacement
                        ? q.y +
                          this.labelFontSize / 2 +
                          ("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) +
                          5
                        : q.y -
                          (("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                            p.textBlock.height -
                            p.textBlock.fontSize / 2)))
                  : ((q.x =
                      "inside" === this.labelPlacement
                        ? 0 < this.labelAngle
                          ? q.x
                          : q.x -
                            p.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                        : q.x +
                          (p.textBlock.height - this.labelFontSize) *
                            Math.sin((Math.PI / 180) * this.labelAngle) -
                          (0 < this.labelAngle
                            ? p.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                            : 0)),
                    (q.y =
                      "inside" === this.labelPlacement
                        ? 0 < this.labelAngle
                          ? q.y +
                            ("inside" === this.tickPlacement
                              ? this.tickLength
                              : 0) +
                            5
                          : q.y -
                            p.textBlock.width *
                              Math.sin((Math.PI / 180) * this.labelAngle) +
                            ("inside" === this.tickPlacement
                              ? this.tickLength
                              : 0) +
                            5
                        : q.y -
                          (("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                            ((p.textBlock.height - p.textBlock.fontSize / 2) *
                              Math.cos((Math.PI / 180) * this.labelAngle) +
                              (0 < this.labelAngle
                                ? p.textBlock.width *
                                  Math.sin((Math.PI / 180) * this.labelAngle)
                                : 0))))),
                (p.textBlock.x = q.x),
                (p.textBlock.y = q.y)));
        "inside" === this.tickPlacement &&
          this.chart.addEventListener(
            "dataAnimationEnd",
            function () {
              for (m = 0; m < a._labels.length; m++)
                if (
                  ((p = a._labels[m]),
                  !(
                    p.position < a.viewportMinimum ||
                    p.position > a.viewportMaximum
                  ) &&
                    ((q = a.getPixelCoordinatesOnAxis(p.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (q.x << 0) + 0.5 : q.x << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(b, q.y << 0);
                  a.ctx.lineTo(b, (q.y + a.tickLength) << 0);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x =
            this.lineCoordinates.x1 +
            this.lineCoordinates.width / 2 -
            this._titleTextBlock.width / 2),
          (this._titleTextBlock.y = this.bounds.y1 + 1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("left" === this._position) {
        for (m = 0; m < this._labels.length; m++)
          (p = this._labels[m]),
            p.position < this.viewportMinimum ||
              p.position > this.viewportMaximum ||
              ((q = this.getPixelCoordinatesOnAxis(p.position)),
              this.tickThickness &&
                "inside" != this.tickPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (q.y << 0) + 0.5 : q.y << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(q.x << 0, c),
                this.ctx.lineTo((q.x - this.tickLength) << 0, c),
                this.ctx.stroke()),
              (e && 0 !== d++ % 2 && this.labelAutoFit) ||
                (0 === this.labelAngle
                  ? ((p.textBlock.y = q.y),
                    (p.textBlock.x =
                      "inside" === this.labelPlacement
                        ? q.x +
                          ("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) +
                          5
                        : q.x -
                          p.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) -
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) -
                          5))
                  : ((p.textBlock.y =
                      "inside" === this.labelPlacement
                        ? q.y
                        : q.y -
                          p.textBlock.width *
                            Math.sin((Math.PI / 180) * this.labelAngle)),
                    (p.textBlock.x =
                      "inside" === this.labelPlacement
                        ? q.x +
                          ("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) +
                          5
                        : 0 < this.labelAngle
                        ? q.x -
                          p.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) -
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) -
                          5
                        : q.x -
                          p.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) +
                          (p.textBlock.height - p.textBlock.fontSize / 2 - 5) *
                            Math.sin((Math.PI / 180) * this.labelAngle) -
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength)))));
        "inside" === this.tickPlacement &&
          this.chart.addEventListener(
            "dataAnimationEnd",
            function () {
              for (m = 0; m < a._labels.length; m++)
                if (
                  ((p = a._labels[m]),
                  !(
                    p.position < a.viewportMinimum ||
                    p.position > a.viewportMaximum
                  ) &&
                    ((q = a.getPixelCoordinatesOnAxis(p.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (q.y << 0) + 0.5 : q.y << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(q.x << 0, b);
                  a.ctx.lineTo((q.x + a.tickLength) << 0, b);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x = this.bounds.x1 + 1),
          (this._titleTextBlock.y =
            this.lineCoordinates.height / 2 +
            this._titleTextBlock.width / 2 +
            this.lineCoordinates.y1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      } else if ("right" === this._position) {
        for (m = 0; m < this._labels.length; m++)
          (p = this._labels[m]),
            p.position < this.viewportMinimum ||
              p.position > this.viewportMaximum ||
              ((q = this.getPixelCoordinatesOnAxis(p.position)),
              this.tickThickness &&
                "inside" != this.tickPlacement &&
                ((this.ctx.lineWidth = this.tickThickness),
                (this.ctx.strokeStyle = this.tickColor),
                (c =
                  1 === this.ctx.lineWidth % 2 ? (q.y << 0) + 0.5 : q.y << 0),
                this.ctx.beginPath(),
                this.ctx.moveTo(q.x << 0, c),
                this.ctx.lineTo((q.x + this.tickLength) << 0, c),
                this.ctx.stroke()),
              (e && 0 !== d++ % 2 && this.labelAutoFit) ||
                (0 === this.labelAngle
                  ? ((p.textBlock.y = q.y),
                    (p.textBlock.x =
                      "inside" === this.labelPlacement
                        ? q.x -
                          p.textBlock.width -
                          ("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) -
                          5
                        : q.x +
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                          5))
                  : ((p.textBlock.y =
                      "inside" === this.labelPlacement
                        ? q.y -
                          p.textBlock.width *
                            Math.sin((Math.PI / 180) * this.labelAngle)
                        : 0 > this.labelAngle
                        ? q.y
                        : q.y -
                          (p.textBlock.height - p.textBlock.fontSize / 2 - 5) *
                            Math.cos((Math.PI / 180) * this.labelAngle)),
                    (p.textBlock.x =
                      "inside" === this.labelPlacement
                        ? q.x -
                          p.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) -
                          ("inside" === this.tickPlacement
                            ? this.tickLength
                            : 0) -
                          5
                        : 0 < this.labelAngle
                        ? q.x +
                          (p.textBlock.height - p.textBlock.fontSize / 2 - 5) *
                            Math.sin((Math.PI / 180) * this.labelAngle) +
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength)
                        : q.x +
                          ("inside" === this.tickPlacement
                            ? 0
                            : this.tickLength) +
                          5))));
        "inside" === this.tickPlacement &&
          this.chart.addEventListener(
            "dataAnimationEnd",
            function () {
              for (m = 0; m < a._labels.length; m++)
                if (
                  ((p = a._labels[m]),
                  !(
                    p.position < a.viewportMinimum ||
                    p.position > a.viewportMaximum
                  ) &&
                    ((q = a.getPixelCoordinatesOnAxis(p.position)),
                    a.tickThickness))
                ) {
                  a.ctx.lineWidth = a.tickThickness;
                  a.ctx.strokeStyle = a.tickColor;
                  var b =
                    1 === a.ctx.lineWidth % 2 ? (q.y << 0) + 0.5 : q.y << 0;
                  a.ctx.save();
                  a.ctx.beginPath();
                  a.ctx.moveTo(q.x << 0, b);
                  a.ctx.lineTo((q.x - a.tickLength) << 0, b);
                  a.ctx.stroke();
                  a.ctx.restore();
                }
            },
            this
          );
        this.title &&
          (this._titleTextBlock.measureText(),
          (this._titleTextBlock.x = this.bounds.x2 - 1),
          (this._titleTextBlock.y =
            this.lineCoordinates.height / 2 -
            this._titleTextBlock.width / 2 +
            this.lineCoordinates.y1),
          (this.titleMaxWidth = this._titleTextBlock.maxWidth),
          this._titleTextBlock.render(!0));
      }
      d = 0;
      if ("inside" === this.labelPlacement)
        this.chart.addEventListener(
          "dataAnimationEnd",
          function () {
            for (m = 0; m < a._labels.length; m++)
              (p = a._labels[m]),
                p.position < a.viewportMinimum ||
                  p.position > a.viewportMaximum ||
                  (e && 0 !== d++ % 2 && a.labelAutoFit) ||
                  (a.ctx.save(),
                  a.ctx.beginPath(),
                  p.textBlock.render(!0),
                  a.ctx.restore());
          },
          this
        );
      else
        for (m = 0; m < this._labels.length; m++)
          (p = this._labels[m]),
            p.position < this.viewportMinimum ||
              p.position > this.viewportMaximum ||
              (e && 0 !== d++ % 2 && this.labelAutoFit) ||
              p.textBlock.render(!0);
    };
    z.prototype.renderInterlacedColors = function () {
      var a = this.chart.plotArea.ctx,
        e,
        b,
        c = this.chart.plotArea,
        g = 0;
      e = !0;
      if (
        ("bottom" === this._position || "top" === this._position) &&
        this.interlacedColor
      )
        for (
          a.fillStyle = this.interlacedColor, g = 0;
          g < this._labels.length;
          g++
        )
          e
            ? ((e = this.getPixelCoordinatesOnAxis(this._labels[g].position)),
              (b =
                g + 1 > this._labels.length - 1
                  ? this.getPixelCoordinatesOnAxis(this.viewportMaximum)
                  : this.getPixelCoordinatesOnAxis(
                      this._labels[g + 1].position
                    )),
              a.fillRect(
                Math.min(b.x, e.x),
                c.y1,
                Math.abs(b.x - e.x),
                Math.abs(c.y1 - c.y2)
              ),
              (e = !1))
            : (e = !0);
      else if (
        ("left" === this._position || "right" === this._position) &&
        this.interlacedColor
      )
        for (
          a.fillStyle = this.interlacedColor, g = 0;
          g < this._labels.length;
          g++
        )
          e
            ? ((b = this.getPixelCoordinatesOnAxis(this._labels[g].position)),
              (e =
                g + 1 > this._labels.length - 1
                  ? this.getPixelCoordinatesOnAxis(this.viewportMaximum)
                  : this.getPixelCoordinatesOnAxis(
                      this._labels[g + 1].position
                    )),
              a.fillRect(
                c.x1,
                Math.min(b.y, e.y),
                Math.abs(c.x1 - c.x2),
                Math.abs(e.y - b.y)
              ),
              (e = !1))
            : (e = !0);
      a.beginPath();
    };
    z.prototype.renderStripLinesOfThicknessType = function (a) {
      if (this.stripLines && 0 < this.stripLines.length && a) {
        for (
          var e = this,
            b,
            c = 0,
            g = 0,
            d = !1,
            k = !1,
            u = [],
            x = [],
            k = !1,
            c = 0;
          c < this.stripLines.length;
          c++
        ) {
          var m = this.stripLines[c];
          m._thicknessType === a &&
            (("pixel" === a &&
              (m.value < this.viewportMinimum ||
                m.value > this.viewportMaximum ||
                f(m.value) ||
                isNaN(this.range))) ||
              ("value" === a &&
                ((m.startValue <= this.viewportMinimum &&
                  m.endValue <= this.viewportMinimum) ||
                  (m.startValue >= this.viewportMaximum &&
                    m.endValue >= this.viewportMaximum) ||
                  f(m.startValue) ||
                  f(m.endValue) ||
                  isNaN(this.range))) ||
              u.push(m));
        }
        for (c = 0; c < this._stripLineLabels.length; c++)
          if (
            ((m = this.stripLines[c]),
            (b = this._stripLineLabels[c]),
            !(
              b.position < this.viewportMinimum ||
              b.position > this.viewportMaximum ||
              isNaN(this.range)
            ))
          ) {
            a = this.getPixelCoordinatesOnAxis(b.position);
            if ("outside" === b.stripLine.labelPlacement)
              if (
                (m &&
                  ((this.ctx.strokeStyle = m.color),
                  "pixel" === m._thicknessType &&
                    (this.ctx.lineWidth = m.thickness)),
                "bottom" === this._position)
              ) {
                var n =
                  1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0;
                this.ctx.beginPath();
                this.ctx.moveTo(n, a.y << 0);
                this.ctx.lineTo(n, (a.y + this.tickLength) << 0);
                this.ctx.stroke();
                0 === this.labelAngle
                  ? ((a.x -= b.textBlock.width / 2),
                    (a.y += this.tickLength + b.textBlock.fontSize / 2))
                  : ((a.x -=
                      0 > this.labelAngle
                        ? b.textBlock.width *
                          Math.cos((Math.PI / 180) * this.labelAngle)
                        : 0),
                    (a.y +=
                      this.tickLength +
                      Math.abs(
                        0 > this.labelAngle
                          ? b.textBlock.width *
                              Math.sin((Math.PI / 180) * this.labelAngle) -
                              5
                          : 5
                      )));
              } else
                "top" === this._position
                  ? ((n =
                      1 === this.ctx.lineWidth % 2
                        ? (a.x << 0) + 0.5
                        : a.x << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(n, a.y << 0),
                    this.ctx.lineTo(n, (a.y - this.tickLength) << 0),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? ((a.x -= b.textBlock.width / 2),
                        (a.y -= this.tickLength + b.textBlock.height))
                      : ((a.x +=
                          (b.textBlock.height -
                            this.tickLength -
                            this.labelFontSize / 2) *
                            Math.sin((Math.PI / 180) * this.labelAngle) -
                          (0 < this.labelAngle
                            ? b.textBlock.width *
                              Math.cos((Math.PI / 180) * this.labelAngle)
                            : 0)),
                        (a.y -=
                          this.tickLength +
                          (b.textBlock.height *
                            Math.cos((Math.PI / 180) * this.labelAngle) +
                            (0 < this.labelAngle
                              ? b.textBlock.width *
                                Math.sin((Math.PI / 180) * this.labelAngle)
                              : 0)))))
                  : "left" === this._position
                  ? ((n =
                      1 === this.ctx.lineWidth % 2
                        ? (a.y << 0) + 0.5
                        : a.y << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(a.x << 0, n),
                    this.ctx.lineTo((a.x - this.tickLength) << 0, n),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? (a.x =
                          a.x -
                          b.textBlock.width *
                            Math.cos((Math.PI / 180) * this.labelAngle) -
                          this.tickLength -
                          5)
                      : ((a.y -=
                          b.textBlock.width *
                          Math.sin((Math.PI / 180) * this.labelAngle)),
                        (a.x =
                          0 < this.labelAngle
                            ? a.x -
                              b.textBlock.width *
                                Math.cos((Math.PI / 180) * this.labelAngle) -
                              this.tickLength -
                              5
                            : a.x -
                              b.textBlock.width *
                                Math.cos((Math.PI / 180) * this.labelAngle) +
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.sin((Math.PI / 180) * this.labelAngle) -
                              this.tickLength)))
                  : "right" === this._position &&
                    ((n =
                      1 === this.ctx.lineWidth % 2
                        ? (a.y << 0) + 0.5
                        : a.y << 0),
                    this.ctx.beginPath(),
                    this.ctx.moveTo(a.x << 0, n),
                    this.ctx.lineTo((a.x + this.tickLength) << 0, n),
                    this.ctx.stroke(),
                    0 === this.labelAngle
                      ? (a.x = a.x + this.tickLength + 5)
                      : ((a.y =
                          0 > this.labelAngle
                            ? a.y
                            : a.y -
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.cos((Math.PI / 180) * this.labelAngle)),
                        (a.x =
                          0 < this.labelAngle
                            ? a.x +
                              (b.textBlock.height -
                                b.textBlock.fontSize / 2 -
                                5) *
                                Math.sin((Math.PI / 180) * this.labelAngle) +
                              this.tickLength
                            : a.x + this.tickLength + 5)));
            else
              (b.textBlock.angle = -90),
                "bottom" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.height - 3),
                    b.textBlock.measureText(),
                    a.x - b.textBlock.height > this.chart.plotArea.x1
                      ? f(m.startValue)
                        ? (a.x -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.x -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 +
                            3)
                      : ((b.textBlock.angle = 90),
                        f(m.startValue)
                          ? (a.x +=
                              b.textBlock.height - b.textBlock.fontSize / 2)
                          : (a.x +=
                              b.textBlock.height / 2 -
                              b.textBlock.fontSize / 2 +
                              3)),
                    (a.y =
                      -90 === b.textBlock.angle
                        ? "near" === b.stripLine.labelAlign
                          ? this.chart.plotArea.y2 - 3
                          : "center" === b.stripLine.labelAlign
                          ? (this.chart.plotArea.y2 +
                              this.chart.plotArea.y1 +
                              b.textBlock.width) /
                            2
                          : this.chart.plotArea.y1 + b.textBlock.width + 3
                        : "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.y2 - b.textBlock.width - 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.y2 +
                            this.chart.plotArea.y1 -
                            b.textBlock.width) /
                          2
                        : this.chart.plotArea.y1 + 3))
                  : "top" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.height - 3),
                    b.textBlock.measureText(),
                    a.x - b.textBlock.height > this.chart.plotArea.x1
                      ? f(m.startValue)
                        ? (a.x -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.x -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 +
                            3)
                      : ((b.textBlock.angle = 90),
                        f(m.startValue)
                          ? (a.x +=
                              b.textBlock.height - b.textBlock.fontSize / 2)
                          : (a.x +=
                              b.textBlock.height / 2 -
                              b.textBlock.fontSize / 2 +
                              3)),
                    (a.y =
                      -90 === b.textBlock.angle
                        ? "near" === b.stripLine.labelAlign
                          ? this.chart.plotArea.y1 + b.textBlock.width + 3
                          : "center" === b.stripLine.labelAlign
                          ? (this.chart.plotArea.y2 +
                              this.chart.plotArea.y1 +
                              b.textBlock.width) /
                            2
                          : this.chart.plotArea.y2 - 3
                        : "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.y1 + 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.y2 +
                            this.chart.plotArea.y1 -
                            b.textBlock.width) /
                          2
                        : this.chart.plotArea.y2 - b.textBlock.width - 3))
                  : "left" === this._position
                  ? ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.width - 3),
                    (b.textBlock.angle = 0),
                    b.textBlock.measureText(),
                    a.y - b.textBlock.height > this.chart.plotArea.y1
                      ? f(m.startValue)
                        ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.y -=
                            b.textBlock.height / 2 - b.textBlock.fontSize + 3)
                      : a.y - b.textBlock.height < this.chart.plotArea.y2
                      ? (a.y += b.textBlock.fontSize / 2 + 3)
                      : f(m.startValue)
                      ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                      : (a.y -=
                          b.textBlock.height / 2 - b.textBlock.fontSize + 3),
                    (a.x =
                      "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.x1 + 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) /
                            2 -
                          b.textBlock.width / 2
                        : this.chart.plotArea.x2 - b.textBlock.width - 3))
                  : "right" === this._position &&
                    ((b.textBlock.maxWidth = this.options.stripLines[c]
                      .labelMaxWidth
                      ? this.options.stripLines[c].labelMaxWidth
                      : this.chart.plotArea.width - 3),
                    (b.textBlock.angle = 0),
                    b.textBlock.measureText(),
                    a.y - +b.textBlock.height > this.chart.plotArea.y1
                      ? f(m.startValue)
                        ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                        : (a.y -=
                            b.textBlock.height / 2 -
                            b.textBlock.fontSize / 2 -
                            3)
                      : a.y - b.textBlock.height < this.chart.plotArea.y2
                      ? (a.y += b.textBlock.fontSize / 2 + 3)
                      : f(m.startValue)
                      ? (a.y -= b.textBlock.height - b.textBlock.fontSize / 2)
                      : (a.y -=
                          b.textBlock.height / 2 -
                          b.textBlock.fontSize / 2 +
                          3),
                    (a.x =
                      "near" === b.stripLine.labelAlign
                        ? this.chart.plotArea.x2 - b.textBlock.width - 3
                        : "center" === b.stripLine.labelAlign
                        ? (this.chart.plotArea.x2 + this.chart.plotArea.x1) /
                            2 -
                          b.textBlock.width / 2
                        : this.chart.plotArea.x1 + 3));
            b.textBlock.x = a.x;
            b.textBlock.y = a.y;
            x.push(b);
          }
        if (!k) {
          k = !1;
          this.ctx.save();
          this.ctx.beginPath();
          this.ctx.rect(
            this.chart.plotArea.x1,
            this.chart.plotArea.y1,
            this.chart.plotArea.width,
            this.chart.plotArea.height
          );
          this.ctx.clip();
          for (c = 0; c < u.length; c++)
            (m = u[c]),
              m.showOnTop
                ? d ||
                  ((d = !0),
                  this.chart.addEventListener(
                    "dataAnimationIterationEnd",
                    function () {
                      this.ctx.save();
                      this.ctx.beginPath();
                      this.ctx.rect(
                        this.chart.plotArea.x1,
                        this.chart.plotArea.y1,
                        this.chart.plotArea.width,
                        this.chart.plotArea.height
                      );
                      this.ctx.clip();
                      for (g = 0; g < u.length; g++)
                        (m = u[g]), m.showOnTop && m.render();
                      this.ctx.restore();
                    },
                    m
                  ))
                : m.render();
          for (c = 0; c < x.length; c++)
            (b = x[c]),
              b.stripLine.showOnTop
                ? k ||
                  ((k = !0),
                  this.chart.addEventListener(
                    "dataAnimationIterationEnd",
                    function () {
                      for (g = 0; g < x.length; g++)
                        (b = x[g]),
                          "inside" === b.stripLine.labelPlacement &&
                            b.stripLine.showOnTop &&
                            (e.ctx.save(),
                            e.ctx.beginPath(),
                            e.ctx.rect(
                              e.chart.plotArea.x1,
                              e.chart.plotArea.y1,
                              e.chart.plotArea.width,
                              e.chart.plotArea.height
                            ),
                            e.ctx.clip(),
                            b.textBlock.render(!0),
                            e.ctx.restore());
                    },
                    b.textBlock
                  ))
                : "inside" === b.stripLine.labelPlacement &&
                  b.textBlock.render(!0);
          this.ctx.restore();
          k = !0;
        }
        if (k)
          for (k = !1, c = 0; c < x.length; c++)
            (b = x[c]),
              "outside" === b.stripLine.labelPlacement &&
                b.textBlock.render(!0);
      }
    };
    z.prototype.renderBreaksBackground = function () {
      this.chart._breaksCanvas &&
        this.scaleBreaks &&
        0 < this.scaleBreaks._appliedBreaks.length &&
        this.maskCanvas &&
        (this.chart._breaksCanvasCtx.save(),
        this.chart._breaksCanvasCtx.beginPath(),
        this.chart._breaksCanvasCtx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        ),
        this.chart._breaksCanvasCtx.clip(),
        this.chart._breaksCanvasCtx.drawImage(
          this.maskCanvas,
          0,
          0,
          this.chart.width,
          this.chart.height
        ),
        this.chart._breaksCanvasCtx.restore());
    };
    z.prototype.createMask = function () {
      if (this.scaleBreaks && 0 < this.scaleBreaks._appliedBreaks.length) {
        var a = this.scaleBreaks._appliedBreaks;
        v
          ? ((this.maskCanvas = ta(this.chart.width, this.chart.height)),
            (this.maskCtx = this.maskCanvas.getContext("2d")))
          : ((this.maskCanvas = this.chart.plotArea.canvas),
            (this.maskCtx = this.chart.plotArea.ctx));
        this.maskCtx.save();
        this.maskCtx.beginPath();
        this.maskCtx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        );
        this.maskCtx.clip();
        for (var e = 0; e < a.length; e++)
          a[e].endValue < this.viewportMinimum ||
            a[e].startValue > this.viewportMaximum ||
            isNaN(this.range) ||
            a[e].render(this.maskCtx);
        this.maskCtx.restore();
      }
    };
    z.prototype.renderCrosshair = function (a, e) {
      isFinite(this.minimum) &&
        isFinite(this.maximum) &&
        (this.crosshair.render(a, e),
        this.crosshair.dispatchEvent(
          "updated",
          {
            chart: this.chart,
            crosshair: this.options,
            axis: this,
            value: this.crosshair.value,
          },
          this
        ));
    };
    z.prototype.showCrosshair = function (a) {
      f(a) ||
        a < this.viewportMinimum ||
        a > this.viewportMaximum ||
        ("top" === this._position || "bottom" === this._position
          ? this.crosshair.render(this.convertValueToPixel(a), null, a)
          : this.crosshair.render(null, this.convertValueToPixel(a), a));
    };
    z.prototype.renderGrid = function () {
      if (this.gridThickness && 0 < this.gridThickness) {
        var a = this.chart.ctx;
        a.save();
        var e,
          b = this.chart.plotArea;
        a.lineWidth = this.gridThickness;
        a.strokeStyle = this.gridColor;
        a.setLineDash &&
          a.setLineDash(N(this.gridDashType, this.gridThickness));
        if ("bottom" === this._position || "top" === this._position)
          for (c = 0; c < this._labels.length; c++)
            this._labels[c].position < this.viewportMinimum ||
              this._labels[c].position > this.viewportMaximum ||
              this._labels[c].breaksLabelType ||
              (a.beginPath(),
              (e = this.getPixelCoordinatesOnAxis(this._labels[c].position)),
              (e = 1 === a.lineWidth % 2 ? (e.x << 0) + 0.5 : e.x << 0),
              a.moveTo(e, b.y1 << 0),
              a.lineTo(e, b.y2 << 0),
              a.stroke());
        else if ("left" === this._position || "right" === this._position)
          for (var c = 0; c < this._labels.length; c++)
            this._labels[c].position < this.viewportMinimum ||
              this._labels[c].position > this.viewportMaximum ||
              this._labels[c].breaksLabelType ||
              (a.beginPath(),
              (e = this.getPixelCoordinatesOnAxis(this._labels[c].position)),
              (e = 1 === a.lineWidth % 2 ? (e.y << 0) + 0.5 : e.y << 0),
              a.moveTo(b.x1 << 0, e),
              a.lineTo(b.x2 << 0, e),
              a.stroke());
        a.restore();
      }
    };
    z.prototype.renderAxisLine = function () {
      var a = this.chart.ctx,
        e = v ? this.chart._preRenderCtx : a,
        b = Math.ceil(this.tickThickness / (this.reversed ? -2 : 2)),
        c = Math.ceil(this.tickThickness / (this.reversed ? 2 : -2)),
        g,
        d;
      e.save();
      if ("bottom" === this._position || "top" === this._position) {
        if (this.lineThickness) {
          this.reversed
            ? ((g = this.lineCoordinates.x2), (d = this.lineCoordinates.x1))
            : ((g = this.lineCoordinates.x1), (d = this.lineCoordinates.x2));
          e.lineWidth = this.lineThickness;
          e.strokeStyle = this.lineColor ? this.lineColor : "black";
          e.setLineDash &&
            e.setLineDash(N(this.lineDashType, this.lineThickness));
          var k =
            1 === this.lineThickness % 2
              ? (this.lineCoordinates.y1 << 0) + 0.5
              : this.lineCoordinates.y1 << 0;
          e.beginPath();
          if (this.scaleBreaks && !f(this.scaleBreaks.firstBreakIndex))
            if (f(this.scaleBreaks.lastBreakIndex))
              g =
                this.scaleBreaks._appliedBreaks[
                  this.scaleBreaks.firstBreakIndex
                ].endPixel + c;
            else
              for (
                var u = this.scaleBreaks.firstBreakIndex;
                u <= this.scaleBreaks.lastBreakIndex;
                u++
              )
                e.moveTo(g, k),
                  e.lineTo(
                    this.scaleBreaks._appliedBreaks[u].startPixel + b,
                    k
                  ),
                  (g = this.scaleBreaks._appliedBreaks[u].endPixel + c);
          g && (e.moveTo(g, k), e.lineTo(d, k));
          e.stroke();
        }
      } else if (
        ("left" === this._position || "right" === this._position) &&
        this.lineThickness
      ) {
        this.reversed
          ? ((g = this.lineCoordinates.y1), (d = this.lineCoordinates.y2))
          : ((g = this.lineCoordinates.y2), (d = this.lineCoordinates.y1));
        e.lineWidth = this.lineThickness;
        e.strokeStyle = this.lineColor;
        e.setLineDash &&
          e.setLineDash(N(this.lineDashType, this.lineThickness));
        k =
          1 === this.lineThickness % 2
            ? (this.lineCoordinates.x1 << 0) + 0.5
            : this.lineCoordinates.x1 << 0;
        e.beginPath();
        if (this.scaleBreaks && !f(this.scaleBreaks.firstBreakIndex))
          if (f(this.scaleBreaks.lastBreakIndex))
            g =
              this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex]
                .endPixel + b;
          else
            for (
              u = this.scaleBreaks.firstBreakIndex;
              u <= this.scaleBreaks.lastBreakIndex;
              u++
            )
              e.moveTo(k, g),
                e.lineTo(k, this.scaleBreaks._appliedBreaks[u].startPixel + c),
                (g = this.scaleBreaks._appliedBreaks[u].endPixel + b);
        g && (e.moveTo(k, g), e.lineTo(k, d));
        e.stroke();
      }
      v &&
        (a.drawImage(
          this.chart._preRenderCanvas,
          0,
          0,
          this.chart.width,
          this.chart.height
        ),
        this.chart._breaksCanvasCtx &&
          this.chart._breaksCanvasCtx.drawImage(
            this.chart._preRenderCanvas,
            0,
            0,
            this.chart.width,
            this.chart.height
          ),
        e.clearRect(0, 0, this.chart.width, this.chart.height));
      e.restore();
    };
    z.prototype.getPixelCoordinatesOnAxis = function (a) {
      var e = {};
      if ("bottom" === this._position || "top" === this._position)
        (e.x = this.convertValueToPixel(a)), (e.y = this.lineCoordinates.y1);
      if ("left" === this._position || "right" === this._position)
        (e.y = this.convertValueToPixel(a)), (e.x = this.lineCoordinates.x2);
      return e;
    };
    z.prototype.convertPixelToValue = function (a) {
      if ("undefined" === typeof a) return null;
      var e = 0,
        b = 0,
        c,
        e = !0,
        g = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [],
        b =
          "number" === typeof a
            ? a
            : "left" === this._position || "right" === this._position
            ? a.y
            : a.x;
      if (this.logarithmic) {
        a = c = Math.pow(
          this.logarithmBase,
          (b - this.conversionParameters.reference) /
            this.conversionParameters.pixelPerUnit
        );
        if (
          (b <= this.conversionParameters.reference ===
            ("left" === this._position || "right" === this._position)) !==
          this.reversed
        )
          for (b = 0; b < g.length; b++) {
            if (!(g[b].endValue < this.conversionParameters.minimum))
              if (e)
                if (g[b].startValue < this.conversionParameters.minimum) {
                  if (
                    1 < g[b].size &&
                    this.conversionParameters.minimum *
                      Math.pow(
                        g[b].endValue / g[b].startValue,
                        Math.log(c) / Math.log(g[b].size)
                      ) <
                      g[b].endValue
                  ) {
                    a = Math.pow(
                      g[b].endValue / g[b].startValue,
                      Math.log(c) / Math.log(g[b].size)
                    );
                    break;
                  } else
                    (a *=
                      g[b].endValue /
                      this.conversionParameters.minimum /
                      Math.pow(
                        g[b].size,
                        Math.log(
                          g[b].endValue / this.conversionParameters.minimum
                        ) / Math.log(g[b].endValue / g[b].startValue)
                      )),
                      (c /= Math.pow(
                        g[b].size,
                        Math.log(
                          g[b].endValue / this.conversionParameters.minimum
                        ) / Math.log(g[b].endValue / g[b].startValue)
                      ));
                  e = !1;
                } else if (
                  c >
                  g[b].startValue / this.conversionParameters.minimum
                ) {
                  c /= g[b].startValue / this.conversionParameters.minimum;
                  if (c < g[b].size) {
                    a *=
                      Math.pow(
                        g[b].endValue / g[b].startValue,
                        1 === g[b].size ? 1 : Math.log(c) / Math.log(g[b].size)
                      ) / c;
                    break;
                  } else a *= g[b].endValue / g[b].startValue / g[b].size;
                  c /= g[b].size;
                  e = !1;
                } else break;
              else if (c > g[b].startValue / g[b - 1].endValue) {
                c /= g[b].startValue / g[b - 1].endValue;
                if (c < g[b].size) {
                  a *=
                    Math.pow(
                      g[b].endValue / g[b].startValue,
                      1 === g[b].size ? 1 : Math.log(c) / Math.log(g[b].size)
                    ) / c;
                  break;
                } else a *= g[b].endValue / g[b].startValue / g[b].size;
                c /= g[b].size;
              } else break;
          }
        else
          for (b = g.length - 1; 0 <= b; b--)
            if (!(g[b].startValue > this.conversionParameters.minimum))
              if (e)
                if (g[b].endValue > this.conversionParameters.minimum) {
                  if (
                    1 < g[b].size &&
                    this.conversionParameters.minimum *
                      Math.pow(
                        g[b].endValue / g[b].startValue,
                        Math.log(c) / Math.log(g[b].size)
                      ) >
                      g[b].startValue
                  ) {
                    a = Math.pow(
                      g[b].endValue / g[b].startValue,
                      Math.log(c) / Math.log(g[b].size)
                    );
                    break;
                  } else
                    (a *=
                      (g[b].startValue / this.conversionParameters.minimum) *
                      Math.pow(
                        g[b].size,
                        Math.log(
                          g[b].startValue / this.conversionParameters.minimum
                        ) / Math.log(g[b].endValue / g[b].startValue)
                      ) *
                      c),
                      (c *= Math.pow(
                        g[b].size,
                        Math.log(
                          this.conversionParameters.minimum / g[b].startValue
                        ) / Math.log(g[b].endValue / g[b].startValue)
                      ));
                  e = !1;
                } else if (
                  c <
                  g[b].endValue / this.conversionParameters.minimum
                ) {
                  c /= g[b].endValue / this.conversionParameters.minimum;
                  if (c > 1 / g[b].size) {
                    a *=
                      Math.pow(
                        g[b].endValue / g[b].startValue,
                        1 >= g[b].size ? 1 : Math.log(c) / Math.log(g[b].size)
                      ) * c;
                    break;
                  } else a /= g[b].endValue / g[b].startValue / g[b].size;
                  c *= g[b].size;
                  e = !1;
                } else break;
              else if (c < g[b].endValue / g[b + 1].startValue) {
                c /= g[b].endValue / g[b + 1].startValue;
                if (c > 1 / g[b].size) {
                  a *=
                    Math.pow(
                      g[b].endValue / g[b].startValue,
                      1 >= g[b].size ? 1 : Math.log(c) / Math.log(g[b].size)
                    ) * c;
                  break;
                } else a /= g[b].endValue / g[b].startValue / g[b].size;
                c *= g[b].size;
              } else break;
        e = a * this.viewportMinimum;
      } else {
        a = c =
          (b - this.conversionParameters.reference) /
          this.conversionParameters.pixelPerUnit;
        if (
          (b <= this.conversionParameters.reference ===
            ("left" === this._position || "right" === this._position)) !==
          this.reversed
        )
          for (b = 0; b < g.length; b++) {
            if (!(g[b].endValue < this.conversionParameters.minimum))
              if (e)
                if (g[b].startValue < this.conversionParameters.minimum) {
                  if (
                    g[b].size &&
                    this.conversionParameters.minimum +
                      (c * (g[b].endValue - g[b].startValue)) / g[b].size <
                      g[b].endValue
                  ) {
                    a =
                      0 >= g[b].size
                        ? 0
                        : (c * (g[b].endValue - g[b].startValue)) / g[b].size;
                    break;
                  } else
                    (a +=
                      g[b].endValue -
                      this.conversionParameters.minimum -
                      (g[b].size *
                        (g[b].endValue - this.conversionParameters.minimum)) /
                        (g[b].endValue - g[b].startValue)),
                      (c -=
                        (g[b].size *
                          (g[b].endValue - this.conversionParameters.minimum)) /
                        (g[b].endValue - g[b].startValue));
                  e = !1;
                } else if (
                  c >
                  g[b].startValue - this.conversionParameters.minimum
                ) {
                  c -= g[b].startValue - this.conversionParameters.minimum;
                  if (c < g[b].size) {
                    a +=
                      (g[b].endValue - g[b].startValue) *
                        (0 === g[b].size ? 1 : c / g[b].size) -
                      c;
                    break;
                  } else a += g[b].endValue - g[b].startValue - g[b].size;
                  c -= g[b].size;
                  e = !1;
                } else break;
              else if (c > g[b].startValue - g[b - 1].endValue) {
                c -= g[b].startValue - g[b - 1].endValue;
                if (c < g[b].size) {
                  a +=
                    (g[b].endValue - g[b].startValue) *
                      (0 === g[b].size ? 1 : c / g[b].size) -
                    c;
                  break;
                } else a += g[b].endValue - g[b].startValue - g[b].size;
                c -= g[b].size;
              } else break;
          }
        else
          for (b = g.length - 1; 0 <= b; b--)
            if (!(g[b].startValue > this.conversionParameters.minimum))
              if (e)
                if (g[b].endValue > this.conversionParameters.minimum)
                  if (
                    g[b].size &&
                    this.conversionParameters.minimum +
                      (c * (g[b].endValue - g[b].startValue)) / g[b].size >
                      g[b].startValue
                  ) {
                    a =
                      0 >= g[b].size
                        ? 0
                        : (c * (g[b].endValue - g[b].startValue)) / g[b].size;
                    break;
                  } else
                    (a +=
                      g[b].startValue -
                      this.conversionParameters.minimum +
                      (g[b].size *
                        (this.conversionParameters.minimum - g[b].startValue)) /
                        (g[b].endValue - g[b].startValue)),
                      (c +=
                        (g[b].size *
                          (this.conversionParameters.minimum -
                            g[b].startValue)) /
                        (g[b].endValue - g[b].startValue)),
                      (e = !1);
                else if (
                  c <
                  g[b].endValue - this.conversionParameters.minimum
                ) {
                  c -= g[b].endValue - this.conversionParameters.minimum;
                  if (c > -1 * g[b].size) {
                    a +=
                      (g[b].endValue - g[b].startValue) *
                        (0 === g[b].size ? 1 : c / g[b].size) +
                      c;
                    break;
                  } else a -= g[b].endValue - g[b].startValue - g[b].size;
                  c += g[b].size;
                  e = !1;
                } else break;
              else if (c < g[b].endValue - g[b + 1].startValue) {
                c -= g[b].endValue - g[b + 1].startValue;
                if (c > -1 * g[b].size) {
                  a +=
                    (g[b].endValue - g[b].startValue) *
                      (0 === g[b].size ? 1 : c / g[b].size) +
                    c;
                  break;
                } else a -= g[b].endValue - g[b].startValue - g[b].size;
                c += g[b].size;
              } else break;
        e = this.conversionParameters.minimum + a;
      }
      return e;
    };
    z.prototype.convertValueToPixel = function (a) {
      a = this.getApparentDifference(this.conversionParameters.minimum, a, a);
      return this.logarithmic
        ? (this.conversionParameters.reference +
            (this.conversionParameters.pixelPerUnit *
              Math.log(a / this.conversionParameters.minimum)) /
              this.conversionParameters.lnLogarithmBase +
            0.5) <<
            0
        : "axisX" === this.type
        ? (this.conversionParameters.reference +
            this.conversionParameters.pixelPerUnit *
              (a - this.conversionParameters.minimum) +
            0.5) <<
          0
        : this.conversionParameters.reference +
          this.conversionParameters.pixelPerUnit *
            (a - this.conversionParameters.minimum) +
          0.5;
    };
    z.prototype.getApparentDifference = function (a, e, b, c) {
      var g = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
      if (this.logarithmic) {
        b = f(b) ? e / a : b;
        for (var d = 0; d < g.length && !(e < g[d].startValue); d++)
          a > g[d].endValue ||
            (a <= g[d].startValue && e >= g[d].endValue
              ? (b = (b / g[d].endValue) * g[d].startValue * g[d].size)
              : a >= g[d].startValue && e >= g[d].endValue
              ? (b =
                  (b / g[d].endValue) *
                  a *
                  Math.pow(
                    g[d].size,
                    Math.log(g[d].endValue / a) /
                      Math.log(g[d].endValue / g[d].startValue)
                  ))
              : a <= g[d].startValue && e <= g[d].endValue
              ? (b =
                  (b / e) *
                  g[d].startValue *
                  Math.pow(
                    g[d].size,
                    Math.log(e / g[d].startValue) /
                      Math.log(g[d].endValue / g[d].startValue)
                  ))
              : !c &&
                a > g[d].startValue &&
                e < g[d].endValue &&
                (b =
                  a *
                  Math.pow(
                    g[d].size,
                    Math.log(e / a) / Math.log(g[d].endValue / g[d].startValue)
                  )));
      } else
        for (
          b = f(b) ? Math.abs(e - a) : b, d = 0;
          d < g.length && !(e < g[d].startValue);
          d++
        )
          a > g[d].endValue ||
            (a <= g[d].startValue && e >= g[d].endValue
              ? (b = b - g[d].endValue + g[d].startValue + g[d].size)
              : a > g[d].startValue && e >= g[d].endValue
              ? (b =
                  b -
                  g[d].endValue +
                  a +
                  (g[d].size * (g[d].endValue - a)) /
                    (g[d].endValue - g[d].startValue))
              : a <= g[d].startValue && e < g[d].endValue
              ? (b =
                  b -
                  e +
                  g[d].startValue +
                  (g[d].size * (e - g[d].startValue)) /
                    (g[d].endValue - g[d].startValue))
              : !c &&
                a > g[d].startValue &&
                e < g[d].endValue &&
                (b =
                  a +
                  (g[d].size * (e - a)) / (g[d].endValue - g[d].startValue)));
      return b;
    };
    z.prototype.setViewPortRange = function (a, e) {
      this.sessionVariables.newViewportMinimum = this.viewportMinimum =
        Math.min(a, e);
      this.sessionVariables.newViewportMaximum = this.viewportMaximum =
        Math.max(a, e);
    };
    z.prototype.getXValueAt = function (a) {
      if (!a) return null;
      var e = null;
      "left" === this._position
        ? (e = this.convertPixelToValue(a.y))
        : "bottom" === this._position && (e = this.convertPixelToValue(a.x));
      return e;
    };
    z.prototype.calculateValueToPixelConversionParameters = function (a) {
      a = this.scaleBreaks ? this.scaleBreaks._appliedBreaks : [];
      var e = { pixelPerUnit: null, minimum: null, reference: null },
        b = this.lineCoordinates.width,
        c = this.lineCoordinates.height,
        b = "bottom" === this._position || "top" === this._position ? b : c,
        c = Math.abs(this.range);
      if (this.logarithmic)
        for (
          var d = 0;
          d < a.length && !(this.viewportMaximum < a[d].startValue);
          d++
        )
          this.viewportMinimum > a[d].endValue ||
            (this.viewportMinimum >= a[d].startValue &&
            this.viewportMaximum <= a[d].endValue
              ? (b = 0)
              : this.viewportMinimum <= a[d].startValue &&
                this.viewportMaximum >= a[d].endValue
              ? ((c = (c / a[d].endValue) * a[d].startValue),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b * (1 - parseFloat(a[d].spacing) / 100)
                    : b - Math.min(a[d].spacing, 0.1 * b)))
              : this.viewportMinimum > a[d].startValue &&
                this.viewportMaximum >= a[d].endValue
              ? ((c = (c / a[d].endValue) * this.viewportMinimum),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[d].spacing) / 100) *
                          Math.log(a[d].endValue / this.viewportMinimum)) /
                          Math.log(a[d].endValue / a[d].startValue))
                    : b -
                      (Math.min(a[d].spacing, 0.1 * b) *
                        Math.log(a[d].endValue / this.viewportMinimum)) /
                        Math.log(a[d].endValue / a[d].startValue)))
              : this.viewportMinimum <= a[d].startValue &&
                this.viewportMaximum < a[d].endValue &&
                ((c = (c / this.viewportMaximum) * a[d].startValue),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[d].spacing) / 100) *
                          Math.log(this.viewportMaximum / a[d].startValue)) /
                          Math.log(a[d].endValue / a[d].startValue))
                    : b -
                      (Math.min(a[d].spacing, 0.1 * b) *
                        Math.log(this.viewportMaximum / a[d].startValue)) /
                        Math.log(a[d].endValue / a[d].startValue))));
      else
        for (
          d = 0;
          d < a.length && !(this.viewportMaximum < a[d].startValue);
          d++
        )
          this.viewportMinimum > a[d].endValue ||
            (this.viewportMinimum >= a[d].startValue &&
            this.viewportMaximum <= a[d].endValue
              ? (b = 0)
              : this.viewportMinimum <= a[d].startValue &&
                this.viewportMaximum >= a[d].endValue
              ? ((c = c - a[d].endValue + a[d].startValue),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b * (1 - parseFloat(a[d].spacing) / 100)
                    : b - Math.min(a[d].spacing, 0.1 * b)))
              : this.viewportMinimum > a[d].startValue &&
                this.viewportMaximum >= a[d].endValue
              ? ((c = c - a[d].endValue + this.viewportMinimum),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[d].spacing) / 100) *
                          (a[d].endValue - this.viewportMinimum)) /
                          (a[d].endValue - a[d].startValue))
                    : b -
                      (Math.min(a[d].spacing, 0.1 * b) *
                        (a[d].endValue - this.viewportMinimum)) /
                        (a[d].endValue - a[d].startValue)))
              : this.viewportMinimum <= a[d].startValue &&
                this.viewportMaximum < a[d].endValue &&
                ((c = c - this.viewportMaximum + a[d].startValue),
                (b =
                  0 < a[d].spacing.toString().indexOf("%")
                    ? b *
                      (1 -
                        ((parseFloat(a[d].spacing) / 100) *
                          (this.viewportMaximum - a[d].startValue)) /
                          (a[d].endValue - a[d].startValue))
                    : b -
                      (Math.min(a[d].spacing, 0.1 * b) *
                        (this.viewportMaximum - a[d].startValue)) /
                        (a[d].endValue - a[d].startValue))));
      e.minimum = this.viewportMinimum;
      e.maximum = this.viewportMaximum;
      e.range = c;
      if ("bottom" === this._position || "top" === this._position)
        this.logarithmic
          ? ((e.lnLogarithmBase = Math.log(this.logarithmBase)),
            (e.pixelPerUnit =
              ((this.reversed ? -1 : 1) * b * e.lnLogarithmBase) /
              Math.log(Math.abs(c))))
          : (e.pixelPerUnit = ((this.reversed ? -1 : 1) * b) / Math.abs(c)),
          (e.reference = this.reversed
            ? this.lineCoordinates.x2
            : this.lineCoordinates.x1);
      if ("left" === this._position || "right" === this._position)
        this.logarithmic
          ? ((e.lnLogarithmBase = Math.log(this.logarithmBase)),
            (e.pixelPerUnit =
              ((this.reversed ? 1 : -1) * b * e.lnLogarithmBase) /
              Math.log(Math.abs(c))))
          : (e.pixelPerUnit = ((this.reversed ? 1 : -1) * b) / Math.abs(c)),
          (e.reference = this.reversed
            ? this.lineCoordinates.y1
            : this.lineCoordinates.y2);
      this.conversionParameters = e;
    };
    z.prototype.calculateAxisParameters = function () {
      if (this.logarithmic) this.calculateLogarithmicAxisParameters();
      else {
        var a = this.chart.layoutManager.getFreeSpace(),
          e = !1,
          b = !1;
        "bottom" === this._position || "top" === this._position
          ? ((this.maxWidth = a.width), (this.maxHeight = a.height))
          : ((this.maxWidth = a.height), (this.maxHeight = a.width));
        var a =
            "axisX" === this.type
              ? "xySwapped" === this.chart.plotInfo.axisPlacement
                ? 62
                : 70
              : "xySwapped" === this.chart.plotInfo.axisPlacement
              ? 50
              : 40,
          c = 4;
        "axisX" === this.type && (c = 600 > this.maxWidth ? 8 : 6);
        var a = Math.max(c, Math.floor(this.maxWidth / a)),
          d,
          h,
          k,
          c = 0;
        !f(this.options.viewportMinimum) &&
          !f(this.options.viewportMaximum) &&
          this.options.viewportMinimum >= this.options.viewportMaximum &&
          (this.viewportMinimum = this.viewportMaximum = null);
        if (
          f(this.options.viewportMinimum) &&
          !f(this.sessionVariables.newViewportMinimum) &&
          !isNaN(this.sessionVariables.newViewportMinimum)
        )
          this.viewportMinimum = this.sessionVariables.newViewportMinimum;
        else if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
          this.viewportMinimum = this.minimum;
        if (
          f(this.options.viewportMaximum) &&
          !f(this.sessionVariables.newViewportMaximum) &&
          !isNaN(this.sessionVariables.newViewportMaximum)
        )
          this.viewportMaximum = this.sessionVariables.newViewportMaximum;
        else if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
          this.viewportMaximum = this.maximum;
        if (this.scaleBreaks)
          for (c = 0; c < this.scaleBreaks._appliedBreaks.length; c++)
            if (
              ((!f(this.sessionVariables.newViewportMinimum) &&
                this.sessionVariables.newViewportMinimum >=
                  this.scaleBreaks._appliedBreaks[c].startValue) ||
                (!f(this.options.minimum) &&
                  this.options.minimum >=
                    this.scaleBreaks._appliedBreaks[c].startValue) ||
                (!f(this.options.viewportMinimum) &&
                  this.viewportMinimum >=
                    this.scaleBreaks._appliedBreaks[c].startValue)) &&
              ((!f(this.sessionVariables.newViewportMaximum) &&
                this.sessionVariables.newViewportMaximum <=
                  this.scaleBreaks._appliedBreaks[c].endValue) ||
                (!f(this.options.maximum) &&
                  this.options.maximum <=
                    this.scaleBreaks._appliedBreaks[c].endValue) ||
                (!f(this.options.viewportMaximum) &&
                  this.viewportMaximum <=
                    this.scaleBreaks._appliedBreaks[c].endValue))
            ) {
              this.scaleBreaks._appliedBreaks.splice(c, 1);
              break;
            }
        if ("axisX" === this.type) {
          if (this.dataSeries && 0 < this.dataSeries.length)
            for (d = 0; d < this.dataSeries.length; d++)
              "dateTime" === this.dataSeries[d].xValueType && (b = !0);
          d =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin;
          h =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax;
          0 === h - d &&
            ((c =
              "undefined" === typeof this.options.interval
                ? 0.4
                : this.options.interval),
            (h += c),
            (d -= c));
          Infinity !== this.dataInfo.minDiff
            ? (k = this.dataInfo.minDiff)
            : 1 < h - d
            ? (k = 0.5 * Math.abs(h - d))
            : ((k = 1), b && (e = !0));
        } else
          "axisY" === this.type &&
            ((d =
              null !== this.viewportMinimum
                ? this.viewportMinimum
                : this.dataInfo.viewPortMin),
            (h =
              null !== this.viewportMaximum
                ? this.viewportMaximum
                : this.dataInfo.viewPortMax),
            isFinite(d) || isFinite(h)
              ? isFinite(d)
                ? isFinite(h) || (h = d)
                : (d = h)
              : ((h =
                  "undefined" === typeof this.options.interval
                    ? -Infinity
                    : this.options.interval),
                (d =
                  "undefined" !== typeof this.options.interval ||
                  isFinite(this.dataInfo.minDiff)
                    ? 0
                    : Infinity)),
            0 === d && 0 === h
              ? ((h += 9), (d = 0))
              : 0 === h - d
              ? ((c = Math.min(Math.abs(0.01 * Math.abs(h)), 5)),
                (h += c),
                (d -= c))
              : d > h
              ? ((c = Math.min(
                  0.01 * Math.abs(this.getApparentDifference(h, d, null, !0)),
                  5
                )),
                0 <= h ? (d = h - c) : (h = isFinite(d) ? d + c : 0))
              : ((c = Math.min(
                  0.01 * Math.abs(this.getApparentDifference(d, h, null, !0)),
                  0.05
                )),
                0 !== h && (h += c),
                0 !== d && (d -= c)),
            (k =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : 1 < h - d
                ? 0.5 * Math.abs(h - d)
                : 1),
            this.includeZero &&
              (null === this.viewportMinimum || isNaN(this.viewportMinimum)) &&
              0 < d &&
              (d = 0),
            this.includeZero &&
              (null === this.viewportMaximum || isNaN(this.viewportMaximum)) &&
              0 > h &&
              (h = 0));
        c = this.getApparentDifference(
          isNaN(this.viewportMinimum) || null === this.viewportMinimum
            ? d
            : this.viewportMinimum,
          isNaN(this.viewportMaximum) || null === this.viewportMaximum
            ? h
            : this.viewportMaximum,
          null,
          !0
        );
        if ("axisX" === this.type && b) {
          this.intervalType ||
            (c / 1 <= a
              ? ((this.interval = 1), (this.intervalType = "millisecond"))
              : c / 2 <= a
              ? ((this.interval = 2), (this.intervalType = "millisecond"))
              : c / 5 <= a
              ? ((this.interval = 5), (this.intervalType = "millisecond"))
              : c / 10 <= a
              ? ((this.interval = 10), (this.intervalType = "millisecond"))
              : c / 20 <= a
              ? ((this.interval = 20), (this.intervalType = "millisecond"))
              : c / 50 <= a
              ? ((this.interval = 50), (this.intervalType = "millisecond"))
              : c / 100 <= a
              ? ((this.interval = 100), (this.intervalType = "millisecond"))
              : c / 200 <= a
              ? ((this.interval = 200), (this.intervalType = "millisecond"))
              : c / 250 <= a
              ? ((this.interval = 250), (this.intervalType = "millisecond"))
              : c / 300 <= a
              ? ((this.interval = 300), (this.intervalType = "millisecond"))
              : c / 400 <= a
              ? ((this.interval = 400), (this.intervalType = "millisecond"))
              : c / 500 <= a
              ? ((this.interval = 500), (this.intervalType = "millisecond"))
              : c / (1 * Y.secondDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "second"))
              : c / (2 * Y.secondDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "second"))
              : c / (5 * Y.secondDuration) <= a
              ? ((this.interval = 5), (this.intervalType = "second"))
              : c / (10 * Y.secondDuration) <= a
              ? ((this.interval = 10), (this.intervalType = "second"))
              : c / (15 * Y.secondDuration) <= a
              ? ((this.interval = 15), (this.intervalType = "second"))
              : c / (20 * Y.secondDuration) <= a
              ? ((this.interval = 20), (this.intervalType = "second"))
              : c / (30 * Y.secondDuration) <= a
              ? ((this.interval = 30), (this.intervalType = "second"))
              : c / (1 * Y.minuteDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "minute"))
              : c / (2 * Y.minuteDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "minute"))
              : c / (5 * Y.minuteDuration) <= a
              ? ((this.interval = 5), (this.intervalType = "minute"))
              : c / (10 * Y.minuteDuration) <= a
              ? ((this.interval = 10), (this.intervalType = "minute"))
              : c / (15 * Y.minuteDuration) <= a
              ? ((this.interval = 15), (this.intervalType = "minute"))
              : c / (20 * Y.minuteDuration) <= a
              ? ((this.interval = 20), (this.intervalType = "minute"))
              : c / (30 * Y.minuteDuration) <= a
              ? ((this.interval = 30), (this.intervalType = "minute"))
              : c / (1 * Y.hourDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "hour"))
              : c / (2 * Y.hourDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "hour"))
              : c / (3 * Y.hourDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "hour"))
              : c / (6 * Y.hourDuration) <= a
              ? ((this.interval = 6), (this.intervalType = "hour"))
              : c / (1 * Y.dayDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "day"))
              : c / (2 * Y.dayDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "day"))
              : c / (4 * Y.dayDuration) <= a
              ? ((this.interval = 4), (this.intervalType = "day"))
              : c / (1 * Y.weekDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "week"))
              : c / (2 * Y.weekDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "week"))
              : c / (3 * Y.weekDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "week"))
              : c / (1 * Y.monthDuration) <= a
              ? ((this.interval = 1), (this.intervalType = "month"))
              : c / (2 * Y.monthDuration) <= a
              ? ((this.interval = 2), (this.intervalType = "month"))
              : c / (3 * Y.monthDuration) <= a
              ? ((this.interval = 3), (this.intervalType = "month"))
              : c / (6 * Y.monthDuration) <= a
              ? ((this.interval = 6), (this.intervalType = "month"))
              : ((this.interval =
                  c / (1 * Y.yearDuration) <= a
                    ? 1
                    : c / (2 * Y.yearDuration) <= a
                    ? 2
                    : c / (4 * Y.yearDuration) <= a
                    ? 4
                    : Math.floor(
                        z.getNiceNumber(c / (a - 1), !0) / Y.yearDuration
                      )),
                (this.intervalType = "year")));
          if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
            this.viewportMinimum = d - k / 2;
          if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
            this.viewportMaximum = h + k / 2;
          e
            ? (this.autoValueFormatString = "MMM DD YYYY HH:mm")
            : "year" === this.intervalType
            ? (this.autoValueFormatString = "YYYY")
            : "month" === this.intervalType
            ? (this.autoValueFormatString = "MMM YYYY")
            : "week" === this.intervalType
            ? (this.autoValueFormatString = "MMM DD YYYY")
            : "day" === this.intervalType
            ? (this.autoValueFormatString = "MMM DD YYYY")
            : "hour" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm TT")
            : "minute" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm TT")
            : "second" === this.intervalType
            ? (this.autoValueFormatString = "hh:mm:ss TT")
            : "millisecond" === this.intervalType &&
              (this.autoValueFormatString = "fff'ms'");
          this.valueFormatString ||
            (this.valueFormatString = this.autoValueFormatString);
        } else {
          this.intervalType = "number";
          c = z.getNiceNumber(c, !1);
          this.interval =
            this.options && 0 < this.options.interval
              ? this.options.interval
              : z.getNiceNumber(c / (a - 1), !0);
          if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
            this.viewportMinimum =
              "axisX" === this.type
                ? d - k / 2
                : Math.floor(d / this.interval) * this.interval;
          if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
            this.viewportMaximum =
              "axisX" === this.type
                ? h + k / 2
                : Math.ceil(h / this.interval) * this.interval;
          0 === this.viewportMaximum &&
            0 === this.viewportMinimum &&
            (0 === this.options.viewportMinimum
              ? (this.viewportMaximum += 10)
              : 0 === this.options.viewportMaximum &&
                (this.viewportMinimum -= 10),
            this.options &&
              "undefined" === typeof this.options.interval &&
              (this.interval = z.getNiceNumber(
                (this.viewportMaximum - this.viewportMinimum) / (a - 1),
                !0
              )));
        }
        if (null === this.minimum || null === this.maximum)
          if (
            ("axisX" === this.type
              ? ((d = null !== this.minimum ? this.minimum : this.dataInfo.min),
                (h = null !== this.maximum ? this.maximum : this.dataInfo.max),
                0 === h - d &&
                  ((c =
                    "undefined" === typeof this.options.interval
                      ? 0.4
                      : this.options.interval),
                  (h += c),
                  (d -= c)),
                (k =
                  Infinity !== this.dataInfo.minDiff
                    ? this.dataInfo.minDiff
                    : 1 < h - d
                    ? 0.5 * Math.abs(h - d)
                    : 1))
              : "axisY" === this.type &&
                ((d = null !== this.minimum ? this.minimum : this.dataInfo.min),
                (h = null !== this.maximum ? this.maximum : this.dataInfo.max),
                isFinite(d) || isFinite(h)
                  ? 0 === d && 0 === h
                    ? ((h += 9), (d = 0))
                    : 0 === h - d
                    ? ((c = Math.min(Math.abs(0.01 * Math.abs(h)), 5)),
                      (h += c),
                      (d -= c))
                    : d > h
                    ? ((c = Math.min(
                        0.01 *
                          Math.abs(this.getApparentDifference(h, d, null, !0)),
                        5
                      )),
                      0 <= h ? (d = h - c) : (h = isFinite(d) ? d + c : 0))
                    : ((c = Math.min(
                        0.01 *
                          Math.abs(this.getApparentDifference(d, h, null, !0)),
                        0.05
                      )),
                      0 !== h && (h += c),
                      0 !== d && (d -= c))
                  : ((h =
                      "undefined" === typeof this.options.interval
                        ? -Infinity
                        : this.options.interval),
                    (d =
                      "undefined" !== typeof this.options.interval ||
                      isFinite(this.dataInfo.minDiff)
                        ? 0
                        : Infinity)),
                (k =
                  Infinity !== this.dataInfo.minDiff
                    ? this.dataInfo.minDiff
                    : 1 < h - d
                    ? 0.5 * Math.abs(h - d)
                    : 1),
                this.includeZero &&
                  (null === this.minimum || isNaN(this.minimum)) &&
                  0 < d &&
                  (d = 0),
                this.includeZero &&
                  (null === this.maximum || isNaN(this.maximum)) &&
                  0 > h &&
                  (h = 0)),
            Math.abs(this.getApparentDifference(d, h, null, !0)),
            "axisX" === this.type && b)
          ) {
            this.valueType = "dateTime";
            if (null === this.minimum || isNaN(this.minimum))
              (this.minimum = d - k / 2),
                (this.minimum = Math.min(
                  this.minimum,
                  null === this.sessionVariables.viewportMinimum ||
                    isNaN(this.sessionVariables.viewportMinimum)
                    ? Infinity
                    : this.sessionVariables.viewportMinimum
                ));
            if (null === this.maximum || isNaN(this.maximum))
              (this.maximum = h + k / 2),
                (this.maximum = Math.max(
                  this.maximum,
                  null === this.sessionVariables.viewportMaximum ||
                    isNaN(this.sessionVariables.viewportMaximum)
                    ? -Infinity
                    : this.sessionVariables.viewportMaximum
                ));
          } else
            (this.intervalType = this.valueType = "number"),
              null === this.minimum &&
                ((this.minimum =
                  "axisX" === this.type
                    ? d - k / 2
                    : Math.floor(d / this.interval) * this.interval),
                (this.minimum = Math.min(
                  this.minimum,
                  null === this.sessionVariables.viewportMinimum ||
                    isNaN(this.sessionVariables.viewportMinimum)
                    ? Infinity
                    : this.sessionVariables.viewportMinimum
                ))),
              null === this.maximum &&
                ((this.maximum =
                  "axisX" === this.type
                    ? h + k / 2
                    : Math.ceil(h / this.interval) * this.interval),
                (this.maximum = Math.max(
                  this.maximum,
                  null === this.sessionVariables.viewportMaximum ||
                    isNaN(this.sessionVariables.viewportMaximum)
                    ? -Infinity
                    : this.sessionVariables.viewportMaximum
                ))),
              0 === this.maximum &&
                0 === this.minimum &&
                (0 === this.options.minimum
                  ? (this.maximum += 10)
                  : 0 === this.options.maximum && (this.minimum -= 10));
        f(this.sessionVariables.newViewportMinimum) &&
          (this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum));
        f(this.sessionVariables.newViewportMaximum) &&
          (this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum));
        this.range = this.viewportMaximum - this.viewportMinimum;
        this.intervalStartPosition =
          "axisX" === this.type && b
            ? this.getLabelStartPoint(
                new Date(this.viewportMinimum),
                this.intervalType,
                this.interval
              )
            : Math.floor(
                (this.viewportMinimum + 0.2 * this.interval) / this.interval
              ) * this.interval;
        this.valueFormatString ||
          (this.valueFormatString = z.generateValueFormatString(this.range, 2));
      }
    };
    z.prototype.calculateLogarithmicAxisParameters = function () {
      var a = this.chart.layoutManager.getFreeSpace(),
        d = Math.log(this.logarithmBase),
        b;
      "bottom" === this._position || "top" === this._position
        ? ((this.maxWidth = a.width), (this.maxHeight = a.height))
        : ((this.maxWidth = a.height), (this.maxHeight = a.width));
      var a =
          "axisX" === this.type
            ? 500 > this.maxWidth
              ? 7
              : Math.max(7, Math.floor(this.maxWidth / 100))
            : Math.max(Math.floor(this.maxWidth / 50), 3),
        c,
        g,
        h,
        k;
      k = 1;
      if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
        this.viewportMinimum = this.minimum;
      if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
        this.viewportMaximum = this.maximum;
      if (this.scaleBreaks)
        for (k = 0; k < this.scaleBreaks._appliedBreaks.length; k++)
          if (
            ((!f(this.sessionVariables.newViewportMinimum) &&
              this.sessionVariables.newViewportMinimum >=
                this.scaleBreaks._appliedBreaks[k].startValue) ||
              (!f(this.options.minimum) &&
                this.options.minimum >=
                  this.scaleBreaks._appliedBreaks[k].startValue) ||
              (!f(this.options.viewportMinimum) &&
                this.viewportMinimum >=
                  this.scaleBreaks._appliedBreaks[k].startValue)) &&
            ((!f(this.sessionVariables.newViewportMaximum) &&
              this.sessionVariables.newViewportMaximum <=
                this.scaleBreaks._appliedBreaks[k].endValue) ||
              (!f(this.options.maximum) &&
                this.options.maximum <=
                  this.scaleBreaks._appliedBreaks[k].endValue) ||
              (!f(this.options.viewportMaximum) &&
                this.viewportMaximum <=
                  this.scaleBreaks._appliedBreaks[k].endValue))
          ) {
            this.scaleBreaks._appliedBreaks.splice(k, 1);
            break;
          }
      "axisX" === this.type
        ? ((c =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin),
          (g =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax),
          1 === g / c &&
            ((k = Math.pow(
              this.logarithmBase,
              "undefined" === typeof this.options.interval
                ? 0.4
                : this.options.interval
            )),
            (g *= k),
            (c /= k)),
          (h =
            Infinity !== this.dataInfo.minDiff
              ? this.dataInfo.minDiff
              : g / c > this.logarithmBase
              ? (g / c) * Math.pow(this.logarithmBase, 0.5)
              : this.logarithmBase))
        : "axisY" === this.type &&
          ((c =
            null !== this.viewportMinimum
              ? this.viewportMinimum
              : this.dataInfo.viewPortMin),
          (g =
            null !== this.viewportMaximum
              ? this.viewportMaximum
              : this.dataInfo.viewPortMax),
          0 >= c && !isFinite(g)
            ? ((g =
                "undefined" === typeof this.options.interval
                  ? 0
                  : this.options.interval),
              (c = 1))
            : 0 >= c
            ? (c = g)
            : isFinite(g) || (g = c),
          1 === c && 1 === g
            ? ((g *= this.logarithmBase - 1 / this.logarithmBase), (c = 1))
            : 1 === g / c
            ? ((k = Math.min(
                g * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 5)
              )),
              (g *= k),
              (c /= k))
            : c > g
            ? ((k = Math.min(
                (c / g) * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 5)
              )),
              1 <= g ? (c = g / k) : (g = c * k))
            : ((k = Math.min(
                (g / c) * Math.pow(this.logarithmBase, 0.01),
                Math.pow(this.logarithmBase, 0.04)
              )),
              1 !== g && (g *= k),
              1 !== c && (c /= k)),
          (h =
            Infinity !== this.dataInfo.minDiff
              ? this.dataInfo.minDiff
              : g / c > this.logarithmBase
              ? (g / c) * Math.pow(this.logarithmBase, 0.5)
              : this.logarithmBase),
          this.includeZero &&
            (null === this.viewportMinimum || isNaN(this.viewportMinimum)) &&
            1 < c &&
            (c = 1),
          this.includeZero &&
            (null === this.viewportMaximum || isNaN(this.viewportMaximum)) &&
            1 > g &&
            (g = 1));
      k =
        (isNaN(this.viewportMaximum) || null === this.viewportMaximum
          ? g
          : this.viewportMaximum) /
        (isNaN(this.viewportMinimum) || null === this.viewportMinimum
          ? c
          : this.viewportMinimum);
      var u =
        (isNaN(this.viewportMaximum) || null === this.viewportMaximum
          ? g
          : this.viewportMaximum) -
        (isNaN(this.viewportMinimum) || null === this.viewportMinimum
          ? c
          : this.viewportMinimum);
      this.intervalType = "number";
      k = Math.pow(
        this.logarithmBase,
        z.getNiceNumber(Math.abs(Math.log(k) / d), !1)
      );
      this.options && 0 < this.options.interval
        ? (this.interval = this.options.interval)
        : ((this.interval = z.getNiceExponent(Math.log(k) / d / (a - 1), !0)),
          (b = z.getNiceNumber(u / (a - 1), !0)));
      if (null === this.viewportMinimum || isNaN(this.viewportMinimum))
        this.viewportMinimum =
          "axisX" === this.type
            ? c / Math.sqrt(h)
            : Math.pow(
                this.logarithmBase,
                this.interval * Math.floor(Math.log(c) / d / this.interval)
              );
      if (null === this.viewportMaximum || isNaN(this.viewportMaximum))
        this.viewportMaximum =
          "axisX" === this.type
            ? g * Math.sqrt(h)
            : Math.pow(
                this.logarithmBase,
                this.interval * Math.ceil(Math.log(g) / d / this.interval)
              );
      1 === this.viewportMaximum &&
        1 === this.viewportMinimum &&
        (1 === this.options.viewportMinimum
          ? (this.viewportMaximum *=
              this.logarithmBase - 1 / this.logarithmBase)
          : 1 === this.options.viewportMaximum &&
            (this.viewportMinimum /=
              this.logarithmBase - 1 / this.logarithmBase),
        this.options &&
          "undefined" === typeof this.options.interval &&
          ((this.interval = z.getNiceExponent(
            Math.ceil(Math.log(k) / d) / (a - 1)
          )),
          (b = z.getNiceNumber(
            (this.viewportMaximum - this.viewportMinimum) / (a - 1),
            !0
          ))));
      if (null === this.minimum || null === this.maximum)
        "axisX" === this.type
          ? ((c = null !== this.minimum ? this.minimum : this.dataInfo.min),
            (g = null !== this.maximum ? this.maximum : this.dataInfo.max),
            1 === g / c &&
              ((k = Math.pow(
                this.logarithmBase,
                "undefined" === typeof this.options.interval
                  ? 0.4
                  : this.options.interval
              )),
              (g *= k),
              (c /= k)),
            (h =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : g / c > this.logarithmBase
                ? (g / c) * Math.pow(this.logarithmBase, 0.5)
                : this.logarithmBase))
          : "axisY" === this.type &&
            ((c = null !== this.minimum ? this.minimum : this.dataInfo.min),
            (g = null !== this.maximum ? this.maximum : this.dataInfo.max),
            isFinite(c) || isFinite(g)
              ? 1 === c && 1 === g
                ? ((g *= this.logarithmBase), (c /= this.logarithmBase))
                : 1 === g / c
                ? ((k = Math.pow(this.logarithmBase, this.interval)),
                  (g *= k),
                  (c /= k))
                : c > g
                ? ((k = Math.min(0.01 * (c / g), 5)),
                  1 <= g ? (c = g / k) : (g = c * k))
                : ((k = Math.min(
                    (g / c) * Math.pow(this.logarithmBase, 0.01),
                    Math.pow(this.logarithmBase, 0.04)
                  )),
                  1 !== g && (g *= k),
                  1 !== c && (c /= k))
              : ((g =
                  "undefined" === typeof this.options.interval
                    ? 0
                    : this.options.interval),
                (c = 1)),
            (h =
              Infinity !== this.dataInfo.minDiff
                ? this.dataInfo.minDiff
                : g / c > this.logarithmBase
                ? (g / c) * Math.pow(this.logarithmBase, 0.5)
                : this.logarithmBase),
            this.includeZero &&
              (null === this.minimum || isNaN(this.minimum)) &&
              1 < c &&
              (c = 1),
            this.includeZero &&
              (null === this.maximum || isNaN(this.maximum)) &&
              1 > g &&
              (g = 1)),
          (this.intervalType = "number"),
          null === this.minimum &&
            ((this.minimum =
              "axisX" === this.type
                ? c / Math.sqrt(h)
                : Math.pow(
                    this.logarithmBase,
                    this.interval * Math.floor(Math.log(c) / d / this.interval)
                  )),
            f(
              null === this.sessionVariables.viewportMinimum ||
                isNaN(this.sessionVariables.viewportMinimum)
                ? "undefined" ===
                  typeof this.sessionVariables.newViewportMinimum
                  ? Infinity
                  : this.sessionVariables.newViewportMinimum
                : this.sessionVariables.viewportMinimum
            ) ||
              (this.minimum = Math.min(
                this.minimum,
                null === this.sessionVariables.viewportMinimum ||
                  isNaN(this.sessionVariables.viewportMinimum)
                  ? "undefined" ===
                    typeof this.sessionVariables.newViewportMinimum
                    ? Infinity
                    : this.sessionVariables.newViewportMinimum
                  : this.sessionVariables.viewportMinimum
              ))),
          null === this.maximum &&
            ((this.maximum =
              "axisX" === this.type
                ? g * Math.sqrt(h)
                : Math.pow(
                    this.logarithmBase,
                    this.interval * Math.ceil(Math.log(g) / d / this.interval)
                  )),
            f(
              null === this.sessionVariables.viewportMaximum ||
                isNaN(this.sessionVariables.viewportMaximum)
                ? "undefined" ===
                  typeof this.sessionVariables.newViewportMaximum
                  ? 0
                  : this.sessionVariables.newViewportMaximum
                : this.sessionVariables.viewportMaximum
            ) ||
              (this.maximum = Math.max(
                this.maximum,
                null === this.sessionVariables.viewportMaximum ||
                  isNaN(this.sessionVariables.viewportMaximum)
                  ? "undefined" ===
                    typeof this.sessionVariables.newViewportMaximum
                    ? 0
                    : this.sessionVariables.newViewportMaximum
                  : this.sessionVariables.viewportMaximum
              ))),
          1 === this.maximum &&
            1 === this.minimum &&
            (1 === this.options.minimum
              ? (this.maximum *= this.logarithmBase - 1 / this.logarithmBase)
              : 1 === this.options.maximum &&
                (this.minimum /= this.logarithmBase - 1 / this.logarithmBase));
      this.viewportMinimum = Math.max(this.viewportMinimum, this.minimum);
      this.viewportMaximum = Math.min(this.viewportMaximum, this.maximum);
      this.viewportMinimum > this.viewportMaximum &&
        ((!this.options.viewportMinimum && !this.options.minimum) ||
        this.options.viewportMaximum ||
        this.options.maximum
          ? this.options.viewportMinimum ||
            this.options.minimum ||
            (!this.options.viewportMaximum && !this.options.maximum) ||
            (this.viewportMinimum = this.minimum =
              (this.options.viewportMaximum || this.options.maximum) /
              Math.pow(this.logarithmBase, 2 * Math.ceil(this.interval)))
          : (this.viewportMaximum = this.maximum =
              this.options.viewportMinimum || this.options.minimum));
      c = Math.pow(
        this.logarithmBase,
        Math.floor(Math.log(this.viewportMinimum) / (d * this.interval) + 0.2) *
          this.interval
      );
      this.range = this.viewportMaximum / this.viewportMinimum;
      this.noTicks = a;
      if (
        !this.options.interval &&
        this.range <
          Math.pow(
            this.logarithmBase,
            8 > this.viewportMaximum || 3 > a ? 2 : 3
          )
      ) {
        for (
          d = Math.floor(this.viewportMinimum / b + 0.5) * b;
          d < this.viewportMinimum;

        )
          d += b;
        this.equidistantInterval = !1;
        this.intervalStartPosition = d;
        this.interval = b;
      } else
        this.options.interval ||
          ((b = Math.ceil(this.interval)),
          this.range > this.interval &&
            ((this.interval = b),
            (c = Math.pow(
              this.logarithmBase,
              Math.floor(
                Math.log(this.viewportMinimum) / (d * this.interval) + 0.2
              ) * this.interval
            )))),
          (this.equidistantInterval = !0),
          (this.intervalStartPosition = c);
      if (
        !this.valueFormatString &&
        ((this.valueFormatString = "#,##0.##"), 1 > this.viewportMinimum)
      ) {
        d =
          Math.floor(Math.abs(Math.log(this.viewportMinimum) / Math.LN10)) + 2;
        if (isNaN(d) || !isFinite(d)) d = 2;
        if (2 < d) for (k = 0; k < d - 2; k++) this.valueFormatString += "#";
      }
    };
    z.generateValueFormatString = function (a, d) {
      var b = "#,##0.",
        c = d;
      1 > a &&
        ((c += Math.floor(Math.abs(Math.log(a) / Math.LN10))),
        isNaN(c) || !isFinite(c)) &&
        (c = d);
      for (var g = 0; g < c; g++) b += "#";
      return b;
    };
    z.getNiceExponent = function (a, d) {
      var b = Math.floor(Math.log(a) / Math.LN10),
        c = a / Math.pow(10, b),
        c = 0 > b ? (1 >= c ? 1 : 5 >= c ? 5 : 10) : Math.max(Math.floor(c), 1);
      return -20 > b
        ? Number(c * Math.pow(10, b))
        : Number((c * Math.pow(10, b)).toFixed(20));
    };
    z.getNiceNumber = function (a, d) {
      var b = Math.floor(Math.log(a) / Math.LN10),
        c = a / Math.pow(10, b),
        c = d
          ? 1.5 > c
            ? 1
            : 3 > c
            ? 2
            : 7 > c
            ? 5
            : 10
          : 1 >= c
          ? 1
          : 2 >= c
          ? 2
          : 5 >= c
          ? 5
          : 10;
      return -20 > b
        ? Number(c * Math.pow(10, b))
        : Number((c * Math.pow(10, b)).toFixed(20));
    };
    z.prototype.getLabelStartPoint = function () {
      var a = Y[this.intervalType + "Duration"] * this.interval,
        a = new Date(Math.floor(this.viewportMinimum / a) * a);
      if ("millisecond" !== this.intervalType)
        if ("second" === this.intervalType)
          0 < a.getMilliseconds() &&
            (a.setSeconds(a.getSeconds() + 1), a.setMilliseconds(0));
        else if ("minute" === this.intervalType) {
          if (0 < a.getSeconds() || 0 < a.getMilliseconds())
            a.setMinutes(a.getMinutes() + 1),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("hour" === this.intervalType) {
          if (
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setHours(a.getHours() + 1),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("day" === this.intervalType) {
          if (
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setDate(a.getDate() + 1),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("week" === this.intervalType) {
          if (
            0 < a.getDay() ||
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setDate(a.getDate() + (7 - a.getDay())),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else if ("month" === this.intervalType) {
          if (
            1 < a.getDate() ||
            0 < a.getHours() ||
            0 < a.getMinutes() ||
            0 < a.getSeconds() ||
            0 < a.getMilliseconds()
          )
            a.setMonth(a.getMonth() + 1),
              a.setDate(1),
              a.setHours(0),
              a.setMinutes(0),
              a.setSeconds(0),
              a.setMilliseconds(0);
        } else
          "year" === this.intervalType &&
            (0 < a.getMonth() ||
              1 < a.getDate() ||
              0 < a.getHours() ||
              0 < a.getMinutes() ||
              0 < a.getSeconds() ||
              0 < a.getMilliseconds()) &&
            (a.setFullYear(a.getFullYear() + 1),
            a.setMonth(0),
            a.setDate(1),
            a.setHours(0),
            a.setMinutes(0),
            a.setSeconds(0),
            a.setMilliseconds(0));
      return a;
    };
    ha(W, Q);
    ha(X, Q);
    X.prototype.createUserOptions = function (a) {
      if ("undefined" !== typeof a || this.options._isPlaceholder) {
        var d = 0;
        this.parent.options._isPlaceholder && this.parent.createUserOptions();
        this.options._isPlaceholder ||
          (Ea(this.parent[this.optionsName]),
          (d = this.parent.options[this.optionsName].indexOf(this.options)));
        this.options = "undefined" === typeof a ? {} : a;
        this.parent.options[this.optionsName][d] = this.options;
      }
    };
    X.prototype.render = function (a) {
      if (
        0 !== this.spacing ||
        (0 !== this.options.lineThickness &&
          ("undefined" !== typeof this.options.lineThickness ||
            0 !== this.parent.lineThickness))
      ) {
        var d = this.ctx,
          b = this.ctx.globalAlpha;
        this.ctx = a || this.ctx;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.rect(
          this.chart.plotArea.x1,
          this.chart.plotArea.y1,
          this.chart.plotArea.width,
          this.chart.plotArea.height
        );
        this.ctx.clip();
        var c = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(
            this.startValue
          ),
          g = this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.endValue);
        this.ctx.strokeStyle = this.lineColor;
        this.ctx.fillStyle = this.color;
        this.ctx.beginPath();
        this.ctx.globalAlpha = 1;
        O(this.id);
        var h, f, k, u, m, n;
        a = Math.max(this.spacing, 3);
        var p = Math.max(0, this.lineThickness);
        this.ctx.lineWidth = p;
        this.ctx.setLineDash && this.ctx.setLineDash(N(this.lineDashType, p));
        if (
          "bottom" === this.scaleBreaks.parent._position ||
          "top" === this.scaleBreaks.parent._position
        )
          if (
            ((c = 1 === p % 2 ? (c.x << 0) + 0.5 : c.x << 0),
            (f = 1 === p % 2 ? (g.x << 0) + 0.5 : g.x << 0),
            "top" === this.scaleBreaks.parent._position
              ? ((g = this.chart.plotArea.y1),
                (k = (this.chart.plotArea.y2 + p / 2 + 0.5) << 0))
              : ((g = this.chart.plotArea.y2),
                (k = (this.chart.plotArea.y1 - p / 2 + 0.5) << 0),
                (a *= -1)),
            (this.bounds = { x1: c - p / 2, y1: g, x2: f + p / 2, y2: k }),
            this.ctx.moveTo(c, g),
            "straight" === this.type ||
              ("top" === this.scaleBreaks.parent._position && 0 >= a) ||
              ("bottom" === this.scaleBreaks.parent._position && 0 <= a))
          )
            this.ctx.lineTo(c, k), this.ctx.lineTo(f, k), this.ctx.lineTo(f, g);
          else if ("wavy" === this.type) {
            u = c;
            m = g;
            h = 0.5;
            n = (k - m) / a / 3;
            for (var q = 0; q < n; q++)
              this.ctx.bezierCurveTo(
                u + h * a,
                m + a,
                u + h * a,
                m + 2 * a,
                u,
                m + 3 * a
              ),
                (m += 3 * a),
                (h *= -1);
            this.ctx.bezierCurveTo(
              u + h * a,
              m + a,
              u + h * a,
              m + 2 * a,
              u,
              m + 3 * a
            );
            u = f;
            h *= -1;
            this.ctx.lineTo(u, m);
            for (q = 0; q < n; q++)
              this.ctx.bezierCurveTo(
                u + h * a,
                m - a,
                u + h * a,
                m - 2 * a,
                u,
                m - 3 * a
              ),
                (m -= 3 * a),
                (h *= -1);
          } else {
            if ("zigzag" === this.type) {
              h = -1;
              m = g + a;
              u = c + a;
              n = (k - m) / a / 2;
              for (q = 0; q < n; q++)
                this.ctx.lineTo(u, m),
                  (u += 2 * h * a),
                  (m += 2 * a),
                  (h *= -1);
              this.ctx.lineTo(u, m);
              u += f - c;
              for (q = 0; q < n + 1; q++)
                this.ctx.lineTo(u, m),
                  (u += 2 * h * a),
                  (m -= 2 * a),
                  (h *= -1);
              this.ctx.lineTo(u + h * a, m + a);
            }
          }
        else if (
          "left" === this.scaleBreaks.parent._position ||
          "right" === this.scaleBreaks.parent._position
        )
          if (
            ((g = 1 === p % 2 ? (g.y << 0) + 0.5 : g.y << 0),
            (k = 1 === p % 2 ? (c.y << 0) + 0.5 : c.y << 0),
            "left" === this.scaleBreaks.parent._position
              ? ((c = this.chart.plotArea.x1),
                (f = (this.chart.plotArea.x2 + p / 2 + 0.5) << 0))
              : ((c = this.chart.plotArea.x2),
                (f = (this.chart.plotArea.x1 - p / 2 + 0.5) << 0),
                (a *= -1)),
            (this.bounds = { x1: c, y1: g - p / 2, x2: f, y2: k + p / 2 }),
            this.ctx.moveTo(c, g),
            "straight" === this.type ||
              ("left" === this.scaleBreaks.parent._position && 0 >= a) ||
              ("right" === this.scaleBreaks.parent._position && 0 <= a))
          )
            this.ctx.lineTo(f, g), this.ctx.lineTo(f, k), this.ctx.lineTo(c, k);
          else if ("wavy" === this.type) {
            u = c;
            m = g;
            h = 0.5;
            n = (f - u) / a / 3;
            for (q = 0; q < n; q++)
              this.ctx.bezierCurveTo(
                u + a,
                m + h * a,
                u + 2 * a,
                m + h * a,
                u + 3 * a,
                m
              ),
                (u += 3 * a),
                (h *= -1);
            this.ctx.bezierCurveTo(
              u + a,
              m + h * a,
              u + 2 * a,
              m + h * a,
              u + 3 * a,
              m
            );
            m = k;
            h *= -1;
            this.ctx.lineTo(u, m);
            for (q = 0; q < n; q++)
              this.ctx.bezierCurveTo(
                u - a,
                m + h * a,
                u - 2 * a,
                m + h * a,
                u - 3 * a,
                m
              ),
                (u -= 3 * a),
                (h *= -1);
          } else if ("zigzag" === this.type) {
            h = 1;
            m = g - a;
            u = c + a;
            n = (f - u) / a / 2;
            for (q = 0; q < n; q++)
              this.ctx.lineTo(u, m), (m += 2 * h * a), (u += 2 * a), (h *= -1);
            this.ctx.lineTo(u, m);
            m += k - g;
            for (q = 0; q < n + 1; q++)
              this.ctx.lineTo(u, m), (m += 2 * h * a), (u -= 2 * a), (h *= -1);
            this.ctx.lineTo(u + a, m + h * a);
          }
        0 < p && this.ctx.stroke();
        this.ctx.closePath();
        this.ctx.globalAlpha = this.fillOpacity;
        this.ctx.globalCompositeOperation = "destination-over";
        this.ctx.fill();
        this.ctx.restore();
        this.ctx.globalAlpha = b;
        this.ctx = d;
      }
    };
    ha(P, Q);
    P.prototype.createUserOptions = function (a) {
      if ("undefined" !== typeof a || this.options._isPlaceholder) {
        var d = 0;
        this.parent.options._isPlaceholder && this.parent.createUserOptions();
        this.options._isPlaceholder ||
          (Ea(this.parent.stripLines),
          (d = this.parent.options.stripLines.indexOf(this.options)));
        this.options = "undefined" === typeof a ? {} : a;
        this.parent.options.stripLines[d] = this.options;
      }
    };
    P.prototype.render = function () {
      this.ctx.save();
      var a = this.parent.getPixelCoordinatesOnAxis(this.value),
        d = Math.abs(
          "pixel" === this._thicknessType
            ? this.thickness
            : Math.abs(
                this.parent.convertValueToPixel(this.endValue) -
                  this.parent.convertValueToPixel(this.startValue)
              )
        );
      if (0 < d) {
        var b = null === this.opacity ? 1 : this.opacity;
        this.ctx.strokeStyle = this.color;
        this.ctx.beginPath();
        var c = this.ctx.globalAlpha;
        this.ctx.globalAlpha = b;
        O(this.id);
        var g, h, f, k;
        this.ctx.lineWidth = d;
        this.ctx.setLineDash && this.ctx.setLineDash(N(this.lineDashType, d));
        if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        )
          (g = h = 1 === this.ctx.lineWidth % 2 ? (a.x << 0) + 0.5 : a.x << 0),
            (f = this.chart.plotArea.y1),
            (k = this.chart.plotArea.y2),
            (this.bounds = { x1: g - d / 2, y1: f, x2: h + d / 2, y2: k });
        else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (f = k = 1 === this.ctx.lineWidth % 2 ? (a.y << 0) + 0.5 : a.y << 0),
            (g = this.chart.plotArea.x1),
            (h = this.chart.plotArea.x2),
            (this.bounds = { x1: g, y1: f - d / 2, x2: h, y2: k + d / 2 });
        this.ctx.moveTo(g, f);
        this.ctx.lineTo(h, k);
        this.ctx.stroke();
        this.ctx.globalAlpha = c;
      }
      this.ctx.restore();
    };
    ha(ea, Q);
    ea.prototype.showAt = function (a) {
      if (!this.enabled) return !1;
      var d = this.chart,
        b = !1;
      d.resetOverlayedCanvas();
      d.clearedOverlayedCanvas = this.parent.type;
      if ("xySwapped" === d.plotInfo.axisPlacement)
        if ("bottom" === this.parent._position)
          for (var c = 0; c < d.axisY.length; c++)
            this.parent === d.axisY[c] &&
              (d.axisY[c]._crosshairValue =
                a >= d.axisY[c].viewportMinimum &&
                a <= d.axisY[c].viewportMaximum
                  ? a
                  : null);
        else if ("top" === this.parent._position)
          for (c = 0; c < d.axisY2.length; c++)
            this.parent === d.axisY2[c] &&
              (d.axisY2[c]._crosshairValue =
                a >= d.axisY2[c].viewportMinimum &&
                a <= d.axisY2[c].viewportMaximum
                  ? a
                  : null);
        else if ("left" === this.parent._position)
          for (c = 0; c < d.axisX.length; c++)
            this.parent === d.axisX[c] &&
              (d.axisX[c]._crosshairValue =
                a >= d.axisX[c].viewportMinimum &&
                a <= d.axisX[c].viewportMaximum
                  ? a
                  : null);
        else {
          if ("right" === this.parent._position)
            for (c = 0; c < d.axisX2.length; c++)
              this.parent === d.axisX2[c] &&
                (d.axisX2[c]._crosshairValue =
                  a >= d.axisX2[c].viewportMinimum &&
                  a <= d.axisX2[c].viewportMaximum
                    ? a
                    : null);
        }
      else if ("bottom" === this.parent._position)
        for (c = 0; c < d.axisX.length; c++)
          this.parent === d.axisX[c] &&
            (d.axisX[c]._crosshairValue =
              a >= d.axisX[c].viewportMinimum && a <= d.axisX[c].viewportMaximum
                ? a
                : null);
      else if ("top" === this.parent._position)
        for (c = 0; c < d.axisX2.length; c++)
          this.parent === d.axisX2[c] &&
            (d.axisX2[c]._crosshairValue =
              a >= d.axisX2[c].viewportMinimum &&
              a <= d.axisX2[c].viewportMaximum
                ? a
                : null);
      else if ("left" === this.parent._position)
        for (c = 0; c < d.axisY.length; c++)
          this.parent === d.axisY[c] &&
            (d.axisY[c]._crosshairValue =
              a >= d.axisY[c].viewportMinimum && a <= d.axisY[c].viewportMaximum
                ? a
                : null);
      else if ("right" === this.parent._position)
        for (c = 0; c < d.axisY2.length; c++)
          this.parent === d.axisY2[c] &&
            (d.axisY2[c]._crosshairValue =
              a >= d.axisY2[c].viewportMinimum &&
              a <= d.axisY2[c].viewportMaximum
                ? a
                : null);
      for (c = 0; c < d.axisX.length; c++)
        (a = d.axisX[c]._crosshairValue),
          d.axisX[c].crosshair &&
            d.axisX[c].crosshair.enabled &&
            !f(a) &&
            a >= d.axisX[c].viewportMinimum &&
            a <= d.axisX[c].viewportMaximum &&
            (d.axisX[c].showCrosshair(a),
            (d.axisX[c].crosshair._updatedValue = a),
            this === d.axisX[c].crosshair && (b = !0));
      for (c = 0; c < d.axisX2.length; c++)
        (a = d.axisX2[c]._crosshairValue),
          d.axisX2[c].crosshair &&
            d.axisX2[c].crosshair.enabled &&
            !f(a) &&
            a >= d.axisX2[c].viewportMinimum &&
            a <= d.axisX2[c].viewportMaximum &&
            (d.axisX2[c].showCrosshair(a),
            (d.axisX2[c].crosshair._updatedValue = a),
            this === d.axisX2[c].crosshair && (b = !0));
      for (c = 0; c < d.axisY.length; c++)
        (a = d.axisY[c]._crosshairValue),
          d.axisY[c].crosshair &&
            d.axisY[c].crosshair.enabled &&
            !f(a) &&
            a >= d.axisY[c].viewportMinimum &&
            a <= d.axisY[c].viewportMaximum &&
            (d.axisY[c].showCrosshair(a),
            (d.axisY[c].crosshair._updatedValue = a),
            this === d.axisY[c].crosshair && (b = !0));
      for (c = 0; c < d.axisY2.length; c++)
        (a = d.axisY2[c]._crosshairValue),
          d.axisY2[c].crosshair &&
            d.axisY2[c].crosshair.enabled &&
            !f(a) &&
            d._crosshairY2Value >= d.axisY2[c].viewportMinimum &&
            d._crosshairY2Value <= d.axisY2[c].viewportMaximum &&
            (d.axisY2[c].showCrosshair(a),
            (d.axisY2[c].crosshair._updatedValue = a),
            this === d.axisY2[c].crosshair && (b = !0));
      this.chart.toolTip &&
        this.chart.toolTip._entries &&
        this.chart.toolTip.highlightObjects(this.chart.toolTip._entries);
      return b;
    };
    ea.prototype.hide = function () {
      this.chart.resetOverlayedCanvas();
      this.chart.renderCrosshairs(this.parent);
      this._hidden = !0;
    };
    ea.prototype.render = function (a, d, b) {
      var c,
        g,
        h,
        k,
        u = null,
        x = null,
        m = null,
        n = "";
      if (!this.valueFormatString)
        if ("dateTime" === this.parent.valueType)
          this.valueFormatString = this.parent.valueFormatString;
        else {
          var p = 0,
            p =
              "xySwapped" === this.chart.plotInfo.axisPlacement
                ? 50 < this.parent.range
                  ? 0
                  : 500 < this.chart.width && 25 > this.parent.range
                  ? 2
                  : Math.floor(
                      Math.abs(Math.log(this.parent.range) / Math.LN10)
                    ) +
                    (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0)
                : 50 < this.parent.range
                ? 0
                : Math.floor(
                    Math.abs(Math.log(this.parent.range) / Math.LN10)
                  ) +
                  (5 > this.parent.range ? 2 : 10 > this.parent.range ? 1 : 0);
          this.valueFormatString = z.generateValueFormatString(
            this.parent.range,
            p
          );
        }
      var m = null === this.opacity ? 1 : this.opacity,
        p = Math.abs(
          "pixel" === this._thicknessType
            ? this.thickness
            : this.parent.conversionParameters.pixelPerUnit * this.thickness
        ),
        q = this.chart.overlaidCanvasCtx,
        l = q.globalAlpha;
      q.globalAlpha = m;
      q.beginPath();
      q.strokeStyle = this.color;
      q.lineWidth = p;
      q.save();
      this.labelFontSize = Math.abs(
        f(this.options.labelFontSize)
          ? this.parent.labelFontSize
          : this.labelFontSize
      );
      this.labelMaxWidth = f(this.options.labelMaxWidth)
        ? 0.3 * this.chart.width
        : this.labelMaxWidth;
      this.labelMaxHeight =
        f(this.options.labelWrap) || this.labelWrap
          ? 0.3 * this.chart.height
          : 2 * this.labelFontSize;
      0 < p && q.setLineDash && q.setLineDash(N(this.lineDashType, p));
      m = new na(q, {
        x: 0,
        y: 0,
        padding: { top: 2, right: 3, bottom: 2, left: 4 },
        backgroundColor: this.labelBackgroundColor,
        borderColor: this.labelBorderColor,
        borderThickness: this.labelBorderThickness,
        cornerRadius: this.labelCornerRadius,
        maxWidth: this.labelMaxWidth,
        maxHeight: this.labelMaxHeight,
        angle: this.labelAngle,
        text: n,
        horizontalAlign: "left",
        fontSize: this.labelFontSize,
        fontFamily: this.labelFontFamily,
        fontWeight: this.labelFontWeight,
        fontColor: this.labelFontColor,
        fontStyle: this.labelFontStyle,
        textBaseline: "middle",
      });
      if (this.snapToDataPoint) {
        var r = 0,
          n = [];
        if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
          var t = null;
          if (
            "bottom" === this.parent._position ||
            "top" === this.parent._position
          )
            r = this.parent.dataSeries[0].axisX.convertPixelToValue({ y: d });
          else if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          )
            r = this.parent.convertPixelToValue({ y: d });
          for (var v = 0; v < this.parent.dataSeries.length; v++)
            (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
              0 <= t.index &&
              ((t.dataSeries = this.parent.dataSeries[v]),
              null !== t.dataPoint.y && t.dataSeries.visible && n.push(t));
          t = null;
          if (0 === n.length) return;
          n.sort(function (a, b) {
            return a.distance - b.distance;
          });
          t = Math.abs(a - this.parent.convertValueToPixel(n[0].dataPoint.y));
          v = 0;
          if (
            "rangeBar" === n[0].dataSeries.type ||
            "error" === n[0].dataSeries.type
          )
            for (
              var t = Math.abs(
                  a - this.parent.convertValueToPixel(n[v].dataPoint.y[0])
                ),
                w = 0,
                r = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (var s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    a - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (w = Math.abs(
                  a - this.parent.convertValueToPixel(n[r].dataPoint.y)
                )),
                  w < t && ((t = w), (v = r));
          else if ("stackedBar" === n[0].dataSeries.type)
            for (
              var t = Math.abs(
                  a - this.parent.convertValueToPixel(n[0].dataPoint.y)
                ),
                y = (w = 0),
                r = (v = 0);
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    a - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (y += n[r].dataPoint.y),
                  (w = Math.abs(a - this.parent.convertValueToPixel(y))),
                  w < t && ((t = w), (v = r));
          else if ("stackedBar100" === n[0].dataSeries.type)
            for (
              var t = Math.abs(
                  a - this.parent.convertValueToPixel(n[0].dataPoint.y)
                ),
                B = (y = w = 0),
                r = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    a - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (y += n[r].dataPoint.y),
                  (B = n[r].dataPoint.x.getTime
                    ? n[r].dataPoint.x.getTime()
                    : n[r].dataPoint.x),
                  (B = 100 * (y / n[r].dataSeries.plotUnit.dataPointYSums[B])),
                  (w = Math.abs(a - this.parent.convertValueToPixel(B))),
                  w < t && ((t = w), (v = r));
          else
            for (
              t = Math.abs(
                a - this.parent.convertValueToPixel(n[0].dataPoint.y)
              ),
                r = v = w = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    a - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (w = Math.abs(
                  a - this.parent.convertValueToPixel(n[r].dataPoint.y)
                )),
                  w < t && ((t = w), (v = r));
          s = n[v];
          if (
            "bottom" === this.parent._position ||
            "top" === this.parent._position
          ) {
            c = 0;
            if (
              "rangeBar" === this.parent.dataSeries[v].type ||
              "error" === this.parent.dataSeries[v].type
            ) {
              t = Math.abs(
                a - this.parent.convertValueToPixel(s.dataPoint.y[0])
              );
              for (r = w = 0; r < s.dataPoint.y.length; r++)
                (w = Math.abs(
                  a - this.parent.convertValueToPixel(s.dataPoint.y[r])
                )),
                  w < t && ((t = w), (c = r));
              u =
                1 === q.lineWidth % 2
                  ? (this.parent.convertValueToPixel(s.dataPoint.y[c]) << 0) +
                    0.5
                  : this.parent.convertValueToPixel(s.dataPoint.y[c]) << 0;
              this.value = s.dataPoint.y[c];
              m.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: b ? b : s.dataPoint.y[c],
                  })
                : f(this.options.label)
                ? $(
                    b ? b : s.dataPoint.y[c],
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label;
            } else if ("stackedBar" === this.parent.dataSeries[v].type) {
              t = Math.abs(
                a - this.parent.convertValueToPixel(n[0].dataPoint.y)
              );
              y = w = 0;
              for (r = v; 0 <= r; r--)
                (y += n[r].dataPoint.y),
                  (w = Math.abs(a - this.parent.convertValueToPixel(y))),
                  w < t && ((t = w), (c = r));
              u =
                1 === q.lineWidth % 2
                  ? (this.parent.convertValueToPixel(y) << 0) + 0.5
                  : this.parent.convertValueToPixel(y) << 0;
              this.value = y;
              m.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: b ? b : s.dataPoint.y,
                  })
                : f(this.options.label)
                ? $(
                    b ? b : s.dataPoint.y,
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label;
            } else if ("stackedBar100" === this.parent.dataSeries[v].type) {
              t = Math.abs(
                a - this.parent.convertValueToPixel(n[0].dataPoint.y)
              );
              B = y = w = 0;
              for (r = v; 0 <= r; r--)
                (y += n[r].dataPoint.y),
                  (B = n[r].dataPoint.x.getTime
                    ? n[r].dataPoint.x.getTime()
                    : n[r].dataPoint.x),
                  (B = 100 * (y / n[r].dataSeries.plotUnit.dataPointYSums[B])),
                  (w = Math.abs(a - this.parent.convertValueToPixel(B))),
                  w < t && ((t = w), (c = r));
              u =
                1 === q.lineWidth % 2
                  ? (this.parent.convertValueToPixel(B) << 0) + 0.5
                  : this.parent.convertValueToPixel(B) << 0;
              this.value = B;
              m.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: b ? b : B,
                  })
                : f(this.options.label)
                ? $(b ? b : B, this.valueFormatString, this.chart._cultureInfo)
                : this.label;
            } else
              (u =
                1 === q.lineWidth % 2
                  ? (this.parent.convertValueToPixel(s.dataPoint.y) << 0) + 0.5
                  : this.parent.convertValueToPixel(s.dataPoint.y) << 0),
                (this.value = s.dataPoint.y),
                (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: b ? b : s.dataPoint.y,
                    })
                  : f(this.options.label)
                  ? $(
                      b ? b : s.dataPoint.y,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
            c = g = u;
            h = this.chart.plotArea.y1;
            k = this.chart.plotArea.y2;
            this.bounds = { x1: c - p / 2, y1: h, x2: g + p / 2, y2: k };
            m.x = c - m.measureText().width / 2;
            m.x + m.width > this.chart.bounds.x2
              ? (m.x = this.chart.bounds.x2 - m.width)
              : m.x < this.chart.bounds.x1 && (m.x = this.chart.bounds.x1);
            m.y =
              this.parent.lineCoordinates.y2 +
              ("top" === this.parent._position
                ? -m.height + this.parent.tickLength
                : m.fontSize / 2) +
              2;
            m.y + m.height > this.chart.bounds.y2
              ? (m.y = this.chart.bounds.y2 - m.height)
              : m.y < this.chart.bounds.y1 && (m.y = this.chart.bounds.y1);
          } else if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          ) {
            h =
              k =
              x =
                1 === q.lineWidth % 2
                  ? (this.parent.convertValueToPixel(s.dataPoint.x) << 0) + 0.5
                  : this.parent.convertValueToPixel(s.dataPoint.x) << 0;
            c = this.chart.plotArea.x1;
            g = this.chart.plotArea.x2;
            this.bounds = { x1: c, y1: h - p / 2, x2: g, y2: k + p / 2 };
            B = !1;
            if (this.parent.labels)
              for (
                n = Math.ceil(this.parent.interval), r = 0;
                r < this.parent.viewportMaximum;
                r += n
              )
                if (this.parent.labels[r]) B = !0;
                else {
                  B = !1;
                  break;
                }
            if (B) {
              if ("axisX" === this.parent.type)
                for (
                  r = this.parent.convertPixelToValue({ y: d }),
                    t = null,
                    v = 0;
                  v < this.parent.dataSeries.length;
                  v++
                )
                  (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
                    0 <= t.index &&
                    (m.text = this.labelFormatter
                      ? this.labelFormatter({
                          chart: this.chart,
                          axis: this.parent.options,
                          crosshair: this.options,
                          value: s.dataPoint.x,
                        })
                      : f(this.options.label)
                      ? t.dataPoint.label
                      : this.label);
            } else
              "dateTime" === this.parent.valueType
                ? (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: b ? b : s.dataPoint.x,
                      })
                    : f(this.options.label)
                    ? oa(
                        b ? b : s.dataPoint.x,
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label)
                : "number" === this.parent.valueType &&
                  (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: b ? b : s.dataPoint.x,
                      })
                    : f(this.options.label)
                    ? $(
                        b ? b : s.dataPoint.x,
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label);
            this.value = s.dataPoint.x;
            m.y = k + m.fontSize / 2 - m.measureText().height / 2 + 2;
            m.y - m.fontSize / 2 < this.chart.bounds.y1
              ? (m.y = this.chart.bounds.y1 + m.fontSize / 2 + 2)
              : m.y + m.measureText().height - m.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (m.y =
                  this.chart.bounds.y2 -
                  m.measureText().height +
                  m.fontSize / 2);
            "left" === this.parent._position
              ? (m.x = this.parent.lineCoordinates.x2 - m.measureText().width)
              : "right" === this.parent._position &&
                (m.x = this.parent.lineCoordinates.x2);
          }
        } else if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        ) {
          r = this.parent.convertPixelToValue({ x: a });
          for (v = 0; v < this.parent.dataSeries.length; v++)
            (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
              0 <= t.index &&
              ((t.dataSeries = this.parent.dataSeries[v]),
              null !== t.dataPoint.y && t.dataSeries.visible && n.push(t));
          if (0 === n.length) return;
          n.sort(function (a, b) {
            return a.distance - b.distance;
          });
          s = n[0];
          c =
            g =
            u =
              1 === q.lineWidth % 2
                ? (this.parent.convertValueToPixel(s.dataPoint.x) << 0) + 0.5
                : this.parent.convertValueToPixel(s.dataPoint.x) << 0;
          h = this.chart.plotArea.y1;
          k = this.chart.plotArea.y2;
          this.bounds = { x1: c - p / 2, y1: h, x2: g + p / 2, y2: k };
          B = !1;
          if (this.parent.labels)
            for (
              n = Math.ceil(this.parent.interval), r = 0;
              r < this.parent.viewportMaximum;
              r += n
            )
              if (this.parent.labels[r]) B = !0;
              else {
                B = !1;
                break;
              }
          if (B) {
            if ("axisX" === this.parent.type)
              for (
                r = this.parent.convertPixelToValue({ x: a }), t = null, v = 0;
                v < this.parent.dataSeries.length;
                v++
              )
                (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
                  0 <= t.index &&
                  (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: s.dataPoint.x,
                      })
                    : f(this.options.label)
                    ? t.dataPoint.label
                    : this.label);
          } else
            "dateTime" === this.parent.valueType
              ? (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: s.dataPoint.x,
                    })
                  : f(this.options.label)
                  ? oa(
                      b ? b : s.dataPoint.x,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label)
              : "number" === this.parent.valueType &&
                (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: s.dataPoint.x,
                    })
                  : f(this.options.label)
                  ? $(
                      b ? b : s.dataPoint.x,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
          this.value = s.dataPoint.x;
          m.x = c - m.measureText().width / 2;
          m.x + m.width > this.chart.bounds.x2 &&
            (m.x = this.chart.bounds.x2 - m.width);
          m.x < this.chart.bounds.x1 && (m.x = this.chart.bounds.x1);
          "bottom" === this.parent._position
            ? (m.y = this.parent.lineCoordinates.y2 + m.fontSize / 2 + 2)
            : "top" === this.parent._position &&
              (m.y =
                this.parent.lineCoordinates.y1 - m.height + m.fontSize / 2 + 2);
        } else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        ) {
          !f(this.parent.dataSeries) &&
            0 < this.parent.dataSeries.length &&
            (r = this.parent.dataSeries[0].axisX.convertPixelToValue({ x: a }));
          for (v = 0; v < this.parent.dataSeries.length; v++)
            (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
              0 <= t.index &&
              ((t.dataSeries = this.parent.dataSeries[v]),
              null !== t.dataPoint.y && t.dataSeries.visible && n.push(t));
          if (0 === n.length) return;
          n.sort(function (a, b) {
            return a.distance - b.distance;
          });
          v = 0;
          if (
            "rangeColumn" === n[0].dataSeries.type ||
            "rangeArea" === n[0].dataSeries.type ||
            "error" === n[0].dataSeries.type ||
            "rangeSplineArea" === n[0].dataSeries.type ||
            "candlestick" === n[0].dataSeries.type ||
            "ohlc" === n[0].dataSeries.type ||
            "boxAndWhisker" === n[0].dataSeries.type
          )
            for (
              t = Math.abs(
                d - this.parent.convertValueToPixel(n[0].dataPoint.y[0])
              ),
                r = w = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    d - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (w = Math.abs(
                  d - this.parent.convertValueToPixel(n[r].dataPoint.y)
                )),
                  w < t && ((t = w), (v = r));
          else if (
            "stackedColumn" === n[0].dataSeries.type ||
            "stackedArea" === n[0].dataSeries.type
          )
            for (
              t = Math.abs(
                d - this.parent.convertValueToPixel(n[0].dataPoint.y)
              ),
                r = y = w = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    d - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (y += n[r].dataPoint.y),
                  (w = Math.abs(d - this.parent.convertValueToPixel(y))),
                  w < t && ((t = w), (v = r));
          else if (
            "stackedColumn100" === n[0].dataSeries.type ||
            "stackedArea100" === n[0].dataSeries.type
          )
            for (
              t = Math.abs(
                d - this.parent.convertValueToPixel(n[0].dataPoint.y)
              ),
                r = B = y = w = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    d - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (y += n[r].dataPoint.y),
                  (B = n[r].dataPoint.x.getTime
                    ? n[r].dataPoint.x.getTime()
                    : n[r].dataPoint.x),
                  (B = 100 * (y / n[r].dataSeries.plotUnit.dataPointYSums[B])),
                  (w = Math.abs(d - this.parent.convertValueToPixel(B))),
                  w < t && ((t = w), (v = r));
          else
            for (
              t = Math.abs(
                d - this.parent.convertValueToPixel(n[0].dataPoint.y)
              ),
                r = w = 0;
              r < n.length;
              r++
            )
              if (n[r].dataPoint.y && n[r].dataPoint.y.length)
                for (s = 0; s < n[r].dataPoint.y.length; s++)
                  (w = Math.abs(
                    d - this.parent.convertValueToPixel(n[r].dataPoint.y[s])
                  )),
                    w < t && ((t = w), (v = r));
              else
                (w = Math.abs(
                  d - this.parent.convertValueToPixel(n[r].dataPoint.y)
                )),
                  w < t && ((t = w), (v = r));
          s = n[v];
          c = 0;
          if (
            "rangeColumn" === this.parent.dataSeries[v].type ||
            "rangeArea" === this.parent.dataSeries[v].type ||
            "error" === this.parent.dataSeries[v].type ||
            "rangeSplineArea" === this.parent.dataSeries[v].type ||
            "candlestick" === this.parent.dataSeries[v].type ||
            "ohlc" === this.parent.dataSeries[v].type ||
            "boxAndWhisker" === this.parent.dataSeries[v].type
          ) {
            t = Math.abs(d - this.parent.convertValueToPixel(s.dataPoint.y[0]));
            for (r = w = 0; r < s.dataPoint.y.length; r++)
              (w = Math.abs(
                d - this.parent.convertValueToPixel(s.dataPoint.y[r])
              )),
                w < t && ((t = w), (c = r));
            x =
              1 === q.lineWidth % 2
                ? (this.parent.convertValueToPixel(s.dataPoint.y[c]) << 0) + 0.5
                : this.parent.convertValueToPixel(s.dataPoint.y[c]) << 0;
            m.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: b ? b : s.dataPoint.y[c],
                })
              : f(this.options.label)
              ? $(
                  b ? b : s.dataPoint.y[c],
                  this.valueFormatString,
                  this.chart._cultureInfo
                )
              : this.label;
            this.value = s.dataPoint.y[c];
          } else if (
            "stackedColumn" === this.parent.dataSeries[v].type ||
            "stackedArea" === this.parent.dataSeries[v].type
          ) {
            t = Math.abs(d - this.parent.convertValueToPixel(n[0].dataPoint.y));
            y = w = 0;
            for (r = v; 0 <= r; r--)
              (y += n[r].dataPoint.y),
                (w = Math.abs(d - this.parent.convertValueToPixel(y))),
                w < t && ((t = w), (c = r));
            x =
              1 === q.lineWidth % 2
                ? (this.parent.convertValueToPixel(y) << 0) + 0.5
                : this.parent.convertValueToPixel(y) << 0;
            m.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: b ? b : s.dataPoint.y,
                })
              : f(this.options.label)
              ? $(
                  b ? b : s.dataPoint.y,
                  this.valueFormatString,
                  this.chart._cultureInfo
                )
              : this.label;
            this.value = y;
          } else if (
            "stackedColumn100" === this.parent.dataSeries[v].type ||
            "stackedArea100" === this.parent.dataSeries[v].type
          ) {
            t = Math.abs(d - this.parent.convertValueToPixel(n[0].dataPoint.y));
            y = w = 0;
            for (r = v; 0 <= r; r--)
              (y += n[r].dataPoint.y),
                (B = n[r].dataPoint.x.getTime
                  ? n[r].dataPoint.x.getTime()
                  : n[r].dataPoint.x),
                (B = 100 * (y / n[r].dataSeries.plotUnit.dataPointYSums[B])),
                (w = Math.abs(d - this.parent.convertValueToPixel(B))),
                w < t && ((t = w), (c = r));
            x =
              1 === q.lineWidth % 2
                ? (this.parent.convertValueToPixel(B) << 0) + 0.5
                : this.parent.convertValueToPixel(B) << 0;
            m.text = this.labelFormatter
              ? this.labelFormatter({
                  chart: this.chart,
                  axis: this.parent.options,
                  crosshair: this.options,
                  value: b ? b : B,
                })
              : f(this.options.label)
              ? $(b ? b : B, this.valueFormatString, this.chart._cultureInfo)
              : this.label;
            this.value = B;
          } else
            "waterfall" === this.parent.dataSeries[v].type
              ? ((x =
                  1 === q.lineWidth % 2
                    ? (this.parent.convertValueToPixel(
                        s.dataSeries.dataPointEOs[s.index].cumulativeSum
                      ) <<
                        0) +
                      0.5
                    : this.parent.convertValueToPixel(
                        s.dataSeries.dataPointEOs[s.index].cumulativeSum
                      ) << 0),
                (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: b
                        ? b
                        : s.dataSeries.dataPointEOs[s.index].cumulativeSum,
                    })
                  : f(this.options.label)
                  ? $(
                      b ? b : s.dataSeries.dataPointEOs[s.index].cumulativeSum,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label),
                (this.value = s.dataSeries.dataPointEOs[s.index].cumulativeSum))
              : ((x =
                  1 === q.lineWidth % 2
                    ? (f(a)
                        ? d
                        : this.parent.convertValueToPixel(s.dataPoint.y) << 0) +
                      0.5
                    : f(a)
                    ? d
                    : this.parent.convertValueToPixel(s.dataPoint.y) << 0),
                (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: s.dataPoint.y,
                    })
                  : f(this.options.label)
                  ? $(
                      b ? b : s.dataPoint.y,
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label),
                (this.value = s.dataPoint.y));
          h = k = x;
          c = this.chart.plotArea.x1;
          g = this.chart.plotArea.x2;
          this.bounds = { x1: c, y1: h - p / 2, x2: g, y2: k + p / 2 };
          m.y = k + m.fontSize / 2 - m.measureText().height / 2 + 2;
          m.y - m.fontSize / 2 < this.chart.bounds.y1
            ? (m.y = this.chart.bounds.y1 + m.fontSize / 2 + 2)
            : m.y + m.measureText().height - m.fontSize / 2 >
                this.chart.bounds.y2 &&
              (m.y =
                this.chart.bounds.y2 - m.measureText().height + m.fontSize / 2);
          "left" === this.parent._position
            ? (m.x = this.parent.lineCoordinates.x2 - m.measureText().width)
            : "right" === this.parent._position &&
              (m.x = this.parent.lineCoordinates.x2);
        }
        n = null;
        if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        )
          "top" === this.parent._position &&
            m.y - m.fontSize / 2 < this.chart.bounds.y1 &&
            (m.y = this.chart.bounds.y1 + m.fontSize / 2),
            "bottom" === this.parent._position &&
              this.parent.lineCoordinates.y2 -
                m.fontSize / 2 +
                m.measureText().height >
                this.chart.bounds.y2 &&
              (m.y = this.chart.bounds.y2 - m.height + m.fontSize / 2 + 2),
            c >=
              this.parent.convertValueToPixel(
                this.parent.reversed
                  ? this.parent.viewportMaximum
                  : this.parent.viewportMinimum
              ) &&
              g <=
                this.parent.convertValueToPixel(
                  this.parent.reversed
                    ? this.parent.viewportMinimum
                    : this.parent.viewportMaximum
                ) &&
              (0 < p &&
                (q.moveTo(c, h),
                q.lineTo(g, k),
                q.stroke(),
                (this._hidden = !1)),
              q.restore(),
              !f(m.text) &&
                ("number" === typeof m.text.valueOf() || 0 < m.text.length) &&
                m.render(!0));
        if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          "left" === this.parent._position &&
            m.x < this.chart.bounds.x1 &&
            (m.x = this.chart.bounds.x1),
            "right" === this.parent._position &&
              m.x + m.measureText().width > this.chart.bounds.x2 &&
              (m.x = this.chart.bounds.x2 - m.measureText().width),
            k >=
              this.parent.convertValueToPixel(
                this.parent.reversed
                  ? this.parent.viewportMinimum
                  : this.parent.viewportMaximum
              ) &&
              h <=
                this.parent.convertValueToPixel(
                  this.parent.reversed
                    ? this.parent.viewportMaximum
                    : this.parent.viewportMinimum
                ) &&
              (0 < p &&
                (q.moveTo(c, h),
                q.lineTo(g, k),
                q.stroke(),
                (this._hidden = !1)),
              q.restore(),
              !f(m.text) &&
                ("number" === typeof m.text.valueOf() || 0 < m.text.length) &&
                m.render(!0));
      } else {
        if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        )
          (c = g = u = 1 === q.lineWidth % 2 ? (a << 0) + 0.5 : a << 0),
            (h = this.chart.plotArea.y1),
            (k = this.chart.plotArea.y2),
            (this.bounds = { x1: c - p / 2, y1: h, x2: g + p / 2, y2: k });
        else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (h = k = x = 1 === q.lineWidth % 2 ? (d << 0) + 0.5 : d << 0),
            (c = this.chart.plotArea.x1),
            (g = this.chart.plotArea.x2),
            (this.bounds = { x1: c, y1: h - p / 2, x2: g, y2: k + p / 2 });
        if ("xySwapped" === this.chart.plotInfo.axisPlacement)
          if (
            "left" === this.parent._position ||
            "right" === this.parent._position
          ) {
            B = !1;
            if (this.parent.labels)
              for (
                n = Math.ceil(this.parent.interval), r = 0;
                r < this.parent.viewportMaximum;
                r += n
              )
                if (this.parent.labels[r]) B = !0;
                else {
                  B = !1;
                  break;
                }
            if (B) {
              if ("axisX" === this.parent.type)
                for (
                  r = this.parent.convertPixelToValue({ y: d }),
                    t = null,
                    v = 0;
                  v < this.parent.dataSeries.length;
                  v++
                )
                  (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
                    0 <= t.index &&
                    (m.text = this.labelFormatter
                      ? this.labelFormatter({
                          chart: this.chart,
                          axis: this.parent.options,
                          crosshair: this.options,
                          value: b ? b : this.parent.convertPixelToValue(a),
                        })
                      : f(this.options.label)
                      ? t.dataPoint.label
                      : this.label);
            } else
              "dateTime" === this.parent.valueType
                ? (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: b ? b : this.parent.convertPixelToValue(d),
                      })
                    : f(this.options.label)
                    ? oa(
                        b ? b : this.parent.convertPixelToValue(d),
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label)
                : "number" === this.parent.valueType &&
                  (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: b ? b : this.parent.convertPixelToValue(d),
                      })
                    : f(this.options.label)
                    ? $(
                        b ? b : this.parent.convertPixelToValue(d),
                        this.valueFormatString,
                        this.chart._cultureInfo
                      )
                    : this.label);
            m.y = d + m.fontSize / 2 - m.measureText().height / 2 + 2;
            m.y - m.fontSize / 2 < this.chart.bounds.y1
              ? (m.y = this.chart.bounds.y1 + m.fontSize / 2 + 2)
              : m.y + m.measureText().height - m.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (m.y =
                  this.chart.bounds.y2 -
                  m.measureText().height +
                  m.fontSize / 2);
            "left" === this.parent._position
              ? (m.x = this.parent.lineCoordinates.x1 - m.measureText().width)
              : "right" === this.parent._position &&
                (m.x = this.parent.lineCoordinates.x2);
          } else {
            if (
              "bottom" === this.parent._position ||
              "top" === this.parent._position
            )
              (m.text = this.labelFormatter
                ? this.labelFormatter({
                    chart: this.chart,
                    axis: this.parent.options,
                    crosshair: this.options,
                    value: b ? b : this.parent.convertPixelToValue(a),
                  })
                : f(this.options.label)
                ? $(
                    b ? b : this.parent.convertPixelToValue(a),
                    this.valueFormatString,
                    this.chart._cultureInfo
                  )
                : this.label),
                (m.x = c - m.measureText().width / 2),
                m.x + m.width > this.chart.bounds.x2 &&
                  (m.x = this.chart.bounds.x2 - m.width),
                m.x < this.chart.bounds.x1 && (m.x = this.chart.bounds.x1),
                "bottom" === this.parent._position
                  ? (m.y = this.parent.lineCoordinates.y2 + m.fontSize / 2 + 2)
                  : "top" === this.parent._position &&
                    (m.y =
                      this.parent.lineCoordinates.y1 -
                      m.height +
                      m.fontSize / 2 +
                      2);
          }
        else if (
          "bottom" === this.parent._position ||
          "top" === this.parent._position
        ) {
          B = !1;
          n = "";
          if (this.parent.labels)
            for (
              n = Math.ceil(this.parent.interval), r = 0;
              r < this.parent.viewportMaximum;
              r += n
            )
              if (this.parent.labels[r]) B = !0;
              else {
                B = !1;
                break;
              }
          if (B) {
            if ("axisX" === this.parent.type)
              for (
                r = this.parent.convertPixelToValue({ x: a }), t = null, v = 0;
                v < this.parent.dataSeries.length;
                v++
              )
                (t = this.parent.dataSeries[v].getDataPointAtX(r, !0)) &&
                  0 <= t.index &&
                  (m.text = this.labelFormatter
                    ? this.labelFormatter({
                        chart: this.chart,
                        axis: this.parent.options,
                        crosshair: this.options,
                        value: b ? b : this.parent.convertPixelToValue(a),
                      })
                    : f(this.options.label)
                    ? b
                      ? b
                      : t.dataPoint.label
                    : this.label);
          } else
            "dateTime" === this.parent.valueType
              ? (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: b ? b : this.parent.convertPixelToValue(a),
                    })
                  : f(this.options.label)
                  ? oa(
                      b ? b : this.parent.convertPixelToValue(a),
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label)
              : "number" === this.parent.valueType &&
                (m.text = this.labelFormatter
                  ? this.labelFormatter({
                      chart: this.chart,
                      axis: this.parent.options,
                      crosshair: this.options,
                      value: b
                        ? b
                        : 0 < this.parent.dataSeries.length
                        ? this.parent.convertPixelToValue(a)
                        : "",
                    })
                  : f(this.options.label)
                  ? $(
                      b ? b : this.parent.convertPixelToValue(a),
                      this.valueFormatString,
                      this.chart._cultureInfo
                    )
                  : this.label);
          m.x = c - m.measureText().width / 2;
          m.x + m.width > this.chart.bounds.x2 &&
            (m.x = this.chart.bounds.x2 - m.width);
          m.x < this.chart.bounds.x1 && (m.x = this.chart.bounds.x1);
          "bottom" === this.parent._position
            ? (m.y = this.parent.lineCoordinates.y2 + m.fontSize / 2 + 2)
            : "top" === this.parent._position &&
              (m.y =
                this.parent.lineCoordinates.y1 - m.height + m.fontSize / 2 + 2);
        } else if (
          "left" === this.parent._position ||
          "right" === this.parent._position
        )
          (m.text = this.labelFormatter
            ? this.labelFormatter({
                chart: this.chart,
                axis: this.parent.options,
                crosshair: this.options,
                value: b ? b : this.parent.convertPixelToValue(d),
              })
            : f(this.options.label)
            ? $(
                b ? b : this.parent.convertPixelToValue(d),
                this.valueFormatString,
                this.chart._cultureInfo
              )
            : this.label),
            (m.y = d + m.fontSize / 2 - m.measureText().height / 2 + 2),
            m.y - m.fontSize / 2 < this.chart.bounds.y1
              ? (m.y = this.chart.bounds.y1 + m.fontSize / 2 + 2)
              : m.y + m.measureText().height - m.fontSize / 2 >
                  this.chart.bounds.y2 &&
                (m.y =
                  this.chart.bounds.y2 -
                  m.measureText().height +
                  m.fontSize / 2),
            "left" === this.parent._position
              ? (m.x = this.parent.lineCoordinates.x2 - m.measureText().width)
              : "right" === this.parent._position &&
                (m.x = this.parent.lineCoordinates.x2);
        "left" === this.parent._position && m.x < this.chart.bounds.x1
          ? (m.x = this.chart.bounds.x1)
          : "right" === this.parent._position &&
            m.x + m.measureText().width > this.chart.bounds.x2
          ? (m.x = this.chart.bounds.x2 - m.measureText().width)
          : "top" === this.parent._position &&
            m.y - m.fontSize / 2 < this.chart.bounds.y1
          ? (m.y = this.chart.bounds.y1 + m.fontSize / 2)
          : "bottom" === this.parent._position &&
            this.parent.lineCoordinates.y2 -
              m.fontSize / 2 +
              m.measureText().height >
              this.chart.bounds.y2 &&
            (m.y = this.chart.bounds.y2 - m.height + m.fontSize / 2 + 2);
        0 < p &&
          (q.moveTo(c, h), q.lineTo(g, k), q.stroke(), (this._hidden = !1));
        q.restore();
        !f(m.text) &&
          ("number" === typeof m.text.valueOf() || 0 < m.text.length) &&
          m.render(!0);
        this.value =
          "bottom" === this.parent._position || "top" === this.parent._position
            ? this.parent.convertPixelToValue(a)
            : this.parent.convertPixelToValue(d);
      }
      if ("bottom" === this.parent._position || "top" === this.parent._position)
        this._updatedValue = this.parent.convertPixelToValue(u);
      if ("left" === this.parent._position || "right" === this.parent._position)
        this._updatedValue = this.parent.convertPixelToValue(x);
      q.globalAlpha = l;
    };
    ha(aa, Q);
    aa.prototype._initialize = function () {
      this.updateOption("updated");
      this.updateOption("hidden");
      if (this.enabled) {
        this.container = document.createElement("div");
        this.container.setAttribute("class", "canvasjs-chart-tooltip");
        this.container.style.position = "absolute";
        this.container.style.height = "auto";
        this.container.style.boxShadow = "1px 1px 2px 2px rgba(0,0,0,0.1)";
        this.container.style.zIndex = "1000";
        this.container.style.pointerEvents = "none";
        this.container.style.display = "none";
        var a;
        a = '<div style=" width: auto;height: auto;min-width: 50px;';
        a += "line-height: auto;";
        a += "margin: 0px 0px 0px 0px;";
        a += "padding: 5px;";
        a += "font-family: Calibri, Arial, Georgia, serif;";
        a += "font-weight: normal;";
        a += "font-style: " + (v ? "italic;" : "normal;");
        a += "font-size: 14px;";
        a += "color: #000000;";
        a += "text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";
        a += "text-align: left;";
        a += "border: 2px solid gray;";
        a += v
          ? "background: rgba(255,255,255,.9);"
          : "background: rgb(255,255,255);";
        a += "text-indent: 0px;";
        a += "white-space: nowrap;";
        a += "border-radius: 5px;";
        a += "-moz-user-select:none;";
        a += "-khtml-user-select: none;";
        a += "-webkit-user-select: none;";
        a += "-ms-user-select: none;";
        a += "user-select: none;";
        v ||
          ((a += "filter: alpha(opacity = 90);"),
          (a +=
            "filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');"));
        a += '} "> Sample Tooltip</div>';
        this.container.innerHTML = a;
        this.contentDiv = this.container.firstChild;
        this.container.style.borderRadius = this.contentDiv.style.borderRadius;
        this.chart._canvasJSContainer.appendChild(this.container);
      }
    };
    aa.prototype.mouseMoveHandler = function (a, d) {
      (this._lastUpdated && 4 > new Date().getTime() - this._lastUpdated) ||
        ((this._lastUpdated = new Date().getTime()),
        this.chart.resetOverlayedCanvas(),
        this._updateToolTip(a, d));
    };
    aa.prototype._updateToolTip = function (a, d, b) {
      b = "undefined" === typeof b ? !0 : b;
      this.container || this._initialize();
      this.enabled ||
        (this.hide(),
        this.dispatchEvent(
          "hidden",
          { chart: this.chart, toolTip: this },
          this
        ));
      if (!this.chart.disableToolTip) {
        if ("undefined" === typeof a || "undefined" === typeof d) {
          if (isNaN(this._prevX) || isNaN(this._prevY)) return;
          a = this._prevX;
          d = this._prevY;
        } else (this._prevX = a), (this._prevY = d);
        var c = null,
          g = null,
          h = [],
          k = 0;
        if (
          this.shared &&
          this.enabled &&
          "none" !== this.chart.plotInfo.axisPlacement
        ) {
          if ("xySwapped" === this.chart.plotInfo.axisPlacement) {
            var u = [];
            if (this.chart.axisX)
              for (var x = 0; x < this.chart.axisX.length; x++) {
                for (
                  var k = this.chart.axisX[x].convertPixelToValue({ y: d }),
                    m = null,
                    c = 0;
                  c < this.chart.axisX[x].dataSeries.length;
                  c++
                )
                  (m = this.chart.axisX[x].dataSeries[c].getDataPointAtX(
                    k,
                    b
                  )) &&
                    0 <= m.index &&
                    ((m.dataSeries = this.chart.axisX[x].dataSeries[c]),
                    null !== m.dataPoint.y && u.push(m));
                m = null;
              }
            if (this.chart.axisX2)
              for (x = 0; x < this.chart.axisX2.length; x++) {
                k = this.chart.axisX2[x].convertPixelToValue({ y: d });
                m = null;
                for (c = 0; c < this.chart.axisX2[x].dataSeries.length; c++)
                  (m = this.chart.axisX2[x].dataSeries[c].getDataPointAtX(
                    k,
                    b
                  )) &&
                    0 <= m.index &&
                    ((m.dataSeries = this.chart.axisX2[x].dataSeries[c]),
                    null !== m.dataPoint.y && u.push(m));
                m = null;
              }
          } else {
            u = [];
            if (this.chart.axisX)
              for (x = 0; x < this.chart.axisX.length; x++)
                for (
                  k = this.chart.axisX[x].convertPixelToValue({ x: a }),
                    m = null,
                    c = 0;
                  c < this.chart.axisX[x].dataSeries.length;
                  c++
                )
                  (m = this.chart.axisX[x].dataSeries[c].getDataPointAtX(
                    k,
                    b
                  )) &&
                    0 <= m.index &&
                    ((m.dataSeries = this.chart.axisX[x].dataSeries[c]),
                    null !== m.dataPoint.y && u.push(m));
            if (this.chart.axisX2)
              for (x = 0; x < this.chart.axisX2.length; x++)
                for (
                  k = this.chart.axisX2[x].convertPixelToValue({ x: a }),
                    m = null,
                    c = 0;
                  c < this.chart.axisX2[x].dataSeries.length;
                  c++
                )
                  (m = this.chart.axisX2[x].dataSeries[c].getDataPointAtX(
                    k,
                    b
                  )) &&
                    0 <= m.index &&
                    ((m.dataSeries = this.chart.axisX2[x].dataSeries[c]),
                    null !== m.dataPoint.y && u.push(m));
          }
          if (0 === u.length) return;
          u.sort(function (a, b) {
            return a.distance - b.distance;
          });
          b = u[0];
          for (c = 0; c < u.length; c++)
            u[c].dataPoint.x.valueOf() === b.dataPoint.x.valueOf() &&
              h.push(u[c]);
          u = null;
        } else {
          if ((m = this.chart.getDataPointAtXY(a, d, b)))
            (this.currentDataPointIndex = m.dataPointIndex),
              (this.currentSeriesIndex = m.dataSeries.index);
          else if (v)
            if (
              ((m = kb(a, d, this.chart._eventManager.ghostCtx)),
              0 < m &&
                "undefined" !== typeof this.chart._eventManager.objectMap[m])
            ) {
              m = this.chart._eventManager.objectMap[m];
              if ("legendItem" === m.objectType) return;
              this.currentSeriesIndex = m.dataSeriesIndex;
              this.currentDataPointIndex =
                0 <= m.dataPointIndex ? m.dataPointIndex : -1;
            } else this.currentDataPointIndex = -1;
          else this.currentDataPointIndex = -1;
          if (0 <= this.currentSeriesIndex) {
            g = this.chart.data[this.currentSeriesIndex];
            m = {};
            if (0 <= this.currentDataPointIndex)
              (c = g.dataPoints[this.currentDataPointIndex]),
                (m.dataSeries = g),
                (m.dataPoint = c),
                (m.index = this.currentDataPointIndex),
                (m.distance = Math.abs(c.x - k)),
                "waterfall" === g.type &&
                  ((m.cumulativeSumYStartValue =
                    g.dataPointEOs[
                      this.currentDataPointIndex
                    ].cumulativeSumYStartValue),
                  (m.cumulativeSum =
                    g.dataPointEOs[this.currentDataPointIndex].cumulativeSum));
            else {
              if (
                !this.enabled ||
                ("line" !== g.type &&
                  "stepLine" !== g.type &&
                  "spline" !== g.type &&
                  "area" !== g.type &&
                  "stepArea" !== g.type &&
                  "splineArea" !== g.type &&
                  "stackedArea" !== g.type &&
                  "stackedArea100" !== g.type &&
                  "rangeArea" !== g.type &&
                  "rangeSplineArea" !== g.type &&
                  "candlestick" !== g.type &&
                  "ohlc" !== g.type &&
                  "boxAndWhisker" !== g.type)
              )
                return;
              k = g.axisX.convertPixelToValue({ x: a });
              m = g.getDataPointAtX(k, b);
              f(m) ||
                ((m.dataSeries = g),
                (this.currentDataPointIndex = m.index),
                (c = m.dataPoint));
            }
            if (!f(m) && !f(m.dataPoint) && !f(m.dataPoint.y))
              if (m.dataSeries.axisY)
                if (0 < m.dataPoint.y.length) {
                  for (c = b = 0; c < m.dataPoint.y.length; c++)
                    m.dataPoint.y[c] < m.dataSeries.axisY.viewportMinimum
                      ? b--
                      : m.dataPoint.y[c] > m.dataSeries.axisY.viewportMaximum &&
                        b++;
                  b < m.dataPoint.y.length &&
                    b > -m.dataPoint.y.length &&
                    h.push(m);
                } else
                  "column" === g.type || "bar" === g.type
                    ? 0 > m.dataPoint.y
                      ? 0 > m.dataSeries.axisY.viewportMinimum &&
                        m.dataSeries.axisY.viewportMaximum >= m.dataPoint.y &&
                        h.push(m)
                      : m.dataSeries.axisY.viewportMinimum <= m.dataPoint.y &&
                        0 <= m.dataSeries.axisY.viewportMaximum &&
                        h.push(m)
                    : "bubble" === g.type
                    ? ((b =
                        this.chart._eventManager.objectMap[
                          g.dataPointIds[m.index]
                        ].size / 2),
                      m.dataPoint.y >= m.dataSeries.axisY.viewportMinimum - b &&
                        m.dataPoint.y <=
                          m.dataSeries.axisY.viewportMaximum + b &&
                        h.push(m))
                    : "waterfall" === g.type
                    ? ((b = 0),
                      m.cumulativeSumYStartValue <
                      m.dataSeries.axisY.viewportMinimum
                        ? b--
                        : m.cumulativeSumYStartValue >
                            m.dataSeries.axisY.viewportMaximum && b++,
                      m.cumulativeSum < m.dataSeries.axisY.viewportMinimum
                        ? b--
                        : m.cumulativeSum >
                            m.dataSeries.axisY.viewportMaximum && b++,
                      2 > b && -2 < b && h.push(m))
                    : (0 <= m.dataSeries.type.indexOf("100") ||
                        "stackedColumn" === g.type ||
                        "stackedBar" === g.type ||
                        (m.dataPoint.y >= m.dataSeries.axisY.viewportMinimum &&
                          m.dataPoint.y <=
                            m.dataSeries.axisY.viewportMaximum)) &&
                      h.push(m);
              else h.push(m);
          }
        }
        if (0 < h.length) {
          this.highlightObjects(h);
          if (this.enabled) {
            var n = "",
              n = this.getToolTipInnerHTML({ entries: h });
            if (null !== n) {
              this.contentDiv.innerHTML = n;
              b = !1;
              "none" === this.container.style.display &&
                ((b = !0), (this.container.style.display = "block"));
              try {
                (this.contentDiv.style.background = this.backgroundColor
                  ? this.backgroundColor
                  : v
                  ? "rgba(255,255,255,.9)"
                  : "rgb(255,255,255)"),
                  (this.borderColor =
                    "waterfall" === h[0].dataSeries.type
                      ? (this.contentDiv.style.borderRightColor =
                          this.contentDiv.style.borderLeftColor =
                          this.contentDiv.style.borderColor =
                            this.options.borderColor
                              ? this.options.borderColor
                              : h[0].dataPoint.color
                              ? h[0].dataPoint.color
                              : 0 < h[0].dataPoint.y
                              ? h[0].dataSeries.risingColor
                              : h[0].dataSeries.fallingColor)
                      : "error" === h[0].dataSeries.type
                      ? (this.contentDiv.style.borderRightColor =
                          this.contentDiv.style.borderLeftColor =
                          this.contentDiv.style.borderColor =
                            this.options.borderColor
                              ? this.options.borderColor
                              : h[0].dataSeries.color
                              ? h[0].dataSeries.color
                              : h[0].dataSeries._colorSet[
                                  g.index % h[0].dataSeries._colorSet.length
                                ])
                      : (this.contentDiv.style.borderRightColor =
                          this.contentDiv.style.borderLeftColor =
                          this.contentDiv.style.borderColor =
                            this.options.borderColor
                              ? this.options.borderColor
                              : h[0].dataPoint.color
                              ? h[0].dataPoint.color
                              : h[0].dataSeries.color
                              ? h[0].dataSeries.color
                              : h[0].dataSeries._colorSet[
                                  h[0].index % h[0].dataSeries._colorSet.length
                                ])),
                  (this.contentDiv.style.borderWidth =
                    this.borderThickness || 0 === this.borderThickness
                      ? this.borderThickness + "px"
                      : "2px"),
                  (this.contentDiv.style.borderRadius =
                    this.cornerRadius || 0 === this.cornerRadius
                      ? this.cornerRadius + "px"
                      : "5px"),
                  (this.container.style.borderRadius =
                    this.contentDiv.style.borderRadius),
                  (this.contentDiv.style.fontSize =
                    this.fontSize || 0 === this.fontSize
                      ? this.fontSize + "px"
                      : "14px"),
                  (this.contentDiv.style.color = this.fontColor
                    ? this.fontColor
                    : "#000000"),
                  (this.contentDiv.style.fontFamily = this.fontFamily
                    ? this.fontFamily
                    : "Calibri, Arial, Georgia, serif;"),
                  (this.contentDiv.style.fontWeight = this.fontWeight
                    ? this.fontWeight
                    : "normal"),
                  (this.contentDiv.style.fontStyle = this.fontStyle
                    ? this.fontStyle
                    : v
                    ? "italic"
                    : "normal");
              } catch (p) {}
              "pie" === h[0].dataSeries.type ||
              "doughnut" === h[0].dataSeries.type ||
              "funnel" === h[0].dataSeries.type ||
              "pyramid" === h[0].dataSeries.type ||
              "bar" === h[0].dataSeries.type ||
              "rangeBar" === h[0].dataSeries.type ||
              "stackedBar" === h[0].dataSeries.type ||
              "stackedBar100" === h[0].dataSeries.type
                ? (a = a - 10 - this.container.clientWidth)
                : ((a =
                    (h[0].dataSeries.axisX.convertValueToPixel(
                      h[0].dataPoint.x
                    ) -
                      this.container.clientWidth) <<
                    0),
                  (a -= 10));
              0 > a && (a += this.container.clientWidth + 20);
              a + this.container.clientWidth >
                Math.max(this.chart.container.clientWidth, this.chart.width) &&
                (a = Math.max(
                  0,
                  Math.max(this.chart.container.clientWidth, this.chart.width) -
                    this.container.clientWidth
                ));
              d =
                1 !== h.length ||
                this.shared ||
                ("line" !== h[0].dataSeries.type &&
                  "stepLine" !== h[0].dataSeries.type &&
                  "spline" !== h[0].dataSeries.type &&
                  "area" !== h[0].dataSeries.type &&
                  "stepArea" !== h[0].dataSeries.type &&
                  "splineArea" !== h[0].dataSeries.type)
                  ? "bar" === h[0].dataSeries.type ||
                    "rangeBar" === h[0].dataSeries.type ||
                    "stackedBar" === h[0].dataSeries.type ||
                    "stackedBar100" === h[0].dataSeries.type
                    ? h[0].dataSeries.axisX.convertValueToPixel(
                        h[0].dataPoint.x
                      )
                    : d
                  : h[0].dataSeries.axisY.convertValueToPixel(h[0].dataPoint.y);
              d = -d + 10;
              0 < d + this.container.clientHeight + 5 &&
                (d -= d + this.container.clientHeight + 5 - 0);
              this.fixMozTransitionDelay(a, d);
              !this.animationEnabled || b
                ? this.disableAnimation()
                : (this.enableAnimation(),
                  (this.container.style.MozTransition =
                    this.mozContainerTransition));
              this.positionLeft = a;
              this.positionBottom = d;
              this.container.style.left = a + "px";
              this.container.style.bottom = d + "px";
            } else
              this.hide(!1),
                this.dispatchEvent(
                  "hidden",
                  { chart: this.chart, toolTip: this },
                  this
                );
          }
          d = [];
          for (c = 0; c < h.length; c++)
            d.push({
              xValue: h[c].dataPoint.x,
              dataPoint: h[c].dataPoint,
              dataSeries: h[c].dataSeries,
              dataPointIndex: h[c].index,
              dataSeriesIndex: h[c].dataSeries._index,
            });
          n = {
            chart: this.chart,
            toolTip: this.options,
            content: n,
            entries: d,
          };
          this._entries = h;
          this.dispatchEvent("updated", n, this);
        } else this.hide();
      }
    };
    aa.prototype.highlightObjects = function (a) {
      var e = this.chart.overlaidCanvasCtx;
      if (
        f(this.chart.clearedOverlayedCanvas) ||
        "toolTip" === this.chart.clearedOverlayedCanvas
      )
        this.chart.resetOverlayedCanvas(),
          e.clearRect(0, 0, this.chart.width, this.chart.height),
          (this.chart.clearedOverlayedCanvas = "toolTip");
      e.save();
      var b = this.chart.plotArea,
        c = 0;
      e.beginPath();
      e.rect(b.x1, b.y1, b.x2 - b.x1, b.y2 - b.y1);
      e.clip();
      for (b = 0; b < a.length; b++) {
        var g = a[b];
        if (
          (g =
            this.chart._eventManager.objectMap[
              g.dataSeries.dataPointIds[g.index]
            ]) &&
          g.objectType &&
          "dataPoint" === g.objectType
        ) {
          var c = this.chart.data[g.dataSeriesIndex],
            h = c.dataPoints[g.dataPointIndex],
            k = g.dataPointIndex;
          !1 === h.highlightEnabled ||
            (!0 !== c.highlightEnabled && !0 !== h.highlightEnabled) ||
            ("line" === c.type ||
            "stepLine" === c.type ||
            "spline" === c.type ||
            "scatter" === c.type ||
            "area" === c.type ||
            "stepArea" === c.type ||
            "splineArea" === c.type ||
            "stackedArea" === c.type ||
            "stackedArea100" === c.type ||
            "rangeArea" === c.type ||
            "rangeSplineArea" === c.type
              ? ((h = c.getMarkerProperties(
                  k,
                  g.x1,
                  g.y1,
                  this.chart.overlaidCanvasCtx
                )),
                (h.size = Math.max((1.5 * h.size) << 0, 10)),
                (h.borderColor = h.borderColor || "#FFFFFF"),
                (h.borderThickness =
                  h.borderThickness || Math.ceil(0.1 * h.size)),
                t.drawMarkers([h]),
                "undefined" !== typeof g.y2 &&
                  ((h = c.getMarkerProperties(
                    k,
                    g.x1,
                    g.y2,
                    this.chart.overlaidCanvasCtx
                  )),
                  (h.size = Math.max((1.5 * h.size) << 0, 10)),
                  (h.borderColor = h.borderColor || "#FFFFFF"),
                  (h.borderThickness =
                    h.borderThickness || Math.ceil(0.1 * h.size)),
                  t.drawMarkers([h])))
              : "bubble" === c.type
              ? ((h = c.getMarkerProperties(
                  k,
                  g.x1,
                  g.y1,
                  this.chart.overlaidCanvasCtx
                )),
                (h.size = g.size),
                (h.color = "white"),
                (h.borderColor = "white"),
                (e.globalAlpha = 0.3),
                t.drawMarkers([h]),
                (e.globalAlpha = 1))
              : "column" === c.type ||
                "stackedColumn" === c.type ||
                "stackedColumn100" === c.type ||
                "bar" === c.type ||
                "rangeBar" === c.type ||
                "stackedBar" === c.type ||
                "stackedBar100" === c.type ||
                "rangeColumn" === c.type ||
                "waterfall" === c.type
              ? fa(
                  e,
                  g.x1,
                  g.y1,
                  g.x2,
                  g.y2,
                  "white",
                  0,
                  null,
                  !1,
                  !1,
                  !1,
                  !1,
                  0.3
                )
              : "pie" === c.type || "doughnut" === c.type
              ? d(
                  e,
                  g.center,
                  g.radius,
                  "white",
                  c.type,
                  g.startAngle,
                  g.endAngle,
                  0.3,
                  g.percentInnerRadius
                )
              : "funnel" === c.type || "pyramid" === c.type
              ? u(e, g.funnelSection, 0.3, "white")
              : "candlestick" === c.type
              ? ((e.globalAlpha = 1),
                (e.strokeStyle = g.color),
                (e.lineWidth = 2 * g.borderThickness),
                (c = 0 === e.lineWidth % 2 ? 0 : 0.5),
                e.beginPath(),
                e.moveTo(g.x3 - c, Math.min(g.y2, g.y3)),
                e.lineTo(g.x3 - c, Math.min(g.y1, g.y4)),
                e.stroke(),
                e.beginPath(),
                e.moveTo(g.x3 - c, Math.max(g.y1, g.y4)),
                e.lineTo(g.x3 - c, Math.max(g.y2, g.y3)),
                e.stroke(),
                fa(
                  e,
                  g.x1,
                  Math.min(g.y1, g.y4),
                  g.x2,
                  Math.max(g.y1, g.y4),
                  "transparent",
                  2 * g.borderThickness,
                  g.color,
                  !1,
                  !1,
                  !1,
                  !1
                ),
                (e.globalAlpha = 1))
              : "ohlc" === c.type
              ? ((e.globalAlpha = 1),
                (e.strokeStyle = g.color),
                (e.lineWidth = 2 * g.borderThickness),
                (c = 0 === e.lineWidth % 2 ? 0 : 0.5),
                e.beginPath(),
                e.moveTo(g.x3 - c, g.y2),
                e.lineTo(g.x3 - c, g.y3),
                e.stroke(),
                e.beginPath(),
                e.moveTo(g.x3, g.y1),
                e.lineTo(g.x1, g.y1),
                e.stroke(),
                e.beginPath(),
                e.moveTo(g.x3, g.y4),
                e.lineTo(g.x2, g.y4),
                e.stroke(),
                (e.globalAlpha = 1))
              : "boxAndWhisker" === c.type
              ? (e.save(),
                (e.globalAlpha = 1),
                (e.strokeStyle = g.stemColor),
                (e.lineWidth = 2 * g.stemThickness),
                0 < g.stemThickness &&
                  (e.beginPath(),
                  e.moveTo(g.x3, g.y2 + g.borderThickness / 2),
                  e.lineTo(g.x3, g.y1 + g.whiskerThickness / 2),
                  e.stroke(),
                  e.beginPath(),
                  e.moveTo(g.x3, g.y4 - g.whiskerThickness / 2),
                  e.lineTo(g.x3, g.y3 - g.borderThickness / 2),
                  e.stroke()),
                e.beginPath(),
                fa(
                  e,
                  g.x1 - g.borderThickness / 2,
                  Math.max(
                    g.y2 + g.borderThickness / 2,
                    g.y3 + g.borderThickness / 2
                  ),
                  g.x2 + g.borderThickness / 2,
                  Math.min(
                    g.y2 - g.borderThickness / 2,
                    g.y3 - g.borderThickness / 2
                  ),
                  "transparent",
                  g.borderThickness,
                  g.color,
                  !1,
                  !1,
                  !1,
                  !1
                ),
                (e.globalAlpha = 1),
                (e.strokeStyle = g.whiskerColor),
                (e.lineWidth = 2 * g.whiskerThickness),
                0 < g.whiskerThickness &&
                  (e.beginPath(),
                  e.moveTo(Math.floor(g.x3 - g.whiskerLength / 2), g.y4),
                  e.lineTo(Math.ceil(g.x3 + g.whiskerLength / 2), g.y4),
                  e.stroke(),
                  e.beginPath(),
                  e.moveTo(Math.floor(g.x3 - g.whiskerLength / 2), g.y1),
                  e.lineTo(Math.ceil(g.x3 + g.whiskerLength / 2), g.y1),
                  e.stroke()),
                (e.globalAlpha = 1),
                (e.strokeStyle = g.lineColor),
                (e.lineWidth = 2 * g.lineThickness),
                0 < g.lineThickness &&
                  (e.beginPath(),
                  e.moveTo(g.x1, g.y5),
                  e.lineTo(g.x2, g.y5),
                  e.stroke()),
                e.restore(),
                (e.globalAlpha = 1))
              : "error" === c.type &&
                K(
                  e,
                  g.x1,
                  g.y1,
                  g.x2,
                  g.y2,
                  "white",
                  g.whiskerProperties,
                  g.stemProperties,
                  g.isXYSwapped,
                  0.3
                ));
        }
      }
      e.restore();
      e.globalAlpha = 1;
      e.beginPath();
    };
    aa.prototype.getToolTipInnerHTML = function (a) {
      a = a.entries;
      for (
        var d = null, b = null, c = null, g = 0, h = "", f = !0, k = 0;
        k < a.length;
        k++
      )
        if (a[k].dataSeries.toolTipContent || a[k].dataPoint.toolTipContent) {
          f = !1;
          break;
        }
      if (
        f &&
        ((this.content && "function" === typeof this.content) ||
          this.contentFormatter)
      )
        (a = { chart: this.chart, toolTip: this.options, entries: a }),
          (d = this.contentFormatter
            ? this.contentFormatter(a)
            : this.content(a));
      else if (this.shared && "none" !== this.chart.plotInfo.axisPlacement) {
        for (var u = null, m = "", k = 0; k < a.length; k++)
          (b = a[k].dataSeries),
            (c = a[k].dataPoint),
            (g = a[k].index),
            (h = ""),
            0 === k &&
              f &&
              !this.content &&
              (this.chart.axisX && 0 < this.chart.axisX.length
                ? (m +=
                    "undefined" !== typeof this.chart.axisX[0].labels[c.x]
                      ? this.chart.axisX[0].labels[c.x]
                      : "{x}")
                : this.chart.axisX2 &&
                  0 < this.chart.axisX2.length &&
                  (m +=
                    "undefined" !== typeof this.chart.axisX2[0].labels[c.x]
                      ? this.chart.axisX2[0].labels[c.x]
                      : "{x}"),
              (m += "</br>"),
              (m = this.chart.replaceKeywordsWithValue(m, c, b, g))),
            null === c.toolTipContent ||
              ("undefined" === typeof c.toolTipContent &&
                null === b.options.toolTipContent) ||
              ("line" === b.type ||
              "stepLine" === b.type ||
              "spline" === b.type ||
              "area" === b.type ||
              "stepArea" === b.type ||
              "splineArea" === b.type ||
              "column" === b.type ||
              "bar" === b.type ||
              "scatter" === b.type ||
              "stackedColumn" === b.type ||
              "stackedColumn100" === b.type ||
              "stackedBar" === b.type ||
              "stackedBar100" === b.type ||
              "stackedArea" === b.type ||
              "stackedArea100" === b.type ||
              "waterfall" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (h +=
                      u != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (h += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y}"),
                  (u = b.axisXIndex))
                : "bubble" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (h +=
                      u != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (h += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}"))
                : "rangeColumn" === b.type ||
                  "rangeBar" === b.type ||
                  "rangeArea" === b.type ||
                  "rangeSplineArea" === b.type ||
                  "error" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (h +=
                      u != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (h += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}"))
                : "candlestick" === b.type || "ohlc" === b.type
                ? (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (h +=
                      u != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (h += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}"))
                : "boxAndWhisker" === b.type &&
                  (this.chart.axisX &&
                    1 < this.chart.axisX.length &&
                    (h +=
                      u != b.axisXIndex
                        ? b.axisX.title
                          ? b.axisX.title + "<br/>"
                          : "X:{axisXIndex}<br/>"
                        : ""),
                  (h += c.toolTipContent
                    ? c.toolTipContent
                    : b.toolTipContent
                    ? b.toolTipContent
                    : this.content && "function" !== typeof this.content
                    ? this.content
                    : "<span style='\"" +
                      (this.options.fontColor ? "" : "'color:{color};'") +
                      "\"'>{name}:</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}")),
              null === d && (d = ""),
              !0 === this.reversed
                ? ((d = this.chart.replaceKeywordsWithValue(h, c, b, g) + d),
                  k < a.length - 1 && (d = "</br>" + d))
                : ((d += this.chart.replaceKeywordsWithValue(h, c, b, g)),
                  k < a.length - 1 && (d += "</br>")));
        null !== d && (d = m + d);
      } else {
        b = a[0].dataSeries;
        c = a[0].dataPoint;
        g = a[0].index;
        if (
          null === c.toolTipContent ||
          ("undefined" === typeof c.toolTipContent &&
            null === b.options.toolTipContent)
        )
          return null;
        "line" === b.type ||
        "stepLine" === b.type ||
        "spline" === b.type ||
        "area" === b.type ||
        "stepArea" === b.type ||
        "splineArea" === b.type ||
        "column" === b.type ||
        "bar" === b.type ||
        "scatter" === b.type ||
        "stackedColumn" === b.type ||
        "stackedColumn100" === b.type ||
        "stackedBar" === b.type ||
        "stackedBar100" === b.type ||
        "stackedArea" === b.type ||
        "stackedArea100" === b.type ||
        "waterfall" === b.type
          ? (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                ":</span>&nbsp;&nbsp;{y}")
          : "bubble" === b.type
          ? (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                ":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}")
          : "pie" === b.type ||
            "doughnut" === b.type ||
            "funnel" === b.type ||
            "pyramid" === b.type
          ? (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.name
                  ? "{name}:</span>&nbsp;&nbsp;"
                  : c.label
                  ? "{label}:</span>&nbsp;&nbsp;"
                  : "</span>") +
                "{y}")
          : "rangeColumn" === b.type ||
            "rangeBar" === b.type ||
            "rangeArea" === b.type ||
            "rangeSplineArea" === b.type ||
            "error" === b.type
          ? (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                " :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}")
          : "candlestick" === b.type || "ohlc" === b.type
          ? (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                "</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}")
          : "boxAndWhisker" === b.type &&
            (h = c.toolTipContent
              ? c.toolTipContent
              : b.toolTipContent
              ? b.toolTipContent
              : this.content && "function" !== typeof this.content
              ? this.content
              : "<span style='\"" +
                (this.options.fontColor ? "" : "'color:{color};'") +
                "\"'>" +
                (c.label ? "{label}" : "{x}") +
                "</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}");
        null === d && (d = "");
        d += this.chart.replaceKeywordsWithValue(h, c, b, g);
      }
      return d;
    };
    aa.prototype.enableAnimation = function () {
      if (!this.container.style.WebkitTransition) {
        var a = this.getContainerTransition(this.containerTransitionDuration);
        this.container.style.WebkitTransition = a;
        this.container.style.MsTransition = a;
        this.container.style.transition = a;
        this.container.style.MozTransition = this.mozContainerTransition;
      }
    };
    aa.prototype.disableAnimation = function () {
      this.container.style.WebkitTransition &&
        ((this.container.style.WebkitTransition = ""),
        (this.container.style.MozTransition = ""),
        (this.container.style.MsTransition = ""),
        (this.container.style.transition = ""));
    };
    aa.prototype.hide = function (a) {
      this.container &&
        ((this.container.style.display = "none"),
        (this.currentSeriesIndex = -1),
        (this._prevY = this._prevX = NaN),
        ("undefined" === typeof a || a) && this.chart.resetOverlayedCanvas());
    };
    aa.prototype.show = function (a, d, b) {
      this._updateToolTip(a, d, "undefined" === typeof b ? !1 : b);
    };
    aa.prototype.showAtIndex = function (a, d) {};
    aa.prototype.showAtX = function (a, d) {
      if (!this.enabled) return !1;
      this.chart.clearedOverlayedCanvas = null;
      var b,
        c,
        g,
        h = [];
      g = !1;
      d = !f(d) && 0 <= d && d < this.chart.data.length ? d : 0;
      if (this.shared)
        for (var k = 0; k < this.chart.data.length; k++)
          (b = this.chart.data[k]),
            (c = b.getDataPointAtX(a, !1)) &&
              c.dataPoint &&
              !f(c.dataPoint.y) &&
              b.visible &&
              ((c.dataSeries = b), h.push(c));
      else
        (b = this.chart.data[d]),
          (c = b.getDataPointAtX(a, !1)) &&
            c.dataPoint &&
            !f(c.dataPoint.y) &&
            b.visible &&
            ((c.dataSeries = b), h.push(c));
      if (0 < h.length) {
        for (k = 0; k < h.length; k++)
          if (
            ((c = h[k]),
            c.dataPoint.x < c.dataSeries.axisX.viewportMinimum ||
              c.dataPoint.x > c.dataSeries.axisX.viewportMaximum ||
              c.dataPoint.y < c.dataSeries.axisY.viewportMinimum ||
              c.dataPoint.y > c.dataSeries.axisY.viewportMaximum)
          )
            g = !0;
          else {
            g = !1;
            break;
          }
        if (g) return this.hide(), !1;
        this.highlightObjects(h);
        this._entries = h;
        c = "";
        c = this.getToolTipInnerHTML({ entries: h });
        if (null !== c) {
          this.contentDiv.innerHTML = c;
          c = !1;
          "none" === this.container.style.display &&
            ((c = !0), (this.container.style.display = "block"));
          try {
            (this.contentDiv.style.background = this.backgroundColor
              ? this.backgroundColor
              : v
              ? "rgba(255,255,255,.9)"
              : "rgb(255,255,255)"),
              (this.borderColor =
                "waterfall" === h[0].dataSeries.type
                  ? (this.contentDiv.style.borderRightColor =
                      this.contentDiv.style.borderLeftColor =
                      this.contentDiv.style.borderColor =
                        this.options.borderColor
                          ? this.options.borderColor
                          : h[0].dataPoint.color
                          ? h[0].dataPoint.color
                          : 0 < h[0].dataPoint.y
                          ? h[0].dataSeries.risingColor
                          : h[0].dataSeries.fallingColor)
                  : "error" === h[0].dataSeries.type
                  ? (this.contentDiv.style.borderRightColor =
                      this.contentDiv.style.borderLeftColor =
                      this.contentDiv.style.borderColor =
                        this.options.borderColor
                          ? this.options.borderColor
                          : h[0].dataSeries.color
                          ? h[0].dataSeries.color
                          : h[0].dataSeries._colorSet[
                              b.index % h[0].dataSeries._colorSet.length
                            ])
                  : (this.contentDiv.style.borderRightColor =
                      this.contentDiv.style.borderLeftColor =
                      this.contentDiv.style.borderColor =
                        this.options.borderColor
                          ? this.options.borderColor
                          : h[0].dataPoint.color
                          ? h[0].dataPoint.color
                          : h[0].dataSeries.color
                          ? h[0].dataSeries.color
                          : h[0].dataSeries._colorSet[
                              h[0].index % h[0].dataSeries._colorSet.length
                            ])),
              (this.contentDiv.style.borderWidth =
                this.borderThickness || 0 === this.borderThickness
                  ? this.borderThickness + "px"
                  : "2px"),
              (this.contentDiv.style.borderRadius =
                this.cornerRadius || 0 === this.cornerRadius
                  ? this.cornerRadius + "px"
                  : "5px"),
              (this.container.style.borderRadius =
                this.contentDiv.style.borderRadius),
              (this.contentDiv.style.fontSize =
                this.fontSize || 0 === this.fontSize
                  ? this.fontSize + "px"
                  : "14px"),
              (this.contentDiv.style.color = this.fontColor
                ? this.fontColor
                : "#000000"),
              (this.contentDiv.style.fontFamily = this.fontFamily
                ? this.fontFamily
                : "Calibri, Arial, Georgia, serif;"),
              (this.contentDiv.style.fontWeight = this.fontWeight
                ? this.fontWeight
                : "normal"),
              (this.contentDiv.style.fontStyle = this.fontStyle
                ? this.fontStyle
                : v
                ? "italic"
                : "normal");
          } catch (u) {}
          "pie" === h[0].dataSeries.type ||
          "doughnut" === h[0].dataSeries.type ||
          "funnel" === h[0].dataSeries.type ||
          "pyramid" === h[0].dataSeries.type
            ? (b = mouseX - 10 - this.container.clientWidth)
            : ((b =
                "bar" === h[0].dataSeries.type ||
                "rangeBar" === h[0].dataSeries.type ||
                "stackedBar" === h[0].dataSeries.type ||
                "stackedBar100" === h[0].dataSeries.type
                  ? (h[0].dataSeries.axisY.convertValueToPixel(
                      h[0].dataPoint.y
                    ) -
                      this.container.clientWidth) <<
                    0
                  : (h[0].dataSeries.axisX.convertValueToPixel(
                      h[0].dataPoint.x
                    ) -
                      this.container.clientWidth) <<
                    0),
              (b -= 10));
          0 > b && (b += this.container.clientWidth + 20);
          b + this.container.clientWidth >
            Math.max(this.chart.container.clientWidth, this.chart.width) &&
            (b = Math.max(
              0,
              Math.max(this.chart.container.clientWidth, this.chart.width) -
                this.container.clientWidth
            ));
          h =
            1 !== h.length ||
            this.shared ||
            ("line" !== h[0].dataSeries.type &&
              "stepLine" !== h[0].dataSeries.type &&
              "spline" !== h[0].dataSeries.type &&
              "area" !== h[0].dataSeries.type &&
              "stepArea" !== h[0].dataSeries.type &&
              "splineArea" !== h[0].dataSeries.type)
              ? "bar" === h[0].dataSeries.type ||
                "rangeBar" === h[0].dataSeries.type ||
                "stackedBar" === h[0].dataSeries.type ||
                "stackedBar100" === h[0].dataSeries.type
                ? h[0].dataSeries.axisX.convertValueToPixel(h[0].dataPoint.x)
                : h[0].dataSeries.axisY.convertValueToPixel(h[0].dataPoint.y)
              : h[0].dataSeries.axisY.convertValueToPixel(h[0].dataPoint.y);
          h = -h + 10;
          0 < h + this.container.clientHeight + 5 &&
            (h -= h + this.container.clientHeight + 5 - 0);
          this.fixMozTransitionDelay(b, h);
          !this.animationEnabled || c
            ? this.disableAnimation()
            : (this.enableAnimation(),
              (this.container.style.MozTransition =
                this.mozContainerTransition));
          this.container.style.left = b + "px";
          this.container.style.bottom = h + "px";
        } else return this.hide(!1), !1;
      } else return this.hide(), !1;
      return !0;
    };
    aa.prototype.fixMozTransitionDelay = function (a, d) {
      if (20 < this.chart._eventManager.lastObjectId)
        this.mozContainerTransition = this.getContainerTransition(0);
      else {
        var b = parseFloat(this.container.style.left),
          b = isNaN(b) ? 0 : b,
          c = parseFloat(this.container.style.bottom),
          c = isNaN(c) ? 0 : c;
        10 < Math.sqrt(Math.pow(b - a, 2) + Math.pow(c - d, 2))
          ? (this.mozContainerTransition = this.getContainerTransition(0.1))
          : (this.mozContainerTransition = this.getContainerTransition(0));
      }
    };
    aa.prototype.getContainerTransition = function (a) {
      return "left " + a + "s ease-out 0s, bottom " + a + "s ease-out 0s";
    };
    ka.prototype.reset = function () {
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.previousDataPointEventObject = null;
      this.eventObjects = [];
      v &&
        (this.ghostCtx.clearRect(0, 0, this.chart.width, this.chart.height),
        this.ghostCtx.beginPath());
    };
    ka.prototype.getNewObjectTrackingId = function () {
      return ++this.lastObjectId;
    };
    ka.prototype.mouseEventHandler = function (a) {
      if ("mousemove" === a.type || "click" === a.type) {
        var d = [],
          b = Ba(a),
          c = null;
        if (
          (c = this.chart.getObjectAtXY(b.x, b.y, !1)) &&
          "undefined" !== typeof this.objectMap[c]
        )
          if (((c = this.objectMap[c]), "dataPoint" === c.objectType)) {
            var g = this.chart.data[c.dataSeriesIndex],
              h = g.dataPoints[c.dataPointIndex],
              f = c.dataPointIndex;
            c.eventParameter = {
              x: b.x,
              y: b.y,
              dataPoint: h,
              dataSeries: g.options,
              dataPointIndex: f,
              dataSeriesIndex: g.index,
              chart: this.chart,
            };
            c.eventContext = {
              context: h,
              userContext: h,
              mouseover: "mouseover",
              mousemove: "mousemove",
              mouseout: "mouseout",
              click: "click",
            };
            d.push(c);
            c = this.objectMap[g.id];
            c.eventParameter = {
              x: b.x,
              y: b.y,
              dataPoint: h,
              dataSeries: g.options,
              dataPointIndex: f,
              dataSeriesIndex: g.index,
              chart: this.chart,
            };
            c.eventContext = {
              context: g,
              userContext: g.options,
              mouseover: "mouseover",
              mousemove: "mousemove",
              mouseout: "mouseout",
              click: "click",
            };
            d.push(this.objectMap[g.id]);
          } else
            "legendItem" === c.objectType &&
              ((g = this.chart.data[c.dataSeriesIndex]),
              (h =
                null !== c.dataPointIndex
                  ? g.dataPoints[c.dataPointIndex]
                  : null),
              (c.eventParameter = {
                x: b.x,
                y: b.y,
                dataSeries: g.options,
                dataPoint: h,
                dataPointIndex: c.dataPointIndex,
                dataSeriesIndex: c.dataSeriesIndex,
                chart: this.chart,
              }),
              (c.eventContext = {
                context: this.chart.legend,
                userContext: this.chart.legend.options,
                mouseover: "itemmouseover",
                mousemove: "itemmousemove",
                mouseout: "itemmouseout",
                click: "itemclick",
              }),
              d.push(c));
        g = [];
        for (b = 0; b < this.mouseoveredObjectMaps.length; b++) {
          h = !0;
          for (c = 0; c < d.length; c++)
            if (d[c].id === this.mouseoveredObjectMaps[b].id) {
              h = !1;
              break;
            }
          h
            ? this.fireEvent(this.mouseoveredObjectMaps[b], "mouseout", a)
            : g.push(this.mouseoveredObjectMaps[b]);
        }
        this.mouseoveredObjectMaps = g;
        for (b = 0; b < d.length; b++) {
          g = !1;
          for (c = 0; c < this.mouseoveredObjectMaps.length; c++)
            if (d[b].id === this.mouseoveredObjectMaps[c].id) {
              g = !0;
              break;
            }
          g ||
            (this.fireEvent(d[b], "mouseover", a),
            this.mouseoveredObjectMaps.push(d[b]));
          "click" === a.type
            ? this.fireEvent(d[b], "click", a)
            : "mousemove" === a.type && this.fireEvent(d[b], "mousemove", a);
        }
      }
    };
    ka.prototype.fireEvent = function (a, d, b) {
      if (a && d) {
        var c = a.eventParameter,
          g = a.eventContext,
          h = a.eventContext.userContext;
        h && g && h[g[d]] && h[g[d]].call(h, c);
        "mouseout" !== d
          ? h.cursor &&
            h.cursor !== b.target.style.cursor &&
            (b.target.style.cursor = h.cursor)
          : ((b.target.style.cursor = this.chart._defaultCursor),
            delete a.eventParameter,
            delete a.eventContext);
        "click" === d &&
          "dataPoint" === a.objectType &&
          this.chart.pieDoughnutClickHandler &&
          this.chart.pieDoughnutClickHandler.call(
            this.chart.data[a.dataSeriesIndex],
            c
          );
        "click" === d &&
          "dataPoint" === a.objectType &&
          this.chart.funnelPyramidClickHandler &&
          this.chart.funnelPyramidClickHandler.call(
            this.chart.data[a.dataSeriesIndex],
            c
          );
      }
    };
    ma.prototype.animate = function (a, d, b, c, g) {
      var h = this;
      this.chart.isAnimating = !0;
      g = g || x.easing.linear;
      b &&
        this.animations.push({
          startTime: new Date().getTime() + (a ? a : 0),
          duration: d,
          animationCallback: b,
          onComplete: c,
        });
      for (a = []; 0 < this.animations.length; )
        if (
          ((d = this.animations.shift()),
          (b = new Date().getTime()),
          (c = 0),
          d.startTime <= b &&
            ((c = g(Math.min(b - d.startTime, d.duration), 0, 1, d.duration)),
            (c = Math.min(c, 1)),
            isNaN(c) || !isFinite(c)) &&
            (c = 1),
          1 > c && a.push(d),
          d.animationCallback(c),
          1 <= c && d.onComplete)
        )
          d.onComplete();
      this.animations = a;
      0 < this.animations.length
        ? (this.animationRequestId = this.chart.requestAnimFrame.call(
            window,
            function () {
              h.animate.call(h);
            }
          ))
        : (this.chart.isAnimating = !1);
    };
    ma.prototype.cancelAllAnimations = function () {
      this.animations = [];
      this.animationRequestId &&
        this.chart.cancelRequestAnimFrame.call(window, this.animationRequestId);
      this.animationRequestId = null;
      this.chart.isAnimating = !1;
    };
    var x = {
        yScaleAnimation: function (a, d) {
          if (0 !== a) {
            var b = d.dest,
              c = d.source.canvas,
              g = d.animationBase;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              0,
              g - g * a,
              b.canvas.width / ia,
              (a * b.canvas.height) / ia
            );
          }
        },
        xScaleAnimation: function (a, d) {
          if (0 !== a) {
            var b = d.dest,
              c = d.source.canvas,
              g = d.animationBase;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              g - g * a,
              0,
              (a * b.canvas.width) / ia,
              b.canvas.height / ia
            );
          }
        },
        xClipAnimation: function (a, d) {
          if (0 !== a) {
            var b = d.dest,
              c = d.source.canvas;
            b.save();
            0 < a &&
              b.drawImage(
                c,
                0,
                0,
                c.width * a,
                c.height,
                0,
                0,
                (c.width * a) / ia,
                c.height / ia
              );
            b.restore();
          }
        },
        fadeInAnimation: function (a, d) {
          if (0 !== a) {
            var b = d.dest,
              c = d.source.canvas;
            b.save();
            b.globalAlpha = a;
            b.drawImage(
              c,
              0,
              0,
              c.width,
              c.height,
              0,
              0,
              b.canvas.width / ia,
              b.canvas.height / ia
            );
            b.restore();
          }
        },
        easing: {
          linear: function (a, d, b, c) {
            return (b * a) / c + d;
          },
          easeOutQuad: function (a, d, b, c) {
            return -b * (a /= c) * (a - 2) + d;
          },
          easeOutQuart: function (a, d, b, c) {
            return -b * ((a = a / c - 1) * a * a * a - 1) + d;
          },
          easeInQuad: function (a, d, b, c) {
            return b * (a /= c) * a + d;
          },
          easeInQuart: function (a, d, b, c) {
            return b * (a /= c) * a * a * a + d;
          },
        },
      },
      t = {
        drawMarker: function (a, d, b, c, g, h, f, k) {
          if (b) {
            var u = 1;
            b.fillStyle = h ? h : "#000000";
            b.strokeStyle = f ? f : "#000000";
            b.lineWidth = k ? k : 0;
            b.setLineDash && b.setLineDash(N("solid", k));
            "circle" === c
              ? (b.moveTo(a, d),
                b.beginPath(),
                b.arc(a, d, g / 2, 0, 2 * Math.PI, !1),
                h && b.fill(),
                k &&
                  (f
                    ? b.stroke()
                    : ((u = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = u))))
              : "square" === c
              ? (b.beginPath(),
                b.rect(a - g / 2, d - g / 2, g, g),
                h && b.fill(),
                k &&
                  (f
                    ? b.stroke()
                    : ((u = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = u))))
              : "triangle" === c
              ? (b.beginPath(),
                b.moveTo(a - g / 2, d + g / 2),
                b.lineTo(a + g / 2, d + g / 2),
                b.lineTo(a, d - g / 2),
                b.closePath(),
                h && b.fill(),
                k &&
                  (f
                    ? b.stroke()
                    : ((u = b.globalAlpha),
                      (b.globalAlpha = 0.15),
                      (b.strokeStyle = "black"),
                      b.stroke(),
                      (b.globalAlpha = u))),
                b.beginPath())
              : "cross" === c &&
                ((b.strokeStyle = h),
                (b.lineWidth = g / 4),
                b.beginPath(),
                b.moveTo(a - g / 2, d - g / 2),
                b.lineTo(a + g / 2, d + g / 2),
                b.stroke(),
                b.moveTo(a + g / 2, d - g / 2),
                b.lineTo(a - g / 2, d + g / 2),
                b.stroke());
          }
        },
        drawMarkers: function (a) {
          for (var d = 0; d < a.length; d++) {
            var b = a[d];
            t.drawMarker(
              b.x,
              b.y,
              b.ctx,
              b.type,
              b.size,
              b.color,
              b.borderColor,
              b.borderThickness
            );
          }
        },
      };
    return s;
  })());
  Ka.version = "v3.3 GA";
  window.CanvasJS &&
    Ka &&
    !window.CanvasJS.Chart &&
    (window.CanvasJS.Chart = Ka);
  ma.StockChart = {
    width: 500,
    height: 600,
    backgroundColor: "white",
    theme: "light1",
    animationEnabled: !1,
    animationDuration: 1200,
    culture: "en",
    creditHref: "",
    creditText: "CanvasJS",
    exportEnabled: !1,
    exportFileName: "StockChart",
    colorSet: "colorSet1",
    rangeChanging: null,
    rangeChanged: null,
    publicProperties: {
      title: "readWrite",
      subtitles: "readWrite",
      navigator: "readWrite",
      rangeSelector: "readWrite",
      charts: "readWrite",
      options: "readWrite",
      bounds: "readOnly",
      container: "readOnly",
      selectedColorSet: "readOnly",
    },
  };
  ma.Navigator = {
    enabled: !0,
    width: 500,
    height: 70,
    verticalAlign: "bottom",
    horizontalAlign: "center",
    dynamicUpdate: !0,
    backgroundColor: "#fff",
    animationEnabled: !1,
    animationDuration: 1200,
    theme: "light1",
    publicProperties: {
      slider: "readWrite",
      backgroundColor: "readWrite",
      animationEnabled: "readWrite",
      animationDuration: "readWrite",
      theme: "readWrite",
      axisX: "readWrite",
      axisY: "readWrite",
      axisX2: "readWrite",
      axisY2: "readWrite",
      data: "readWrite",
      options: "readWrite",
      bounds: "readOnly",
    },
  };
  ma.RangeSelector = {
    enabled: !0,
    width: 500,
    height: 35,
    label: "Range",
    verticalAlign: "top",
    horizontalAlign: "center",
    selectedRangeButtonIndex: null,
    publicProperties: {
      options: "readWrite",
      buttons: "readWrite",
      inputFields: "readWrite",
      buttonStyle: "readWrite",
      bounds: "readOnly",
    },
  };
  ma.RangeButton = {
    range: null,
    rangeType: null,
    label: null,
    style: "position: inline; margin: 5px 0;text-align:center;cursor: pointer;",
    backgroundColorDisabled: "#ddd",
    publicProperties: { options: "readWrite", bounds: "readOnly" },
  };
  ma.ButtonStyle = {
    backgroundColor: "#fff",
    backgroundColorOnHover: "#2196f3",
    backgroundColorOnSelect: "#2196f3",
    borderColor: "#2196f3",
    borderThickness: 2,
    labelFontColor: "#000",
    labelFontColorOnHover: "#fff",
    labelFontSize: 14,
    labelFontStyle: "normal",
    labelFontFamily: v ? "Trebuchet MS, Helvetica, sans-serif" : "Arial",
    labelFontWeight: "normal",
    width: null,
    maxWidth: null,
    padding: { left: 5, right: 5, top: 2, bottom: 2 },
    spacing: 5,
    cursor: "pointer",
    publicProperties: { options: "readWrite" },
  };
  ma.InputFields = {
    enabled: !0,
    startValue: null,
    endValue: null,
    valueType: "dateTime",
    valueFormatString: "MMM DD YYYY",
    publicProperties: { style: "readWrite", options: "readWrite" },
  };
  ma.Style = {
    backgroundColor: "#fff",
    borderColor: "#2196f3",
    borderColorOnFocus: "#008eff",
    borderThickness: 2,
    fontColor: "#000",
    fontSize: 12,
    fontStyle: "normal",
    fontFamily: v ? "Trebuchet MS, Helvetica, sans-serif" : "Arial",
    fontWeight: "normal",
    width: null,
    maxWidth: null,
    padding: { left: 5, right: 5, top: 2, bottom: 2 },
    spacing: 5,
    cursor: "text",
    publicProperties: { options: "readWrite" },
  };
  ma.Slider = {
    maskColor: "#d9e8f9",
    maskInverted: !1,
    maskOpacity: 0.7,
    handleColor: "#ddd",
    handleBorderColor: "#aaa",
    handleBorderThickness: 1,
    handleWidth: 8,
    handleHeight: 18,
    minimum: null,
    maximum: null,
    outlineThickness: 1,
    outlineColor: "#666",
    outlineInverted: !1,
    publicProperties: { options: "readWrite" },
  };
  ma.CultureInfo.rangeSelector = {
    fromText: "From",
    toText: "To",
    rangeText: "Range",
  };
  K = "#FFFFFF";
  W = "#333333";
  M = "#000000";
  Ga = {
    colorSet: "colorSet1",
    backgroundColor: K,
    title: Ga.title,
    subtitles: Ga.subtitles,
    charts: [Ga],
    rangeSelector: {
      buttonStyle: {
        backgroundColor: "#FEFEFE",
        backgroundColorOnHover: "#41a5f5",
        backgroundColorOnSelect: "#2196f3",
        borderColor: "#2196f3",
        borderThickness: 1,
        labelFontColor: M,
        labelFontColorOnHover: "#ffffff",
        labelFontSize: 14,
        labelFontStyle: "normal",
        labelFontFamily: s,
        labelFontWeight: "normal",
        spacing: 0,
      },
      inputFields: {
        style: {
          backgroundColor: "#ffffff",
          borderColor: "#2196f3",
          borderColorOnFocus: "#2196f3",
          borderThickness: 1,
          fontColor: M,
          fontSize: 14,
          fontStyle: "normal",
          fontFamily: s,
          fontWeight: "normal",
        },
      },
    },
    navigator: {
      backgroundColor: K,
      slider: {
        maskColor: "#d9e8f9",
        maskOpacity: 0.6,
        handleColor: "#efefef",
        handleBorderColor: "#666666",
        handleBorderThickness: 1,
        outlineColor: "#666666",
        outlineThickness: 1,
      },
    },
    toolbar: Ga.toolbar,
  };
  K = "#FFFFFF";
  W = "#3A3A3A";
  M = "#666666";
  Ja = {
    colorSet: "colorSet2",
    backgroundColor: K,
    title: Ja.title,
    subtitles: Ja.subtitles,
    charts: [Ja],
    rangeSelector: {
      buttonStyle: {
        backgroundColor: "#FEFEFE",
        backgroundColorOnHover: "#41a5f5",
        backgroundColorOnSelect: "#2196f3",
        borderColor: "#2196f3",
        borderThickness: 1,
        labelFontColor: M,
        labelFontColorOnHover: "#ffffff",
        labelFontSize: 14,
        labelFontStyle: "normal",
        labelFontFamily: s,
        labelFontWeight: "normal",
        spacing: 0,
      },
      inputFields: {
        style: {
          backgroundColor: "#ffffff",
          borderColor: "#2196f3",
          borderColorOnFocus: "#2196f3",
          borderThickness: 1,
          fontColor: M,
          fontSize: 14,
          fontStyle: "normal",
          fontFamily: s,
          fontWeight: "normal",
        },
      },
    },
    navigator: {
      backgroundColor: K,
      slider: {
        maskColor: "#D9E8F9",
        maskOpacity: 0.6,
        handleColor: "#EFEFEF",
        handleBorderColor: "#BBBBBB",
        handleBorderThickness: 1,
        outlineColor: "#BBBBBB",
        outlineThickness: 1,
      },
    },
    toolbar: Ja.toolbar,
  };
  K = "#2A2A2A";
  M = W = "#F5F5F5";
  Aa = {
    colorSet: "colorSet1",
    backgroundColor: K,
    title: Aa.title,
    subtitles: Aa.subtitles,
    charts: [Aa],
    rangeSelector: {
      buttonStyle: {
        backgroundColor: "#666666",
        backgroundColorOnHover: "#FF7372",
        backgroundColorOnSelect: "#FF7372",
        borderColor: "#FF7372",
        borderThickness: 1,
        labelFontColor: M,
        labelFontColorOnHover: "#F5F5F5",
        labelFontSize: 14,
        labelFontStyle: "normal",
        labelFontFamily: s,
        labelFontWeight: "normal",
        spacing: 0,
      },
      inputFields: {
        style: {
          backgroundColor: "#666666",
          borderColor: "#FF7372",
          borderColorOnFocus: "#FF7372",
          borderThickness: 1,
          fontColor: M,
          fontSize: 14,
          fontStyle: "normal",
          fontFamily: s,
          fontWeight: "normal",
        },
      },
    },
    navigator: {
      backgroundColor: K,
      slider: {
        maskColor: "#d9e8f9",
        maskOpacity: 0.6,
        handleColor: "#efefef",
        handleBorderColor: "#666666",
        handleBorderThickness: 1,
        outlineColor: "#FFFFFF",
        outlineThickness: 1,
      },
    },
    toolbar: Aa.toolbar,
  };
  K = "#32373A";
  M = W = "#FAFAFA";
  var cb = {
    light1: Ga,
    light2: Ja,
    dark1: Aa,
    dark2: {
      colorSet: "colorSet2",
      backgroundColor: K,
      title: X.title,
      subtitles: X.subtitles,
      charts: [X],
      rangeSelector: {
        buttonStyle: {
          backgroundColor: "#666666",
          backgroundColorOnHover: "#FF7372",
          backgroundColorOnSelect: "#FF7372",
          borderColor: "#FF7372",
          borderThickness: 1,
          labelFontColor: M,
          labelFontColorOnHover: "#F5F5F5",
          labelFontSize: 14,
          labelFontStyle: "normal",
          labelFontFamily: s,
          labelFontWeight: "normal",
          spacing: 0,
        },
        inputFields: {
          style: {
            backgroundColor: "#666666",
            borderColor: "#FF7372",
            borderColorOnFocus: "#FF7372",
            borderThickness: 1,
            fontColor: M,
            fontSize: 14,
            fontStyle: "normal",
            fontFamily: s,
            fontWeight: "normal",
          },
        },
      },
      navigator: {
        backgroundColor: K,
        slider: {
          maskColor: "#d9e8f9",
          maskOpacity: 0.6,
          handleColor: "#efefef",
          handleBorderColor: "#666666",
          handleBorderThickness: 1,
          outlineColor: "#FFFFFF",
          outlineThickness: 1,
        },
      },
      toolbar: X.toolbar,
    },
  };
  W = Sa.StockChart = (function () {
    function k(d) {
      var f;
      f = document.createElement("div");
      f.setAttribute("class", d);
      sa(f, {
        position: "absolute",
        textAlign: "left",
        cursor: "auto",
        webkitTapHighlightColor: "transparent",
      });
      return f;
    }
    function B(d, k, x) {
      d = document.createElement(d);
      d.setAttribute("class", k);
      sa(d, { webkitTapHighlightColor: "transparent" });
      f(x) || d.setAttribute("type", x);
      return d;
    }
    function F(d, k) {
      k = k || {};
      this.theme = f(k.theme) || f(bb[k.theme]) ? "light1" : k.theme;
      this.predefinedThemes = cb;
      F.base.constructor.call(this, "StockChart", null, k, null, null);
      this.optionsName = "stockChart";
      var x = this;
      this.sessionVariables = {};
      this._axisXMax = this._axisXMin = null;
      this._containerId = d;
      this._objectsInitialized = !1;
      this.ctx = null;
      this.plotArea = {
        canvas: null,
        ctx: null,
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0,
        width: 0,
        height: 0,
      };
      this._dataInRenderedOrder = [];
      this.allDOMEventHandlers = [];
      if (
        (this.container =
          "string" === typeof this._containerId
            ? document.getElementById(this._containerId)
            : this._containerId)
      ) {
        this.container.innerHTML = "";
        var t = 0,
          a = 0;
        this._defaultCursor = "default";
        t = this.options.width
          ? this.width
          : 0 < this.container.clientWidth
          ? this.container.clientWidth
          : this.width;
        a = this.options.height
          ? this.height
          : 0 < this.container.clientHeight
          ? this.container.clientHeight
          : this.height;
        this.width = t;
        this.height = a;
        this.x1 = this.y1 = 0;
        this.x2 = this.width;
        this.y2 = this.height;
        this.selectedColorSet =
          "undefined" !== typeof ya[this.colorSet]
            ? ya[this.colorSet]
            : ya.colorSet1;
        this._canvasJSContainer = document.createElement("div");
        this._canvasJSContainer.setAttribute(
          "class",
          "canvasjs-stock-container"
        );
        this._canvasJSContainer.style.position = "relative";
        this._canvasJSContainer.style.userSelect =
          this._canvasJSContainer.style.WebkitUserSelect =
          this._canvasJSContainer.style.MozUserSelect =
          this._canvasJSContainer.style.msUserSelect =
            "none";
        this._canvasJSContainer.style.textAlign = "left";
        this._canvasJSContainer.style.cursor = "auto";
        this._canvasJSContainer.style.direction = "ltr";
        this._canvasJSContainer.style.fontFamily = s;
        v || (this._canvasJSContainer.style.height = "0px");
        this.container.appendChild(this._canvasJSContainer);
        this.canvas = ta(t, a);
        this.canvas.style.position = "absolute";
        this.canvas.getContext &&
          (this._canvasJSContainer.appendChild(this.canvas),
          (this.ctx = this.canvas.getContext("2d")),
          (this.ctx.textBaseline = "top"),
          Ha(this.ctx),
          (this.overlaidCanvas = ta(t, a)),
          (this.overlaidCanvas.style.position = "absolute"),
          (this.overlaidCanvas.style.webkitTapHighlightColor = "transparent"),
          this.overlaidCanvas.getContext &&
            (this._canvasJSContainer.appendChild(this.overlaidCanvas),
            (this.overlaidCanvasCtx = this.overlaidCanvas.getContext("2d")),
            (this.overlaidCanvasCtx.textBaseline = "top"),
            Ha(this.overlaidCanvasCtx)),
          v
            ? (this.plotArea.ctx = this.ctx)
            : ((this.plotArea.canvas = ta(t, a)),
              (this.plotArea.canvas.style.position = "absolute"),
              this.plotArea.canvas.setAttribute("class", "plotAreaCanvas"),
              this._canvasJSContainer.appendChild(this.plotArea.canvas),
              (this.plotArea.ctx = this.plotArea.canvas.getContext("2d"))),
          (this._toolBar = document.createElement("div")),
          this._toolBar.setAttribute("class", "canvasjs-chart-toolbar"),
          (this._toolBar.style.cssText =
            "position: absolute; right: 1px; top: 1px; z-index: 999;"),
          this._canvasJSContainer.appendChild(this._toolBar),
          (this.bounds = { x1: 0, y1: 0, x2: this.width, y2: this.height }),
          (this.charts = []),
          Ea(this.charts),
          (this._eventManager = new H(this)),
          y(
            this.overlaidCanvas,
            "click",
            function (a) {
              x._mouseEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            "mousemove",
            function (a) {
              x._mouseEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            "mouseup",
            function (a) {
              x._mouseEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            "mousedown",
            function (a) {
              x._mouseEventHandler(a);
              za(x._dropdownMenu);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            "mouseout",
            function (a) {
              x._mouseEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
            function (a) {
              x._touchEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove",
            function (a) {
              x._touchEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend",
            function (a) {
              x._touchEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          y(
            this.overlaidCanvas,
            window.navigator.msPointerEnabled
              ? "MSPointerCancel"
              : "touchcancel",
            function (a) {
              x._touchEventHandler(a);
            },
            this.allDOMEventHandlers
          ),
          (this.windowResizeHandler = y(
            window,
            "resize",
            function () {
              x._updateSize() && x.render();
            },
            this.allDOMEventHandlers
          )));
      } else
        window.console &&
          window.console.log(
            'CanvasJS Error: StockChart Container with id "' +
              this._containerId +
              '" was not found'
          );
    }
    function K(d, f) {
      K.base.constructor.call(this, d, f);
      this.options = f;
      this.dockInsidePlotArea = !1;
    }
    function M(d, f, k) {
      M.base.constructor.call(this, d, f, k);
      this.options = f;
      this.dockInsidePlotArea = !1;
    }
    function H(d) {
      this.stockChart = d;
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.ghostCanvas = ta(this.stockChart.width, this.stockChart.height);
      this.ghostCtx = this.ghostCanvas.getContext("2d");
      this.mouseoveredObjectMaps = [];
    }
    function z(d, f) {
      f = f || {};
      this.optionsName = "navigator";
      z.base.constructor.call(this, "Navigator", "navigator", f, null, d);
      this.parent = this.stockChart = d;
    }
    function N(d, u) {
      this.panel = k("canvasjs-slider-panel");
      this.parent = this.navigator = d;
      this.stockChart = d.stockChart;
      this.navigator.panel.appendChild(this.panel);
      N.base.constructor.call(this, "Slider", "slider", u, null, d);
      this.options =
        f(u.navigator) || f(u.navigator.slider) ? {} : u.navigator.slider;
      this.optionsName = "slider";
      this.panMode = !1;
      this.sessionVariables = {};
    }
    function O(d, k) {
      O.base.constructor.call(
        this,
        "RangeSelector",
        "rangeSelector",
        k,
        null,
        d
      );
      this.parent = this.stockChart = d;
      this.options = f(k) || f(k.rangeSelector) ? {} : k.rangeSelector;
      this.optionsName = "rangeSelector";
      this.ctx = d.ctx;
      this._label = {};
      this.buttons = [];
    }
    function P(d, k, x) {
      P.base.constructor.call(
        this,
        "RangeButton",
        "rangeButton",
        x,
        k,
        d.rangeSelector
      );
      this.stockChart = d;
      this.parent = this.rangeSelector = d.rangeSelector;
      this.options = f(x) ? {} : x;
      this.optionsName = "rangeButton";
      this.enabled = !1;
      this.state = "off";
    }
    function W(d, k) {
      W.base.constructor.call(
        this,
        "InputFields",
        "inputFields",
        k,
        null,
        d.rangeSelector
      );
      this.stockChart = d;
      this.options = f(k) || f(k.inputFields) ? {} : k.inputFields;
      this.parent = this.rangeSelector = d.rangeSelector;
      this.elements = [];
      this._textBlocks = [];
      this.optionsName = "inputFields";
      this.elements.push(B("input", "canvasjs-input-field", "text"));
      this.elements.push(B("input", "canvasjs-input-field", "text"));
      for (var x = 0; x < this.elements.length; x++)
        this.stockChart._canvasJSContainer.appendChild(this.elements[x]);
      var t = this,
        a = null,
        e = null;
      y(
        this.elements[0],
        "focus",
        function () {
          t.elements[0].focused = !0;
          t._textBlocks[0].borderColor = t.style.borderColorOnFocus;
          t._textBlocks[0].render(!0);
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[0],
        "focusout",
        function () {
          t.elements[0].focused = !1;
          var a;
          t.stockChart.charts &&
            t.stockChart.charts.length &&
            (a =
              t.stockChart.charts[0].axisX &&
              t.stockChart.charts[0].axisX.length
                ? t.stockChart.charts[0].axisX[0]
                : t.stockChart.charts[0].axisX2[0]);
          this.value =
            "dateTime" === t.valueType
              ? oa(
                  a ? a.viewportMinimum : null,
                  "YYYY-MM-DD",
                  t.stockChart._cultureInfo
                )
              : $(
                  a ? a.viewportMinimum : null,
                  t.valueFormatString,
                  t.stockChart._cultureInfo
                );
          this.style.display = "none";
          t._textBlocks[0].borderColor = t.style.borderColor;
          t._textBlocks[0].render(!0);
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[1],
        "focus",
        function () {
          t.elements[1].focused = !0;
          t._textBlocks[1].borderColor = t.style.borderColorOnFocus;
          t._textBlocks[1].render(!0);
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[1],
        "focusout",
        function () {
          t.elements[1].focused = !1;
          var a;
          t.stockChart.charts &&
            t.stockChart.charts.length &&
            (a =
              t.stockChart.charts[0].axisX &&
              t.stockChart.charts[0].axisX.length
                ? t.stockChart.charts[0].axisX[0]
                : t.stockChart.charts[0].axisX2[0]);
          this.value =
            "dateTime" === t.valueType
              ? oa(
                  a ? a.viewportMaximum : null,
                  "YYYY-MM-DD",
                  t.stockChart._cultureInfo
                )
              : $(
                  a ? a.viewportMaximum : null,
                  t.valueFormatString,
                  t.stockChart._cultureInfo
                );
          this.style.display = "none";
          t._textBlocks[1].borderColor = t.style.borderColor;
          t._textBlocks[1].render(!0);
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[0],
        "change",
        function (b) {
          var c, d;
          t.stockChart.charts &&
            t.stockChart.charts.length &&
            (t.stockChart.navigator &&
              t.stockChart.navigator.enabled &&
              (d =
                t.stockChart.navigator &&
                t.stockChart.navigator.chart &&
                t.stockChart.navigator.chart.axisX
                  ? t.stockChart.navigator.chart.axisX[0]
                  : t.stockChart.navigator.chart.axisX2[0]),
            (c =
              t.stockChart.charts[0].axisX &&
              t.stockChart.charts[0].axisX.length
                ? t.stockChart.charts[0].axisX[0]
                : t.stockChart.charts[0].axisX2[0]));
          b =
            "dateTime" === t.valueType
              ? isNaN(new Date(this.value.replace(/-/g, "/")).getTime())
                ? null
                : new Date(this.value.replace(/-/g, "/")).getTime()
              : this.value;
          a = f(d)
            ? !f(b) && b < (f(c) ? null : c.maximum)
              ? Math.max(f(c) ? null : c.minimum, b)
              : f(c)
              ? null
              : c.minimum
            : !f(b) && b < (f(d) ? null : d.maximum)
            ? Math.max(f(d) ? null : d.minimum, b)
            : f(d)
            ? null
            : d.minimum;
          e = f(c) ? null : c.viewportMaximum;
          t.stockChart._rangeEventParameter = {
            stockChart: t.stockChart,
            source: "inputFields",
            index: null,
            minimum: a,
            maximum: e,
          };
          t.stockChart._rangeEventParameter.type = "rangeChanging";
          t.stockChart.dispatchEvent(
            "rangeChanging",
            t.stockChart._rangeEventParameter,
            t.stockChart
          );
          t.stockChart.sessionVariables._axisXMin = a;
          t.stockChart.sessionVariables._axisXMax = e;
          t.stockChart._syncCharts(a, e);
          t.stockChart._rangeEventParameter.type = "rangeChanged";
          t.stockChart.dispatchEvent(
            "rangeChanged",
            t.stockChart._rangeEventParameter,
            t.stockChart
          );
          t.stockChart.rangeSelector &&
            t.stockChart.rangeSelector.resetRangeButtons();
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[1],
        "change",
        function (b) {
          var c, d;
          t.stockChart.charts &&
            t.stockChart.charts.length &&
            (t.stockChart.navigator &&
              t.stockChart.navigator.enabled &&
              (d =
                t.stockChart.navigator &&
                t.stockChart.navigator.chart &&
                t.stockChart.navigator.chart.axisX
                  ? t.stockChart.navigator.chart.axisX[0]
                  : t.stockChart.navigator.chart.axisX2[0]),
            (c =
              t.stockChart.charts[0].axisX &&
              t.stockChart.charts[0].axisX.length
                ? t.stockChart.charts[0].axisX[0]
                : t.stockChart.charts[0].axisX2[0]));
          b =
            "dateTime" === t.valueType
              ? isNaN(new Date(this.value.replace(/-/g, "/")).getTime())
                ? null
                : new Date(this.value.replace(/-/g, "/")).getTime()
              : this.value;
          a = c ? c.viewportMinimum : null;
          e = f(d)
            ? !f(b) && b > (c ? c.minimum : null)
              ? Math.min(c ? c.maximum : null, b)
              : c
              ? c.maximum
              : null
            : !f(b) && b > (d ? d.minimum : null)
            ? Math.min(d ? d.maximum : null, b)
            : d
            ? d.maximum
            : null;
          t.stockChart._rangeEventParameter = {
            stockChart: t.stockChart,
            source: "inputFields",
            index: null,
            minimum: a,
            maximum: e,
          };
          t.stockChart._rangeEventParameter.type = "rangeChanging";
          t.stockChart.dispatchEvent(
            "rangeChanging",
            t.stockChart._rangeEventParameter,
            t.stockChart
          );
          t.stockChart.sessionVariables._axisXMin = a;
          t.stockChart.sessionVariables._axisXMax = e;
          t.stockChart._syncCharts(a, e);
          t.stockChart._rangeEventParameter.type = "rangeChanged";
          t.stockChart.dispatchEvent(
            "rangeChanged",
            t.stockChart._rangeEventParameter,
            t.stockChart
          );
          t.stockChart.rangeSelector &&
            t.stockChart.rangeSelector.resetRangeButtons();
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[0],
        "keydown",
        function (a) {
          if (13 === a.keyCode) {
            var c =
              "dateTime" === t.valueType
                ? oa(t.startValue, "YYYY-MM-DD")
                : $(t.startValue, t.valueFormatString);
            this.value != c && ib(this, "change");
            this.blur();
            a.preventDefault && a.preventDefault();
          }
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
      y(
        this.elements[1],
        "keydown",
        function (a) {
          if (13 === a.keyCode) {
            var c =
              "dateTime" === t.valueType
                ? oa(t.endValue, "YYYY-MM-DD")
                : $(t.endValue, t.valueFormatString);
            this.value != c && ib(this, "change");
            this.blur();
            a.preventDefault && a.preventDefault();
          }
        },
        this.rangeSelector.stockChart.allDOMEventHandlers
      );
    }
    function X(d, k) {
      X.base.constructor.call(
        this,
        "ButtonStyle",
        "buttonStyle",
        k,
        null,
        d.rangeSelector
      );
      this.stockChart = d;
      this.parent = this.rangeSelector = d.rangeSelector;
      this.options = f(k) || f(k.buttonStyle) ? {} : k.buttonStyle;
      this.optionsName = "buttonStyle";
    }
    function Y(d, k) {
      Y.base.constructor.call(
        this,
        "Style",
        "style",
        k,
        null,
        d.rangeSelector.inputFields
      );
      this.stockChart = d;
      this.parent = this.inputFields = d.rangeSelector.inputFields;
      this.options = f(k) || f(k.style) ? {} : k.style;
      this.optionsName = "style";
    }
    var ea = !0;
    ha(F, Q);
    F.prototype._updateOptions = function () {
      this.updateOption("width");
      this.updateOption("height");
      this.updateOption("theme");
      this.updateOption("colorSet") &&
        (this.selectedColorSet =
          "undefined" !== typeof ya[this.colorSet]
            ? ya[this.colorSet]
            : ya.colorSet1);
      this.updateOption("backgroundColor");
      this.backgroundColor || (this.backgroundColor = "rgba(0,0,0,0)");
      this.updateOption("exportEnabled");
      this.updateOption("exportFileName");
      this.updateOption("creditHref");
      this.updateOption("creditHref");
      this.updateOption("culture");
      this._cultureInfo = new Oa(this.options.culture);
      this.updateOption("animationEnabled");
      this.updateOption("animationDuration");
      this.updateOption("rangeChanging");
      this.updateOption("rangeChanged");
      jb(this);
    };
    F._supportedChartTypes = Ea(
      "line stepLine spline column area stepArea splineArea bubble scatter stackedColumn stackedColumn100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeArea rangeSplineArea waterfall".split(
        " "
      )
    );
    F.prototype._initialize = function () {
      this.toolbar = new Xa(this, this.options.toolbar);
      this._updateOptions();
      this.animationEnabled = this.animationEnabled && v;
      this._updateSize();
      this.clearCanvas();
      this.ctx.beginPath();
      var d,
        u = f(this.options.charts) ? [] : this.options.charts;
      Ea(u);
      for (var x = 0; x < this.charts.length; x++)
        (d = this.charts[x]),
          0 > u.indexOf(d.options) &&
            (this.charts.splice(x, 1),
            d.destroy(),
            this._canvasJSContainer.removeChild(d.panel),
            x--);
      this.layoutManager = new La(0, 0, this.width, this.height, 2);
      this.plotArea.layoutManager && this.plotArea.layoutManager.reset();
      this.title = null;
      this.subtitles = [];
      this.options.title &&
        ((this.title = new K(this, this.options.title)),
        this.title.setLayout());
      if (this.options.subtitles)
        for (x = 0; x < this.options.subtitles.length; x++)
          (d = new M(this, this.options.subtitles[x], x)),
            this.subtitles.push(d),
            d.setLayout();
      this.navigator = this.navigator || new z(this, this.options.navigator);
      this.navigator._initialize();
      if (this.navigator.enabled) {
        d = {
          theme:
            this.options.navigator && this.options.navigator.theme
              ? this.options.navigator.theme
              : this.theme,
          animationEnabled:
            this.options.navigator &&
            !f(this.options.navigator.animationEnabled)
              ? this.options.navigator.animationEnabled
              : this.animationEnabled,
          animationDuration:
            this.options.navigator && this.options.navigator.animationDuration
              ? this.options.navigator.animationDuration
              : this.animationDuration,
          culture:
            this.options.navigator && this.options.navigator.culture
              ? this.options.navigator.culture
              : this.culture,
          zoomEnabled: !1,
          data:
            this.options.navigator && this.options.navigator.data
              ? this.options.navigator.data
              : this.options.charts &&
                this.options.charts[0] &&
                this.options.charts[0].data
              ? $a(this.options.charts[0].data)
              : [],
          axisX:
            this.options.navigator && this.options.navigator.axisX
              ? this.options.navigator.axisX
              : {},
          axisY:
            this.options.navigator && this.options.navigator.axisY
              ? this.options.navigator.axisY
              : {},
          axisX2:
            this.options.navigator && this.options.navigator.axisX2
              ? this.options.navigator.axisX2
              : {},
          axisY2:
            this.options.navigator && this.options.navigator.axisY2
              ? this.options.navigator.axisY2
              : {},
          interactivityEnabled: !1,
          exportEnabled: !1,
        };
        for (x = 0; x < d.data.length; x++)
          !f(this.navigator.options.data) ||
          (!f(d.data[x].type) &&
            (f(d.data[x].type) ||
              0 <= d.data[x].type.indexOf("range") ||
              0 <= d.data[x].type.indexOf("ohlc") ||
              0 <= d.data[x].type.indexOf("candlestick") ||
              0 <= d.data[x].type.indexOf("error")))
            ? this.navigator.options.data &&
              f(this.navigator.options.data[x].type) &&
              (d.data[x].type = "splineArea")
            : (d.data[x].type = "splineArea");
        if (d.axisX.length)
          for (x = 0; x < d.axisX.length; x++)
            (d.axisX[x].titleFontSize = f(d.axisX[x].titleFontSize)
              ? 1
              : d.axisX[x].titleFontSize),
              (d.axisX[x].labelFontSize = f(d.axisX[x].labelFontSize)
                ? 12
                : d.axisX[x].labelFontSize),
              (d.axisX[x].labelAngle = f(d.axisX[x].labelAngle)
                ? 0
                : d.axisX[x].labelAngle),
              (d.axisX[x].labelPlacement = f(d.axisX[x].labelPlacement)
                ? "inside"
                : d.axisX[x].labelPlacement),
              (d.axisX[x].tickLength = f(d.axisX[x].tickLength)
                ? 0
                : d.axisX[x].tickLength),
              (d.axisX[x].lineThickness = f(d.axisX[x].lineThickness)
                ? 0
                : d.axisX[x].lineThickness),
              (d.axisX[x].tickThickness = f(d.axisX[x].tickThickness)
                ? 0
                : d.axisX[x].tickThickness),
              (d.axisX[x].gridThickness = f(d.axisX[x].gridThickness)
                ? 1
                : d.axisX[x].gridThickness);
        else
          (d.axisX.titleFontSize =
            this.options.navigator &&
            this.options.navigator.axisX &&
            !f(this.options.navigator.axisX.titleFontSize)
              ? this.options.navigator.axisX.titleFontSize
              : v
              ? 0
              : 1),
            (d.axisX.labelFontSize =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.labelFontSize)
                ? this.options.navigator.axisX.labelFontSize
                : 12),
            (d.axisX.labelAngle =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.labelAngle)
                ? this.options.navigator.axisX.labelAngle
                : 0),
            (d.axisX.labelPlacement =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.labelPlacement)
                ? this.options.navigator.axisX.labelPlacement
                : "inside"),
            (d.axisX.tickLength =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.tickLength)
                ? this.options.navigator.axisX.tickLength
                : 0),
            (d.axisX.lineThickness =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.lineThickness)
                ? this.options.navigator.axisX.lineThickness
                : 0),
            (d.axisX.tickThickness =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.tickThickness)
                ? this.options.navigator.axisX.tickThickness
                : 0),
            (d.axisX.gridThickness =
              this.options.navigator &&
              this.options.navigator.axisX &&
              !f(this.options.navigator.axisX.gridThickness)
                ? this.options.navigator.axisX.gridThickness
                : 1);
        if (d.axisY.length)
          for (x = 0; x < d.axisY.length; x++)
            (d.axisY[x].titleFontSize = d.axisY[x].titleFontSize
              ? d.axisY[x].titleFontSize
              : v
              ? 0
              : 1),
              (d.axisY[x].labelFontSize = d.axisY[x].labelFontSize
                ? d.axisY[x].labelFontSize
                : v
                ? 0
                : 1),
              (d.axisY[x].labelPlacement = d.axisY[x].labelPlacement
                ? d.axisY[x].labelPlacement
                : "inside"),
              (d.axisY[x].includeZero = !1),
              (d.axisY[x].lineThickness = 0),
              (d.axisY[x].tickThickness = 0),
              (d.axisY[x].tickLength = 0),
              (d.axisY[x].gridThickness = 0);
        else
          (d.axisY.titleFontSize =
            this.options.navigator &&
            this.options.navigator.axisY &&
            this.options.navigator.axisY.titleFontSize
              ? this.options.navigator.axisY.titleFontSize
              : v
              ? 0
              : 1),
            (d.axisY.labelFontSize =
              this.options.navigator &&
              this.options.navigator.axisY &&
              this.options.navigator.axisY.labelFontSize
                ? this.options.navigator.axisY.labelFontSize
                : v
                ? 0
                : 1),
            (d.axisY.labelPlacement =
              this.options.navigator &&
              this.options.navigator.axisY &&
              this.options.navigator.axisY.labelPlacement
                ? this.options.navigator.axisY.labelPlacement
                : "inside"),
            (d.axisY.includeZero = !1),
            (d.axisY.lineThickness = 0),
            (d.axisY.tickThickness = 0),
            (d.axisY.tickLength = 0),
            (d.axisY.gridThickness = 0);
        if (d.axisX2.length)
          for (x = 0; x < d.axisX2.length; x++)
            (d.axisX2[x].titleFontSize = d.axisX2[x].titleFontSize
              ? d.axisX2[x].titleFontSize
              : v
              ? 0
              : 1),
              (d.axisX2[x].labelFontSize = d.axisX2[x].labelFontSize
                ? d.axisX2[x].labelFontSize
                : 12),
              (d.axisX2[x].labelAngle = f(d.axisX2[x].labelAngle)
                ? 0
                : d.axisX2[x].labelAngle),
              (d.axisX2[x].labelPlacement = d.axisX2[x].labelPlacement
                ? d.axisX2[x].labelPlacement
                : "inside"),
              (d.axisX2[x].tickLength = f(d.axisX2[x].tickLength)
                ? 0
                : d.axisX2[x].tickLength),
              (d.axisX2[x].lineThickness = d.axisX2[x].lineThickness
                ? d.axisX2[x].lineThickness
                : 0),
              (d.axisX2[x].tickThickness = d.axisX2[x].tickThickness
                ? d.axisX2[x].tickThickness
                : 1),
              (d.axisX2[x].gridThickness = f(d.axisX2[x].gridThickness)
                ? 1
                : d.axisX2[x].gridThickness);
        else
          (d.axisX2.titleFontSize =
            this.options.navigator &&
            this.options.navigator.axisX2 &&
            this.options.navigator.axisX2.titleFontSize
              ? this.options.navigator.axisX2.titleFontSize
              : v
              ? 0
              : 1),
            (d.axisX2.labelFontSize =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.labelFontSize
                ? this.options.navigator.axisX2.labelFontSize
                : 12),
            (d.axisX2.labelAngle =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.labelAngle
                ? this.options.navigator.axisX2.labelAngle
                : 0),
            (d.axisX2.labelPlacement =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.labelPlacement
                ? this.options.navigator.axisX2.labelPlacement
                : "inside"),
            (d.axisX2.tickLength =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.tickLength
                ? this.options.navigator.axisX2.tickLength
                : 0),
            (d.axisX2.lineThickness =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.lineThickness
                ? this.options.navigator.axisX2.lineThickness
                : 0),
            (d.axisX2.tickThickness =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.tickThickness
                ? this.options.navigator.axisX2.tickThickness
                : 1),
            (d.axisX2.gridThickness =
              this.options.navigator &&
              this.options.navigator.axisX2 &&
              this.options.navigator.axisX2.gridThickness
                ? this.options.navigator.axisX2.gridThickness
                : 1);
        if (d.axisY2.length)
          for (x = 0; x < d.axisY2.length; x++)
            (d.axisY2[x].titleFontSize = d.axisY2[x].titleFontSize
              ? d.axisY2[x].titleFontSize
              : v
              ? 0
              : 1),
              (d.axisY2[x].labelFontSize = d.axisY2[x].labelFontSize
                ? d.axisY2[x].labelFontSize
                : v
                ? 0
                : 1),
              (d.axisY2[x].labelPlacement = d.axisY2[x].labelPlacement
                ? d.axisY2[x].labelPlacement
                : "inside"),
              (d.axisY2[x].includeZero = !1),
              (d.axisY2[x].lineThickness = 0),
              (d.axisY2[x].margin = 0),
              (d.axisY2[x].tickLength = 0),
              (d.axisY2[x].tickThickness = 0),
              (d.axisY2[x].gridThickness = 0);
        else
          (d.axisY2.titleFontSize =
            this.options.navigator &&
            this.options.navigator.axisY2 &&
            this.options.navigator.axisY2.titleFontSize
              ? this.options.navigator.axisY2.titleFontSize
              : v
              ? 0
              : 1),
            (d.axisY2.labelFontSize =
              this.options.navigator &&
              this.options.navigator.axisY2 &&
              this.options.navigator.axisY2.labelFontSize
                ? this.options.navigator.axisY2.labelFontSize
                : v
                ? 0
                : 1),
            (d.axisY2.labelPlacement =
              this.options.navigator &&
              this.options.navigator.axisY2 &&
              this.options.navigator.axisY2.labelPlacement
                ? this.options.navigator.axisY2.labelPlacement
                : "inside"),
            (d.axisY2.includeZero = !1),
            (d.axisY2.lineThickness = 0),
            (d.axisY2.margin = 0),
            (d.axisY2.tickLength = 0),
            (d.axisY2.tickThickness = 0),
            (d.axisY2.gridThickness = 0);
        d.backgroundColor = this.navigator.backgroundColor;
        for (x = 0; x < d.data.length; x++)
          d.data[x].markerSize = d.data[x].markerSize
            ? d.data[x].markerSize
            : 0;
        if (!this.navigator.chart) {
          var t = k("canvasjs-chart-panel");
          this.navigator.panel.appendChild(t);
          t.style.height = this.navigator.height + "px";
          t.style.width = this.navigator.width + "px";
        }
        this.navigator.chart &&
          (this.navigator.chart.panel.style.width =
            this.navigator.width + "px");
        this.navigator.chart =
          this.navigator.chart ||
          new Ka(t, d, {
            parent: this.navigator,
            isOptionsInArray: !1,
            index: null,
            predefinedThemes: cb,
            optionsName: "navigator",
            stockChart: this,
          });
        this.navigator.chart._initialize();
        this.navigator.chart.setLayout();
        this.navigator.chart.selectedColorSet = this.selectedColorSet;
        this.navigator._chartOptions = d;
        this.navigator.slider =
          this.navigator.slider || new N(this.navigator, this.options);
        this.navigator.slider._initialize();
      }
      this.rangeSelector = this.rangeSelector || new O(this, this.options);
      this.rangeSelector.buttonStyle =
        this.rangeSelector.buttonStyle ||
        new X(this, this.rangeSelector.options);
      this.rangeSelector.inputFields =
        this.rangeSelector.inputFields ||
        new W(this, this.rangeSelector.options);
      this.rangeSelector.inputFields.style = new Y(
        this,
        this.rangeSelector.inputFields.options
      );
      this.rangeSelector.inputFields.style._updateOptions();
      this.rangeSelector.inputFields._initialize();
      if (
        this.rangeSelector.inputFields &&
        this.rangeSelector.inputFields.enabled
      )
        for (
          this.rangeSelector.inputFields._textBlocks = [],
            this.rangeSelector.inputFields._labels = [],
            this.rangeSelector.inputFieldsWidth = 0,
            t = this.rangeSelector.inputFields.style.maxWidth =
              this.rangeSelector.inputFields.style.options.maxWidth
                ? this.rangeSelector.inputFields.style.options.maxWidth
                : this.rangeSelector.stockChart.width / 2,
            x = 0;
          x < this.rangeSelector.inputFields.elements.length;
          x++
        ) {
          d = new na(this.rangeSelector.ctx, {
            x: 0,
            y: 0,
            backgroundColor:
              this.rangeSelector.inputFields.style.backgroundColor,
            borderColor: this.rangeSelector.inputFields.style.borderColor,
            borderThickness:
              this.rangeSelector.inputFields.style.borderThickness,
            cornerRadius: 0,
            maxWidth: f(this.rangeSelector.inputFields.style.options.width)
              ? t
              : this.rangeSelector.inputFields.style.width,
            maxHeight: 2 * this.rangeSelector.inputFields.style.fontSize,
            angle: 0,
            padding: this.rangeSelector.inputFields.style.padding,
            text: this.rangeSelector.inputFields.valueFormatString,
            horizontalAlign: "center",
            textAlign: "center",
            fontSize: this.rangeSelector.inputFields.style.fontSize,
            fontFamily: this.rangeSelector.inputFields.style.fontFamily,
            fontWeight: this.rangeSelector.inputFields.style.fontWeight,
            fontColor: this.rangeSelector.inputFields.style.fontColor,
            fontStyle: this.rangeSelector.inputFields.style.fontStyle,
            textBaseline: "middle",
          });
          var u = d.measureText(),
            a = new na(this.rangeSelector.ctx, {
              x: 0,
              y: 0,
              backgroundColor: v ? "transparent" : null,
              borderColor: this.rangeSelector.inputFields.style.borderColor,
              borderThickness: 0,
              cornerRadius: 0,
              maxWidth: this.rangeSelector.inputFields.style.maxWidth,
              maxHeight: 2 * this.rangeSelector.inputFields.style.fontSize,
              angle: 0,
              padding: this.rangeSelector.inputFields.style.padding,
              text: "From",
              horizontalAlign: "left",
              fontSize: this.rangeSelector.inputFields.style.fontSize,
              fontFamily: this.rangeSelector.inputFields.style.fontFamily,
              fontWeight: this.rangeSelector.inputFields.style.fontWeight,
              fontColor: this.rangeSelector.inputFields.style.fontColor,
              fontStyle: this.rangeSelector.inputFields.style.fontStyle,
              textBaseline: "middle",
            });
          this.rangeSelector.inputFields._textBlocks.push(d);
          this.rangeSelector.inputFields._labels.push(a);
          this.rangeSelector.inputFields._textBlocks[x].bounds = {
            x1: null,
            x2: null,
            y1: null,
            y2: null,
            width: null,
            height: null,
          };
          this.rangeSelector.inputFields._labels[x].bounds = {
            x1: null,
            x2: null,
            y1: null,
            y2: null,
            width: null,
            height: null,
          };
          this.rangeSelector.inputFieldsWidth +=
            u.width +
            this.rangeSelector.inputFields.style.spacing +
            a.measureText().width;
          this.rangeSelector.inputFieldsHeight =
            this.rangeSelector.inputFieldsHeight < u.height
              ? u.height
              : this.rangeSelector.inputFieldsHeight;
          d = this.rangeSelector.inputFields._textBlocks[x];
          d.id = ++this.rangeSelector.stockChart._eventManager.lastObjectId;
          this.rangeSelector.stockChart._eventManager.objectMap[d.id] = {
            id: d.id,
            objectType: "inputFields",
            inputFieldIndex: x,
          };
        }
      this.rangeSelector.buttonStyle._updateOptions();
      this.rangeSelector._initialize();
      this._objectsInitialized = !0;
    };
    F.prototype.render = function (d) {
      var u = this;
      d && (this.options = d);
      this._initialize();
      this.title && this.title.render();
      if (this.subtitles)
        for (d = 0; d < this.subtitles.length; d++) this.subtitles[d].render();
      var x;
      if (this.options.charts) {
        x = Array(this.options.charts.length);
        var t = this.layoutManager.getFreeSpace(),
          a = t.height,
          t = t.height,
          e = this.options.charts.length;
        for (d = 0; d < this.options.charts.length; d++)
          f(this.options.charts[d].height) ||
            ((x[d] =
              0 <= this.options.charts[d].height.toString().indexOf("%")
                ? Wa(
                    this.options.charts[d].height,
                    a,
                    Math.floor(t / e),
                    this.height,
                    0
                  )
                : this.options.charts[d].height),
            (t -= x[d]),
            e--);
        t = Math.floor(t / e);
        for (d = 0; d < this.options.charts.length; d++) f(x[d]) && (x[d] = t);
        var b,
          e = this.options.charts,
          c = this.charts;
        this.charts = [];
        for (d = 0; d < e.length; d++) {
          t = this.layoutManager.getFreeSpace();
          a = e[d];
          a.theme = e[d].theme
            ? e[d].theme
            : this.options.theme
            ? this.options.theme
            : this.theme;
          a.animationEnabled = f(e[d].animationEnabled)
            ? this.animationEnabled
            : e[d].animationEnabled;
          a.animationDuration = e[d].animationDuration
            ? e[d].animationDuration
            : this.animationDuration;
          a.culture = e[d].culture ? e[d].culture : this.culture;
          a.height = e[d].height ? x[d] : null;
          f(e.backgroundColor)
            ? f(this.options.backgroundColor) ||
              (a.backgroundColor = this.backgroundColor)
            : (a.backgroundColor = this.options.charts[d].backgroundColor);
          for (b = c.length; 0 < b-- && c[b].options !== a; );
          0 <= b
            ? ((this.charts[d] = c[b]), (this.charts[d].options = a))
            : ((b = k("canvasjs-chart-panel")),
              (b.style.height = x[d] + "px"),
              this._canvasJSContainer.appendChild(b),
              (this.charts[d] = new Ka(b, a, {
                parent: this,
                isOptionsInArray: !0,
                index: d,
                predefinedThemes: cb,
                optionsName: "charts",
                stockChart: this,
              })));
          this.charts[d].panel.style.width = t.width + "px";
          this.charts[d].panel.style.top = t.y1 + "px";
          this.charts[d].panel.style.left = t.x1 + "px";
          this.charts[d].panel.style.height = x[d] + "px";
          this.charts[d].height = a.height ? a.height : x[d];
          this.layoutManager.registerSpace("top", {
            width: t.width,
            height: x[d],
          });
        }
        c = null;
        for (d = 0; d < this.charts.length; d++)
          if (!f(this.options.charts[d].data))
            for (b = 0; b < this.options.charts[d].data.length; b++)
              (x = this.options.charts[d].data[b]),
                0 <= F._supportedChartTypes.indexOf(x.type) ||
                  f(x.type) ||
                  ((ea = !1),
                  window.console &&
                    window.console.log(
                      "CanvasJS Error: " +
                        x.type +
                        " Chart is not Supported in StockChart"
                    ));
        if (!ea) return;
        this.setChartsLayout();
        for (d = x = 0; d < this.charts.length; d++)
          if (f(this.charts[d].options.colorSet)) {
            this.charts[d].selectedColorSet = [];
            for (b = x; b < x + this.charts[d].data.length; b++)
              this.charts[d].selectedColorSet.push(
                this.selectedColorSet[b % this.selectedColorSet.length]
              );
            x += this.charts[d].data.length;
          }
        if (this.navigator && this.navigator.enabled)
          if (this.navigator.options.data) {
            this.navigator.chart.selectedColorSet = [];
            for (b = x; b < x + this.navigator.chart.data.length; b++)
              this.navigator.chart.selectedColorSet.push(
                this.selectedColorSet[b % this.selectedColorSet.length]
              );
            x += this.navigator.chart.data.length;
          } else
            this.navigator.chart.selectedColorSet =
              this.charts[0].selectedColorSet;
      }
      if (this.navigator && this.navigator.enabled) {
        for (d = 0; d < this.navigator.chart.data.length; d++)
          0 <=
            F._supportedChartTypes.indexOf(this.navigator.chart.data[d].type) ||
            ((ea = !1),
            window.console &&
              window.console.log(
                "CanvasJS Error: " +
                  this.navigator.chart.data[d].type +
                  " Chart is not Supported in Navigator"
              ));
        if (ea) {
          var g =
            this.navigator.chart.axisX && this.navigator.chart.axisX.length
              ? this.navigator.chart.axisX[0]
              : this.navigator.chart.axisX2[0];
          g.bounds.x1 > this._chartsPlotAreaX1 &&
            (this._chartsPlotAreaX1 = g.bounds.x1);
          this.navigator.width =
            this.navigator.chart.width =
            this.navigator.slider.fullWidth =
              this.navigator.options.width
                ? this.navigator.options.width
                : this._chartsPlotAreaX2 - this._chartsPlotAreaX1 + g.bounds.x1;
          this.navigator.panel.style.left =
            this._chartsPlotAreaX1 +
            this.layoutManager.getFreeSpace().x1 -
            g.bounds.x1 +
            "px";
          this.navigator.panel.style.width =
            this.navigator.chart.panel.style.width = this.navigator.options
              .width
              ? this.navigator.options.width
              : this._chartsPlotAreaX2 -
                this._chartsPlotAreaX1 +
                g.bounds.x1 +
                "px";
          this.navigator.chart.render(this.navigator._chartOptions);
          this.navigator.backgroundColor = this.navigator.chart.backgroundColor;
          this.navigator.animationEnabled =
            this.navigator.chart.animationEnabled;
          this.navigator.animationDuration =
            this.navigator.chart.animationDuration;
          this.navigator.theme = this.navigator.chart.theme;
          this.navigator.axisX = this.navigator.chart.axisX;
          this.navigator.axisX2 = this.navigator.chart.axisX2;
          this.navigator.axisY = this.navigator.chart.axisY;
          this.navigator.axisY2 = this.navigator.chart.axisY2;
          this.navigator.data = this.navigator.chart.data;
        }
      }
      t = x = null;
      b = 0;
      e = a = null;
      for (d = 0; d < this.charts.length; d++)
        for (
          c =
            this.charts[d].axisX && this.charts[d].axisX.length
              ? this.charts[d].axisX
              : this.charts[d].axisX2,
            x = x || (c && 0 < c.length ? c[0].minimum : null),
            t = t || (c && 0 < c.length ? c[0].maximum : null),
            b = 0;
          b < c.length;
          b++
        )
          (g = c[b]),
            g.minimum < x && (x = g.minimum),
            g.maximum > t && (t = g.maximum);
      var h;
      this.navigator &&
        this.navigator.chart &&
        ea &&
        ((h =
          this.navigator.chart.axisX && 0 < this.navigator.chart.axisX.length
            ? this.navigator.chart.axisX[0]
            : this.navigator.chart.axisX2[0]),
        (this._axisXMin = this.navigator.slider.minimum =
          f(this.navigator.options.slider) ||
          f(this.navigator.options.slider.minimum)
            ? null
            : Math.max(h.minimum, this.navigator.slider.minimum)),
        (this._axisXMax = this.navigator.slider.maximum =
          f(this.navigator.options.slider) ||
          f(this.navigator.options.slider.maximum)
            ? null
            : Math.min(h.maximum, this.navigator.slider.maximum)));
      if (this.rangeSelector && this.rangeSelector.enabled) {
        b = h ? h.maximum - h.minimum : t - x;
        this.charts &&
          this.charts.length &&
          (g =
            this.charts[0].axisX && this.charts[0].axisX.length
              ? this.charts[0].axisX[0]
              : this.charts[0].axisX2[0]);
        for (d = 0; d < this.rangeSelector.buttons.length; d++) {
          var s = null,
            c = this.rangeSelector.buttons[d];
          "year" === c.rangeType
            ? (s = 31104e6 * c.range)
            : "ytd" === c.rangeType
            ? (s = "ytd")
            : "month" === c.rangeType
            ? (s = 2592e6 * c.range)
            : "week" === c.rangeType
            ? (s = 6048e5 * c.range)
            : "day" === c.rangeType
            ? (s = 864e5 * c.range)
            : "hour" === c.rangeType
            ? (s = 36e5 * c.range)
            : "minute" === c.rangeType
            ? (s = 6e4 * c.range)
            : "second" === c.rangeType
            ? (s = 1e3 * c.range)
            : "millisecond" === c.rangeType
            ? (s = c.range)
            : "all" === c.rangeType
            ? (s = null)
            : "number" === c.rangeType && (s = c.range);
          if ("ytd" === c.rangeType || s < b) c.enabled = !0;
          c.enabled
            ? ((c.cursor = this.rangeSelector.buttonStyle.cursor),
              "on" === c.state &&
                ((f(this._axisXMin) &&
                  f(this._axisXMax) &&
                  ((c.textBlock.fontWeight = "bold"),
                  (c.textBlock.fontColor =
                    this.rangeSelector.buttonStyle.labelFontColorOnHover),
                  (c.textBlock.backgroundColor =
                    this.rangeSelector.buttonStyle.backgroundColorOnSelect)),
                "ytd" === c.rangeType && g)
                  ? ((a = new Date(g.viewportMaximum)),
                    a.setDate(1),
                    a.setMonth(0),
                    (a = a.getTime()))
                  : f(s)
                  ? h
                    ? ((a = h.minimum), (e = h.maximum))
                    : g && ((a = g.minimum), (e = g.maximum))
                  : g.viewportMaximum - s < (h ? h.minimum : g.minimum)
                  ? ((e = h.minimum - (g.viewportMaximum - s)),
                    (a = h.minimum),
                    (e = Math.min(h.maximum, g.viewportMaximum + e)))
                  : ((a = g.viewportMaximum - s), (e = g.viewportMaximum))),
              (f(this._axisXMin) && f(this._axisXMax)) || (c.state = "off"),
              (this._axisXMin = f(this._axisXMin) ? a : this._axisXMin),
              (this._axisXMax = f(this._axisXMax) ? e : this._axisXMax))
            : (c.cursor = "not-allowed");
          c.mousemove = function (a) {
            this.enabled &&
              "off" === this.state &&
              ((this.textBlock.backgroundColor =
                a.stockChart.rangeSelector.buttonStyle.backgroundColorOnHover),
              (this.textBlock.fontColor =
                a.stockChart.rangeSelector.buttonStyle.labelFontColorOnHover),
              this.textBlock.render(!0));
          };
          c.mouseover = function (a) {
            this.enabled &&
              "off" === this.state &&
              ((this.textBlock.backgroundColor =
                a.stockChart.rangeSelector.buttonStyle.backgroundColorOnHover),
              (this.textBlock.fontColor =
                a.stockChart.rangeSelector.buttonStyle.labelFontColorOnHover),
              this.textBlock.render(!0));
          };
          c.mouseout = function (a) {
            this.enabled &&
              "off" === this.state &&
              ((this.textBlock.backgroundColor =
                a.stockChart.rangeSelector.buttonStyle.backgroundColor),
              (this.textBlock.fontColor =
                a.stockChart.rangeSelector.buttonStyle.labelFontColor),
              this.textBlock.render(!0));
          };
          c.click = function (a) {
            if (this.enabled) {
              for (
                var b = 0, c = null, d = null, e = 0;
                e < u.rangeSelector.buttons.length;
                e++
              )
                u.rangeSelector.buttons[e] != this &&
                  (u.rangeSelector.buttons[e].state = "off"),
                  (u.rangeSelector.buttons[e].textBlock.fontWeight =
                    u.rangeSelector.buttonStyle.labelFontWeight),
                  (u.rangeSelector.buttons[e].textBlock.fontColor =
                    a.stockChart.rangeSelector.buttonStyle.labelFontColor),
                  (u.rangeSelector.buttons[e].textBlock.backgroundColor =
                    a.stockChart.rangeSelector.buttonStyle.backgroundColor),
                  u.rangeSelector.buttons[e].textBlock.render(!0);
              var g;
              u.charts &&
                u.charts.length &&
                (g =
                  u.charts[0].axisX && u.charts[0].axisX.length
                    ? u.charts[0].axisX[0]
                    : u.charts[0].axisX2[0]);
              var h;
              u.navigator &&
                u.navigator.chart &&
                (h = u.navigator.chart.axisX
                  ? u.navigator.chart.axisX[0]
                  : u.navigator.chart.axisX2[0]);
              "year" === this.rangeType
                ? (b = 31104e6 * this.range)
                : "month" === this.rangeType
                ? (b = 2592e6 * this.range)
                : "week" === this.rangeType
                ? (b = 6048e5 * this.range)
                : "day" === this.rangeType
                ? (b = 864e5 * this.range)
                : "hour" === this.rangeType
                ? (b = 36e5 * this.range)
                : "minute" === this.rangeType
                ? (b = 6e4 * this.range)
                : "second" === this.rangeType
                ? (b = 1e3 * this.range)
                : "millisecond" === this.rangeType
                ? (b = this.range)
                : "all" === this.rangeType
                ? (b = null)
                : "number" === this.rangeType && (b = this.range);
              "ytd" === this.rangeType && g
                ? ((c = new Date(g.viewportMaximum)),
                  c.setDate(1),
                  c.setMonth(0),
                  (b = c.getTime()),
                  (c = Math.max(b, h ? h.minimum : g.minimum)),
                  (d = g.viewportMaximum))
                : f(b)
                ? h
                  ? ((c = h.minimum), (d = h.maximum))
                  : g && ((c = g.minimum), (d = g.maximum))
                : h && g.viewportMaximum - b < (h ? h.minimum : g.minimum)
                ? ((h =
                    u.navigator.chart.axisX[0].minimum -
                    (g.viewportMaximum - b)),
                  (c = u.navigator.chart.axisX[0].minimum),
                  (d = Math.min(
                    u.navigator.chart.axisX[0].maximum,
                    g.viewportMaximum + h
                  )))
                : ((c = g.viewportMaximum - b), (d = g.viewportMaximum));
              u._rangeEventParameter = {
                stockChart: u,
                source: "buttons",
                index: this._index,
                minimum: c,
                maximum: d,
              };
              "on" != this.state &&
                ((u._rangeEventParameter.type = "rangeChanging"),
                u.dispatchEvent("rangeChanging", u._rangeEventParameter, u),
                u._syncCharts(c, d),
                (u.sessionVariables._axisXMin = c),
                (u.sessionVariables._axisXMax = d),
                (u._rangeEventParameter.type = "rangeChanged"),
                u.dispatchEvent("rangeChanged", u._rangeEventParameter, u),
                (this.state = "on"));
              this.textBlock.fontWeight = "bold";
              this.textBlock.fontColor =
                a.stockChart.rangeSelector.buttonStyle.labelFontColorOnHover;
              this.textBlock.backgroundColor =
                a.stockChart.rangeSelector.buttonStyle.backgroundColorOnSelect;
              this.textBlock.render(!0);
            }
          };
        }
        if (
          this.rangeSelector.inputFields &&
          this.rangeSelector.inputFields.enabled
        ) {
          this.rangeSelector.inputFields.valueType =
            this.options.rangeSelector &&
            this.options.rangeSelector.inputFields &&
            this.options.rangeSelector.inputFields.valueType
              ? this.options.rangeSelector.inputFields.valueType
              : this.isDateTime
              ? "dateTime"
              : "number";
          for (
            d = 0;
            d < this.rangeSelector.inputFields._textBlocks.length;
            d++
          )
            (g = this.rangeSelector.inputFields._textBlocks[d]),
              (g.mousemove = function (a) {
                a.inputField.cursor =
                  a.stockChart.rangeSelector.inputFields.style.cursor;
              }),
              (g.mouseover = function (a) {
                a.inputField.cursor =
                  a.stockChart.rangeSelector.inputFields.style.cursor;
              }),
              (g.mouseout = function (a) {
                a.inputField.cursor = "auto";
              }),
              (g.click = function (a) {
                a.stockChart.rangeSelector.inputFields.elements[
                  a.inputFieldIndex
                ].style.display = "inline";
                a.stockChart.rangeSelector.inputFields.elements[
                  a.inputFieldIndex
                ].focus();
              });
          if (isFinite(x) && isFinite(t)) {
            "dateTime" === this.rangeSelector.inputFields.valueType
              ? ((this.rangeSelector.inputFields.valueFormatString =
                  this.options.rangeSelector &&
                  this.options.rangeSelector.inputFields &&
                  this.options.rangeSelector.inputFields.valueFormatString
                    ? this.options.rangeSelector.inputFields.valueFormatString
                    : "MMM DD YYYY"),
                (this.rangeSelector.inputFields.startValue = f(
                  this.rangeSelector.inputFields.options.startValue
                )
                  ? f(a)
                    ? x
                    : a
                  : oa(
                      this.rangeSelector.inputFields.options.startValue,
                      this.rangeSelector.inputFields.valueFormatString
                    )),
                (this.rangeSelector.inputFields.endValue = f(
                  this.rangeSelector.inputFields.options.endValue
                )
                  ? f(e)
                    ? t
                    : e
                  : oa(
                      this.rangeSelector.inputFields.options.endValue,
                      this.rangeSelector.inputFields.valueFormatString
                    )))
              : ((this.rangeSelector.inputFields.valueFormatString =
                  this.options.rangeSelector &&
                  this.options.rangeSelector.inputFields &&
                  this.options.rangeSelector.inputFields.valueFormatString
                    ? this.options.rangeSelector.inputFields.valueFormatString
                    : "#,##0.##"),
                (this.rangeSelector.inputFields.startValue = f(
                  this.rangeSelector.inputFields.options.startValue
                )
                  ? f(a)
                    ? x
                    : a
                  : this.rangeSelector.inputFields.options.startValue),
                (this.rangeSelector.inputFields.endValue = f(
                  this.rangeSelector.inputFields.options.endValue
                )
                  ? f(e)
                    ? t
                    : e
                  : this.rangeSelector.inputFields.options.endValue));
            if (
              !(
                f(this._axisXMin) &&
                f(this._axisXMax) &&
                f(this.rangeSelector.inputFields.options.startValue) &&
                f(this.rangeSelector.inputFields.options.endValue)
              )
            )
              for (b = 0; b < this.rangeSelector.buttons.length; b++)
                c = this.rangeSelector.buttons[b];
            d = oa(
              this.rangeSelector.inputFields.startValue,
              "YYYY-MM-DD'T'HH:mm:ssZ"
            );
            g = oa(
              this.rangeSelector.inputFields.endValue,
              "YYYY-MM-DD'T'HH:mm:ssZ"
            );
            v ||
              ((d = d.replace(/-/g, "/")),
              (g = g.replace(/-/g, "/")),
              (d = d.replace("T", " ")),
              (g = g.replace("T", " ")),
              (d = d.replace(/(\+[0-9]{2})(\:)([0-9]{2}$)/, " UTC$1$3")),
              (g = g.replace(/(\+[0-9]{2})(\:)([0-9]{2}$)/, " UTC$1$3")));
            this._axisXMin = f(this._axisXMin)
              ? "dateTime" === this.rangeSelector.inputFields.valueType
                ? new Date(d).getTime()
                : this.rangeSelector.inputFields.startValue
              : this._axisXMin;
            this._axisXMax = f(this._axisXMax)
              ? "dateTime" === this.rangeSelector.inputFields.valueType
                ? new Date(g).getTime()
                : this.rangeSelector.inputFields.endValue
              : this._axisXMax;
          }
          for (d = 0; d < this.rangeSelector.inputFields.elements.length; d++)
            this.rangeSelector.inputFields.elements[d].title =
              "dateTime" === this.rangeSelector.inputFields.valueType
                ? "YYYY-MM-DD"
                : this.rangeSelector.inputFields.valueFormatString;
        }
        this.rangeSelector.render();
      }
      f(this._axisXMin) && (this._axisXMin = x);
      f(this._axisXMax) && (this._axisXMax = t);
      this._axisXMin =
        !f(this.sessionVariables._axisXMin) &&
        this.navigator &&
        this.navigator.slider &&
        !this.navigator.slider.hasOptionChanged("minimum")
          ? this.sessionVariables._axisXMin
          : this._axisXMin;
      this._axisXMax =
        !f(this.sessionVariables._axisXMax) &&
        this.navigator &&
        this.navigator.slider &&
        !this.navigator.slider.hasOptionChanged("maximum")
          ? this.sessionVariables._axisXMax
          : this._axisXMax;
      if (!f(h)) {
        this.navigator.slider.hasOptionChanged("minimum") &&
          (this._axisXMin =
            this.sessionVariables._axisXMin =
            this.navigator.slider.sessionVariables.minimum =
            this.navigator.slider.minimum =
              this.navigator.slider.options.minimum);
        this.navigator.slider.hasOptionChanged("maximum") &&
          (this._axisXMax =
            this.sessionVariables._axisXMax =
            this.navigator.slider.sessionVariables.maximum =
            this.navigator.slider.maximum =
              this.navigator.slider.options.maximum);
        if (this._axisXMin < h.minimum || this._axisXMin > h.maximum)
          this._axisXMin = h.minimum;
        if (this._axisXMax < h.minimum || this._axisXMax > h.maximum)
          this._axisXMax = h.maximum;
      }
      !f(h) && h.reversed
        ? this._syncCharts(this._axisXMax, this._axisXMin)
        : this._syncCharts(this._axisXMin, this._axisXMax);
    };
    F.prototype.setChartsLayout = function () {
      var d,
        f,
        k = 0,
        t = this.width;
      this.isPlotAreaSet = this.isDateTime = !1;
      for (var a = 0; a < this.charts.length; a++) {
        d = this.charts[a];
        d._initialize();
        d.setLayout();
        f = {};
        if ((d.axisX[0] || d.axisX2[0]) && (d.axisY[0] || d.axisY2[0])) {
          var e = d.axisX[0]
            ? d.axisX[0].lineCoordinates
            : d.axisX2[0].lineCoordinates;
          if (d.axisY && 0 < d.axisY.length && d.axisY[0]) {
            var b = d.axisY[0];
            f.x1 = e.x1 < e.x2 ? e.x1 : b.lineCoordinates.x1;
            f.x2 = e.x2 > b.lineCoordinates.x2 ? e.x2 : b.lineCoordinates.x2;
          }
          d.axisY2 &&
            0 < d.axisY2.length &&
            d.axisY2[0] &&
            ((b = d.axisY2[0]),
            (f.x1 = e.x1 < e.x2 ? e.x1 : b.lineCoordinates.x1),
            (f.x2 = e.x2 > b.lineCoordinates.x2 ? e.x2 : b.lineCoordinates.x2));
        }
        for (e = 0; e < d.data.length; e++)
          "dateTime" === d.data[e].xValueType && (this.isDateTime = !0);
        k = Math.max(k, f.x1);
        t = Math.min(t, f.x2);
        d.sessionVariables.plotAreaBounds = f;
      }
      this._chartsPlotAreaX1 = k;
      this._chartsPlotAreaX2 = t;
    };
    F.prototype._updateSize = function () {
      return mb.call(this, [this.canvas, this.overlaidCanvas]);
    };
    F.prototype._syncCharts = function (d, k) {
      for (
        var x = this, t = null, a = Math.min(d, k), e = Math.max(d, k), b = 0;
        b < this.charts.length;
        b++
      ) {
        t = this.charts[b];
        t.toolTip && t.toolTip.enabled && t.toolTip.hide();
        for (var c = 0; c < t.axisX.length; c++)
          t.axisX[c].setViewPortRange(d, k),
            (t.axisX[c].options.labelAngle = f(t.axisX[c].options.labelAngle)
              ? 0
              : t.axisX[c].options.labelAngle),
            this.charts[b].axisX[c].crosshair &&
              this.charts[b].axisX[c].crosshair.enabled &&
              !this.charts[b].axisX[c].crosshair.options.updated &&
              (this.charts[b].axisX[c].crosshair.options.updated = function (
                a
              ) {
                for (var b = 0; b < x.charts.length; b++)
                  if (x.charts[b] != a.chart)
                    for (var c = 0; c < x.charts[b].axisX.length; c++)
                      x.charts[b].axisX[c].crosshair &&
                        x.charts[b].axisX[c].crosshair.showAt(a.value);
              });
        for (c = 0; c < t.axisX2.length; c++)
          t.axisX2[c].setViewPortRange(d, k),
            (t.axisX2[c].options.labelAngle = f(t.axisX2[c].options.labelAngle)
              ? 0
              : t.axisX2[c].options.labelAngle),
            this.charts[b].axisX2[c].crosshair &&
              this.charts[b].axisX2[c].crosshair.enabled &&
              !this.charts[b].axisX2[c].crosshair.options.updated &&
              (this.charts[b].axisX2[c].crosshair.options.updated = function (
                a
              ) {
                for (var b = 0; b < x.charts.length; b++)
                  if (x.charts[b] != a.chart)
                    for (var c = 0; c < x.charts[b].axisX2.length; c++)
                      x.charts[b].axisX2[c].crosshair &&
                        x.charts[b].axisX2[c].crosshair.showAt(a.value);
              });
        t._initialize();
        t.setLayout();
        t.panEnabled = t.options.zoomEnabled && t.zoomEnabled ? !1 : !0;
        t.renderElements();
        (f(this.charts[b].options.toolTip) ||
          (!f(this.charts[b].options.toolTip) &&
            f(this.charts[b].options.toolTip.updated))) &&
          this.charts[b].toolTip &&
          (this.charts[b].toolTip.updated = function (a) {
            for (var b = 0; b < x.charts.length; b++)
              x.charts[b] != a.chart &&
                x.charts[b].toolTip.showAtX(
                  a.entries[0].xValue,
                  a.entries[0].dataSeriesIndex
                );
          });
        (f(this.charts[b].options.toolTip) ||
          (!f(this.charts[b].options.toolTip) &&
            f(this.charts[b].options.toolTip.hidden))) &&
          this.charts[b].toolTip &&
          (this.charts[b].toolTip.hidden = function (a) {
            for (var b = 0; b < x.charts.length; b++)
              x.charts[b] != a.chart && x.charts[b].toolTip.hide();
          });
      }
      this.rangeSelector &&
        this.rangeSelector.enabled &&
        this.rangeSelector.inputFields &&
        this.rangeSelector.inputFields.enabled &&
        this.rangeSelector._updateInputFields(a, e);
      this.navigator &&
        this.navigator.enabled &&
        this.navigator._updateSlider(a, e);
    };
    F.prototype.destroy = function () {
      for (var d = this.allDOMEventHandlers, f = 0; f < this.charts.length; f++)
        this.charts[f].destroy();
      this.navigator &&
        this.navigator.enabled &&
        this.navigator.chart.destroy();
      for (f = 0; f < d.length; f++) hb(d[f][0], d[f][1], d[f][2], d[f][3]);
      for (
        this.allDOMEventHandlers = [];
        this.navigator &&
        this.navigator.enabled &&
        this.navigator.panel.hasChildNodes();

      )
        this.navigator.panel.removeChild(this.navigator.panel.lastChild);
      for (
        ;
        this._canvasJSContainer && this._canvasJSContainer.hasChildNodes();

      )
        this._canvasJSContainer.removeChild(this._canvasJSContainer.lastChild);
      for (; this.container && this.container.hasChildNodes(); )
        this.container.removeChild(this.container.lastChild);
      this.canvas = this.container = this._canvasJSContainer = null;
      this.navigator.panel = null;
      this.rangeSelector.panel = null;
    };
    F.prototype.exportChart = function (d) {
      d = "undefined" === typeof d ? {} : d;
      var f = d.format ? d.format : "png",
        k = d.fileName ? d.fileName : this.exportFileName,
        t = this.canvas.cloneNode();
      t.setAttribute("class", t.getAttribute("class") + "-clone");
      var a = t.getContext("2d");
      a.drawImage(this.canvas, 0, 0);
      for (var e = [], b = 0; b < this.charts.length; b++) {
        var c = this.charts[b];
        e.push({
          canvas: c.canvas,
          position: { x: c.container.offsetLeft, y: c.container.offsetTop },
        });
        e.push({
          canvas: c.overlaidCanvas,
          position: { x: c.container.offsetLeft, y: c.container.offsetTop },
        });
      }
      this.navigator &&
        this.navigator.enabled &&
        ((b = this.navigator),
        e.push({
          canvas: b.chart.canvas,
          position: { x: b.panel.offsetLeft, y: b.panel.offsetTop },
        }),
        e.push({
          canvas: b.chart.overlaidCanvas,
          position: { x: b.panel.offsetLeft, y: b.panel.offsetTop },
        }));
      for (b = 0; b < e.length; b++)
        a.drawImage(e[b].canvas, e[b].position.x * ia, e[b].position.y * ia);
      if (d.toDataURL) return t.toDataURL("image/" + f);
      eb(t, f, k);
    };
    F.prototype.print = function () {
      var d = this.exportChart({ toDataURL: !0 }),
        f = document.createElement("iframe");
      f.setAttribute("class", "canvasjs-chart-print-frame");
      f.setAttribute(
        "style",
        "position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;"
      );
      f.style.height = this.height + "px";
      this._canvasJSContainer.appendChild(f);
      var k = this,
        t = f.contentWindow || f.contentDocument.document || f.contentDocument;
      t.document.open();
      t.document.write(
        '<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="' +
          d +
          '"/><body/></html>'
      );
      t.document.close();
      setTimeout(function () {
        t.focus();
        t.print();
        setTimeout(function () {
          k._canvasJSContainer.removeChild(f);
        }, 1e3);
      }, 500);
    };
    F.prototype.getObjectAtXY = function (d, k, x) {
      x = null;
      if (!f(this.rangeSelector)) {
        for (var t = 0; t < this.rangeSelector.buttons.length; t++) {
          var a = this.rangeSelector.buttons[t];
          d >= a.bounds.x1 &&
            d <= a.bounds.x2 &&
            k >= a.bounds.y1 &&
            k <= a.bounds.y2 &&
            (x = a.id);
        }
        for (t = 0; t < this.rangeSelector.inputFields._textBlocks.length; t++)
          (a = this.rangeSelector.inputFields._textBlocks[t]),
            d >= a.bounds.x1 &&
              d <= a.bounds.x2 &&
              k >= a.bounds.y1 &&
              k <= a.bounds.y2 &&
              (x = a.id);
      }
      return x;
    };
    F.prototype._touchEventHandler = function (d) {
      if (d.changedTouches) {
        var k = [],
          x = d.changedTouches,
          t = x ? x[0] : d,
          a = null;
        switch (d.type) {
          case "touchstart":
          case "MSPointerDown":
            k = ["mousemove", "mousedown"];
            this._lastTouchData = Ba(t);
            this._lastTouchData.time = new Date();
            break;
          case "touchmove":
          case "MSPointerMove":
            k = ["mousemove"];
            break;
          case "touchend":
          case "MSPointerUp":
            var e =
                this._lastTouchData && this._lastTouchData.time
                  ? new Date() - this._lastTouchData.time
                  : 0,
              k =
                "touchstart" === this._lastTouchEventType ||
                "MSPointerDown" === this._lastTouchEventType ||
                300 > e
                  ? ["mouseup", "click"]
                  : ["mouseup"];
            break;
          default:
            return;
        }
        if (!(x && 1 < x.length)) {
          a = Ba(t);
          a.time = new Date();
          try {
            var b = a.y - this._lastTouchData.y,
              e = a.time - this._lastTouchData.time;
            if (
              (1 < Math.abs(b) && this._lastTouchData.scroll) ||
              (5 < Math.abs(b) && 250 > e)
            )
              this._lastTouchData.scroll = !0;
          } catch (c) {}
          this._lastTouchEventType = d.type;
          if (this._lastTouchData && this._lastTouchData.scroll)
            this.isDrag && this.resetOverlayedCanvas(), (this.isDrag = !1);
          else
            for (x = 0; x < k.length; x++)
              if (
                ((a = k[x]),
                (b = document.createEvent("MouseEvent")),
                b.initMouseEvent(
                  a,
                  !0,
                  !0,
                  window,
                  1,
                  t.screenX,
                  t.screenY,
                  t.clientX,
                  t.clientY,
                  !1,
                  !1,
                  !1,
                  !1,
                  0,
                  null
                ),
                t.target.dispatchEvent(b),
                (this._lastTouchData &&
                  !f(this._lastTouchData.scroll) &&
                  !this._lastTouchData.scroll) ||
                  (this._lastTouchData &&
                    !this._lastTouchData.scroll &&
                    250 < e) ||
                  "click" === a)
              )
                d.preventManipulation && d.preventManipulation(),
                  d.preventDefault && d.cancelable && d.preventDefault();
        }
      }
    };
    F.prototype._mouseEventHandler = function (d) {
      "undefined" === typeof d.target &&
        d.srcElement &&
        (d.target = d.srcElement);
      var f = Ba(d),
        k = d.type,
        t,
        a;
      d.which ? (a = 3 == d.which) : d.button && (a = 2 == d.button);
      F.capturedEventParam &&
        ((t = F.capturedEventParam),
        "mouseup" === k &&
          ((F.capturedEventParam = null),
          t.stockChart.overlaidCanvas.releaseCapture
            ? t.stockChart.overlaidCanvas.releaseCapture()
            : document.documentElement.removeEventListener(
                "mouseup",
                t.stockChart._mouseEventHandler,
                !1
              )),
        t.hasOwnProperty(k) &&
          ("mouseup" !== k || t.stockChart.overlaidCanvas.releaseCapture
            ? (d.target !== t.stockChart.overlaidCanvas && v) ||
              t[k].call(t.context, f.x, f.y)
            : d.target !== t.stockChart.overlaidCanvas &&
              (t.stockChart.isDrag = !1)));
      if (this._ignoreNextEvent) this._ignoreNextEvent = !1;
      else if (
        (d.preventManipulation && d.preventManipulation(),
        d.preventDefault && d.preventDefault(),
        Ma &&
          window.console &&
          (window.console.log(k + " --\x3e x: " + f.x + "; y:" + f.y),
          a && window.console.log(d.which),
          "mouseup" === k && window.console.log("mouseup")),
        !a)
      ) {
        if (!F.capturedEventParam && this._events) {
          for (var e = 0; e < this._events.length; e++)
            if (this._events[e].hasOwnProperty(k))
              if (
                ((t = this._events[e]),
                (a = t.bounds),
                f.x >= a.x1 && f.x <= a.x2 && f.y >= a.y1 && f.y <= a.y2)
              ) {
                t[k].call(t.context, f.x, f.y);
                "mousedown" === k && !0 === t.capture
                  ? ((Chart.capturedEventParam = t),
                    this.overlaidCanvas.setCapture
                      ? this.overlaidCanvas.setCapture()
                      : document.documentElement.addEventListener(
                          "mouseup",
                          this._mouseEventHandler,
                          !1
                        ))
                  : "mouseup" === k &&
                    (t.stockChart.overlaidCanvas.releaseCapture
                      ? t.stockChart.overlaidCanvas.releaseCapture()
                      : document.documentElement.removeEventListener(
                          "mouseup",
                          this._mouseEventHandler,
                          !1
                        ));
                break;
              } else t = null;
          d.target.style.cursor =
            t && t.cursor ? t.cursor : this._defaultCursor;
        }
        k = this.bounds;
        (f.x < k.x1 || f.x > k.x2 || f.y < k.y1 || f.y > k.y2) &&
          this.resetOverlayedCanvas();
        !this.isDrag &&
          this._eventManager &&
          this._eventManager.mouseEventHandler(d);
      }
    };
    F.prototype.resetOverlayedCanvas = function () {
      this.overlaidCanvasCtx.clearRect(0, 0, this.width, this.height);
    };
    F.prototype.clearCanvas = nb;
    F.prototype.getAutoFontSize = ob;
    ha(K, Ia);
    ha(M, Na);
    Ka.prototype.alignVerticalAxes = function () {
      if (!this.isNavigator && this.stockChart) {
        for (
          var d = this.sessionVariables.plotAreaBounds,
            f = this.stockChart._chartsPlotAreaX1 - d.x1,
            d = d.x2 - this.stockChart._chartsPlotAreaX2,
            k = 0;
          k < this.axisX.length;
          k++
        )
          (this.axisX[k].lineCoordinates.x1 += f),
            (this.axisX[k].lineCoordinates.x2 -= d),
            (this.axisX[k].lineCoordinates.width =
              this.axisX[k].lineCoordinates.x2 -
              this.axisX[k].lineCoordinates.x1),
            (this.axisX[k].bounds.x1 += f),
            (this.axisX[k].bounds.x2 -= d),
            this.axisX[k].calculateValueToPixelConversionParameters();
        for (k = 0; k < this.axisX2.length; k++)
          (this.axisX2[k].lineCoordinates.x1 += f),
            (this.axisX2[k].lineCoordinates.x2 -= d),
            (this.axisX2[k].lineCoordinates.width =
              this.axisX2[k].lineCoordinates.x2 -
              this.axisX2[k].lineCoordinates.x1),
            (this.axisX2[k].bounds.x1 += f),
            (this.axisX2[k].bounds.x2 -= d),
            this.axisX2[k].calculateValueToPixelConversionParameters();
        for (k = 0; k < this.axisY.length; k++)
          (this.axisY[k].lineCoordinates.x1 += f),
            (this.axisY[k].lineCoordinates.x2 += f),
            (this.axisY[k].bounds.x1 += f),
            (this.axisY[k].bounds.x2 += f);
        for (k = 0; k < this.axisY2.length; k++)
          (this.axisY2[k].lineCoordinates.x1 -= d),
            (this.axisY2[k].lineCoordinates.x2 -= d),
            (this.axisY2[k].bounds.x1 -= d),
            (this.axisY2[k].bounds.x2 -= d);
      }
    };
    Ka.prototype.syncCharts = function (d, k) {
      this.stockChart &&
        ((d = f(d) ? this.stockChart._axisXMin : d),
        (k = f(k) ? this.stockChart._axisXMax : k),
        this.stockChart._syncCharts(d, k),
        (this.stockChart.sessionVariables._axisXMin = d),
        (this.stockChart.sessionVariables._axisXMax = k),
        this.stockChart.rangeSelector &&
          "zoom" !== this._zoomButton.getAttribute("state") &&
          this.stockChart.rangeSelector.resetRangeButtons());
    };
    H.prototype.reset = function () {
      this.lastObjectId = 0;
      this.objectMap = [];
      this.rectangularRegionEventSubscriptions = [];
      this.eventObjects = [];
      v &&
        (this.ghostCtx.clearRect(
          0,
          0,
          this.stockChart.width,
          this.stockChart.height
        ),
        this.ghostCtx.beginPath());
    };
    H.prototype.getNewObjectTrackingId = function () {
      return ++this.lastObjectId;
    };
    H.prototype.mouseEventHandler = function (d) {
      if ("mousemove" === d.type || "click" === d.type) {
        var f = [],
          k = Ba(d),
          t = null;
        if (
          (t = this.stockChart.getObjectAtXY(k.x, k.y, !1)) &&
          "undefined" !== typeof this.objectMap[t]
        )
          if (((t = this.objectMap[t]), "rangeButton" === t.objectType)) {
            var a = this.stockChart.rangeSelector.buttons[t.rangeButtonIndex];
            t.eventParameter = {
              x: k.x,
              y: k.y,
              rangeButton: a,
              rangeButtonIndex: t.rangeButtonIndex,
              stockChart: this.stockChart,
            };
            t.eventContext = {
              context: this.stockChart.rangeSelector,
              userContext: a,
              mouseover: "mouseover",
              mousemove: "mousemove",
              mouseout: "mouseout",
              click: "click",
            };
            f.push(t);
          } else
            "inputFields" === t.objectType &&
              ((a =
                this.stockChart.rangeSelector.inputFields._textBlocks[
                  t.inputFieldIndex
                ]),
              (t.eventParameter = {
                x: k.x,
                y: k.y,
                inputField: a,
                inputFieldIndex: t.inputFieldIndex,
                stockChart: this.stockChart,
              }),
              (t.eventContext = {
                context: this.stockChart.rangeSelector,
                userContext: a,
                mouseover: "mouseover",
                mousemove: "mousemove",
                mouseout: "mouseout",
                click: "click",
              }),
              f.push(t));
        a = [];
        for (k = 0; k < this.mouseoveredObjectMaps.length; k++) {
          for (var e = !0, t = 0; t < f.length; t++)
            if (f[t].id === this.mouseoveredObjectMaps[k].id) {
              e = !1;
              break;
            }
          e
            ? this.fireEvent(this.mouseoveredObjectMaps[k], "mouseout", d)
            : a.push(this.mouseoveredObjectMaps[k]);
        }
        this.mouseoveredObjectMaps = a;
        for (k = 0; k < f.length; k++) {
          a = !1;
          for (t = 0; t < this.mouseoveredObjectMaps.length; t++)
            if (f[k].id === this.mouseoveredObjectMaps[t].id) {
              a = !0;
              break;
            }
          a ||
            (this.fireEvent(f[k], "mouseover", d),
            this.mouseoveredObjectMaps.push(f[k]));
          "click" === d.type
            ? this.fireEvent(f[k], "click", d)
            : "mousemove" === d.type && this.fireEvent(f[k], "mousemove", d);
        }
      }
    };
    H.prototype.fireEvent = function (d, f, k) {
      if (d && f) {
        var t = d.eventParameter,
          a = d.eventContext,
          e = d.eventContext.userContext;
        e && a && e[a[f]] && e[a[f]].call(e, t);
        "mouseout" !== f
          ? e.cursor &&
            e.cursor !== k.target.style.cursor &&
            (k.target.style.cursor = e.cursor)
          : ((k.target.style.cursor = this.stockChart._defaultCursor),
            delete d.eventParameter,
            delete d.eventContext);
      }
    };
    ha(z, Q);
    z.prototype._updateOptions = function () {
      this.updateOption("enabled");
      this.updateOption("backgroundColor");
      this.options.backgroundColor ||
        (this.backgroundColor = this.stockChart.backgroundColor);
      this.updateOption("animationEnabled");
      this.animationEnabled = this.animationEnabled && v;
      this.updateOption("animationDuration");
      this.updateOption("theme");
      this.updateOption("verticalAlign");
      this.updateOption("horizontalAlign");
      this.updateOption("width");
      this.updateOption("height");
      this.updateOption("dynamicUpdate");
    };
    z.prototype._initialize = function () {
      this._updateOptions();
      var d;
      this.enabled &&
        !this.panel &&
        ((this.panel = k("canvasjs-navigator-panel")),
        (d =
          !f(this.panel) &&
          this.stockChart._canvasJSContainer.contains(this.panel)) ||
          this.stockChart._canvasJSContainer.appendChild(this.panel));
      d =
        !f(this.panel) &&
        this.stockChart._canvasJSContainer.contains(this.panel);
      if (this.enabled) {
        this.height = this.options.height
          ? parseInt(this.options.height)
          : 0.14 * this.stockChart.height;
        d || this.stockChart._canvasJSContainer.appendChild(this.panel);
        var u = this.stockChart.layoutManager.getFreeSpace(),
          x = u.x1,
          t = u.y1;
        this.width = this.options.width ? this.width : u.width;
        "top" === this.verticalAlign
          ? ((t = u.y1 + 2), (d = "top"))
          : ((t = u.y2 - this.height - 2), (d = "bottom"));
        "left" === this.horizontalAlign
          ? (x = u.x1 + 2)
          : "center" === this.horizontalAlign
          ? (x = u.x1 + u.width / 2 - this.width / 2)
          : "right" === this.horizontalAlign && (x = u.x2 - 2 - this.width);
        this.panel.style.top = t + "px";
        this.panel.style.left = x + "px";
        this.panel.style.height = this.height + "px";
        this.panel.style.width = this.width + "px";
        this.stockChart.layoutManager.registerSpace(d, {
          width: this.width,
          height: this.height + 2,
        });
        this.bounds = { x1: x, y1: t, x2: x + this.width, y2: t + this.height };
      } else d && this.stockChart._canvasJSContainer.removeChild(this.panel);
    };
    z.prototype._updateSlider = function (d, k) {
      var x =
        this.chart.axisX && this.chart.axisX.length
          ? this.chart.axisX[0]
          : this.chart.axisX2[0];
      if (!f(x)) {
        var t = Math.max(
            x.bounds.x1,
            x.convertValueToPixel(
              x.reversed
                ? Math.max(d, Math.min(x.maximum, k))
                : Math.min(d, Math.min(x.maximum, k))
            )
          ),
          a = x.convertValueToPixel(
            x.reversed
              ? Math.min(d, Math.min(x.maximum, k))
              : Math.max(d, Math.min(x.maximum, k))
          );
        this.slider.panel.style.left = t + "px";
        this.slider.left = t;
        this.slider.panel.style.width = a - t + "px";
        this.slider.width = a - t;
        this.slider.minimum = d;
        this.slider.maximum = k;
        this.chart.resetOverlayedCanvas();
        this.slider.maskInverted
          ? fa(
              this.chart.overlaidCanvasCtx,
              t,
              0,
              a,
              this.height,
              this.slider.maskColor,
              0,
              this.slider.outlineColor,
              0,
              0,
              0,
              0,
              this.slider.maskOpacity
            )
          : (fa(
              this.chart.overlaidCanvasCtx,
              x.bounds.x1,
              0,
              t,
              this.height,
              this.slider.maskColor,
              0,
              this.slider.outlineColor,
              !1,
              !1,
              !1,
              !1,
              this.slider.maskOpacity
            ),
            fa(
              this.chart.overlaidCanvasCtx,
              a,
              0,
              this.width,
              this.height,
              this.slider.maskColor,
              0,
              this.slider.outlineColor,
              !1,
              !1,
              !1,
              !1,
              this.slider.maskOpacity
            ));
        this.chart.overlaidCanvasCtx.lineWidth = this.slider.outlineThickness;
        this.chart.overlaidCanvasCtx.strokeStyle = this.slider.outlineColor;
        this.chart.overlaidCanvasCtx.save();
        this.chart.overlaidCanvasCtx.beginPath();
        0 < this.slider.outlineThickness &&
          (this.slider.outlineInverted
            ? (this.chart.overlaidCanvasCtx.moveTo(
                x.bounds.x1,
                this.height - this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((t - this.slider.outlineThickness / 2) << 0) + 0.5
                  : t,
                this.height - this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((t - this.slider.outlineThickness / 2) << 0) + 0.5
                  : t,
                this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((a - this.slider.outlineThickness / 2) << 0) + 0.5
                  : a,
                this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((a - this.slider.outlineThickness / 2) << 0) + 0.5
                  : a,
                this.height - this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                this.width,
                this.height - this.slider.outlineThickness
              ))
            : (this.chart.overlaidCanvasCtx.moveTo(
                x.bounds.x1,
                this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((t - this.slider.outlineThickness / 2) << 0) + 0.5
                  : t,
                this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((t - this.slider.outlineThickness / 2) << 0) + 0.5
                  : t,
                this.height - this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((a - this.slider.outlineThickness / 2) << 0) + 0.5
                  : a,
                this.height - this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                1 === this.slider.outlineThickness % 2
                  ? ((a - this.slider.outlineThickness / 2) << 0) + 0.5
                  : a,
                this.slider.outlineThickness / 2
              ),
              this.chart.overlaidCanvasCtx.lineTo(
                this.width,
                this.slider.outlineThickness / 2
              )));
        this.chart.overlaidCanvasCtx.stroke();
        this.chart.overlaidCanvasCtx.restore();
        fa(
          this.chart.overlaidCanvasCtx,
          1 === this.slider.handleBorderThickness % 2
            ? (t - this.slider.handleWidth / 2) << 0.5
            : (t - this.slider.handleWidth / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (this.height / 2 - this.slider.handleHeight / 2) << 0.5
            : (this.height / 2 - this.slider.handleHeight / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (t + this.slider.handleWidth / 2) << 0.5
            : (t + this.slider.handleWidth / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (this.height / 2 + this.slider.handleHeight / 2) << 0.5
            : (this.height / 2 + this.slider.handleHeight / 2) << 0,
          this.slider.handleColor,
          this.slider.handleBorderThickness,
          this.slider.handleBorderColor,
          !1,
          !1,
          !1,
          !1,
          1
        );
        fa(
          this.chart.overlaidCanvasCtx,
          1 === this.slider.handleBorderThickness % 2
            ? (a - this.slider.handleWidth / 2) << 0.5
            : (a - this.slider.handleWidth / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (this.height / 2 - this.slider.handleHeight / 2) << 0.5
            : (this.height / 2 - this.slider.handleHeight / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (a + this.slider.handleWidth / 2) << 0.5
            : (a + this.slider.handleWidth / 2) << 0,
          1 === this.slider.handleBorderThickness % 2
            ? (this.height / 2 + this.slider.handleHeight / 2) << 0.5
            : (this.height / 2 + this.slider.handleHeight / 2) << 0,
          this.slider.handleColor,
          this.slider.handleBorderThickness,
          this.slider.handleBorderColor,
          !1,
          !1,
          !1,
          !1,
          1
        );
        this.chart.overlaidCanvasCtx.lineWidth =
          this.slider.handleBorderThickness;
        this.chart.overlaidCanvasCtx.strokeStyle =
          this.slider.handleBorderColor;
        this.chart.overlaidCanvasCtx.save();
        this.chart.overlaidCanvasCtx.beginPath();
        this.chart.overlaidCanvasCtx.moveTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((t - this.slider.handleBorderThickness / 2) << 0) + 0.5
            : t) - Math.round(this.slider.handleBorderThickness),
          this.height / 2 - this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.lineTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((t - this.slider.handleBorderThickness / 2) << 0) + 0.5
            : t) - Math.round(this.slider.handleBorderThickness),
          this.height / 2 + this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.moveTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((t + this.slider.handleBorderThickness / 2) << 0) + 0.5
            : t) + Math.round(this.slider.handleBorderThickness),
          this.height / 2 - this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.lineTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((t + this.slider.handleBorderThickness / 2) << 0) + 0.5
            : t) + Math.round(this.slider.handleBorderThickness),
          this.height / 2 + this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.moveTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((a - this.slider.handleBorderThickness / 2) << 0) + 0.5
            : a) - Math.round(this.slider.handleBorderThickness),
          this.height / 2 - this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.lineTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((a - this.slider.handleBorderThickness / 2) << 0) + 0.5
            : a) - Math.round(this.slider.handleBorderThickness),
          this.height / 2 + this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.moveTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((a + this.slider.handleBorderThickness / 2) << 0) + 0.5
            : a) + Math.round(this.slider.handleBorderThickness),
          this.height / 2 - this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.lineTo(
          (1 === this.slider.handleBorderThickness % 2
            ? ((a + this.slider.handleBorderThickness / 2) << 0) + 0.5
            : a) + Math.round(this.slider.handleBorderThickness),
          this.height / 2 + this.slider.handleHeight / 4
        );
        this.chart.overlaidCanvasCtx.stroke();
        this.chart.overlaidCanvasCtx.restore();
      }
    };
    ha(N, Q);
    N.prototype._updateOptions = function () {
      this.updateOption("maskColor");
      this.updateOption("maskInverted");
      this.updateOption("maskOpacity");
      this.updateOption("handleColor");
      this.updateOption("handleBorderColor");
      this.updateOption("handleBorderThickness");
      this.updateOption("handleWidth");
      this.updateOption("handleHeight");
      this.updateOption("outlineColor");
      this.updateOption("outlineThickness");
      this.updateOption("outlineInverted");
      this.updateOption("minimum");
      this.updateOption("maximum");
    };
    N.prototype._attachEvents = function () {
      var d = this;
      y(
        this.panel,
        "mousedown",
        function (f) {
          d.stockChart.isDrag = !0;
          f.target !== d.leftHandle &&
            f.target !== d.rightHandle &&
            ((d.stockChart.navigatorClicked = !0),
            (d.currentHandle = d.leftHandle),
            (d.panMode = !0),
            (d.startPosition = Ba(f)),
            f.target === d.currentHandle
              ? (d.startPosition.x +=
                  d.currentHandle.offsetLeft +
                  d.currentHandle.clientWidth / 2 +
                  d.panel.offsetLeft)
              : f.target === d.panel &&
                (d.startPosition.x += d.panel.offsetLeft),
            (d.startWidth = d.panel.clientWidth),
            (d.startLeft = d.panel.offsetLeft));
        },
        this.stockChart.allDOMEventHandlers
      );
      y(
        this.panel,
        window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
        function (f) {
          d.stockChart._touchEventHandler(f);
        },
        this.stockChart.allDOMEventHandlers
      );
      y(
        this.navigator.panel,
        "mousedown",
        function (k) {
          if (
            k.target !== d.navigator.slider.panel &&
            k.target !== d.leftHandle &&
            k.target !== d.rightHandle
          ) {
            d.stockChart.navigatorClicked = !0;
            var x = Ba(k),
              t,
              a;
            t = 0;
            var e =
              d.navigator.chart.axisX && d.navigator.chart.axisX.length
                ? d.navigator.chart.axisX[0]
                : d.navigator.chart.axisX2[0];
            k = d.navigator.slider.left;
            f(d.startLeft) && (d.startLeft = k);
            t = k + d.navigator.slider.width;
            a = x.x - (k + t) / 2;
            if (x.x < k || x.x > t) {
              var x = Math.max(0, k + a),
                b = Math.min(t + a, d.navigator.width);
              t + a > d.navigator.width &&
                ((t = t + a - d.navigator.width), (x -= t));
              0 > k + a && ((t = Math.abs(k + a)), (b += t));
              d.stockChart._rangeEventParameter = {
                stockChart: d.stockChart,
                source: "navigator",
                index: null,
                minimum: e.convertPixelToValue(x),
                maximum: e.convertPixelToValue(b),
              };
              d.stockChart.sessionVariables._axisXMin =
                e.convertPixelToValue(x);
              d.stockChart.sessionVariables._axisXMax =
                e.convertPixelToValue(b);
              d.navigator.dynamicUpdate
                ? ((d.stockChart._rangeEventParameter.type = "rangeChanging"),
                  d.stockChart.dispatchEvent(
                    "rangeChanging",
                    d.stockChart._rangeEventParameter,
                    d.stockChart
                  ),
                  d.stockChart._syncCharts(
                    e.convertPixelToValue(x),
                    e.convertPixelToValue(b)
                  ),
                  (d.stockChart._rangeEventParameter.type = "rangeChanged"),
                  d.stockChart.dispatchEvent(
                    "rangeChanged",
                    d.stockChart._rangeEventParameter,
                    d.stockChart
                  ))
                : d.navigator._updateSlider(
                    d.stockChart.sessionVariables._axisXMin,
                    d.stockChart.sessionVariables._axisXMax
                  );
            }
          }
        },
        this.navigator.stockChart.allDOMEventHandlers
      );
      y(
        this.navigator.panel,
        window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
        function (f) {
          d.stockChart._touchEventHandler(f);
        },
        this.navigator.stockChart.allDOMEventHandlers
      );
      y(
        this.navigator.stockChart.container,
        "mousemove",
        function (k) {
          var x =
            d.navigator.chart.axisX && d.navigator.chart.axisX.length
              ? d.navigator.chart.axisX[0]
              : d.navigator.chart.axisX2[0];
          if (!f(d.currentHandle) && d.startPosition) {
            d.navigator.chart.overlaidCanvas.style.cursor =
              d.navigator.chart.container.style.cursor =
              d.navigator.panel.style.cursor =
                "ew-resize";
            var t;
            t = d.currentHandle === d.leftHandle ? 1 : -1;
            var a = Ba(k);
            k = k.target || k.srcElement;
            a.x =
              k === d.currentHandle
                ? a.x +
                  (d.currentHandle.offsetLeft +
                    d.currentHandle.clientWidth / 2 +
                    d.panel.offsetLeft)
                : k === d.mask || k === d.panel
                ? a.x + d.panel.offsetLeft
                : k === d.rightHandle && d.currentHandle === d.leftHandle
                ? a.x +
                  (d.rightHandle.offsetLeft +
                    d.rightHandle.clientWidth / 2 +
                    d.panel.offsetLeft)
                : k === d.leftHandle && d.currentHandle === d.rightHandle
                ? a.x + d.panel.offsetLeft
                : a.x +
                  ("canvasjs-chart-toolbar" === k.parentElement.className
                    ? k.offsetParent.offsetLeft +
                      k.offsetLeft -
                      d.stockChart._chartsPlotAreaX1
                    : k.parentElement.parentElement.parentElement ===
                      d.navigator.panel
                    ? k.offsetLeft
                    : k.offsetLeft - d.stockChart._chartsPlotAreaX1);
            var e = a.x - d.startPosition.x;
            if (0 !== e) {
              k = d.panel.offsetLeft;
              var b = d.panel.clientWidth;
              0 < t && (k = Math.max(d.startLeft + t * e, d._left));
              d.panMode ||
                ((b = Math.min(d.startWidth - t * e, d.fullWidth)),
                t * e > d.startWidth
                  ? ((k =
                      0 < t
                        ? d.startLeft + d.startWidth
                        : Math.max(a.x, d._left)),
                    (b = (0 < t ? a.x : d.startLeft) - parseFloat(k)))
                  : 0 > t && (k = d.startLeft));
              k + b <= d._left + d.fullWidth &&
                (2 < Math.abs(d.startLeft - k) ||
                  2 < Math.abs(d.startWidth - parseFloat(b))) &&
                (0 < t && ((d.left = k), (d.panel.style.left = d.left + "px")),
                d.panMode || (d.panel.style.width = d.width = b + "px"),
                f(x) ||
                  ((t = x.convertPixelToValue(
                    Math.max(x.bounds.x1, parseFloat(k))
                  )),
                  (x = x.convertPixelToValue(parseFloat(k) + parseFloat(b))),
                  (d.stockChart.sessionVariables._axisXMin = t),
                  (d.stockChart.sessionVariables._axisXMax = x),
                  d.stockChart.rangeSelector &&
                    !d.panMode &&
                    d.stockChart.rangeSelector.resetRangeButtons(),
                  (d.stockChart._rangeEventParameter = {
                    stockChart: d.stockChart,
                    source: "navigator",
                    index: null,
                    minimum: t,
                    maximum: x,
                  }),
                  d.navigator.dynamicUpdate
                    ? ((d.stockChart._rangeEventParameter.type =
                        "rangeChanging"),
                      d.stockChart.dispatchEvent(
                        "rangeChanging",
                        d.stockChart._rangeEventParameter,
                        d.stockChart
                      ),
                      d.stockChart._syncCharts(t, x),
                      (d.stockChart._rangeEventParameter.type = "rangeChanged"),
                      d.stockChart.dispatchEvent(
                        "rangeChanged",
                        d.stockChart._rangeEventParameter,
                        d.stockChart
                      ))
                    : d.navigator._updateSlider(
                        d.stockChart.sessionVariables._axisXMin,
                        d.stockChart.sessionVariables._axisXMax
                      )));
            }
          } else
            d.navigator.chart.overlaidCanvas.style.cursor =
              d.navigator.chart.container.style.cursor =
              d.navigator.panel.style.cursor =
                "auto";
        },
        this.navigator.stockChart.allDOMEventHandlers
      );
      y(
        this.navigator.stockChart.container,
        window.navigator.msPointerEnabled ? "MSPointerMove" : "touchmove",
        function (f) {
          d.stockChart._touchEventHandler(f);
        },
        this.navigator.stockChart.allDOMEventHandlers
      );
    };
    N.prototype._initialize = function () {
      var d = this,
        k;
      this._updateOptions();
      ea &&
        (this.eventsAttached ||
          (this._attachEvents(), (this.eventsAttached = !0)),
        (this.handleWidth = this.options.handleWidth ? this.handleWidth : 8),
        (this.handleHeight = this.options.handleHeight
          ? Math.min(this.navigator.height, this.options.handleHeight)
          : 0.25 * this.navigator.height),
        this.leftHandle ||
          ((this.leftHandle = B("button", "canvasjs-slider-handle", "button")),
          (this.leftHandle.innerHTML = "||"),
          (this.leftHandle.style.cssText =
            "height: " +
            this.navigator.height +
            "px; width: " +
            (this.handleWidth + 10) +
            "px; position:absolute; left: -" +
            (this.handleWidth / 2 + 8) +
            "px; top: 0; cursor:ew-resize;border-style: solid; border-width:" +
            this.handleBorderThickness +
            "px; border-color: transparent; outline:none; padding:0px; background-color: transparent; color: transparent;font-size:12px;font-family:Arial;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;user-select: none; opacity: 1; z-index: 999;"),
          this.panel.appendChild(this.leftHandle),
          this.initHandle(this.leftHandle, 1)),
        this.rightHandle ||
          ((this.rightHandle = B("button", "canvasjs-slider-handle", "button")),
          (this.rightHandle.innerHTML = "||"),
          (this.rightHandle.style.cssText =
            "height: " +
            this.navigator.height +
            "px; width: " +
            (this.handleWidth + 10) +
            "px; position:absolute; right: -" +
            (this.handleWidth / 2 + 8) +
            "px; top: 0; cursor:ew-resize;border-style: solid; border-width:" +
            this.handleBorderThickness +
            "px; border-color: transparent; outline:none; padding:0px; background-color: transparent; color: transparent;font-size:12px;font-family:Arial;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;user-select: none; opacity: 1; z-index: 999;"),
          this.panel.appendChild(this.rightHandle),
          this.initHandle(this.rightHandle, -1)),
        (this.panel.style.cssText =
          "height: " +
          this.navigator.height +
          "px; width: 100%; position: absolute; cursor: move;"),
        (this.fullWidth = this.panel.clientWidth),
        (this._left = this.panel.offsetLeft),
        y(
          document,
          "mousedown",
          function (f) {
            if (
              d.stockChart.rangeSelector &&
              d.stockChart.rangeSelector.inputFields &&
              d.stockChart.rangeSelector.inputFields.enabled
            )
              for (
                var k = 0;
                k < d.stockChart.rangeSelector.inputFields.elements.length;
                k++
              )
                f.target !=
                  d.stockChart.rangeSelector.inputFields.elements[k] &&
                  d.stockChart.rangeSelector.inputFields.elements[k].focused &&
                  d.stockChart.rangeSelector.inputFields.elements[k].blur();
          },
          this.navigator.stockChart.allDOMEventHandlers
        ),
        y(
          document,
          window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
          function (d) {
            a: {
              var f = d.changedTouches,
                f = f ? f[0] : d,
                a = "";
              switch (d.type) {
                case "touchstart":
                case "MSPointerDown":
                  a = "mousedown";
                  break;
                case "touchmove":
                case "MSPointerMove":
                  a = "mousemove";
                  break;
                case "touchend":
                case "MSPointerUp":
                  a = "mouseup";
                  break;
                default:
                  break a;
              }
              d = document.createEvent("MouseEvent");
              d.initMouseEvent(
                a,
                !0,
                !0,
                window,
                1,
                f.screenX,
                f.screenY,
                f.clientX,
                f.clientY,
                !1,
                !1,
                !1,
                !1,
                0,
                null
              );
              f.target.dispatchEvent(d);
            }
          },
          this.navigator.stockChart.allDOMEventHandlers
        ),
        y(
          document,
          "mouseup",
          function (x) {
            d.panMode = !1;
            d.navigator.stockChart.isDrag = !1;
            if (d.stockChart.navigatorClicked) {
              x = Math.min(
                d.stockChart.sessionVariables._axisXMin,
                d.stockChart.sessionVariables._axisXMax
              );
              var t = Math.max(
                d.stockChart.sessionVariables._axisXMin,
                d.stockChart.sessionVariables._axisXMax
              );
              f(d.stockChart._rangeEventParameter) &&
                (d.stockChart._rangeEventParameter = {
                  stockChart: d.stockChart,
                  source: "navigator",
                  index: null,
                  minimum: x,
                  maximum: t,
                });
              if (
                2 < Math.abs(d.startLeft - d.left) ||
                2 < Math.abs(d.startWidth - parseFloat(d.width))
              ) {
                d.navigator.dynamicUpdate ||
                  ((d.stockChart._rangeEventParameter.type = "rangeChanging"),
                  d.stockChart.dispatchEvent(
                    "rangeChanging",
                    d.stockChart._rangeEventParameter,
                    d.stockChart
                  ));
                for (var a = 0; a < d.stockChart.charts.length; a++) {
                  k = d.stockChart.charts[a];
                  k.toolTip && k.toolTip.enabled && k.toolTip.hide();
                  for (var e = 0; e < k.axisX.length; e++)
                    k.axisX[e].setViewPortRange(x, t);
                  for (e = 0; e < k.axisX2.length; e++)
                    k.axisX2[e].setViewPortRange(x, t);
                  k.render();
                }
                d.stockChart.rangeSelector &&
                  d.stockChart.rangeSelector.enabled &&
                  d.stockChart.rangeSelector.inputFields &&
                  d.stockChart.rangeSelector.inputFields.enabled &&
                  d.stockChart.rangeSelector._updateInputFields(x, t);
                d.navigator.dynamicUpdate ||
                  ((d.stockChart._rangeEventParameter.type = "rangeChanged"),
                  d.stockChart.dispatchEvent(
                    "rangeChanged",
                    d.stockChart._rangeEventParameter,
                    d.stockChart
                  ));
              }
            }
            d.stockChart.navigatorClicked =
              d.currentHandle =
              d.startPosition =
              d.startWidth =
              d.startLeft =
                null;
          },
          this.navigator.stockChart.allDOMEventHandlers
        ),
        y(
          document,
          window.navigator.msPointerEnabled ? "MSPointerUp" : "touchend",
          function (x) {
            d.panMode = !1;
            d.navigator.stockChart.isDrag = !1;
            if (d.stockChart.navigatorClicked) {
              x = Math.min(
                d.stockChart.sessionVariables._axisXMin,
                d.stockChart.sessionVariables._axisXMax
              );
              var t = Math.max(
                d.stockChart.sessionVariables._axisXMin,
                d.stockChart.sessionVariables._axisXMax
              );
              f(d.stockChart._rangeEventParameter) &&
                (d.stockChart._rangeEventParameter = {
                  stockChart: d.stockChart,
                  source: "navigator",
                  index: null,
                  minimum: x,
                  maximum: t,
                });
              d.navigator.dynamicUpdate ||
                ((d.stockChart._rangeEventParameter.type = "rangeChanging"),
                d.stockChart.dispatchEvent(
                  "rangeChanging",
                  d.stockChart._rangeEventParameter,
                  d.stockChart
                ));
              for (var a = 0; a < d.stockChart.charts.length; a++) {
                k = d.stockChart.charts[a];
                k.toolTip && k.toolTip.enabled && k.toolTip.hide();
                for (var e = 0; e < k.axisX.length; e++)
                  k.axisX[e].setViewPortRange(x, t);
                for (e = 0; e < k.axisX2.length; e++)
                  k.axisX2[e].setViewPortRange(x, t);
                k.render();
              }
              d.stockChart.rangeSelector &&
                d.stockChart.rangeSelector.enabled &&
                d.stockChart.rangeSelector.inputFields &&
                d.stockChart.rangeSelector.inputFields.enabled &&
                d.stockChart.rangeSelector._updateInputFields(x, t);
              d.navigator.dynamicUpdate ||
                ((d.stockChart._rangeEventParameter.type = "rangeChanged"),
                d.stockChart.dispatchEvent(
                  "rangeChanged",
                  d.stockChart._rangeEventParameter,
                  d.stockChart
                ));
            }
            d.stockChart.navigatorClicked =
              d.currentHandle =
              d.startPosition =
              d.startWidth =
              d.startLeft =
                null;
          },
          this.navigator.stockChart.allDOMEventHandlers
        ));
    };
    N.prototype.initHandle = function (d, f) {
      var k = this;
      d &&
        (y(
          d,
          "mousedown",
          function (d) {
            k.stockChart.navigatorClicked = !0;
            k.currentHandle = this;
            k.startPosition = Ba(d);
            d.target === k.currentHandle
              ? (k.startPosition.x +=
                  k.currentHandle.offsetLeft +
                  k.currentHandle.clientWidth / 2 +
                  k.panel.offsetLeft)
              : d.target === k.panel &&
                (k.startPosition.x += k.panel.offsetLeft);
            k.startWidth = k.panel.clientWidth;
            k.startLeft = k.panel.offsetLeft;
            d.preventDefault && d.preventDefault();
            d.stopPropagation && d.stopPropagation();
          },
          this.navigator.stockChart.allDOMEventHandlers
        ),
        y(
          d,
          window.navigator.msPointerEnabled ? "MSPointerDown" : "touchstart",
          function (d) {
            k.stockChart._touchEventHandler(d);
          },
          this.navigator.stockChart.allDOMEventHandlers
        ));
    };
    ha(O, Q);
    O.prototype._updateOptions = function () {
      this.updateOption("enabled");
      this.updateOption("verticalAlign");
      this.updateOption("horizontalAlign");
      this.updateOption("width");
      this.updateOption("height");
      this.updateOption("label");
      this.updateOption("selectedRangeButtonIndex");
    };
    O.prototype._initialize = function () {
      var d = 0;
      this._updateOptions();
      this.buttons = [];
      if (ea && this.enabled) {
        if (this.options.buttons)
          for (var k = 0; k < this.options.buttons.length; k++)
            this.buttons.push(
              new P(this.stockChart, k, this.options.buttons[k])
            );
        else {
          for (k = 0; 6 > k; k++) this.buttons.push(new P(this.stockChart, k));
          this.buttonLabels = "1m 3m 6m YTD 1y All".split(" ");
        }
        this._wrapElements = !1;
        var s = this.stockChart.layoutManager.getFreeSpace(),
          t = s.x1,
          k = s.y1;
        this.width = this.options.width ? this.width : s.width;
        f(this.buttonStyle.options.labelFontSize) &&
          (this.buttonStyle.labelFontSize = this.stockChart.getAutoFontSize(
            this.buttonStyle.labelFontSize
          ));
        this.rangeButtonsWidth = 0;
        this.buttonStyle.maxWidth = this.buttonStyle.options.maxWidth
          ? this.buttonStyle.options.maxWidth
          : this.stockChart.width / this.buttons.length;
        if (this.buttons && 0 < this.buttons.length) {
          var a = new na(this.ctx, {
            x: 0,
            y: 0,
            backgroundColor: this.stockChart.backgroundColor,
            borderThickness: 0,
            cornerRadius: 0,
            maxWidth: 0.2 * this.stockChart.width,
            maxHeight: 2 * this.buttonStyle.labelFontSize,
            angle: 0,
            padding: { left: 5, right: 5, top: 2, bottom: 2 },
            text:
              f(this.stockChart.options.culture) ||
              f(this.stockChart._cultureInfo.rangeSelector.rangeText)
                ? this.label
                : this.stockChart._cultureInfo.rangeSelector.rangeText,
            horizontalAlign: "left",
            fontSize: this.buttonStyle.labelFontSize,
            fontFamily: this.buttonStyle.labelFontFamily,
            fontWeight: this.buttonStyle.labelFontWeight,
            fontColor: this.buttonStyle.labelFontColor,
            fontStyle: this.buttonStyle.labelFontStyle,
            textBaseline: "middle",
          });
          this._label.textBlock = a;
        }
        for (k = 0; k < this.buttons.length; k++) {
          var e = this.buttons[k];
          e._index = k;
          a = new na(this.ctx, {
            x: 0,
            y: 0,
            backgroundColor: this.buttonStyle.backgroundColor,
            borderColor: this.buttonStyle.borderColor,
            borderThickness: this.buttonStyle.borderThickness,
            cornerRadius: 0,
            maxWidth: this.buttonStyle.options.width
              ? this.buttonStyle.width
              : this.buttonStyle.maxWidth,
            maxHeight: 2 * this.buttonStyle.labelFontSize,
            angle: 0,
            padding: this.buttonStyle.padding,
            text:
              this.options.buttons && this.options.buttons.length
                ? f(e.label)
                  ? ""
                  : e.label
                : this.buttonLabels[k],
            horizontalAlign: "center",
            textAlign: "center",
            fontSize: this.buttonStyle.labelFontSize,
            fontFamily: this.buttonStyle.labelFontFamily,
            fontWeight: this.buttonStyle.labelFontWeight,
            fontColor: this.buttonStyle.labelFontColor,
            fontStyle: this.buttonStyle.labelFontStyle,
            textBaseline: "middle",
          });
          e.state =
            f(this.selectedRangeButtonIndex) ||
            this.selectedRangeButtonIndex !== k
              ? "off"
              : "on";
          e.textBlock = a;
          e.bounds = {
            x1: null,
            x2: null,
            y1: null,
            y2: null,
            width: null,
            height: null,
          };
          a.measureText();
          this.rangeButtonsWidth += a.width + this.buttonStyle.spacing;
          this.rangeButtonsHeight = a.height;
          d = d < a.height ? a.height : d;
          e = this.buttons[k];
          e.id = ++this.stockChart._eventManager.lastObjectId;
          this.stockChart._eventManager.objectMap[e.id] = {
            id: e.id,
            objectType: "rangeButton",
            rangeButtonIndex: k,
          };
        }
        this.height <
          this.inputFieldsHeight + 2 * this.inputFields.style.borderThickness &&
          (this.height =
            this.inputFieldsHeight +
            2 * this.inputFields.style.borderThickness);
        this.height < d + 2 * this.buttonStyle.borderThickness + 5 &&
          (this.height = d + 2 * this.buttonStyle.borderThickness + 5);
        this.rangeButtonsWidth +
          this._label.textBlock.measureText().width +
          this.inputFieldsWidth >=
          this.stockChart.width &&
          ((this.height = this.options.height ? this.height : 2 * this.height),
          (this._wrapElements = !0));
        "bottom" === this.verticalAlign
          ? ((k = s.y2 - this.height), (d = "bottom"))
          : ((k = s.y1), (d = "top"));
        "left" === this.horizontalAlign
          ? (t = s.x1 + 2)
          : "center" === this.horizontalAlign
          ? (t = s.x1 + s.width / 2 - this.width / 2)
          : "right" === this.horizontalAlign && (t = s.x2 - 2 - this.width);
        this.stockChart.layoutManager.registerSpace(d, {
          width: this.width,
          height: this.height,
        });
        this.bounds = {
          x1: t,
          y1: k,
          x2: t + this.width,
          y2: k + this.height,
          width: this.width,
          height: this.height,
        };
        for (k = 0; k < this.buttons.length; k++)
          this.buttons[k]._initialize(k);
      }
    };
    O.prototype.render = function () {
      var d;
      this.setButtonsLayout();
      fa(
        this.ctx,
        this.bounds.x1,
        this.bounds.y1,
        this.bounds.x2,
        this.bounds.y2,
        this.stockChart.backgroundColor,
        0,
        null,
        0,
        0,
        0,
        0,
        1
      );
      this._label && this._label.textBlock && this._label.textBlock.render(!0);
      for (d = 0; d < this.buttons.length; d++)
        this.buttons[d].enabled ||
          ((this.buttons[d].textBlock.backgroundColor =
            this.buttons[d].backgroundColorDisabled),
          (this.buttons[d].textBlock.borderColor =
            this.buttons[d].backgroundColorDisabled)),
          this.buttons[d].render(!0);
      this.inputFields &&
        this.inputFields.enabled &&
        this.renderInputFields(!0);
    };
    O.prototype.setButtonsLayout = function () {
      var d,
        f,
        k = this.bounds.x1 + 5,
        t,
        a;
      this._label &&
        this._label.textBlock &&
        0 < this.buttons.length &&
        ((this._label.textBlock.x = k),
        (this._label.textBlock.y = a =
          this.bounds.y1 +
          this._label.textBlock.measureText().height / 2 +
          2 * this.buttons[0].textBlock.borderThickness),
        (this._label.bounds = {
          x1: k,
          y1: a - this._label.textBlock.fontSize / 2,
          x2: k + this._label.textBlock.measureText().width,
          y2: a + this._label.textBlock.measureText().height,
          width: this._label.textBlock.measureText().width,
          height: this._label.textBlock.measureText().height,
        }),
        (k += this._label.bounds.width));
      for (d = 0; d < this.buttons.length; d++)
        (f = this.buttons[d]),
          (f.textBlock.width =
            f.textBlock.maxWidth =
            this.buttonStyle.width =
              this.buttonStyle.options.width
                ? this.buttonStyle.width
                : f.textBlock.width),
          (t = k + f.textBlock.width),
          (f.textBlock.x = f.bounds.x1 =
            1 === f.textBlock.borderThickness % 2 ? (k << 0) + 0.5 : k),
          (f.bounds.x2 = t),
          (a =
            1 === f.textBlock.borderThickness % 2
              ? (this.bounds.y1 +
                  f.textBlock.height / 2 +
                  2 * f.textBlock.borderThickness) <<
                0.5
              : this.bounds.y1 +
                f.textBlock.height / 2 +
                2 * f.textBlock.borderThickness),
          (f.textBlock.y = a),
          (f.bounds.y1 = a - f.textBlock.height / 2),
          (f.bounds.y2 = f.bounds.y1 + f.textBlock.height),
          (f.bounds.width = t - k),
          (f.bounds.height = f.bounds.y2 - f.bounds.y1),
          (k = t + this.buttonStyle.spacing),
          (f.textBlock.maxWidth = this.buttonStyle.maxWidth);
    };
    O.prototype.resetRangeButtons = function () {
      for (var d = 0; d < this.buttons.length; d++)
        this.buttons[d].enabled &&
          ((this.buttons[d].state = "off"),
          (this.buttons[d].textBlock.backgroundColor =
            this.buttonStyle.backgroundColor),
          (this.buttons[d].textBlock.fontColor =
            this.buttonStyle.labelFontColor),
          (this.buttons[d].textBlock.fontWeight =
            this.buttonStyle.labelFontWeight),
          this.buttons[d].textBlock.render(!0));
    };
    O.prototype.renderInputFields = function () {
      this.inputFields._textBlocks[0].text =
        "dateTime" === this.inputFields.valueType
          ? oa(
              this.inputFields.startValue,
              this.inputFields.valueFormatString,
              this.stockChart._cultureInfo
            )
          : $(
              this.inputFields.startValue,
              this.inputFields.valueFormatString,
              this.stockChart._cultureInfo
            );
      this.inputFields._textBlocks[1].text =
        "dateTime" === this.inputFields.valueType
          ? oa(
              this.inputFields.endValue,
              this.inputFields.valueFormatString,
              this.stockChart._cultureInfo
            )
          : $(
              this.inputFields.endValue,
              this.inputFields.valueFormatString,
              this.stockChart._cultureInfo
            );
      this.inputFields._labels[0].text = f(
        this.stockChart._cultureInfo.rangeSelector.fromText
      )
        ? "From"
        : this.stockChart._cultureInfo.rangeSelector.fromText;
      this.inputFields._labels[1].text = f(
        this.stockChart._cultureInfo.rangeSelector.toText
      )
        ? "To"
        : this.stockChart._cultureInfo.rangeSelector.toText;
      var d = 0,
        k = !0;
      if (
        (this.stockChart.title &&
          this.stockChart.title.text &&
          ("top" === this.stockChart.title.verticalAlign ||
            ("right" === this.stockChart.title.horizontalAlign &&
              "center" === this.stockChart.title.verticalAlign &&
              this.stockChart.exportEnabled))) ||
        "bottom" === this.verticalAlign
      )
        k = !1;
      if (this.stockChart.subtitles)
        for (var s = 0; s < this.stockChart.subtitles.length; s++)
          this.stockChart.subtitles[s] &&
            this.stockChart.subtitles[s].text &&
            ("top" === this.stockChart.subtitles[s].verticalAlign ||
              ("right" === this.stockChart.subtitles[s].horizontalAlign &&
                "center" === this.stockChart.subtitles[s].verticalAlign &&
                this.stockChart.exportEnabled)) &&
            (k = !1);
      for (s = this.inputFields._textBlocks.length - 1; 0 <= s; s--) {
        var t = this.inputFields._textBlocks[s],
          a = t.measureText();
        t._width = this.inputFields.style.options.width
          ? this.inputFields.style.width
          : Math.abs(a.width - t._width) <=
            ("dateTime" === this.inputFields.valueType ? 10 : 5)
          ? t._width
          : a.width + 10;
        d += t._width + this.inputFields.style.spacing;
        this.inputFields.elements[s].style.width =
          t._width -
          this.inputFields.style.spacing -
          2 * this.inputFields.style.borderThickness -
          5 +
          "px";
        t.x = t.bounds.x1 =
          1 === t.borderThickness % 2
            ? ((this.bounds.x2 -
                d -
                (this.stockChart.exportEnabled && k ? 40 : 0)) <<
                0) +
              0.5
            : this.bounds.x2 -
              d -
              (this.stockChart.exportEnabled && k ? 40 : 0);
        t.bounds.x2 = t.bounds.x1 + t._width;
        this.inputFields.elements[s].style.left =
          this.bounds.x2 -
          d -
          (this.stockChart.exportEnabled && k ? 40 : 0) +
          this.inputFields.style.borderThickness +
          "px";
        d += this.inputFields._labels[s].measureText().width;
        this.inputFields._labels[s].x = this.inputFields._labels[s].bounds.x1 =
          this.bounds.x2 - d - (this.stockChart.exportEnabled && k ? 40 : 0);
        this.inputFields._labels[s].bounds.x2 =
          this.inputFields._labels[s].bounds.x1 +
          this.inputFields._labels[s].measureText().width;
        t.width = t._width;
        t.y =
          1 === t.borderThickness % 2
            ? ((this._wrapElements
                ? this.bounds.y1 + this.rangeButtonsHeight + 10
                : this.bounds.y1) +
                a.height / 2 +
                2 * t.borderThickness) <<
              0.5
            : (this._wrapElements
                ? this.bounds.y1 + this.rangeButtonsHeight + 10
                : this.bounds.y1) +
              a.height / 2 +
              2 * t.borderThickness;
        this.inputFields._labels[s].y =
          (this._wrapElements
            ? this.bounds.y1 + this.rangeButtonsHeight + 10
            : this.bounds.y1) +
          a.height / 2 +
          2 * t.borderThickness;
        t.bounds.y1 = this.inputFields._labels[s].bounds.y1 =
          t.y - a.height / 2 + 2 * t.borderThickness;
        t.bounds.y2 = this.inputFields._labels[s].bounds.y2 =
          t.bounds.y1 + a.height;
        this.inputFields.elements[s].style.top =
          this.inputFields._labels[s].bounds.y1 + "px";
        t.render(!0);
        this.inputFields._labels[s].render(!0);
      }
    };
    O.prototype._updateInputFields = function (d, f) {
      this.inputFields.elements[0].focused ||
        (this.inputFields.elements[0].value =
          "dateTime" === this.inputFields.valueType
            ? oa(d, "YYYY-MM-DD")
            : $(d, this.inputFields.valueFormatString));
      this.inputFields.elements[1].focused ||
        (this.inputFields.elements[1].value =
          "dateTime" === this.inputFields.valueType
            ? oa(f, "YYYY-MM-DD")
            : $(f, this.inputFields.valueFormatString));
      for (var k = 0; k < this.inputFields.elements.length; k++)
        this.inputFields.elements[k].focused &&
          this.inputFields.elements[k].focus();
      this.inputFields.startValue = d;
      this.inputFields.endValue = f;
      this.render();
    };
    ha(P, Q);
    P.prototype._updateOptions = function () {
      this.updateOption("style");
      this.updateOption("label");
      this.updateOption("range");
      this.updateOption("rangeType");
    };
    P.prototype._initialize = function (d) {
      this._updateOptions();
      var k = "1m 3m 6m YTD 1y All".split(" "),
        s = [1, 3, 6, null, 1, null],
        t = "month month month ytd year all".split(" ");
      this.range =
        "undefined" !== typeof this.options.range
          ? this.range
          : f(s[d])
          ? null
          : s[d];
      this.rangeType =
        "undefined" !== typeof this.options.rangeType ? this.rangeType : t[d];
      this.label = this.textBlock.text = f(this.options.label)
        ? k[d]
        : this.label;
    };
    P.prototype.render = function () {
      this.textBlock.render(!0);
    };
    ha(W, Q);
    W.prototype._updateOptions = function () {
      this.updateOption("enabled");
      this.updateOption("startValue");
      this.updateOption("endValue");
      this.updateOption("valueType");
      this.updateOption("valueFormatString");
    };
    W.prototype._initialize = function () {
      this._updateOptions();
      f(this.style.options.fontSize) &&
        (this.style.fontSize = this.stockChart.getAutoFontSize(
          this.style.fontSize
        ));
      if (this.enabled) {
        for (var d = 0; d < this.elements.length; d++)
          (this.elements[d].style.position = "absolute"),
            (this.elements[d].style.display = this.elements[d].focused
              ? "inline"
              : "none"),
            (this.elements[d].style.backgroundColor =
              this.style.backgroundColor),
            (this.elements[d].style.border = "none"),
            (this.elements[d].style.outline = "none"),
            (this.elements[d].style.outlineOffset = 0),
            (this.elements[d].style.textAlign = "center"),
            (this.elements[d].style.color = this.style.fontColor),
            (this.elements[d].style.fontSize = this.elements[d].style.height =
              this.style.fontSize + "px"),
            (this.elements[d].style.fontStyle = this.style.fontStyle),
            (this.elements[d].style.fontFamily = this.style.fontFamily),
            (this.elements[d].style.fontWeight = this.style.fontWeight),
            (this.elements[d].style.lineHeight = 1),
            isNaN(this.style.padding)
              ? ((this.elements[d].style.paddingTop =
                  this.style.padding.top + "px"),
                (this.elements[d].style.paddingRight =
                  this.style.padding.right + "px"),
                (this.elements[d].style.paddingBottom =
                  this.style.padding.bottom + "px"),
                (this.elements[d].style.paddingLeft =
                  this.style.padding.left + "px"))
              : (this.elements[d].style.padding = this.style.padding + "px"),
            (this.elements[d].style.mozAppearance =
              this.elements[d].style.webkitAppearance =
              this.elements[d].style.appearance =
                "none"),
            (this.elements[d].style.webkitBorderRadius = 0),
            (this.elements[d].style.mozBorderRadius = 0),
            (this.elements[d].style.borderRadius = 0),
            (this.elements[d].style.boxSizing = "content-box");
        this.parent = this.rangeSelector = this.stockChart.rangeSelector;
      }
    };
    ha(X, Q);
    X.prototype._updateOptions = function () {
      this.updateOption("backgroundColor");
      this.updateOption("backgroundColorOnHover");
      this.updateOption("backgroundColorOnSelect");
      this.updateOption("borderColor");
      this.updateOption("borderThickness");
      this.updateOption("labelFontColor");
      this.updateOption("labelFontColorOnHover");
      this.updateOption("labelFontSize");
      this.updateOption("labelFontStyle");
      this.updateOption("labelFontFamily");
      this.updateOption("labelFontWeight");
      this.updateOption("width");
      this.updateOption("maxWidth");
      this.updateOption("padding");
      this.updateOption("spacing");
      this.updateOption("cursor");
    };
    ha(Y, Q);
    Y.prototype._updateOptions = function () {
      this.updateOption("backgroundColor");
      this.updateOption("borderColor");
      this.updateOption("borderThickness");
      this.updateOption("borderColorOnFocus");
      this.updateOption("fontColor");
      this.updateOption("fontSize");
      this.updateOption("fontStyle");
      this.updateOption("fontFamily");
      this.updateOption("fontWeight");
      this.updateOption("width");
      this.updateOption("maxWidth");
      this.updateOption("padding");
      this.updateOption("spacing");
      this.updateOption("cursor");
    };
    return F;
  })();
  W.version = "v1.3 GA";
  window.CanvasJS &&
    (W &&
      !window.CanvasJS.StockChart &&
      window.CanvasJS.Chart &&
      (window.CanvasJS.StockChart = W),
    W &&
      !window.CanvasJS.Chart &&
      ((window.CanvasJS.Chart = Ka), (window.CanvasJS.StockChart = W)));
})();

/*
  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.

  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
  Licensed under the Apache License, Version 2.0
*/
document.createElement("canvas").getContext ||
  (function () {
    function V() {
      return this.context_ || (this.context_ = new C(this));
    }
    function W(a, b, c) {
      var g = M.call(arguments, 2);
      return function () {
        return a.apply(b, g.concat(M.call(arguments)));
      };
    }
    function N(a) {
      return String(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    }
    function O(a) {
      a.namespaces.g_vml_ ||
        a.namespaces.add(
          "g_vml_",
          "urn:schemas-microsoft-com:vml",
          "#default#VML"
        );
      a.namespaces.g_o_ ||
        a.namespaces.add(
          "g_o_",
          "urn:schemas-microsoft-com:office:office",
          "#default#VML"
        );
      a.styleSheets.ex_canvas_ ||
        ((a = a.createStyleSheet()),
        (a.owningElement.id = "ex_canvas_"),
        (a.cssText =
          "canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}"));
    }
    function X(a) {
      var b = a.srcElement;
      switch (a.propertyName) {
        case "width":
          b.getContext().clearRect();
          b.style.width = b.attributes.width.nodeValue + "px";
          b.firstChild.style.width = b.clientWidth + "px";
          break;
        case "height":
          b.getContext().clearRect(),
            (b.style.height = b.attributes.height.nodeValue + "px"),
            (b.firstChild.style.height = b.clientHeight + "px");
      }
    }
    function Y(a) {
      a = a.srcElement;
      a.firstChild &&
        ((a.firstChild.style.width = a.clientWidth + "px"),
        (a.firstChild.style.height = a.clientHeight + "px"));
    }
    function D() {
      return [
        [1, 0, 0],
        [0, 1, 0],
        [0, 0, 1],
      ];
    }
    function t(a, b) {
      for (var c = D(), g = 0; 3 > g; g++)
        for (var e = 0; 3 > e; e++) {
          for (var f = 0, d = 0; 3 > d; d++) f += a[g][d] * b[d][e];
          c[g][e] = f;
        }
      return c;
    }
    function P(a, b) {
      b.fillStyle = a.fillStyle;
      b.lineCap = a.lineCap;
      b.lineJoin = a.lineJoin;
      b.lineWidth = a.lineWidth;
      b.miterLimit = a.miterLimit;
      b.shadowBlur = a.shadowBlur;
      b.shadowColor = a.shadowColor;
      b.shadowOffsetX = a.shadowOffsetX;
      b.shadowOffsetY = a.shadowOffsetY;
      b.strokeStyle = a.strokeStyle;
      b.globalAlpha = a.globalAlpha;
      b.font = a.font;
      b.textAlign = a.textAlign;
      b.textBaseline = a.textBaseline;
      b.arcScaleX_ = a.arcScaleX_;
      b.arcScaleY_ = a.arcScaleY_;
      b.lineScale_ = a.lineScale_;
    }
    function Q(a) {
      var b = a.indexOf("(", 3),
        c = a.indexOf(")", b + 1),
        b = a.substring(b + 1, c).split(",");
      if (4 != b.length || "a" != a.charAt(3)) b[3] = 1;
      return b;
    }
    function E(a, b, c) {
      return Math.min(c, Math.max(b, a));
    }
    function F(a, b, c) {
      0 > c && c++;
      1 < c && c--;
      return 1 > 6 * c
        ? a + 6 * (b - a) * c
        : 1 > 2 * c
        ? b
        : 2 > 3 * c
        ? a + 6 * (b - a) * (2 / 3 - c)
        : a;
    }
    function G(a) {
      if (a in H) return H[a];
      var b,
        c = 1;
      a = String(a);
      if ("#" == a.charAt(0)) b = a;
      else if (/^rgb/.test(a)) {
        c = Q(a);
        b = "#";
        for (var g, e = 0; 3 > e; e++)
          (g =
            -1 != c[e].indexOf("%")
              ? Math.floor(255 * (parseFloat(c[e]) / 100))
              : +c[e]),
            (b += v[E(g, 0, 255)]);
        c = +c[3];
      } else if (/^hsl/.test(a)) {
        e = c = Q(a);
        b = (parseFloat(e[0]) / 360) % 360;
        0 > b && b++;
        g = E(parseFloat(e[1]) / 100, 0, 1);
        e = E(parseFloat(e[2]) / 100, 0, 1);
        if (0 == g) g = e = b = e;
        else {
          var f = 0.5 > e ? e * (1 + g) : e + g - e * g,
            d = 2 * e - f;
          g = F(d, f, b + 1 / 3);
          e = F(d, f, b);
          b = F(d, f, b - 1 / 3);
        }
        b =
          "#" +
          v[Math.floor(255 * g)] +
          v[Math.floor(255 * e)] +
          v[Math.floor(255 * b)];
        c = c[3];
      } else b = Z[a] || a;
      return (H[a] = { color: b, alpha: c });
    }
    function C(a) {
      this.m_ = D();
      this.mStack_ = [];
      this.aStack_ = [];
      this.currentPath_ = [];
      this.fillStyle = this.strokeStyle = "#000";
      this.lineWidth = 1;
      this.lineJoin = "miter";
      this.lineCap = "butt";
      this.miterLimit = 1 * q;
      this.globalAlpha = 1;
      this.font = "10px sans-serif";
      this.textAlign = "left";
      this.textBaseline = "alphabetic";
      this.canvas = a;
      var b =
          "width:" +
          a.clientWidth +
          "px;height:" +
          a.clientHeight +
          "px;overflow:hidden;position:absolute",
        c = a.ownerDocument.createElement("div");
      c.style.cssText = b;
      a.appendChild(c);
      b = c.cloneNode(!1);
      b.style.backgroundColor = "red";
      b.style.filter = "alpha(opacity=0)";
      a.appendChild(b);
      this.element_ = c;
      this.lineScale_ = this.arcScaleY_ = this.arcScaleX_ = 1;
    }
    function R(a, b, c, g) {
      a.currentPath_.push({
        type: "bezierCurveTo",
        cp1x: b.x,
        cp1y: b.y,
        cp2x: c.x,
        cp2y: c.y,
        x: g.x,
        y: g.y,
      });
      a.currentX_ = g.x;
      a.currentY_ = g.y;
    }
    function S(a, b) {
      var c = G(a.strokeStyle),
        g = c.color,
        c = c.alpha * a.globalAlpha,
        e = a.lineScale_ * a.lineWidth;
      1 > e && (c *= e);
      b.push(
        "<g_vml_:stroke",
        ' opacity="',
        c,
        '"',
        ' joinstyle="',
        a.lineJoin,
        '"',
        ' miterlimit="',
        a.miterLimit,
        '"',
        ' endcap="',
        $[a.lineCap] || "square",
        '"',
        ' weight="',
        e,
        'px"',
        ' color="',
        g,
        '" />'
      );
    }
    function T(a, b, c, g) {
      var e = a.fillStyle,
        f = a.arcScaleX_,
        d = a.arcScaleY_,
        k = g.x - c.x,
        n = g.y - c.y;
      if (e instanceof w) {
        var h = 0,
          l = (g = 0),
          u = 0,
          m = 1;
        if ("gradient" == e.type_) {
          h = e.x1_ / f;
          c = e.y1_ / d;
          var p = s(a, e.x0_ / f, e.y0_ / d),
            h = s(a, h, c),
            h = (180 * Math.atan2(h.x - p.x, h.y - p.y)) / Math.PI;
          0 > h && (h += 360);
          1e-6 > h && (h = 0);
        } else
          (p = s(a, e.x0_, e.y0_)),
            (g = (p.x - c.x) / k),
            (l = (p.y - c.y) / n),
            (k /= f * q),
            (n /= d * q),
            (m = x.max(k, n)),
            (u = (2 * e.r0_) / m),
            (m = (2 * e.r1_) / m - u);
        f = e.colors_;
        f.sort(function (a, b) {
          return a.offset - b.offset;
        });
        d = f.length;
        p = f[0].color;
        c = f[d - 1].color;
        k = f[0].alpha * a.globalAlpha;
        a = f[d - 1].alpha * a.globalAlpha;
        for (var n = [], r = 0; r < d; r++) {
          var t = f[r];
          n.push(t.offset * m + u + " " + t.color);
        }
        b.push(
          '<g_vml_:fill type="',
          e.type_,
          '"',
          ' method="none" focus="100%"',
          ' color="',
          p,
          '"',
          ' color2="',
          c,
          '"',
          ' colors="',
          n.join(","),
          '"',
          ' opacity="',
          a,
          '"',
          ' g_o_:opacity2="',
          k,
          '"',
          ' angle="',
          h,
          '"',
          ' focusposition="',
          g,
          ",",
          l,
          '" />'
        );
      } else
        e instanceof I
          ? k &&
            n &&
            b.push(
              "<g_vml_:fill",
              ' position="',
              (-c.x / k) * f * f,
              ",",
              (-c.y / n) * d * d,
              '"',
              ' type="tile"',
              ' src="',
              e.src_,
              '" />'
            )
          : ((e = G(a.fillStyle)),
            b.push(
              '<g_vml_:fill color="',
              e.color,
              '" opacity="',
              e.alpha * a.globalAlpha,
              '" />'
            ));
    }
    function s(a, b, c) {
      a = a.m_;
      return {
        x: q * (b * a[0][0] + c * a[1][0] + a[2][0]) - r,
        y: q * (b * a[0][1] + c * a[1][1] + a[2][1]) - r,
      };
    }
    function z(a, b, c) {
      isFinite(b[0][0]) &&
        isFinite(b[0][1]) &&
        isFinite(b[1][0]) &&
        isFinite(b[1][1]) &&
        isFinite(b[2][0]) &&
        isFinite(b[2][1]) &&
        ((a.m_ = b),
        c && (a.lineScale_ = aa(ba(b[0][0] * b[1][1] - b[0][1] * b[1][0]))));
    }
    function w(a) {
      this.type_ = a;
      this.r1_ = this.y1_ = this.x1_ = this.r0_ = this.y0_ = this.x0_ = 0;
      this.colors_ = [];
    }
    function I(a, b) {
      if (!a || 1 != a.nodeType || "IMG" != a.tagName)
        throw new A("TYPE_MISMATCH_ERR");
      if ("complete" != a.readyState) throw new A("INVALID_STATE_ERR");
      switch (b) {
        case "repeat":
        case null:
        case "":
          this.repetition_ = "repeat";
          break;
        case "repeat-x":
        case "repeat-y":
        case "no-repeat":
          this.repetition_ = b;
          break;
        default:
          throw new A("SYNTAX_ERR");
      }
      this.src_ = a.src;
      this.width_ = a.width;
      this.height_ = a.height;
    }
    function A(a) {
      this.code = this[a];
      this.message = a + ": DOM Exception " + this.code;
    }
    var x = Math,
      k = x.round,
      J = x.sin,
      K = x.cos,
      ba = x.abs,
      aa = x.sqrt,
      q = 10,
      r = q / 2;
    navigator.userAgent.match(/MSIE ([\d.]+)?/);
    var M = Array.prototype.slice;
    O(document);
    var U = {
      init: function (a) {
        a = a || document;
        a.createElement("canvas");
        a.attachEvent("onreadystatechange", W(this.init_, this, a));
      },
      init_: function (a) {
        a = a.getElementsByTagName("canvas");
        for (var b = 0; b < a.length; b++) this.initElement(a[b]);
      },
      initElement: function (a) {
        if (!a.getContext) {
          a.getContext = V;
          O(a.ownerDocument);
          a.innerHTML = "";
          a.attachEvent("onpropertychange", X);
          a.attachEvent("onresize", Y);
          var b = a.attributes;
          b.width && b.width.specified
            ? (a.style.width = b.width.nodeValue + "px")
            : (a.width = a.clientWidth);
          b.height && b.height.specified
            ? (a.style.height = b.height.nodeValue + "px")
            : (a.height = a.clientHeight);
        }
        return a;
      },
    };
    U.init();
    for (var v = [], d = 0; 16 > d; d++)
      for (var B = 0; 16 > B; B++)
        v[16 * d + B] = d.toString(16) + B.toString(16);
    var Z = {
        aliceblue: "#F0F8FF",
        antiquewhite: "#FAEBD7",
        aquamarine: "#7FFFD4",
        azure: "#F0FFFF",
        beige: "#F5F5DC",
        bisque: "#FFE4C4",
        black: "#000000",
        blanchedalmond: "#FFEBCD",
        blueviolet: "#8A2BE2",
        brown: "#A52A2A",
        burlywood: "#DEB887",
        cadetblue: "#5F9EA0",
        chartreuse: "#7FFF00",
        chocolate: "#D2691E",
        coral: "#FF7F50",
        cornflowerblue: "#6495ED",
        cornsilk: "#FFF8DC",
        crimson: "#DC143C",
        cyan: "#00FFFF",
        darkblue: "#00008B",
        darkcyan: "#008B8B",
        darkgoldenrod: "#B8860B",
        darkgray: "#A9A9A9",
        darkgreen: "#006400",
        darkgrey: "#A9A9A9",
        darkkhaki: "#BDB76B",
        darkmagenta: "#8B008B",
        darkolivegreen: "#556B2F",
        darkorange: "#FF8C00",
        darkorchid: "#9932CC",
        darkred: "#8B0000",
        darksalmon: "#E9967A",
        darkseagreen: "#8FBC8F",
        darkslateblue: "#483D8B",
        darkslategray: "#2F4F4F",
        darkslategrey: "#2F4F4F",
        darkturquoise: "#00CED1",
        darkviolet: "#9400D3",
        deeppink: "#FF1493",
        deepskyblue: "#00BFFF",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1E90FF",
        firebrick: "#B22222",
        floralwhite: "#FFFAF0",
        forestgreen: "#228B22",
        gainsboro: "#DCDCDC",
        ghostwhite: "#F8F8FF",
        gold: "#FFD700",
        goldenrod: "#DAA520",
        grey: "#808080",
        greenyellow: "#ADFF2F",
        honeydew: "#F0FFF0",
        hotpink: "#FF69B4",
        indianred: "#CD5C5C",
        indigo: "#4B0082",
        ivory: "#FFFFF0",
        khaki: "#F0E68C",
        lavender: "#E6E6FA",
        lavenderblush: "#FFF0F5",
        lawngreen: "#7CFC00",
        lemonchiffon: "#FFFACD",
        lightblue: "#ADD8E6",
        lightcoral: "#F08080",
        lightcyan: "#E0FFFF",
        lightgoldenrodyellow: "#FAFAD2",
        lightgreen: "#90EE90",
        lightgrey: "#D3D3D3",
        lightpink: "#FFB6C1",
        lightsalmon: "#FFA07A",
        lightseagreen: "#20B2AA",
        lightskyblue: "#87CEFA",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#B0C4DE",
        lightyellow: "#FFFFE0",
        limegreen: "#32CD32",
        linen: "#FAF0E6",
        magenta: "#FF00FF",
        mediumaquamarine: "#66CDAA",
        mediumblue: "#0000CD",
        mediumorchid: "#BA55D3",
        mediumpurple: "#9370DB",
        mediumseagreen: "#3CB371",
        mediumslateblue: "#7B68EE",
        mediumspringgreen: "#00FA9A",
        mediumturquoise: "#48D1CC",
        mediumvioletred: "#C71585",
        midnightblue: "#191970",
        mintcream: "#F5FFFA",
        mistyrose: "#FFE4E1",
        moccasin: "#FFE4B5",
        navajowhite: "#FFDEAD",
        oldlace: "#FDF5E6",
        olivedrab: "#6B8E23",
        orange: "#FFA500",
        orangered: "#FF4500",
        orchid: "#DA70D6",
        palegoldenrod: "#EEE8AA",
        palegreen: "#98FB98",
        paleturquoise: "#AFEEEE",
        palevioletred: "#DB7093",
        papayawhip: "#FFEFD5",
        peachpuff: "#FFDAB9",
        peru: "#CD853F",
        pink: "#FFC0CB",
        plum: "#DDA0DD",
        powderblue: "#B0E0E6",
        rosybrown: "#BC8F8F",
        royalblue: "#4169E1",
        saddlebrown: "#8B4513",
        salmon: "#FA8072",
        sandybrown: "#F4A460",
        seagreen: "#2E8B57",
        seashell: "#FFF5EE",
        sienna: "#A0522D",
        skyblue: "#87CEEB",
        slateblue: "#6A5ACD",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#FFFAFA",
        springgreen: "#00FF7F",
        steelblue: "#4682B4",
        tan: "#D2B48C",
        thistle: "#D8BFD8",
        tomato: "#FF6347",
        turquoise: "#40E0D0",
        violet: "#EE82EE",
        wheat: "#F5DEB3",
        whitesmoke: "#F5F5F5",
        yellowgreen: "#9ACD32",
      },
      H = {},
      L = {},
      $ = { butt: "flat", round: "round" },
      d = C.prototype;
    d.clearRect = function () {
      this.textMeasureEl_ &&
        (this.textMeasureEl_.removeNode(!0), (this.textMeasureEl_ = null));
      this.element_.innerHTML = "";
    };
    d.beginPath = function () {
      this.currentPath_ = [];
    };
    d.moveTo = function (a, b) {
      var c = s(this, a, b);
      this.currentPath_.push({ type: "moveTo", x: c.x, y: c.y });
      this.currentX_ = c.x;
      this.currentY_ = c.y;
    };
    d.lineTo = function (a, b) {
      var c = s(this, a, b);
      this.currentPath_.push({ type: "lineTo", x: c.x, y: c.y });
      this.currentX_ = c.x;
      this.currentY_ = c.y;
    };
    d.bezierCurveTo = function (a, b, c, g, e, f) {
      e = s(this, e, f);
      a = s(this, a, b);
      c = s(this, c, g);
      R(this, a, c, e);
    };
    d.quadraticCurveTo = function (a, b, c, g) {
      a = s(this, a, b);
      c = s(this, c, g);
      g = {
        x: this.currentX_ + (2 / 3) * (a.x - this.currentX_),
        y: this.currentY_ + (2 / 3) * (a.y - this.currentY_),
      };
      R(
        this,
        g,
        {
          x: g.x + (c.x - this.currentX_) / 3,
          y: g.y + (c.y - this.currentY_) / 3,
        },
        c
      );
    };
    d.arc = function (a, b, c, g, e, f) {
      c *= q;
      var d = f ? "at" : "wa",
        k = a + K(g) * c - r,
        n = b + J(g) * c - r;
      g = a + K(e) * c - r;
      e = b + J(e) * c - r;
      k != g || f || (k += 0.125);
      a = s(this, a, b);
      k = s(this, k, n);
      g = s(this, g, e);
      this.currentPath_.push({
        type: d,
        x: a.x,
        y: a.y,
        radius: c,
        xStart: k.x,
        yStart: k.y,
        xEnd: g.x,
        yEnd: g.y,
      });
    };
    d.rect = function (a, b, c, g) {
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
    };
    d.strokeRect = function (a, b, c, g) {
      var e = this.currentPath_;
      this.beginPath();
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
      this.stroke();
      this.currentPath_ = e;
    };
    d.fillRect = function (a, b, c, g) {
      var e = this.currentPath_;
      this.beginPath();
      this.moveTo(a, b);
      this.lineTo(a + c, b);
      this.lineTo(a + c, b + g);
      this.lineTo(a, b + g);
      this.closePath();
      this.fill();
      this.currentPath_ = e;
    };
    d.createLinearGradient = function (a, b, c, g) {
      var e = new w("gradient");
      e.x0_ = a;
      e.y0_ = b;
      e.x1_ = c;
      e.y1_ = g;
      return e;
    };
    d.createRadialGradient = function (a, b, c, g, e, f) {
      var d = new w("gradientradial");
      d.x0_ = a;
      d.y0_ = b;
      d.r0_ = c;
      d.x1_ = g;
      d.y1_ = e;
      d.r1_ = f;
      return d;
    };
    d.drawImage = function (a, b) {
      var c, g, e, d, r, y, n, h;
      e = a.runtimeStyle.width;
      d = a.runtimeStyle.height;
      a.runtimeStyle.width = "auto";
      a.runtimeStyle.height = "auto";
      var l = a.width,
        u = a.height;
      a.runtimeStyle.width = e;
      a.runtimeStyle.height = d;
      if (3 == arguments.length)
        (c = arguments[1]),
          (g = arguments[2]),
          (r = y = 0),
          (n = e = l),
          (h = d = u);
      else if (5 == arguments.length)
        (c = arguments[1]),
          (g = arguments[2]),
          (e = arguments[3]),
          (d = arguments[4]),
          (r = y = 0),
          (n = l),
          (h = u);
      else if (9 == arguments.length)
        (r = arguments[1]),
          (y = arguments[2]),
          (n = arguments[3]),
          (h = arguments[4]),
          (c = arguments[5]),
          (g = arguments[6]),
          (e = arguments[7]),
          (d = arguments[8]);
      else throw Error("Invalid number of arguments");
      var m = s(this, c, g),
        p = [];
      p.push(
        " <g_vml_:group",
        ' coordsize="',
        10 * q,
        ",",
        10 * q,
        '"',
        ' coordorigin="0,0"',
        ' style="width:',
        10,
        "px;height:",
        10,
        "px;position:absolute;"
      );
      if (
        1 != this.m_[0][0] ||
        this.m_[0][1] ||
        1 != this.m_[1][1] ||
        this.m_[1][0]
      ) {
        var t = [];
        t.push(
          "M11=",
          this.m_[0][0],
          ",",
          "M12=",
          this.m_[1][0],
          ",",
          "M21=",
          this.m_[0][1],
          ",",
          "M22=",
          this.m_[1][1],
          ",",
          "Dx=",
          k(m.x / q),
          ",",
          "Dy=",
          k(m.y / q),
          ""
        );
        var v = s(this, c + e, g),
          w = s(this, c, g + d);
        c = s(this, c + e, g + d);
        m.x = x.max(m.x, v.x, w.x, c.x);
        m.y = x.max(m.y, v.y, w.y, c.y);
        p.push(
          "padding:0 ",
          k(m.x / q),
          "px ",
          k(m.y / q),
          "px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",
          t.join(""),
          ", sizingmethod='clip');"
        );
      } else p.push("top:", k(m.y / q), "px;left:", k(m.x / q), "px;");
      p.push(
        ' ">',
        '<g_vml_:image src="',
        a.src,
        '"',
        ' style="width:',
        q * e,
        "px;",
        " height:",
        q * d,
        'px"',
        ' cropleft="',
        r / l,
        '"',
        ' croptop="',
        y / u,
        '"',
        ' cropright="',
        (l - r - n) / l,
        '"',
        ' cropbottom="',
        (u - y - h) / u,
        '"',
        " />",
        "</g_vml_:group>"
      );
      this.element_.insertAdjacentHTML("BeforeEnd", p.join(""));
    };
    d.stroke = function (a) {
      var b = [];
      b.push(
        "<g_vml_:shape",
        ' filled="',
        !!a,
        '"',
        ' style="position:absolute;width:',
        10,
        "px;height:",
        10,
        'px;"',
        ' coordorigin="0,0"',
        ' coordsize="',
        10 * q,
        ",",
        10 * q,
        '"',
        ' stroked="',
        !a,
        '"',
        ' path="'
      );
      for (
        var c = { x: null, y: null }, d = { x: null, y: null }, e = 0;
        e < this.currentPath_.length;
        e++
      ) {
        var f = this.currentPath_[e];
        switch (f.type) {
          case "moveTo":
            b.push(" m ", k(f.x), ",", k(f.y));
            break;
          case "lineTo":
            b.push(" l ", k(f.x), ",", k(f.y));
            break;
          case "close":
            b.push(" x ");
            f = null;
            break;
          case "bezierCurveTo":
            b.push(
              " c ",
              k(f.cp1x),
              ",",
              k(f.cp1y),
              ",",
              k(f.cp2x),
              ",",
              k(f.cp2y),
              ",",
              k(f.x),
              ",",
              k(f.y)
            );
            break;
          case "at":
          case "wa":
            b.push(
              " ",
              f.type,
              " ",
              k(f.x - this.arcScaleX_ * f.radius),
              ",",
              k(f.y - this.arcScaleY_ * f.radius),
              " ",
              k(f.x + this.arcScaleX_ * f.radius),
              ",",
              k(f.y + this.arcScaleY_ * f.radius),
              " ",
              k(f.xStart),
              ",",
              k(f.yStart),
              " ",
              k(f.xEnd),
              ",",
              k(f.yEnd)
            );
        }
        if (f) {
          if (null == c.x || f.x < c.x) c.x = f.x;
          if (null == d.x || f.x > d.x) d.x = f.x;
          if (null == c.y || f.y < c.y) c.y = f.y;
          if (null == d.y || f.y > d.y) d.y = f.y;
        }
      }
      b.push(' ">');
      a ? T(this, b, c, d) : S(this, b);
      b.push("</g_vml_:shape>");
      this.element_.insertAdjacentHTML("beforeEnd", b.join(""));
    };
    d.fill = function () {
      this.stroke(!0);
    };
    d.closePath = function () {
      this.currentPath_.push({ type: "close" });
    };
    d.save = function () {
      var a = {};
      P(this, a);
      this.aStack_.push(a);
      this.mStack_.push(this.m_);
      this.m_ = t(D(), this.m_);
    };
    d.restore = function () {
      this.aStack_.length &&
        (P(this.aStack_.pop(), this), (this.m_ = this.mStack_.pop()));
    };
    d.translate = function (a, b) {
      z(
        this,
        t(
          [
            [1, 0, 0],
            [0, 1, 0],
            [a, b, 1],
          ],
          this.m_
        ),
        !1
      );
    };
    d.rotate = function (a) {
      var b = K(a);
      a = J(a);
      z(
        this,
        t(
          [
            [b, a, 0],
            [-a, b, 0],
            [0, 0, 1],
          ],
          this.m_
        ),
        !1
      );
    };
    d.scale = function (a, b) {
      this.arcScaleX_ *= a;
      this.arcScaleY_ *= b;
      z(
        this,
        t(
          [
            [a, 0, 0],
            [0, b, 0],
            [0, 0, 1],
          ],
          this.m_
        ),
        !0
      );
    };
    d.transform = function (a, b, c, d, e, f) {
      z(
        this,
        t(
          [
            [a, b, 0],
            [c, d, 0],
            [e, f, 1],
          ],
          this.m_
        ),
        !0
      );
    };
    d.setTransform = function (a, b, c, d, e, f) {
      z(
        this,
        [
          [a, b, 0],
          [c, d, 0],
          [e, f, 1],
        ],
        !0
      );
    };
    d.drawText_ = function (a, b, c, d, e) {
      var f = this.m_;
      d = 0;
      var r = 1e3,
        t = 0,
        n = [],
        h;
      h = this.font;
      if (L[h]) h = L[h];
      else {
        var l = document.createElement("div").style;
        try {
          l.font = h;
        } catch (u) {}
        h = L[h] = {
          style: l.fontStyle || "normal",
          variant: l.fontVariant || "normal",
          weight: l.fontWeight || "normal",
          size: l.fontSize || 10,
          family: l.fontFamily || "sans-serif",
        };
      }
      var l = h,
        m = this.element_;
      h = {};
      for (var p in l) h[p] = l[p];
      p = parseFloat(m.currentStyle.fontSize);
      m = parseFloat(l.size);
      "number" == typeof l.size
        ? (h.size = l.size)
        : -1 != l.size.indexOf("px")
        ? (h.size = m)
        : -1 != l.size.indexOf("em")
        ? (h.size = p * m)
        : -1 != l.size.indexOf("%")
        ? (h.size = (p / 100) * m)
        : -1 != l.size.indexOf("pt")
        ? (h.size = m / 0.75)
        : (h.size = p);
      h.size *= 0.981;
      p =
        h.style +
        " " +
        h.variant +
        " " +
        h.weight +
        " " +
        h.size +
        "px " +
        h.family;
      m = this.element_.currentStyle;
      l = this.textAlign.toLowerCase();
      switch (l) {
        case "left":
        case "center":
        case "right":
          break;
        case "end":
          l = "ltr" == m.direction ? "right" : "left";
          break;
        case "start":
          l = "rtl" == m.direction ? "right" : "left";
          break;
        default:
          l = "left";
      }
      switch (this.textBaseline) {
        case "hanging":
        case "top":
          t = h.size / 1.75;
          break;
        case "middle":
          break;
        default:
        case null:
        case "alphabetic":
        case "ideographic":
        case "bottom":
          t = -h.size / 2.25;
      }
      switch (l) {
        case "right":
          d = 1e3;
          r = 0.05;
          break;
        case "center":
          d = r = 500;
      }
      b = s(this, b + 0, c + t);
      n.push(
        '<g_vml_:line from="',
        -d,
        ' 0" to="',
        r,
        ' 0.05" ',
        ' coordsize="100 100" coordorigin="0 0"',
        ' filled="',
        !e,
        '" stroked="',
        !!e,
        '" style="position:absolute;width:1px;height:1px;">'
      );
      e ? S(this, n) : T(this, n, { x: -d, y: 0 }, { x: r, y: h.size });
      e =
        f[0][0].toFixed(3) +
        "," +
        f[1][0].toFixed(3) +
        "," +
        f[0][1].toFixed(3) +
        "," +
        f[1][1].toFixed(3) +
        ",0,0";
      b = k(b.x / q) + "," + k(b.y / q);
      n.push(
        '<g_vml_:skew on="t" matrix="',
        e,
        '" ',
        ' offset="',
        b,
        '" origin="',
        d,
        ' 0" />',
        '<g_vml_:path textpathok="true" />',
        '<g_vml_:textpath on="true" string="',
        N(a),
        '" style="v-text-align:',
        l,
        ";font:",
        N(p),
        '" /></g_vml_:line>'
      );
      this.element_.insertAdjacentHTML("beforeEnd", n.join(""));
    };
    d.fillText = function (a, b, c, d) {
      this.drawText_(a, b, c, d, !1);
    };
    d.strokeText = function (a, b, c, d) {
      this.drawText_(a, b, c, d, !0);
    };
    d.measureText = function (a) {
      this.textMeasureEl_ ||
        (this.element_.insertAdjacentHTML(
          "beforeEnd",
          '<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'
        ),
        (this.textMeasureEl_ = this.element_.lastChild));
      var b = this.element_.ownerDocument;
      this.textMeasureEl_.innerHTML = "";
      this.textMeasureEl_.style.font = this.font;
      this.textMeasureEl_.appendChild(b.createTextNode(a));
      return { width: this.textMeasureEl_.offsetWidth };
    };
    d.clip = function () {};
    d.arcTo = function () {};
    d.createPattern = function (a, b) {
      return new I(a, b);
    };
    w.prototype.addColorStop = function (a, b) {
      b = G(b);
      this.colors_.push({ offset: a, color: b.color, alpha: b.alpha });
    };
    d = A.prototype = Error();
    d.INDEX_SIZE_ERR = 1;
    d.DOMSTRING_SIZE_ERR = 2;
    d.HIERARCHY_REQUEST_ERR = 3;
    d.WRONG_DOCUMENT_ERR = 4;
    d.INVALID_CHARACTER_ERR = 5;
    d.NO_DATA_ALLOWED_ERR = 6;
    d.NO_MODIFICATION_ALLOWED_ERR = 7;
    d.NOT_FOUND_ERR = 8;
    d.NOT_SUPPORTED_ERR = 9;
    d.INUSE_ATTRIBUTE_ERR = 10;
    d.INVALID_STATE_ERR = 11;
    d.SYNTAX_ERR = 12;
    d.INVALID_MODIFICATION_ERR = 13;
    d.NAMESPACE_ERR = 14;
    d.INVALID_ACCESS_ERR = 15;
    d.VALIDATION_ERR = 16;
    d.TYPE_MISMATCH_ERR = 17;
    G_vmlCanvasManager = U;
    CanvasRenderingContext2D = C;
    CanvasGradient = w;
    CanvasPattern = I;
    DOMException = A;
  })();
/*eslint-enable*/
/*jshint ignore:end*/
